"use client";
import { y as on, x as u, w as Fe, L as $L, u as Ce, M as Hp, N as Ra, O as ke, X as ei, B as _C, D as zi, E as BL, T as hl, P as SC, Q as bl, R as OC, V as FL, W as zL, K as l0, C as EC, A as qL, Y as VL, F as WL, p as UL, i as AC, k as HL, a as Uy, b as Hy, l as YL, o as KL, s as GL, d as ZL, c as XL, S as QL, z as PC, f as JL, q as Yp, U as es, J as e2, G as t2 } from "./youtube-icon-ebGlwlFR.js";
import * as A from "react";
import T, { isValidElement as Yn, Children as Ri, PureComponent as ta, forwardRef as ku, useRef as Le, useImperativeHandle as n2, useState as Ee, useCallback as ot, useEffect as St, useMemo as Tr, cloneElement as _t, createElement as Yy, useContext as si, createContext as hr, Component as CC, useLayoutEffect as Ky, useTransition as jC, useId as tf } from "react";
import { c as J, C as TC } from "./word-count-C8UohVJy.js";
import { w as $ue } from "./word-count-C8UohVJy.js";
import * as Ru from "react-dom";
import r2 from "react-dom";
import { B as i2 } from "./index-DBXxTzmR.js";
import a2 from "embla-carousel-react";
var Mc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ct(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o2 = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], u0 = on("alarm-clock-check", o2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s2 = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], NC = on("chevron-left", s2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c2 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], ls = on("circle-check", c2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l2 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
], u2 = on("circle-pause", l2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d2 = [
  [
    "path",
    {
      d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
      key: "kmsa83"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], f2 = on("circle-play", d2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h2 = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], m2 = on("ellipsis", h2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v2 = [
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M9 19h6", key: "456am0" }]
], d0 = on("list-filter", v2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p2 = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], g2 = on("lock", p2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y2 = [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
], MC = on("octagon-alert", y2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b2 = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], us = on("pencil", b2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x2 = [
  ["path", { d: "M12 17V7", key: "pyj7ub" }],
  ["path", { d: "M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8", key: "1elt7d" }],
  [
    "path",
    {
      d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
      key: "ycz6yz"
    }
  ]
], w2 = on("receipt", x2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _2 = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], S2 = on("refresh-cw", _2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O2 = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], E2 = on("triangle-alert", O2);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A2 = [
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m14.305 16.53.923-.382", key: "1itpsq" }],
  ["path", { d: "m15.228 13.852-.923-.383", key: "eplpkm" }],
  ["path", { d: "m16.852 12.228-.383-.923", key: "13v3q0" }],
  ["path", { d: "m16.852 17.772-.383.924", key: "1i8mnm" }],
  ["path", { d: "m19.148 12.228.383-.923", key: "1q8j1v" }],
  ["path", { d: "m19.53 18.696-.382-.924", key: "vk1qj3" }],
  ["path", { d: "m20.772 13.852.924-.383", key: "n880s0" }],
  ["path", { d: "m20.772 16.148.924.383", key: "1g6xey" }],
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], P2 = on("user-cog", A2), C2 = {
  default: {
    container: "border-zinc-200",
    text: "text-zinc-900",
    icon: /* @__PURE__ */ u.jsx(ls, { className: "shrink-0 text-zinc-900", size: 16 })
  },
  warning: {
    container: "border-orange-500",
    text: "text-orange-500",
    icon: /* @__PURE__ */ u.jsx(E2, { className: "shrink-0 text-orange-500", size: 16 })
  },
  destructive: {
    container: "border-red-600",
    text: "text-red-600",
    icon: /* @__PURE__ */ u.jsx(MC, { className: "shrink-0 text-red-600", size: 16 })
  },
  success: {
    container: "border-lime-500",
    text: "text-lime-700",
    icon: /* @__PURE__ */ u.jsx(ls, { className: "shrink-0 text-lime-500", size: 16 })
  }
};
function na(e) {
  const t = e.variant ?? "default", n = C2[t];
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: `flex w-full flex-row gap-1 rounded-lg border bg-white px-4 py-3 ${n.container}`,
      role: "alert",
      children: [
        n.icon,
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ u.jsx("span", { className: `font-semibold text-sm leading-4 ${n.text}`, children: e.microcopies.title }),
          e.microcopies.description && /* @__PURE__ */ u.jsx("span", { className: `font-normal text-sm leading-4 ${n.text}`, children: e.microcopies.description })
        ] })
      ]
    }
  );
}
const f0 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, h0 = Fe, yt = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return h0(e, n?.class, n?.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((l) => {
    const d = n?.[l], f = a?.[l];
    if (d === null) return null;
    const h = f0(d) || f0(f);
    return i[l][h];
  }), s = n && Object.entries(n).reduce((l, d) => {
    let [f, h] = d;
    return h === void 0 || (l[f] = h), l;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, d) => {
    let { class: f, className: h, ...m } = d;
    return Object.entries(m).every((g) => {
      let [p, v] = g;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...s
      }[p]) : {
        ...a,
        ...s
      }[p] === v;
    }) ? [
      ...l,
      f,
      h
    ] : l;
  }, []);
  return h0(e, o, c, n?.class, n?.className);
}, j2 = yt("", {
  variants: {
    variant: {
      h1: "block font-bold font-heading text-3xl leading-none tracking-tight md:text-4xl md:leading-none",
      h2: "block pb-2 font-heading font-semibold text-2xl text-blue leading-7 tracking-tight md:text-3xl md:leading-7",
      "h2-underline": "!border-neutral-300 !border-b-2 block pb-2 font-heading font-semibold text-2xl leading-7 tracking-tight md:text-3xl md:leading-7",
      h3: "block font-heading font-semibold text-xl leading-8 tracking-tight sm:text-2xl",
      "h3-light": "block font-heading font-normal text-2xl leading-8 tracking-tight",
      h4: "block font-heading font-semibold text-base leading-6 tracking-tight sm:text-xl sm:leading-6",
      "body-md": "font-normal text-base leading-5",
      "body-md-bold": "font-semibold text-base leading-7",
      "body-sm": "font-medium text-sm leading-4",
      "body-sm-bold": "font-semibold text-sm leading-4",
      "body-xs": "font-normal text-xs leading-4",
      "body-xs-bold": "font-semibold text-xs leading-4 tracking-normal",
      "body-lg": "font-semibold text-lg leading-7 tracking-normal",
      lead: "font-normal text-neutral-600 text-xl leading-7 tracking-normal",
      muted: "font-medium text-neutral-600 text-sm leading-4"
    },
    color: {
      black: "text-neutral-darker",
      white: "text-white",
      muted: "text-muted-foreground",
      success: "text-success",
      red: "text-red-600"
    },
    style: {
      "line-through": "line-through"
    }
  },
  defaultVariants: {
    variant: "body-md",
    color: "black"
  }
});
function B({
  children: e,
  variant: t = "body-md",
  color: n = "black",
  style: r,
  ...i
}) {
  const a = T2(t), o = j2({ variant: t, color: n, style: r });
  return /* @__PURE__ */ u.jsx(
    a,
    {
      className: o,
      ...a === "h1" ? { id: "main-content", tabIndex: -1, ...i } : i,
      children: e
    }
  );
}
function T2(e) {
  switch (e) {
    case "h1":
      return "h1";
    case "h2":
    case "h2-underline":
      return "h2";
    case "h3":
    case "h3-light":
      return "h3";
    case "h4":
      return "h4";
    case "body-md":
    case "body-md-bold":
    case "body-sm":
    case "body-sm-bold":
    case "body-xs":
    case "body-xs-bold":
    case "body-lg":
    case "lead":
    case "muted":
      return "p";
    default:
      return "p";
  }
}
const N2 = yt(
  "inline-flex items-center gap-1 outline-none transition-[color,box-shadow] focus:ring-[2px] focus:ring-black focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-primary shadow-sm hover:bg-primary/80 [a&]:hover:bg-primary/80",
        secondary: "bg-secondary hover:bg-secondary/80 [a&]:hover:bg-secondary/80",
        outline: "border border-zinc-700 bg-transparent hover:bg-muted [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        destructive: "bg-destructive hover:bg-red-700 [a&]:hover:bg-destructive/80"
      },
      size: {
        default: "h-5 rounded-md px-2.5 py-0.5",
        sm: "h-4 rounded-md px-1 py-0.5"
      },
      disabled: {
        true: "pointer-events-none cursor-not-allowed opacity-80",
        false: "cursor-pointer"
      }
    },
    compoundVariants: [
      {
        variant: "default",
        disabled: !0,
        className: "bg-muted-foreground"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "bg-secondary text-muted-foreground [&_*]:text-muted-foreground"
      },
      {
        variant: "outline",
        disabled: !0,
        className: "border-border text-muted-foreground [&_*]:text-muted-foreground"
      },
      {
        variant: "destructive",
        disabled: !0,
        className: "bg-muted-foreground"
      }
    ],
    defaultVariants: {
      size: "default",
      disabled: !1
    }
  }
);
function La(e) {
  const t = e.size ?? "default", n = e.fontWeight ?? "default", r = e.disabled ?? !1, a = e.asChild ?? !1 ? $L : "span", o = t === "sm" ? "h-3 w-3" : "h-4 w-4", s = e.variant === "secondary" || e.variant === "outline" ? "black" : "white", c = n === "bold" ? "body-sm-bold" : "body-sm";
  return /* @__PURE__ */ u.jsxs(
    a,
    {
      "aria-disabled": r || void 0,
      className: Ce(
        N2({ variant: e.variant, size: t, disabled: r }),
        e.className
      ),
      tabIndex: r ? -1 : 0,
      children: [
        e.icon ? /* @__PURE__ */ u.jsx(
          "span",
          {
            "aria-hidden": "true",
            className: `shrink-0 ${o}`,
            onClick: e.onClick,
            children: e.icon
          }
        ) : null,
        /* @__PURE__ */ u.jsx(B, { color: s, variant: c, children: e.text })
      ]
    }
  );
}
var nf, m0;
function sn() {
  if (m0) return nf;
  m0 = 1;
  var e = Array.isArray;
  return nf = e, nf;
}
var rf, v0;
function IC() {
  if (v0) return rf;
  v0 = 1;
  var e = typeof Mc == "object" && Mc && Mc.Object === Object && Mc;
  return rf = e, rf;
}
var af, p0;
function mr() {
  if (p0) return af;
  p0 = 1;
  var e = IC(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return af = n, af;
}
var of, g0;
function tc() {
  if (g0) return of;
  g0 = 1;
  var e = mr(), t = e.Symbol;
  return of = t, of;
}
var sf, y0;
function M2() {
  if (y0) return sf;
  y0 = 1;
  var e = tc(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function a(o) {
    var s = n.call(o, i), c = o[i];
    try {
      o[i] = void 0;
      var l = !0;
    } catch {
    }
    var d = r.call(o);
    return l && (s ? o[i] = c : delete o[i]), d;
  }
  return sf = a, sf;
}
var cf, b0;
function I2() {
  if (b0) return cf;
  b0 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return cf = n, cf;
}
var lf, x0;
function $r() {
  if (x0) return lf;
  x0 = 1;
  var e = tc(), t = M2(), n = I2(), r = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? i : r : a && a in Object(s) ? t(s) : n(s);
  }
  return lf = o, lf;
}
var uf, w0;
function Br() {
  if (w0) return uf;
  w0 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return uf = e, uf;
}
var df, _0;
function go() {
  if (_0) return df;
  _0 = 1;
  var e = $r(), t = Br(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return df = r, df;
}
var ff, S0;
function Gy() {
  if (S0) return ff;
  S0 = 1;
  var e = sn(), t = go(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(a, o) {
    if (e(a))
      return !1;
    var s = typeof a;
    return s == "number" || s == "symbol" || s == "boolean" || a == null || t(a) ? !0 : r.test(a) || !n.test(a) || o != null && a in Object(o);
  }
  return ff = i, ff;
}
var hf, O0;
function ci() {
  if (O0) return hf;
  O0 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return hf = e, hf;
}
var mf, E0;
function Zy() {
  if (E0) return mf;
  E0 = 1;
  var e = $r(), t = ci(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == r || c == i || c == n || c == a;
  }
  return mf = o, mf;
}
var vf, A0;
function D2() {
  if (A0) return vf;
  A0 = 1;
  var e = mr(), t = e["__core-js_shared__"];
  return vf = t, vf;
}
var pf, P0;
function k2() {
  if (P0) return pf;
  P0 = 1;
  var e = D2(), t = (function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })();
  function n(r) {
    return !!t && t in r;
  }
  return pf = n, pf;
}
var gf, C0;
function DC() {
  if (C0) return gf;
  C0 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return gf = n, gf;
}
var yf, j0;
function R2() {
  if (j0) return yf;
  j0 = 1;
  var e = Zy(), t = k2(), n = ci(), r = DC(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, c = o.toString, l = s.hasOwnProperty, d = RegExp(
    "^" + c.call(l).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!n(h) || t(h))
      return !1;
    var m = e(h) ? d : a;
    return m.test(r(h));
  }
  return yf = f, yf;
}
var bf, T0;
function L2() {
  if (T0) return bf;
  T0 = 1;
  function e(t, n) {
    return t?.[n];
  }
  return bf = e, bf;
}
var xf, N0;
function ra() {
  if (N0) return xf;
  N0 = 1;
  var e = R2(), t = L2();
  function n(r, i) {
    var a = t(r, i);
    return e(a) ? a : void 0;
  }
  return xf = n, xf;
}
var wf, M0;
function Lu() {
  if (M0) return wf;
  M0 = 1;
  var e = ra(), t = e(Object, "create");
  return wf = t, wf;
}
var _f, I0;
function $2() {
  if (I0) return _f;
  I0 = 1;
  var e = Lu();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return _f = t, _f;
}
var Sf, D0;
function B2() {
  if (D0) return Sf;
  D0 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Sf = e, Sf;
}
var Of, k0;
function F2() {
  if (k0) return Of;
  k0 = 1;
  var e = Lu(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    if (e) {
      var s = o[a];
      return s === t ? void 0 : s;
    }
    return r.call(o, a) ? o[a] : void 0;
  }
  return Of = i, Of;
}
var Ef, R0;
function z2() {
  if (R0) return Ef;
  R0 = 1;
  var e = Lu(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : n.call(a, i);
  }
  return Ef = r, Ef;
}
var Af, L0;
function q2() {
  if (L0) return Af;
  L0 = 1;
  var e = Lu(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var a = this.__data__;
    return this.size += this.has(r) ? 0 : 1, a[r] = e && i === void 0 ? t : i, this;
  }
  return Af = n, Af;
}
var Pf, $0;
function V2() {
  if ($0) return Pf;
  $0 = 1;
  var e = $2(), t = B2(), n = F2(), r = z2(), i = q2();
  function a(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var l = o[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Pf = a, Pf;
}
var Cf, B0;
function W2() {
  if (B0) return Cf;
  B0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Cf = e, Cf;
}
var jf, F0;
function Xy() {
  if (F0) return jf;
  F0 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return jf = e, jf;
}
var Tf, z0;
function $u() {
  if (z0) return Tf;
  z0 = 1;
  var e = Xy();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return Tf = t, Tf;
}
var Nf, q0;
function U2() {
  if (q0) return Nf;
  q0 = 1;
  var e = $u(), t = Array.prototype, n = t.splice;
  function r(i) {
    var a = this.__data__, o = e(a, i);
    if (o < 0)
      return !1;
    var s = a.length - 1;
    return o == s ? a.pop() : n.call(a, o, 1), --this.size, !0;
  }
  return Nf = r, Nf;
}
var Mf, V0;
function H2() {
  if (V0) return Mf;
  V0 = 1;
  var e = $u();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return Mf = t, Mf;
}
var If, W0;
function Y2() {
  if (W0) return If;
  W0 = 1;
  var e = $u();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return If = t, If;
}
var Df, U0;
function K2() {
  if (U0) return Df;
  U0 = 1;
  var e = $u();
  function t(n, r) {
    var i = this.__data__, a = e(i, n);
    return a < 0 ? (++this.size, i.push([n, r])) : i[a][1] = r, this;
  }
  return Df = t, Df;
}
var kf, H0;
function Bu() {
  if (H0) return kf;
  H0 = 1;
  var e = W2(), t = U2(), n = H2(), r = Y2(), i = K2();
  function a(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var l = o[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, kf = a, kf;
}
var Rf, Y0;
function Qy() {
  if (Y0) return Rf;
  Y0 = 1;
  var e = ra(), t = mr(), n = e(t, "Map");
  return Rf = n, Rf;
}
var Lf, K0;
function G2() {
  if (K0) return Lf;
  K0 = 1;
  var e = V2(), t = Bu(), n = Qy();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Lf = r, Lf;
}
var $f, G0;
function Z2() {
  if (G0) return $f;
  G0 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return $f = e, $f;
}
var Bf, Z0;
function Fu() {
  if (Z0) return Bf;
  Z0 = 1;
  var e = Z2();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return Bf = t, Bf;
}
var Ff, X0;
function X2() {
  if (X0) return Ff;
  X0 = 1;
  var e = Fu();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Ff = t, Ff;
}
var zf, Q0;
function Q2() {
  if (Q0) return zf;
  Q0 = 1;
  var e = Fu();
  function t(n) {
    return e(this, n).get(n);
  }
  return zf = t, zf;
}
var qf, J0;
function J2() {
  if (J0) return qf;
  J0 = 1;
  var e = Fu();
  function t(n) {
    return e(this, n).has(n);
  }
  return qf = t, qf;
}
var Vf, ew;
function e$() {
  if (ew) return Vf;
  ew = 1;
  var e = Fu();
  function t(n, r) {
    var i = e(this, n), a = i.size;
    return i.set(n, r), this.size += i.size == a ? 0 : 1, this;
  }
  return Vf = t, Vf;
}
var Wf, tw;
function Jy() {
  if (tw) return Wf;
  tw = 1;
  var e = G2(), t = X2(), n = Q2(), r = J2(), i = e$();
  function a(o) {
    var s = -1, c = o == null ? 0 : o.length;
    for (this.clear(); ++s < c; ) {
      var l = o[s];
      this.set(l[0], l[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Wf = a, Wf;
}
var Uf, nw;
function kC() {
  if (nw) return Uf;
  nw = 1;
  var e = Jy(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var o = arguments, s = i ? i.apply(this, o) : o[0], c = a.cache;
      if (c.has(s))
        return c.get(s);
      var l = r.apply(this, o);
      return a.cache = c.set(s, l) || c, l;
    };
    return a.cache = new (n.Cache || e)(), a;
  }
  return n.Cache = e, Uf = n, Uf;
}
var Hf, rw;
function t$() {
  if (rw) return Hf;
  rw = 1;
  var e = kC(), t = 500;
  function n(r) {
    var i = e(r, function(o) {
      return a.size === t && a.clear(), o;
    }), a = i.cache;
    return i;
  }
  return Hf = n, Hf;
}
var Yf, iw;
function n$() {
  if (iw) return Yf;
  iw = 1;
  var e = t$(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(o, s, c, l) {
      a.push(c ? l.replace(n, "$1") : s || o);
    }), a;
  });
  return Yf = r, Yf;
}
var Kf, aw;
function eb() {
  if (aw) return Kf;
  aw = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = Array(i); ++r < i; )
      a[r] = n(t[r], r, t);
    return a;
  }
  return Kf = e, Kf;
}
var Gf, ow;
function r$() {
  if (ow) return Gf;
  ow = 1;
  var e = tc(), t = eb(), n = sn(), r = go(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, o) + "";
    if (r(s))
      return a ? a.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Gf = o, Gf;
}
var Zf, sw;
function RC() {
  if (sw) return Zf;
  sw = 1;
  var e = r$();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Zf = t, Zf;
}
var Xf, cw;
function LC() {
  if (cw) return Xf;
  cw = 1;
  var e = sn(), t = Gy(), n = n$(), r = RC();
  function i(a, o) {
    return e(a) ? a : t(a, o) ? [a] : n(r(a));
  }
  return Xf = i, Xf;
}
var Qf, lw;
function zu() {
  if (lw) return Qf;
  lw = 1;
  var e = go();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return Qf = t, Qf;
}
var Jf, uw;
function tb() {
  if (uw) return Jf;
  uw = 1;
  var e = LC(), t = zu();
  function n(r, i) {
    i = e(i, r);
    for (var a = 0, o = i.length; r != null && a < o; )
      r = r[t(i[a++])];
    return a && a == o ? r : void 0;
  }
  return Jf = n, Jf;
}
var eh, dw;
function $C() {
  if (dw) return eh;
  dw = 1;
  var e = tb();
  function t(n, r, i) {
    var a = n == null ? void 0 : e(n, r);
    return a === void 0 ? i : a;
  }
  return eh = t, eh;
}
var i$ = $C();
const Tn = /* @__PURE__ */ ct(i$);
var th, fw;
function a$() {
  if (fw) return th;
  fw = 1;
  function e(t) {
    return t == null;
  }
  return th = e, th;
}
var o$ = a$();
const Ke = /* @__PURE__ */ ct(o$);
var nh, hw;
function s$() {
  if (hw) return nh;
  hw = 1;
  var e = $r(), t = sn(), n = Br(), r = "[object String]";
  function i(a) {
    return typeof a == "string" || !t(a) && n(a) && e(a) == r;
  }
  return nh = i, nh;
}
var c$ = s$();
const nc = /* @__PURE__ */ ct(c$);
var l$ = Zy();
const Re = /* @__PURE__ */ ct(l$);
var u$ = ci();
const yo = /* @__PURE__ */ ct(u$);
var Ic = { exports: {} }, ze = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mw;
function d$() {
  if (mw) return ze;
  mw = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function p(v) {
    if (typeof v == "object" && v !== null) {
      var y = v.$$typeof;
      switch (y) {
        case e:
          switch (v = v.type, v) {
            case n:
            case i:
            case r:
            case l:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case o:
                case c:
                case h:
                case f:
                case a:
                  return v;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return ze.ContextConsumer = o, ze.ContextProvider = a, ze.Element = e, ze.ForwardRef = c, ze.Fragment = n, ze.Lazy = h, ze.Memo = f, ze.Portal = t, ze.Profiler = i, ze.StrictMode = r, ze.Suspense = l, ze.SuspenseList = d, ze.isAsyncMode = function() {
    return !1;
  }, ze.isConcurrentMode = function() {
    return !1;
  }, ze.isContextConsumer = function(v) {
    return p(v) === o;
  }, ze.isContextProvider = function(v) {
    return p(v) === a;
  }, ze.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, ze.isForwardRef = function(v) {
    return p(v) === c;
  }, ze.isFragment = function(v) {
    return p(v) === n;
  }, ze.isLazy = function(v) {
    return p(v) === h;
  }, ze.isMemo = function(v) {
    return p(v) === f;
  }, ze.isPortal = function(v) {
    return p(v) === t;
  }, ze.isProfiler = function(v) {
    return p(v) === i;
  }, ze.isStrictMode = function(v) {
    return p(v) === r;
  }, ze.isSuspense = function(v) {
    return p(v) === l;
  }, ze.isSuspenseList = function(v) {
    return p(v) === d;
  }, ze.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === i || v === r || v === l || v === d || v === m || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === f || v.$$typeof === a || v.$$typeof === o || v.$$typeof === c || v.$$typeof === g || v.getModuleId !== void 0);
  }, ze.typeOf = p, ze;
}
var qe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vw;
function f$() {
  return vw || (vw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = !1, p = !1, v = !1, y = !1, x = !1, w;
    w = Symbol.for("react.module.reference");
    function _(te) {
      return !!(typeof te == "string" || typeof te == "function" || te === n || te === i || x || te === r || te === l || te === d || y || te === m || g || p || v || typeof te == "object" && te !== null && (te.$$typeof === h || te.$$typeof === f || te.$$typeof === a || te.$$typeof === o || te.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      te.$$typeof === w || te.getModuleId !== void 0));
    }
    function b(te) {
      if (typeof te == "object" && te !== null) {
        var Ne = te.$$typeof;
        switch (Ne) {
          case e:
            var Te = te.type;
            switch (Te) {
              case n:
              case i:
              case r:
              case l:
              case d:
                return Te;
              default:
                var Ge = Te && Te.$$typeof;
                switch (Ge) {
                  case s:
                  case o:
                  case c:
                  case h:
                  case f:
                  case a:
                    return Ge;
                  default:
                    return Ne;
                }
            }
          case t:
            return Ne;
        }
      }
    }
    var S = o, O = a, E = e, P = c, R = n, j = h, C = f, N = t, k = i, I = r, $ = l, z = d, V = !1, K = !1;
    function D(te) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(te) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(te) {
      return b(te) === o;
    }
    function X(te) {
      return b(te) === a;
    }
    function oe(te) {
      return typeof te == "object" && te !== null && te.$$typeof === e;
    }
    function ie(te) {
      return b(te) === c;
    }
    function he(te) {
      return b(te) === n;
    }
    function ee(te) {
      return b(te) === h;
    }
    function se(te) {
      return b(te) === f;
    }
    function G(te) {
      return b(te) === t;
    }
    function Q(te) {
      return b(te) === i;
    }
    function ce(te) {
      return b(te) === r;
    }
    function F(te) {
      return b(te) === l;
    }
    function ye(te) {
      return b(te) === d;
    }
    qe.ContextConsumer = S, qe.ContextProvider = O, qe.Element = E, qe.ForwardRef = P, qe.Fragment = R, qe.Lazy = j, qe.Memo = C, qe.Portal = N, qe.Profiler = k, qe.StrictMode = I, qe.Suspense = $, qe.SuspenseList = z, qe.isAsyncMode = D, qe.isConcurrentMode = U, qe.isContextConsumer = Y, qe.isContextProvider = X, qe.isElement = oe, qe.isForwardRef = ie, qe.isFragment = he, qe.isLazy = ee, qe.isMemo = se, qe.isPortal = G, qe.isProfiler = Q, qe.isStrictMode = ce, qe.isSuspense = F, qe.isSuspenseList = ye, qe.isValidElementType = _, qe.typeOf = b;
  })()), qe;
}
var pw;
function h$() {
  return pw || (pw = 1, process.env.NODE_ENV === "production" ? Ic.exports = d$() : Ic.exports = f$()), Ic.exports;
}
var m$ = h$(), rh, gw;
function BC() {
  if (gw) return rh;
  gw = 1;
  var e = $r(), t = Br(), n = "[object Number]";
  function r(i) {
    return typeof i == "number" || t(i) && e(i) == n;
  }
  return rh = r, rh;
}
var ih, yw;
function v$() {
  if (yw) return ih;
  yw = 1;
  var e = BC();
  function t(n) {
    return e(n) && n != +n;
  }
  return ih = t, ih;
}
var p$ = v$();
const rc = /* @__PURE__ */ ct(p$);
var g$ = BC();
const y$ = /* @__PURE__ */ ct(g$);
var Un = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Ti = function(t) {
  return nc(t) && t.indexOf("%") === t.length - 1;
}, me = function(t) {
  return y$(t) && !rc(t);
}, Ct = function(t) {
  return me(t) || nc(t);
}, b$ = 0, qu = function(t) {
  var n = ++b$;
  return "".concat(t || "").concat(n);
}, qi = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!me(t) && !nc(t))
    return r;
  var a;
  if (Ti(t)) {
    var o = t.indexOf("%");
    a = n * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return rc(a) && (a = r), i && a > n && (a = n), a;
}, ba = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, x$ = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, i = 0; i < n; i++)
    if (!r[t[i]])
      r[t[i]] = !0;
    else
      return !0;
  return !1;
}, da = function(t, n) {
  return me(t) && me(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function Kp(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : Tn(r, t)) === n;
  });
}
function Ea(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function Gp(e) {
  "@babel/helpers - typeof";
  return Gp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gp(e);
}
var w$ = ["viewBox", "children"], _$ = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], bw = ["points", "pathLength"], ah = {
  svg: w$,
  polygon: bw,
  polyline: bw
}, nb = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], xl = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ Yn(t) && (r = t.props), !yo(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(a) {
    nb.includes(a) && (i[a] = n || function(o) {
      return r[a](r, o);
    });
  }), i;
}, S$ = function(t, n, r) {
  return function(i) {
    return t(n, r, i), null;
  };
}, wl = function(t, n, r) {
  if (!yo(t) || Gp(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(a) {
    var o = t[a];
    nb.includes(a) && typeof o == "function" && (i || (i = {}), i[a] = S$(o, n, r));
  }), i;
}, O$ = ["children"], E$ = ["children"];
function xw(e, t) {
  if (e == null) return {};
  var n = A$(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function A$(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var ww = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Nr = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, _w = null, oh = null, rb = function e(t) {
  if (t === _w && Array.isArray(oh))
    return oh;
  var n = [];
  return Ri.forEach(t, function(r) {
    Ke(r) || (m$.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), oh = n, _w = t, n;
};
function Kn(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(i) {
    return Nr(i);
  }) : r = [Nr(t)], rb(e).forEach(function(i) {
    var a = Tn(i, "type.displayName") || Tn(i, "type.name");
    r.indexOf(a) !== -1 && n.push(i);
  }), n;
}
function fn(e, t) {
  var n = Kn(e, t);
  return n && n[0];
}
var Sw = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, i = n.height;
  return !(!me(r) || r <= 0 || !me(i) || i <= 0);
}, P$ = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], C$ = function(t) {
  return t && t.type && nc(t.type) && P$.indexOf(t.type) >= 0;
}, j$ = function(t, n, r, i) {
  var a, o = (a = ah?.[i]) !== null && a !== void 0 ? a : [];
  return !Re(t) && (i && o.includes(n) || _$.includes(n)) || r && nb.includes(n);
}, Ye = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ Yn(t) && (i = t.props), !yo(i))
    return null;
  var a = {};
  return Object.keys(i).forEach(function(o) {
    var s;
    j$((s = i) === null || s === void 0 ? void 0 : s[o], o, n, r) && (a[o] = i[o]);
  }), a;
}, Zp = function e(t, n) {
  if (t === n)
    return !0;
  var r = Ri.count(t);
  if (r !== Ri.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return Ow(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var i = 0; i < r; i++) {
    var a = t[i], o = n[i];
    if (Array.isArray(a) || Array.isArray(o)) {
      if (!e(a, o))
        return !1;
    } else if (!Ow(a, o))
      return !1;
  }
  return !0;
}, Ow = function(t, n) {
  if (Ke(t) && Ke(n))
    return !0;
  if (!Ke(t) && !Ke(n)) {
    var r = t.props || {}, i = r.children, a = xw(r, O$), o = n.props || {}, s = o.children, c = xw(o, E$);
    return i && s ? Ea(a, c) && Zp(i, s) : !i && !s ? Ea(a, c) : !1;
  }
  return !1;
}, Ew = function(t, n) {
  var r = [], i = {};
  return rb(t).forEach(function(a, o) {
    if (C$(a))
      r.push(a);
    else if (a) {
      var s = Nr(a.type), c = n[s] || {}, l = c.handler, d = c.once;
      if (l && (!d || !i[s])) {
        var f = l(a, s, o);
        r.push(f), i[s] = !0;
      }
    }
  }), r;
}, T$ = function(t) {
  var n = t && t.type;
  return n && ww[n] ? ww[n] : null;
}, N$ = function(t, n) {
  return rb(n).indexOf(t);
}, M$ = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Xp() {
  return Xp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xp.apply(this, arguments);
}
function I$(e, t) {
  if (e == null) return {};
  var n = D$(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function D$(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Qp(e) {
  var t = e.children, n = e.width, r = e.height, i = e.viewBox, a = e.className, o = e.style, s = e.title, c = e.desc, l = I$(e, M$), d = i || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, f = Fe("recharts-surface", a);
  return /* @__PURE__ */ T.createElement("svg", Xp({}, Ye(l, !0, "svg"), {
    className: f,
    width: n,
    height: r,
    style: o,
    viewBox: "".concat(d.x, " ").concat(d.y, " ").concat(d.width, " ").concat(d.height)
  }), /* @__PURE__ */ T.createElement("title", null, s), /* @__PURE__ */ T.createElement("desc", null, c), t);
}
var k$ = ["children", "className"];
function Jp() {
  return Jp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jp.apply(this, arguments);
}
function R$(e, t) {
  if (e == null) return {};
  var n = L$(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function L$(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var It = /* @__PURE__ */ T.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = R$(e, k$), a = Fe("recharts-layer", r);
  return /* @__PURE__ */ T.createElement("g", Jp({
    className: a
  }, Ye(i, !0), {
    ref: t
  }), n);
}), $$ = process.env.NODE_ENV !== "production", Li = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  if ($$ && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[o++];
      }));
    }
}, sh, Aw;
function B$() {
  if (Aw) return sh;
  Aw = 1;
  function e(t, n, r) {
    var i = -1, a = t.length;
    n < 0 && (n = -n > a ? 0 : a + n), r = r > a ? a : r, r < 0 && (r += a), a = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var o = Array(a); ++i < a; )
      o[i] = t[i + n];
    return o;
  }
  return sh = e, sh;
}
var ch, Pw;
function F$() {
  if (Pw) return ch;
  Pw = 1;
  var e = B$();
  function t(n, r, i) {
    var a = n.length;
    return i = i === void 0 ? a : i, !r && i >= a ? n : e(n, r, i);
  }
  return ch = t, ch;
}
var lh, Cw;
function FC() {
  if (Cw) return lh;
  Cw = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, a = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + e + i + a + "]");
  function c(l) {
    return s.test(l);
  }
  return lh = c, lh;
}
var uh, jw;
function z$() {
  if (jw) return uh;
  jw = 1;
  function e(t) {
    return t.split("");
  }
  return uh = e, uh;
}
var dh, Tw;
function q$() {
  if (Tw) return dh;
  Tw = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, a = "\\ufe0e\\ufe0f", o = "[" + e + "]", s = "[" + i + "]", c = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + s + "|" + c + ")", d = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", m = "\\u200d", g = l + "?", p = "[" + a + "]?", v = "(?:" + m + "(?:" + [d, f, h].join("|") + ")" + p + g + ")*", y = p + g + v, x = "(?:" + [d + s + "?", s, f, h, o].join("|") + ")", w = RegExp(c + "(?=" + c + ")|" + x + y, "g");
  function _(b) {
    return b.match(w) || [];
  }
  return dh = _, dh;
}
var fh, Nw;
function V$() {
  if (Nw) return fh;
  Nw = 1;
  var e = z$(), t = FC(), n = q$();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return fh = r, fh;
}
var hh, Mw;
function W$() {
  if (Mw) return hh;
  Mw = 1;
  var e = F$(), t = FC(), n = V$(), r = RC();
  function i(a) {
    return function(o) {
      o = r(o);
      var s = t(o) ? n(o) : void 0, c = s ? s[0] : o.charAt(0), l = s ? e(s, 1).join("") : o.slice(1);
      return c[a]() + l;
    };
  }
  return hh = i, hh;
}
var mh, Iw;
function U$() {
  if (Iw) return mh;
  Iw = 1;
  var e = W$(), t = e("toUpperCase");
  return mh = t, mh;
}
var H$ = U$();
const Vu = /* @__PURE__ */ ct(H$);
function nt(e) {
  return function() {
    return e;
  };
}
const zC = Math.cos, _l = Math.sin, Xn = Math.sqrt, Sl = Math.PI, Wu = 2 * Sl, eg = Math.PI, tg = 2 * eg, Oi = 1e-6, Y$ = tg - Oi;
function qC(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function K$(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return qC;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, a = r.length; i < a; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class G$ {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? qC : K$(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, a, o) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, n, r, i, a) {
    if (t = +t, n = +n, r = +r, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, s = this._y1, c = r - t, l = i - n, d = o - t, f = s - n, h = d * d + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > Oi) if (!(Math.abs(f * c - l * d) > Oi) || !a)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = r - o, g = i - s, p = c * c + l * l, v = m * m + g * g, y = Math.sqrt(p), x = Math.sqrt(h), w = a * Math.tan((eg - Math.acos((p + h - v) / (2 * y * x))) / 2), _ = w / x, b = w / y;
      Math.abs(_ - 1) > Oi && this._append`L${t + _ * d},${n + _ * f}`, this._append`A${a},${a},0,0,${+(f * m > d * g)},${this._x1 = t + b * c},${this._y1 = n + b * l}`;
    }
  }
  arc(t, n, r, i, a, o) {
    if (t = +t, n = +n, r = +r, o = !!o, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), c = r * Math.sin(i), l = t + s, d = n + c, f = 1 ^ o, h = o ? i - a : a - i;
    this._x1 === null ? this._append`M${l},${d}` : (Math.abs(this._x1 - l) > Oi || Math.abs(this._y1 - d) > Oi) && this._append`L${l},${d}`, r && (h < 0 && (h = h % tg + tg), h > Y$ ? this._append`A${r},${r},0,1,${f},${t - s},${n - c}A${r},${r},0,1,${f},${this._x1 = l},${this._y1 = d}` : h > Oi && this._append`A${r},${r},0,${+(h >= eg)},${f},${this._x1 = t + r * Math.cos(a)},${this._y1 = n + r * Math.sin(a)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function ib(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new G$(t);
}
function ab(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function VC(e) {
  this._context = e;
}
VC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Uu(e) {
  return new VC(e);
}
function WC(e) {
  return e[0];
}
function UC(e) {
  return e[1];
}
function HC(e, t) {
  var n = nt(!0), r = null, i = Uu, a = null, o = ib(s);
  e = typeof e == "function" ? e : e === void 0 ? WC : nt(e), t = typeof t == "function" ? t : t === void 0 ? UC : nt(t);
  function s(c) {
    var l, d = (c = ab(c)).length, f, h = !1, m;
    for (r == null && (a = i(m = o())), l = 0; l <= d; ++l)
      !(l < d && n(f = c[l], l, c)) === h && ((h = !h) ? a.lineStart() : a.lineEnd()), h && a.point(+e(f, l, c), +t(f, l, c));
    if (m) return a = null, m + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : nt(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : nt(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : nt(!!c), s) : n;
  }, s.curve = function(c) {
    return arguments.length ? (i = c, r != null && (a = i(r)), s) : i;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? r = a = null : a = i(r = c), s) : r;
  }, s;
}
function Dc(e, t, n) {
  var r = null, i = nt(!0), a = null, o = Uu, s = null, c = ib(l);
  e = typeof e == "function" ? e : e === void 0 ? WC : nt(+e), t = typeof t == "function" ? t : nt(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? UC : nt(+n);
  function l(f) {
    var h, m, g, p = (f = ab(f)).length, v, y = !1, x, w = new Array(p), _ = new Array(p);
    for (a == null && (s = o(x = c())), h = 0; h <= p; ++h) {
      if (!(h < p && i(v = f[h], h, f)) === y)
        if (y = !y)
          m = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = h - 1; g >= m; --g)
            s.point(w[g], _[g]);
          s.lineEnd(), s.areaEnd();
        }
      y && (w[h] = +e(v, h, f), _[h] = +t(v, h, f), s.point(r ? +r(v, h, f) : w[h], n ? +n(v, h, f) : _[h]));
    }
    if (x) return s = null, x + "" || null;
  }
  function d() {
    return HC().defined(i).curve(o).context(a);
  }
  return l.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : nt(+f), r = null, l) : e;
  }, l.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : nt(+f), l) : e;
  }, l.x1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : nt(+f), l) : r;
  }, l.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : nt(+f), n = null, l) : t;
  }, l.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : nt(+f), l) : t;
  }, l.y1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : nt(+f), l) : n;
  }, l.lineX0 = l.lineY0 = function() {
    return d().x(e).y(t);
  }, l.lineY1 = function() {
    return d().x(e).y(n);
  }, l.lineX1 = function() {
    return d().x(r).y(t);
  }, l.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : nt(!!f), l) : i;
  }, l.curve = function(f) {
    return arguments.length ? (o = f, a != null && (s = o(a)), l) : o;
  }, l.context = function(f) {
    return arguments.length ? (f == null ? a = s = null : s = o(a = f), l) : a;
  }, l;
}
class YC {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function Z$(e) {
  return new YC(e, !0);
}
function X$(e) {
  return new YC(e, !1);
}
const ob = {
  draw(e, t) {
    const n = Xn(t / Sl);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Wu);
  }
}, Q$ = {
  draw(e, t) {
    const n = Xn(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, KC = Xn(1 / 3), J$ = KC * 2, eB = {
  draw(e, t) {
    const n = Xn(t / J$), r = n * KC;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, tB = {
  draw(e, t) {
    const n = Xn(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, nB = 0.8908130915292852, GC = _l(Sl / 10) / _l(7 * Sl / 10), rB = _l(Wu / 10) * GC, iB = -zC(Wu / 10) * GC, aB = {
  draw(e, t) {
    const n = Xn(t * nB), r = rB * n, i = iB * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let a = 1; a < 5; ++a) {
      const o = Wu * a / 5, s = zC(o), c = _l(o);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, vh = Xn(3), oB = {
  draw(e, t) {
    const n = -Xn(t / (vh * 3));
    e.moveTo(0, n * 2), e.lineTo(-vh * n, -n), e.lineTo(vh * n, -n), e.closePath();
  }
}, On = -0.5, En = Xn(3) / 2, ng = 1 / Xn(12), sB = (ng / 2 + 1) * 3, cB = {
  draw(e, t) {
    const n = Xn(t / sB), r = n / 2, i = n * ng, a = r, o = n * ng + n, s = -a, c = o;
    e.moveTo(r, i), e.lineTo(a, o), e.lineTo(s, c), e.lineTo(On * r - En * i, En * r + On * i), e.lineTo(On * a - En * o, En * a + On * o), e.lineTo(On * s - En * c, En * s + On * c), e.lineTo(On * r + En * i, On * i - En * r), e.lineTo(On * a + En * o, On * o - En * a), e.lineTo(On * s + En * c, On * c - En * s), e.closePath();
  }
};
function lB(e, t) {
  let n = null, r = ib(i);
  e = typeof e == "function" ? e : nt(e || ob), t = typeof t == "function" ? t : nt(t === void 0 ? 64 : +t);
  function i() {
    let a;
    if (n || (n = a = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), a) return n = null, a + "" || null;
  }
  return i.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : nt(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : nt(+a), i) : t;
  }, i.context = function(a) {
    return arguments.length ? (n = a ?? null, i) : n;
  }, i;
}
function Ol() {
}
function El(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function ZC(e) {
  this._context = e;
}
ZC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        El(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        El(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function uB(e) {
  return new ZC(e);
}
function XC(e) {
  this._context = e;
}
XC.prototype = {
  areaStart: Ol,
  areaEnd: Ol,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        El(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function dB(e) {
  return new XC(e);
}
function QC(e) {
  this._context = e;
}
QC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        El(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function fB(e) {
  return new QC(e);
}
function JC(e) {
  this._context = e;
}
JC.prototype = {
  areaStart: Ol,
  areaEnd: Ol,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function hB(e) {
  return new JC(e);
}
function Dw(e) {
  return e < 0 ? -1 : 1;
}
function kw(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (r || i < 0 && -0), o = (n - e._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
  return (Dw(a) + Dw(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function Rw(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function ph(e, t, n) {
  var r = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, a - s, o - s * n, a, o);
}
function Al(e) {
  this._context = e;
}
Al.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        ph(this, this._t0, Rw(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, ph(this, Rw(this, n = kw(this, e, t)), n);
          break;
        default:
          ph(this, this._t0, n = kw(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function ej(e) {
  this._context = new tj(e);
}
(ej.prototype = Object.create(Al.prototype)).point = function(e, t) {
  Al.prototype.point.call(this, t, e);
};
function tj(e) {
  this._context = e;
}
tj.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, a) {
    this._context.bezierCurveTo(t, e, r, n, a, i);
  }
};
function mB(e) {
  return new Al(e);
}
function vB(e) {
  return new ej(e);
}
function nj(e) {
  this._context = e;
}
nj.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = Lw(e), i = Lw(t), a = 0, o = 1; o < n; ++a, ++o)
          this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Lw(e) {
  var t, n = e.length - 1, r, i = new Array(n), a = new Array(n), o = new Array(n);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, a[n - 1] = 7, o[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / a[t - 1], a[t] -= r, o[t] -= r * o[t - 1];
  for (i[n - 1] = o[n - 1] / a[n - 1], t = n - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function pB(e) {
  return new nj(e);
}
function Hu(e, t) {
  this._context = e, this._t = t;
}
Hu.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function gB(e) {
  return new Hu(e, 0.5);
}
function yB(e) {
  return new Hu(e, 0);
}
function bB(e) {
  return new Hu(e, 1);
}
function $a(e, t) {
  if ((o = e.length) > 1)
    for (var n = 1, r, i, a = e[t[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = e[t[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function rg(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function xB(e, t) {
  return e[t];
}
function wB(e) {
  const t = [];
  return t.key = e, t;
}
function _B() {
  var e = nt([]), t = rg, n = $a, r = xB;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), wB), s, c = o.length, l = -1, d;
    for (const f of a)
      for (s = 0, ++l; s < c; ++s)
        (o[s][l] = [0, +r(f, o[s].key, l, a)]).data = f;
    for (s = 0, d = ab(t(o)); s < c; ++s)
      o[d[s]].index = s;
    return n(o, d), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : nt(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : nt(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? rg : typeof a == "function" ? a : nt(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? $a, i) : n;
  }, i;
}
function SB(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = n = 0; n < r; ++n) o += e[n][i][1] || 0;
      if (o) for (n = 0; n < r; ++n) e[n][i][1] /= o;
    }
    $a(e, t);
  }
}
function OB(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, a = r.length; n < a; ++n) {
      for (var o = 0, s = 0; o < i; ++o) s += e[o][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    $a(e, t);
  }
}
function EB(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, a, o; r < a; ++r) {
      for (var s = 0, c = 0, l = 0; s < o; ++s) {
        for (var d = e[t[s]], f = d[r][1] || 0, h = d[r - 1][1] || 0, m = (f - h) / 2, g = 0; g < s; ++g) {
          var p = e[t[g]], v = p[r][1] || 0, y = p[r - 1][1] || 0;
          m += v - y;
        }
        c += f, l += m * f;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, $a(e, t);
  }
}
function ds(e) {
  "@babel/helpers - typeof";
  return ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ds(e);
}
var AB = ["type", "size", "sizeType"];
function ig() {
  return ig = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ig.apply(this, arguments);
}
function $w(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $w(Object(n), !0).forEach(function(r) {
      PB(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $w(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function PB(e, t, n) {
  return t = CB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function CB(e) {
  var t = jB(e, "string");
  return ds(t) == "symbol" ? t : t + "";
}
function jB(e, t) {
  if (ds(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ds(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function TB(e, t) {
  if (e == null) return {};
  var n = NB(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NB(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var rj = {
  symbolCircle: ob,
  symbolCross: Q$,
  symbolDiamond: eB,
  symbolSquare: tB,
  symbolStar: aB,
  symbolTriangle: oB,
  symbolWye: cB
}, MB = Math.PI / 180, IB = function(t) {
  var n = "symbol".concat(Vu(t));
  return rj[n] || ob;
}, DB = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * MB;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, kB = function(t, n) {
  rj["symbol".concat(Vu(t))] = n;
}, sb = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, i = t.size, a = i === void 0 ? 64 : i, o = t.sizeType, s = o === void 0 ? "area" : o, c = TB(t, AB), l = Bw(Bw({}, c), {}, {
    type: r,
    size: a,
    sizeType: s
  }), d = function() {
    var v = IB(r), y = lB().type(v).size(DB(a, s, r));
    return y();
  }, f = l.className, h = l.cx, m = l.cy, g = Ye(l, !0);
  return h === +h && m === +m && a === +a ? /* @__PURE__ */ T.createElement("path", ig({}, g, {
    className: Fe("recharts-symbols", f),
    transform: "translate(".concat(h, ", ").concat(m, ")"),
    d: d()
  })) : null;
};
sb.registerSymbol = kB;
function Ba(e) {
  "@babel/helpers - typeof";
  return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ba(e);
}
function ag() {
  return ag = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ag.apply(this, arguments);
}
function Fw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function RB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fw(Object(n), !0).forEach(function(r) {
      fs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function LB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $B(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, aj(r.key), r);
  }
}
function BB(e, t, n) {
  return t && $B(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function FB(e, t, n) {
  return t = Pl(t), zB(e, ij() ? Reflect.construct(t, n || [], Pl(e).constructor) : t.apply(e, n));
}
function zB(e, t) {
  if (t && (Ba(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return qB(e);
}
function qB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ij() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ij = function() {
    return !!e;
  })();
}
function Pl(e) {
  return Pl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Pl(e);
}
function VB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && og(e, t);
}
function og(e, t) {
  return og = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, og(e, t);
}
function fs(e, t, n) {
  return t = aj(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function aj(e) {
  var t = WB(e, "string");
  return Ba(t) == "symbol" ? t : t + "";
}
function WB(e, t) {
  if (Ba(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ba(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var An = 32, cb = /* @__PURE__ */ (function(e) {
  function t() {
    return LB(this, t), FB(this, t, arguments);
  }
  return VB(t, e), BB(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, a = An / 2, o = An / 6, s = An / 3, c = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ T.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: An,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ T.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(a, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(a, `
            H`).concat(An, "M").concat(2 * s, ",").concat(a, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ T.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(An / 8, "h").concat(An, "v").concat(An * 3 / 4, "h").concat(-An, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ T.isValidElement(r.legendIcon)) {
          var l = RB({}, r);
          return delete l.legendIcon, /* @__PURE__ */ T.cloneElement(r.legendIcon, l);
        }
        return /* @__PURE__ */ T.createElement(sb, {
          fill: c,
          cx: a,
          cy: a,
          size: An,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, a = i.payload, o = i.iconSize, s = i.layout, c = i.formatter, l = i.inactiveColor, d = {
        x: 0,
        y: 0,
        width: An,
        height: An
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, h = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(m, g) {
        var p = m.formatter || c, v = Fe(fs(fs({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", m.inactive));
        if (m.type === "none")
          return null;
        var y = Re(m.value) ? null : m.value;
        Li(
          !Re(m.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var x = m.inactive ? l : m.color;
        return /* @__PURE__ */ T.createElement("li", ag({
          className: v,
          style: f,
          key: "legend-item-".concat(g)
        }, wl(r.props, m, g)), /* @__PURE__ */ T.createElement(Qp, {
          width: o,
          height: o,
          viewBox: d,
          style: h
        }, r.renderIcon(m)), /* @__PURE__ */ T.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: x
          }
        }, p ? p(y, m, g) : y));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, a = r.layout, o = r.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ T.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
})(ta);
fs(cb, "displayName", "Legend");
fs(cb, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var gh, zw;
function UB() {
  if (zw) return gh;
  zw = 1;
  var e = Bu();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return gh = t, gh;
}
var yh, qw;
function HB() {
  if (qw) return yh;
  qw = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return yh = e, yh;
}
var bh, Vw;
function YB() {
  if (Vw) return bh;
  Vw = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return bh = e, bh;
}
var xh, Ww;
function KB() {
  if (Ww) return xh;
  Ww = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return xh = e, xh;
}
var wh, Uw;
function GB() {
  if (Uw) return wh;
  Uw = 1;
  var e = Bu(), t = Qy(), n = Jy(), r = 200;
  function i(a, o) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < r - 1)
        return c.push([a, o]), this.size = ++s.size, this;
      s = this.__data__ = new n(c);
    }
    return s.set(a, o), this.size = s.size, this;
  }
  return wh = i, wh;
}
var _h, Hw;
function oj() {
  if (Hw) return _h;
  Hw = 1;
  var e = Bu(), t = UB(), n = HB(), r = YB(), i = KB(), a = GB();
  function o(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return o.prototype.clear = t, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, _h = o, _h;
}
var Sh, Yw;
function ZB() {
  if (Yw) return Sh;
  Yw = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return Sh = t, Sh;
}
var Oh, Kw;
function XB() {
  if (Kw) return Oh;
  Kw = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Oh = e, Oh;
}
var Eh, Gw;
function sj() {
  if (Gw) return Eh;
  Gw = 1;
  var e = Jy(), t = ZB(), n = XB();
  function r(i) {
    var a = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < o; )
      this.add(i[a]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, Eh = r, Eh;
}
var Ah, Zw;
function cj() {
  if (Zw) return Ah;
  Zw = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return Ah = e, Ah;
}
var Ph, Xw;
function lj() {
  if (Xw) return Ph;
  Xw = 1;
  function e(t, n) {
    return t.has(n);
  }
  return Ph = e, Ph;
}
var Ch, Qw;
function uj() {
  if (Qw) return Ch;
  Qw = 1;
  var e = sj(), t = cj(), n = lj(), r = 1, i = 2;
  function a(o, s, c, l, d, f) {
    var h = c & r, m = o.length, g = s.length;
    if (m != g && !(h && g > m))
      return !1;
    var p = f.get(o), v = f.get(s);
    if (p && v)
      return p == s && v == o;
    var y = -1, x = !0, w = c & i ? new e() : void 0;
    for (f.set(o, s), f.set(s, o); ++y < m; ) {
      var _ = o[y], b = s[y];
      if (l)
        var S = h ? l(b, _, y, s, o, f) : l(_, b, y, o, s, f);
      if (S !== void 0) {
        if (S)
          continue;
        x = !1;
        break;
      }
      if (w) {
        if (!t(s, function(O, E) {
          if (!n(w, E) && (_ === O || d(_, O, c, l, f)))
            return w.push(E);
        })) {
          x = !1;
          break;
        }
      } else if (!(_ === b || d(_, b, c, l, f))) {
        x = !1;
        break;
      }
    }
    return f.delete(o), f.delete(s), x;
  }
  return Ch = a, Ch;
}
var jh, Jw;
function QB() {
  if (Jw) return jh;
  Jw = 1;
  var e = mr(), t = e.Uint8Array;
  return jh = t, jh;
}
var Th, e_;
function JB() {
  if (e_) return Th;
  e_ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i, a) {
      r[++n] = [a, i];
    }), r;
  }
  return Th = e, Th;
}
var Nh, t_;
function lb() {
  if (t_) return Nh;
  t_ = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i) {
      r[++n] = i;
    }), r;
  }
  return Nh = e, Nh;
}
var Mh, n_;
function eF() {
  if (n_) return Mh;
  n_ = 1;
  var e = tc(), t = QB(), n = Xy(), r = uj(), i = JB(), a = lb(), o = 1, s = 2, c = "[object Boolean]", l = "[object Date]", d = "[object Error]", f = "[object Map]", h = "[object Number]", m = "[object RegExp]", g = "[object Set]", p = "[object String]", v = "[object Symbol]", y = "[object ArrayBuffer]", x = "[object DataView]", w = e ? e.prototype : void 0, _ = w ? w.valueOf : void 0;
  function b(S, O, E, P, R, j, C) {
    switch (E) {
      case x:
        if (S.byteLength != O.byteLength || S.byteOffset != O.byteOffset)
          return !1;
        S = S.buffer, O = O.buffer;
      case y:
        return !(S.byteLength != O.byteLength || !j(new t(S), new t(O)));
      case c:
      case l:
      case h:
        return n(+S, +O);
      case d:
        return S.name == O.name && S.message == O.message;
      case m:
      case p:
        return S == O + "";
      case f:
        var N = i;
      case g:
        var k = P & o;
        if (N || (N = a), S.size != O.size && !k)
          return !1;
        var I = C.get(S);
        if (I)
          return I == O;
        P |= s, C.set(S, O);
        var $ = r(N(S), N(O), P, R, j, C);
        return C.delete(S), $;
      case v:
        if (_)
          return _.call(S) == _.call(O);
    }
    return !1;
  }
  return Mh = b, Mh;
}
var Ih, r_;
function dj() {
  if (r_) return Ih;
  r_ = 1;
  function e(t, n) {
    for (var r = -1, i = n.length, a = t.length; ++r < i; )
      t[a + r] = n[r];
    return t;
  }
  return Ih = e, Ih;
}
var Dh, i_;
function tF() {
  if (i_) return Dh;
  i_ = 1;
  var e = dj(), t = sn();
  function n(r, i, a) {
    var o = i(r);
    return t(r) ? o : e(o, a(r));
  }
  return Dh = n, Dh;
}
var kh, a_;
function nF() {
  if (a_) return kh;
  a_ = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = 0, o = []; ++r < i; ) {
      var s = t[r];
      n(s, r, t) && (o[a++] = s);
    }
    return o;
  }
  return kh = e, kh;
}
var Rh, o_;
function rF() {
  if (o_) return Rh;
  o_ = 1;
  function e() {
    return [];
  }
  return Rh = e, Rh;
}
var Lh, s_;
function iF() {
  if (s_) return Lh;
  s_ = 1;
  var e = nF(), t = rF(), n = Object.prototype, r = n.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(o) {
    return o == null ? [] : (o = Object(o), e(i(o), function(s) {
      return r.call(o, s);
    }));
  } : t;
  return Lh = a, Lh;
}
var $h, c_;
function aF() {
  if (c_) return $h;
  c_ = 1;
  function e(t, n) {
    for (var r = -1, i = Array(t); ++r < t; )
      i[r] = n(r);
    return i;
  }
  return $h = e, $h;
}
var Bh, l_;
function oF() {
  if (l_) return Bh;
  l_ = 1;
  var e = $r(), t = Br(), n = "[object Arguments]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return Bh = r, Bh;
}
var Fh, u_;
function ub() {
  if (u_) return Fh;
  u_ = 1;
  var e = oF(), t = Br(), n = Object.prototype, r = n.hasOwnProperty, i = n.propertyIsEnumerable, a = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(o) {
    return t(o) && r.call(o, "callee") && !i.call(o, "callee");
  };
  return Fh = a, Fh;
}
var Yo = { exports: {} }, zh, d_;
function sF() {
  if (d_) return zh;
  d_ = 1;
  function e() {
    return !1;
  }
  return zh = e, zh;
}
Yo.exports;
var f_;
function fj() {
  return f_ || (f_ = 1, (function(e, t) {
    var n = mr(), r = sF(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
    e.exports = l;
  })(Yo, Yo.exports)), Yo.exports;
}
var qh, h_;
function db() {
  if (h_) return qh;
  h_ = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, i) {
    var a = typeof r;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return qh = n, qh;
}
var Vh, m_;
function fb() {
  if (m_) return Vh;
  m_ = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return Vh = t, Vh;
}
var Wh, v_;
function cF() {
  if (v_) return Wh;
  v_ = 1;
  var e = $r(), t = fb(), n = Br(), r = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", o = "[object Date]", s = "[object Error]", c = "[object Function]", l = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", m = "[object Set]", g = "[object String]", p = "[object WeakMap]", v = "[object ArrayBuffer]", y = "[object DataView]", x = "[object Float32Array]", w = "[object Float64Array]", _ = "[object Int8Array]", b = "[object Int16Array]", S = "[object Int32Array]", O = "[object Uint8Array]", E = "[object Uint8ClampedArray]", P = "[object Uint16Array]", R = "[object Uint32Array]", j = {};
  j[x] = j[w] = j[_] = j[b] = j[S] = j[O] = j[E] = j[P] = j[R] = !0, j[r] = j[i] = j[v] = j[a] = j[y] = j[o] = j[s] = j[c] = j[l] = j[d] = j[f] = j[h] = j[m] = j[g] = j[p] = !1;
  function C(N) {
    return n(N) && t(N.length) && !!j[e(N)];
  }
  return Wh = C, Wh;
}
var Uh, p_;
function hj() {
  if (p_) return Uh;
  p_ = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return Uh = e, Uh;
}
var Ko = { exports: {} };
Ko.exports;
var g_;
function lF() {
  return g_ || (g_ = 1, (function(e, t) {
    var n = IC(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, a = i && i.exports === r, o = a && n.process, s = (function() {
      try {
        var c = i && i.require && i.require("util").types;
        return c || o && o.binding && o.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(Ko, Ko.exports)), Ko.exports;
}
var Hh, y_;
function mj() {
  if (y_) return Hh;
  y_ = 1;
  var e = cF(), t = hj(), n = lF(), r = n && n.isTypedArray, i = r ? t(r) : e;
  return Hh = i, Hh;
}
var Yh, b_;
function uF() {
  if (b_) return Yh;
  b_ = 1;
  var e = aF(), t = ub(), n = sn(), r = fj(), i = db(), a = mj(), o = Object.prototype, s = o.hasOwnProperty;
  function c(l, d) {
    var f = n(l), h = !f && t(l), m = !f && !h && r(l), g = !f && !h && !m && a(l), p = f || h || m || g, v = p ? e(l.length, String) : [], y = v.length;
    for (var x in l)
      (d || s.call(l, x)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (x == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (x == "offset" || x == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (x == "buffer" || x == "byteLength" || x == "byteOffset") || // Skip index properties.
      i(x, y))) && v.push(x);
    return v;
  }
  return Yh = c, Yh;
}
var Kh, x_;
function dF() {
  if (x_) return Kh;
  x_ = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, i = typeof r == "function" && r.prototype || e;
    return n === i;
  }
  return Kh = t, Kh;
}
var Gh, w_;
function vj() {
  if (w_) return Gh;
  w_ = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return Gh = e, Gh;
}
var Zh, __;
function fF() {
  if (__) return Zh;
  __ = 1;
  var e = vj(), t = e(Object.keys, Object);
  return Zh = t, Zh;
}
var Xh, S_;
function hF() {
  if (S_) return Xh;
  S_ = 1;
  var e = dF(), t = fF(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var o = [];
    for (var s in Object(a))
      r.call(a, s) && s != "constructor" && o.push(s);
    return o;
  }
  return Xh = i, Xh;
}
var Qh, O_;
function ic() {
  if (O_) return Qh;
  O_ = 1;
  var e = Zy(), t = fb();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return Qh = n, Qh;
}
var Jh, E_;
function Yu() {
  if (E_) return Jh;
  E_ = 1;
  var e = uF(), t = hF(), n = ic();
  function r(i) {
    return n(i) ? e(i) : t(i);
  }
  return Jh = r, Jh;
}
var em, A_;
function mF() {
  if (A_) return em;
  A_ = 1;
  var e = tF(), t = iF(), n = Yu();
  function r(i) {
    return e(i, n, t);
  }
  return em = r, em;
}
var tm, P_;
function vF() {
  if (P_) return tm;
  P_ = 1;
  var e = mF(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function i(a, o, s, c, l, d) {
    var f = s & t, h = e(a), m = h.length, g = e(o), p = g.length;
    if (m != p && !f)
      return !1;
    for (var v = m; v--; ) {
      var y = h[v];
      if (!(f ? y in o : r.call(o, y)))
        return !1;
    }
    var x = d.get(a), w = d.get(o);
    if (x && w)
      return x == o && w == a;
    var _ = !0;
    d.set(a, o), d.set(o, a);
    for (var b = f; ++v < m; ) {
      y = h[v];
      var S = a[y], O = o[y];
      if (c)
        var E = f ? c(O, S, y, o, a, d) : c(S, O, y, a, o, d);
      if (!(E === void 0 ? S === O || l(S, O, s, c, d) : E)) {
        _ = !1;
        break;
      }
      b || (b = y == "constructor");
    }
    if (_ && !b) {
      var P = a.constructor, R = o.constructor;
      P != R && "constructor" in a && "constructor" in o && !(typeof P == "function" && P instanceof P && typeof R == "function" && R instanceof R) && (_ = !1);
    }
    return d.delete(a), d.delete(o), _;
  }
  return tm = i, tm;
}
var nm, C_;
function pF() {
  if (C_) return nm;
  C_ = 1;
  var e = ra(), t = mr(), n = e(t, "DataView");
  return nm = n, nm;
}
var rm, j_;
function gF() {
  if (j_) return rm;
  j_ = 1;
  var e = ra(), t = mr(), n = e(t, "Promise");
  return rm = n, rm;
}
var im, T_;
function pj() {
  if (T_) return im;
  T_ = 1;
  var e = ra(), t = mr(), n = e(t, "Set");
  return im = n, im;
}
var am, N_;
function yF() {
  if (N_) return am;
  N_ = 1;
  var e = ra(), t = mr(), n = e(t, "WeakMap");
  return am = n, am;
}
var om, M_;
function bF() {
  if (M_) return om;
  M_ = 1;
  var e = pF(), t = Qy(), n = gF(), r = pj(), i = yF(), a = $r(), o = DC(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", m = o(e), g = o(t), p = o(n), v = o(r), y = o(i), x = a;
  return (e && x(new e(new ArrayBuffer(1))) != h || t && x(new t()) != s || n && x(n.resolve()) != l || r && x(new r()) != d || i && x(new i()) != f) && (x = function(w) {
    var _ = a(w), b = _ == c ? w.constructor : void 0, S = b ? o(b) : "";
    if (S)
      switch (S) {
        case m:
          return h;
        case g:
          return s;
        case p:
          return l;
        case v:
          return d;
        case y:
          return f;
      }
    return _;
  }), om = x, om;
}
var sm, I_;
function xF() {
  if (I_) return sm;
  I_ = 1;
  var e = oj(), t = uj(), n = eF(), r = vF(), i = bF(), a = sn(), o = fj(), s = mj(), c = 1, l = "[object Arguments]", d = "[object Array]", f = "[object Object]", h = Object.prototype, m = h.hasOwnProperty;
  function g(p, v, y, x, w, _) {
    var b = a(p), S = a(v), O = b ? d : i(p), E = S ? d : i(v);
    O = O == l ? f : O, E = E == l ? f : E;
    var P = O == f, R = E == f, j = O == E;
    if (j && o(p)) {
      if (!o(v))
        return !1;
      b = !0, P = !1;
    }
    if (j && !P)
      return _ || (_ = new e()), b || s(p) ? t(p, v, y, x, w, _) : n(p, v, O, y, x, w, _);
    if (!(y & c)) {
      var C = P && m.call(p, "__wrapped__"), N = R && m.call(v, "__wrapped__");
      if (C || N) {
        var k = C ? p.value() : p, I = N ? v.value() : v;
        return _ || (_ = new e()), w(k, I, y, x, _);
      }
    }
    return j ? (_ || (_ = new e()), r(p, v, y, x, w, _)) : !1;
  }
  return sm = g, sm;
}
var cm, D_;
function hb() {
  if (D_) return cm;
  D_ = 1;
  var e = xF(), t = Br();
  function n(r, i, a, o, s) {
    return r === i ? !0 : r == null || i == null || !t(r) && !t(i) ? r !== r && i !== i : e(r, i, a, o, n, s);
  }
  return cm = n, cm;
}
var lm, k_;
function wF() {
  if (k_) return lm;
  k_ = 1;
  var e = oj(), t = hb(), n = 1, r = 2;
  function i(a, o, s, c) {
    var l = s.length, d = l, f = !c;
    if (a == null)
      return !d;
    for (a = Object(a); l--; ) {
      var h = s[l];
      if (f && h[2] ? h[1] !== a[h[0]] : !(h[0] in a))
        return !1;
    }
    for (; ++l < d; ) {
      h = s[l];
      var m = h[0], g = a[m], p = h[1];
      if (f && h[2]) {
        if (g === void 0 && !(m in a))
          return !1;
      } else {
        var v = new e();
        if (c)
          var y = c(g, p, m, a, o, v);
        if (!(y === void 0 ? t(p, g, n | r, c, v) : y))
          return !1;
      }
    }
    return !0;
  }
  return lm = i, lm;
}
var um, R_;
function gj() {
  if (R_) return um;
  R_ = 1;
  var e = ci();
  function t(n) {
    return n === n && !e(n);
  }
  return um = t, um;
}
var dm, L_;
function _F() {
  if (L_) return dm;
  L_ = 1;
  var e = gj(), t = Yu();
  function n(r) {
    for (var i = t(r), a = i.length; a--; ) {
      var o = i[a], s = r[o];
      i[a] = [o, s, e(s)];
    }
    return i;
  }
  return dm = n, dm;
}
var fm, $_;
function yj() {
  if ($_) return fm;
  $_ = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return fm = e, fm;
}
var hm, B_;
function SF() {
  if (B_) return hm;
  B_ = 1;
  var e = wF(), t = _F(), n = yj();
  function r(i) {
    var a = t(i);
    return a.length == 1 && a[0][2] ? n(a[0][0], a[0][1]) : function(o) {
      return o === i || e(o, i, a);
    };
  }
  return hm = r, hm;
}
var mm, F_;
function OF() {
  if (F_) return mm;
  F_ = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return mm = e, mm;
}
var vm, z_;
function EF() {
  if (z_) return vm;
  z_ = 1;
  var e = LC(), t = ub(), n = sn(), r = db(), i = fb(), a = zu();
  function o(s, c, l) {
    c = e(c, s);
    for (var d = -1, f = c.length, h = !1; ++d < f; ) {
      var m = a(c[d]);
      if (!(h = s != null && l(s, m)))
        break;
      s = s[m];
    }
    return h || ++d != f ? h : (f = s == null ? 0 : s.length, !!f && i(f) && r(m, f) && (n(s) || t(s)));
  }
  return vm = o, vm;
}
var pm, q_;
function AF() {
  if (q_) return pm;
  q_ = 1;
  var e = OF(), t = EF();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return pm = n, pm;
}
var gm, V_;
function PF() {
  if (V_) return gm;
  V_ = 1;
  var e = hb(), t = $C(), n = AF(), r = Gy(), i = gj(), a = yj(), o = zu(), s = 1, c = 2;
  function l(d, f) {
    return r(d) && i(f) ? a(o(d), f) : function(h) {
      var m = t(h, d);
      return m === void 0 && m === f ? n(h, d) : e(f, m, s | c);
    };
  }
  return gm = l, gm;
}
var ym, W_;
function bo() {
  if (W_) return ym;
  W_ = 1;
  function e(t) {
    return t;
  }
  return ym = e, ym;
}
var bm, U_;
function CF() {
  if (U_) return bm;
  U_ = 1;
  function e(t) {
    return function(n) {
      return n?.[t];
    };
  }
  return bm = e, bm;
}
var xm, H_;
function jF() {
  if (H_) return xm;
  H_ = 1;
  var e = tb();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return xm = t, xm;
}
var wm, Y_;
function TF() {
  if (Y_) return wm;
  Y_ = 1;
  var e = CF(), t = jF(), n = Gy(), r = zu();
  function i(a) {
    return n(a) ? e(r(a)) : t(a);
  }
  return wm = i, wm;
}
var _m, K_;
function li() {
  if (K_) return _m;
  K_ = 1;
  var e = SF(), t = PF(), n = bo(), r = sn(), i = TF();
  function a(o) {
    return typeof o == "function" ? o : o == null ? n : typeof o == "object" ? r(o) ? t(o[0], o[1]) : e(o) : i(o);
  }
  return _m = a, _m;
}
var Sm, G_;
function bj() {
  if (G_) return Sm;
  G_ = 1;
  function e(t, n, r, i) {
    for (var a = t.length, o = r + (i ? 1 : -1); i ? o-- : ++o < a; )
      if (n(t[o], o, t))
        return o;
    return -1;
  }
  return Sm = e, Sm;
}
var Om, Z_;
function NF() {
  if (Z_) return Om;
  Z_ = 1;
  function e(t) {
    return t !== t;
  }
  return Om = e, Om;
}
var Em, X_;
function MF() {
  if (X_) return Em;
  X_ = 1;
  function e(t, n, r) {
    for (var i = r - 1, a = t.length; ++i < a; )
      if (t[i] === n)
        return i;
    return -1;
  }
  return Em = e, Em;
}
var Am, Q_;
function IF() {
  if (Q_) return Am;
  Q_ = 1;
  var e = bj(), t = NF(), n = MF();
  function r(i, a, o) {
    return a === a ? n(i, a, o) : e(i, t, o);
  }
  return Am = r, Am;
}
var Pm, J_;
function DF() {
  if (J_) return Pm;
  J_ = 1;
  var e = IF();
  function t(n, r) {
    var i = n == null ? 0 : n.length;
    return !!i && e(n, r, 0) > -1;
  }
  return Pm = t, Pm;
}
var Cm, e1;
function kF() {
  if (e1) return Cm;
  e1 = 1;
  function e(t, n, r) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; )
      if (r(n, t[i]))
        return !0;
    return !1;
  }
  return Cm = e, Cm;
}
var jm, t1;
function RF() {
  if (t1) return jm;
  t1 = 1;
  function e() {
  }
  return jm = e, jm;
}
var Tm, n1;
function LF() {
  if (n1) return Tm;
  n1 = 1;
  var e = pj(), t = RF(), n = lb(), r = 1 / 0, i = e && 1 / n(new e([, -0]))[1] == r ? function(a) {
    return new e(a);
  } : t;
  return Tm = i, Tm;
}
var Nm, r1;
function $F() {
  if (r1) return Nm;
  r1 = 1;
  var e = sj(), t = DF(), n = kF(), r = lj(), i = LF(), a = lb(), o = 200;
  function s(c, l, d) {
    var f = -1, h = t, m = c.length, g = !0, p = [], v = p;
    if (d)
      g = !1, h = n;
    else if (m >= o) {
      var y = l ? null : i(c);
      if (y)
        return a(y);
      g = !1, h = r, v = new e();
    } else
      v = l ? [] : p;
    e:
      for (; ++f < m; ) {
        var x = c[f], w = l ? l(x) : x;
        if (x = d || x !== 0 ? x : 0, g && w === w) {
          for (var _ = v.length; _--; )
            if (v[_] === w)
              continue e;
          l && v.push(w), p.push(x);
        } else h(v, w, d) || (v !== p && v.push(w), p.push(x));
      }
    return p;
  }
  return Nm = s, Nm;
}
var Mm, i1;
function BF() {
  if (i1) return Mm;
  i1 = 1;
  var e = li(), t = $F();
  function n(r, i) {
    return r && r.length ? t(r, e(i, 2)) : [];
  }
  return Mm = n, Mm;
}
var FF = BF();
const a1 = /* @__PURE__ */ ct(FF);
function xj(e, t, n) {
  return t === !0 ? a1(e, n) : Re(t) ? a1(e, t) : e;
}
function Fa(e) {
  "@babel/helpers - typeof";
  return Fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fa(e);
}
var zF = ["ref"];
function o1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o1(Object(n), !0).forEach(function(r) {
      Ku(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qF(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function s1(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _j(r.key), r);
  }
}
function VF(e, t, n) {
  return t && s1(e.prototype, t), n && s1(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function WF(e, t, n) {
  return t = Cl(t), UF(e, wj() ? Reflect.construct(t, n || [], Cl(e).constructor) : t.apply(e, n));
}
function UF(e, t) {
  if (t && (Fa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return HF(e);
}
function HF(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wj() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wj = function() {
    return !!e;
  })();
}
function Cl(e) {
  return Cl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cl(e);
}
function YF(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && sg(e, t);
}
function sg(e, t) {
  return sg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, sg(e, t);
}
function Ku(e, t, n) {
  return t = _j(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _j(e) {
  var t = KF(e, "string");
  return Fa(t) == "symbol" ? t : t + "";
}
function KF(e, t) {
  if (Fa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Fa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function GF(e, t) {
  if (e == null) return {};
  var n = ZF(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ZF(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function XF(e) {
  return e.value;
}
function QF(e, t) {
  if (/* @__PURE__ */ T.isValidElement(e))
    return /* @__PURE__ */ T.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ T.createElement(e, t);
  t.ref;
  var n = GF(t, zF);
  return /* @__PURE__ */ T.createElement(cb, n);
}
var c1 = 1, Aa = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    qF(this, t);
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    return n = WF(this, t, [].concat(i)), Ku(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return YF(t, e), VF(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > c1 || Math.abs(i.height - this.lastBoundingBox.height) > c1) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Sr({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, a = i.layout, o = i.align, s = i.verticalAlign, c = i.margin, l = i.chartWidth, d = i.chartHeight, f, h;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (o === "center" && a === "vertical") {
          var m = this.getBBoxSnapshot();
          f = {
            left: ((l || 0) - m.width) / 2
          };
        } else
          f = o === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          h = {
            top: ((d || 0) - g.height) / 2
          };
        } else
          h = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return Sr(Sr({}, f), h);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.content, o = i.width, s = i.height, c = i.wrapperStyle, l = i.payloadUniqBy, d = i.payload, f = Sr(Sr({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ T.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(m) {
          r.wrapperNode = m;
        }
      }, QF(a, Sr(Sr({}, this.props), {}, {
        payload: xj(d, l, XF)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var a = Sr(Sr({}, this.defaultProps), r.props), o = a.layout;
      return o === "vertical" && me(r.props.height) ? {
        height: r.props.height
      } : o === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
})(ta);
Ku(Aa, "displayName", "Legend");
Ku(Aa, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Im, l1;
function JF() {
  if (l1) return Im;
  l1 = 1;
  var e = tc(), t = ub(), n = sn(), r = e ? e.isConcatSpreadable : void 0;
  function i(a) {
    return n(a) || t(a) || !!(r && a && a[r]);
  }
  return Im = i, Im;
}
var Dm, u1;
function Sj() {
  if (u1) return Dm;
  u1 = 1;
  var e = dj(), t = JF();
  function n(r, i, a, o, s) {
    var c = -1, l = r.length;
    for (a || (a = t), s || (s = []); ++c < l; ) {
      var d = r[c];
      i > 0 && a(d) ? i > 1 ? n(d, i - 1, a, o, s) : e(s, d) : o || (s[s.length] = d);
    }
    return s;
  }
  return Dm = n, Dm;
}
var km, d1;
function ez() {
  if (d1) return km;
  d1 = 1;
  function e(t) {
    return function(n, r, i) {
      for (var a = -1, o = Object(n), s = i(n), c = s.length; c--; ) {
        var l = s[t ? c : ++a];
        if (r(o[l], l, o) === !1)
          break;
      }
      return n;
    };
  }
  return km = e, km;
}
var Rm, f1;
function tz() {
  if (f1) return Rm;
  f1 = 1;
  var e = ez(), t = e();
  return Rm = t, Rm;
}
var Lm, h1;
function Oj() {
  if (h1) return Lm;
  h1 = 1;
  var e = tz(), t = Yu();
  function n(r, i) {
    return r && e(r, i, t);
  }
  return Lm = n, Lm;
}
var $m, m1;
function nz() {
  if (m1) return $m;
  m1 = 1;
  var e = ic();
  function t(n, r) {
    return function(i, a) {
      if (i == null)
        return i;
      if (!e(i))
        return n(i, a);
      for (var o = i.length, s = r ? o : -1, c = Object(i); (r ? s-- : ++s < o) && a(c[s], s, c) !== !1; )
        ;
      return i;
    };
  }
  return $m = t, $m;
}
var Bm, v1;
function mb() {
  if (v1) return Bm;
  v1 = 1;
  var e = Oj(), t = nz(), n = t(e);
  return Bm = n, Bm;
}
var Fm, p1;
function Ej() {
  if (p1) return Fm;
  p1 = 1;
  var e = mb(), t = ic();
  function n(r, i) {
    var a = -1, o = t(r) ? Array(r.length) : [];
    return e(r, function(s, c, l) {
      o[++a] = i(s, c, l);
    }), o;
  }
  return Fm = n, Fm;
}
var zm, g1;
function rz() {
  if (g1) return zm;
  g1 = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return zm = e, zm;
}
var qm, y1;
function iz() {
  if (y1) return qm;
  y1 = 1;
  var e = go();
  function t(n, r) {
    if (n !== r) {
      var i = n !== void 0, a = n === null, o = n === n, s = e(n), c = r !== void 0, l = r === null, d = r === r, f = e(r);
      if (!l && !f && !s && n > r || s && c && d && !l && !f || a && c && d || !i && d || !o)
        return 1;
      if (!a && !s && !f && n < r || f && i && o && !a && !s || l && i && o || !c && o || !d)
        return -1;
    }
    return 0;
  }
  return qm = t, qm;
}
var Vm, b1;
function az() {
  if (b1) return Vm;
  b1 = 1;
  var e = iz();
  function t(n, r, i) {
    for (var a = -1, o = n.criteria, s = r.criteria, c = o.length, l = i.length; ++a < c; ) {
      var d = e(o[a], s[a]);
      if (d) {
        if (a >= l)
          return d;
        var f = i[a];
        return d * (f == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return Vm = t, Vm;
}
var Wm, x1;
function oz() {
  if (x1) return Wm;
  x1 = 1;
  var e = eb(), t = tb(), n = li(), r = Ej(), i = rz(), a = hj(), o = az(), s = bo(), c = sn();
  function l(d, f, h) {
    f.length ? f = e(f, function(p) {
      return c(p) ? function(v) {
        return t(v, p.length === 1 ? p[0] : p);
      } : p;
    }) : f = [s];
    var m = -1;
    f = e(f, a(n));
    var g = r(d, function(p, v, y) {
      var x = e(f, function(w) {
        return w(p);
      });
      return { criteria: x, index: ++m, value: p };
    });
    return i(g, function(p, v) {
      return o(p, v, h);
    });
  }
  return Wm = l, Wm;
}
var Um, w1;
function sz() {
  if (w1) return Um;
  w1 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return Um = e, Um;
}
var Hm, _1;
function cz() {
  if (_1) return Hm;
  _1 = 1;
  var e = sz(), t = Math.max;
  function n(r, i, a) {
    return i = t(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var o = arguments, s = -1, c = t(o.length - i, 0), l = Array(c); ++s < c; )
        l[s] = o[i + s];
      s = -1;
      for (var d = Array(i + 1); ++s < i; )
        d[s] = o[s];
      return d[i] = a(l), e(r, this, d);
    };
  }
  return Hm = n, Hm;
}
var Ym, S1;
function lz() {
  if (S1) return Ym;
  S1 = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Ym = e, Ym;
}
var Km, O1;
function Aj() {
  if (O1) return Km;
  O1 = 1;
  var e = ra(), t = (function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  })();
  return Km = t, Km;
}
var Gm, E1;
function uz() {
  if (E1) return Gm;
  E1 = 1;
  var e = lz(), t = Aj(), n = bo(), r = t ? function(i, a) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : n;
  return Gm = r, Gm;
}
var Zm, A1;
function dz() {
  if (A1) return Zm;
  A1 = 1;
  var e = 800, t = 16, n = Date.now;
  function r(i) {
    var a = 0, o = 0;
    return function() {
      var s = n(), c = t - (s - o);
      if (o = s, c > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return i.apply(void 0, arguments);
    };
  }
  return Zm = r, Zm;
}
var Xm, P1;
function fz() {
  if (P1) return Xm;
  P1 = 1;
  var e = uz(), t = dz(), n = t(e);
  return Xm = n, Xm;
}
var Qm, C1;
function hz() {
  if (C1) return Qm;
  C1 = 1;
  var e = bo(), t = cz(), n = fz();
  function r(i, a) {
    return n(t(i, a, e), i + "");
  }
  return Qm = r, Qm;
}
var Jm, j1;
function Gu() {
  if (j1) return Jm;
  j1 = 1;
  var e = Xy(), t = ic(), n = db(), r = ci();
  function i(a, o, s) {
    if (!r(s))
      return !1;
    var c = typeof o;
    return (c == "number" ? t(s) && n(o, s.length) : c == "string" && o in s) ? e(s[o], a) : !1;
  }
  return Jm = i, Jm;
}
var ev, T1;
function mz() {
  if (T1) return ev;
  T1 = 1;
  var e = Sj(), t = oz(), n = hz(), r = Gu(), i = n(function(a, o) {
    if (a == null)
      return [];
    var s = o.length;
    return s > 1 && r(a, o[0], o[1]) ? o = [] : s > 2 && r(o[0], o[1], o[2]) && (o = [o[0]]), t(a, e(o, 1), []);
  });
  return ev = i, ev;
}
var vz = mz();
const vb = /* @__PURE__ */ ct(vz);
function hs(e) {
  "@babel/helpers - typeof";
  return hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hs(e);
}
function cg() {
  return cg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cg.apply(this, arguments);
}
function pz(e, t) {
  return xz(e) || bz(e, t) || yz(e, t) || gz();
}
function gz() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yz(e, t) {
  if (e) {
    if (typeof e == "string") return N1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return N1(e, t);
  }
}
function N1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function bz(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function xz(e) {
  if (Array.isArray(e)) return e;
}
function M1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M1(Object(n), !0).forEach(function(r) {
      wz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wz(e, t, n) {
  return t = _z(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _z(e) {
  var t = Sz(e, "string");
  return hs(t) == "symbol" ? t : t + "";
}
function Sz(e, t) {
  if (hs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (hs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Oz(e) {
  return Array.isArray(e) && Ct(e[0]) && Ct(e[1]) ? e.join(" ~ ") : e;
}
var Ez = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, i = t.contentStyle, a = i === void 0 ? {} : i, o = t.itemStyle, s = o === void 0 ? {} : o, c = t.labelStyle, l = c === void 0 ? {} : c, d = t.payload, f = t.formatter, h = t.itemSorter, m = t.wrapperClassName, g = t.labelClassName, p = t.label, v = t.labelFormatter, y = t.accessibilityLayer, x = y === void 0 ? !1 : y, w = function() {
    if (d && d.length) {
      var C = {
        padding: 0,
        margin: 0
      }, N = (h ? vb(d, h) : d).map(function(k, I) {
        if (k.type === "none")
          return null;
        var $ = tv({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: k.color || "#000"
        }, s), z = k.formatter || f || Oz, V = k.value, K = k.name, D = V, U = K;
        if (z && D != null && U != null) {
          var Y = z(V, K, k, I, d);
          if (Array.isArray(Y)) {
            var X = pz(Y, 2);
            D = X[0], U = X[1];
          } else
            D = Y;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ T.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(I),
            style: $
          }, Ct(U) ? /* @__PURE__ */ T.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, U) : null, Ct(U) ? /* @__PURE__ */ T.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ T.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, D), /* @__PURE__ */ T.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, k.unit || ""))
        );
      });
      return /* @__PURE__ */ T.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: C
      }, N);
    }
    return null;
  }, _ = tv({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), b = tv({
    margin: 0
  }, l), S = !Ke(p), O = S ? p : "", E = Fe("recharts-default-tooltip", m), P = Fe("recharts-tooltip-label", g);
  S && v && d !== void 0 && d !== null && (O = v(p, d));
  var R = x ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ T.createElement("div", cg({
    className: E,
    style: _
  }, R), /* @__PURE__ */ T.createElement("p", {
    className: P,
    style: b
  }, /* @__PURE__ */ T.isValidElement(O) ? O : "".concat(O)), w());
};
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function kc(e, t, n) {
  return t = Az(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Az(e) {
  var t = Pz(e, "string");
  return ms(t) == "symbol" ? t : t + "";
}
function Pz(e, t) {
  if (ms(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ms(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Mo = "recharts-tooltip-wrapper", Cz = {
  visibility: "hidden"
};
function jz(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return Fe(Mo, kc(kc(kc(kc({}, "".concat(Mo, "-right"), me(n) && t && me(t.x) && n >= t.x), "".concat(Mo, "-left"), me(n) && t && me(t.x) && n < t.x), "".concat(Mo, "-bottom"), me(r) && t && me(t.y) && r >= t.y), "".concat(Mo, "-top"), me(r) && t && me(t.y) && r < t.y));
}
function I1(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, i = e.offsetTopLeft, a = e.position, o = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, l = e.viewBoxDimension;
  if (a && me(a[r]))
    return a[r];
  var d = n[r] - s - i, f = n[r] + i;
  if (t[r])
    return o[r] ? d : f;
  if (o[r]) {
    var h = d, m = c[r];
    return h < m ? Math.max(f, c[r]) : Math.max(d, c[r]);
  }
  var g = f + s, p = c[r] + l;
  return g > p ? Math.max(d, c[r]) : Math.max(f, c[r]);
}
function Tz(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function Nz(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, i = e.position, a = e.reverseDirection, o = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, l, d, f;
  return o.height > 0 && o.width > 0 && n ? (d = I1({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), f = I1({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), l = Tz({
    translateX: d,
    translateY: f,
    useTranslate3d: s
  })) : l = Cz, {
    cssProperties: l,
    cssClasses: jz({
      translateX: d,
      translateY: f,
      coordinate: n
    })
  };
}
function za(e) {
  "@babel/helpers - typeof";
  return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, za(e);
}
function D1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function k1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? D1(Object(n), !0).forEach(function(r) {
      ug(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Iz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Cj(r.key), r);
  }
}
function Dz(e, t, n) {
  return t && Iz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function kz(e, t, n) {
  return t = jl(t), Rz(e, Pj() ? Reflect.construct(t, n || [], jl(e).constructor) : t.apply(e, n));
}
function Rz(e, t) {
  if (t && (za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lz(e);
}
function Lz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pj() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Pj = function() {
    return !!e;
  })();
}
function jl(e) {
  return jl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jl(e);
}
function $z(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && lg(e, t);
}
function lg(e, t) {
  return lg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, lg(e, t);
}
function ug(e, t, n) {
  return t = Cj(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cj(e) {
  var t = Bz(e, "string");
  return za(t) == "symbol" ? t : t + "";
}
function Bz(e, t) {
  if (za(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (za(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var R1 = 1, Fz = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    Mz(this, t);
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    return n = kz(this, t, [].concat(i)), ug(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), ug(n, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, c, l, d;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = n.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (l = (d = n.props.coordinate) === null || d === void 0 ? void 0 : d.y) !== null && l !== void 0 ? l : 0
          }
        });
      }
    }), n;
  }
  return $z(t, e), Dz(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > R1 || Math.abs(r.height - this.state.lastBoundingBox.height) > R1) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, c = i.animationEasing, l = i.children, d = i.coordinate, f = i.hasPayload, h = i.isAnimationActive, m = i.offset, g = i.position, p = i.reverseDirection, v = i.useTranslate3d, y = i.viewBox, x = i.wrapperStyle, w = Nz({
        allowEscapeViewBox: o,
        coordinate: d,
        offsetTopLeft: m,
        position: g,
        reverseDirection: p,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: v,
        viewBox: y
      }), _ = w.cssClasses, b = w.cssProperties, S = k1(k1({
        transition: h && a ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, b), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, x);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ T.createElement("div", {
          tabIndex: -1,
          className: _,
          style: S,
          ref: function(E) {
            r.wrapperNode = E;
          }
        }, l)
      );
    }
  }]);
})(ta), zz = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, ac = {
  isSsr: zz()
};
function qa(e) {
  "@babel/helpers - typeof";
  return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qa(e);
}
function L1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L1(Object(n), !0).forEach(function(r) {
      pb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : L1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Vz(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Tj(r.key), r);
  }
}
function Wz(e, t, n) {
  return t && Vz(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Uz(e, t, n) {
  return t = Tl(t), Hz(e, jj() ? Reflect.construct(t, n || [], Tl(e).constructor) : t.apply(e, n));
}
function Hz(e, t) {
  if (t && (qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Yz(e);
}
function Yz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jj() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jj = function() {
    return !!e;
  })();
}
function Tl(e) {
  return Tl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Tl(e);
}
function Kz(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && dg(e, t);
}
function dg(e, t) {
  return dg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, dg(e, t);
}
function pb(e, t, n) {
  return t = Tj(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Tj(e) {
  var t = Gz(e, "string");
  return qa(t) == "symbol" ? t : t + "";
}
function Gz(e, t) {
  if (qa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (qa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Zz(e) {
  return e.dataKey;
}
function Xz(e, t) {
  return /* @__PURE__ */ T.isValidElement(e) ? /* @__PURE__ */ T.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ T.createElement(e, t) : /* @__PURE__ */ T.createElement(Ez, t);
}
var Or = /* @__PURE__ */ (function(e) {
  function t() {
    return qz(this, t), Uz(this, t, arguments);
  }
  return Kz(t, e), Wz(t, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, s = i.animationDuration, c = i.animationEasing, l = i.content, d = i.coordinate, f = i.filterNull, h = i.isAnimationActive, m = i.offset, g = i.payload, p = i.payloadUniqBy, v = i.position, y = i.reverseDirection, x = i.useTranslate3d, w = i.viewBox, _ = i.wrapperStyle, b = g ?? [];
      f && b.length && (b = xj(g.filter(function(O) {
        return O.value != null && (O.hide !== !0 || r.props.includeHidden);
      }), p, Zz));
      var S = b.length > 0;
      return /* @__PURE__ */ T.createElement(Fz, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: h,
        active: a,
        coordinate: d,
        hasPayload: S,
        offset: m,
        position: v,
        reverseDirection: y,
        useTranslate3d: x,
        viewBox: w,
        wrapperStyle: _
      }, Xz(l, $1($1({}, this.props), {}, {
        payload: b
      })));
    }
  }]);
})(ta);
pb(Or, "displayName", "Tooltip");
pb(Or, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !ac.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var nv, B1;
function Qz() {
  if (B1) return nv;
  B1 = 1;
  var e = mr(), t = function() {
    return e.Date.now();
  };
  return nv = t, nv;
}
var rv, F1;
function Jz() {
  if (F1) return rv;
  F1 = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return rv = t, rv;
}
var iv, z1;
function e4() {
  if (z1) return iv;
  z1 = 1;
  var e = Jz(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return iv = n, iv;
}
var av, q1;
function Nj() {
  if (q1) return av;
  q1 = 1;
  var e = e4(), t = ci(), n = go(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function c(l) {
    if (typeof l == "number")
      return l;
    if (n(l))
      return r;
    if (t(l)) {
      var d = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = t(d) ? d + "" : d;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var f = a.test(l);
    return f || o.test(l) ? s(l.slice(2), f ? 2 : 8) : i.test(l) ? r : +l;
  }
  return av = c, av;
}
var ov, V1;
function t4() {
  if (V1) return ov;
  V1 = 1;
  var e = ci(), t = Qz(), n = Nj(), r = "Expected a function", i = Math.max, a = Math.min;
  function o(s, c, l) {
    var d, f, h, m, g, p, v = 0, y = !1, x = !1, w = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    c = n(c) || 0, e(l) && (y = !!l.leading, x = "maxWait" in l, h = x ? i(n(l.maxWait) || 0, c) : h, w = "trailing" in l ? !!l.trailing : w);
    function _(N) {
      var k = d, I = f;
      return d = f = void 0, v = N, m = s.apply(I, k), m;
    }
    function b(N) {
      return v = N, g = setTimeout(E, c), y ? _(N) : m;
    }
    function S(N) {
      var k = N - p, I = N - v, $ = c - k;
      return x ? a($, h - I) : $;
    }
    function O(N) {
      var k = N - p, I = N - v;
      return p === void 0 || k >= c || k < 0 || x && I >= h;
    }
    function E() {
      var N = t();
      if (O(N))
        return P(N);
      g = setTimeout(E, S(N));
    }
    function P(N) {
      return g = void 0, w && d ? _(N) : (d = f = void 0, m);
    }
    function R() {
      g !== void 0 && clearTimeout(g), v = 0, d = p = f = g = void 0;
    }
    function j() {
      return g === void 0 ? m : P(t());
    }
    function C() {
      var N = t(), k = O(N);
      if (d = arguments, f = this, p = N, k) {
        if (g === void 0)
          return b(p);
        if (x)
          return clearTimeout(g), g = setTimeout(E, c), _(p);
      }
      return g === void 0 && (g = setTimeout(E, c)), m;
    }
    return C.cancel = R, C.flush = j, C;
  }
  return ov = o, ov;
}
var sv, W1;
function n4() {
  if (W1) return sv;
  W1 = 1;
  var e = t4(), t = ci(), n = "Expected a function";
  function r(i, a, o) {
    var s = !0, c = !0;
    if (typeof i != "function")
      throw new TypeError(n);
    return t(o) && (s = "leading" in o ? !!o.leading : s, c = "trailing" in o ? !!o.trailing : c), e(i, a, {
      leading: s,
      maxWait: a,
      trailing: c
    });
  }
  return sv = r, sv;
}
var r4 = n4();
const Mj = /* @__PURE__ */ ct(r4);
function vs(e) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vs(e);
}
function U1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U1(Object(n), !0).forEach(function(r) {
      i4(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function i4(e, t, n) {
  return t = a4(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function a4(e) {
  var t = o4(e, "string");
  return vs(t) == "symbol" ? t : t + "";
}
function o4(e, t) {
  if (vs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (vs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function s4(e, t) {
  return d4(e) || u4(e, t) || l4(e, t) || c4();
}
function c4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function l4(e, t) {
  if (e) {
    if (typeof e == "string") return H1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return H1(e, t);
  }
}
function H1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function u4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function d4(e) {
  if (Array.isArray(e)) return e;
}
var f4 = /* @__PURE__ */ ku(function(e, t) {
  var n = e.aspect, r = e.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, a = e.width, o = a === void 0 ? "100%" : a, s = e.height, c = s === void 0 ? "100%" : s, l = e.minWidth, d = l === void 0 ? 0 : l, f = e.minHeight, h = e.maxHeight, m = e.children, g = e.debounce, p = g === void 0 ? 0 : g, v = e.id, y = e.className, x = e.onResize, w = e.style, _ = w === void 0 ? {} : w, b = Le(null), S = Le();
  S.current = x, n2(t, function() {
    return Object.defineProperty(b.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), b.current;
      },
      configurable: !0
    });
  });
  var O = Ee({
    containerWidth: i.width,
    containerHeight: i.height
  }), E = s4(O, 2), P = E[0], R = E[1], j = ot(function(N, k) {
    R(function(I) {
      var $ = Math.round(N), z = Math.round(k);
      return I.containerWidth === $ && I.containerHeight === z ? I : {
        containerWidth: $,
        containerHeight: z
      };
    });
  }, []);
  St(function() {
    var N = function(K) {
      var D, U = K[0].contentRect, Y = U.width, X = U.height;
      j(Y, X), (D = S.current) === null || D === void 0 || D.call(S, Y, X);
    };
    p > 0 && (N = Mj(N, p, {
      trailing: !0,
      leading: !1
    }));
    var k = new ResizeObserver(N), I = b.current.getBoundingClientRect(), $ = I.width, z = I.height;
    return j($, z), k.observe(b.current), function() {
      k.disconnect();
    };
  }, [j, p]);
  var C = Tr(function() {
    var N = P.containerWidth, k = P.containerHeight;
    if (N < 0 || k < 0)
      return null;
    Li(Ti(o) || Ti(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, c), Li(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var I = Ti(o) ? N : o, $ = Ti(c) ? k : c;
    n && n > 0 && (I ? $ = I / n : $ && (I = $ * n), h && $ > h && ($ = h)), Li(I > 0 || $ > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, I, $, o, c, d, f, n);
    var z = !Array.isArray(m) && Nr(m.type).endsWith("Chart");
    return T.Children.map(m, function(V) {
      return /* @__PURE__ */ T.isValidElement(V) ? /* @__PURE__ */ _t(V, Rc({
        width: I,
        height: $
      }, z ? {
        style: Rc({
          height: "100%",
          width: "100%",
          maxHeight: $,
          maxWidth: I
        }, V.props.style)
      } : {})) : V;
    });
  }, [n, m, c, h, f, d, P, o]);
  return /* @__PURE__ */ T.createElement("div", {
    id: v ? "".concat(v) : void 0,
    className: Fe("recharts-responsive-container", y),
    style: Rc(Rc({}, _), {}, {
      width: o,
      height: c,
      minWidth: d,
      minHeight: f,
      maxHeight: h
    }),
    ref: b
  }, C);
}), gb = function(t) {
  return null;
};
gb.displayName = "Cell";
function ps(e) {
  "@babel/helpers - typeof";
  return ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ps(e);
}
function Y1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Y1(Object(n), !0).forEach(function(r) {
      h4(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Y1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function h4(e, t, n) {
  return t = m4(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function m4(e) {
  var t = v4(e, "string");
  return ps(t) == "symbol" ? t : t + "";
}
function v4(e, t) {
  if (ps(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ps(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var fa = {
  widthCache: {},
  cacheCount: 0
}, p4 = 2e3, g4 = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, K1 = "recharts_measurement_span";
function y4(e) {
  var t = fg({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var ts = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || ac.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = y4(n), i = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (fa.widthCache[i])
    return fa.widthCache[i];
  try {
    var a = document.getElementById(K1);
    a || (a = document.createElement("span"), a.setAttribute("id", K1), a.setAttribute("aria-hidden", "true"), document.body.appendChild(a));
    var o = fg(fg({}, g4), r);
    Object.assign(a.style, o), a.textContent = "".concat(t);
    var s = a.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return fa.widthCache[i] = c, ++fa.cacheCount > p4 && (fa.cacheCount = 0, fa.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, b4 = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function gs(e) {
  "@babel/helpers - typeof";
  return gs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gs(e);
}
function Nl(e, t) {
  return S4(e) || _4(e, t) || w4(e, t) || x4();
}
function x4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w4(e, t) {
  if (e) {
    if (typeof e == "string") return G1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return G1(e, t);
  }
}
function G1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function S4(e) {
  if (Array.isArray(e)) return e;
}
function O4(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Z1(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, A4(r.key), r);
  }
}
function E4(e, t, n) {
  return t && Z1(e.prototype, t), n && Z1(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function A4(e) {
  var t = P4(e, "string");
  return gs(t) == "symbol" ? t : t + "";
}
function P4(e, t) {
  if (gs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (gs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var X1 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Q1 = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, C4 = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, j4 = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, Ij = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, T4 = Object.keys(Ij), xa = "NaN";
function N4(e, t) {
  return e * Ij[t];
}
var Lc = /* @__PURE__ */ (function() {
  function e(t, n) {
    O4(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !C4.test(n) && (this.num = NaN, this.unit = ""), T4.includes(n) && (this.num = N4(t, n), this.unit = "px");
  }
  return E4(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, i = (r = j4.exec(n)) !== null && r !== void 0 ? r : [], a = Nl(i, 3), o = a[1], s = a[2];
      return new e(parseFloat(o), s ?? "");
    }
  }]);
})();
function Dj(e) {
  if (e.includes(xa))
    return xa;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = X1.exec(t)) !== null && n !== void 0 ? n : [], i = Nl(r, 4), a = i[1], o = i[2], s = i[3], c = Lc.parse(a ?? ""), l = Lc.parse(s ?? ""), d = o === "*" ? c.multiply(l) : c.divide(l);
    if (d.isNaN())
      return xa;
    t = t.replace(X1, d.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, h = (f = Q1.exec(t)) !== null && f !== void 0 ? f : [], m = Nl(h, 4), g = m[1], p = m[2], v = m[3], y = Lc.parse(g ?? ""), x = Lc.parse(v ?? ""), w = p === "+" ? y.add(x) : y.subtract(x);
    if (w.isNaN())
      return xa;
    t = t.replace(Q1, w.toString());
  }
  return t;
}
var J1 = /\(([^()]*)\)/;
function M4(e) {
  for (var t = e; t.includes("("); ) {
    var n = J1.exec(t), r = Nl(n, 2), i = r[1];
    t = t.replace(J1, Dj(i));
  }
  return t;
}
function I4(e) {
  var t = e.replace(/\s+/g, "");
  return t = M4(t), t = Dj(t), t;
}
function D4(e) {
  try {
    return I4(e);
  } catch {
    return xa;
  }
}
function cv(e) {
  var t = D4(e.slice(5, -1));
  return t === xa ? "" : t;
}
var k4 = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], R4 = ["dx", "dy", "angle", "className", "breakAll"];
function hg() {
  return hg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hg.apply(this, arguments);
}
function eS(e, t) {
  if (e == null) return {};
  var n = L4(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function L4(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function tS(e, t) {
  return z4(e) || F4(e, t) || B4(e, t) || $4();
}
function $4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B4(e, t) {
  if (e) {
    if (typeof e == "string") return nS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nS(e, t);
  }
}
function nS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function F4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function z4(e) {
  if (Array.isArray(e)) return e;
}
var kj = /[ \f\n\r\t\v\u2028\u2029]+/, Rj = function(t) {
  var n = t.children, r = t.breakAll, i = t.style;
  try {
    var a = [];
    Ke(n) || (r ? a = n.toString().split("") : a = n.toString().split(kj));
    var o = a.map(function(c) {
      return {
        word: c,
        width: ts(c, i).width
      };
    }), s = r ? 0 : ts(" ", i).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, q4 = function(t, n, r, i, a) {
  var o = t.maxLines, s = t.children, c = t.style, l = t.breakAll, d = me(o), f = s, h = function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return I.reduce(function($, z) {
      var V = z.word, K = z.width, D = $[$.length - 1];
      if (D && (i == null || a || D.width + K + r < Number(i)))
        D.words.push(V), D.width += K + r;
      else {
        var U = {
          words: [V],
          width: K
        };
        $.push(U);
      }
      return $;
    }, []);
  }, m = h(n), g = function(I) {
    return I.reduce(function($, z) {
      return $.width > z.width ? $ : z;
    });
  };
  if (!d)
    return m;
  for (var p = "…", v = function(I) {
    var $ = f.slice(0, I), z = Rj({
      breakAll: l,
      style: c,
      children: $ + p
    }).wordsWithComputedWidth, V = h(z), K = V.length > o || g(V).width > Number(i);
    return [K, V];
  }, y = 0, x = f.length - 1, w = 0, _; y <= x && w <= f.length - 1; ) {
    var b = Math.floor((y + x) / 2), S = b - 1, O = v(S), E = tS(O, 2), P = E[0], R = E[1], j = v(b), C = tS(j, 1), N = C[0];
    if (!P && !N && (y = b + 1), P && N && (x = b - 1), !P && N) {
      _ = R;
      break;
    }
    w++;
  }
  return _ || m;
}, rS = function(t) {
  var n = Ke(t) ? [] : t.toString().split(kj);
  return [{
    words: n
  }];
}, V4 = function(t) {
  var n = t.width, r = t.scaleToFit, i = t.children, a = t.style, o = t.breakAll, s = t.maxLines;
  if ((n || r) && !ac.isSsr) {
    var c, l, d = Rj({
      breakAll: o,
      children: i,
      style: a
    });
    if (d) {
      var f = d.wordsWithComputedWidth, h = d.spaceWidth;
      c = f, l = h;
    } else
      return rS(i);
    return q4({
      breakAll: o,
      children: i,
      maxLines: s,
      style: a
    }, c, l, n, r);
  }
  return rS(i);
}, iS = "#808080", Ml = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, a = i === void 0 ? 0 : i, o = t.lineHeight, s = o === void 0 ? "1em" : o, c = t.capHeight, l = c === void 0 ? "0.71em" : c, d = t.scaleToFit, f = d === void 0 ? !1 : d, h = t.textAnchor, m = h === void 0 ? "start" : h, g = t.verticalAnchor, p = g === void 0 ? "end" : g, v = t.fill, y = v === void 0 ? iS : v, x = eS(t, k4), w = Tr(function() {
    return V4({
      breakAll: x.breakAll,
      children: x.children,
      maxLines: x.maxLines,
      scaleToFit: f,
      style: x.style,
      width: x.width
    });
  }, [x.breakAll, x.children, x.maxLines, f, x.style, x.width]), _ = x.dx, b = x.dy, S = x.angle, O = x.className, E = x.breakAll, P = eS(x, R4);
  if (!Ct(r) || !Ct(a))
    return null;
  var R = r + (me(_) ? _ : 0), j = a + (me(b) ? b : 0), C;
  switch (p) {
    case "start":
      C = cv("calc(".concat(l, ")"));
      break;
    case "middle":
      C = cv("calc(".concat((w.length - 1) / 2, " * -").concat(s, " + (").concat(l, " / 2))"));
      break;
    default:
      C = cv("calc(".concat(w.length - 1, " * -").concat(s, ")"));
      break;
  }
  var N = [];
  if (f) {
    var k = w[0].width, I = x.width;
    N.push("scale(".concat((me(I) ? I / k : 1) / k, ")"));
  }
  return S && N.push("rotate(".concat(S, ", ").concat(R, ", ").concat(j, ")")), N.length && (P.transform = N.join(" ")), /* @__PURE__ */ T.createElement("text", hg({}, Ye(P, !0), {
    x: R,
    y: j,
    className: Fe("recharts-text", O),
    textAnchor: m,
    fill: y.includes("url") ? iS : y
  }), w.map(function($, z) {
    var V = $.words.join(E ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ T.createElement("tspan", {
        x: R,
        dy: z === 0 ? C : s,
        key: "".concat(V, "-").concat(z)
      }, V)
    );
  }));
};
function ti(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function W4(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function yb(e) {
  let t, n, r;
  e.length !== 2 ? (t = ti, n = (s, c) => ti(e(s), c), r = (s, c) => e(s) - c) : (t = e === ti || e === W4 ? e : U4, n = e, r = e);
  function i(s, c, l = 0, d = s.length) {
    if (l < d) {
      if (t(c, c) !== 0) return d;
      do {
        const f = l + d >>> 1;
        n(s[f], c) < 0 ? l = f + 1 : d = f;
      } while (l < d);
    }
    return l;
  }
  function a(s, c, l = 0, d = s.length) {
    if (l < d) {
      if (t(c, c) !== 0) return d;
      do {
        const f = l + d >>> 1;
        n(s[f], c) <= 0 ? l = f + 1 : d = f;
      } while (l < d);
    }
    return l;
  }
  function o(s, c, l = 0, d = s.length) {
    const f = i(s, c, l, d - 1);
    return f > l && r(s[f - 1], c) > -r(s[f], c) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function U4() {
  return 0;
}
function Lj(e) {
  return e === null ? NaN : +e;
}
function* H4(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const Y4 = yb(ti), oc = Y4.right;
yb(Lj).center;
class aS extends Map {
  constructor(t, n = Z4) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, i] of t) this.set(r, i);
  }
  get(t) {
    return super.get(oS(this, t));
  }
  has(t) {
    return super.has(oS(this, t));
  }
  set(t, n) {
    return super.set(K4(this, t), n);
  }
  delete(t) {
    return super.delete(G4(this, t));
  }
}
function oS({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function K4({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function G4({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function Z4(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function X4(e = ti) {
  if (e === ti) return $j;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function $j(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const Q4 = Math.sqrt(50), J4 = Math.sqrt(10), eq = Math.sqrt(2);
function Il(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / Math.pow(10, i), o = a >= Q4 ? 10 : a >= J4 ? 5 : a >= eq ? 2 : 1;
  let s, c, l;
  return i < 0 ? (l = Math.pow(10, -i) / o, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, i) * o, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= n && n < 2 ? Il(e, t, n * 2) : [s, c, l];
}
function mg(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [i, a, o] = r ? Il(t, e, n) : Il(e, t, n);
  if (!(a >= i)) return [];
  const s = a - i + 1, c = new Array(s);
  if (r)
    if (o < 0) for (let l = 0; l < s; ++l) c[l] = (a - l) / -o;
    else for (let l = 0; l < s; ++l) c[l] = (a - l) * o;
  else if (o < 0) for (let l = 0; l < s; ++l) c[l] = (i + l) / -o;
  else for (let l = 0; l < s; ++l) c[l] = (i + l) * o;
  return c;
}
function vg(e, t, n) {
  return t = +t, e = +e, n = +n, Il(e, t, n)[2];
}
function pg(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? vg(t, e, n) : vg(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function sS(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function cS(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function Bj(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (i = i === void 0 ? $j : X4(i); r > n; ) {
    if (r - n > 600) {
      const c = r - n + 1, l = t - n + 1, d = Math.log(c), f = 0.5 * Math.exp(2 * d / 3), h = 0.5 * Math.sqrt(d * f * (c - f) / c) * (l - c / 2 < 0 ? -1 : 1), m = Math.max(n, Math.floor(t - l * f / c + h)), g = Math.min(r, Math.floor(t + (c - l) * f / c + h));
      Bj(e, t, m, g, i);
    }
    const a = e[t];
    let o = n, s = r;
    for (Io(e, n, t), i(e[r], a) > 0 && Io(e, n, r); o < s; ) {
      for (Io(e, o, s), ++o, --s; i(e[o], a) < 0; ) ++o;
      for (; i(e[s], a) > 0; ) --s;
    }
    i(e[n], a) === 0 ? Io(e, n, s) : (++s, Io(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function Io(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function tq(e, t, n) {
  if (e = Float64Array.from(H4(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return cS(e);
    if (t >= 1) return sS(e);
    var r, i = (r - 1) * t, a = Math.floor(i), o = sS(Bj(e, a).subarray(0, a + 1)), s = cS(e.subarray(a + 1));
    return o + (s - o) * (i - a);
  }
}
function nq(e, t, n = Lj) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, a = Math.floor(i), o = +n(e[a], a, e), s = +n(e[a + 1], a + 1, e);
    return o + (s - o) * (i - a);
  }
}
function rq(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = e + r * n;
  return a;
}
function Dn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Fr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const gg = Symbol("implicit");
function bb() {
  var e = new aS(), t = [], n = [], r = gg;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (r !== gg) return r;
      e.set(a, o = t.push(a) - 1);
    }
    return n[o % n.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new aS();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (n = Array.from(a), i) : n.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return bb(t, n).unknown(r);
  }, Dn.apply(i, arguments), i;
}
function ys() {
  var e = bb().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, a, o, s = !1, c = 0, l = 0, d = 0.5;
  delete e.unknown;
  function f() {
    var h = t().length, m = i < r, g = m ? i : r, p = m ? r : i;
    a = (p - g) / Math.max(1, h - c + l * 2), s && (a = Math.floor(a)), g += (p - g - a * (h - c)) * d, o = a * (1 - c), s && (g = Math.round(g), o = Math.round(o));
    var v = rq(h).map(function(y) {
      return g + a * y;
    });
    return n(m ? v.reverse() : v);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), f()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, i] = h, r = +r, i = +i, f()) : [r, i];
  }, e.rangeRound = function(h) {
    return [r, i] = h, r = +r, i = +i, s = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, f()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (c = Math.min(1, l = +h), f()) : c;
  }, e.paddingInner = function(h) {
    return arguments.length ? (c = Math.min(1, h), f()) : c;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (l = +h, f()) : l;
  }, e.align = function(h) {
    return arguments.length ? (d = Math.max(0, Math.min(1, h)), f()) : d;
  }, e.copy = function() {
    return ys(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(d);
  }, Dn.apply(f(), arguments);
}
function Fj(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Fj(t());
  }, e;
}
function ns() {
  return Fj(ys.apply(null, arguments).paddingInner(1));
}
function xb(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function zj(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function sc() {
}
var bs = 0.7, Dl = 1 / bs, Pa = "\\s*([+-]?\\d+)\\s*", xs = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", cr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", iq = /^#([0-9a-f]{3,8})$/, aq = new RegExp(`^rgb\\(${Pa},${Pa},${Pa}\\)$`), oq = new RegExp(`^rgb\\(${cr},${cr},${cr}\\)$`), sq = new RegExp(`^rgba\\(${Pa},${Pa},${Pa},${xs}\\)$`), cq = new RegExp(`^rgba\\(${cr},${cr},${cr},${xs}\\)$`), lq = new RegExp(`^hsl\\(${xs},${cr},${cr}\\)$`), uq = new RegExp(`^hsla\\(${xs},${cr},${cr},${xs}\\)$`), lS = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
xb(sc, ws, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: uS,
  // Deprecated! Use color.formatHex.
  formatHex: uS,
  formatHex8: dq,
  formatHsl: fq,
  formatRgb: dS,
  toString: dS
});
function uS() {
  return this.rgb().formatHex();
}
function dq() {
  return this.rgb().formatHex8();
}
function fq() {
  return qj(this).formatHsl();
}
function dS() {
  return this.rgb().formatRgb();
}
function ws(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = iq.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? fS(t) : n === 3 ? new rn(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? $c(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? $c(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = aq.exec(e)) ? new rn(t[1], t[2], t[3], 1) : (t = oq.exec(e)) ? new rn(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = sq.exec(e)) ? $c(t[1], t[2], t[3], t[4]) : (t = cq.exec(e)) ? $c(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = lq.exec(e)) ? vS(t[1], t[2] / 100, t[3] / 100, 1) : (t = uq.exec(e)) ? vS(t[1], t[2] / 100, t[3] / 100, t[4]) : lS.hasOwnProperty(e) ? fS(lS[e]) : e === "transparent" ? new rn(NaN, NaN, NaN, 0) : null;
}
function fS(e) {
  return new rn(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function $c(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new rn(e, t, n, r);
}
function hq(e) {
  return e instanceof sc || (e = ws(e)), e ? (e = e.rgb(), new rn(e.r, e.g, e.b, e.opacity)) : new rn();
}
function yg(e, t, n, r) {
  return arguments.length === 1 ? hq(e) : new rn(e, t, n, r ?? 1);
}
function rn(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
xb(rn, yg, zj(sc, {
  brighter(e) {
    return e = e == null ? Dl : Math.pow(Dl, e), new rn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? bs : Math.pow(bs, e), new rn(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new rn($i(this.r), $i(this.g), $i(this.b), kl(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: hS,
  // Deprecated! Use color.formatHex.
  formatHex: hS,
  formatHex8: mq,
  formatRgb: mS,
  toString: mS
}));
function hS() {
  return `#${Ni(this.r)}${Ni(this.g)}${Ni(this.b)}`;
}
function mq() {
  return `#${Ni(this.r)}${Ni(this.g)}${Ni(this.b)}${Ni((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function mS() {
  const e = kl(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${$i(this.r)}, ${$i(this.g)}, ${$i(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function kl(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function $i(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ni(e) {
  return e = $i(e), (e < 16 ? "0" : "") + e.toString(16);
}
function vS(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Vn(e, t, n, r);
}
function qj(e) {
  if (e instanceof Vn) return new Vn(e.h, e.s, e.l, e.opacity);
  if (e instanceof sc || (e = ws(e)), !e) return new Vn();
  if (e instanceof Vn) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
  return s ? (t === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - t) / s + 2 : o = (t - n) / s + 4, s /= c < 0.5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Vn(o, s, c, e.opacity);
}
function vq(e, t, n, r) {
  return arguments.length === 1 ? qj(e) : new Vn(e, t, n, r ?? 1);
}
function Vn(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
xb(Vn, vq, zj(sc, {
  brighter(e) {
    return e = e == null ? Dl : Math.pow(Dl, e), new Vn(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? bs : Math.pow(bs, e), new Vn(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new rn(
      lv(e >= 240 ? e - 240 : e + 120, i, r),
      lv(e, i, r),
      lv(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Vn(pS(this.h), Bc(this.s), Bc(this.l), kl(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = kl(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${pS(this.h)}, ${Bc(this.s) * 100}%, ${Bc(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function pS(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Bc(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function lv(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const wb = (e) => () => e;
function pq(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function gq(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function yq(e) {
  return (e = +e) == 1 ? Vj : function(t, n) {
    return n - t ? gq(t, n, e) : wb(isNaN(t) ? n : t);
  };
}
function Vj(e, t) {
  var n = t - e;
  return n ? pq(e, n) : wb(isNaN(e) ? t : e);
}
const gS = (function e(t) {
  var n = yq(t);
  function r(i, a) {
    var o = n((i = yg(i)).r, (a = yg(a)).r), s = n(i.g, a.g), c = n(i.b, a.b), l = Vj(i.opacity, a.opacity);
    return function(d) {
      return i.r = o(d), i.g = s(d), i.b = c(d), i.opacity = l(d), i + "";
    };
  }
  return r.gamma = e, r;
})(1);
function bq(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
    return r;
  };
}
function xq(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function wq(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = xo(e[o], t[o]);
  for (; o < n; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function _q(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Rl(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Sq(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = xo(e[i], t[i]) : r[i] = t[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var bg = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, uv = new RegExp(bg.source, "g");
function Oq(e) {
  return function() {
    return e;
  };
}
function Eq(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Aq(e, t) {
  var n = bg.lastIndex = uv.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = bg.exec(e)) && (i = uv.exec(t)); )
    (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({ i: o, x: Rl(r, i) })), n = uv.lastIndex;
  return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? Eq(c[0].x) : Oq(t) : (t = c.length, function(l) {
    for (var d = 0, f; d < t; ++d) s[(f = c[d]).i] = f.x(l);
    return s.join("");
  });
}
function xo(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? wb(t) : (n === "number" ? Rl : n === "string" ? (r = ws(t)) ? (t = r, gS) : Aq : t instanceof ws ? gS : t instanceof Date ? _q : xq(t) ? bq : Array.isArray(t) ? wq : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Sq : Rl)(e, t);
}
function _b(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Pq(e, t) {
  t === void 0 && (t = e, e = xo);
  for (var n = 0, r = t.length - 1, i = t[0], a = new Array(r < 0 ? 0 : r); n < r; ) a[n] = e(i, i = t[++n]);
  return function(o) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(o *= r)));
    return a[s](o - s);
  };
}
function Cq(e) {
  return function() {
    return e;
  };
}
function Ll(e) {
  return +e;
}
var yS = [0, 1];
function Jt(e) {
  return e;
}
function xg(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Cq(isNaN(t) ? NaN : 0.5);
}
function jq(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function Tq(e, t, n) {
  var r = e[0], i = e[1], a = t[0], o = t[1];
  return i < r ? (r = xg(i, r), a = n(o, a)) : (r = xg(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function Nq(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < r; )
    i[o] = xg(e[o], e[o + 1]), a[o] = n(t[o], t[o + 1]);
  return function(s) {
    var c = oc(e, s, 1, r) - 1;
    return a[c](i[c](s));
  };
}
function cc(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Zu() {
  var e = yS, t = yS, n = xo, r, i, a, o = Jt, s, c, l;
  function d() {
    var h = Math.min(e.length, t.length);
    return o !== Jt && (o = jq(e[0], e[h - 1])), s = h > 2 ? Nq : Tq, c = l = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? a : (c || (c = s(e.map(r), t, n)))(r(o(h)));
  }
  return f.invert = function(h) {
    return o(i((l || (l = s(t, e.map(r), Rl)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, Ll), d()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), d()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = _b, d();
  }, f.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : Jt, d()) : o !== Jt;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, d()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (a = h, f) : a;
  }, function(h, m) {
    return r = h, i = m, d();
  };
}
function Sb() {
  return Zu()(Jt, Jt);
}
function Mq(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function $l(e, t) {
  if (!isFinite(e) || e === 0) return null;
  var n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function Va(e) {
  return e = $l(Math.abs(e)), e ? e[1] : NaN;
}
function Iq(e, t) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function Dq(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var kq = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function _s(e) {
  if (!(t = kq.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Ob({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
_s.prototype = Ob.prototype;
function Ob(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Ob.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function Rq(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var Bl;
function Lq(e, t) {
  var n = $l(e, t);
  if (!n) return Bl = void 0, e.toPrecision(t);
  var r = n[0], i = n[1], a = i - (Bl = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + $l(e, Math.max(0, t + a - 1))[0];
}
function bS(e, t) {
  var n = $l(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const xS = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Mq,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => bS(e * 100, t),
  r: bS,
  s: Lq,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function wS(e) {
  return e;
}
var _S = Array.prototype.map, SS = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function $q(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? wS : Iq(_S.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? wS : Dq(_S.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(f, h) {
    f = _s(f);
    var m = f.fill, g = f.align, p = f.sign, v = f.symbol, y = f.zero, x = f.width, w = f.comma, _ = f.precision, b = f.trim, S = f.type;
    S === "n" ? (w = !0, S = "g") : xS[S] || (_ === void 0 && (_ = 12), b = !0, S = "g"), (y || m === "0" && g === "=") && (y = !0, m = "0", g = "=");
    var O = (h && h.prefix !== void 0 ? h.prefix : "") + (v === "$" ? n : v === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : ""), E = (v === "$" ? r : /[%p]/.test(S) ? o : "") + (h && h.suffix !== void 0 ? h.suffix : ""), P = xS[S], R = /[defgprs%]/.test(S);
    _ = _ === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function j(C) {
      var N = O, k = E, I, $, z;
      if (S === "c")
        k = P(C) + k, C = "";
      else {
        C = +C;
        var V = C < 0 || 1 / C < 0;
        if (C = isNaN(C) ? c : P(Math.abs(C), _), b && (C = Rq(C)), V && +C == 0 && p !== "+" && (V = !1), N = (V ? p === "(" ? p : s : p === "-" || p === "(" ? "" : p) + N, k = (S === "s" && !isNaN(C) && Bl !== void 0 ? SS[8 + Bl / 3] : "") + k + (V && p === "(" ? ")" : ""), R) {
          for (I = -1, $ = C.length; ++I < $; )
            if (z = C.charCodeAt(I), 48 > z || z > 57) {
              k = (z === 46 ? i + C.slice(I + 1) : C.slice(I)) + k, C = C.slice(0, I);
              break;
            }
        }
      }
      w && !y && (C = t(C, 1 / 0));
      var K = N.length + C.length + k.length, D = K < x ? new Array(x - K + 1).join(m) : "";
      switch (w && y && (C = t(D + C, D.length ? x - k.length : 1 / 0), D = ""), g) {
        case "<":
          C = N + C + k + D;
          break;
        case "=":
          C = N + D + C + k;
          break;
        case "^":
          C = D.slice(0, K = D.length >> 1) + N + C + k + D.slice(K);
          break;
        default:
          C = D + N + C + k;
          break;
      }
      return a(C);
    }
    return j.toString = function() {
      return f + "";
    }, j;
  }
  function d(f, h) {
    var m = Math.max(-8, Math.min(8, Math.floor(Va(h) / 3))) * 3, g = Math.pow(10, -m), p = l((f = _s(f), f.type = "f", f), { suffix: SS[8 + m / 3] });
    return function(v) {
      return p(g * v);
    };
  }
  return {
    format: l,
    formatPrefix: d
  };
}
var Fc, Eb, Wj;
Bq({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Bq(e) {
  return Fc = $q(e), Eb = Fc.format, Wj = Fc.formatPrefix, Fc;
}
function Fq(e) {
  return Math.max(0, -Va(Math.abs(e)));
}
function zq(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Va(t) / 3))) * 3 - Va(Math.abs(e)));
}
function qq(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Va(t) - Va(e)) + 1;
}
function Uj(e, t, n, r) {
  var i = pg(e, t, n), a;
  switch (r = _s(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(a = zq(i, o)) && (r.precision = a), Wj(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = qq(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = Fq(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Eb(r);
}
function ui(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return mg(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return Uj(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], c, l, d = 10;
    for (s < o && (l = o, o = s, s = l, l = i, i = a, a = l); d-- > 0; ) {
      if (l = vg(o, s, n), l === c)
        return r[i] = o, r[a] = s, t(r);
      if (l > 0)
        o = Math.floor(o / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        o = Math.ceil(o * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function Fl() {
  var e = Sb();
  return e.copy = function() {
    return cc(e, Fl());
  }, Dn.apply(e, arguments), ui(e);
}
function Hj(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, Ll), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return Hj(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Ll) : [0, 1], ui(n);
}
function Yj(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], a = e[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), e[n] = t.floor(i), e[r] = t.ceil(a), e;
}
function OS(e) {
  return Math.log(e);
}
function ES(e) {
  return Math.exp(e);
}
function Vq(e) {
  return -Math.log(-e);
}
function Wq(e) {
  return -Math.exp(-e);
}
function Uq(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function Hq(e) {
  return e === 10 ? Uq : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function Yq(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function AS(e) {
  return (t, n) => -e(-t, n);
}
function Ab(e) {
  const t = e(OS, ES), n = t.domain;
  let r = 10, i, a;
  function o() {
    return i = Yq(r), a = Hq(r), n()[0] < 0 ? (i = AS(i), a = AS(a), e(Vq, Wq)) : e(OS, ES), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, o()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), o()) : n();
  }, t.ticks = (s) => {
    const c = n();
    let l = c[0], d = c[c.length - 1];
    const f = d < l;
    f && ([l, d] = [d, l]);
    let h = i(l), m = i(d), g, p;
    const v = s == null ? 10 : +s;
    let y = [];
    if (!(r % 1) && m - h < v) {
      if (h = Math.floor(h), m = Math.ceil(m), l > 0) {
        for (; h <= m; ++h)
          for (g = 1; g < r; ++g)
            if (p = h < 0 ? g / a(-h) : g * a(h), !(p < l)) {
              if (p > d) break;
              y.push(p);
            }
      } else for (; h <= m; ++h)
        for (g = r - 1; g >= 1; --g)
          if (p = h > 0 ? g / a(-h) : g * a(h), !(p < l)) {
            if (p > d) break;
            y.push(p);
          }
      y.length * 2 < v && (y = mg(l, d, v));
    } else
      y = mg(h, m, Math.min(m - h, v)).map(a);
    return f ? y.reverse() : y;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = r === 10 ? "s" : ","), typeof c != "function" && (!(r % 1) && (c = _s(c)).precision == null && (c.trim = !0), c = Eb(c)), s === 1 / 0) return c;
    const l = Math.max(1, r * s / t.ticks().length);
    return (d) => {
      let f = d / a(Math.round(i(d)));
      return f * r < r - 0.5 && (f *= r), f <= l ? c(d) : "";
    };
  }, t.nice = () => n(Yj(n(), {
    floor: (s) => a(Math.floor(i(s))),
    ceil: (s) => a(Math.ceil(i(s)))
  })), t;
}
function Kj() {
  const e = Ab(Zu()).domain([1, 10]);
  return e.copy = () => cc(e, Kj()).base(e.base()), Dn.apply(e, arguments), e;
}
function PS(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function CS(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function Pb(e) {
  var t = 1, n = e(PS(t), CS(t));
  return n.constant = function(r) {
    return arguments.length ? e(PS(t = +r), CS(t)) : t;
  }, ui(n);
}
function Gj() {
  var e = Pb(Zu());
  return e.copy = function() {
    return cc(e, Gj()).constant(e.constant());
  }, Dn.apply(e, arguments);
}
function jS(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function Kq(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function Gq(e) {
  return e < 0 ? -e * e : e * e;
}
function Cb(e) {
  var t = e(Jt, Jt), n = 1;
  function r() {
    return n === 1 ? e(Jt, Jt) : n === 0.5 ? e(Kq, Gq) : e(jS(n), jS(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, ui(t);
}
function jb() {
  var e = Cb(Zu());
  return e.copy = function() {
    return cc(e, jb()).exponent(e.exponent());
  }, Dn.apply(e, arguments), e;
}
function Zq() {
  return jb.apply(null, arguments).exponent(0.5);
}
function TS(e) {
  return Math.sign(e) * e * e;
}
function Xq(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Zj() {
  var e = Sb(), t = [0, 1], n = !1, r;
  function i(a) {
    var o = Xq(e(a));
    return isNaN(o) ? r : n ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(TS(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, Ll)).map(TS)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (n = !!a, i) : n;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return Zj(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, Dn.apply(i, arguments), ui(i);
}
function Xj() {
  var e = [], t = [], n = [], r;
  function i() {
    var o = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++o < s; ) n[o - 1] = nq(e, o / s);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? r : t[oc(n, o)];
  }
  return a.invertExtent = function(o) {
    var s = t.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of o) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(ti), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (r = o, a) : r;
  }, a.quantiles = function() {
    return n.slice();
  }, a.copy = function() {
    return Xj().domain(e).range(t).unknown(r);
  }, Dn.apply(a, arguments);
}
function Qj() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], a;
  function o(c) {
    return c != null && c <= c ? i[oc(r, c, 0, n)] : a;
  }
  function s() {
    var c = -1;
    for (r = new Array(n); ++c < n; ) r[c] = ((c + 1) * t - (c - n) * e) / (n + 1);
    return o;
  }
  return o.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, o.range = function(c) {
    return arguments.length ? (n = (i = Array.from(c)).length - 1, s()) : i.slice();
  }, o.invertExtent = function(c) {
    var l = i.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, r[0]] : l >= n ? [r[n - 1], t] : [r[l - 1], r[l]];
  }, o.unknown = function(c) {
    return arguments.length && (a = c), o;
  }, o.thresholds = function() {
    return r.slice();
  }, o.copy = function() {
    return Qj().domain([e, t]).range(i).unknown(a);
  }, Dn.apply(ui(o), arguments);
}
function Jj() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(a) {
    return a != null && a <= a ? t[oc(e, a, 0, r)] : n;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Jj().domain(e).range(t).unknown(n);
  }, Dn.apply(i, arguments);
}
const dv = /* @__PURE__ */ new Date(), fv = /* @__PURE__ */ new Date();
function jt(e, t, n, r) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, s) => {
    const c = [];
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (l < a && a < o);
    return c;
  }, i.filter = (a) => jt((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0) for (; ++s <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --s >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), n && (i.count = (a, o) => (dv.setTime(+a), fv.setTime(+o), e(dv), e(fv), Math.floor(n(dv, fv))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? (o) => r(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const zl = jt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
zl.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? jt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : zl);
zl.range;
const Er = 1e3, jn = Er * 60, Ar = jn * 60, Ir = Ar * 24, Tb = Ir * 7, NS = Ir * 30, hv = Ir * 365, Mi = jt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Er);
}, (e, t) => (t - e) / Er, (e) => e.getUTCSeconds());
Mi.range;
const Nb = jt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Er);
}, (e, t) => {
  e.setTime(+e + t * jn);
}, (e, t) => (t - e) / jn, (e) => e.getMinutes());
Nb.range;
const Mb = jt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * jn);
}, (e, t) => (t - e) / jn, (e) => e.getUTCMinutes());
Mb.range;
const Ib = jt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Er - e.getMinutes() * jn);
}, (e, t) => {
  e.setTime(+e + t * Ar);
}, (e, t) => (t - e) / Ar, (e) => e.getHours());
Ib.range;
const Db = jt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ar);
}, (e, t) => (t - e) / Ar, (e) => e.getUTCHours());
Db.range;
const lc = jt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * jn) / Ir,
  (e) => e.getDate() - 1
);
lc.range;
const Xu = jt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ir, (e) => e.getUTCDate() - 1);
Xu.range;
const eT = jt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ir, (e) => Math.floor(e / Ir));
eT.range;
function ia(e) {
  return jt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * jn) / Tb);
}
const Qu = ia(0), ql = ia(1), Qq = ia(2), Jq = ia(3), Wa = ia(4), eV = ia(5), tV = ia(6);
Qu.range;
ql.range;
Qq.range;
Jq.range;
Wa.range;
eV.range;
tV.range;
function aa(e) {
  return jt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / Tb);
}
const Ju = aa(0), Vl = aa(1), nV = aa(2), rV = aa(3), Ua = aa(4), iV = aa(5), aV = aa(6);
Ju.range;
Vl.range;
nV.range;
rV.range;
Ua.range;
iV.range;
aV.range;
const kb = jt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
kb.range;
const Rb = jt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Rb.range;
const Dr = jt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Dr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : jt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Dr.range;
const kr = jt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
kr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : jt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
kr.range;
function tT(e, t, n, r, i, a) {
  const o = [
    [Mi, 1, Er],
    [Mi, 5, 5 * Er],
    [Mi, 15, 15 * Er],
    [Mi, 30, 30 * Er],
    [a, 1, jn],
    [a, 5, 5 * jn],
    [a, 15, 15 * jn],
    [a, 30, 30 * jn],
    [i, 1, Ar],
    [i, 3, 3 * Ar],
    [i, 6, 6 * Ar],
    [i, 12, 12 * Ar],
    [r, 1, Ir],
    [r, 2, 2 * Ir],
    [n, 1, Tb],
    [t, 1, NS],
    [t, 3, 3 * NS],
    [e, 1, hv]
  ];
  function s(l, d, f) {
    const h = d < l;
    h && ([l, d] = [d, l]);
    const m = f && typeof f.range == "function" ? f : c(l, d, f), g = m ? m.range(l, +d + 1) : [];
    return h ? g.reverse() : g;
  }
  function c(l, d, f) {
    const h = Math.abs(d - l) / f, m = yb(([, , v]) => v).right(o, h);
    if (m === o.length) return e.every(pg(l / hv, d / hv, f));
    if (m === 0) return zl.every(Math.max(pg(l, d, f), 1));
    const [g, p] = o[h / o[m - 1][2] < o[m][2] / h ? m - 1 : m];
    return g.every(p);
  }
  return [s, c];
}
const [oV, sV] = tT(kr, Rb, Ju, eT, Db, Mb), [cV, lV] = tT(Dr, kb, Qu, lc, Ib, Nb);
function mv(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function vv(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Do(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function uV(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, l = ko(i), d = Ro(i), f = ko(a), h = Ro(a), m = ko(o), g = Ro(o), p = ko(s), v = Ro(s), y = ko(c), x = Ro(c), w = {
    a: z,
    A: V,
    b: K,
    B: D,
    c: null,
    d: LS,
    e: LS,
    f: IV,
    g: VV,
    G: UV,
    H: TV,
    I: NV,
    j: MV,
    L: nT,
    m: DV,
    M: kV,
    p: U,
    q: Y,
    Q: FS,
    s: zS,
    S: RV,
    u: LV,
    U: $V,
    V: BV,
    w: FV,
    W: zV,
    x: null,
    X: null,
    y: qV,
    Y: WV,
    Z: HV,
    "%": BS
  }, _ = {
    a: X,
    A: oe,
    b: ie,
    B: he,
    c: null,
    d: $S,
    e: $S,
    f: ZV,
    g: oW,
    G: cW,
    H: YV,
    I: KV,
    j: GV,
    L: iT,
    m: XV,
    M: QV,
    p: ee,
    q: se,
    Q: FS,
    s: zS,
    S: JV,
    u: eW,
    U: tW,
    V: nW,
    w: rW,
    W: iW,
    x: null,
    X: null,
    y: aW,
    Y: sW,
    Z: lW,
    "%": BS
  }, b = {
    a: R,
    A: j,
    b: C,
    B: N,
    c: k,
    d: kS,
    e: kS,
    f: AV,
    g: DS,
    G: IS,
    H: RS,
    I: RS,
    j: _V,
    L: EV,
    m: wV,
    M: SV,
    p: P,
    q: xV,
    Q: CV,
    s: jV,
    S: OV,
    u: vV,
    U: pV,
    V: gV,
    w: mV,
    W: yV,
    x: I,
    X: $,
    y: DS,
    Y: IS,
    Z: bV,
    "%": PV
  };
  w.x = S(n, w), w.X = S(r, w), w.c = S(t, w), _.x = S(n, _), _.X = S(r, _), _.c = S(t, _);
  function S(G, Q) {
    return function(ce) {
      var F = [], ye = -1, te = 0, Ne = G.length, Te, Ge, At;
      for (ce instanceof Date || (ce = /* @__PURE__ */ new Date(+ce)); ++ye < Ne; )
        G.charCodeAt(ye) === 37 && (F.push(G.slice(te, ye)), (Ge = MS[Te = G.charAt(++ye)]) != null ? Te = G.charAt(++ye) : Ge = Te === "e" ? " " : "0", (At = Q[Te]) && (Te = At(ce, Ge)), F.push(Te), te = ye + 1);
      return F.push(G.slice(te, ye)), F.join("");
    };
  }
  function O(G, Q) {
    return function(ce) {
      var F = Do(1900, void 0, 1), ye = E(F, G, ce += "", 0), te, Ne;
      if (ye != ce.length) return null;
      if ("Q" in F) return new Date(F.Q);
      if ("s" in F) return new Date(F.s * 1e3 + ("L" in F ? F.L : 0));
      if (Q && !("Z" in F) && (F.Z = 0), "p" in F && (F.H = F.H % 12 + F.p * 12), F.m === void 0 && (F.m = "q" in F ? F.q : 0), "V" in F) {
        if (F.V < 1 || F.V > 53) return null;
        "w" in F || (F.w = 1), "Z" in F ? (te = vv(Do(F.y, 0, 1)), Ne = te.getUTCDay(), te = Ne > 4 || Ne === 0 ? Vl.ceil(te) : Vl(te), te = Xu.offset(te, (F.V - 1) * 7), F.y = te.getUTCFullYear(), F.m = te.getUTCMonth(), F.d = te.getUTCDate() + (F.w + 6) % 7) : (te = mv(Do(F.y, 0, 1)), Ne = te.getDay(), te = Ne > 4 || Ne === 0 ? ql.ceil(te) : ql(te), te = lc.offset(te, (F.V - 1) * 7), F.y = te.getFullYear(), F.m = te.getMonth(), F.d = te.getDate() + (F.w + 6) % 7);
      } else ("W" in F || "U" in F) && ("w" in F || (F.w = "u" in F ? F.u % 7 : "W" in F ? 1 : 0), Ne = "Z" in F ? vv(Do(F.y, 0, 1)).getUTCDay() : mv(Do(F.y, 0, 1)).getDay(), F.m = 0, F.d = "W" in F ? (F.w + 6) % 7 + F.W * 7 - (Ne + 5) % 7 : F.w + F.U * 7 - (Ne + 6) % 7);
      return "Z" in F ? (F.H += F.Z / 100 | 0, F.M += F.Z % 100, vv(F)) : mv(F);
    };
  }
  function E(G, Q, ce, F) {
    for (var ye = 0, te = Q.length, Ne = ce.length, Te, Ge; ye < te; ) {
      if (F >= Ne) return -1;
      if (Te = Q.charCodeAt(ye++), Te === 37) {
        if (Te = Q.charAt(ye++), Ge = b[Te in MS ? Q.charAt(ye++) : Te], !Ge || (F = Ge(G, ce, F)) < 0) return -1;
      } else if (Te != ce.charCodeAt(F++))
        return -1;
    }
    return F;
  }
  function P(G, Q, ce) {
    var F = l.exec(Q.slice(ce));
    return F ? (G.p = d.get(F[0].toLowerCase()), ce + F[0].length) : -1;
  }
  function R(G, Q, ce) {
    var F = m.exec(Q.slice(ce));
    return F ? (G.w = g.get(F[0].toLowerCase()), ce + F[0].length) : -1;
  }
  function j(G, Q, ce) {
    var F = f.exec(Q.slice(ce));
    return F ? (G.w = h.get(F[0].toLowerCase()), ce + F[0].length) : -1;
  }
  function C(G, Q, ce) {
    var F = y.exec(Q.slice(ce));
    return F ? (G.m = x.get(F[0].toLowerCase()), ce + F[0].length) : -1;
  }
  function N(G, Q, ce) {
    var F = p.exec(Q.slice(ce));
    return F ? (G.m = v.get(F[0].toLowerCase()), ce + F[0].length) : -1;
  }
  function k(G, Q, ce) {
    return E(G, t, Q, ce);
  }
  function I(G, Q, ce) {
    return E(G, n, Q, ce);
  }
  function $(G, Q, ce) {
    return E(G, r, Q, ce);
  }
  function z(G) {
    return o[G.getDay()];
  }
  function V(G) {
    return a[G.getDay()];
  }
  function K(G) {
    return c[G.getMonth()];
  }
  function D(G) {
    return s[G.getMonth()];
  }
  function U(G) {
    return i[+(G.getHours() >= 12)];
  }
  function Y(G) {
    return 1 + ~~(G.getMonth() / 3);
  }
  function X(G) {
    return o[G.getUTCDay()];
  }
  function oe(G) {
    return a[G.getUTCDay()];
  }
  function ie(G) {
    return c[G.getUTCMonth()];
  }
  function he(G) {
    return s[G.getUTCMonth()];
  }
  function ee(G) {
    return i[+(G.getUTCHours() >= 12)];
  }
  function se(G) {
    return 1 + ~~(G.getUTCMonth() / 3);
  }
  return {
    format: function(G) {
      var Q = S(G += "", w);
      return Q.toString = function() {
        return G;
      }, Q;
    },
    parse: function(G) {
      var Q = O(G += "", !1);
      return Q.toString = function() {
        return G;
      }, Q;
    },
    utcFormat: function(G) {
      var Q = S(G += "", _);
      return Q.toString = function() {
        return G;
      }, Q;
    },
    utcParse: function(G) {
      var Q = O(G += "", !0);
      return Q.toString = function() {
        return G;
      }, Q;
    }
  };
}
var MS = { "-": "", _: " ", 0: "0" }, Dt = /^\s*\d+/, dV = /^%/, fV = /[\\^$*+?|[\]().{}]/g;
function Be(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(t) + i : i);
}
function hV(e) {
  return e.replace(fV, "\\$&");
}
function ko(e) {
  return new RegExp("^(?:" + e.map(hV).join("|") + ")", "i");
}
function Ro(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function mV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function vV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function pV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function gV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function yV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function IS(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function DS(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function bV(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function xV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function wV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function kS(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function _V(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function RS(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function SV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function OV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function EV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function AV(e, t, n) {
  var r = Dt.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function PV(e, t, n) {
  var r = dV.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function CV(e, t, n) {
  var r = Dt.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function jV(e, t, n) {
  var r = Dt.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function LS(e, t) {
  return Be(e.getDate(), t, 2);
}
function TV(e, t) {
  return Be(e.getHours(), t, 2);
}
function NV(e, t) {
  return Be(e.getHours() % 12 || 12, t, 2);
}
function MV(e, t) {
  return Be(1 + lc.count(Dr(e), e), t, 3);
}
function nT(e, t) {
  return Be(e.getMilliseconds(), t, 3);
}
function IV(e, t) {
  return nT(e, t) + "000";
}
function DV(e, t) {
  return Be(e.getMonth() + 1, t, 2);
}
function kV(e, t) {
  return Be(e.getMinutes(), t, 2);
}
function RV(e, t) {
  return Be(e.getSeconds(), t, 2);
}
function LV(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function $V(e, t) {
  return Be(Qu.count(Dr(e) - 1, e), t, 2);
}
function rT(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Wa(e) : Wa.ceil(e);
}
function BV(e, t) {
  return e = rT(e), Be(Wa.count(Dr(e), e) + (Dr(e).getDay() === 4), t, 2);
}
function FV(e) {
  return e.getDay();
}
function zV(e, t) {
  return Be(ql.count(Dr(e) - 1, e), t, 2);
}
function qV(e, t) {
  return Be(e.getFullYear() % 100, t, 2);
}
function VV(e, t) {
  return e = rT(e), Be(e.getFullYear() % 100, t, 2);
}
function WV(e, t) {
  return Be(e.getFullYear() % 1e4, t, 4);
}
function UV(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Wa(e) : Wa.ceil(e), Be(e.getFullYear() % 1e4, t, 4);
}
function HV(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Be(t / 60 | 0, "0", 2) + Be(t % 60, "0", 2);
}
function $S(e, t) {
  return Be(e.getUTCDate(), t, 2);
}
function YV(e, t) {
  return Be(e.getUTCHours(), t, 2);
}
function KV(e, t) {
  return Be(e.getUTCHours() % 12 || 12, t, 2);
}
function GV(e, t) {
  return Be(1 + Xu.count(kr(e), e), t, 3);
}
function iT(e, t) {
  return Be(e.getUTCMilliseconds(), t, 3);
}
function ZV(e, t) {
  return iT(e, t) + "000";
}
function XV(e, t) {
  return Be(e.getUTCMonth() + 1, t, 2);
}
function QV(e, t) {
  return Be(e.getUTCMinutes(), t, 2);
}
function JV(e, t) {
  return Be(e.getUTCSeconds(), t, 2);
}
function eW(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function tW(e, t) {
  return Be(Ju.count(kr(e) - 1, e), t, 2);
}
function aT(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Ua(e) : Ua.ceil(e);
}
function nW(e, t) {
  return e = aT(e), Be(Ua.count(kr(e), e) + (kr(e).getUTCDay() === 4), t, 2);
}
function rW(e) {
  return e.getUTCDay();
}
function iW(e, t) {
  return Be(Vl.count(kr(e) - 1, e), t, 2);
}
function aW(e, t) {
  return Be(e.getUTCFullYear() % 100, t, 2);
}
function oW(e, t) {
  return e = aT(e), Be(e.getUTCFullYear() % 100, t, 2);
}
function sW(e, t) {
  return Be(e.getUTCFullYear() % 1e4, t, 4);
}
function cW(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Ua(e) : Ua.ceil(e), Be(e.getUTCFullYear() % 1e4, t, 4);
}
function lW() {
  return "+0000";
}
function BS() {
  return "%";
}
function FS(e) {
  return +e;
}
function zS(e) {
  return Math.floor(+e / 1e3);
}
var ha, oT, sT;
uW({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function uW(e) {
  return ha = uV(e), oT = ha.format, ha.parse, sT = ha.utcFormat, ha.utcParse, ha;
}
function dW(e) {
  return new Date(e);
}
function fW(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Lb(e, t, n, r, i, a, o, s, c, l) {
  var d = Sb(), f = d.invert, h = d.domain, m = l(".%L"), g = l(":%S"), p = l("%I:%M"), v = l("%I %p"), y = l("%a %d"), x = l("%b %d"), w = l("%B"), _ = l("%Y");
  function b(S) {
    return (c(S) < S ? m : s(S) < S ? g : o(S) < S ? p : a(S) < S ? v : r(S) < S ? i(S) < S ? y : x : n(S) < S ? w : _)(S);
  }
  return d.invert = function(S) {
    return new Date(f(S));
  }, d.domain = function(S) {
    return arguments.length ? h(Array.from(S, fW)) : h().map(dW);
  }, d.ticks = function(S) {
    var O = h();
    return e(O[0], O[O.length - 1], S ?? 10);
  }, d.tickFormat = function(S, O) {
    return O == null ? b : l(O);
  }, d.nice = function(S) {
    var O = h();
    return (!S || typeof S.range != "function") && (S = t(O[0], O[O.length - 1], S ?? 10)), S ? h(Yj(O, S)) : d;
  }, d.copy = function() {
    return cc(d, Lb(e, t, n, r, i, a, o, s, c, l));
  }, d;
}
function hW() {
  return Dn.apply(Lb(cV, lV, Dr, kb, Qu, lc, Ib, Nb, Mi, oT).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function mW() {
  return Dn.apply(Lb(oV, sV, kr, Rb, Ju, Xu, Db, Mb, Mi, sT).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function ed() {
  var e = 0, t = 1, n, r, i, a, o = Jt, s = !1, c;
  function l(f) {
    return f == null || isNaN(f = +f) ? c : o(i === 0 ? 0.5 : (f = (a(f) - n) * i, s ? Math.max(0, Math.min(1, f)) : f));
  }
  l.domain = function(f) {
    return arguments.length ? ([e, t] = f, n = a(e = +e), r = a(t = +t), i = n === r ? 0 : 1 / (r - n), l) : [e, t];
  }, l.clamp = function(f) {
    return arguments.length ? (s = !!f, l) : s;
  }, l.interpolator = function(f) {
    return arguments.length ? (o = f, l) : o;
  };
  function d(f) {
    return function(h) {
      var m, g;
      return arguments.length ? ([m, g] = h, o = f(m, g), l) : [o(0), o(1)];
    };
  }
  return l.range = d(xo), l.rangeRound = d(_b), l.unknown = function(f) {
    return arguments.length ? (c = f, l) : c;
  }, function(f) {
    return a = f, n = f(e), r = f(t), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function di(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function cT() {
  var e = ui(ed()(Jt));
  return e.copy = function() {
    return di(e, cT());
  }, Fr.apply(e, arguments);
}
function lT() {
  var e = Ab(ed()).domain([1, 10]);
  return e.copy = function() {
    return di(e, lT()).base(e.base());
  }, Fr.apply(e, arguments);
}
function uT() {
  var e = Pb(ed());
  return e.copy = function() {
    return di(e, uT()).constant(e.constant());
  }, Fr.apply(e, arguments);
}
function $b() {
  var e = Cb(ed());
  return e.copy = function() {
    return di(e, $b()).exponent(e.exponent());
  }, Fr.apply(e, arguments);
}
function vW() {
  return $b.apply(null, arguments).exponent(0.5);
}
function dT() {
  var e = [], t = Jt;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((oc(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of r) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(ti), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, a) => tq(e, a / r));
  }, n.copy = function() {
    return dT(t).domain(e);
  }, Fr.apply(n, arguments);
}
function td() {
  var e = 0, t = 0.5, n = 1, r = 1, i, a, o, s, c, l = Jt, d, f = !1, h;
  function m(p) {
    return isNaN(p = +p) ? h : (p = 0.5 + ((p = +d(p)) - a) * (r * p < r * a ? s : c), l(f ? Math.max(0, Math.min(1, p)) : p));
  }
  m.domain = function(p) {
    return arguments.length ? ([e, t, n] = p, i = d(e = +e), a = d(t = +t), o = d(n = +n), s = i === a ? 0 : 0.5 / (a - i), c = a === o ? 0 : 0.5 / (o - a), r = a < i ? -1 : 1, m) : [e, t, n];
  }, m.clamp = function(p) {
    return arguments.length ? (f = !!p, m) : f;
  }, m.interpolator = function(p) {
    return arguments.length ? (l = p, m) : l;
  };
  function g(p) {
    return function(v) {
      var y, x, w;
      return arguments.length ? ([y, x, w] = v, l = Pq(p, [y, x, w]), m) : [l(0), l(0.5), l(1)];
    };
  }
  return m.range = g(xo), m.rangeRound = g(_b), m.unknown = function(p) {
    return arguments.length ? (h = p, m) : h;
  }, function(p) {
    return d = p, i = p(e), a = p(t), o = p(n), s = i === a ? 0 : 0.5 / (a - i), c = a === o ? 0 : 0.5 / (o - a), r = a < i ? -1 : 1, m;
  };
}
function fT() {
  var e = ui(td()(Jt));
  return e.copy = function() {
    return di(e, fT());
  }, Fr.apply(e, arguments);
}
function hT() {
  var e = Ab(td()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return di(e, hT()).base(e.base());
  }, Fr.apply(e, arguments);
}
function mT() {
  var e = Pb(td());
  return e.copy = function() {
    return di(e, mT()).constant(e.constant());
  }, Fr.apply(e, arguments);
}
function Bb() {
  var e = Cb(td());
  return e.copy = function() {
    return di(e, Bb()).exponent(e.exponent());
  }, Fr.apply(e, arguments);
}
function pW() {
  return Bb.apply(null, arguments).exponent(0.5);
}
const qS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: ys,
  scaleDiverging: fT,
  scaleDivergingLog: hT,
  scaleDivergingPow: Bb,
  scaleDivergingSqrt: pW,
  scaleDivergingSymlog: mT,
  scaleIdentity: Hj,
  scaleImplicit: gg,
  scaleLinear: Fl,
  scaleLog: Kj,
  scaleOrdinal: bb,
  scalePoint: ns,
  scalePow: jb,
  scaleQuantile: Xj,
  scaleQuantize: Qj,
  scaleRadial: Zj,
  scaleSequential: cT,
  scaleSequentialLog: lT,
  scaleSequentialPow: $b,
  scaleSequentialQuantile: dT,
  scaleSequentialSqrt: vW,
  scaleSequentialSymlog: uT,
  scaleSqrt: Zq,
  scaleSymlog: Gj,
  scaleThreshold: Jj,
  scaleTime: hW,
  scaleUtc: mW,
  tickFormat: Uj
}, Symbol.toStringTag, { value: "Module" }));
var pv, VS;
function vT() {
  if (VS) return pv;
  VS = 1;
  var e = go();
  function t(n, r, i) {
    for (var a = -1, o = n.length; ++a < o; ) {
      var s = n[a], c = r(s);
      if (c != null && (l === void 0 ? c === c && !e(c) : i(c, l)))
        var l = c, d = s;
    }
    return d;
  }
  return pv = t, pv;
}
var gv, WS;
function gW() {
  if (WS) return gv;
  WS = 1;
  function e(t, n) {
    return t > n;
  }
  return gv = e, gv;
}
var yv, US;
function yW() {
  if (US) return yv;
  US = 1;
  var e = vT(), t = gW(), n = bo();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return yv = r, yv;
}
var bW = yW();
const nd = /* @__PURE__ */ ct(bW);
var bv, HS;
function xW() {
  if (HS) return bv;
  HS = 1;
  function e(t, n) {
    return t < n;
  }
  return bv = e, bv;
}
var xv, YS;
function wW() {
  if (YS) return xv;
  YS = 1;
  var e = vT(), t = xW(), n = bo();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return xv = r, xv;
}
var _W = wW();
const rd = /* @__PURE__ */ ct(_W);
var wv, KS;
function SW() {
  if (KS) return wv;
  KS = 1;
  var e = eb(), t = li(), n = Ej(), r = sn();
  function i(a, o) {
    var s = r(a) ? e : n;
    return s(a, t(o, 3));
  }
  return wv = i, wv;
}
var _v, GS;
function OW() {
  if (GS) return _v;
  GS = 1;
  var e = Sj(), t = SW();
  function n(r, i) {
    return e(t(r, i), 1);
  }
  return _v = n, _v;
}
var EW = OW();
const AW = /* @__PURE__ */ ct(EW);
var Sv, ZS;
function PW() {
  if (ZS) return Sv;
  ZS = 1;
  var e = hb();
  function t(n, r) {
    return e(n, r);
  }
  return Sv = t, Sv;
}
var CW = PW();
const Fb = /* @__PURE__ */ ct(CW);
var wo = 1e9, jW = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, qb, lt = !0, Mn = "[DecimalError] ", Bi = Mn + "Invalid argument: ", zb = Mn + "Exponent out of range: ", _o = Math.floor, Ei = Math.pow, TW = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, gn, Mt = 1e7, st = 7, pT = 9007199254740991, Wl = _o(pT / st), ge = {};
ge.absoluteValue = ge.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
ge.comparedTo = ge.cmp = function(e) {
  var t, n, r, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (r = a.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ a.s < 0 ? 1 : -1;
};
ge.decimalPlaces = ge.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * st;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
ge.dividedBy = ge.div = function(e) {
  return Mr(this, new this.constructor(e));
};
ge.dividedToIntegerBy = ge.idiv = function(e) {
  var t = this, n = t.constructor;
  return et(Mr(t, new n(e), 0, 1), n.precision);
};
ge.equals = ge.eq = function(e) {
  return !this.cmp(e);
};
ge.exponent = function() {
  return Ot(this);
};
ge.greaterThan = ge.gt = function(e) {
  return this.cmp(e) > 0;
};
ge.greaterThanOrEqualTo = ge.gte = function(e) {
  return this.cmp(e) >= 0;
};
ge.isInteger = ge.isint = function() {
  return this.e > this.d.length - 2;
};
ge.isNegative = ge.isneg = function() {
  return this.s < 0;
};
ge.isPositive = ge.ispos = function() {
  return this.s > 0;
};
ge.isZero = function() {
  return this.s === 0;
};
ge.lessThan = ge.lt = function(e) {
  return this.cmp(e) < 0;
};
ge.lessThanOrEqualTo = ge.lte = function(e) {
  return this.cmp(e) < 1;
};
ge.logarithm = ge.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, a = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(gn)) throw Error(Mn + "NaN");
  if (n.s < 1) throw Error(Mn + (n.s ? "NaN" : "-Infinity"));
  return n.eq(gn) ? new r(0) : (lt = !1, t = Mr(Ss(n, a), Ss(e, a), a), lt = !0, et(t, i));
};
ge.minus = ge.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? bT(t, e) : gT(t, (e.s = -e.s, e));
};
ge.modulo = ge.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(Mn + "NaN");
  return n.s ? (lt = !1, t = Mr(n, e, 0, 1).times(e), lt = !0, n.minus(t)) : et(new r(n), i);
};
ge.naturalExponential = ge.exp = function() {
  return yT(this);
};
ge.naturalLogarithm = ge.ln = function() {
  return Ss(this);
};
ge.negated = ge.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
ge.plus = ge.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? gT(t, e) : bT(t, (e.s = -e.s, e));
};
ge.precision = ge.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Bi + e);
  if (t = Ot(i) + 1, r = i.d.length - 1, n = r * st + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
ge.squareRoot = ge.sqrt = function() {
  var e, t, n, r, i, a, o, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new c(0);
    throw Error(Mn + "NaN");
  }
  for (e = Ot(s), lt = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = ar(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = _o((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new c(t)) : r = new c(i.toString()), n = c.precision, i = o = n + 3; ; )
    if (a = r, r = a.plus(Mr(s, a, o + 2)).times(0.5), ar(a.d).slice(0, o) === (t = ar(r.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (et(a, n + 1, 0), a.times(a).eq(s)) {
          r = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return lt = !0, et(r, n);
};
ge.times = ge.mul = function(e) {
  var t, n, r, i, a, o, s, c, l, d = this, f = d.constructor, h = d.d, m = (e = new f(e)).d;
  if (!d.s || !e.s) return new f(0);
  for (e.s *= d.s, n = d.e + e.e, c = h.length, l = m.length, c < l && (a = h, h = m, m = a, o = c, c = l, l = o), a = [], o = c + l, r = o; r--; ) a.push(0);
  for (r = l; --r >= 0; ) {
    for (t = 0, i = c + r; i > r; )
      s = a[i] + m[r] * h[i - r - 1] + t, a[i--] = s % Mt | 0, t = s / Mt | 0;
    a[i] = (a[i] + t) % Mt | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++n : a.shift(), e.d = a, e.e = n, lt ? et(e, f.precision) : e;
};
ge.toDecimalPlaces = ge.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (dr(e, 0, wo), t === void 0 ? t = r.rounding : dr(t, 0, 8), et(n, e + Ot(n) + 1, t));
};
ge.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = Vi(r, !0) : (dr(e, 0, wo), t === void 0 ? t = i.rounding : dr(t, 0, 8), r = et(new i(r), e + 1, t), n = Vi(r, !0, e + 1)), n;
};
ge.toFixed = function(e, t) {
  var n, r, i = this, a = i.constructor;
  return e === void 0 ? Vi(i) : (dr(e, 0, wo), t === void 0 ? t = a.rounding : dr(t, 0, 8), r = et(new a(i), e + Ot(i) + 1, t), n = Vi(r.abs(), !1, e + Ot(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
ge.toInteger = ge.toint = function() {
  var e = this, t = e.constructor;
  return et(new t(e), Ot(e) + 1, t.rounding);
};
ge.toNumber = function() {
  return +this;
};
ge.toPower = ge.pow = function(e) {
  var t, n, r, i, a, o, s = this, c = s.constructor, l = 12, d = +(e = new c(e));
  if (!e.s) return new c(gn);
  if (s = new c(s), !s.s) {
    if (e.s < 1) throw Error(Mn + "Infinity");
    return s;
  }
  if (s.eq(gn)) return s;
  if (r = c.precision, e.eq(gn)) return et(s, r);
  if (t = e.e, n = e.d.length - 1, o = t >= n, a = s.s, o) {
    if ((n = d < 0 ? -d : d) <= pT) {
      for (i = new c(gn), t = Math.ceil(r / st + 4), lt = !1; n % 2 && (i = i.times(s), QS(i.d, t)), n = _o(n / 2), n !== 0; )
        s = s.times(s), QS(s.d, t);
      return lt = !0, e.s < 0 ? new c(gn).div(i) : et(i, r);
    }
  } else if (a < 0) throw Error(Mn + "NaN");
  return a = a < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, lt = !1, i = e.times(Ss(s, r + l)), lt = !0, i = yT(i), i.s = a, i;
};
ge.toPrecision = function(e, t) {
  var n, r, i = this, a = i.constructor;
  return e === void 0 ? (n = Ot(i), r = Vi(i, n <= a.toExpNeg || n >= a.toExpPos)) : (dr(e, 1, wo), t === void 0 ? t = a.rounding : dr(t, 0, 8), i = et(new a(i), e, t), n = Ot(i), r = Vi(i, e <= n || n <= a.toExpNeg, e)), r;
};
ge.toSignificantDigits = ge.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (dr(e, 1, wo), t === void 0 ? t = r.rounding : dr(t, 0, 8)), et(new r(n), e, t);
};
ge.toString = ge.valueOf = ge.val = ge.toJSON = ge[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ot(e), n = e.constructor;
  return Vi(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function gT(e, t) {
  var n, r, i, a, o, s, c, l, d = e.constructor, f = d.precision;
  if (!e.s || !t.s)
    return t.s || (t = new d(e)), lt ? et(t, f) : t;
  if (c = e.d, l = t.d, o = e.e, i = t.e, c = c.slice(), a = o - i, a) {
    for (a < 0 ? (r = c, a = -a, s = l.length) : (r = l, i = o, s = c.length), o = Math.ceil(f / st), s = o > s ? o + 1 : s + 1, a > s && (a = s, r.length = 1), r.reverse(); a--; ) r.push(0);
    r.reverse();
  }
  for (s = c.length, a = l.length, s - a < 0 && (a = s, r = l, l = c, c = r), n = 0; a; )
    n = (c[--a] = c[a] + l[a] + n) / Mt | 0, c[a] %= Mt;
  for (n && (c.unshift(n), ++i), s = c.length; c[--s] == 0; ) c.pop();
  return t.d = c, t.e = i, lt ? et(t, f) : t;
}
function dr(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Bi + e);
}
function ar(e) {
  var t, n, r, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      r = e[t] + "", n = st - r.length, n && (a += Xr(n)), a += r;
    o = e[t], r = o + "", n = st - r.length, n && (a += Xr(n));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Mr = /* @__PURE__ */ (function() {
  function e(r, i) {
    var a, o = 0, s = r.length;
    for (r = r.slice(); s--; )
      a = r[s] * i + o, r[s] = a % Mt | 0, o = a / Mt | 0;
    return o && r.unshift(o), r;
  }
  function t(r, i, a, o) {
    var s, c;
    if (a != o)
      c = a > o ? 1 : -1;
    else
      for (s = c = 0; s < a; s++)
        if (r[s] != i[s]) {
          c = r[s] > i[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function n(r, i, a) {
    for (var o = 0; a--; )
      r[a] -= o, o = r[a] < i[a] ? 1 : 0, r[a] = o * Mt + r[a] - i[a];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, a, o) {
    var s, c, l, d, f, h, m, g, p, v, y, x, w, _, b, S, O, E, P = r.constructor, R = r.s == i.s ? 1 : -1, j = r.d, C = i.d;
    if (!r.s) return new P(r);
    if (!i.s) throw Error(Mn + "Division by zero");
    for (c = r.e - i.e, O = C.length, b = j.length, m = new P(R), g = m.d = [], l = 0; C[l] == (j[l] || 0); ) ++l;
    if (C[l] > (j[l] || 0) && --c, a == null ? x = a = P.precision : o ? x = a + (Ot(r) - Ot(i)) + 1 : x = a, x < 0) return new P(0);
    if (x = x / st + 2 | 0, l = 0, O == 1)
      for (d = 0, C = C[0], x++; (l < b || d) && x--; l++)
        w = d * Mt + (j[l] || 0), g[l] = w / C | 0, d = w % C | 0;
    else {
      for (d = Mt / (C[0] + 1) | 0, d > 1 && (C = e(C, d), j = e(j, d), O = C.length, b = j.length), _ = O, p = j.slice(0, O), v = p.length; v < O; ) p[v++] = 0;
      E = C.slice(), E.unshift(0), S = C[0], C[1] >= Mt / 2 && ++S;
      do
        d = 0, s = t(C, p, O, v), s < 0 ? (y = p[0], O != v && (y = y * Mt + (p[1] || 0)), d = y / S | 0, d > 1 ? (d >= Mt && (d = Mt - 1), f = e(C, d), h = f.length, v = p.length, s = t(f, p, h, v), s == 1 && (d--, n(f, O < h ? E : C, h))) : (d == 0 && (s = d = 1), f = C.slice()), h = f.length, h < v && f.unshift(0), n(p, f, v), s == -1 && (v = p.length, s = t(C, p, O, v), s < 1 && (d++, n(p, O < v ? E : C, v))), v = p.length) : s === 0 && (d++, p = [0]), g[l++] = d, s && p[0] ? p[v++] = j[_] || 0 : (p = [j[_]], v = 1);
      while ((_++ < b || p[0] !== void 0) && x--);
    }
    return g[0] || g.shift(), m.e = c, et(m, o ? a + Ot(m) + 1 : a);
  };
})();
function yT(e, t) {
  var n, r, i, a, o, s, c = 0, l = 0, d = e.constructor, f = d.precision;
  if (Ot(e) > 16) throw Error(zb + Ot(e));
  if (!e.s) return new d(gn);
  for (lt = !1, s = f, o = new d(0.03125); e.abs().gte(0.1); )
    e = e.times(o), l += 5;
  for (r = Math.log(Ei(2, l)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = a = new d(gn), d.precision = s; ; ) {
    if (i = et(i.times(e), s), n = n.times(++c), o = a.plus(Mr(i, n, s)), ar(o.d).slice(0, s) === ar(a.d).slice(0, s)) {
      for (; l--; ) a = et(a.times(a), s);
      return d.precision = f, t == null ? (lt = !0, et(a, f)) : a;
    }
    a = o;
  }
}
function Ot(e) {
  for (var t = e.e * st, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function Ov(e, t, n) {
  if (t > e.LN10.sd())
    throw lt = !0, n && (e.precision = n), Error(Mn + "LN10 precision limit exceeded");
  return et(new e(e.LN10), t);
}
function Xr(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Ss(e, t) {
  var n, r, i, a, o, s, c, l, d, f = 1, h = 10, m = e, g = m.d, p = m.constructor, v = p.precision;
  if (m.s < 1) throw Error(Mn + (m.s ? "NaN" : "-Infinity"));
  if (m.eq(gn)) return new p(0);
  if (t == null ? (lt = !1, l = v) : l = t, m.eq(10))
    return t == null && (lt = !0), Ov(p, l);
  if (l += h, p.precision = l, n = ar(g), r = n.charAt(0), a = Ot(m), Math.abs(a) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      m = m.times(e), n = ar(m.d), r = n.charAt(0), f++;
    a = Ot(m), r > 1 ? (m = new p("0." + n), a++) : m = new p(r + "." + n.slice(1));
  } else
    return c = Ov(p, l + 2, v).times(a + ""), m = Ss(new p(r + "." + n.slice(1)), l - h).plus(c), p.precision = v, t == null ? (lt = !0, et(m, v)) : m;
  for (s = o = m = Mr(m.minus(gn), m.plus(gn), l), d = et(m.times(m), l), i = 3; ; ) {
    if (o = et(o.times(d), l), c = s.plus(Mr(o, new p(i), l)), ar(c.d).slice(0, l) === ar(s.d).slice(0, l))
      return s = s.times(2), a !== 0 && (s = s.plus(Ov(p, l + 2, v).times(a + ""))), s = Mr(s, new p(f), l), p.precision = v, t == null ? (lt = !0, et(s, v)) : s;
    s = c, i += 2;
  }
}
function XS(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = _o(n / st), e.d = [], r = (n + 1) % st, n < 0 && (r += st), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= st; r < i; ) e.d.push(+t.slice(r, r += st));
      t = t.slice(r), r = st - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), lt && (e.e > Wl || e.e < -Wl)) throw Error(zb + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function et(e, t, n) {
  var r, i, a, o, s, c, l, d, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (r = t - o, r < 0)
    r += st, i = t, l = f[d = 0];
  else {
    if (d = Math.ceil((r + 1) / st), a = f.length, d >= a) return e;
    for (l = a = f[d], o = 1; a >= 10; a /= 10) o++;
    r %= st, i = r - st + o;
  }
  if (n !== void 0 && (a = Ei(10, o - i - 1), s = l / a % 10 | 0, c = t < 0 || f[d + 1] !== void 0 || l % a, c = n < 4 ? (s || c) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || c || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? l / Ei(10, o - i) : 0 : f[d - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return c ? (a = Ot(e), f.length = 1, t = t - a - 1, f[0] = Ei(10, (st - t % st) % st), e.e = _o(-t / st) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (r == 0 ? (f.length = d, a = 1, d--) : (f.length = d + 1, a = Ei(10, st - r), f[d] = i > 0 ? (l / Ei(10, o - i) % Ei(10, i) | 0) * a : 0), c)
    for (; ; )
      if (d == 0) {
        (f[0] += a) == Mt && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[d] += a, f[d] != Mt) break;
        f[d--] = 0, a = 1;
      }
  for (r = f.length; f[--r] === 0; ) f.pop();
  if (lt && (e.e > Wl || e.e < -Wl))
    throw Error(zb + Ot(e));
  return e;
}
function bT(e, t) {
  var n, r, i, a, o, s, c, l, d, f, h = e.constructor, m = h.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new h(e), lt ? et(t, m) : t;
  if (c = e.d, f = t.d, r = t.e, l = e.e, c = c.slice(), o = l - r, o) {
    for (d = o < 0, d ? (n = c, o = -o, s = f.length) : (n = f, r = l, s = c.length), i = Math.max(Math.ceil(m / st), s) + 2, o > i && (o = i, n.length = 1), n.reverse(), i = o; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = c.length, s = f.length, d = i < s, d && (s = i), i = 0; i < s; i++)
      if (c[i] != f[i]) {
        d = c[i] < f[i];
        break;
      }
    o = 0;
  }
  for (d && (n = c, c = f, f = n, t.s = -t.s), s = c.length, i = f.length - s; i > 0; --i) c[s++] = 0;
  for (i = f.length; i > o; ) {
    if (c[--i] < f[i]) {
      for (a = i; a && c[--a] === 0; ) c[a] = Mt - 1;
      --c[a], c[i] += Mt;
    }
    c[i] -= f[i];
  }
  for (; c[--s] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --r;
  return c[0] ? (t.d = c, t.e = r, lt ? et(t, m) : t) : new h(0);
}
function Vi(e, t, n) {
  var r, i = Ot(e), a = ar(e.d), o = a.length;
  return t ? (n && (r = n - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + Xr(r) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + Xr(-i - 1) + a, n && (r = n - o) > 0 && (a += Xr(r))) : i >= o ? (a += Xr(i + 1 - o), n && (r = n - i - 1) > 0 && (a = a + "." + Xr(r))) : ((r = i + 1) < o && (a = a.slice(0, r) + "." + a.slice(r)), n && (r = n - o) > 0 && (i + 1 === o && (a += "."), a += Xr(r))), e.s < 0 ? "-" + a : a;
}
function QS(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function xT(e) {
  var t, n, r;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(Bi + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return XS(o, a.toString());
    } else if (typeof a != "string")
      throw Error(Bi + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, TW.test(a)) XS(o, a);
    else throw Error(Bi + a);
  }
  if (i.prototype = ge, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = xT, i.config = i.set = NW, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function NW(e) {
  if (!e || typeof e != "object")
    throw Error(Mn + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    wo,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if (_o(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Bi + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Bi + n + ": " + r);
  return this;
}
var qb = xT(jW);
gn = new qb(1);
const Qe = qb;
function MW(e) {
  return RW(e) || kW(e) || DW(e) || IW();
}
function IW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DW(e, t) {
  if (e) {
    if (typeof e == "string") return wg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wg(e, t);
  }
}
function kW(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function RW(e) {
  if (Array.isArray(e)) return wg(e);
}
function wg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var LW = function(t) {
  return t;
}, wT = {}, _T = function(t) {
  return t === wT;
}, JS = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && _T(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, $W = function e(t, n) {
  return t === 1 ? n : JS(function() {
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    var o = i.filter(function(s) {
      return s !== wT;
    }).length;
    return o >= t ? n.apply(void 0, i) : e(t - o, JS(function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      var d = i.map(function(f) {
        return _T(f) ? c.shift() : f;
      });
      return n.apply(void 0, MW(d).concat(c));
    }));
  });
}, id = function(t) {
  return $W(t.length, t);
}, _g = function(t, n) {
  for (var r = [], i = t; i < n; ++i)
    r[i - t] = i;
  return r;
}, BW = id(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), FW = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return LW;
  var i = n.reverse(), a = i[0], o = i.slice(1);
  return function() {
    return o.reduce(function(s, c) {
      return c(s);
    }, a.apply(void 0, arguments));
  };
}, Sg = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, ST = function(t) {
  var n = null, r = null;
  return function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n && a.every(function(s, c) {
      return s === n[c];
    }) || (n = a, r = t.apply(void 0, a)), r;
  };
};
function zW(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Qe(e).abs().log(10).toNumber()) + 1, t;
}
function qW(e, t, n) {
  for (var r = new Qe(e), i = 0, a = []; r.lt(t) && i < 1e5; )
    a.push(r.toNumber()), r = r.add(n), i++;
  return a;
}
var VW = id(function(e, t, n) {
  var r = +e, i = +t;
  return r + n * (i - r);
}), WW = id(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), UW = id(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const ad = {
  rangeStep: qW,
  getDigitCount: zW,
  interpolateNumber: VW,
  uninterpolateNumber: WW,
  uninterpolateTruncation: UW
};
function Og(e) {
  return KW(e) || YW(e) || OT(e) || HW();
}
function HW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YW(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function KW(e) {
  if (Array.isArray(e)) return Eg(e);
}
function Os(e, t) {
  return XW(e) || ZW(e, t) || OT(e, t) || GW();
}
function GW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OT(e, t) {
  if (e) {
    if (typeof e == "string") return Eg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Eg(e, t);
  }
}
function Eg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ZW(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, i = !1, a = void 0;
    try {
      for (var o = e[Symbol.iterator](), s; !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (c) {
      i = !0, a = c;
    } finally {
      try {
        !r && o.return != null && o.return();
      } finally {
        if (i) throw a;
      }
    }
    return n;
  }
}
function XW(e) {
  if (Array.isArray(e)) return e;
}
function ET(e) {
  var t = Os(e, 2), n = t[0], r = t[1], i = n, a = r;
  return n > r && (i = r, a = n), [i, a];
}
function AT(e, t, n) {
  if (e.lte(0))
    return new Qe(0);
  var r = ad.getDigitCount(e.toNumber()), i = new Qe(10).pow(r), a = e.div(i), o = r !== 1 ? 0.05 : 0.1, s = new Qe(Math.ceil(a.div(o).toNumber())).add(n).mul(o), c = s.mul(i);
  return t ? c : new Qe(Math.ceil(c));
}
function QW(e, t, n) {
  var r = 1, i = new Qe(e);
  if (!i.isint() && n) {
    var a = Math.abs(e);
    a < 1 ? (r = new Qe(10).pow(ad.getDigitCount(e) - 1), i = new Qe(Math.floor(i.div(r).toNumber())).mul(r)) : a > 1 && (i = new Qe(Math.floor(e)));
  } else e === 0 ? i = new Qe(Math.floor((t - 1) / 2)) : n || (i = new Qe(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), s = FW(BW(function(c) {
    return i.add(new Qe(c - o).mul(r)).toNumber();
  }), _g);
  return s(0, t);
}
function PT(e, t, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new Qe(0),
      tickMin: new Qe(0),
      tickMax: new Qe(0)
    };
  var a = AT(new Qe(t).sub(e).div(n - 1), r, i), o;
  e <= 0 && t >= 0 ? o = new Qe(0) : (o = new Qe(e).add(t).div(2), o = o.sub(new Qe(o).mod(a)));
  var s = Math.ceil(o.sub(e).div(a).toNumber()), c = Math.ceil(new Qe(t).sub(o).div(a).toNumber()), l = s + c + 1;
  return l > n ? PT(e, t, n, r, i + 1) : (l < n && (c = t > 0 ? c + (n - l) : c, s = t > 0 ? s : s + (n - l)), {
    step: a,
    tickMin: o.sub(new Qe(s).mul(a)),
    tickMax: o.add(new Qe(c).mul(a))
  });
}
function JW(e) {
  var t = Os(e, 2), n = t[0], r = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(i, 2), s = ET([n, r]), c = Os(s, 2), l = c[0], d = c[1];
  if (l === -1 / 0 || d === 1 / 0) {
    var f = d === 1 / 0 ? [l].concat(Og(_g(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Og(_g(0, i - 1).map(function() {
      return -1 / 0;
    })), [d]);
    return n > r ? Sg(f) : f;
  }
  if (l === d)
    return QW(l, i, a);
  var h = PT(l, d, o, a), m = h.step, g = h.tickMin, p = h.tickMax, v = ad.rangeStep(g, p.add(new Qe(0.1).mul(m)), m);
  return n > r ? Sg(v) : v;
}
function eU(e, t) {
  var n = Os(e, 2), r = n[0], i = n[1], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = ET([r, i]), s = Os(o, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0)
    return [r, i];
  if (c === l)
    return [c];
  var d = Math.max(t, 2), f = AT(new Qe(l).sub(c).div(d - 1), a, 0), h = [].concat(Og(ad.rangeStep(new Qe(c), new Qe(l).sub(new Qe(0.99).mul(f)), f)), [l]);
  return r > i ? Sg(h) : h;
}
var tU = ST(JW), nU = ST(eU), rU = process.env.NODE_ENV === "production", Ev = "Invariant failed";
function an(e, t) {
  if (rU)
    throw new Error(Ev);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(Ev, ": ").concat(n) : Ev;
  throw new Error(r);
}
var iU = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Ha(e) {
  "@babel/helpers - typeof";
  return Ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ha(e);
}
function Ul() {
  return Ul = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ul.apply(this, arguments);
}
function aU(e, t) {
  return lU(e) || cU(e, t) || sU(e, t) || oU();
}
function oU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sU(e, t) {
  if (e) {
    if (typeof e == "string") return eO(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return eO(e, t);
  }
}
function eO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function cU(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function lU(e) {
  if (Array.isArray(e)) return e;
}
function uU(e, t) {
  if (e == null) return {};
  var n = dU(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function dU(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function fU(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hU(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, TT(r.key), r);
  }
}
function mU(e, t, n) {
  return t && hU(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vU(e, t, n) {
  return t = Hl(t), pU(e, CT() ? Reflect.construct(t, n || [], Hl(e).constructor) : t.apply(e, n));
}
function pU(e, t) {
  if (t && (Ha(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gU(e);
}
function gU(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function CT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (CT = function() {
    return !!e;
  })();
}
function Hl(e) {
  return Hl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hl(e);
}
function yU(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ag(e, t);
}
function Ag(e, t) {
  return Ag = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ag(e, t);
}
function jT(e, t, n) {
  return t = TT(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TT(e) {
  var t = bU(e, "string");
  return Ha(t) == "symbol" ? t : t + "";
}
function bU(e, t) {
  if (Ha(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ha(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var od = /* @__PURE__ */ (function(e) {
  function t() {
    return fU(this, t), vU(this, t, arguments);
  }
  return yU(t, e), mU(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, a = r.layout, o = r.width, s = r.dataKey, c = r.data, l = r.dataPointFormatter, d = r.xAxis, f = r.yAxis, h = uU(r, iU), m = Ye(h, !1);
      this.props.direction === "x" && d.type !== "number" && (process.env.NODE_ENV !== "production" ? an(!1, 'ErrorBar requires Axis type property to be "number".') : an());
      var g = c.map(function(p) {
        var v = l(p, s), y = v.x, x = v.y, w = v.value, _ = v.errorVal;
        if (!_)
          return null;
        var b = [], S, O;
        if (Array.isArray(_)) {
          var E = aU(_, 2);
          S = E[0], O = E[1];
        } else
          S = O = _;
        if (a === "vertical") {
          var P = d.scale, R = x + i, j = R + o, C = R - o, N = P(w - S), k = P(w + O);
          b.push({
            x1: k,
            y1: j,
            x2: k,
            y2: C
          }), b.push({
            x1: N,
            y1: R,
            x2: k,
            y2: R
          }), b.push({
            x1: N,
            y1: j,
            x2: N,
            y2: C
          });
        } else if (a === "horizontal") {
          var I = f.scale, $ = y + i, z = $ - o, V = $ + o, K = I(w - S), D = I(w + O);
          b.push({
            x1: z,
            y1: D,
            x2: V,
            y2: D
          }), b.push({
            x1: $,
            y1: K,
            x2: $,
            y2: D
          }), b.push({
            x1: z,
            y1: K,
            x2: V,
            y2: K
          });
        }
        return /* @__PURE__ */ T.createElement(It, Ul({
          className: "recharts-errorBar",
          key: "bar-".concat(b.map(function(U) {
            return "".concat(U.x1, "-").concat(U.x2, "-").concat(U.y1, "-").concat(U.y2);
          }))
        }, m), b.map(function(U) {
          return /* @__PURE__ */ T.createElement("line", Ul({}, U, {
            key: "line-".concat(U.x1, "-").concat(U.x2, "-").concat(U.y1, "-").concat(U.y2)
          }));
        }));
      });
      return /* @__PURE__ */ T.createElement(It, {
        className: "recharts-errorBars"
      }, g);
    }
  }]);
})(T.Component);
jT(od, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
jT(od, "displayName", "ErrorBar");
function Es(e) {
  "@babel/helpers - typeof";
  return Es = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Es(e);
}
function tO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _i(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tO(Object(n), !0).forEach(function(r) {
      xU(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xU(e, t, n) {
  return t = wU(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wU(e) {
  var t = _U(e, "string");
  return Es(t) == "symbol" ? t : t + "";
}
function _U(e, t) {
  if (Es(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Es(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var NT = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, i = t.legendWidth, a = t.legendContent, o = fn(n, Aa);
  if (!o)
    return null;
  var s = Aa.defaultProps, c = s !== void 0 ? _i(_i({}, s), o.props) : {}, l;
  return o.props && o.props.payload ? l = o.props && o.props.payload : a === "children" ? l = (r || []).reduce(function(d, f) {
    var h = f.item, m = f.props, g = m.sectors || m.data || [];
    return d.concat(g.map(function(p) {
      return {
        type: o.props.iconType || h.props.legendType,
        value: p.name,
        color: p.fill,
        payload: p
      };
    }));
  }, []) : l = (r || []).map(function(d) {
    var f = d.item, h = f.type.defaultProps, m = h !== void 0 ? _i(_i({}, h), f.props) : {}, g = m.dataKey, p = m.name, v = m.legendType, y = m.hide;
    return {
      inactive: y,
      dataKey: g,
      type: c.iconType || v || "square",
      color: Vb(f),
      value: p || g,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: m
    };
  }), _i(_i(_i({}, c), Aa.getWithHeight(o, i)), {}, {
    payload: l,
    item: o
  });
};
function As(e) {
  "@babel/helpers - typeof";
  return As = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, As(e);
}
function nO(e) {
  return AU(e) || EU(e) || OU(e) || SU();
}
function SU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OU(e, t) {
  if (e) {
    if (typeof e == "string") return Pg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Pg(e, t);
  }
}
function EU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function AU(e) {
  if (Array.isArray(e)) return Pg(e);
}
function Pg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function rO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rO(Object(n), !0).forEach(function(r) {
      Ca(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ca(e, t, n) {
  return t = PU(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PU(e) {
  var t = CU(e, "string");
  return As(t) == "symbol" ? t : t + "";
}
function CU(e, t) {
  if (As(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (As(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fr(e, t, n) {
  return Ke(e) || Ke(t) ? n : Ct(t) ? Tn(e, t, n) : Re(t) ? t(e) : n;
}
function rs(e, t, n, r) {
  var i = AW(e, function(s) {
    return fr(s, t);
  });
  if (n === "number") {
    var a = i.filter(function(s) {
      return me(s) || parseFloat(s);
    });
    return a.length ? [rd(a), nd(a)] : [1 / 0, -1 / 0];
  }
  var o = r ? i.filter(function(s) {
    return !Ke(s);
  }) : i;
  return o.map(function(s) {
    return Ct(s) || s instanceof Date ? s : "";
  });
}
var jU = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, a = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (n = r?.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (a && a.axisType === "angleAxis" && Math.abs(Math.abs(a.range[1] - a.range[0]) - 360) <= 1e-6)
    for (var c = a.range, l = 0; l < s; l++) {
      var d = l > 0 ? i[l - 1].coordinate : i[s - 1].coordinate, f = i[l].coordinate, h = l >= s - 1 ? i[0].coordinate : i[l + 1].coordinate, m = void 0;
      if (Un(f - d) !== Un(h - f)) {
        var g = [];
        if (Un(h - f) === Un(c[1] - c[0])) {
          m = h;
          var p = f + c[1] - c[0];
          g[0] = Math.min(p, (p + d) / 2), g[1] = Math.max(p, (p + d) / 2);
        } else {
          m = d;
          var v = h + c[1] - c[0];
          g[0] = Math.min(f, (v + f) / 2), g[1] = Math.max(f, (v + f) / 2);
        }
        var y = [Math.min(f, (m + f) / 2), Math.max(f, (m + f) / 2)];
        if (t > y[0] && t <= y[1] || t >= g[0] && t <= g[1]) {
          o = i[l].index;
          break;
        }
      } else {
        var x = Math.min(d, h), w = Math.max(d, h);
        if (t > (x + f) / 2 && t <= (w + f) / 2) {
          o = i[l].index;
          break;
        }
      }
    }
  else
    for (var _ = 0; _ < s; _++)
      if (_ === 0 && t <= (r[_].coordinate + r[_ + 1].coordinate) / 2 || _ > 0 && _ < s - 1 && t > (r[_].coordinate + r[_ - 1].coordinate) / 2 && t <= (r[_].coordinate + r[_ + 1].coordinate) / 2 || _ === s - 1 && t > (r[_].coordinate + r[_ - 1].coordinate) / 2) {
        o = r[_].index;
        break;
      }
  return o;
}, Vb = function(t) {
  var n, r = t, i = r.type.displayName, a = (n = t.type) !== null && n !== void 0 && n.defaultProps ? gt(gt({}, t.type.defaultProps), t.props) : t.props, o = a.stroke, s = a.fill, c;
  switch (i) {
    case "Line":
      c = o;
      break;
    case "Area":
    case "Radar":
      c = o && o !== "none" ? o : s;
      break;
    default:
      c = s;
      break;
  }
  return c;
}, TU = function(t) {
  var n = t.barSize, r = t.totalSize, i = t.stackGroups, a = i === void 0 ? {} : i;
  if (!a)
    return {};
  for (var o = {}, s = Object.keys(a), c = 0, l = s.length; c < l; c++)
    for (var d = a[s[c]].stackGroups, f = Object.keys(d), h = 0, m = f.length; h < m; h++) {
      var g = d[f[h]], p = g.items, v = g.cateAxisId, y = p.filter(function(O) {
        return Nr(O.type).indexOf("Bar") >= 0;
      });
      if (y && y.length) {
        var x = y[0].type.defaultProps, w = x !== void 0 ? gt(gt({}, x), y[0].props) : y[0].props, _ = w.barSize, b = w[v];
        o[b] || (o[b] = []);
        var S = Ke(_) ? n : _;
        o[b].push({
          item: y[0],
          stackList: y.slice(1),
          barSize: Ke(S) ? void 0 : qi(S, r, 0)
        });
      }
    }
  return o;
}, NU = function(t) {
  var n = t.barGap, r = t.barCategoryGap, i = t.bandSize, a = t.sizeList, o = a === void 0 ? [] : a, s = t.maxBarSize, c = o.length;
  if (c < 1) return null;
  var l = qi(n, i, 0, !0), d, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var h = !1, m = i / c, g = o.reduce(function(_, b) {
      return _ + b.barSize || 0;
    }, 0);
    g += (c - 1) * l, g >= i && (g -= (c - 1) * l, l = 0), g >= i && m > 0 && (h = !0, m *= 0.9, g = c * m);
    var p = (i - g) / 2 >> 0, v = {
      offset: p - l,
      size: 0
    };
    d = o.reduce(function(_, b) {
      var S = {
        item: b.item,
        position: {
          offset: v.offset + v.size + l,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: h ? m : b.barSize
        }
      }, O = [].concat(nO(_), [S]);
      return v = O[O.length - 1].position, b.stackList && b.stackList.length && b.stackList.forEach(function(E) {
        O.push({
          item: E,
          position: v
        });
      }), O;
    }, f);
  } else {
    var y = qi(r, i, 0, !0);
    i - 2 * y - (c - 1) * l <= 0 && (l = 0);
    var x = (i - 2 * y - (c - 1) * l) / c;
    x > 1 && (x >>= 0);
    var w = s === +s ? Math.min(x, s) : x;
    d = o.reduce(function(_, b, S) {
      var O = [].concat(nO(_), [{
        item: b.item,
        position: {
          offset: y + (x + l) * S + (x - w) / 2,
          size: w
        }
      }]);
      return b.stackList && b.stackList.length && b.stackList.forEach(function(E) {
        O.push({
          item: E,
          position: O[O.length - 1].position
        });
      }), O;
    }, f);
  }
  return d;
}, MU = function(t, n, r, i) {
  var a = r.children, o = r.width, s = r.margin, c = o - (s.left || 0) - (s.right || 0), l = NT({
    children: a,
    legendWidth: c
  });
  if (l) {
    var d = i || {}, f = d.width, h = d.height, m = l.align, g = l.verticalAlign, p = l.layout;
    if ((p === "vertical" || p === "horizontal" && g === "middle") && m !== "center" && me(t[m]))
      return gt(gt({}, t), {}, Ca({}, m, t[m] + (f || 0)));
    if ((p === "horizontal" || p === "vertical" && m === "center") && g !== "middle" && me(t[g]))
      return gt(gt({}, t), {}, Ca({}, g, t[g] + (h || 0)));
  }
  return t;
}, IU = function(t, n, r) {
  return Ke(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, MT = function(t, n, r, i, a) {
  var o = n.props.children, s = Kn(o, od).filter(function(l) {
    return IU(i, a, l.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(l) {
      return l.props.dataKey;
    });
    return t.reduce(function(l, d) {
      var f = fr(d, r);
      if (Ke(f)) return l;
      var h = Array.isArray(f) ? [rd(f), nd(f)] : [f, f], m = c.reduce(function(g, p) {
        var v = fr(d, p, 0), y = h[0] - Math.abs(Array.isArray(v) ? v[0] : v), x = h[1] + Math.abs(Array.isArray(v) ? v[1] : v);
        return [Math.min(y, g[0]), Math.max(x, g[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(m[0], l[0]), Math.max(m[1], l[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, DU = function(t, n, r, i, a) {
  var o = n.map(function(s) {
    return MT(t, s, r, a, i);
  }).filter(function(s) {
    return !Ke(s);
  });
  return o && o.length ? o.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, IT = function(t, n, r, i, a) {
  var o = n.map(function(c) {
    var l = c.props.dataKey;
    return r === "number" && l && MT(t, c, l, i) || rs(t, l, r, a);
  });
  if (r === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, l) {
        return [Math.min(c[0], l[0]), Math.max(c[1], l[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(c, l) {
    for (var d = 0, f = l.length; d < f; d++)
      s[l[d]] || (s[l[d]] = !0, c.push(l[d]));
    return c;
  }, []);
}, DT = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, Ii = function(t, n, r) {
  if (!t) return null;
  var i = t.scale, a = t.duplicateDomain, o = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, l = (n || r) && o === "category" && i.bandwidth ? i.bandwidth() / c : 0;
  if (l = t.axisType === "angleAxis" && s?.length >= 2 ? Un(s[0] - s[1]) * 2 * l : l, n && (t.ticks || t.niceTicks)) {
    var d = (t.ticks || t.niceTicks).map(function(f) {
      var h = a ? a.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(h) + l,
        value: f,
        offset: l
      };
    });
    return d.filter(function(f) {
      return !rc(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, h) {
    return {
      coordinate: i(f) + l,
      value: f,
      index: h,
      offset: l
    };
  }) : i.ticks && !r ? i.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: i(f) + l,
      value: f,
      offset: l
    };
  }) : i.domain().map(function(f, h) {
    return {
      coordinate: i(f) + l,
      value: a ? a[f] : f,
      index: h,
      offset: l
    };
  });
}, Av = /* @__PURE__ */ new WeakMap(), zc = function(t, n) {
  if (typeof n != "function")
    return t;
  Av.has(t) || Av.set(t, /* @__PURE__ */ new WeakMap());
  var r = Av.get(t);
  if (r.has(n))
    return r.get(n);
  var i = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, i), i;
}, kU = function(t, n, r) {
  var i = t.scale, a = t.type, o = t.layout, s = t.axisType;
  if (i === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: ys(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: Fl(),
      realScaleType: "linear"
    } : a === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: ns(),
      realScaleType: "point"
    } : a === "category" ? {
      scale: ys(),
      realScaleType: "band"
    } : {
      scale: Fl(),
      realScaleType: "linear"
    };
  if (nc(i)) {
    var c = "scale".concat(Vu(i));
    return {
      scale: (qS[c] || ns)(),
      realScaleType: qS[c] ? c : "point"
    };
  }
  return Re(i) ? {
    scale: i
  } : {
    scale: ns(),
    realScaleType: "point"
  };
}, iO = 1e-4, RU = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, i = t.range(), a = Math.min(i[0], i[1]) - iO, o = Math.max(i[0], i[1]) + iO, s = t(n[0]), c = t(n[r - 1]);
    (s < a || s > o || c < a || c > o) && t.domain([n[0], n[r - 1]]);
  }
}, LU = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, $U = function(t, n) {
  if (!n || n.length !== 2 || !me(n[0]) || !me(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]), a = [t[0], t[1]];
  return (!me(t[0]) || t[0] < r) && (a[0] = r), (!me(t[1]) || t[1] > i) && (a[1] = i), a[0] > i && (a[0] = i), a[1] < r && (a[1] = r), a;
}, BU = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var a = 0, o = 0, s = 0; s < n; ++s) {
        var c = rc(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        c >= 0 ? (t[s][r][0] = a, t[s][r][1] = a + c, a = t[s][r][1]) : (t[s][r][0] = o, t[s][r][1] = o + c, o = t[s][r][1]);
      }
}, FU = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var a = 0, o = 0; o < n; ++o) {
        var s = rc(t[o][r][1]) ? t[o][r][0] : t[o][r][1];
        s >= 0 ? (t[o][r][0] = a, t[o][r][1] = a + s, a = t[o][r][1]) : (t[o][r][0] = 0, t[o][r][1] = 0);
      }
}, zU = {
  sign: BU,
  // @ts-expect-error definitelytyped types are incorrect
  expand: SB,
  // @ts-expect-error definitelytyped types are incorrect
  none: $a,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: OB,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: EB,
  positive: FU
}, qU = function(t, n, r) {
  var i = n.map(function(s) {
    return s.props.dataKey;
  }), a = zU[r], o = _B().keys(i).value(function(s, c) {
    return +fr(s, c, 0);
  }).order(rg).offset(a);
  return o(t);
}, VU = function(t, n, r, i, a, o) {
  if (!t)
    return null;
  var s = o ? n.reverse() : n, c = {}, l = s.reduce(function(f, h) {
    var m, g = (m = h.type) !== null && m !== void 0 && m.defaultProps ? gt(gt({}, h.type.defaultProps), h.props) : h.props, p = g.stackId, v = g.hide;
    if (v)
      return f;
    var y = g[r], x = f[y] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Ct(p)) {
      var w = x.stackGroups[p] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      w.items.push(h), x.hasStack = !0, x.stackGroups[p] = w;
    } else
      x.stackGroups[qu("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [h]
      };
    return gt(gt({}, f), {}, Ca({}, y, x));
  }, c), d = {};
  return Object.keys(l).reduce(function(f, h) {
    var m = l[h];
    if (m.hasStack) {
      var g = {};
      m.stackGroups = Object.keys(m.stackGroups).reduce(function(p, v) {
        var y = m.stackGroups[v];
        return gt(gt({}, p), {}, Ca({}, v, {
          numericAxisId: r,
          cateAxisId: i,
          items: y.items,
          stackedData: qU(t, y.items, a)
        }));
      }, g);
    }
    return gt(gt({}, f), {}, Ca({}, h, m));
  }, d);
}, WU = function(t, n) {
  var r = n.realScaleType, i = n.type, a = n.tickCount, o = n.originalDomain, s = n.allowDecimals, c = r || n.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (a && i === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var l = t.domain();
    if (!l.length)
      return null;
    var d = tU(l, a, s);
    return t.domain([rd(d), nd(d)]), {
      niceTicks: d
    };
  }
  if (a && i === "number") {
    var f = t.domain(), h = nU(f, a, s);
    return {
      niceTicks: h
    };
  }
  return null;
}, aO = function(t) {
  var n = t.axis, r = t.ticks, i = t.offset, a = t.bandSize, o = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + i : null;
  var c = fr(o, n.dataKey, n.domain[s]);
  return Ke(c) ? null : n.scale(c) - a / 2 + i;
}, UU = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var i = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]);
    return i <= 0 && a >= 0 ? 0 : a < 0 ? a : i;
  }
  return r[0];
}, HU = function(t, n) {
  var r, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? gt(gt({}, t.type.defaultProps), t.props) : t.props, a = i.stackId;
  if (Ct(a)) {
    var o = n[a];
    if (o) {
      var s = o.items.indexOf(t);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, YU = function(t) {
  return t.reduce(function(n, r) {
    return [rd(r.concat([n[0]]).filter(me)), nd(r.concat([n[1]]).filter(me))];
  }, [1 / 0, -1 / 0]);
}, kT = function(t, n, r) {
  return Object.keys(t).reduce(function(i, a) {
    var o = t[a], s = o.stackedData, c = s.reduce(function(l, d) {
      var f = YU(d.slice(n, r + 1));
      return [Math.min(l[0], f[0]), Math.max(l[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], i[0]), Math.max(c[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, oO = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, sO = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Cg = function(t, n, r) {
  if (Re(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var i = [];
  if (me(t[0]))
    i[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (oO.test(t[0])) {
    var a = +oO.exec(t[0])[1];
    i[0] = n[0] - a;
  } else Re(t[0]) ? i[0] = t[0](n[0]) : i[0] = n[0];
  if (me(t[1]))
    i[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (sO.test(t[1])) {
    var o = +sO.exec(t[1])[1];
    i[1] = n[1] + o;
  } else Re(t[1]) ? i[1] = t[1](n[1]) : i[1] = n[1];
  return i;
}, Yl = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (t && n && n.length >= 2) {
    for (var a = vb(n, function(f) {
      return f.coordinate;
    }), o = 1 / 0, s = 1, c = a.length; s < c; s++) {
      var l = a[s], d = a[s - 1];
      o = Math.min((l.coordinate || 0) - (d.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return r ? void 0 : 0;
}, cO = function(t, n, r) {
  return !t || !t.length || Fb(t, Tn(r, "type.defaultProps.domain")) ? n : t;
}, RT = function(t, n) {
  var r = t.type.defaultProps ? gt(gt({}, t.type.defaultProps), t.props) : t.props, i = r.dataKey, a = r.name, o = r.unit, s = r.formatter, c = r.tooltipType, l = r.chartType, d = r.hide;
  return gt(gt({}, Ye(t, !1)), {}, {
    dataKey: i,
    unit: o,
    formatter: s,
    name: a || i,
    color: Vb(t),
    value: fr(n, i),
    type: c,
    payload: n,
    chartType: l,
    hide: d
  });
};
function Ps(e) {
  "@babel/helpers - typeof";
  return Ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ps(e);
}
function lO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lO(Object(n), !0).forEach(function(r) {
      KU(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function KU(e, t, n) {
  return t = GU(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GU(e) {
  var t = ZU(e, "string");
  return Ps(t) == "symbol" ? t : t + "";
}
function ZU(e, t) {
  if (Ps(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ps(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Kl = Math.PI / 180, XU = function(t) {
  return t * 180 / Math.PI;
}, qt = function(t, n, r, i) {
  return {
    x: t + Math.cos(-Kl * i) * r,
    y: n + Math.sin(-Kl * i) * r
  };
}, QU = function(t, n) {
  var r = t.x, i = t.y, a = n.x, o = n.y;
  return Math.sqrt(Math.pow(r - a, 2) + Math.pow(i - o, 2));
}, JU = function(t, n) {
  var r = t.x, i = t.y, a = n.cx, o = n.cy, s = QU({
    x: r,
    y: i
  }, {
    x: a,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (r - a) / s, l = Math.acos(c);
  return i > o && (l = 2 * Math.PI - l), {
    radius: s,
    angle: XU(l),
    angleInRadian: l
  };
}, e5 = function(t) {
  var n = t.startAngle, r = t.endAngle, i = Math.floor(n / 360), a = Math.floor(r / 360), o = Math.min(i, a);
  return {
    startAngle: n - o * 360,
    endAngle: r - o * 360
  };
}, t5 = function(t, n) {
  var r = n.startAngle, i = n.endAngle, a = Math.floor(r / 360), o = Math.floor(i / 360), s = Math.min(a, o);
  return t + s * 360;
}, dO = function(t, n) {
  var r = t.x, i = t.y, a = JU({
    x: r,
    y: i
  }, n), o = a.radius, s = a.angle, c = n.innerRadius, l = n.outerRadius;
  if (o < c || o > l)
    return !1;
  if (o === 0)
    return !0;
  var d = e5(n), f = d.startAngle, h = d.endAngle, m = s, g;
  if (f <= h) {
    for (; m > h; )
      m -= 360;
    for (; m < f; )
      m += 360;
    g = m >= f && m <= h;
  } else {
    for (; m > f; )
      m -= 360;
    for (; m < h; )
      m += 360;
    g = m >= h && m <= f;
  }
  return g ? uO(uO({}, n), {}, {
    radius: o,
    angle: t5(m, n)
  }) : null;
};
function Cs(e) {
  "@babel/helpers - typeof";
  return Cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cs(e);
}
var n5 = ["offset"];
function r5(e) {
  return s5(e) || o5(e) || a5(e) || i5();
}
function i5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function a5(e, t) {
  if (e) {
    if (typeof e == "string") return jg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jg(e, t);
  }
}
function o5(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function s5(e) {
  if (Array.isArray(e)) return jg(e);
}
function jg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function c5(e, t) {
  if (e == null) return {};
  var n = l5(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function l5(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function fO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fO(Object(n), !0).forEach(function(r) {
      u5(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u5(e, t, n) {
  return t = d5(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function d5(e) {
  var t = f5(e, "string");
  return Cs(t) == "symbol" ? t : t + "";
}
function f5(e, t) {
  if (Cs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Cs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function js() {
  return js = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, js.apply(this, arguments);
}
var h5 = function(t) {
  var n = t.value, r = t.formatter, i = Ke(t.children) ? n : t.children;
  return Re(r) ? r(i) : i;
}, m5 = function(t, n) {
  var r = Un(n - t), i = Math.min(Math.abs(n - t), 360);
  return r * i;
}, v5 = function(t, n, r) {
  var i = t.position, a = t.viewBox, o = t.offset, s = t.className, c = a, l = c.cx, d = c.cy, f = c.innerRadius, h = c.outerRadius, m = c.startAngle, g = c.endAngle, p = c.clockWise, v = (f + h) / 2, y = m5(m, g), x = y >= 0 ? 1 : -1, w, _;
  i === "insideStart" ? (w = m + x * o, _ = p) : i === "insideEnd" ? (w = g - x * o, _ = !p) : i === "end" && (w = g + x * o, _ = p), _ = y <= 0 ? _ : !_;
  var b = qt(l, d, v, w), S = qt(l, d, v, w + (_ ? 1 : -1) * 359), O = "M".concat(b.x, ",").concat(b.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(_ ? 0 : 1, `,
    `).concat(S.x, ",").concat(S.y), E = Ke(t.id) ? qu("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ T.createElement("text", js({}, r, {
    dominantBaseline: "central",
    className: Fe("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ T.createElement("defs", null, /* @__PURE__ */ T.createElement("path", {
    id: E,
    d: O
  })), /* @__PURE__ */ T.createElement("textPath", {
    xlinkHref: "#".concat(E)
  }, n));
}, p5 = function(t) {
  var n = t.viewBox, r = t.offset, i = t.position, a = n, o = a.cx, s = a.cy, c = a.innerRadius, l = a.outerRadius, d = a.startAngle, f = a.endAngle, h = (d + f) / 2;
  if (i === "outside") {
    var m = qt(o, s, l + r, h), g = m.x, p = m.y;
    return {
      x: g,
      y: p,
      textAnchor: g >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var v = (c + l) / 2, y = qt(o, s, v, h), x = y.x, w = y.y;
  return {
    x,
    y: w,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, g5 = function(t) {
  var n = t.viewBox, r = t.parentViewBox, i = t.offset, a = t.position, o = n, s = o.x, c = o.y, l = o.width, d = o.height, f = d >= 0 ? 1 : -1, h = f * i, m = f > 0 ? "end" : "start", g = f > 0 ? "start" : "end", p = l >= 0 ? 1 : -1, v = p * i, y = p > 0 ? "end" : "start", x = p > 0 ? "start" : "end";
  if (a === "top") {
    var w = {
      x: s + l / 2,
      y: c - f * i,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Pt(Pt({}, w), r ? {
      height: Math.max(c - r.y, 0),
      width: l
    } : {});
  }
  if (a === "bottom") {
    var _ = {
      x: s + l / 2,
      y: c + d + h,
      textAnchor: "middle",
      verticalAnchor: g
    };
    return Pt(Pt({}, _), r ? {
      height: Math.max(r.y + r.height - (c + d), 0),
      width: l
    } : {});
  }
  if (a === "left") {
    var b = {
      x: s - v,
      y: c + d / 2,
      textAnchor: y,
      verticalAnchor: "middle"
    };
    return Pt(Pt({}, b), r ? {
      width: Math.max(b.x - r.x, 0),
      height: d
    } : {});
  }
  if (a === "right") {
    var S = {
      x: s + l + v,
      y: c + d / 2,
      textAnchor: x,
      verticalAnchor: "middle"
    };
    return Pt(Pt({}, S), r ? {
      width: Math.max(r.x + r.width - S.x, 0),
      height: d
    } : {});
  }
  var O = r ? {
    width: l,
    height: d
  } : {};
  return a === "insideLeft" ? Pt({
    x: s + v,
    y: c + d / 2,
    textAnchor: x,
    verticalAnchor: "middle"
  }, O) : a === "insideRight" ? Pt({
    x: s + l - v,
    y: c + d / 2,
    textAnchor: y,
    verticalAnchor: "middle"
  }, O) : a === "insideTop" ? Pt({
    x: s + l / 2,
    y: c + h,
    textAnchor: "middle",
    verticalAnchor: g
  }, O) : a === "insideBottom" ? Pt({
    x: s + l / 2,
    y: c + d - h,
    textAnchor: "middle",
    verticalAnchor: m
  }, O) : a === "insideTopLeft" ? Pt({
    x: s + v,
    y: c + h,
    textAnchor: x,
    verticalAnchor: g
  }, O) : a === "insideTopRight" ? Pt({
    x: s + l - v,
    y: c + h,
    textAnchor: y,
    verticalAnchor: g
  }, O) : a === "insideBottomLeft" ? Pt({
    x: s + v,
    y: c + d - h,
    textAnchor: x,
    verticalAnchor: m
  }, O) : a === "insideBottomRight" ? Pt({
    x: s + l - v,
    y: c + d - h,
    textAnchor: y,
    verticalAnchor: m
  }, O) : yo(a) && (me(a.x) || Ti(a.x)) && (me(a.y) || Ti(a.y)) ? Pt({
    x: s + qi(a.x, l),
    y: c + qi(a.y, d),
    textAnchor: "end",
    verticalAnchor: "end"
  }, O) : Pt({
    x: s + l / 2,
    y: c + d / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, O);
}, y5 = function(t) {
  return "cx" in t && me(t.cx);
};
function Kt(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = c5(e, n5), i = Pt({
    offset: n
  }, r), a = i.viewBox, o = i.position, s = i.value, c = i.children, l = i.content, d = i.className, f = d === void 0 ? "" : d, h = i.textBreakAll;
  if (!a || Ke(s) && Ke(c) && !/* @__PURE__ */ Yn(l) && !Re(l))
    return null;
  if (/* @__PURE__ */ Yn(l))
    return /* @__PURE__ */ _t(l, i);
  var m;
  if (Re(l)) {
    if (m = /* @__PURE__ */ Yy(l, i), /* @__PURE__ */ Yn(m))
      return m;
  } else
    m = h5(i);
  var g = y5(a), p = Ye(i, !0);
  if (g && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return v5(i, m, p);
  var v = g ? p5(i) : g5(i);
  return /* @__PURE__ */ T.createElement(Ml, js({
    className: Fe("recharts-label", f)
  }, p, v, {
    breakAll: h
  }), m);
}
Kt.displayName = "Label";
var LT = function(t) {
  var n = t.cx, r = t.cy, i = t.angle, a = t.startAngle, o = t.endAngle, s = t.r, c = t.radius, l = t.innerRadius, d = t.outerRadius, f = t.x, h = t.y, m = t.top, g = t.left, p = t.width, v = t.height, y = t.clockWise, x = t.labelViewBox;
  if (x)
    return x;
  if (me(p) && me(v)) {
    if (me(f) && me(h))
      return {
        x: f,
        y: h,
        width: p,
        height: v
      };
    if (me(m) && me(g))
      return {
        x: m,
        y: g,
        width: p,
        height: v
      };
  }
  return me(f) && me(h) ? {
    x: f,
    y: h,
    width: 0,
    height: 0
  } : me(n) && me(r) ? {
    cx: n,
    cy: r,
    startAngle: a || i || 0,
    endAngle: o || i || 0,
    innerRadius: l || 0,
    outerRadius: d || c || s || 0,
    clockWise: y
  } : t.viewBox ? t.viewBox : {};
}, b5 = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ T.createElement(Kt, {
    key: "label-implicit",
    viewBox: n
  }) : Ct(t) ? /* @__PURE__ */ T.createElement(Kt, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ Yn(t) ? t.type === Kt ? /* @__PURE__ */ _t(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ T.createElement(Kt, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : Re(t) ? /* @__PURE__ */ T.createElement(Kt, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : yo(t) ? /* @__PURE__ */ T.createElement(Kt, js({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, x5 = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var i = t.children, a = LT(t), o = Kn(i, Kt).map(function(c, l) {
    return /* @__PURE__ */ _t(c, {
      viewBox: n || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(l)
    });
  });
  if (!r)
    return o;
  var s = b5(t.label, n || a);
  return [s].concat(r5(o));
};
Kt.parseViewBox = LT;
Kt.renderCallByParent = x5;
var Pv, hO;
function w5() {
  if (hO) return Pv;
  hO = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return Pv = e, Pv;
}
var _5 = w5();
const S5 = /* @__PURE__ */ ct(_5);
function Ts(e) {
  "@babel/helpers - typeof";
  return Ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ts(e);
}
var O5 = ["valueAccessor"], E5 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function A5(e) {
  return T5(e) || j5(e) || C5(e) || P5();
}
function P5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C5(e, t) {
  if (e) {
    if (typeof e == "string") return Tg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Tg(e, t);
  }
}
function j5(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function T5(e) {
  if (Array.isArray(e)) return Tg(e);
}
function Tg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Gl() {
  return Gl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gl.apply(this, arguments);
}
function mO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mO(Object(n), !0).forEach(function(r) {
      N5(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function N5(e, t, n) {
  return t = M5(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function M5(e) {
  var t = I5(e, "string");
  return Ts(t) == "symbol" ? t : t + "";
}
function I5(e, t) {
  if (Ts(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ts(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pO(e, t) {
  if (e == null) return {};
  var n = D5(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function D5(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var k5 = function(t) {
  return Array.isArray(t.value) ? S5(t.value) : t.value;
};
function Fi(e) {
  var t = e.valueAccessor, n = t === void 0 ? k5 : t, r = pO(e, O5), i = r.data, a = r.dataKey, o = r.clockWise, s = r.id, c = r.textBreakAll, l = pO(r, E5);
  return !i || !i.length ? null : /* @__PURE__ */ T.createElement(It, {
    className: "recharts-label-list"
  }, i.map(function(d, f) {
    var h = Ke(a) ? n(d, f) : fr(d && d.payload, a), m = Ke(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ T.createElement(Kt, Gl({}, Ye(d, !0), l, m, {
      parentViewBox: d.parentViewBox,
      value: h,
      textBreakAll: c,
      viewBox: Kt.parseViewBox(Ke(o) ? d : vO(vO({}, d), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Fi.displayName = "LabelList";
function R5(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ T.createElement(Fi, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ T.isValidElement(e) || Re(e) ? /* @__PURE__ */ T.createElement(Fi, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : yo(e) ? /* @__PURE__ */ T.createElement(Fi, Gl({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function L5(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, i = Kn(r, Fi).map(function(o, s) {
    return /* @__PURE__ */ _t(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return i;
  var a = R5(e.label, t);
  return [a].concat(A5(i));
}
Fi.renderCallByParent = L5;
function Ns(e) {
  "@babel/helpers - typeof";
  return Ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ns(e);
}
function Ng() {
  return Ng = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ng.apply(this, arguments);
}
function gO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gO(Object(n), !0).forEach(function(r) {
      $5(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $5(e, t, n) {
  return t = B5(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function B5(e) {
  var t = F5(e, "string");
  return Ns(t) == "symbol" ? t : t + "";
}
function F5(e, t) {
  if (Ns(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ns(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var z5 = function(t, n) {
  var r = Un(n - t), i = Math.min(Math.abs(n - t), 359.999);
  return r * i;
}, qc = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, a = t.angle, o = t.sign, s = t.isExternal, c = t.cornerRadius, l = t.cornerIsExternal, d = c * (s ? 1 : -1) + i, f = Math.asin(c / d) / Kl, h = l ? a : a + o * f, m = qt(n, r, d, h), g = qt(n, r, i, h), p = l ? a - o * f : a, v = qt(n, r, d * Math.cos(f * Kl), p);
  return {
    center: m,
    circleTangency: g,
    lineTangency: v,
    theta: f
  };
}, $T = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.startAngle, s = t.endAngle, c = z5(o, s), l = o + c, d = qt(n, r, a, o), f = qt(n, r, a, l), h = "M ".concat(d.x, ",").concat(d.y, `
    A `).concat(a, ",").concat(a, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(o > l), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (i > 0) {
    var m = qt(n, r, i, o), g = qt(n, r, i, l);
    h += "L ".concat(g.x, ",").concat(g.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(o <= l), `,
            `).concat(m.x, ",").concat(m.y, " Z");
  } else
    h += "L ".concat(n, ",").concat(r, " Z");
  return h;
}, q5 = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, l = t.startAngle, d = t.endAngle, f = Un(d - l), h = qc({
    cx: n,
    cy: r,
    radius: a,
    angle: l,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: c
  }), m = h.circleTangency, g = h.lineTangency, p = h.theta, v = qc({
    cx: n,
    cy: r,
    radius: a,
    angle: d,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: c
  }), y = v.circleTangency, x = v.lineTangency, w = v.theta, _ = c ? Math.abs(l - d) : Math.abs(l - d) - p - w;
  if (_ < 0)
    return s ? "M ".concat(g.x, ",").concat(g.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : $T({
      cx: n,
      cy: r,
      innerRadius: i,
      outerRadius: a,
      startAngle: l,
      endAngle: d
    });
  var b = "M ".concat(g.x, ",").concat(g.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(m.x, ",").concat(m.y, `
    A`).concat(a, ",").concat(a, ",0,").concat(+(_ > 180), ",").concat(+(f < 0), ",").concat(y.x, ",").concat(y.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(x.x, ",").concat(x.y, `
  `);
  if (i > 0) {
    var S = qc({
      cx: n,
      cy: r,
      radius: i,
      angle: l,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), O = S.circleTangency, E = S.lineTangency, P = S.theta, R = qc({
      cx: n,
      cy: r,
      radius: i,
      angle: d,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: c
    }), j = R.circleTangency, C = R.lineTangency, N = R.theta, k = c ? Math.abs(l - d) : Math.abs(l - d) - P - N;
    if (k < 0 && o === 0)
      return "".concat(b, "L").concat(n, ",").concat(r, "Z");
    b += "L".concat(C.x, ",").concat(C.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(j.x, ",").concat(j.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(k > 180), ",").concat(+(f > 0), ",").concat(O.x, ",").concat(O.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(E.x, ",").concat(E.y, "Z");
  } else
    b += "L".concat(n, ",").concat(r, "Z");
  return b;
}, V5 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, BT = function(t) {
  var n = yO(yO({}, V5), t), r = n.cx, i = n.cy, a = n.innerRadius, o = n.outerRadius, s = n.cornerRadius, c = n.forceCornerRadius, l = n.cornerIsExternal, d = n.startAngle, f = n.endAngle, h = n.className;
  if (o < a || d === f)
    return null;
  var m = Fe("recharts-sector", h), g = o - a, p = qi(s, g, 0, !0), v;
  return p > 0 && Math.abs(d - f) < 360 ? v = q5({
    cx: r,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    cornerRadius: Math.min(p, g / 2),
    forceCornerRadius: c,
    cornerIsExternal: l,
    startAngle: d,
    endAngle: f
  }) : v = $T({
    cx: r,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    startAngle: d,
    endAngle: f
  }), /* @__PURE__ */ T.createElement("path", Ng({}, Ye(n, !0), {
    className: m,
    d: v,
    role: "img"
  }));
};
function Ms(e) {
  "@babel/helpers - typeof";
  return Ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ms(e);
}
function Mg() {
  return Mg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mg.apply(this, arguments);
}
function bO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bO(Object(n), !0).forEach(function(r) {
      W5(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function W5(e, t, n) {
  return t = U5(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function U5(e) {
  var t = H5(e, "string");
  return Ms(t) == "symbol" ? t : t + "";
}
function H5(e, t) {
  if (Ms(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ms(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wO = {
  curveBasisClosed: dB,
  curveBasisOpen: fB,
  curveBasis: uB,
  curveBumpX: Z$,
  curveBumpY: X$,
  curveLinearClosed: hB,
  curveLinear: Uu,
  curveMonotoneX: mB,
  curveMonotoneY: vB,
  curveNatural: pB,
  curveStep: gB,
  curveStepAfter: bB,
  curveStepBefore: yB
}, Vc = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Lo = function(t) {
  return t.x;
}, $o = function(t) {
  return t.y;
}, Y5 = function(t, n) {
  if (Re(t))
    return t;
  var r = "curve".concat(Vu(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? wO["".concat(r).concat(n === "vertical" ? "Y" : "X")] : wO[r] || Uu;
}, K5 = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, i = t.points, a = i === void 0 ? [] : i, o = t.baseLine, s = t.layout, c = t.connectNulls, l = c === void 0 ? !1 : c, d = Y5(r, s), f = l ? a.filter(function(p) {
    return Vc(p);
  }) : a, h;
  if (Array.isArray(o)) {
    var m = l ? o.filter(function(p) {
      return Vc(p);
    }) : o, g = f.map(function(p, v) {
      return xO(xO({}, p), {}, {
        base: m[v]
      });
    });
    return s === "vertical" ? h = Dc().y($o).x1(Lo).x0(function(p) {
      return p.base.x;
    }) : h = Dc().x(Lo).y1($o).y0(function(p) {
      return p.base.y;
    }), h.defined(Vc).curve(d), h(g);
  }
  return s === "vertical" && me(o) ? h = Dc().y($o).x1(Lo).x0(o) : me(o) ? h = Dc().x(Lo).y1($o).y0(o) : h = HC().x(Lo).y($o), h.defined(Vc).curve(d), h(f);
}, _O = function(t) {
  var n = t.className, r = t.points, i = t.path, a = t.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var o = r && r.length ? K5(t) : i;
  return /* @__PURE__ */ T.createElement("path", Mg({}, Ye(t, !1), xl(t), {
    className: Fe("recharts-curve", n),
    d: o,
    ref: a
  }));
}, Wc = { exports: {} }, Uc = { exports: {} }, Ve = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SO;
function G5() {
  if (SO) return Ve;
  SO = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var S = b.$$typeof;
      switch (S) {
        case t:
          switch (b = b.type, b) {
            case c:
            case l:
            case r:
            case a:
            case i:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case d:
                case g:
                case m:
                case o:
                  return b;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function _(b) {
    return w(b) === l;
  }
  return Ve.AsyncMode = c, Ve.ConcurrentMode = l, Ve.ContextConsumer = s, Ve.ContextProvider = o, Ve.Element = t, Ve.ForwardRef = d, Ve.Fragment = r, Ve.Lazy = g, Ve.Memo = m, Ve.Portal = n, Ve.Profiler = a, Ve.StrictMode = i, Ve.Suspense = f, Ve.isAsyncMode = function(b) {
    return _(b) || w(b) === c;
  }, Ve.isConcurrentMode = _, Ve.isContextConsumer = function(b) {
    return w(b) === s;
  }, Ve.isContextProvider = function(b) {
    return w(b) === o;
  }, Ve.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Ve.isForwardRef = function(b) {
    return w(b) === d;
  }, Ve.isFragment = function(b) {
    return w(b) === r;
  }, Ve.isLazy = function(b) {
    return w(b) === g;
  }, Ve.isMemo = function(b) {
    return w(b) === m;
  }, Ve.isPortal = function(b) {
    return w(b) === n;
  }, Ve.isProfiler = function(b) {
    return w(b) === a;
  }, Ve.isStrictMode = function(b) {
    return w(b) === i;
  }, Ve.isSuspense = function(b) {
    return w(b) === f;
  }, Ve.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === l || b === a || b === i || b === f || b === h || typeof b == "object" && b !== null && (b.$$typeof === g || b.$$typeof === m || b.$$typeof === o || b.$$typeof === s || b.$$typeof === d || b.$$typeof === v || b.$$typeof === y || b.$$typeof === x || b.$$typeof === p);
  }, Ve.typeOf = w, Ve;
}
var We = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OO;
function Z5() {
  return OO || (OO = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function w(F) {
      return typeof F == "string" || typeof F == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      F === r || F === l || F === a || F === i || F === f || F === h || typeof F == "object" && F !== null && (F.$$typeof === g || F.$$typeof === m || F.$$typeof === o || F.$$typeof === s || F.$$typeof === d || F.$$typeof === v || F.$$typeof === y || F.$$typeof === x || F.$$typeof === p);
    }
    function _(F) {
      if (typeof F == "object" && F !== null) {
        var ye = F.$$typeof;
        switch (ye) {
          case t:
            var te = F.type;
            switch (te) {
              case c:
              case l:
              case r:
              case a:
              case i:
              case f:
                return te;
              default:
                var Ne = te && te.$$typeof;
                switch (Ne) {
                  case s:
                  case d:
                  case g:
                  case m:
                  case o:
                    return Ne;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var b = c, S = l, O = s, E = o, P = t, R = d, j = r, C = g, N = m, k = n, I = a, $ = i, z = f, V = !1;
    function K(F) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(F) || _(F) === c;
    }
    function D(F) {
      return _(F) === l;
    }
    function U(F) {
      return _(F) === s;
    }
    function Y(F) {
      return _(F) === o;
    }
    function X(F) {
      return typeof F == "object" && F !== null && F.$$typeof === t;
    }
    function oe(F) {
      return _(F) === d;
    }
    function ie(F) {
      return _(F) === r;
    }
    function he(F) {
      return _(F) === g;
    }
    function ee(F) {
      return _(F) === m;
    }
    function se(F) {
      return _(F) === n;
    }
    function G(F) {
      return _(F) === a;
    }
    function Q(F) {
      return _(F) === i;
    }
    function ce(F) {
      return _(F) === f;
    }
    We.AsyncMode = b, We.ConcurrentMode = S, We.ContextConsumer = O, We.ContextProvider = E, We.Element = P, We.ForwardRef = R, We.Fragment = j, We.Lazy = C, We.Memo = N, We.Portal = k, We.Profiler = I, We.StrictMode = $, We.Suspense = z, We.isAsyncMode = K, We.isConcurrentMode = D, We.isContextConsumer = U, We.isContextProvider = Y, We.isElement = X, We.isForwardRef = oe, We.isFragment = ie, We.isLazy = he, We.isMemo = ee, We.isPortal = se, We.isProfiler = G, We.isStrictMode = Q, We.isSuspense = ce, We.isValidElementType = w, We.typeOf = _;
  })()), We;
}
var EO;
function FT() {
  return EO || (EO = 1, process.env.NODE_ENV === "production" ? Uc.exports = G5() : Uc.exports = Z5()), Uc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Cv, AO;
function X5() {
  if (AO) return Cv;
  AO = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Cv = i() ? Object.assign : function(a, o) {
    for (var s, c = r(a), l, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var h = 0; h < l.length; h++)
          n.call(s, l[h]) && (c[l[h]] = s[l[h]]);
      }
    }
    return c;
  }, Cv;
}
var jv, PO;
function Wb() {
  if (PO) return jv;
  PO = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return jv = e, jv;
}
var Tv, CO;
function zT() {
  return CO || (CO = 1, Tv = Function.call.bind(Object.prototype.hasOwnProperty)), Tv;
}
var Nv, jO;
function Q5() {
  if (jO) return Nv;
  jO = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Wb(), n = {}, r = /* @__PURE__ */ zT();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var h = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = a[d](o, d, c, s, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Nv = i, Nv;
}
var Mv, TO;
function J5() {
  if (TO) return Mv;
  TO = 1;
  var e = FT(), t = X5(), n = /* @__PURE__ */ Wb(), r = /* @__PURE__ */ zT(), i = /* @__PURE__ */ Q5(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Mv = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(D) {
      var U = D && (l && D[l] || D[d]);
      if (typeof U == "function")
        return U;
    }
    var h = "<<anonymous>>", m = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: x(),
      arrayOf: w,
      element: _(),
      elementType: b(),
      instanceOf: S,
      node: R(),
      objectOf: E,
      oneOf: O,
      oneOfType: P,
      shape: C,
      exact: N
    };
    function g(D, U) {
      return D === U ? D !== 0 || 1 / D === 1 / U : D !== D && U !== U;
    }
    function p(D, U) {
      this.message = D, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v(D) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, Y = 0;
      function X(ie, he, ee, se, G, Q, ce) {
        if (se = se || h, Q = Q || ee, ce !== n) {
          if (c) {
            var F = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw F.name = "Invariant Violation", F;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = se + ":" + ee;
            !U[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[ye] = !0, Y++);
          }
        }
        return he[ee] == null ? ie ? he[ee] === null ? new p("The " + G + " `" + Q + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new p("The " + G + " `" + Q + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : D(he, ee, se, G, Q);
      }
      var oe = X.bind(null, !1);
      return oe.isRequired = X.bind(null, !0), oe;
    }
    function y(D) {
      function U(Y, X, oe, ie, he, ee) {
        var se = Y[X], G = $(se);
        if (G !== D) {
          var Q = z(se);
          return new p(
            "Invalid " + ie + " `" + he + "` of type " + ("`" + Q + "` supplied to `" + oe + "`, expected ") + ("`" + D + "`."),
            { expectedType: D }
          );
        }
        return null;
      }
      return v(U);
    }
    function x() {
      return v(o);
    }
    function w(D) {
      function U(Y, X, oe, ie, he) {
        if (typeof D != "function")
          return new p("Property `" + he + "` of component `" + oe + "` has invalid PropType notation inside arrayOf.");
        var ee = Y[X];
        if (!Array.isArray(ee)) {
          var se = $(ee);
          return new p("Invalid " + ie + " `" + he + "` of type " + ("`" + se + "` supplied to `" + oe + "`, expected an array."));
        }
        for (var G = 0; G < ee.length; G++) {
          var Q = D(ee, G, oe, ie, he + "[" + G + "]", n);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return v(U);
    }
    function _() {
      function D(U, Y, X, oe, ie) {
        var he = U[Y];
        if (!s(he)) {
          var ee = $(he);
          return new p("Invalid " + oe + " `" + ie + "` of type " + ("`" + ee + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(D);
    }
    function b() {
      function D(U, Y, X, oe, ie) {
        var he = U[Y];
        if (!e.isValidElementType(he)) {
          var ee = $(he);
          return new p("Invalid " + oe + " `" + ie + "` of type " + ("`" + ee + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(D);
    }
    function S(D) {
      function U(Y, X, oe, ie, he) {
        if (!(Y[X] instanceof D)) {
          var ee = D.name || h, se = K(Y[X]);
          return new p("Invalid " + ie + " `" + he + "` of type " + ("`" + se + "` supplied to `" + oe + "`, expected ") + ("instance of `" + ee + "`."));
        }
        return null;
      }
      return v(U);
    }
    function O(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function U(Y, X, oe, ie, he) {
        for (var ee = Y[X], se = 0; se < D.length; se++)
          if (g(ee, D[se]))
            return null;
        var G = JSON.stringify(D, function(ce, F) {
          var ye = z(F);
          return ye === "symbol" ? String(F) : F;
        });
        return new p("Invalid " + ie + " `" + he + "` of value `" + String(ee) + "` " + ("supplied to `" + oe + "`, expected one of " + G + "."));
      }
      return v(U);
    }
    function E(D) {
      function U(Y, X, oe, ie, he) {
        if (typeof D != "function")
          return new p("Property `" + he + "` of component `" + oe + "` has invalid PropType notation inside objectOf.");
        var ee = Y[X], se = $(ee);
        if (se !== "object")
          return new p("Invalid " + ie + " `" + he + "` of type " + ("`" + se + "` supplied to `" + oe + "`, expected an object."));
        for (var G in ee)
          if (r(ee, G)) {
            var Q = D(ee, G, oe, ie, he + "." + G, n);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return v(U);
    }
    function P(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var U = 0; U < D.length; U++) {
        var Y = D[U];
        if (typeof Y != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(Y) + " at index " + U + "."
          ), o;
      }
      function X(oe, ie, he, ee, se) {
        for (var G = [], Q = 0; Q < D.length; Q++) {
          var ce = D[Q], F = ce(oe, ie, he, ee, se, n);
          if (F == null)
            return null;
          F.data && r(F.data, "expectedType") && G.push(F.data.expectedType);
        }
        var ye = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new p("Invalid " + ee + " `" + se + "` supplied to " + ("`" + he + "`" + ye + "."));
      }
      return v(X);
    }
    function R() {
      function D(U, Y, X, oe, ie) {
        return k(U[Y]) ? null : new p("Invalid " + oe + " `" + ie + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return v(D);
    }
    function j(D, U, Y, X, oe) {
      return new p(
        (D || "React class") + ": " + U + " type `" + Y + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + oe + "`."
      );
    }
    function C(D) {
      function U(Y, X, oe, ie, he) {
        var ee = Y[X], se = $(ee);
        if (se !== "object")
          return new p("Invalid " + ie + " `" + he + "` of type `" + se + "` " + ("supplied to `" + oe + "`, expected `object`."));
        for (var G in D) {
          var Q = D[G];
          if (typeof Q != "function")
            return j(oe, ie, he, G, z(Q));
          var ce = Q(ee, G, oe, ie, he + "." + G, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return v(U);
    }
    function N(D) {
      function U(Y, X, oe, ie, he) {
        var ee = Y[X], se = $(ee);
        if (se !== "object")
          return new p("Invalid " + ie + " `" + he + "` of type `" + se + "` " + ("supplied to `" + oe + "`, expected `object`."));
        var G = t({}, Y[X], D);
        for (var Q in G) {
          var ce = D[Q];
          if (r(D, Q) && typeof ce != "function")
            return j(oe, ie, he, Q, z(ce));
          if (!ce)
            return new p(
              "Invalid " + ie + " `" + he + "` key `" + Q + "` supplied to `" + oe + "`.\nBad object: " + JSON.stringify(Y[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
            );
          var F = ce(ee, Q, oe, ie, he + "." + Q, n);
          if (F)
            return F;
        }
        return null;
      }
      return v(U);
    }
    function k(D) {
      switch (typeof D) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !D;
        case "object":
          if (Array.isArray(D))
            return D.every(k);
          if (D === null || s(D))
            return !0;
          var U = f(D);
          if (U) {
            var Y = U.call(D), X;
            if (U !== D.entries) {
              for (; !(X = Y.next()).done; )
                if (!k(X.value))
                  return !1;
            } else
              for (; !(X = Y.next()).done; ) {
                var oe = X.value;
                if (oe && !k(oe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(D, U) {
      return D === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function $(D) {
      var U = typeof D;
      return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : I(U, D) ? "symbol" : U;
    }
    function z(D) {
      if (typeof D > "u" || D === null)
        return "" + D;
      var U = $(D);
      if (U === "object") {
        if (D instanceof Date)
          return "date";
        if (D instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function V(D) {
      var U = z(D);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function K(D) {
      return !D.constructor || !D.constructor.name ? h : D.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, Mv;
}
var Iv, NO;
function e3() {
  if (NO) return Iv;
  NO = 1;
  var e = /* @__PURE__ */ Wb();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Iv = function() {
    function r(o, s, c, l, d, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Iv;
}
var MO;
function t3() {
  if (MO) return Wc.exports;
  if (MO = 1, process.env.NODE_ENV !== "production") {
    var e = FT(), t = !0;
    Wc.exports = /* @__PURE__ */ J5()(e.isElement, t);
  } else
    Wc.exports = /* @__PURE__ */ e3()();
  return Wc.exports;
}
var n3 = /* @__PURE__ */ t3();
const Ue = /* @__PURE__ */ ct(n3), { getOwnPropertyNames: r3, getOwnPropertySymbols: i3 } = Object, { hasOwnProperty: a3 } = Object.prototype;
function Dv(e, t) {
  return function(r, i, a) {
    return e(r, i, a) && t(r, i, a);
  };
}
function Hc(e) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, i);
    const { cache: a } = i, o = a.get(n), s = a.get(r);
    if (o && s)
      return o === r && s === n;
    a.set(n, r), a.set(r, n);
    const c = e(n, r, i);
    return a.delete(n), a.delete(r), c;
  };
}
function o3(e) {
  return e?.[Symbol.toStringTag];
}
function IO(e) {
  return r3(e).concat(i3(e));
}
const s3 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((e, t) => a3.call(e, t))
);
function oa(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
const c3 = "__v", l3 = "__o", u3 = "_owner", { getOwnPropertyDescriptor: DO, keys: kO } = Object;
function d3(e, t) {
  return e.byteLength === t.byteLength && Zl(new Uint8Array(e), new Uint8Array(t));
}
function f3(e, t, n) {
  let r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function h3(e, t) {
  return e.byteLength === t.byteLength && Zl(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function m3(e, t) {
  return oa(e.getTime(), t.getTime());
}
function v3(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function p3(e, t) {
  return e === t;
}
function RO(e, t, n) {
  const r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  const i = new Array(r), a = e.entries();
  let o, s, c = 0;
  for (; (o = a.next()) && !o.done; ) {
    const l = t.entries();
    let d = !1, f = 0;
    for (; (s = l.next()) && !s.done; ) {
      if (i[f]) {
        f++;
        continue;
      }
      const h = o.value, m = s.value;
      if (n.equals(h[0], m[0], c, f, e, t, n) && n.equals(h[1], m[1], h[0], m[0], e, t, n)) {
        d = i[f] = !0;
        break;
      }
      f++;
    }
    if (!d)
      return !1;
    c++;
  }
  return !0;
}
const g3 = oa;
function y3(e, t, n) {
  const r = kO(e);
  let i = r.length;
  if (kO(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!qT(e, t, n, r[i]))
      return !1;
  return !0;
}
function Bo(e, t, n) {
  const r = IO(e);
  let i = r.length;
  if (IO(t).length !== i)
    return !1;
  let a, o, s;
  for (; i-- > 0; )
    if (a = r[i], !qT(e, t, n, a) || (o = DO(e, a), s = DO(t, a), (o || s) && (!o || !s || o.configurable !== s.configurable || o.enumerable !== s.enumerable || o.writable !== s.writable)))
      return !1;
  return !0;
}
function b3(e, t) {
  return oa(e.valueOf(), t.valueOf());
}
function x3(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function LO(e, t, n) {
  const r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  const i = new Array(r), a = e.values();
  let o, s;
  for (; (o = a.next()) && !o.done; ) {
    const c = t.values();
    let l = !1, d = 0;
    for (; (s = c.next()) && !s.done; ) {
      if (!i[d] && n.equals(o.value, s.value, o.value, s.value, e, t, n)) {
        l = i[d] = !0;
        break;
      }
      d++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function Zl(e, t) {
  let n = e.byteLength;
  if (t.byteLength !== n || e.byteOffset !== t.byteOffset)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function w3(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function qT(e, t, n, r) {
  return (r === u3 || r === l3 || r === c3) && (e.$$typeof || t.$$typeof) ? !0 : s3(t, r) && n.equals(e[r], t[r], r, r, e, t, n);
}
const _3 = "[object ArrayBuffer]", S3 = "[object Arguments]", O3 = "[object Boolean]", E3 = "[object DataView]", A3 = "[object Date]", P3 = "[object Error]", C3 = "[object Map]", j3 = "[object Number]", T3 = "[object Object]", N3 = "[object RegExp]", M3 = "[object Set]", I3 = "[object String]", D3 = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, k3 = "[object URL]", R3 = Object.prototype.toString;
function L3({ areArrayBuffersEqual: e, areArraysEqual: t, areDataViewsEqual: n, areDatesEqual: r, areErrorsEqual: i, areFunctionsEqual: a, areMapsEqual: o, areNumbersEqual: s, areObjectsEqual: c, arePrimitiveWrappersEqual: l, areRegExpsEqual: d, areSetsEqual: f, areTypedArraysEqual: h, areUrlsEqual: m, unknownTagComparators: g }) {
  return function(v, y, x) {
    if (v === y)
      return !0;
    if (v == null || y == null)
      return !1;
    const w = typeof v;
    if (w !== typeof y)
      return !1;
    if (w !== "object")
      return w === "number" ? s(v, y, x) : w === "function" ? a(v, y, x) : !1;
    const _ = v.constructor;
    if (_ !== y.constructor)
      return !1;
    if (_ === Object)
      return c(v, y, x);
    if (Array.isArray(v))
      return t(v, y, x);
    if (_ === Date)
      return r(v, y, x);
    if (_ === RegExp)
      return d(v, y, x);
    if (_ === Map)
      return o(v, y, x);
    if (_ === Set)
      return f(v, y, x);
    const b = R3.call(v);
    if (b === A3)
      return r(v, y, x);
    if (b === N3)
      return d(v, y, x);
    if (b === C3)
      return o(v, y, x);
    if (b === M3)
      return f(v, y, x);
    if (b === T3)
      return typeof v.then != "function" && typeof y.then != "function" && c(v, y, x);
    if (b === k3)
      return m(v, y, x);
    if (b === P3)
      return i(v, y, x);
    if (b === S3)
      return c(v, y, x);
    if (D3[b])
      return h(v, y, x);
    if (b === _3)
      return e(v, y, x);
    if (b === E3)
      return n(v, y, x);
    if (b === O3 || b === j3 || b === I3)
      return l(v, y, x);
    if (g) {
      let S = g[b];
      if (!S) {
        const O = o3(v);
        O && (S = g[O]);
      }
      if (S)
        return S(v, y, x);
    }
    return !1;
  };
}
function $3({ circular: e, createCustomConfig: t, strict: n }) {
  let r = {
    areArrayBuffersEqual: d3,
    areArraysEqual: n ? Bo : f3,
    areDataViewsEqual: h3,
    areDatesEqual: m3,
    areErrorsEqual: v3,
    areFunctionsEqual: p3,
    areMapsEqual: n ? Dv(RO, Bo) : RO,
    areNumbersEqual: g3,
    areObjectsEqual: n ? Bo : y3,
    arePrimitiveWrappersEqual: b3,
    areRegExpsEqual: x3,
    areSetsEqual: n ? Dv(LO, Bo) : LO,
    areTypedArraysEqual: n ? Dv(Zl, Bo) : Zl,
    areUrlsEqual: w3,
    unknownTagComparators: void 0
  };
  if (t && (r = Object.assign({}, r, t(r))), e) {
    const i = Hc(r.areArraysEqual), a = Hc(r.areMapsEqual), o = Hc(r.areObjectsEqual), s = Hc(r.areSetsEqual);
    r = Object.assign({}, r, {
      areArraysEqual: i,
      areMapsEqual: a,
      areObjectsEqual: o,
      areSetsEqual: s
    });
  }
  return r;
}
function B3(e) {
  return function(t, n, r, i, a, o, s) {
    return e(t, n, s);
  };
}
function F3({ circular: e, comparator: t, createState: n, equals: r, strict: i }) {
  if (n)
    return function(s, c) {
      const { cache: l = e ? /* @__PURE__ */ new WeakMap() : void 0, meta: d } = n();
      return t(s, c, {
        cache: l,
        equals: r,
        meta: d,
        strict: i
      });
    };
  if (e)
    return function(s, c) {
      return t(s, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: r,
        meta: void 0,
        strict: i
      });
    };
  const a = {
    cache: void 0,
    equals: r,
    meta: void 0,
    strict: i
  };
  return function(s, c) {
    return t(s, c, a);
  };
}
const z3 = fi();
fi({ strict: !0 });
fi({ circular: !0 });
fi({
  circular: !0,
  strict: !0
});
fi({
  createInternalComparator: () => oa
});
fi({
  strict: !0,
  createInternalComparator: () => oa
});
fi({
  circular: !0,
  createInternalComparator: () => oa
});
fi({
  circular: !0,
  createInternalComparator: () => oa,
  strict: !0
});
function fi(e = {}) {
  const { circular: t = !1, createInternalComparator: n, createState: r, strict: i = !1 } = e, a = $3(e), o = L3(a), s = n ? n(o) : B3(o);
  return F3({ circular: t, comparator: o, createState: r, equals: s, strict: i });
}
function q3(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function $O(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function i(a) {
    n < 0 && (n = a), a - n > t ? (e(a), n = -1) : q3(i);
  };
  requestAnimationFrame(r);
}
function Ig(e) {
  "@babel/helpers - typeof";
  return Ig = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ig(e);
}
function V3(e) {
  return Y3(e) || H3(e) || U3(e) || W3();
}
function W3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U3(e, t) {
  if (e) {
    if (typeof e == "string") return BO(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BO(e, t);
  }
}
function BO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function H3(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Y3(e) {
  if (Array.isArray(e)) return e;
}
function K3() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function i(a) {
    if (!n) {
      if (Array.isArray(a)) {
        if (!a.length)
          return;
        var o = a, s = V3(o), c = s[0], l = s.slice(1);
        if (typeof c == "number") {
          $O(i.bind(null, l), c);
          return;
        }
        i(c), $O(i.bind(null, l));
        return;
      }
      Ig(a) === "object" && (e = a, t(e)), typeof a == "function" && a();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(a) {
      n = !1, r(a);
    },
    subscribe: function(a) {
      return t = a, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Is(e) {
  "@babel/helpers - typeof";
  return Is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Is(e);
}
function FO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FO(Object(n), !0).forEach(function(r) {
      VT(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function VT(e, t, n) {
  return t = G3(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function G3(e) {
  var t = Z3(e, "string");
  return Is(t) === "symbol" ? t : String(t);
}
function Z3(e, t) {
  if (Is(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Is(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var X3 = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, i) {
    return r.filter(function(a) {
      return i.includes(a);
    });
  });
}, Q3 = function(t) {
  return t;
}, J3 = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, is = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return zO(zO({}, r), {}, VT({}, i, t(i, n[i])));
  }, {});
}, qO = function(t, n, r) {
  return t.map(function(i) {
    return "".concat(J3(i), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, eH = process.env.NODE_ENV !== "production", Xl = function(t, n, r, i, a, o, s, c) {
  if (eH && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var l = [r, i, a, o, s, c], d = 0;
      console.warn(n.replace(/%s/g, function() {
        return l[d++];
      }));
    }
};
function tH(e, t) {
  return iH(e) || rH(e, t) || WT(e, t) || nH();
}
function nH() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rH(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function iH(e) {
  if (Array.isArray(e)) return e;
}
function aH(e) {
  return cH(e) || sH(e) || WT(e) || oH();
}
function oH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WT(e, t) {
  if (e) {
    if (typeof e == "string") return Dg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Dg(e, t);
  }
}
function sH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function cH(e) {
  if (Array.isArray(e)) return Dg(e);
}
function Dg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Ql = 1e-4, UT = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, HT = function(t, n) {
  return t.map(function(r, i) {
    return r * Math.pow(n, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, VO = function(t, n) {
  return function(r) {
    var i = UT(t, n);
    return HT(i, r);
  };
}, lH = function(t, n) {
  return function(r) {
    var i = UT(t, n), a = [].concat(aH(i.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return HT(a, r);
  };
}, WO = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0], a = n[1], o = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        i = 0, a = 0, o = 1, s = 1;
        break;
      case "ease":
        i = 0.25, a = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, a = 0, o = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, a = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, a = 0, o = 0.58, s = 1;
        break;
      default: {
        var c = n[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var l = c[1].split(")")[0].split(",").map(function(v) {
            return parseFloat(v);
          }), d = tH(l, 4);
          i = d[0], a = d[1], o = d[2], s = d[3];
        } else
          Xl(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  Xl([i, o, a, s].every(function(v) {
    return typeof v == "number" && v >= 0 && v <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var f = VO(i, o), h = VO(a, s), m = lH(i, o), g = function(y) {
    return y > 1 ? 1 : y < 0 ? 0 : y;
  }, p = function(y) {
    for (var x = y > 1 ? 1 : y, w = x, _ = 0; _ < 8; ++_) {
      var b = f(w) - x, S = m(w);
      if (Math.abs(b - x) < Ql || S < Ql)
        return h(w);
      w = g(w - b / S);
    }
    return h(w);
  };
  return p.isStepper = !1, p;
}, uH = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, i = t.damping, a = i === void 0 ? 8 : i, o = t.dt, s = o === void 0 ? 17 : o, c = function(d, f, h) {
    var m = -(d - f) * r, g = h * a, p = h + (m - g) * s / 1e3, v = h * s / 1e3 + d;
    return Math.abs(v - f) < Ql && Math.abs(p) < Ql ? [f, 0] : [v, p];
  };
  return c.isStepper = !0, c.dt = s, c;
}, dH = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return WO(i);
      case "spring":
        return uH();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return WO(i);
        Xl(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof i == "function" ? i : (Xl(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function Ds(e) {
  "@babel/helpers - typeof";
  return Ds = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ds(e);
}
function UO(e) {
  return mH(e) || hH(e) || YT(e) || fH();
}
function fH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function hH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function mH(e) {
  if (Array.isArray(e)) return Rg(e);
}
function HO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HO(Object(n), !0).forEach(function(r) {
      kg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kg(e, t, n) {
  return t = vH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vH(e) {
  var t = pH(e, "string");
  return Ds(t) === "symbol" ? t : String(t);
}
function pH(e, t) {
  if (Ds(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ds(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gH(e, t) {
  return xH(e) || bH(e, t) || YT(e, t) || yH();
}
function yH() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YT(e, t) {
  if (e) {
    if (typeof e == "string") return Rg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Rg(e, t);
  }
}
function Rg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function bH(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function xH(e) {
  if (Array.isArray(e)) return e;
}
var Jl = function(t, n, r) {
  return t + (n - t) * r;
}, Lg = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, wH = function e(t, n, r) {
  var i = is(function(a, o) {
    if (Lg(o)) {
      var s = t(o.from, o.to, o.velocity), c = gH(s, 2), l = c[0], d = c[1];
      return Bt(Bt({}, o), {}, {
        from: l,
        velocity: d
      });
    }
    return o;
  }, n);
  return r < 1 ? is(function(a, o) {
    return Lg(o) ? Bt(Bt({}, o), {}, {
      velocity: Jl(o.velocity, i[a].velocity, r),
      from: Jl(o.from, i[a].from, r)
    }) : o;
  }, n) : e(t, i, r - 1);
};
const _H = (function(e, t, n, r, i) {
  var a = X3(e, t), o = a.reduce(function(v, y) {
    return Bt(Bt({}, v), {}, kg({}, y, [e[y], t[y]]));
  }, {}), s = a.reduce(function(v, y) {
    return Bt(Bt({}, v), {}, kg({}, y, {
      from: e[y],
      velocity: 0,
      to: t[y]
    }));
  }, {}), c = -1, l, d, f = function() {
    return null;
  }, h = function() {
    return is(function(y, x) {
      return x.from;
    }, s);
  }, m = function() {
    return !Object.values(s).filter(Lg).length;
  }, g = function(y) {
    l || (l = y);
    var x = y - l, w = x / n.dt;
    s = wH(n, s, w), i(Bt(Bt(Bt({}, e), t), h())), l = y, m() || (c = requestAnimationFrame(f));
  }, p = function(y) {
    d || (d = y);
    var x = (y - d) / r, w = is(function(b, S) {
      return Jl.apply(void 0, UO(S).concat([n(x)]));
    }, o);
    if (i(Bt(Bt(Bt({}, e), t), w)), x < 1)
      c = requestAnimationFrame(f);
    else {
      var _ = is(function(b, S) {
        return Jl.apply(void 0, UO(S).concat([n(1)]));
      }, o);
      i(Bt(Bt(Bt({}, e), t), _));
    }
  };
  return f = n.isStepper ? g : p, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(c);
    };
  };
});
function Ya(e) {
  "@babel/helpers - typeof";
  return Ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ya(e);
}
var SH = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function OH(e, t) {
  if (e == null) return {};
  var n = EH(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function EH(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function kv(e) {
  return jH(e) || CH(e) || PH(e) || AH();
}
function AH() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PH(e, t) {
  if (e) {
    if (typeof e == "string") return $g(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $g(e, t);
  }
}
function CH(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function jH(e) {
  if (Array.isArray(e)) return $g(e);
}
function $g(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function YO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YO(Object(n), !0).forEach(function(r) {
      Go(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Go(e, t, n) {
  return t = KT(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TH(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function NH(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, KT(r.key), r);
  }
}
function MH(e, t, n) {
  return t && NH(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function KT(e) {
  var t = IH(e, "string");
  return Ya(t) === "symbol" ? t : String(t);
}
function IH(e, t) {
  if (Ya(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ya(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function DH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bg(e, t);
}
function Bg(e, t) {
  return Bg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Bg(e, t);
}
function kH(e) {
  var t = RH();
  return function() {
    var r = eu(e), i;
    if (t) {
      var a = eu(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return Fg(this, i);
  };
}
function Fg(e, t) {
  if (t && (Ya(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zg(e);
}
function zg(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RH() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function eu(e) {
  return eu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, eu(e);
}
var ri = /* @__PURE__ */ (function(e) {
  DH(n, e);
  var t = kH(n);
  function n(r, i) {
    var a;
    TH(this, n), a = t.call(this, r, i);
    var o = a.props, s = o.isActive, c = o.attributeName, l = o.from, d = o.to, f = o.steps, h = o.children, m = o.duration;
    if (a.handleStyleChange = a.handleStyleChange.bind(zg(a)), a.changeStyle = a.changeStyle.bind(zg(a)), !s || m <= 0)
      return a.state = {
        style: {}
      }, typeof h == "function" && (a.state = {
        style: d
      }), Fg(a);
    if (f && f.length)
      a.state = {
        style: f[0].style
      };
    else if (l) {
      if (typeof h == "function")
        return a.state = {
          style: l
        }, Fg(a);
      a.state = {
        style: c ? Go({}, c, l) : l
      };
    } else
      a.state = {
        style: {}
      };
    return a;
  }
  return MH(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, a = i.isActive, o = i.canBegin;
      this.mounted = !0, !(!a || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isActive, s = a.canBegin, c = a.attributeName, l = a.shouldReAnimate, d = a.to, f = a.from, h = this.state.style;
      if (s) {
        if (!o) {
          var m = {
            style: c ? Go({}, c, d) : d
          };
          this.state && h && (c && h[c] !== d || !c && h !== d) && this.setState(m);
          return;
        }
        if (!(z3(i.to, d) && i.canBegin && i.isActive)) {
          var g = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var p = g || l ? f : i.to;
          if (this.state && h) {
            var v = {
              style: c ? Go({}, c, p) : p
            };
            (c && h[c] !== p || !c && h !== p) && this.setState(v);
          }
          this.runAnimation(Bn(Bn({}, this.props), {}, {
            from: p,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var a = this, o = i.from, s = i.to, c = i.duration, l = i.easing, d = i.begin, f = i.onAnimationEnd, h = i.onAnimationStart, m = _H(o, s, dH(l), c, this.changeStyle), g = function() {
        a.stopJSAnimation = m();
      };
      this.manager.start([h, d, g, c, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var a = this, o = i.steps, s = i.begin, c = i.onAnimationStart, l = o[0], d = l.style, f = l.duration, h = f === void 0 ? 0 : f, m = function(p, v, y) {
        if (y === 0)
          return p;
        var x = v.duration, w = v.easing, _ = w === void 0 ? "ease" : w, b = v.style, S = v.properties, O = v.onAnimationEnd, E = y > 0 ? o[y - 1] : v, P = S || Object.keys(b);
        if (typeof _ == "function" || _ === "spring")
          return [].concat(kv(p), [a.runJSAnimation.bind(a, {
            from: E.style,
            to: b,
            duration: x,
            easing: _
          }), x]);
        var R = qO(P, x, _), j = Bn(Bn(Bn({}, E.style), b), {}, {
          transition: R
        });
        return [].concat(kv(p), [j, x, O]).filter(Q3);
      };
      return this.manager.start([c].concat(kv(o.reduce(m, [d, Math.max(h, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = K3());
      var a = i.begin, o = i.duration, s = i.attributeName, c = i.to, l = i.easing, d = i.onAnimationStart, f = i.onAnimationEnd, h = i.steps, m = i.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof l == "function" || typeof m == "function" || l === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (h.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var p = s ? Go({}, s, c) : c, v = qO(Object.keys(p), o, l);
      g.start([d, a, Bn(Bn({}, p), {}, {
        transition: v
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, a = i.children;
      i.begin;
      var o = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var c = OH(i, SH), l = Ri.count(a), d = this.state.style;
      if (typeof a == "function")
        return a(d);
      if (!s || l === 0 || o <= 0)
        return a;
      var f = function(m) {
        var g = m.props, p = g.style, v = p === void 0 ? {} : p, y = g.className, x = /* @__PURE__ */ _t(m, Bn(Bn({}, c), {}, {
          style: Bn(Bn({}, v), d),
          className: y
        }));
        return x;
      };
      return l === 1 ? f(Ri.only(a)) : /* @__PURE__ */ T.createElement("div", null, Ri.map(a, function(h) {
        return f(h);
      }));
    }
  }]), n;
})(ta);
ri.displayName = "Animate";
ri.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
ri.propTypes = {
  from: Ue.oneOfType([Ue.object, Ue.string]),
  to: Ue.oneOfType([Ue.object, Ue.string]),
  attributeName: Ue.string,
  // animation duration
  duration: Ue.number,
  begin: Ue.number,
  easing: Ue.oneOfType([Ue.string, Ue.func]),
  steps: Ue.arrayOf(Ue.shape({
    duration: Ue.number.isRequired,
    style: Ue.object.isRequired,
    easing: Ue.oneOfType([Ue.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Ue.func]),
    // transition css properties(dash case), optional
    properties: Ue.arrayOf("string"),
    onAnimationEnd: Ue.func
  })),
  children: Ue.oneOfType([Ue.node, Ue.func]),
  isActive: Ue.bool,
  canBegin: Ue.bool,
  onAnimationEnd: Ue.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Ue.bool,
  onAnimationStart: Ue.func,
  onAnimationReStart: Ue.func
};
function ks(e) {
  "@babel/helpers - typeof";
  return ks = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ks(e);
}
function tu() {
  return tu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tu.apply(this, arguments);
}
function LH(e, t) {
  return zH(e) || FH(e, t) || BH(e, t) || $H();
}
function $H() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BH(e, t) {
  if (e) {
    if (typeof e == "string") return KO(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return KO(e, t);
  }
}
function KO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function FH(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function zH(e) {
  if (Array.isArray(e)) return e;
}
function GO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ZO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GO(Object(n), !0).forEach(function(r) {
      qH(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : GO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qH(e, t, n) {
  return t = VH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VH(e) {
  var t = WH(e, "string");
  return ks(t) == "symbol" ? t : t + "";
}
function WH(e, t) {
  if (ks(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ks(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var XO = function(t, n, r, i, a) {
  var o = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, c = r >= 0 ? 1 : -1, l = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, d;
  if (o > 0 && a instanceof Array) {
    for (var f = [0, 0, 0, 0], h = 0, m = 4; h < m; h++)
      f[h] = a[h] > o ? o : a[h];
    d = "M".concat(t, ",").concat(n + s * f[0]), f[0] > 0 && (d += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(l, ",").concat(t + c * f[0], ",").concat(n)), d += "L ".concat(t + r - c * f[1], ",").concat(n), f[1] > 0 && (d += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(l, `,
        `).concat(t + r, ",").concat(n + s * f[1])), d += "L ".concat(t + r, ",").concat(n + i - s * f[2]), f[2] > 0 && (d += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(l, `,
        `).concat(t + r - c * f[2], ",").concat(n + i)), d += "L ".concat(t + c * f[3], ",").concat(n + i), f[3] > 0 && (d += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(l, `,
        `).concat(t, ",").concat(n + i - s * f[3])), d += "Z";
  } else if (o > 0 && a === +a && a > 0) {
    var g = Math.min(o, a);
    d = "M ".concat(t, ",").concat(n + s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + c * g, ",").concat(n, `
            L `).concat(t + r - c * g, ",").concat(n, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + r, ",").concat(n + s * g, `
            L `).concat(t + r, ",").concat(n + i - s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + r - c * g, ",").concat(n + i, `
            L `).concat(t + c * g, ",").concat(n + i, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t, ",").concat(n + i - s * g, " Z");
  } else
    d = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return d;
}, UH = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, i = t.y, a = n.x, o = n.y, s = n.width, c = n.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var l = Math.min(a, a + s), d = Math.max(a, a + s), f = Math.min(o, o + c), h = Math.max(o, o + c);
    return r >= l && r <= d && i >= f && i <= h;
  }
  return !1;
}, HH = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Ub = function(t) {
  var n = ZO(ZO({}, HH), t), r = Le(), i = Ee(-1), a = LH(i, 2), o = a[0], s = a[1];
  St(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var _ = r.current.getTotalLength();
        _ && s(_);
      } catch {
      }
  }, []);
  var c = n.x, l = n.y, d = n.width, f = n.height, h = n.radius, m = n.className, g = n.animationEasing, p = n.animationDuration, v = n.animationBegin, y = n.isAnimationActive, x = n.isUpdateAnimationActive;
  if (c !== +c || l !== +l || d !== +d || f !== +f || d === 0 || f === 0)
    return null;
  var w = Fe("recharts-rectangle", m);
  return x ? /* @__PURE__ */ T.createElement(ri, {
    canBegin: o > 0,
    from: {
      width: d,
      height: f,
      x: c,
      y: l
    },
    to: {
      width: d,
      height: f,
      x: c,
      y: l
    },
    duration: p,
    animationEasing: g,
    isActive: x
  }, function(_) {
    var b = _.width, S = _.height, O = _.x, E = _.y;
    return /* @__PURE__ */ T.createElement(ri, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: p,
      isActive: y,
      easing: g
    }, /* @__PURE__ */ T.createElement("path", tu({}, Ye(n, !0), {
      className: w,
      d: XO(O, E, b, S, h),
      ref: r
    })));
  }) : /* @__PURE__ */ T.createElement("path", tu({}, Ye(n, !0), {
    className: w,
    d: XO(c, l, d, f, h)
  }));
};
function qg() {
  return qg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qg.apply(this, arguments);
}
var GT = function(t) {
  var n = t.cx, r = t.cy, i = t.r, a = t.className, o = Fe("recharts-dot", a);
  return n === +n && r === +r && i === +i ? /* @__PURE__ */ T.createElement("circle", qg({}, Ye(t, !1), xl(t), {
    className: o,
    cx: n,
    cy: r,
    r: i
  })) : null;
};
function Rs(e) {
  "@babel/helpers - typeof";
  return Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rs(e);
}
var YH = ["x", "y", "top", "left", "width", "height", "className"];
function Vg() {
  return Vg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vg.apply(this, arguments);
}
function QO(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KH(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QO(Object(n), !0).forEach(function(r) {
      GH(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QO(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function GH(e, t, n) {
  return t = ZH(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ZH(e) {
  var t = XH(e, "string");
  return Rs(t) == "symbol" ? t : t + "";
}
function XH(e, t) {
  if (Rs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Rs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function QH(e, t) {
  if (e == null) return {};
  var n = JH(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JH(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var e6 = function(t, n, r, i, a, o) {
  return "M".concat(t, ",").concat(a, "v").concat(i, "M").concat(o, ",").concat(n, "h").concat(r);
}, t6 = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, a = i === void 0 ? 0 : i, o = t.top, s = o === void 0 ? 0 : o, c = t.left, l = c === void 0 ? 0 : c, d = t.width, f = d === void 0 ? 0 : d, h = t.height, m = h === void 0 ? 0 : h, g = t.className, p = QH(t, YH), v = KH({
    x: r,
    y: a,
    top: s,
    left: l,
    width: f,
    height: m
  }, p);
  return !me(r) || !me(a) || !me(f) || !me(m) || !me(s) || !me(l) ? null : /* @__PURE__ */ T.createElement("path", Vg({}, Ye(v, !0), {
    className: Fe("recharts-cross", g),
    d: e6(r, a, f, m, s, l)
  }));
}, Rv, JO;
function n6() {
  if (JO) return Rv;
  JO = 1;
  var e = vj(), t = e(Object.getPrototypeOf, Object);
  return Rv = t, Rv;
}
var Lv, eE;
function r6() {
  if (eE) return Lv;
  eE = 1;
  var e = $r(), t = n6(), n = Br(), r = "[object Object]", i = Function.prototype, a = Object.prototype, o = i.toString, s = a.hasOwnProperty, c = o.call(Object);
  function l(d) {
    if (!n(d) || e(d) != r)
      return !1;
    var f = t(d);
    if (f === null)
      return !0;
    var h = s.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && o.call(h) == c;
  }
  return Lv = l, Lv;
}
var i6 = r6();
const a6 = /* @__PURE__ */ ct(i6);
var $v, tE;
function o6() {
  if (tE) return $v;
  tE = 1;
  var e = $r(), t = Br(), n = "[object Boolean]";
  function r(i) {
    return i === !0 || i === !1 || t(i) && e(i) == n;
  }
  return $v = r, $v;
}
var s6 = o6();
const c6 = /* @__PURE__ */ ct(s6);
function Ls(e) {
  "@babel/helpers - typeof";
  return Ls = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ls(e);
}
function nu() {
  return nu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nu.apply(this, arguments);
}
function l6(e, t) {
  return h6(e) || f6(e, t) || d6(e, t) || u6();
}
function u6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function d6(e, t) {
  if (e) {
    if (typeof e == "string") return nE(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nE(e, t);
  }
}
function nE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function f6(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function h6(e) {
  if (Array.isArray(e)) return e;
}
function rE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function iE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rE(Object(n), !0).forEach(function(r) {
      m6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function m6(e, t, n) {
  return t = v6(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v6(e) {
  var t = p6(e, "string");
  return Ls(t) == "symbol" ? t : t + "";
}
function p6(e, t) {
  if (Ls(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ls(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var aE = function(t, n, r, i, a) {
  var o = r - i, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - o / 2, ",").concat(n + a), s += "L ".concat(t + r - o / 2 - i, ",").concat(n + a), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, g6 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, y6 = function(t) {
  var n = iE(iE({}, g6), t), r = Le(), i = Ee(-1), a = l6(i, 2), o = a[0], s = a[1];
  St(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var w = r.current.getTotalLength();
        w && s(w);
      } catch {
      }
  }, []);
  var c = n.x, l = n.y, d = n.upperWidth, f = n.lowerWidth, h = n.height, m = n.className, g = n.animationEasing, p = n.animationDuration, v = n.animationBegin, y = n.isUpdateAnimationActive;
  if (c !== +c || l !== +l || d !== +d || f !== +f || h !== +h || d === 0 && f === 0 || h === 0)
    return null;
  var x = Fe("recharts-trapezoid", m);
  return y ? /* @__PURE__ */ T.createElement(ri, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: h,
      x: c,
      y: l
    },
    to: {
      upperWidth: d,
      lowerWidth: f,
      height: h,
      x: c,
      y: l
    },
    duration: p,
    animationEasing: g,
    isActive: y
  }, function(w) {
    var _ = w.upperWidth, b = w.lowerWidth, S = w.height, O = w.x, E = w.y;
    return /* @__PURE__ */ T.createElement(ri, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: p,
      easing: g
    }, /* @__PURE__ */ T.createElement("path", nu({}, Ye(n, !0), {
      className: x,
      d: aE(O, E, _, b, S),
      ref: r
    })));
  }) : /* @__PURE__ */ T.createElement("g", null, /* @__PURE__ */ T.createElement("path", nu({}, Ye(n, !0), {
    className: x,
    d: aE(c, l, d, f, h)
  })));
}, b6 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function $s(e) {
  "@babel/helpers - typeof";
  return $s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $s(e);
}
function x6(e, t) {
  if (e == null) return {};
  var n = w6(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function w6(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function oE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ru(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oE(Object(n), !0).forEach(function(r) {
      _6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _6(e, t, n) {
  return t = S6(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function S6(e) {
  var t = O6(e, "string");
  return $s(t) == "symbol" ? t : t + "";
}
function O6(e, t) {
  if ($s(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if ($s(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function E6(e, t) {
  return ru(ru({}, t), e);
}
function A6(e, t) {
  return e === "symbols";
}
function sE(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ T.createElement(Ub, n);
    case "trapezoid":
      return /* @__PURE__ */ T.createElement(y6, n);
    case "sector":
      return /* @__PURE__ */ T.createElement(BT, n);
    case "symbols":
      if (A6(t))
        return /* @__PURE__ */ T.createElement(sb, n);
      break;
    default:
      return null;
  }
}
function P6(e) {
  return /* @__PURE__ */ Yn(e) ? e.props : e;
}
function C6(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, i = r === void 0 ? E6 : r, a = e.activeClassName, o = a === void 0 ? "recharts-active-shape" : a, s = e.isActive, c = x6(e, b6), l;
  if (/* @__PURE__ */ Yn(t))
    l = /* @__PURE__ */ _t(t, ru(ru({}, c), P6(t)));
  else if (Re(t))
    l = t(c);
  else if (a6(t) && !c6(t)) {
    var d = i(t, c);
    l = /* @__PURE__ */ T.createElement(sE, {
      shapeType: n,
      elementProps: d
    });
  } else {
    var f = c;
    l = /* @__PURE__ */ T.createElement(sE, {
      shapeType: n,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ T.createElement(It, {
    className: o
  }, l) : l;
}
function sd(e, t) {
  return t != null && "trapezoids" in e.props;
}
function cd(e, t) {
  return t != null && "sectors" in e.props;
}
function Bs(e, t) {
  return t != null && "points" in e.props;
}
function j6(e, t) {
  var n, r, i = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, a = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return i && a;
}
function T6(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function N6(e, t) {
  var n = e.x === t.x, r = e.y === t.y, i = e.z === t.z;
  return n && r && i;
}
function M6(e, t) {
  var n;
  return sd(e, t) ? n = j6 : cd(e, t) ? n = T6 : Bs(e, t) && (n = N6), n;
}
function I6(e, t) {
  var n;
  return sd(e, t) ? n = "trapezoids" : cd(e, t) ? n = "sectors" : Bs(e, t) && (n = "points"), n;
}
function D6(e, t) {
  if (sd(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (cd(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return Bs(e, t) ? t.payload : {};
}
function k6(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, i = I6(n, t), a = D6(n, t), o = r.filter(function(c, l) {
    var d = Fb(a, c), f = n.props[i].filter(function(g) {
      var p = M6(n, t);
      return p(g, t);
    }), h = n.props[i].indexOf(f[f.length - 1]), m = l === h;
    return d && m;
  }), s = r.indexOf(o[o.length - 1]);
  return s;
}
var Bv, cE;
function R6() {
  if (cE) return Bv;
  cE = 1;
  var e = Math.ceil, t = Math.max;
  function n(r, i, a, o) {
    for (var s = -1, c = t(e((i - r) / (a || 1)), 0), l = Array(c); c--; )
      l[o ? c : ++s] = r, r += a;
    return l;
  }
  return Bv = n, Bv;
}
var Fv, lE;
function ZT() {
  if (lE) return Fv;
  lE = 1;
  var e = Nj(), t = 1 / 0, n = 17976931348623157e292;
  function r(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -t) {
      var a = i < 0 ? -1 : 1;
      return a * n;
    }
    return i === i ? i : 0;
  }
  return Fv = r, Fv;
}
var zv, uE;
function L6() {
  if (uE) return zv;
  uE = 1;
  var e = R6(), t = Gu(), n = ZT();
  function r(i) {
    return function(a, o, s) {
      return s && typeof s != "number" && t(a, o, s) && (o = s = void 0), a = n(a), o === void 0 ? (o = a, a = 0) : o = n(o), s = s === void 0 ? a < o ? 1 : -1 : n(s), e(a, o, s, i);
    };
  }
  return zv = r, zv;
}
var qv, dE;
function $6() {
  if (dE) return qv;
  dE = 1;
  var e = L6(), t = e();
  return qv = t, qv;
}
var B6 = $6();
const iu = /* @__PURE__ */ ct(B6);
function Fs(e) {
  "@babel/helpers - typeof";
  return Fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fs(e);
}
function fE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fE(Object(n), !0).forEach(function(r) {
      XT(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function XT(e, t, n) {
  return t = F6(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function F6(e) {
  var t = z6(e, "string");
  return Fs(t) == "symbol" ? t : t + "";
}
function z6(e, t) {
  if (Fs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Fs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var q6 = ["Webkit", "Moz", "O", "ms"], V6 = function(t, n) {
  var r = t.replace(/(\w)/, function(a) {
    return a.toUpperCase();
  }), i = q6.reduce(function(a, o) {
    return hE(hE({}, a), {}, XT({}, o + r, n));
  }, {});
  return i[t] = n, i;
};
function Ka(e) {
  "@babel/helpers - typeof";
  return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ka(e);
}
function au() {
  return au = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, au.apply(this, arguments);
}
function mE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mE(Object(n), !0).forEach(function(r) {
      dn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function W6(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, JT(r.key), r);
  }
}
function U6(e, t, n) {
  return t && vE(e.prototype, t), n && vE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function H6(e, t, n) {
  return t = ou(t), Y6(e, QT() ? Reflect.construct(t, n || [], ou(e).constructor) : t.apply(e, n));
}
function Y6(e, t) {
  if (t && (Ka(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return K6(e);
}
function K6(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (QT = function() {
    return !!e;
  })();
}
function ou(e) {
  return ou = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ou(e);
}
function G6(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Wg(e, t);
}
function Wg(e, t) {
  return Wg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Wg(e, t);
}
function dn(e, t, n) {
  return t = JT(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function JT(e) {
  var t = Z6(e, "string");
  return Ka(t) == "symbol" ? t : t + "";
}
function Z6(e, t) {
  if (Ka(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ka(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var X6 = function(t) {
  var n = t.data, r = t.startIndex, i = t.endIndex, a = t.x, o = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var c = n.length, l = ns().domain(iu(0, c)).range([a, a + o - s]), d = l.domain().map(function(f) {
    return l(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: l(r),
    endX: l(i),
    scale: l,
    scaleValues: d
  };
}, pE = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Ga = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r;
    return W6(this, t), r = H6(this, t, [n]), dn(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), dn(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), dn(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, a = i.endIndex, o = i.onDragEnd, s = i.startIndex;
        o?.({
          endIndex: a,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), dn(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), dn(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), dn(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), dn(r, "handleSlideDragStart", function(i) {
      var a = pE(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: a.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return G6(t, e), U6(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, a = r.endX, o = this.state.scaleValues, s = this.props, c = s.gap, l = s.data, d = l.length - 1, f = Math.min(i, a), h = Math.max(i, a), m = t.getIndexInRange(o, f), g = t.getIndexInRange(o, h);
      return {
        startIndex: m - m % c,
        endIndex: g === d ? d : g - g % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, a = i.data, o = i.tickFormatter, s = i.dataKey, c = fr(a[r], s, r);
      return Re(o) ? o(c, r) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, a = i.slideMoveStartX, o = i.startX, s = i.endX, c = this.props, l = c.x, d = c.width, f = c.travellerWidth, h = c.startIndex, m = c.endIndex, g = c.onChange, p = r.pageX - a;
      p > 0 ? p = Math.min(p, l + d - f - s, l + d - f - o) : p < 0 && (p = Math.max(p, l - o, l - s));
      var v = this.getIndex({
        startX: o + p,
        endX: s + p
      });
      (v.startIndex !== h || v.endIndex !== m) && g && g(v), this.setState({
        startX: o + p,
        endX: s + p,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var a = pE(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: a.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, a = i.brushMoveStartX, o = i.movingTravellerId, s = i.endX, c = i.startX, l = this.state[o], d = this.props, f = d.x, h = d.width, m = d.travellerWidth, g = d.onChange, p = d.gap, v = d.data, y = {
        startX: this.state.startX,
        endX: this.state.endX
      }, x = r.pageX - a;
      x > 0 ? x = Math.min(x, f + h - m - l) : x < 0 && (x = Math.max(x, f - l)), y[o] = l + x;
      var w = this.getIndex(y), _ = w.startIndex, b = w.endIndex, S = function() {
        var E = v.length - 1;
        return o === "startX" && (s > c ? _ % p === 0 : b % p === 0) || s < c && b === E || o === "endX" && (s > c ? b % p === 0 : _ % p === 0) || s > c && b === E;
      };
      this.setState(dn(dn({}, o, l + x), "brushMoveStartX", r.pageX), function() {
        g && S() && g(w);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var a = this, o = this.state, s = o.scaleValues, c = o.startX, l = o.endX, d = this.state[i], f = s.indexOf(d);
      if (f !== -1) {
        var h = f + r;
        if (!(h === -1 || h >= s.length)) {
          var m = s[h];
          i === "startX" && m >= l || i === "endX" && m <= c || this.setState(dn({}, i, m), function() {
            a.props.onChange(a.getIndex({
              startX: a.state.startX,
              endX: a.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, a = r.y, o = r.width, s = r.height, c = r.fill, l = r.stroke;
      return /* @__PURE__ */ T.createElement("rect", {
        stroke: l,
        fill: c,
        x: i,
        y: a,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, a = r.y, o = r.width, s = r.height, c = r.data, l = r.children, d = r.padding, f = Ri.only(l);
      return f ? /* @__PURE__ */ T.cloneElement(f, {
        x: i,
        y: a,
        width: o,
        height: s,
        margin: d,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var a, o, s = this, c = this.props, l = c.y, d = c.travellerWidth, f = c.height, h = c.traveller, m = c.ariaLabel, g = c.data, p = c.startIndex, v = c.endIndex, y = Math.max(r, this.props.x), x = Vv(Vv({}, Ye(this.props, !1)), {}, {
        x: y,
        y: l,
        width: d,
        height: f
      }), w = m || "Min value: ".concat((a = g[p]) === null || a === void 0 ? void 0 : a.name, ", Max value: ").concat((o = g[v]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ T.createElement(It, {
        tabIndex: 0,
        role: "slider",
        "aria-label": w,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(b) {
          ["ArrowLeft", "ArrowRight"].includes(b.key) && (b.preventDefault(), b.stopPropagation(), s.handleTravellerMoveKeyboard(b.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(h, x));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var a = this.props, o = a.y, s = a.height, c = a.stroke, l = a.travellerWidth, d = Math.min(r, i) + l, f = Math.max(Math.abs(i - r) - l, 0);
      return /* @__PURE__ */ T.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: d,
        y: o,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, a = r.endIndex, o = r.y, s = r.height, c = r.travellerWidth, l = r.stroke, d = this.state, f = d.startX, h = d.endX, m = 5, g = {
        pointerEvents: "none",
        fill: l
      };
      return /* @__PURE__ */ T.createElement(It, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ T.createElement(Ml, au({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, h) - m,
        y: o + s / 2
      }, g), this.getTextOfTick(i)), /* @__PURE__ */ T.createElement(Ml, au({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, h) + c + m,
        y: o + s / 2
      }, g), this.getTextOfTick(a)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, a = r.className, o = r.children, s = r.x, c = r.y, l = r.width, d = r.height, f = r.alwaysShowText, h = this.state, m = h.startX, g = h.endX, p = h.isTextActive, v = h.isSlideMoving, y = h.isTravellerMoving, x = h.isTravellerFocused;
      if (!i || !i.length || !me(s) || !me(c) || !me(l) || !me(d) || l <= 0 || d <= 0)
        return null;
      var w = Fe("recharts-brush", a), _ = T.Children.count(o) === 1, b = V6("userSelect", "none");
      return /* @__PURE__ */ T.createElement(It, {
        className: w,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: b
      }, this.renderBackground(), _ && this.renderPanorama(), this.renderSlide(m, g), this.renderTravellerLayer(m, "startX"), this.renderTravellerLayer(g, "endX"), (p || v || y || x || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, a = r.y, o = r.width, s = r.height, c = r.stroke, l = Math.floor(a + s / 2) - 1;
      return /* @__PURE__ */ T.createElement(T.Fragment, null, /* @__PURE__ */ T.createElement("rect", {
        x: i,
        y: a,
        width: o,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ T.createElement("line", {
        x1: i + 1,
        y1: l,
        x2: i + o - 1,
        y2: l,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ T.createElement("line", {
        x1: i + 1,
        y1: l + 2,
        x2: i + o - 1,
        y2: l + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var a;
      return /* @__PURE__ */ T.isValidElement(r) ? a = /* @__PURE__ */ T.cloneElement(r, i) : Re(r) ? a = r(i) : a = t.renderDefaultTraveller(i), a;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var a = r.data, o = r.width, s = r.x, c = r.travellerWidth, l = r.updateId, d = r.startIndex, f = r.endIndex;
      if (a !== i.prevData || l !== i.prevUpdateId)
        return Vv({
          prevData: a,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: o
        }, a && a.length ? X6({
          data: a,
          width: o,
          x: s,
          travellerWidth: c,
          startIndex: d,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (o !== i.prevWidth || s !== i.prevX || c !== i.prevTravellerWidth)) {
        i.scale.range([s, s + o - c]);
        var h = i.scale.domain().map(function(m) {
          return i.scale(m);
        });
        return {
          prevData: a,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: o,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: h
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var a = r.length, o = 0, s = a - 1; s - o > 1; ) {
        var c = Math.floor((o + s) / 2);
        r[c] > i ? s = c : o = c;
      }
      return i >= r[s] ? s : o;
    }
  }]);
})(ta);
dn(Ga, "displayName", "Brush");
dn(Ga, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Wv, gE;
function Q6() {
  if (gE) return Wv;
  gE = 1;
  var e = mb();
  function t(n, r) {
    var i;
    return e(n, function(a, o, s) {
      return i = r(a, o, s), !i;
    }), !!i;
  }
  return Wv = t, Wv;
}
var Uv, yE;
function J6() {
  if (yE) return Uv;
  yE = 1;
  var e = cj(), t = li(), n = Q6(), r = sn(), i = Gu();
  function a(o, s, c) {
    var l = r(o) ? e : n;
    return c && i(o, s, c) && (s = void 0), l(o, t(s, 3));
  }
  return Uv = a, Uv;
}
var e8 = J6();
const t8 = /* @__PURE__ */ ct(e8);
var lr = function(t, n) {
  var r = t.alwaysShow, i = t.ifOverflow;
  return r && (i = "extendDomain"), i === n;
}, Hv, bE;
function n8() {
  if (bE) return Hv;
  bE = 1;
  var e = Aj();
  function t(n, r, i) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : n[r] = i;
  }
  return Hv = t, Hv;
}
var Yv, xE;
function r8() {
  if (xE) return Yv;
  xE = 1;
  var e = n8(), t = Oj(), n = li();
  function r(i, a) {
    var o = {};
    return a = n(a, 3), t(i, function(s, c, l) {
      e(o, c, a(s, c, l));
    }), o;
  }
  return Yv = r, Yv;
}
var i8 = r8();
const a8 = /* @__PURE__ */ ct(i8);
var Kv, wE;
function o8() {
  if (wE) return Kv;
  wE = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (!n(t[r], r, t))
        return !1;
    return !0;
  }
  return Kv = e, Kv;
}
var Gv, _E;
function s8() {
  if (_E) return Gv;
  _E = 1;
  var e = mb();
  function t(n, r) {
    var i = !0;
    return e(n, function(a, o, s) {
      return i = !!r(a, o, s), i;
    }), i;
  }
  return Gv = t, Gv;
}
var Zv, SE;
function c8() {
  if (SE) return Zv;
  SE = 1;
  var e = o8(), t = s8(), n = li(), r = sn(), i = Gu();
  function a(o, s, c) {
    var l = r(o) ? e : t;
    return c && i(o, s, c) && (s = void 0), l(o, n(s, 3));
  }
  return Zv = a, Zv;
}
var l8 = c8();
const u8 = /* @__PURE__ */ ct(l8);
var d8 = ["x", "y"];
function Za(e) {
  "@babel/helpers - typeof";
  return Za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Za(e);
}
function Ug() {
  return Ug = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ug.apply(this, arguments);
}
function OE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OE(Object(n), !0).forEach(function(r) {
      f8(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function f8(e, t, n) {
  return t = h8(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function h8(e) {
  var t = m8(e, "string");
  return Za(t) == "symbol" ? t : t + "";
}
function m8(e, t) {
  if (Za(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Za(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function v8(e, t) {
  if (e == null) return {};
  var n = p8(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function p8(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function g8(e, t) {
  var n = e.x, r = e.y, i = v8(e, d8), a = "".concat(n), o = parseInt(a, 10), s = "".concat(r), c = parseInt(s, 10), l = "".concat(t.height || i.height), d = parseInt(l, 10), f = "".concat(t.width || i.width), h = parseInt(f, 10);
  return Fo(Fo(Fo(Fo(Fo({}, t), i), o ? {
    x: o
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: d,
    width: h,
    name: t.name,
    radius: t.radius
  });
}
function EE(e) {
  return /* @__PURE__ */ T.createElement(C6, Ug({
    shapeType: "rectangle",
    propTransformer: g8,
    activeClassName: "recharts-active-bar"
  }, e));
}
var y8 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var a = typeof r == "number";
    return a ? t(r, i) : (a || (process.env.NODE_ENV !== "production" ? an(!1, "minPointSize callback function received a value with type of ".concat(Za(r), ". Currently only numbers are supported.")) : an()), n);
  };
}, b8 = ["value", "background"], eN;
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
function x8(e, t) {
  if (e == null) return {};
  var n = w8(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function w8(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function su() {
  return su = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, su.apply(this, arguments);
}
function AE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? AE(Object(n), !0).forEach(function(r) {
      Jr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : AE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function PE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, nN(r.key), r);
  }
}
function S8(e, t, n) {
  return t && PE(e.prototype, t), n && PE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function O8(e, t, n) {
  return t = cu(t), E8(e, tN() ? Reflect.construct(t, n || [], cu(e).constructor) : t.apply(e, n));
}
function E8(e, t) {
  if (t && (Xa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return A8(e);
}
function A8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tN = function() {
    return !!e;
  })();
}
function cu(e) {
  return cu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, cu(e);
}
function P8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Hg(e, t);
}
function Hg(e, t) {
  return Hg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Hg(e, t);
}
function Jr(e, t, n) {
  return t = nN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nN(e) {
  var t = C8(e, "string");
  return Xa(t) == "symbol" ? t : t + "";
}
function C8(e, t) {
  if (Xa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Xa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var sa = /* @__PURE__ */ (function(e) {
  function t() {
    var n;
    _8(this, t);
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    return n = O8(this, t, [].concat(i)), Jr(n, "state", {
      isAnimationFinished: !1
    }), Jr(n, "id", qu("recharts-bar-")), Jr(n, "handleAnimationEnd", function() {
      var o = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Jr(n, "handleAnimationStart", function() {
      var o = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), o && o();
    }), n;
  }
  return P8(t, e), S8(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, a = this.props, o = a.shape, s = a.dataKey, c = a.activeIndex, l = a.activeBar, d = Ye(this.props, !1);
      return r && r.map(function(f, h) {
        var m = h === c, g = m ? l : o, p = xt(xt(xt({}, d), f), {}, {
          isActive: m,
          option: g,
          index: h,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ T.createElement(It, su({
          className: "recharts-bar-rectangle"
        }, wl(i.props, f, h), {
          key: "rectangle-".concat(f?.x, "-").concat(f?.y, "-").concat(f?.value)
        }), /* @__PURE__ */ T.createElement(EE, p));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, a = i.data, o = i.layout, s = i.isAnimationActive, c = i.animationBegin, l = i.animationDuration, d = i.animationEasing, f = i.animationId, h = this.state.prevData;
      return /* @__PURE__ */ T.createElement(ri, {
        begin: c,
        duration: l,
        isActive: s,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(m) {
        var g = m.t, p = a.map(function(v, y) {
          var x = h && h[y];
          if (x) {
            var w = da(x.x, v.x), _ = da(x.y, v.y), b = da(x.width, v.width), S = da(x.height, v.height);
            return xt(xt({}, v), {}, {
              x: w(g),
              y: _(g),
              width: b(g),
              height: S(g)
            });
          }
          if (o === "horizontal") {
            var O = da(0, v.height), E = O(g);
            return xt(xt({}, v), {}, {
              y: v.y + v.height - E,
              height: E
            });
          }
          var P = da(0, v.width), R = P(g);
          return xt(xt({}, v), {}, {
            width: R
          });
        });
        return /* @__PURE__ */ T.createElement(It, null, r.renderRectanglesStatically(p));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, a = r.isAnimationActive, o = this.state.prevData;
      return a && i && i.length && (!o || !Fb(o, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, a = i.data, o = i.dataKey, s = i.activeIndex, c = Ye(this.props.background, !1);
      return a.map(function(l, d) {
        l.value;
        var f = l.background, h = x8(l, b8);
        if (!f)
          return null;
        var m = xt(xt(xt(xt(xt({}, h), {}, {
          fill: "#eee"
        }, f), c), wl(r.props, l, d)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: o,
          index: d,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ T.createElement(EE, su({
          key: "background-bar-".concat(d),
          option: r.props.background,
          isActive: d === s
        }, m));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.data, s = a.xAxis, c = a.yAxis, l = a.layout, d = a.children, f = Kn(d, od);
      if (!f)
        return null;
      var h = l === "vertical" ? o[0].height / 2 : o[0].width / 2, m = function(v, y) {
        var x = Array.isArray(v.value) ? v.value[1] : v.value;
        return {
          x: v.x,
          y: v.y,
          value: x,
          errorVal: fr(v, y)
        };
      }, g = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ T.createElement(It, g, f.map(function(p) {
        return /* @__PURE__ */ T.cloneElement(p, {
          key: "error-bar-".concat(i, "-").concat(p.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: c,
          layout: l,
          offset: h,
          dataPointFormatter: m
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, a = r.data, o = r.className, s = r.xAxis, c = r.yAxis, l = r.left, d = r.top, f = r.width, h = r.height, m = r.isAnimationActive, g = r.background, p = r.id;
      if (i || !a || !a.length)
        return null;
      var v = this.state.isAnimationFinished, y = Fe("recharts-bar", o), x = s && s.allowDataOverflow, w = c && c.allowDataOverflow, _ = x || w, b = Ke(p) ? this.id : p;
      return /* @__PURE__ */ T.createElement(It, {
        className: y
      }, x || w ? /* @__PURE__ */ T.createElement("defs", null, /* @__PURE__ */ T.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ T.createElement("rect", {
        x: x ? l : l - f / 2,
        y: w ? d : d - h / 2,
        width: x ? f : f * 2,
        height: w ? h : h * 2
      }))) : null, /* @__PURE__ */ T.createElement(It, {
        className: "recharts-bar-rectangles",
        clipPath: _ ? "url(#clipPath-".concat(b, ")") : null
      }, g ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(_, b), (!m || v) && Fi.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
})(ta);
eN = sa;
Jr(sa, "displayName", "Bar");
Jr(sa, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !ac.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Jr(sa, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, i = e.bandSize, a = e.xAxis, o = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, l = e.stackedData, d = e.dataStartIndex, f = e.displayedData, h = e.offset, m = LU(r, n);
  if (!m)
    return null;
  var g = t.layout, p = n.type.defaultProps, v = p !== void 0 ? xt(xt({}, p), n.props) : n.props, y = v.dataKey, x = v.children, w = v.minPointSize, _ = g === "horizontal" ? o : a, b = l ? _.scale.domain() : null, S = UU({
    numericAxis: _
  }), O = Kn(x, gb), E = f.map(function(P, R) {
    var j, C, N, k, I, $;
    l ? j = $U(l[d + R], b) : (j = fr(P, y), Array.isArray(j) || (j = [S, j]));
    var z = y8(w, eN.defaultProps.minPointSize)(j[1], R);
    if (g === "horizontal") {
      var V, K = [o.scale(j[0]), o.scale(j[1])], D = K[0], U = K[1];
      C = aO({
        axis: a,
        ticks: s,
        bandSize: i,
        offset: m.offset,
        entry: P,
        index: R
      }), N = (V = U ?? D) !== null && V !== void 0 ? V : void 0, k = m.size;
      var Y = D - U;
      if (I = Number.isNaN(Y) ? 0 : Y, $ = {
        x: C,
        y: o.y,
        width: k,
        height: o.height
      }, Math.abs(z) > 0 && Math.abs(I) < Math.abs(z)) {
        var X = Un(I || z) * (Math.abs(z) - Math.abs(I));
        N -= X, I += X;
      }
    } else {
      var oe = [a.scale(j[0]), a.scale(j[1])], ie = oe[0], he = oe[1];
      if (C = ie, N = aO({
        axis: o,
        ticks: c,
        bandSize: i,
        offset: m.offset,
        entry: P,
        index: R
      }), k = he - ie, I = m.size, $ = {
        x: a.x,
        y: N,
        width: a.width,
        height: I
      }, Math.abs(z) > 0 && Math.abs(k) < Math.abs(z)) {
        var ee = Un(k || z) * (Math.abs(z) - Math.abs(k));
        k += ee;
      }
    }
    return xt(xt(xt({}, P), {}, {
      x: C,
      y: N,
      width: k,
      height: I,
      value: l ? j : j[1],
      payload: P,
      background: $
    }, O && O[R] && O[R].props), {}, {
      tooltipPayload: [RT(n, P)],
      tooltipPosition: {
        x: C + k / 2,
        y: N + I / 2
      }
    });
  });
  return xt({
    data: E,
    layout: g
  }, h);
});
function zs(e) {
  "@babel/helpers - typeof";
  return zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zs(e);
}
function j8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function CE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, rN(r.key), r);
  }
}
function T8(e, t, n) {
  return t && CE(e.prototype, t), n && CE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jE(Object(n), !0).forEach(function(r) {
      ld(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ld(e, t, n) {
  return t = rN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rN(e) {
  var t = N8(e, "string");
  return zs(t) == "symbol" ? t : t + "";
}
function N8(e, t) {
  if (zs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (zs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var M8 = function(t, n, r, i, a) {
  var o = t.width, s = t.height, c = t.layout, l = t.children, d = Object.keys(n), f = {
    left: r.left,
    leftMirror: r.left,
    right: o - r.right,
    rightMirror: o - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, h = !!fn(l, sa);
  return d.reduce(function(m, g) {
    var p = n[g], v = p.orientation, y = p.domain, x = p.padding, w = x === void 0 ? {} : x, _ = p.mirror, b = p.reversed, S = "".concat(v).concat(_ ? "Mirror" : ""), O, E, P, R, j;
    if (p.type === "number" && (p.padding === "gap" || p.padding === "no-gap")) {
      var C = y[1] - y[0], N = 1 / 0, k = p.categoricalDomain.sort();
      if (k.forEach(function(oe, ie) {
        ie > 0 && (N = Math.min((oe || 0) - (k[ie - 1] || 0), N));
      }), Number.isFinite(N)) {
        var I = N / C, $ = p.layout === "vertical" ? r.height : r.width;
        if (p.padding === "gap" && (O = I * $ / 2), p.padding === "no-gap") {
          var z = qi(t.barCategoryGap, I * $), V = I * $ / 2;
          O = V - z - (V - z) / $ * z;
        }
      }
    }
    i === "xAxis" ? E = [r.left + (w.left || 0) + (O || 0), r.left + r.width - (w.right || 0) - (O || 0)] : i === "yAxis" ? E = c === "horizontal" ? [r.top + r.height - (w.bottom || 0), r.top + (w.top || 0)] : [r.top + (w.top || 0) + (O || 0), r.top + r.height - (w.bottom || 0) - (O || 0)] : E = p.range, b && (E = [E[1], E[0]]);
    var K = kU(p, a, h), D = K.scale, U = K.realScaleType;
    D.domain(y).range(E), RU(D);
    var Y = WU(D, qn(qn({}, p), {}, {
      realScaleType: U
    }));
    i === "xAxis" ? (j = v === "top" && !_ || v === "bottom" && _, P = r.left, R = f[S] - j * p.height) : i === "yAxis" && (j = v === "left" && !_ || v === "right" && _, P = f[S] - j * p.width, R = r.top);
    var X = qn(qn(qn({}, p), Y), {}, {
      realScaleType: U,
      x: P,
      y: R,
      scale: D,
      width: i === "xAxis" ? r.width : p.width,
      height: i === "yAxis" ? r.height : p.height
    });
    return X.bandSize = Yl(X, Y), !p.hide && i === "xAxis" ? f[S] += (j ? -1 : 1) * X.height : p.hide || (f[S] += (j ? -1 : 1) * X.width), qn(qn({}, m), {}, ld({}, g, X));
  }, {});
}, iN = function(t, n) {
  var r = t.x, i = t.y, a = n.x, o = n.y;
  return {
    x: Math.min(r, a),
    y: Math.min(i, o),
    width: Math.abs(a - r),
    height: Math.abs(o - i)
  };
}, I8 = function(t) {
  var n = t.x1, r = t.y1, i = t.x2, a = t.y2;
  return iN({
    x: n,
    y: r
  }, {
    x: i,
    y: a
  });
}, aN = /* @__PURE__ */ (function() {
  function e(t) {
    j8(this, e), this.scale = t;
  }
  return T8(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, a = r.position;
      if (n !== void 0) {
        if (a)
          switch (a) {
            case "start":
              return this.scale(n);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (i) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + c;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), i = r[0], a = r[r.length - 1];
      return i <= a ? n >= i && n <= a : n >= a && n <= i;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
})();
ld(aN, "EPS", 1e-4);
var Hb = function(t) {
  var n = Object.keys(t).reduce(function(r, i) {
    return qn(qn({}, r), {}, ld({}, i, aN.create(t[i])));
  }, {});
  return qn(qn({}, n), {}, {
    apply: function(i) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.bandAware, s = a.position;
      return a8(i, function(c, l) {
        return n[l].apply(c, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return u8(i, function(a, o) {
        return n[o].isInRange(a);
      });
    }
  });
};
function D8(e) {
  return (e % 180 + 180) % 180;
}
var k8 = function(t) {
  var n = t.width, r = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = D8(i), o = a * Math.PI / 180, s = Math.atan(r / n), c = o > s && o < Math.PI - s ? r / Math.sin(o) : n / Math.cos(o);
  return Math.abs(c);
}, Xv, TE;
function R8() {
  if (TE) return Xv;
  TE = 1;
  var e = li(), t = ic(), n = Yu();
  function r(i) {
    return function(a, o, s) {
      var c = Object(a);
      if (!t(a)) {
        var l = e(o, 3);
        a = n(a), o = function(f) {
          return l(c[f], f, c);
        };
      }
      var d = i(a, o, s);
      return d > -1 ? c[l ? a[d] : d] : void 0;
    };
  }
  return Xv = r, Xv;
}
var Qv, NE;
function L8() {
  if (NE) return Qv;
  NE = 1;
  var e = ZT();
  function t(n) {
    var r = e(n), i = r % 1;
    return r === r ? i ? r - i : r : 0;
  }
  return Qv = t, Qv;
}
var Jv, ME;
function $8() {
  if (ME) return Jv;
  ME = 1;
  var e = bj(), t = li(), n = L8(), r = Math.max;
  function i(a, o, s) {
    var c = a == null ? 0 : a.length;
    if (!c)
      return -1;
    var l = s == null ? 0 : n(s);
    return l < 0 && (l = r(c + l, 0)), e(a, t(o, 3), l);
  }
  return Jv = i, Jv;
}
var ep, IE;
function B8() {
  if (IE) return ep;
  IE = 1;
  var e = R8(), t = $8(), n = e(t);
  return ep = n, ep;
}
B8();
var F8 = kC();
const z8 = /* @__PURE__ */ ct(F8);
var q8 = z8(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function lu(e) {
  "@babel/helpers - typeof";
  return lu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lu(e);
}
var oN = /* @__PURE__ */ hr(void 0), sN = /* @__PURE__ */ hr(void 0), cN = /* @__PURE__ */ hr(void 0), V8 = /* @__PURE__ */ hr({}), lN = /* @__PURE__ */ hr(void 0), uN = /* @__PURE__ */ hr(0), dN = /* @__PURE__ */ hr(0), DE = function(t) {
  var n = t.state, r = n.xAxisMap, i = n.yAxisMap, a = n.offset, o = t.clipPathId, s = t.children, c = t.width, l = t.height, d = q8(a);
  return /* @__PURE__ */ T.createElement(oN.Provider, {
    value: r
  }, /* @__PURE__ */ T.createElement(sN.Provider, {
    value: i
  }, /* @__PURE__ */ T.createElement(V8.Provider, {
    value: a
  }, /* @__PURE__ */ T.createElement(cN.Provider, {
    value: d
  }, /* @__PURE__ */ T.createElement(lN.Provider, {
    value: o
  }, /* @__PURE__ */ T.createElement(uN.Provider, {
    value: l
  }, /* @__PURE__ */ T.createElement(dN.Provider, {
    value: c
  }, s)))))));
}, W8 = function() {
  return si(lN);
};
function fN(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var hN = function(t) {
  var n = si(oN);
  n == null && (process.env.NODE_ENV !== "production" ? an(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : an());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? an(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(lu(t), "]. ").concat(fN(n))) : an()), r;
}, mN = function(t) {
  var n = si(sN);
  n == null && (process.env.NODE_ENV !== "production" ? an(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : an());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? an(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(lu(t), "]. ").concat(fN(n))) : an()), r;
}, U8 = function() {
  var t = si(cN);
  return t;
}, vN = function() {
  return si(dN);
}, pN = function() {
  return si(uN);
};
function Qa(e) {
  "@babel/helpers - typeof";
  return Qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qa(e);
}
function H8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Y8(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, yN(r.key), r);
  }
}
function K8(e, t, n) {
  return t && Y8(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function G8(e, t, n) {
  return t = uu(t), Z8(e, gN() ? Reflect.construct(t, n || [], uu(e).constructor) : t.apply(e, n));
}
function Z8(e, t) {
  if (t && (Qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return X8(e);
}
function X8(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gN = function() {
    return !!e;
  })();
}
function uu(e) {
  return uu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, uu(e);
}
function Q8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yg(e, t);
}
function Yg(e, t) {
  return Yg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Yg(e, t);
}
function kE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function RE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kE(Object(n), !0).forEach(function(r) {
      Yb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Yb(e, t, n) {
  return t = yN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yN(e) {
  var t = J8(e, "string");
  return Qa(t) == "symbol" ? t : t + "";
}
function J8(e, t) {
  if (Qa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Qa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function eY(e, t) {
  return iY(e) || rY(e, t) || nY(e, t) || tY();
}
function tY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nY(e, t) {
  if (e) {
    if (typeof e == "string") return LE(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LE(e, t);
  }
}
function LE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function rY(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function iY(e) {
  if (Array.isArray(e)) return e;
}
function Kg() {
  return Kg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kg.apply(this, arguments);
}
var aY = function(t, n) {
  var r;
  return /* @__PURE__ */ T.isValidElement(t) ? r = /* @__PURE__ */ T.cloneElement(t, n) : Re(t) ? r = t(n) : r = /* @__PURE__ */ T.createElement("line", Kg({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, oY = function(t, n, r, i, a, o, s, c, l) {
  var d = a.x, f = a.y, h = a.width, m = a.height;
  if (r) {
    var g = l.y, p = t.y.apply(g, {
      position: o
    });
    if (lr(l, "discard") && !t.y.isInRange(p))
      return null;
    var v = [{
      x: d + h,
      y: p
    }, {
      x: d,
      y: p
    }];
    return c === "left" ? v.reverse() : v;
  }
  if (n) {
    var y = l.x, x = t.x.apply(y, {
      position: o
    });
    if (lr(l, "discard") && !t.x.isInRange(x))
      return null;
    var w = [{
      x,
      y: f + m
    }, {
      x,
      y: f
    }];
    return s === "top" ? w.reverse() : w;
  }
  if (i) {
    var _ = l.segment, b = _.map(function(S) {
      return t.apply(S, {
        position: o
      });
    });
    return lr(l, "discard") && t8(b, function(S) {
      return !t.isInRange(S);
    }) ? null : b;
  }
  return null;
};
function sY(e) {
  var t = e.x, n = e.y, r = e.segment, i = e.xAxisId, a = e.yAxisId, o = e.shape, s = e.className, c = e.alwaysShow, l = W8(), d = hN(i), f = mN(a), h = U8();
  if (!l || !h)
    return null;
  Li(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var m = Hb({
    x: d.scale,
    y: f.scale
  }), g = Ct(t), p = Ct(n), v = r && r.length === 2, y = oY(m, g, p, v, h, e.position, d.orientation, f.orientation, e);
  if (!y)
    return null;
  var x = eY(y, 2), w = x[0], _ = w.x, b = w.y, S = x[1], O = S.x, E = S.y, P = lr(e, "hidden") ? "url(#".concat(l, ")") : void 0, R = RE(RE({
    clipPath: P
  }, Ye(e, !0)), {}, {
    x1: _,
    y1: b,
    x2: O,
    y2: E
  });
  return /* @__PURE__ */ T.createElement(It, {
    className: Fe("recharts-reference-line", s)
  }, aY(o, R), Kt.renderCallByParent(e, I8({
    x1: _,
    y1: b,
    x2: O,
    y2: E
  })));
}
var Kb = /* @__PURE__ */ (function(e) {
  function t() {
    return H8(this, t), G8(this, t, arguments);
  }
  return Q8(t, e), K8(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ T.createElement(sY, this.props);
    }
  }]);
})(T.Component);
Yb(Kb, "displayName", "ReferenceLine");
Yb(Kb, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Gg() {
  return Gg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gg.apply(this, arguments);
}
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function $E(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $E(Object(n), !0).forEach(function(r) {
      ud(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $E(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, xN(r.key), r);
  }
}
function uY(e, t, n) {
  return t && lY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function dY(e, t, n) {
  return t = du(t), fY(e, bN() ? Reflect.construct(t, n || [], du(e).constructor) : t.apply(e, n));
}
function fY(e, t) {
  if (t && (Ja(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hY(e);
}
function hY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bN = function() {
    return !!e;
  })();
}
function du(e) {
  return du = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, du(e);
}
function mY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Zg(e, t);
}
function Zg(e, t) {
  return Zg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Zg(e, t);
}
function ud(e, t, n) {
  return t = xN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xN(e) {
  var t = vY(e, "string");
  return Ja(t) == "symbol" ? t : t + "";
}
function vY(e, t) {
  if (Ja(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ja(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var pY = function(t) {
  var n = t.x, r = t.y, i = t.xAxis, a = t.yAxis, o = Hb({
    x: i.scale,
    y: a.scale
  }), s = o.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return lr(t, "discard") && !o.isInRange(s) ? null : s;
}, dd = /* @__PURE__ */ (function(e) {
  function t() {
    return cY(this, t), dY(this, t, arguments);
  }
  return mY(t, e), uY(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, a = r.y, o = r.r, s = r.alwaysShow, c = r.clipPathId, l = Ct(i), d = Ct(a);
      if (Li(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !l || !d)
        return null;
      var f = pY(this.props);
      if (!f)
        return null;
      var h = f.x, m = f.y, g = this.props, p = g.shape, v = g.className, y = lr(this.props, "hidden") ? "url(#".concat(c, ")") : void 0, x = BE(BE({
        clipPath: y
      }, Ye(this.props, !0)), {}, {
        cx: h,
        cy: m
      });
      return /* @__PURE__ */ T.createElement(It, {
        className: Fe("recharts-reference-dot", v)
      }, t.renderDot(p, x), Kt.renderCallByParent(this.props, {
        x: h - o,
        y: m - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
})(T.Component);
ud(dd, "displayName", "ReferenceDot");
ud(dd, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
ud(dd, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ T.isValidElement(e) ? n = /* @__PURE__ */ T.cloneElement(e, t) : Re(e) ? n = e(t) : n = /* @__PURE__ */ T.createElement(GT, Gg({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function Xg() {
  return Xg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xg.apply(this, arguments);
}
function eo(e) {
  "@babel/helpers - typeof";
  return eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, eo(e);
}
function FE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FE(Object(n), !0).forEach(function(r) {
      fd(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function yY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _N(r.key), r);
  }
}
function bY(e, t, n) {
  return t && yY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xY(e, t, n) {
  return t = fu(t), wY(e, wN() ? Reflect.construct(t, n || [], fu(e).constructor) : t.apply(e, n));
}
function wY(e, t) {
  if (t && (eo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _Y(e);
}
function _Y(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wN = function() {
    return !!e;
  })();
}
function fu(e) {
  return fu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fu(e);
}
function SY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Qg(e, t);
}
function Qg(e, t) {
  return Qg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Qg(e, t);
}
function fd(e, t, n) {
  return t = _N(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _N(e) {
  var t = OY(e, "string");
  return eo(t) == "symbol" ? t : t + "";
}
function OY(e, t) {
  if (eo(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (eo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var EY = function(t, n, r, i, a) {
  var o = a.x1, s = a.x2, c = a.y1, l = a.y2, d = a.xAxis, f = a.yAxis;
  if (!d || !f) return null;
  var h = Hb({
    x: d.scale,
    y: f.scale
  }), m = {
    x: t ? h.x.apply(o, {
      position: "start"
    }) : h.x.rangeMin,
    y: r ? h.y.apply(c, {
      position: "start"
    }) : h.y.rangeMin
  }, g = {
    x: n ? h.x.apply(s, {
      position: "end"
    }) : h.x.rangeMax,
    y: i ? h.y.apply(l, {
      position: "end"
    }) : h.y.rangeMax
  };
  return lr(a, "discard") && (!h.isInRange(m) || !h.isInRange(g)) ? null : iN(m, g);
}, hd = /* @__PURE__ */ (function(e) {
  function t() {
    return gY(this, t), xY(this, t, arguments);
  }
  return SY(t, e), bY(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, a = r.x2, o = r.y1, s = r.y2, c = r.className, l = r.alwaysShow, d = r.clipPathId;
      Li(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = Ct(i), h = Ct(a), m = Ct(o), g = Ct(s), p = this.props.shape;
      if (!f && !h && !m && !g && !p)
        return null;
      var v = EY(f, h, m, g, this.props);
      if (!v && !p)
        return null;
      var y = lr(this.props, "hidden") ? "url(#".concat(d, ")") : void 0;
      return /* @__PURE__ */ T.createElement(It, {
        className: Fe("recharts-reference-area", c)
      }, t.renderRect(p, zE(zE({
        clipPath: y
      }, Ye(this.props, !0)), v)), Kt.renderCallByParent(this.props, v));
    }
  }]);
})(T.Component);
fd(hd, "displayName", "ReferenceArea");
fd(hd, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
fd(hd, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ T.isValidElement(e) ? n = /* @__PURE__ */ T.cloneElement(e, t) : Re(e) ? n = e(t) : n = /* @__PURE__ */ T.createElement(Ub, Xg({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function SN(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], i = 0; i < e.length; i += t)
    r.push(e[i]);
  return r;
}
function AY(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return k8(r, n);
}
function PY(e, t, n) {
  var r = n === "width", i = e.x, a = e.y, o = e.width, s = e.height;
  return t === 1 ? {
    start: r ? i : a,
    end: r ? i + o : a + s
  } : {
    start: r ? i + o : a + s,
    end: r ? i : a
  };
}
function hu(e, t, n, r, i) {
  if (e * t < e * r || e * t > e * i)
    return !1;
  var a = n();
  return e * (t - e * a / 2 - r) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function CY(e, t) {
  return SN(e, t + 1);
}
function jY(e, t, n, r, i) {
  for (var a = (r || []).slice(), o = t.start, s = t.end, c = 0, l = 1, d = o, f = function() {
    var g = r?.[c];
    if (g === void 0)
      return {
        v: SN(r, l)
      };
    var p = c, v, y = function() {
      return v === void 0 && (v = n(g, p)), v;
    }, x = g.coordinate, w = c === 0 || hu(e, x, y, d, s);
    w || (c = 0, d = o, l += 1), w && (d = x + e * (y() / 2 + i), c += l);
  }, h; l <= a.length; )
    if (h = f(), h) return h.v;
  return [];
}
function qs(e) {
  "@babel/helpers - typeof";
  return qs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qs(e);
}
function qE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qE(Object(n), !0).forEach(function(r) {
      TY(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function TY(e, t, n) {
  return t = NY(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function NY(e) {
  var t = MY(e, "string");
  return qs(t) == "symbol" ? t : t + "";
}
function MY(e, t) {
  if (qs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (qs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IY(e, t, n, r, i) {
  for (var a = (r || []).slice(), o = a.length, s = t.start, c = t.end, l = function(h) {
    var m = a[h], g, p = function() {
      return g === void 0 && (g = n(m, h)), g;
    };
    if (h === o - 1) {
      var v = e * (m.coordinate + e * p() / 2 - c);
      a[h] = m = Ht(Ht({}, m), {}, {
        tickCoord: v > 0 ? m.coordinate - v * e : m.coordinate
      });
    } else
      a[h] = m = Ht(Ht({}, m), {}, {
        tickCoord: m.coordinate
      });
    var y = hu(e, m.tickCoord, p, s, c);
    y && (c = m.tickCoord - e * (p() / 2 + i), a[h] = Ht(Ht({}, m), {}, {
      isShow: !0
    }));
  }, d = o - 1; d >= 0; d--)
    l(d);
  return a;
}
function DY(e, t, n, r, i, a) {
  var o = (r || []).slice(), s = o.length, c = t.start, l = t.end;
  if (a) {
    var d = r[s - 1], f = n(d, s - 1), h = e * (d.coordinate + e * f / 2 - l);
    o[s - 1] = d = Ht(Ht({}, d), {}, {
      tickCoord: h > 0 ? d.coordinate - h * e : d.coordinate
    });
    var m = hu(e, d.tickCoord, function() {
      return f;
    }, c, l);
    m && (l = d.tickCoord - e * (f / 2 + i), o[s - 1] = Ht(Ht({}, d), {}, {
      isShow: !0
    }));
  }
  for (var g = a ? s - 1 : s, p = function(x) {
    var w = o[x], _, b = function() {
      return _ === void 0 && (_ = n(w, x)), _;
    };
    if (x === 0) {
      var S = e * (w.coordinate - e * b() / 2 - c);
      o[x] = w = Ht(Ht({}, w), {}, {
        tickCoord: S < 0 ? w.coordinate - S * e : w.coordinate
      });
    } else
      o[x] = w = Ht(Ht({}, w), {}, {
        tickCoord: w.coordinate
      });
    var O = hu(e, w.tickCoord, b, c, l);
    O && (c = w.tickCoord + e * (b() / 2 + i), o[x] = Ht(Ht({}, w), {}, {
      isShow: !0
    }));
  }, v = 0; v < g; v++)
    p(v);
  return o;
}
function kY(e, t, n) {
  var r = e.tick, i = e.ticks, a = e.viewBox, o = e.minTickGap, s = e.orientation, c = e.interval, l = e.tickFormatter, d = e.unit, f = e.angle;
  if (!i || !i.length || !r)
    return [];
  if (me(c) || ac.isSsr)
    return CY(i, typeof c == "number" && me(c) ? c : 0);
  var h = [], m = s === "top" || s === "bottom" ? "width" : "height", g = d && m === "width" ? ts(d, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, p = function(w, _) {
    var b = Re(l) ? l(w.value, _) : w.value;
    return m === "width" ? AY(ts(b, {
      fontSize: t,
      letterSpacing: n
    }), g, f) : ts(b, {
      fontSize: t,
      letterSpacing: n
    })[m];
  }, v = i.length >= 2 ? Un(i[1].coordinate - i[0].coordinate) : 1, y = PY(a, v, m);
  return c === "equidistantPreserveStart" ? jY(v, y, p, i, o) : (c === "preserveStart" || c === "preserveStartEnd" ? h = DY(v, y, p, i, o, c === "preserveStartEnd") : h = IY(v, y, p, i, o), h.filter(function(x) {
    return x.isShow;
  }));
}
var RY = ["viewBox"], LY = ["viewBox"], $Y = ["ticks"];
function to(e) {
  "@babel/helpers - typeof";
  return to = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, to(e);
}
function wa() {
  return wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wa.apply(this, arguments);
}
function VE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Qt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VE(Object(n), !0).forEach(function(r) {
      Gb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function tp(e, t) {
  if (e == null) return {};
  var n = BY(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function BY(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function FY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function WE(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, EN(r.key), r);
  }
}
function zY(e, t, n) {
  return t && WE(e.prototype, t), n && WE(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qY(e, t, n) {
  return t = mu(t), VY(e, ON() ? Reflect.construct(t, n || [], mu(e).constructor) : t.apply(e, n));
}
function VY(e, t) {
  if (t && (to(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WY(e);
}
function WY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ON() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ON = function() {
    return !!e;
  })();
}
function mu(e) {
  return mu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, mu(e);
}
function UY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Jg(e, t);
}
function Jg(e, t) {
  return Jg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Jg(e, t);
}
function Gb(e, t, n) {
  return t = EN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function EN(e) {
  var t = HY(e, "string");
  return to(t) == "symbol" ? t : t + "";
}
function HY(e, t) {
  if (to(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (to(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var md = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r;
    return FY(this, t), r = qY(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return UY(t, e), zY(t, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var a = r.viewBox, o = tp(r, RY), s = this.props, c = s.viewBox, l = tp(s, LY);
      return !Ea(a, c) || !Ea(o, l) || !Ea(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, a = i.x, o = i.y, s = i.width, c = i.height, l = i.orientation, d = i.tickSize, f = i.mirror, h = i.tickMargin, m, g, p, v, y, x, w = f ? -1 : 1, _ = r.tickSize || d, b = me(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (l) {
        case "top":
          m = g = r.coordinate, v = o + +!f * c, p = v - w * _, x = p - w * h, y = b;
          break;
        case "left":
          p = v = r.coordinate, g = a + +!f * s, m = g - w * _, y = m - w * h, x = b;
          break;
        case "right":
          p = v = r.coordinate, g = a + +f * s, m = g + w * _, y = m + w * h, x = b;
          break;
        default:
          m = g = r.coordinate, v = o + +f * c, p = v + w * _, x = p + w * h, y = b;
          break;
      }
      return {
        line: {
          x1: m,
          y1: p,
          x2: g,
          y2: v
        },
        tick: {
          x: y,
          y: x
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, a = r.mirror, o;
      switch (i) {
        case "left":
          o = a ? "start" : "end";
          break;
        case "right":
          o = a ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, a = r.mirror, o = "end";
      switch (i) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = a ? "start" : "end";
          break;
        default:
          o = a ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, a = r.y, o = r.width, s = r.height, c = r.orientation, l = r.mirror, d = r.axisLine, f = Qt(Qt(Qt({}, Ye(this.props, !1)), Ye(d, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var h = +(c === "top" && !l || c === "bottom" && l);
        f = Qt(Qt({}, f), {}, {
          x1: i,
          y1: a + h * s,
          x2: i + o,
          y2: a + h * s
        });
      } else {
        var m = +(c === "left" && !l || c === "right" && l);
        f = Qt(Qt({}, f), {}, {
          x1: i + m * o,
          y1: a,
          x2: i + m * o,
          y2: a + s
        });
      }
      return /* @__PURE__ */ T.createElement("line", wa({}, f, {
        className: Fe("recharts-cartesian-axis-line", Tn(d, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, a) {
        var o = this, s = this.props, c = s.tickLine, l = s.stroke, d = s.tick, f = s.tickFormatter, h = s.unit, m = kY(Qt(Qt({}, this.props), {}, {
          ticks: r
        }), i, a), g = this.getTickTextAnchor(), p = this.getTickVerticalAnchor(), v = Ye(this.props, !1), y = Ye(d, !1), x = Qt(Qt({}, v), {}, {
          fill: "none"
        }, Ye(c, !1)), w = m.map(function(_, b) {
          var S = o.getTickLineCoord(_), O = S.line, E = S.tick, P = Qt(Qt(Qt(Qt({
            textAnchor: g,
            verticalAnchor: p
          }, v), {}, {
            stroke: "none",
            fill: l
          }, y), E), {}, {
            index: b,
            payload: _,
            visibleTicksCount: m.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ T.createElement(It, wa({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(_.value, "-").concat(_.coordinate, "-").concat(_.tickCoord)
          }, wl(o.props, _, b)), c && /* @__PURE__ */ T.createElement("line", wa({}, x, O, {
            className: Fe("recharts-cartesian-axis-tick-line", Tn(c, "className"))
          })), d && t.renderTickItem(d, P, "".concat(Re(f) ? f(_.value, b) : _.value).concat(h || "")));
        });
        return /* @__PURE__ */ T.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, w);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.axisLine, o = i.width, s = i.height, c = i.ticksGenerator, l = i.className, d = i.hide;
      if (d)
        return null;
      var f = this.props, h = f.ticks, m = tp(f, $Y), g = h;
      return Re(c) && (g = h && h.length > 0 ? c(this.props) : c(m)), o <= 0 || s <= 0 || !g || !g.length ? null : /* @__PURE__ */ T.createElement(It, {
        className: Fe("recharts-cartesian-axis", l),
        ref: function(v) {
          r.layerReference = v;
        }
      }, a && this.renderAxisLine(), this.renderTicks(g, this.state.fontSize, this.state.letterSpacing), Kt.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, a) {
      var o;
      return /* @__PURE__ */ T.isValidElement(r) ? o = /* @__PURE__ */ T.cloneElement(r, i) : Re(r) ? o = r(i) : o = /* @__PURE__ */ T.createElement(Ml, wa({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), o;
    }
  }]);
})(CC);
Gb(md, "displayName", "CartesianAxis");
Gb(md, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
function no(e) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, no(e);
}
function YY(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function KY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, CN(r.key), r);
  }
}
function GY(e, t, n) {
  return t && KY(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ZY(e, t, n) {
  return t = vu(t), XY(e, AN() ? Reflect.construct(t, n || [], vu(e).constructor) : t.apply(e, n));
}
function XY(e, t) {
  if (t && (no(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return QY(e);
}
function QY(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (AN = function() {
    return !!e;
  })();
}
function vu(e) {
  return vu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, vu(e);
}
function JY(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ey(e, t);
}
function ey(e, t) {
  return ey = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ey(e, t);
}
function PN(e, t, n) {
  return t = CN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function CN(e) {
  var t = e9(e, "string");
  return no(t) == "symbol" ? t : t + "";
}
function e9(e, t) {
  if (no(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (no(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ty() {
  return ty = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ty.apply(this, arguments);
}
function t9(e) {
  var t = e.xAxisId, n = vN(), r = pN(), i = hN(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ T.createElement(md, ty({}, i, {
      className: Fe("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(o) {
        return Ii(o, !0);
      }
    }))
  );
}
var Zb = /* @__PURE__ */ (function(e) {
  function t() {
    return YY(this, t), ZY(this, t, arguments);
  }
  return JY(t, e), GY(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ T.createElement(t9, this.props);
    }
  }]);
})(T.Component);
PN(Zb, "displayName", "XAxis");
PN(Zb, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
function n9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function r9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, NN(r.key), r);
  }
}
function i9(e, t, n) {
  return t && r9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function a9(e, t, n) {
  return t = pu(t), o9(e, jN() ? Reflect.construct(t, n || [], pu(e).constructor) : t.apply(e, n));
}
function o9(e, t) {
  if (t && (ro(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return s9(e);
}
function s9(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jN = function() {
    return !!e;
  })();
}
function pu(e) {
  return pu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, pu(e);
}
function c9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ny(e, t);
}
function ny(e, t) {
  return ny = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ny(e, t);
}
function TN(e, t, n) {
  return t = NN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function NN(e) {
  var t = l9(e, "string");
  return ro(t) == "symbol" ? t : t + "";
}
function l9(e, t) {
  if (ro(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ro(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ry() {
  return ry = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ry.apply(this, arguments);
}
var u9 = function(t) {
  var n = t.yAxisId, r = vN(), i = pN(), a = mN(n);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ T.createElement(md, ry({}, a, {
      className: Fe("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(s) {
        return Ii(s, !0);
      }
    }))
  );
}, Xb = /* @__PURE__ */ (function(e) {
  function t() {
    return n9(this, t), a9(this, t, arguments);
  }
  return c9(t, e), i9(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ T.createElement(u9, this.props);
    }
  }]);
})(T.Component);
TN(Xb, "displayName", "YAxis");
TN(Xb, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function UE(e) {
  return m9(e) || h9(e) || f9(e) || d9();
}
function d9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f9(e, t) {
  if (e) {
    if (typeof e == "string") return iy(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return iy(e, t);
  }
}
function h9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function m9(e) {
  if (Array.isArray(e)) return iy(e);
}
function iy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var ay = function(t, n, r, i, a) {
  var o = Kn(t, Kb), s = Kn(t, dd), c = [].concat(UE(o), UE(s)), l = Kn(t, hd), d = "".concat(i, "Id"), f = i[0], h = n;
  if (c.length && (h = c.reduce(function(p, v) {
    if (v.props[d] === r && lr(v.props, "extendDomain") && me(v.props[f])) {
      var y = v.props[f];
      return [Math.min(p[0], y), Math.max(p[1], y)];
    }
    return p;
  }, h)), l.length) {
    var m = "".concat(f, "1"), g = "".concat(f, "2");
    h = l.reduce(function(p, v) {
      if (v.props[d] === r && lr(v.props, "extendDomain") && me(v.props[m]) && me(v.props[g])) {
        var y = v.props[m], x = v.props[g];
        return [Math.min(p[0], y, x), Math.max(p[1], y, x)];
      }
      return p;
    }, h);
  }
  return a && a.length && (h = a.reduce(function(p, v) {
    return me(v) ? [Math.min(p[0], v), Math.max(p[1], v)] : p;
  }, h)), h;
}, np = { exports: {} }, HE;
function v9() {
  return HE || (HE = 1, (function(e) {
    var t = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function i(c, l, d) {
      this.fn = c, this.context = l, this.once = d || !1;
    }
    function a(c, l, d, f, h) {
      if (typeof d != "function")
        throw new TypeError("The listener must be a function");
      var m = new i(d, f || c, h), g = n ? n + l : l;
      return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], m] : c._events[g].push(m) : (c._events[g] = m, c._eventsCount++), c;
    }
    function o(c, l) {
      --c._eventsCount === 0 ? c._events = new r() : delete c._events[l];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var l = [], d, f;
      if (this._eventsCount === 0) return l;
      for (f in d = this._events)
        t.call(d, f) && l.push(n ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(d)) : l;
    }, s.prototype.listeners = function(l) {
      var d = n ? n + l : l, f = this._events[d];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var h = 0, m = f.length, g = new Array(m); h < m; h++)
        g[h] = f[h].fn;
      return g;
    }, s.prototype.listenerCount = function(l) {
      var d = n ? n + l : l, f = this._events[d];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(l, d, f, h, m, g) {
      var p = n ? n + l : l;
      if (!this._events[p]) return !1;
      var v = this._events[p], y = arguments.length, x, w;
      if (v.fn) {
        switch (v.once && this.removeListener(l, v.fn, void 0, !0), y) {
          case 1:
            return v.fn.call(v.context), !0;
          case 2:
            return v.fn.call(v.context, d), !0;
          case 3:
            return v.fn.call(v.context, d, f), !0;
          case 4:
            return v.fn.call(v.context, d, f, h), !0;
          case 5:
            return v.fn.call(v.context, d, f, h, m), !0;
          case 6:
            return v.fn.call(v.context, d, f, h, m, g), !0;
        }
        for (w = 1, x = new Array(y - 1); w < y; w++)
          x[w - 1] = arguments[w];
        v.fn.apply(v.context, x);
      } else {
        var _ = v.length, b;
        for (w = 0; w < _; w++)
          switch (v[w].once && this.removeListener(l, v[w].fn, void 0, !0), y) {
            case 1:
              v[w].fn.call(v[w].context);
              break;
            case 2:
              v[w].fn.call(v[w].context, d);
              break;
            case 3:
              v[w].fn.call(v[w].context, d, f);
              break;
            case 4:
              v[w].fn.call(v[w].context, d, f, h);
              break;
            default:
              if (!x) for (b = 1, x = new Array(y - 1); b < y; b++)
                x[b - 1] = arguments[b];
              v[w].fn.apply(v[w].context, x);
          }
      }
      return !0;
    }, s.prototype.on = function(l, d, f) {
      return a(this, l, d, f, !1);
    }, s.prototype.once = function(l, d, f) {
      return a(this, l, d, f, !0);
    }, s.prototype.removeListener = function(l, d, f, h) {
      var m = n ? n + l : l;
      if (!this._events[m]) return this;
      if (!d)
        return o(this, m), this;
      var g = this._events[m];
      if (g.fn)
        g.fn === d && (!h || g.once) && (!f || g.context === f) && o(this, m);
      else {
        for (var p = 0, v = [], y = g.length; p < y; p++)
          (g[p].fn !== d || h && !g[p].once || f && g[p].context !== f) && v.push(g[p]);
        v.length ? this._events[m] = v.length === 1 ? v[0] : v : o(this, m);
      }
      return this;
    }, s.prototype.removeAllListeners = function(l) {
      var d;
      return l ? (d = n ? n + l : l, this._events[d] && o(this, d)) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
  })(np)), np.exports;
}
var p9 = v9();
const g9 = /* @__PURE__ */ ct(p9);
var rp = new g9(), ip = "recharts.syncMouseEvents";
function Vs(e) {
  "@babel/helpers - typeof";
  return Vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vs(e);
}
function y9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, MN(r.key), r);
  }
}
function x9(e, t, n) {
  return t && b9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ap(e, t, n) {
  return t = MN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function MN(e) {
  var t = w9(e, "string");
  return Vs(t) == "symbol" ? t : t + "";
}
function w9(e, t) {
  if (Vs(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Vs(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var _9 = /* @__PURE__ */ (function() {
  function e() {
    y9(this, e), ap(this, "activeIndex", 0), ap(this, "coordinateList", []), ap(this, "layout", "horizontal");
  }
  return x9(e, [{
    key: "setDetails",
    value: function(n) {
      var r, i = n.coordinateList, a = i === void 0 ? null : i, o = n.container, s = o === void 0 ? null : o, c = n.layout, l = c === void 0 ? null : c, d = n.offset, f = d === void 0 ? null : d, h = n.mouseHandlerCallback, m = h === void 0 ? null : h;
      this.coordinateList = (r = a ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = l ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = m ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), a = i.x, o = i.y, s = i.height, c = this.coordinateList[this.activeIndex].coordinate, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, d = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, f = a + c + l, h = o + this.offset.top + s / 2 + d;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: h
        });
      }
    }
  }]);
})();
function S9(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e?.[0], i = e?.[1];
    if (r && i && me(r) && me(i))
      return !0;
  }
  return !1;
}
function O9(e, t, n, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - i,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function IN(e) {
  var t = e.cx, n = e.cy, r = e.radius, i = e.startAngle, a = e.endAngle, o = qt(t, n, r, i), s = qt(t, n, r, a);
  return {
    points: [o, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: i,
    endAngle: a
  };
}
function E9(e, t, n) {
  var r, i, a, o;
  if (e === "horizontal")
    r = t.x, a = r, i = n.top, o = n.top + n.height;
  else if (e === "vertical")
    i = t.y, o = i, r = n.left, a = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, l = t.innerRadius, d = t.outerRadius, f = t.angle, h = qt(s, c, l, f), m = qt(s, c, d, f);
      r = h.x, i = h.y, a = m.x, o = m.y;
    } else
      return IN(t);
  return [{
    x: r,
    y: i
  }, {
    x: a,
    y: o
  }];
}
function Ws(e) {
  "@babel/helpers - typeof";
  return Ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ws(e);
}
function YE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YE(Object(n), !0).forEach(function(r) {
      A9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A9(e, t, n) {
  return t = P9(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function P9(e) {
  var t = C9(e, "string");
  return Ws(t) == "symbol" ? t : t + "";
}
function C9(e, t) {
  if (Ws(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ws(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function j9(e) {
  var t, n, r = e.element, i = e.tooltipEventType, a = e.isActive, o = e.activeCoordinate, s = e.activePayload, c = e.offset, l = e.activeTooltipIndex, d = e.tooltipAxisBandSize, f = e.layout, h = e.chartName, m = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !m || !a || !o || h !== "ScatterChart" && i !== "axis")
    return null;
  var g, p = _O;
  if (h === "ScatterChart")
    g = o, p = t6;
  else if (h === "BarChart")
    g = O9(f, o, c, d), p = Ub;
  else if (f === "radial") {
    var v = IN(o), y = v.cx, x = v.cy, w = v.radius, _ = v.startAngle, b = v.endAngle;
    g = {
      cx: y,
      cy: x,
      startAngle: _,
      endAngle: b,
      innerRadius: w,
      outerRadius: w
    }, p = BT;
  } else
    g = {
      points: E9(f, o, c)
    }, p = _O;
  var S = Yc(Yc(Yc(Yc({
    stroke: "#ccc",
    pointerEvents: "none"
  }, c), g), Ye(m, !1)), {}, {
    payload: s,
    payloadIndex: l,
    className: Fe("recharts-tooltip-cursor", m.className)
  });
  return /* @__PURE__ */ Yn(m) ? /* @__PURE__ */ _t(m, S) : /* @__PURE__ */ Yy(p, S);
}
var T9 = ["item"], N9 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function io(e) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, io(e);
}
function _a() {
  return _a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _a.apply(this, arguments);
}
function KE(e, t) {
  return D9(e) || I9(e, t) || kN(e, t) || M9();
}
function M9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I9(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0) ;
    } catch (d) {
      l = !0, i = d;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
function D9(e) {
  if (Array.isArray(e)) return e;
}
function GE(e, t) {
  if (e == null) return {};
  var n = k9(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function k9(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function R9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function L9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, RN(r.key), r);
  }
}
function $9(e, t, n) {
  return t && L9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function B9(e, t, n) {
  return t = gu(t), F9(e, DN() ? Reflect.construct(t, n || [], gu(e).constructor) : t.apply(e, n));
}
function F9(e, t) {
  if (t && (io(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return z9(e);
}
function z9(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DN = function() {
    return !!e;
  })();
}
function gu(e) {
  return gu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, gu(e);
}
function q9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && oy(e, t);
}
function oy(e, t) {
  return oy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, oy(e, t);
}
function ao(e) {
  return U9(e) || W9(e) || kN(e) || V9();
}
function V9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kN(e, t) {
  if (e) {
    if (typeof e == "string") return sy(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sy(e, t);
  }
}
function W9(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function U9(e) {
  if (Array.isArray(e)) return sy(e);
}
function sy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ZE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Z(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZE(Object(n), !0).forEach(function(r) {
      _e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _e(e, t, n) {
  return t = RN(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function RN(e) {
  var t = H9(e, "string");
  return io(t) == "symbol" ? t : t + "";
}
function H9(e, t) {
  if (io(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (io(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Y9 = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, K9 = {
  width: "100%",
  height: "100%"
}, LN = {
  x: 0,
  y: 0
};
function Kc(e) {
  return e;
}
var G9 = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, Z9 = function(t, n, r, i) {
  var a = n.find(function(d) {
    return d && d.index === r;
  });
  if (a) {
    if (t === "horizontal")
      return {
        x: a.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: a.coordinate
      };
    if (t === "centric") {
      var o = a.coordinate, s = i.radius;
      return Z(Z(Z({}, i), qt(i.cx, i.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var c = a.coordinate, l = i.angle;
    return Z(Z(Z({}, i), qt(i.cx, i.cy, c, l)), {}, {
      angle: l,
      radius: c
    });
  }
  return LN;
}, vd = function(t, n) {
  var r = n.graphicalItems, i = n.dataStartIndex, a = n.dataEndIndex, o = (r ?? []).reduce(function(s, c) {
    var l = c.props.data;
    return l && l.length ? [].concat(ao(s), ao(l)) : s;
  }, []);
  return o.length > 0 ? o : t && t.length && me(i) && me(a) ? t.slice(i, a + 1) : [];
};
function $N(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var cy = function(t, n, r, i) {
  var a = t.graphicalItems, o = t.tooltipAxis, s = vd(n, t);
  return r < 0 || !a || !a.length || r >= s.length ? null : a.reduce(function(c, l) {
    var d, f = (d = l.props.data) !== null && d !== void 0 ? d : n;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var h;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var m = f === void 0 ? s : f;
      h = Kp(m, o.dataKey, i);
    } else
      h = f && f[r] || s[r];
    return h ? [].concat(ao(c), [RT(l, h)]) : c;
  }, []);
}, XE = function(t, n, r, i) {
  var a = i || {
    x: t.chartX,
    y: t.chartY
  }, o = G9(a, r), s = t.orderedTooltipTicks, c = t.tooltipAxis, l = t.tooltipTicks, d = jU(o, s, l, c);
  if (d >= 0 && l) {
    var f = l[d] && l[d].value, h = cy(t, n, d, f), m = Z9(r, s, d, a);
    return {
      activeTooltipIndex: d,
      activeLabel: f,
      activePayload: h,
      activeCoordinate: m
    };
  }
  return null;
}, X9 = function(t, n) {
  var r = n.axes, i = n.graphicalItems, a = n.axisType, o = n.axisIdKey, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, d = t.layout, f = t.children, h = t.stackOffset, m = DT(d, a);
  return r.reduce(function(g, p) {
    var v, y = p.type.defaultProps !== void 0 ? Z(Z({}, p.type.defaultProps), p.props) : p.props, x = y.type, w = y.dataKey, _ = y.allowDataOverflow, b = y.allowDuplicatedCategory, S = y.scale, O = y.ticks, E = y.includeHidden, P = y[o];
    if (g[P])
      return g;
    var R = vd(t.data, {
      graphicalItems: i.filter(function(Y) {
        var X, oe = o in Y.props ? Y.props[o] : (X = Y.type.defaultProps) === null || X === void 0 ? void 0 : X[o];
        return oe === P;
      }),
      dataStartIndex: c,
      dataEndIndex: l
    }), j = R.length, C, N, k;
    S9(y.domain, _, x) && (C = Cg(y.domain, null, _), m && (x === "number" || S !== "auto") && (k = rs(R, w, "category")));
    var I = $N(x);
    if (!C || C.length === 0) {
      var $, z = ($ = y.domain) !== null && $ !== void 0 ? $ : I;
      if (w) {
        if (C = rs(R, w, x), x === "category" && m) {
          var V = x$(C);
          b && V ? (N = C, C = iu(0, j)) : b || (C = cO(z, C, p).reduce(function(Y, X) {
            return Y.indexOf(X) >= 0 ? Y : [].concat(ao(Y), [X]);
          }, []));
        } else if (x === "category")
          b ? C = C.filter(function(Y) {
            return Y !== "" && !Ke(Y);
          }) : C = cO(z, C, p).reduce(function(Y, X) {
            return Y.indexOf(X) >= 0 || X === "" || Ke(X) ? Y : [].concat(ao(Y), [X]);
          }, []);
        else if (x === "number") {
          var K = DU(R, i.filter(function(Y) {
            var X, oe, ie = o in Y.props ? Y.props[o] : (X = Y.type.defaultProps) === null || X === void 0 ? void 0 : X[o], he = "hide" in Y.props ? Y.props.hide : (oe = Y.type.defaultProps) === null || oe === void 0 ? void 0 : oe.hide;
            return ie === P && (E || !he);
          }), w, a, d);
          K && (C = K);
        }
        m && (x === "number" || S !== "auto") && (k = rs(R, w, "category"));
      } else m ? C = iu(0, j) : s && s[P] && s[P].hasStack && x === "number" ? C = h === "expand" ? [0, 1] : kT(s[P].stackGroups, c, l) : C = IT(R, i.filter(function(Y) {
        var X = o in Y.props ? Y.props[o] : Y.type.defaultProps[o], oe = "hide" in Y.props ? Y.props.hide : Y.type.defaultProps.hide;
        return X === P && (E || !oe);
      }), x, d, !0);
      if (x === "number")
        C = ay(f, C, P, a, O), z && (C = Cg(z, C, _));
      else if (x === "category" && z) {
        var D = z, U = C.every(function(Y) {
          return D.indexOf(Y) >= 0;
        });
        U && (C = D);
      }
    }
    return Z(Z({}, g), {}, _e({}, P, Z(Z({}, y), {}, {
      axisType: a,
      domain: C,
      categoricalDomain: k,
      duplicateDomain: N,
      originalDomain: (v = y.domain) !== null && v !== void 0 ? v : I,
      isCategorical: m,
      layout: d
    })));
  }, {});
}, Q9 = function(t, n) {
  var r = n.graphicalItems, i = n.Axis, a = n.axisType, o = n.axisIdKey, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, d = t.layout, f = t.children, h = vd(t.data, {
    graphicalItems: r,
    dataStartIndex: c,
    dataEndIndex: l
  }), m = h.length, g = DT(d, a), p = -1;
  return r.reduce(function(v, y) {
    var x = y.type.defaultProps !== void 0 ? Z(Z({}, y.type.defaultProps), y.props) : y.props, w = x[o], _ = $N("number");
    if (!v[w]) {
      p++;
      var b;
      return g ? b = iu(0, m) : s && s[w] && s[w].hasStack ? (b = kT(s[w].stackGroups, c, l), b = ay(f, b, w, a)) : (b = Cg(_, IT(h, r.filter(function(S) {
        var O, E, P = o in S.props ? S.props[o] : (O = S.type.defaultProps) === null || O === void 0 ? void 0 : O[o], R = "hide" in S.props ? S.props.hide : (E = S.type.defaultProps) === null || E === void 0 ? void 0 : E.hide;
        return P === w && !R;
      }), "number", d), i.defaultProps.allowDataOverflow), b = ay(f, b, w, a)), Z(Z({}, v), {}, _e({}, w, Z(Z({
        axisType: a
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: Tn(Y9, "".concat(a, ".").concat(p % 2), null),
        domain: b,
        originalDomain: _,
        isCategorical: g,
        layout: d
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return v;
  }, {});
}, J9 = function(t, n) {
  var r = n.axisType, i = r === void 0 ? "xAxis" : r, a = n.AxisComp, o = n.graphicalItems, s = n.stackGroups, c = n.dataStartIndex, l = n.dataEndIndex, d = t.children, f = "".concat(i, "Id"), h = Kn(d, a), m = {};
  return h && h.length ? m = X9(t, {
    axes: h,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  }) : o && o.length && (m = Q9(t, {
    Axis: a,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  })), m;
}, eK = function(t) {
  var n = ba(t), r = Ii(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: vb(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: Yl(n, r)
  };
}, QE = function(t) {
  var n = t.children, r = t.defaultShowTooltip, i = fn(n, Ga), a = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (a = i.props.startIndex), i.props.endIndex >= 0 && (o = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: a,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, tK = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Nr(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, JE = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, nK = function(t, n) {
  var r = t.props, i = t.graphicalItems, a = t.xAxisMap, o = a === void 0 ? {} : a, s = t.yAxisMap, c = s === void 0 ? {} : s, l = r.width, d = r.height, f = r.children, h = r.margin || {}, m = fn(f, Ga), g = fn(f, Aa), p = Object.keys(c).reduce(function(b, S) {
    var O = c[S], E = O.orientation;
    return !O.mirror && !O.hide ? Z(Z({}, b), {}, _e({}, E, b[E] + O.width)) : b;
  }, {
    left: h.left || 0,
    right: h.right || 0
  }), v = Object.keys(o).reduce(function(b, S) {
    var O = o[S], E = O.orientation;
    return !O.mirror && !O.hide ? Z(Z({}, b), {}, _e({}, E, Tn(b, "".concat(E)) + O.height)) : b;
  }, {
    top: h.top || 0,
    bottom: h.bottom || 0
  }), y = Z(Z({}, v), p), x = y.bottom;
  m && (y.bottom += m.props.height || Ga.defaultProps.height), g && n && (y = MU(y, i, r, n));
  var w = l - y.left - y.right, _ = d - y.top - y.bottom;
  return Z(Z({
    brushBottom: x
  }, y), {}, {
    // never return negative values for height and width
    width: Math.max(w, 0),
    height: Math.max(_, 0)
  });
}, rK = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, iK = function(t) {
  var n = t.chartName, r = t.GraphicalChild, i = t.defaultTooltipEventType, a = i === void 0 ? "axis" : i, o = t.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, c = t.axisComponents, l = t.legendContent, d = t.formatAxisMap, f = t.defaultProps, h = function(y, x) {
    var w = x.graphicalItems, _ = x.stackGroups, b = x.offset, S = x.updateId, O = x.dataStartIndex, E = x.dataEndIndex, P = y.barSize, R = y.layout, j = y.barGap, C = y.barCategoryGap, N = y.maxBarSize, k = JE(R), I = k.numericAxisName, $ = k.cateAxisName, z = tK(w), V = [];
    return w.forEach(function(K, D) {
      var U = vd(y.data, {
        graphicalItems: [K],
        dataStartIndex: O,
        dataEndIndex: E
      }), Y = K.type.defaultProps !== void 0 ? Z(Z({}, K.type.defaultProps), K.props) : K.props, X = Y.dataKey, oe = Y.maxBarSize, ie = Y["".concat(I, "Id")], he = Y["".concat($, "Id")], ee = {}, se = c.reduce(function(tn, Wt) {
        var Ln, er, Wr = x["".concat(Wt.axisType, "Map")], yr = Y["".concat(Wt.axisType, "Id")];
        Wr && Wr[yr] || Wt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? an(!1, "Specifying a(n) ".concat(Wt.axisType, "Id requires a corresponding ").concat(
          Wt.axisType,
          "Id on the targeted graphical component "
        ).concat((Ln = K == null || (er = K.type) === null || er === void 0 ? void 0 : er.displayName) !== null && Ln !== void 0 ? Ln : "")) : an());
        var L = Wr[yr];
        return Z(Z({}, tn), {}, _e(_e({}, Wt.axisType, L), "".concat(Wt.axisType, "Ticks"), Ii(L)));
      }, ee), G = se[$], Q = se["".concat($, "Ticks")], ce = _ && _[ie] && _[ie].hasStack && HU(K, _[ie].stackGroups), F = Nr(K.type).indexOf("Bar") >= 0, ye = Yl(G, Q), te = [], Ne = z && TU({
        barSize: P,
        stackGroups: _,
        totalSize: rK(se, $)
      });
      if (F) {
        var Te, Ge, At = Ke(oe) ? N : oe, en = (Te = (Ge = Yl(G, Q, !0)) !== null && Ge !== void 0 ? Ge : At) !== null && Te !== void 0 ? Te : 0;
        te = NU({
          barGap: j,
          barCategoryGap: C,
          bandSize: en !== ye ? en : ye,
          sizeList: Ne[he],
          maxBarSize: At
        }), en !== ye && (te = te.map(function(tn) {
          return Z(Z({}, tn), {}, {
            position: Z(Z({}, tn.position), {}, {
              offset: tn.position.offset - en / 2
            })
          });
        }));
      }
      var Rn = K && K.type && K.type.getComposedData;
      Rn && V.push({
        props: Z(Z({}, Rn(Z(Z({}, se), {}, {
          displayedData: U,
          props: y,
          dataKey: X,
          item: K,
          bandSize: ye,
          barPosition: te,
          offset: b,
          stackedData: ce,
          layout: R,
          dataStartIndex: O,
          dataEndIndex: E
        }))), {}, _e(_e(_e({
          key: K.key || "item-".concat(D)
        }, I, se[I]), $, se[$]), "animationId", S)),
        childIndex: N$(K, y.children),
        item: K
      });
    }), V;
  }, m = function(y, x) {
    var w = y.props, _ = y.dataStartIndex, b = y.dataEndIndex, S = y.updateId;
    if (!Sw({
      props: w
    }))
      return null;
    var O = w.children, E = w.layout, P = w.stackOffset, R = w.data, j = w.reverseStackOrder, C = JE(E), N = C.numericAxisName, k = C.cateAxisName, I = Kn(O, r), $ = VU(R, I, "".concat(N, "Id"), "".concat(k, "Id"), P, j), z = c.reduce(function(Y, X) {
      var oe = "".concat(X.axisType, "Map");
      return Z(Z({}, Y), {}, _e({}, oe, J9(w, Z(Z({}, X), {}, {
        graphicalItems: I,
        stackGroups: X.axisType === N && $,
        dataStartIndex: _,
        dataEndIndex: b
      }))));
    }, {}), V = nK(Z(Z({}, z), {}, {
      props: w,
      graphicalItems: I
    }), x?.legendBBox);
    Object.keys(z).forEach(function(Y) {
      z[Y] = d(w, z[Y], V, Y.replace("Map", ""), n);
    });
    var K = z["".concat(k, "Map")], D = eK(K), U = h(w, Z(Z({}, z), {}, {
      dataStartIndex: _,
      dataEndIndex: b,
      updateId: S,
      graphicalItems: I,
      stackGroups: $,
      offset: V
    }));
    return Z(Z({
      formattedGraphicalItems: U,
      graphicalItems: I,
      offset: V,
      stackGroups: $
    }, D), z);
  }, g = /* @__PURE__ */ (function(v) {
    function y(x) {
      var w, _, b;
      return R9(this, y), b = B9(this, y, [x]), _e(b, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), _e(b, "accessibilityManager", new _9()), _e(b, "handleLegendBBoxUpdate", function(S) {
        if (S) {
          var O = b.state, E = O.dataStartIndex, P = O.dataEndIndex, R = O.updateId;
          b.setState(Z({
            legendBBox: S
          }, m({
            props: b.props,
            dataStartIndex: E,
            dataEndIndex: P,
            updateId: R
          }, Z(Z({}, b.state), {}, {
            legendBBox: S
          }))));
        }
      }), _e(b, "handleReceiveSyncEvent", function(S, O, E) {
        if (b.props.syncId === S) {
          if (E === b.eventEmitterSymbol && typeof b.props.syncMethod != "function")
            return;
          b.applySyncEvent(O);
        }
      }), _e(b, "handleBrushChange", function(S) {
        var O = S.startIndex, E = S.endIndex;
        if (O !== b.state.dataStartIndex || E !== b.state.dataEndIndex) {
          var P = b.state.updateId;
          b.setState(function() {
            return Z({
              dataStartIndex: O,
              dataEndIndex: E
            }, m({
              props: b.props,
              dataStartIndex: O,
              dataEndIndex: E,
              updateId: P
            }, b.state));
          }), b.triggerSyncEvent({
            dataStartIndex: O,
            dataEndIndex: E
          });
        }
      }), _e(b, "handleMouseEnter", function(S) {
        var O = b.getMouseInfo(S);
        if (O) {
          var E = Z(Z({}, O), {}, {
            isTooltipActive: !0
          });
          b.setState(E), b.triggerSyncEvent(E);
          var P = b.props.onMouseEnter;
          Re(P) && P(E, S);
        }
      }), _e(b, "triggeredAfterMouseMove", function(S) {
        var O = b.getMouseInfo(S), E = O ? Z(Z({}, O), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        b.setState(E), b.triggerSyncEvent(E);
        var P = b.props.onMouseMove;
        Re(P) && P(E, S);
      }), _e(b, "handleItemMouseEnter", function(S) {
        b.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: S,
            activePayload: S.tooltipPayload,
            activeCoordinate: S.tooltipPosition || {
              x: S.cx,
              y: S.cy
            }
          };
        });
      }), _e(b, "handleItemMouseLeave", function() {
        b.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), _e(b, "handleMouseMove", function(S) {
        S.persist(), b.throttleTriggeredAfterMouseMove(S);
      }), _e(b, "handleMouseLeave", function(S) {
        b.throttleTriggeredAfterMouseMove.cancel();
        var O = {
          isTooltipActive: !1
        };
        b.setState(O), b.triggerSyncEvent(O);
        var E = b.props.onMouseLeave;
        Re(E) && E(O, S);
      }), _e(b, "handleOuterEvent", function(S) {
        var O = T$(S), E = Tn(b.props, "".concat(O));
        if (O && Re(E)) {
          var P, R;
          /.*touch.*/i.test(O) ? R = b.getMouseInfo(S.changedTouches[0]) : R = b.getMouseInfo(S), E((P = R) !== null && P !== void 0 ? P : {}, S);
        }
      }), _e(b, "handleClick", function(S) {
        var O = b.getMouseInfo(S);
        if (O) {
          var E = Z(Z({}, O), {}, {
            isTooltipActive: !0
          });
          b.setState(E), b.triggerSyncEvent(E);
          var P = b.props.onClick;
          Re(P) && P(E, S);
        }
      }), _e(b, "handleMouseDown", function(S) {
        var O = b.props.onMouseDown;
        if (Re(O)) {
          var E = b.getMouseInfo(S);
          O(E, S);
        }
      }), _e(b, "handleMouseUp", function(S) {
        var O = b.props.onMouseUp;
        if (Re(O)) {
          var E = b.getMouseInfo(S);
          O(E, S);
        }
      }), _e(b, "handleTouchMove", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.throttleTriggeredAfterMouseMove(S.changedTouches[0]);
      }), _e(b, "handleTouchStart", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.handleMouseDown(S.changedTouches[0]);
      }), _e(b, "handleTouchEnd", function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && b.handleMouseUp(S.changedTouches[0]);
      }), _e(b, "handleDoubleClick", function(S) {
        var O = b.props.onDoubleClick;
        if (Re(O)) {
          var E = b.getMouseInfo(S);
          O(E, S);
        }
      }), _e(b, "handleContextMenu", function(S) {
        var O = b.props.onContextMenu;
        if (Re(O)) {
          var E = b.getMouseInfo(S);
          O(E, S);
        }
      }), _e(b, "triggerSyncEvent", function(S) {
        b.props.syncId !== void 0 && rp.emit(ip, b.props.syncId, S, b.eventEmitterSymbol);
      }), _e(b, "applySyncEvent", function(S) {
        var O = b.props, E = O.layout, P = O.syncMethod, R = b.state.updateId, j = S.dataStartIndex, C = S.dataEndIndex;
        if (S.dataStartIndex !== void 0 || S.dataEndIndex !== void 0)
          b.setState(Z({
            dataStartIndex: j,
            dataEndIndex: C
          }, m({
            props: b.props,
            dataStartIndex: j,
            dataEndIndex: C,
            updateId: R
          }, b.state)));
        else if (S.activeTooltipIndex !== void 0) {
          var N = S.chartX, k = S.chartY, I = S.activeTooltipIndex, $ = b.state, z = $.offset, V = $.tooltipTicks;
          if (!z)
            return;
          if (typeof P == "function")
            I = P(V, S);
          else if (P === "value") {
            I = -1;
            for (var K = 0; K < V.length; K++)
              if (V[K].value === S.activeLabel) {
                I = K;
                break;
              }
          }
          var D = Z(Z({}, z), {}, {
            x: z.left,
            y: z.top
          }), U = Math.min(N, D.x + D.width), Y = Math.min(k, D.y + D.height), X = V[I] && V[I].value, oe = cy(b.state, b.props.data, I), ie = V[I] ? {
            x: E === "horizontal" ? V[I].coordinate : U,
            y: E === "horizontal" ? Y : V[I].coordinate
          } : LN;
          b.setState(Z(Z({}, S), {}, {
            activeLabel: X,
            activeCoordinate: ie,
            activePayload: oe,
            activeTooltipIndex: I
          }));
        } else
          b.setState(S);
      }), _e(b, "renderCursor", function(S) {
        var O, E = b.state, P = E.isTooltipActive, R = E.activeCoordinate, j = E.activePayload, C = E.offset, N = E.activeTooltipIndex, k = E.tooltipAxisBandSize, I = b.getTooltipEventType(), $ = (O = S.props.active) !== null && O !== void 0 ? O : P, z = b.props.layout, V = S.key || "_recharts-cursor";
        return /* @__PURE__ */ T.createElement(j9, {
          key: V,
          activeCoordinate: R,
          activePayload: j,
          activeTooltipIndex: N,
          chartName: n,
          element: S,
          isActive: $,
          layout: z,
          offset: C,
          tooltipAxisBandSize: k,
          tooltipEventType: I
        });
      }), _e(b, "renderPolarAxis", function(S, O, E) {
        var P = Tn(S, "type.axisType"), R = Tn(b.state, "".concat(P, "Map")), j = S.type.defaultProps, C = j !== void 0 ? Z(Z({}, j), S.props) : S.props, N = R && R[C["".concat(P, "Id")]];
        return /* @__PURE__ */ _t(S, Z(Z({}, N), {}, {
          className: Fe(P, N.className),
          key: S.key || "".concat(O, "-").concat(E),
          ticks: Ii(N, !0)
        }));
      }), _e(b, "renderPolarGrid", function(S) {
        var O = S.props, E = O.radialLines, P = O.polarAngles, R = O.polarRadius, j = b.state, C = j.radiusAxisMap, N = j.angleAxisMap, k = ba(C), I = ba(N), $ = I.cx, z = I.cy, V = I.innerRadius, K = I.outerRadius;
        return /* @__PURE__ */ _t(S, {
          polarAngles: Array.isArray(P) ? P : Ii(I, !0).map(function(D) {
            return D.coordinate;
          }),
          polarRadius: Array.isArray(R) ? R : Ii(k, !0).map(function(D) {
            return D.coordinate;
          }),
          cx: $,
          cy: z,
          innerRadius: V,
          outerRadius: K,
          key: S.key || "polar-grid",
          radialLines: E
        });
      }), _e(b, "renderLegend", function() {
        var S = b.state.formattedGraphicalItems, O = b.props, E = O.children, P = O.width, R = O.height, j = b.props.margin || {}, C = P - (j.left || 0) - (j.right || 0), N = NT({
          children: E,
          formattedGraphicalItems: S,
          legendWidth: C,
          legendContent: l
        });
        if (!N)
          return null;
        var k = N.item, I = GE(N, T9);
        return /* @__PURE__ */ _t(k, Z(Z({}, I), {}, {
          chartWidth: P,
          chartHeight: R,
          margin: j,
          onBBoxUpdate: b.handleLegendBBoxUpdate
        }));
      }), _e(b, "renderTooltip", function() {
        var S, O = b.props, E = O.children, P = O.accessibilityLayer, R = fn(E, Or);
        if (!R)
          return null;
        var j = b.state, C = j.isTooltipActive, N = j.activeCoordinate, k = j.activePayload, I = j.activeLabel, $ = j.offset, z = (S = R.props.active) !== null && S !== void 0 ? S : C;
        return /* @__PURE__ */ _t(R, {
          viewBox: Z(Z({}, $), {}, {
            x: $.left,
            y: $.top
          }),
          active: z,
          label: I,
          payload: z ? k : [],
          coordinate: N,
          accessibilityLayer: P
        });
      }), _e(b, "renderBrush", function(S) {
        var O = b.props, E = O.margin, P = O.data, R = b.state, j = R.offset, C = R.dataStartIndex, N = R.dataEndIndex, k = R.updateId;
        return /* @__PURE__ */ _t(S, {
          key: S.key || "_recharts-brush",
          onChange: zc(b.handleBrushChange, S.props.onChange),
          data: P,
          x: me(S.props.x) ? S.props.x : j.left,
          y: me(S.props.y) ? S.props.y : j.top + j.height + j.brushBottom - (E.bottom || 0),
          width: me(S.props.width) ? S.props.width : j.width,
          startIndex: C,
          endIndex: N,
          updateId: "brush-".concat(k)
        });
      }), _e(b, "renderReferenceElement", function(S, O, E) {
        if (!S)
          return null;
        var P = b, R = P.clipPathId, j = b.state, C = j.xAxisMap, N = j.yAxisMap, k = j.offset, I = S.type.defaultProps || {}, $ = S.props, z = $.xAxisId, V = z === void 0 ? I.xAxisId : z, K = $.yAxisId, D = K === void 0 ? I.yAxisId : K;
        return /* @__PURE__ */ _t(S, {
          key: S.key || "".concat(O, "-").concat(E),
          xAxis: C[V],
          yAxis: N[D],
          viewBox: {
            x: k.left,
            y: k.top,
            width: k.width,
            height: k.height
          },
          clipPathId: R
        });
      }), _e(b, "renderActivePoints", function(S) {
        var O = S.item, E = S.activePoint, P = S.basePoint, R = S.childIndex, j = S.isRange, C = [], N = O.props.key, k = O.item.type.defaultProps !== void 0 ? Z(Z({}, O.item.type.defaultProps), O.item.props) : O.item.props, I = k.activeDot, $ = k.dataKey, z = Z(Z({
          index: R,
          dataKey: $,
          cx: E.x,
          cy: E.y,
          r: 4,
          fill: Vb(O.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: E.payload,
          value: E.value
        }, Ye(I, !1)), xl(I));
        return C.push(y.renderActiveDot(I, z, "".concat(N, "-activePoint-").concat(R))), P ? C.push(y.renderActiveDot(I, Z(Z({}, z), {}, {
          cx: P.x,
          cy: P.y
        }), "".concat(N, "-basePoint-").concat(R))) : j && C.push(null), C;
      }), _e(b, "renderGraphicChild", function(S, O, E) {
        var P = b.filterFormatItem(S, O, E);
        if (!P)
          return null;
        var R = b.getTooltipEventType(), j = b.state, C = j.isTooltipActive, N = j.tooltipAxis, k = j.activeTooltipIndex, I = j.activeLabel, $ = b.props.children, z = fn($, Or), V = P.props, K = V.points, D = V.isRange, U = V.baseLine, Y = P.item.type.defaultProps !== void 0 ? Z(Z({}, P.item.type.defaultProps), P.item.props) : P.item.props, X = Y.activeDot, oe = Y.hide, ie = Y.activeBar, he = Y.activeShape, ee = !!(!oe && C && z && (X || ie || he)), se = {};
        R !== "axis" && z && z.props.trigger === "click" ? se = {
          onClick: zc(b.handleItemMouseEnter, S.props.onClick)
        } : R !== "axis" && (se = {
          onMouseLeave: zc(b.handleItemMouseLeave, S.props.onMouseLeave),
          onMouseEnter: zc(b.handleItemMouseEnter, S.props.onMouseEnter)
        });
        var G = /* @__PURE__ */ _t(S, Z(Z({}, P.props), se));
        function Q(Wt) {
          return typeof N.dataKey == "function" ? N.dataKey(Wt.payload) : null;
        }
        if (ee)
          if (k >= 0) {
            var ce, F;
            if (N.dataKey && !N.allowDuplicatedCategory) {
              var ye = typeof N.dataKey == "function" ? Q : "payload.".concat(N.dataKey.toString());
              ce = Kp(K, ye, I), F = D && U && Kp(U, ye, I);
            } else
              ce = K?.[k], F = D && U && U[k];
            if (he || ie) {
              var te = S.props.activeIndex !== void 0 ? S.props.activeIndex : k;
              return [/* @__PURE__ */ _t(S, Z(Z(Z({}, P.props), se), {}, {
                activeIndex: te
              })), null, null];
            }
            if (!Ke(ce))
              return [G].concat(ao(b.renderActivePoints({
                item: P,
                activePoint: ce,
                basePoint: F,
                childIndex: k,
                isRange: D
              })));
          } else {
            var Ne, Te = (Ne = b.getItemByXY(b.state.activeCoordinate)) !== null && Ne !== void 0 ? Ne : {
              graphicalItem: G
            }, Ge = Te.graphicalItem, At = Ge.item, en = At === void 0 ? S : At, Rn = Ge.childIndex, tn = Z(Z(Z({}, P.props), se), {}, {
              activeIndex: Rn
            });
            return [/* @__PURE__ */ _t(en, tn), null, null];
          }
        return D ? [G, null, null] : [G, null];
      }), _e(b, "renderCustomized", function(S, O, E) {
        return /* @__PURE__ */ _t(S, Z(Z({
          key: "recharts-customized-".concat(E)
        }, b.props), b.state));
      }), _e(b, "renderMap", {
        CartesianGrid: {
          handler: Kc,
          once: !0
        },
        ReferenceArea: {
          handler: b.renderReferenceElement
        },
        ReferenceLine: {
          handler: Kc
        },
        ReferenceDot: {
          handler: b.renderReferenceElement
        },
        XAxis: {
          handler: Kc
        },
        YAxis: {
          handler: Kc
        },
        Brush: {
          handler: b.renderBrush,
          once: !0
        },
        Bar: {
          handler: b.renderGraphicChild
        },
        Line: {
          handler: b.renderGraphicChild
        },
        Area: {
          handler: b.renderGraphicChild
        },
        Radar: {
          handler: b.renderGraphicChild
        },
        RadialBar: {
          handler: b.renderGraphicChild
        },
        Scatter: {
          handler: b.renderGraphicChild
        },
        Pie: {
          handler: b.renderGraphicChild
        },
        Funnel: {
          handler: b.renderGraphicChild
        },
        Tooltip: {
          handler: b.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: b.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: b.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: b.renderPolarAxis
        },
        Customized: {
          handler: b.renderCustomized
        }
      }), b.clipPathId = "".concat((w = x.id) !== null && w !== void 0 ? w : qu("recharts"), "-clip"), b.throttleTriggeredAfterMouseMove = Mj(b.triggeredAfterMouseMove, (_ = x.throttleDelay) !== null && _ !== void 0 ? _ : 1e3 / 60), b.state = {}, b;
    }
    return q9(y, v), $9(y, [{
      key: "componentDidMount",
      value: function() {
        var w, _;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
            top: (_ = this.props.margin.top) !== null && _ !== void 0 ? _ : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var w = this.props, _ = w.children, b = w.data, S = w.height, O = w.layout, E = fn(_, Or);
        if (E) {
          var P = E.props.defaultIndex;
          if (!(typeof P != "number" || P < 0 || P > this.state.tooltipTicks.length - 1)) {
            var R = this.state.tooltipTicks[P] && this.state.tooltipTicks[P].value, j = cy(this.state, b, P, R), C = this.state.tooltipTicks[P].coordinate, N = (this.state.offset.top + S) / 2, k = O === "horizontal", I = k ? {
              x: C,
              y: N
            } : {
              y: C,
              x: N
            }, $ = this.state.formattedGraphicalItems.find(function(V) {
              var K = V.item;
              return K.type.name === "Scatter";
            });
            $ && (I = Z(Z({}, I), $.props.points[P].tooltipPosition), j = $.props.points[P].tooltipPayload);
            var z = {
              activeTooltipIndex: P,
              isTooltipActive: !0,
              activeLabel: R,
              activePayload: j,
              activeCoordinate: I
            };
            this.setState(z), this.renderCursor(E), this.accessibilityManager.setIndex(P);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(w, _) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== _.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== w.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== w.margin) {
          var b, S;
          this.accessibilityManager.setDetails({
            offset: {
              left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
              top: (S = this.props.margin.top) !== null && S !== void 0 ? S : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(w) {
        Zp([fn(w.children, Or)], [fn(this.props.children, Or)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var w = fn(this.props.children, Or);
        if (w && typeof w.props.shared == "boolean") {
          var _ = w.props.shared ? "axis" : "item";
          return s.indexOf(_) >= 0 ? _ : a;
        }
        return a;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(w) {
        if (!this.container)
          return null;
        var _ = this.container, b = _.getBoundingClientRect(), S = b4(b), O = {
          chartX: Math.round(w.pageX - S.left),
          chartY: Math.round(w.pageY - S.top)
        }, E = b.width / _.offsetWidth || 1, P = this.inRange(O.chartX, O.chartY, E);
        if (!P)
          return null;
        var R = this.state, j = R.xAxisMap, C = R.yAxisMap, N = this.getTooltipEventType();
        if (N !== "axis" && j && C) {
          var k = ba(j).scale, I = ba(C).scale, $ = k && k.invert ? k.invert(O.chartX) : null, z = I && I.invert ? I.invert(O.chartY) : null;
          return Z(Z({}, O), {}, {
            xValue: $,
            yValue: z
          });
        }
        var V = XE(this.state, this.props.data, this.props.layout, P);
        return V ? Z(Z({}, O), V) : null;
      }
    }, {
      key: "inRange",
      value: function(w, _) {
        var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, S = this.props.layout, O = w / b, E = _ / b;
        if (S === "horizontal" || S === "vertical") {
          var P = this.state.offset, R = O >= P.left && O <= P.left + P.width && E >= P.top && E <= P.top + P.height;
          return R ? {
            x: O,
            y: E
          } : null;
        }
        var j = this.state, C = j.angleAxisMap, N = j.radiusAxisMap;
        if (C && N) {
          var k = ba(C);
          return dO({
            x: O,
            y: E
          }, k);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var w = this.props.children, _ = this.getTooltipEventType(), b = fn(w, Or), S = {};
        b && _ === "axis" && (b.props.trigger === "click" ? S = {
          onClick: this.handleClick
        } : S = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var O = xl(this.props, this.handleOuterEvent);
        return Z(Z({}, O), S);
      }
    }, {
      key: "addListener",
      value: function() {
        rp.on(ip, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        rp.removeListener(ip, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(w, _, b) {
        for (var S = this.state.formattedGraphicalItems, O = 0, E = S.length; O < E; O++) {
          var P = S[O];
          if (P.item === w || P.props.key === w.key || _ === Nr(P.item.type) && b === P.childIndex)
            return P;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var w = this.clipPathId, _ = this.state.offset, b = _.left, S = _.top, O = _.height, E = _.width;
        return /* @__PURE__ */ T.createElement("defs", null, /* @__PURE__ */ T.createElement("clipPath", {
          id: w
        }, /* @__PURE__ */ T.createElement("rect", {
          x: b,
          y: S,
          height: O,
          width: E
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var w = this.state.xAxisMap;
        return w ? Object.entries(w).reduce(function(_, b) {
          var S = KE(b, 2), O = S[0], E = S[1];
          return Z(Z({}, _), {}, _e({}, O, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var w = this.state.yAxisMap;
        return w ? Object.entries(w).reduce(function(_, b) {
          var S = KE(b, 2), O = S[0], E = S[1];
          return Z(Z({}, _), {}, _e({}, O, E.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(w) {
        var _;
        return (_ = this.state.xAxisMap) === null || _ === void 0 || (_ = _[w]) === null || _ === void 0 ? void 0 : _.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(w) {
        var _;
        return (_ = this.state.yAxisMap) === null || _ === void 0 || (_ = _[w]) === null || _ === void 0 ? void 0 : _.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(w) {
        var _ = this.state, b = _.formattedGraphicalItems, S = _.activeItem;
        if (b && b.length)
          for (var O = 0, E = b.length; O < E; O++) {
            var P = b[O], R = P.props, j = P.item, C = j.type.defaultProps !== void 0 ? Z(Z({}, j.type.defaultProps), j.props) : j.props, N = Nr(j.type);
            if (N === "Bar") {
              var k = (R.data || []).find(function(V) {
                return UH(w, V);
              });
              if (k)
                return {
                  graphicalItem: P,
                  payload: k
                };
            } else if (N === "RadialBar") {
              var I = (R.data || []).find(function(V) {
                return dO(w, V);
              });
              if (I)
                return {
                  graphicalItem: P,
                  payload: I
                };
            } else if (sd(P, S) || cd(P, S) || Bs(P, S)) {
              var $ = k6({
                graphicalItem: P,
                activeTooltipItem: S,
                itemData: C.data
              }), z = C.activeIndex === void 0 ? $ : C.activeIndex;
              return {
                graphicalItem: Z(Z({}, P), {}, {
                  childIndex: z
                }),
                payload: Bs(P, S) ? C.data[$] : P.props.data[$]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var w = this;
        if (!Sw(this))
          return null;
        var _ = this.props, b = _.children, S = _.className, O = _.width, E = _.height, P = _.style, R = _.compact, j = _.title, C = _.desc, N = GE(_, N9), k = Ye(N, !1);
        if (R)
          return /* @__PURE__ */ T.createElement(DE, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ T.createElement(Qp, _a({}, k, {
            width: O,
            height: E,
            title: j,
            desc: C
          }), this.renderClipPath(), Ew(b, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var I, $;
          k.tabIndex = (I = this.props.tabIndex) !== null && I !== void 0 ? I : 0, k.role = ($ = this.props.role) !== null && $ !== void 0 ? $ : "application", k.onKeyDown = function(V) {
            w.accessibilityManager.keyboardEvent(V);
          }, k.onFocus = function() {
            w.accessibilityManager.focus();
          };
        }
        var z = this.parseEventsOfWrapper();
        return /* @__PURE__ */ T.createElement(DE, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ T.createElement("div", _a({
          className: Fe("recharts-wrapper", S),
          style: Z({
            position: "relative",
            cursor: "default",
            width: O,
            height: E
          }, P)
        }, z, {
          ref: function(K) {
            w.container = K;
          }
        }), /* @__PURE__ */ T.createElement(Qp, _a({}, k, {
          width: O,
          height: E,
          title: j,
          desc: C,
          style: K9
        }), this.renderClipPath(), Ew(b, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  })(CC);
  _e(g, "displayName", n), _e(g, "defaultProps", Z({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), _e(g, "getDerivedStateFromProps", function(v, y) {
    var x = v.dataKey, w = v.data, _ = v.children, b = v.width, S = v.height, O = v.layout, E = v.stackOffset, P = v.margin, R = y.dataStartIndex, j = y.dataEndIndex;
    if (y.updateId === void 0) {
      var C = QE(v);
      return Z(Z(Z({}, C), {}, {
        updateId: 0
      }, m(Z(Z({
        props: v
      }, C), {}, {
        updateId: 0
      }), y)), {}, {
        prevDataKey: x,
        prevData: w,
        prevWidth: b,
        prevHeight: S,
        prevLayout: O,
        prevStackOffset: E,
        prevMargin: P,
        prevChildren: _
      });
    }
    if (x !== y.prevDataKey || w !== y.prevData || b !== y.prevWidth || S !== y.prevHeight || O !== y.prevLayout || E !== y.prevStackOffset || !Ea(P, y.prevMargin)) {
      var N = QE(v), k = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: y.chartX,
        chartY: y.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: y.isTooltipActive
      }, I = Z(Z({}, XE(y, w, O)), {}, {
        updateId: y.updateId + 1
      }), $ = Z(Z(Z({}, N), k), I);
      return Z(Z(Z({}, $), m(Z({
        props: v
      }, $), y)), {}, {
        prevDataKey: x,
        prevData: w,
        prevWidth: b,
        prevHeight: S,
        prevLayout: O,
        prevStackOffset: E,
        prevMargin: P,
        prevChildren: _
      });
    }
    if (!Zp(_, y.prevChildren)) {
      var z, V, K, D, U = fn(_, Ga), Y = U && (z = (V = U.props) === null || V === void 0 ? void 0 : V.startIndex) !== null && z !== void 0 ? z : R, X = U && (K = (D = U.props) === null || D === void 0 ? void 0 : D.endIndex) !== null && K !== void 0 ? K : j, oe = Y !== R || X !== j, ie = !Ke(w), he = ie && !oe ? y.updateId : y.updateId + 1;
      return Z(Z({
        updateId: he
      }, m(Z(Z({
        props: v
      }, y), {}, {
        updateId: he,
        dataStartIndex: Y,
        dataEndIndex: X
      }), y)), {}, {
        prevChildren: _,
        dataStartIndex: Y,
        dataEndIndex: X
      });
    }
    return null;
  }), _e(g, "renderActiveDot", function(v, y, x) {
    var w;
    return /* @__PURE__ */ Yn(v) ? w = /* @__PURE__ */ _t(v, y) : Re(v) ? w = v(y) : w = /* @__PURE__ */ T.createElement(GT, y), /* @__PURE__ */ T.createElement(It, {
      className: "recharts-active-dot",
      key: x
    }, w);
  });
  var p = /* @__PURE__ */ ku(function(y, x) {
    return /* @__PURE__ */ T.createElement(g, _a({}, y, {
      ref: x
    }));
  });
  return p.displayName = g.displayName, p;
}, aK = iK({
  chartName: "BarChart",
  GraphicalChild: sa,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Zb
  }, {
    axisType: "yAxis",
    AxisComp: Xb
  }],
  formatAxisMap: M8
});
const oK = 64, sK = 0;
function cK(e) {
  const t = e.height ?? oK, n = e.activeRange?.[0] ?? sK, r = e.activeRange?.[1] ?? e.data.length - 1;
  return /* @__PURE__ */ u.jsx("div", { className: Ce("w-full", e.className), children: /* @__PURE__ */ u.jsx(f4, { height: t, width: "100%", children: /* @__PURE__ */ u.jsx(
    aK,
    {
      data: e.data,
      margin: { bottom: 0, left: 0, right: 0, top: 0 },
      children: /* @__PURE__ */ u.jsx(sa, { dataKey: "value", isAnimationActive: !1, radius: [2, 2, 0, 0], children: e.data.map((i, a) => /* @__PURE__ */ u.jsx(
        gb,
        {
          className: a >= n && a <= r ? "text-gray-900" : "text-gray-300",
          fill: "currentColor"
        },
        `bar-${i.label}-${a}`
      )) })
    }
  ) }) });
}
const BN = A.createContext({});
function Ule(e) {
  const t = A.useMemo(
    () => ({ Override: e.component }),
    [e.component]
  );
  return /* @__PURE__ */ u.jsx(BN.Provider, { value: t, children: e.children });
}
function lK() {
  return A.useContext(BN).Override;
}
function uK(e) {
  switch (e) {
    case "sm":
    case "icon-sm":
    case "rounded-sm":
      return "min-w-6 px-1.5";
    case "lg":
    case "icon-lg":
    case "rounded-lg":
      return "min-w-10 px-2.5";
    default:
      return "min-w-8 px-2";
  }
}
function dK(e, t) {
  if (e !== "D2C")
    return "opacity-50";
  switch (t) {
    case "outline":
    case "outline-no-hover":
      return "border-alabastergrey bg-transparent text-alabastergrey hover:bg-transparent active:border-alabastergrey active:text-alabastergrey [&>button:disabled]:opacity-100";
    case "ghost":
    case "link":
      return "bg-transparent text-alabastergrey hover:bg-transparent active:text-alabastergrey [&>button:disabled]:opacity-100";
    case "default":
    case "secondary":
    case "destructive":
    case null:
    case void 0:
      return "bg-alabastergrey text-white hover:bg-alabastergrey active:bg-alabastergrey [&>button:disabled]:opacity-100";
    default:
      return "opacity-50";
  }
}
function eA({ action: e, disabled: t, size: n }) {
  const {
    ariaLabel: r,
    className: i,
    disabled: a,
    icon: o,
    type: s = "button",
    ...c
  } = e;
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      ...c,
      "aria-label": r,
      className: J(
        "inline-flex h-full shrink-0 cursor-pointer items-center justify-center text-current outline-none transition-colors focus-visible:ring-2 focus-visible:ring-current focus-visible:ring-inset disabled:pointer-events-none disabled:cursor-default disabled:opacity-50",
        uK(n),
        i
      ),
      disabled: t || a,
      type: s,
      children: /* @__PURE__ */ u.jsx("span", { "aria-hidden": "true", className: "inline-flex shrink-0", children: o })
    }
  );
}
function Hle(e) {
  const {
    children: t,
    className: n,
    disabled: r = !1,
    leadingAction: i,
    mode: a,
    role: o = "group",
    size: s,
    trailingAction: c,
    variant: l,
    ...d
  } = e;
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      ...d,
      "aria-disabled": r || void 0,
      className: J(
        Us({ mode: a, size: s, variant: l }),
        "group cursor-default gap-0 px-0 py-0 focus-within:ring-2 focus-within:ring-current/30 focus-within:ring-offset-2",
        r && "pointer-events-none cursor-default",
        r && dK(a, l),
        n
      ),
      role: o,
      children: [
        /* @__PURE__ */ u.jsx(eA, { action: i, disabled: r, size: s }),
        /* @__PURE__ */ u.jsx("span", { className: "pointer-events-none inline-flex min-w-6 flex-1 items-center justify-center px-1 text-center", children: t }),
        /* @__PURE__ */ u.jsx(eA, { action: c, disabled: r, size: s })
      ]
    }
  );
}
const Us = yt(
  "inline-flex shrink-0 cursor-pointer items-center justify-center whitespace-nowrap font-medium outline-none transition-all focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_.button-loader]:size-4 [&_.button-loader]:shrink-0 [&_.button-loader]:animate-spin",
  {
    variants: {
      mode: {
        B2B: null,
        D2C: "font-brand font-normal shadow-none [&_svg:not(.button-loader)]:size-5 [&_svg:not(.button-loader)]:shrink-0"
      },
      unstyled: {
        true: "bg-transparent font-normal shadow-none hover:bg-transparent hover:shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:pointer-events-auto disabled:opacity-100"
      },
      variant: {
        default: "bg-primary text-primary-foreground shadow-[0_1px_2px_0_rgba(0,0,0,0.06),0_1px_3px_0_rgba(0,0,0,0.1)] hover:bg-primary/90 focus-visible:ring-primary/50",
        secondary: "bg-secondary text-secondary-foreground shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] hover:bg-secondary/80 focus-visible:ring-secondary-foreground/20",
        destructive: "bg-destructive text-destructive-foreground shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] hover:bg-destructive/90 focus-visible:ring-destructive/50",
        outline: "border border-border bg-background text-foreground shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] hover:border-foreground/50 hover:bg-secondary/70 hover:shadow-[0_2px_4px_0_rgba(0,0,0,0.05)] focus-visible:ring-foreground/20",
        "outline-no-hover": "border border-border bg-background text-foreground shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] focus-visible:ring-foreground/20",
        ghost: "text-foreground hover:bg-secondary focus-visible:ring-foreground/20",
        link: "text-foreground hover:underline focus-visible:ring-foreground/50",
        rounded: "rounded-full bg-background font-bold text-foreground shadow-sm"
      },
      size: {
        default: "h-9 gap-2 rounded-md px-4 py-2 text-sm",
        sm: "h-8 gap-2 rounded-md px-4 py-2 text-xs",
        lg: "h-10 gap-2 rounded-md px-4 py-2 text-sm",
        icon: "size-9 rounded-md",
        "icon-sm": "size-8 rounded-md",
        "icon-lg": "size-10 rounded-md",
        "rounded-sm": "h-8 w-8 gap-2 px-4 py-2 text-xs",
        "rounded-lg": "h-12.5 w-12.5 gap-2 px-4 py-2 text-xl"
      }
    },
    compoundVariants: [
      {
        mode: "D2C",
        variant: "default",
        class: "bg-primary text-primary-foreground shadow-none hover:bg-primary/90 focus-visible:ring-primary/30 active:bg-blazeorange active:text-white disabled:bg-alabastergrey disabled:text-white disabled:opacity-100"
      },
      {
        mode: "D2C",
        variant: "secondary",
        class: "bg-secondary text-secondary-foreground shadow-none hover:bg-secondary/80 focus-visible:ring-secondary-foreground/30 active:bg-blazeorange active:text-white disabled:bg-alabastergrey disabled:text-white disabled:opacity-100"
      },
      {
        mode: "D2C",
        variant: "destructive",
        class: "shadow-none focus-visible:ring-current/30 active:bg-blazeorange disabled:bg-alabastergrey disabled:text-white disabled:opacity-100"
      },
      {
        mode: "D2C",
        variant: "outline",
        class: "border border-alabastergrey bg-transparent text-inherit shadow-none hover:border-current hover:bg-transparent focus-visible:border-current focus-visible:ring-current/30 active:border-blazeorange active:bg-transparent disabled:border-alabastergrey disabled:bg-transparent disabled:text-alabastergrey disabled:opacity-100 dark:disabled:border-white dark:disabled:text-white dark:disabled:opacity-30"
      },
      {
        mode: "D2C",
        variant: "outline-no-hover",
        class: "border border-alabastergrey bg-transparent text-inherit shadow-none focus-visible:border-current focus-visible:ring-current/30 active:border-blazeorange disabled:border-alabastergrey disabled:text-alabastergrey disabled:opacity-100 dark:disabled:border-white dark:disabled:text-white dark:disabled:opacity-30"
      },
      {
        mode: "D2C",
        variant: "ghost",
        class: "bg-transparent text-inherit shadow-none hover:bg-current/10 focus-visible:ring-current/30 active:bg-current/10 active:text-blazeorange disabled:bg-transparent disabled:text-alabastergrey disabled:opacity-100 dark:disabled:text-white dark:disabled:opacity-30"
      },
      {
        mode: "D2C",
        variant: "link",
        class: "bg-transparent text-inherit shadow-none focus-visible:ring-current/30 active:text-blazeorange disabled:text-alabastergrey disabled:opacity-100 dark:disabled:text-white dark:disabled:opacity-30"
      },
      {
        mode: "D2C",
        size: "default",
        class: "h-12 gap-2 rounded-sm px-4 py-3 text-base leading-6"
      },
      {
        mode: "D2C",
        size: "sm",
        class: "h-10 gap-1 rounded-sm px-4 py-3 text-xs leading-4"
      },
      {
        mode: "D2C",
        size: "lg",
        class: "h-12 gap-2 rounded-sm px-4 py-3 text-base leading-6"
      },
      {
        mode: "D2C",
        size: "icon",
        class: "size-10 rounded-sm"
      },
      {
        mode: "D2C",
        size: "icon-sm",
        class: "size-8 rounded-sm"
      },
      {
        mode: "D2C",
        size: "icon-lg",
        class: "size-12 rounded-sm"
      },
      {
        mode: "D2C",
        unstyled: !0,
        class: "h-auto w-auto gap-0 rounded-none border-0 bg-transparent px-0 py-0 text-inherit shadow-none hover:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 active:bg-transparent active:text-inherit disabled:bg-transparent disabled:text-inherit"
      }
    ],
    defaultVariants: {
      mode: "B2B",
      variant: "default",
      size: "default",
      unstyled: !1
    }
  }
);
function ve(e) {
  const {
    mode: t,
    variant: n,
    size: r,
    unstyled: i,
    loading: a = !1,
    children: o,
    href: s,
    onClick: c,
    disabled: l,
    className: d,
    ...f
  } = e, h = !!l || a, m = lK();
  if (s) {
    let v = function(S) {
      if (h) {
        S.preventDefault(), S.stopPropagation();
        return;
      }
      typeof c == "function" && c(S);
    }, y = function(S) {
      h && (S.key === " " || S.key === "Enter") && (S.preventDefault(), S.stopPropagation());
    };
    const x = m || "a", w = f, _ = s.startsWith("http") || w.target === "_blank", b = w.rel || (_ ? "noopener noreferrer" : void 0);
    return /* @__PURE__ */ u.jsxs(
      x,
      {
        "aria-disabled": h ? "true" : void 0,
        className: J(
          Us({ mode: t, variant: n, size: r, unstyled: i }),
          h && "disabled:pointer-events-none disabled:opacity-50",
          d
        ),
        href: s,
        onClick: v,
        onKeyDown: y,
        rel: b,
        tabIndex: h ? -1 : void 0,
        ...w,
        children: [
          a && /* @__PURE__ */ u.jsx(Hp, { "aria-hidden": "true", className: "button-loader animate-spin" }),
          o
        ]
      }
    );
  }
  const g = f;
  function p(v) {
    typeof c == "function" && c(
      v
    );
  }
  return /* @__PURE__ */ u.jsxs(
    "button",
    {
      className: J(
        Us({ mode: t, variant: n, size: r, unstyled: i }),
        d
      ),
      disabled: h,
      onClick: p,
      ...g,
      children: [
        a && /* @__PURE__ */ u.jsx(Hp, { "aria-hidden": "true", className: "button-loader animate-spin" }),
        o
      ]
    }
  );
}
function FN({
  className: e,
  type: t,
  ...n
}) {
  const r = t === "checkbox";
  return /* @__PURE__ */ u.jsxs(
    "span",
    {
      className: J(
        "relative inline-flex size-[15px] shrink-0 align-middle",
        e
      ),
      "data-slot": `${t}-control`,
      children: [
        /* @__PURE__ */ u.jsx(
          "input",
          {
            className: "peer absolute inset-0 z-10 m-0 size-full cursor-pointer appearance-none opacity-0 disabled:cursor-not-allowed forced-colors:appearance-auto forced-colors:opacity-100",
            type: t,
            ...n
          }
        ),
        /* @__PURE__ */ u.jsx(
          "span",
          {
            "aria-hidden": "true",
            className: J(
              "pointer-events-none box-border size-full border border-black bg-white transition-[background-color,border-color,outline-color] duration-150 ease-out peer-hover:bg-zinc-100 peer-focus-visible:outline-2 peer-focus-visible:outline-black peer-focus-visible:outline-offset-2 peer-active:bg-zinc-200 peer-disabled:border-zinc-400 peer-disabled:bg-zinc-100 forced-colors:hidden",
              r ? "rounded-[2px]" : "rounded-full"
            )
          }
        ),
        /* @__PURE__ */ u.jsx(
          "span",
          {
            "aria-hidden": "true",
            className: J(
              "pointer-events-none absolute bg-black opacity-0 transition-opacity duration-150 ease-out peer-checked:opacity-100 peer-disabled:bg-zinc-400 forced-colors:hidden",
              r ? "inset-[2px] rounded-[1px]" : "inset-[3px] rounded-full"
            )
          }
        )
      ]
    }
  );
}
function Oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e?.(i), n === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
function fK(e, t) {
  const n = A.createContext(t), r = (a) => {
    const { children: o, ...s } = a, c = A.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ u.jsx(n.Provider, { value: c, children: o });
  };
  r.displayName = e + "Provider";
  function i(a) {
    const o = A.useContext(n);
    if (o) return o;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function wn(e, t = []) {
  let n = [];
  function r(a, o) {
    const s = A.createContext(o), c = n.length;
    n = [...n, o];
    const l = (f) => {
      const { scope: h, children: m, ...g } = f, p = h?.[e]?.[c] || s, v = A.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(p.Provider, { value: v, children: m });
    };
    l.displayName = a + "Provider";
    function d(f, h) {
      const m = h?.[e]?.[c] || s, g = A.useContext(m);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [l, d];
  }
  const i = () => {
    const a = n.map((o) => A.createContext(o));
    return function(s) {
      const c = s?.[e] || a;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, hK(i, ...t)];
}
function hK(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const o = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Vt = globalThis?.document ? A.useLayoutEffect : () => {
}, mK = A[" useId ".trim().toString()] || (() => {
}), vK = 0;
function Nn(e) {
  const [t, n] = A.useState(mK());
  return Vt(() => {
    n((r) => r ?? String(vK++));
  }, [e]), t ? `radix-${t}` : "";
}
var pK = A[" useInsertionEffect ".trim().toString()] || Vt;
function In({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, a, o] = gK({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, c = s ? e : i;
  {
    const d = A.useRef(e !== void 0);
    A.useEffect(() => {
      const f = d.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = s;
    }, [s, r]);
  }
  const l = A.useCallback(
    (d) => {
      if (s) {
        const f = yK(d) ? d(e) : d;
        f !== e && o.current?.(f);
      } else
        a(d);
    },
    [s, e, a, o]
  );
  return [c, l];
}
function gK({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = A.useState(e), i = A.useRef(n), a = A.useRef(t);
  return pK(() => {
    a.current = t;
  }, [t]), A.useEffect(() => {
    i.current !== n && (a.current?.(n), i.current = n);
  }, [n, i]), [n, r, a];
}
function yK(e) {
  return typeof e == "function";
}
var bK = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ae = bK.reduce((e, t) => {
  const n = Ra(`Primitive.${t}`), r = A.forwardRef((i, a) => {
    const { asChild: o, ...s } = i, c = o ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u.jsx(c, { ...s, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function xK(e, t) {
  e && Ru.flushSync(() => e.dispatchEvent(t));
}
function ii(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => t.current?.(...n), []);
}
function wK(e, t = globalThis?.document) {
  const n = ii(e);
  A.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var _K = "DismissableLayer", ly = "dismissableLayer.update", SK = "dismissableLayer.pointerDownOutside", OK = "dismissableLayer.focusOutside", tA, zN = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), uc = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: o,
      onDismiss: s,
      ...c
    } = e, l = A.useContext(zN), [d, f] = A.useState(null), h = d?.ownerDocument ?? globalThis?.document, [, m] = A.useState({}), g = ke(t, (O) => f(O)), p = Array.from(l.layers), [v] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = p.indexOf(v), x = d ? p.indexOf(d) : -1, w = l.layersWithOutsidePointerEventsDisabled.size > 0, _ = x >= y, b = PK((O) => {
      const E = O.target, P = [...l.branches].some((R) => R.contains(E));
      !_ || P || (i?.(O), o?.(O), O.defaultPrevented || s?.());
    }, h), S = CK((O) => {
      const E = O.target;
      [...l.branches].some((R) => R.contains(E)) || (a?.(O), o?.(O), O.defaultPrevented || s?.());
    }, h);
    return wK((O) => {
      x === l.layers.size - 1 && (r?.(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), A.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (tA = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), nA(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = tA);
        };
    }, [d, h, n, l]), A.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), nA());
    }, [d, l]), A.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(ly, O), () => document.removeEventListener(ly, O);
    }, []), /* @__PURE__ */ u.jsx(
      Ae.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: w ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Oe(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: Oe(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: Oe(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
uc.displayName = _K;
var EK = "DismissableLayerBranch", AK = A.forwardRef((e, t) => {
  const n = A.useContext(zN), r = A.useRef(null), i = ke(t, r);
  return A.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u.jsx(Ae.div, { ...e, ref: i });
});
AK.displayName = EK;
function PK(e, t = globalThis?.document) {
  const n = ii(e), r = A.useRef(!1), i = A.useRef(() => {
  });
  return A.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          qN(
            SK,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", a), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function CK(e, t = globalThis?.document) {
  const n = ii(e), r = A.useRef(!1);
  return A.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && qN(OK, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function nA() {
  const e = new CustomEvent(ly);
  document.dispatchEvent(e);
}
function qN(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? xK(i, a) : i.dispatchEvent(a);
}
var op = "focusScope.autoFocusOnMount", sp = "focusScope.autoFocusOnUnmount", rA = { bubbles: !1, cancelable: !0 }, jK = "FocusScope", pd = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...o
  } = e, [s, c] = A.useState(null), l = ii(i), d = ii(a), f = A.useRef(null), h = ke(t, (p) => c(p)), m = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let p = function(w) {
        if (m.paused || !s) return;
        const _ = w.target;
        s.contains(_) ? f.current = _ : Zr(f.current, { select: !0 });
      }, v = function(w) {
        if (m.paused || !s) return;
        const _ = w.relatedTarget;
        _ !== null && (s.contains(_) || Zr(f.current, { select: !0 }));
      }, y = function(w) {
        if (document.activeElement === document.body)
          for (const b of w)
            b.removedNodes.length > 0 && Zr(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const x = new MutationObserver(y);
      return s && x.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), x.disconnect();
      };
    }
  }, [r, s, m.paused]), A.useEffect(() => {
    if (s) {
      aA.add(m);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const y = new CustomEvent(op, rA);
        s.addEventListener(op, l), s.dispatchEvent(y), y.defaultPrevented || (TK(kK(VN(s)), { select: !0 }), document.activeElement === p && Zr(s));
      }
      return () => {
        s.removeEventListener(op, l), setTimeout(() => {
          const y = new CustomEvent(sp, rA);
          s.addEventListener(sp, d), s.dispatchEvent(y), y.defaultPrevented || Zr(p ?? document.body, { select: !0 }), s.removeEventListener(sp, d), aA.remove(m);
        }, 0);
      };
    }
  }, [s, l, d, m]);
  const g = A.useCallback(
    (p) => {
      if (!n && !r || m.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, y = document.activeElement;
      if (v && y) {
        const x = p.currentTarget, [w, _] = NK(x);
        w && _ ? !p.shiftKey && y === _ ? (p.preventDefault(), n && Zr(w, { select: !0 })) : p.shiftKey && y === w && (p.preventDefault(), n && Zr(_, { select: !0 })) : y === x && p.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ u.jsx(Ae.div, { tabIndex: -1, ...o, ref: h, onKeyDown: g });
});
pd.displayName = jK;
function TK(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Zr(r, { select: t }), document.activeElement !== n) return;
}
function NK(e) {
  const t = VN(e), n = iA(t, e), r = iA(t.reverse(), e);
  return [n, r];
}
function VN(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function iA(e, t) {
  for (const n of e)
    if (!MK(n, { upTo: t })) return n;
}
function MK(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function IK(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Zr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && IK(e) && t && e.select();
  }
}
var aA = DK();
function DK() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = oA(e, t), e.unshift(t);
    },
    remove(t) {
      e = oA(e, t), e[0]?.resume();
    }
  };
}
function oA(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function kK(e) {
  return e.filter((t) => t.tagName !== "A");
}
var RK = "Portal", gd = A.forwardRef((e, t) => {
  const { container: n, ...r } = e, [i, a] = A.useState(!1);
  Vt(() => a(!0), []);
  const o = n || i && globalThis?.document?.body;
  return o ? r2.createPortal(/* @__PURE__ */ u.jsx(Ae.div, { ...r, ref: t }), o) : null;
});
gd.displayName = RK;
function LK(e, t) {
  return A.useReducer((n, r) => t[n][r] ?? n, e);
}
var zr = (e) => {
  const { present: t, children: n } = e, r = $K(t), i = typeof n == "function" ? n({ present: r.isPresent }) : A.Children.only(n), a = ke(r.ref, BK(i));
  return typeof n == "function" || r.isPresent ? A.cloneElement(i, { ref: a }) : null;
};
zr.displayName = "Presence";
function $K(e) {
  const [t, n] = A.useState(), r = A.useRef(null), i = A.useRef(e), a = A.useRef("none"), o = e ? "mounted" : "unmounted", [s, c] = LK(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const l = Gc(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), Vt(() => {
    const l = r.current, d = i.current;
    if (d !== e) {
      const h = a.current, m = Gc(l);
      e ? c("MOUNT") : m === "none" || l?.display === "none" ? c("UNMOUNT") : c(d && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), Vt(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (m) => {
        const p = Gc(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && p && (c("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (m) => {
        m.target === t && (a.current = Gc(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: A.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Gc(e) {
  return e?.animationName || "none";
}
function BK(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var cp = 0;
function Qb() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? sA()), document.body.insertAdjacentElement("beforeend", e[1] ?? sA()), cp++, () => {
      cp === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), cp--;
    };
  }, []);
}
function sA() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var nr = function() {
  return nr = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, nr.apply(this, arguments);
};
function WN(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function FK(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var ml = "right-scroll-bar-position", vl = "width-before-scroll-bar", zK = "with-scroll-bars-hidden", qK = "--removed-body-scroll-bar-size";
function lp(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function VK(e, t) {
  var n = Ee(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var WK = typeof window < "u" ? A.useLayoutEffect : A.useEffect, cA = /* @__PURE__ */ new WeakMap();
function UK(e, t) {
  var n = VK(null, function(r) {
    return e.forEach(function(i) {
      return lp(i, r);
    });
  });
  return WK(function() {
    var r = cA.get(n);
    if (r) {
      var i = new Set(r), a = new Set(e), o = n.current;
      i.forEach(function(s) {
        a.has(s) || lp(s, null);
      }), a.forEach(function(s) {
        i.has(s) || lp(s, o);
      });
    }
    cA.set(n, e);
  }, [e]), n;
}
function HK(e) {
  return e;
}
function YK(e, t) {
  t === void 0 && (t = HK);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var o = t(a, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), o = n;
      }
      var c = function() {
        var d = o;
        o = [], d.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(d) {
          o.push(d), l();
        },
        filter: function(d) {
          return o = o.filter(d), n;
        }
      };
    }
  };
  return i;
}
function KK(e) {
  e === void 0 && (e = {});
  var t = YK(null);
  return t.options = nr({ async: !0, ssr: !1 }, e), t;
}
var UN = function(e) {
  var t = e.sideCar, n = WN(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, nr({}, n));
};
UN.isSideCarExport = !0;
function GK(e, t) {
  return e.useMedium(t), UN;
}
var HN = KK(), up = function() {
}, yd = A.forwardRef(function(e, t) {
  var n = A.useRef(null), r = A.useState({
    onScrollCapture: up,
    onWheelCapture: up,
    onTouchMoveCapture: up
  }), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, d = e.enabled, f = e.shards, h = e.sideCar, m = e.noRelative, g = e.noIsolation, p = e.inert, v = e.allowPinchZoom, y = e.as, x = y === void 0 ? "div" : y, w = e.gapMode, _ = WN(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = h, S = UK([n, t]), O = nr(nr({}, _), i);
  return A.createElement(
    A.Fragment,
    null,
    d && A.createElement(b, { sideCar: HN, removeScrollBar: l, shards: f, noRelative: m, noIsolation: g, inert: p, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: w }),
    o ? A.cloneElement(A.Children.only(s), nr(nr({}, O), { ref: S })) : A.createElement(x, nr({}, O, { className: c, ref: S }), s)
  );
});
yd.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
yd.classNames = {
  fullWidth: vl,
  zeroRight: ml
};
var ZK = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function XK() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ZK();
  return t && e.setAttribute("nonce", t), e;
}
function QK(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function JK(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var eG = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = XK()) && (QK(t, n), JK(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, tG = function() {
  var e = eG();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, YN = function() {
  var e = tG(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, nG = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, dp = function(e) {
  return parseInt(e || "", 10) || 0;
}, rG = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [dp(n), dp(r), dp(i)];
}, iG = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return nG;
  var t = rG(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, aG = YN(), ja = "data-scroll-locked", oG = function(e, t, n, r) {
  var i = e.left, a = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(zK, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(ja, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ml, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(vl, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(ml, " .").concat(ml, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(vl, " .").concat(vl, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ja, `] {
    `).concat(qK, ": ").concat(s, `px;
  }
`);
}, lA = function() {
  var e = parseInt(document.body.getAttribute(ja) || "0", 10);
  return isFinite(e) ? e : 0;
}, sG = function() {
  A.useEffect(function() {
    return document.body.setAttribute(ja, (lA() + 1).toString()), function() {
      var e = lA() - 1;
      e <= 0 ? document.body.removeAttribute(ja) : document.body.setAttribute(ja, e.toString());
    };
  }, []);
}, cG = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  sG();
  var a = A.useMemo(function() {
    return iG(i);
  }, [i]);
  return A.createElement(aG, { styles: oG(a, !t, i, n ? "" : "!important") });
}, uy = !1;
if (typeof window < "u")
  try {
    var Zc = Object.defineProperty({}, "passive", {
      get: function() {
        return uy = !0, !0;
      }
    });
    window.addEventListener("test", Zc, Zc), window.removeEventListener("test", Zc, Zc);
  } catch {
    uy = !1;
  }
var ma = uy ? { passive: !1 } : !1, lG = function(e) {
  return e.tagName === "TEXTAREA";
}, KN = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !lG(e) && n[t] === "visible")
  );
}, uG = function(e) {
  return KN(e, "overflowY");
}, dG = function(e) {
  return KN(e, "overflowX");
}, uA = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = GN(e, r);
    if (i) {
      var a = ZN(e, r), o = a[1], s = a[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, fG = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, hG = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, GN = function(e, t) {
  return e === "v" ? uG(t) : dG(t);
}, ZN = function(e, t) {
  return e === "v" ? fG(t) : hG(t);
}, mG = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, vG = function(e, t, n, r, i) {
  var a = mG(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, d = o > 0, f = 0, h = 0;
  do {
    if (!s)
      break;
    var m = ZN(e, s), g = m[0], p = m[1], v = m[2], y = p - v - a * g;
    (g || y) && GN(e, s) && (f += y, h += g);
    var x = s.parentNode;
    s = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && Math.abs(f) < 1 || !d && Math.abs(h) < 1) && (l = !0), l;
}, Xc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, dA = function(e) {
  return [e.deltaX, e.deltaY];
}, fA = function(e) {
  return e && "current" in e ? e.current : e;
}, pG = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, gG = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, yG = 0, va = [];
function bG(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), i = A.useState(yG++)[0], a = A.useState(YN)[0], o = A.useRef(e);
  A.useEffect(function() {
    o.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var p = FK([e.lockRef.current], (e.shards || []).map(fA), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = A.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !o.current.allowPinchZoom;
    var y = Xc(p), x = n.current, w = "deltaX" in p ? p.deltaX : x[0] - y[0], _ = "deltaY" in p ? p.deltaY : x[1] - y[1], b, S = p.target, O = Math.abs(w) > Math.abs(_) ? "h" : "v";
    if ("touches" in p && O === "h" && S.type === "range")
      return !1;
    var E = window.getSelection(), P = E && E.anchorNode, R = P ? P === S || P.contains(S) : !1;
    if (R)
      return !1;
    var j = uA(O, S);
    if (!j)
      return !0;
    if (j ? b = O : (b = O === "v" ? "h" : "v", j = uA(O, S)), !j)
      return !1;
    if (!r.current && "changedTouches" in p && (w || _) && (r.current = b), !b)
      return !0;
    var C = r.current || b;
    return vG(C, v, p, C === "h" ? w : _);
  }, []), c = A.useCallback(function(p) {
    var v = p;
    if (!(!va.length || va[va.length - 1] !== a)) {
      var y = "deltaY" in v ? dA(v) : Xc(v), x = t.current.filter(function(b) {
        return b.name === v.type && (b.target === v.target || v.target === b.shadowParent) && pG(b.delta, y);
      })[0];
      if (x && x.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!x) {
        var w = (o.current.shards || []).map(fA).filter(Boolean).filter(function(b) {
          return b.contains(v.target);
        }), _ = w.length > 0 ? s(v, w[0]) : !o.current.noIsolation;
        _ && v.cancelable && v.preventDefault();
      }
    }
  }, []), l = A.useCallback(function(p, v, y, x) {
    var w = { name: p, delta: v, target: y, should: x, shadowParent: xG(y) };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== w;
      });
    }, 1);
  }, []), d = A.useCallback(function(p) {
    n.current = Xc(p), r.current = void 0;
  }, []), f = A.useCallback(function(p) {
    l(p.type, dA(p), p.target, s(p, e.lockRef.current));
  }, []), h = A.useCallback(function(p) {
    l(p.type, Xc(p), p.target, s(p, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return va.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, ma), document.addEventListener("touchmove", c, ma), document.addEventListener("touchstart", d, ma), function() {
      va = va.filter(function(p) {
        return p !== a;
      }), document.removeEventListener("wheel", c, ma), document.removeEventListener("touchmove", c, ma), document.removeEventListener("touchstart", d, ma);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    g ? A.createElement(a, { styles: gG(i) }) : null,
    m ? A.createElement(cG, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function xG(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const wG = GK(HN, bG);
var bd = A.forwardRef(function(e, t) {
  return A.createElement(yd, nr({}, e, { ref: t, sideCar: wG }));
});
bd.classNames = yd.classNames;
var _G = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, pa = /* @__PURE__ */ new WeakMap(), Qc = /* @__PURE__ */ new WeakMap(), Jc = {}, fp = 0, XN = function(e) {
  return e && (e.host || XN(e.parentNode));
}, SG = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = XN(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, OG = function(e, t, n, r) {
  var i = SG(t, Array.isArray(e) ? e : [e]);
  Jc[n] || (Jc[n] = /* @__PURE__ */ new WeakMap());
  var a = Jc[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(f) {
    !f || s.has(f) || (s.add(f), l(f.parentNode));
  };
  i.forEach(l);
  var d = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (s.has(h))
        d(h);
      else
        try {
          var m = h.getAttribute(r), g = m !== null && m !== "false", p = (pa.get(h) || 0) + 1, v = (a.get(h) || 0) + 1;
          pa.set(h, p), a.set(h, v), o.push(h), p === 1 && g && Qc.set(h, !0), v === 1 && h.setAttribute(n, "true"), g || h.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", h, y);
        }
    });
  };
  return d(t), s.clear(), fp++, function() {
    o.forEach(function(f) {
      var h = pa.get(f) - 1, m = a.get(f) - 1;
      pa.set(f, h), a.set(f, m), h || (Qc.has(f) || f.removeAttribute(r), Qc.delete(f)), m || f.removeAttribute(n);
    }), fp--, fp || (pa = /* @__PURE__ */ new WeakMap(), pa = /* @__PURE__ */ new WeakMap(), Qc = /* @__PURE__ */ new WeakMap(), Jc = {});
  };
}, Jb = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = _G(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), OG(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, xd = "Dialog", [QN, JN] = wn(xd), [EG, Qn] = QN(xd), eM = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !0
  } = e, s = A.useRef(null), c = A.useRef(null), [l, d] = In({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: xd
  });
  return /* @__PURE__ */ u.jsx(
    EG,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: Nn(),
      titleId: Nn(),
      descriptionId: Nn(),
      open: l,
      onOpenChange: d,
      onOpenToggle: A.useCallback(() => d((f) => !f), [d]),
      modal: o,
      children: n
    }
  );
};
eM.displayName = xd;
var tM = "DialogTrigger", nM = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Qn(tM, n), a = ke(t, i.triggerRef);
    return /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": nx(i.open),
        ...r,
        ref: a,
        onClick: Oe(e.onClick, i.onOpenToggle)
      }
    );
  }
);
nM.displayName = tM;
var ex = "DialogPortal", [AG, rM] = QN(ex, {
  forceMount: void 0
}), iM = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = Qn(ex, t);
  return /* @__PURE__ */ u.jsx(AG, { scope: t, forceMount: n, children: A.Children.map(r, (o) => /* @__PURE__ */ u.jsx(zr, { present: n || a.open, children: /* @__PURE__ */ u.jsx(gd, { asChild: !0, container: i, children: o }) })) });
};
iM.displayName = ex;
var yu = "DialogOverlay", aM = A.forwardRef(
  (e, t) => {
    const n = rM(yu, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Qn(yu, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u.jsx(zr, { present: r || a.open, children: /* @__PURE__ */ u.jsx(CG, { ...i, ref: t }) }) : null;
  }
);
aM.displayName = yu;
var PG = Ra("DialogOverlay.RemoveScroll"), CG = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Qn(yu, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u.jsx(bd, { as: PG, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ u.jsx(
        Ae.div,
        {
          "data-state": nx(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Wi = "DialogContent", oM = A.forwardRef(
  (e, t) => {
    const n = rM(Wi, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Qn(Wi, e.__scopeDialog);
    return /* @__PURE__ */ u.jsx(zr, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u.jsx(jG, { ...i, ref: t }) : /* @__PURE__ */ u.jsx(TG, { ...i, ref: t }) });
  }
);
oM.displayName = Wi;
var jG = A.forwardRef(
  (e, t) => {
    const n = Qn(Wi, e.__scopeDialog), r = A.useRef(null), i = ke(t, n.contentRef, r);
    return A.useEffect(() => {
      const a = r.current;
      if (a) return Jb(a);
    }, []), /* @__PURE__ */ u.jsx(
      sM,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oe(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Oe(e.onPointerDownOutside, (a) => {
          const o = a.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: Oe(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), TG = A.forwardRef(
  (e, t) => {
    const n = Qn(Wi, e.__scopeDialog), r = A.useRef(!1), i = A.useRef(!1);
    return /* @__PURE__ */ u.jsx(
      sM,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (r.current || n.triggerRef.current?.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = a.target;
          n.triggerRef.current?.contains(o) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), sM = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = Qn(Wi, n), c = A.useRef(null), l = ke(t, c);
    return Qb(), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        pd,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u.jsx(
            uc,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": nx(s.open),
              ...o,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx(MG, { titleId: s.titleId }),
        /* @__PURE__ */ u.jsx(DG, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), tx = "DialogTitle", cM = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Qn(tx, n);
    return /* @__PURE__ */ u.jsx(Ae.h2, { id: i.titleId, ...r, ref: t });
  }
);
cM.displayName = tx;
var lM = "DialogDescription", uM = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Qn(lM, n);
    return /* @__PURE__ */ u.jsx(Ae.p, { id: i.descriptionId, ...r, ref: t });
  }
);
uM.displayName = lM;
var dM = "DialogClose", fM = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Qn(dM, n);
    return /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Oe(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
fM.displayName = dM;
function nx(e) {
  return e ? "open" : "closed";
}
var hM = "DialogTitleWarning", [NG, mM] = fK(hM, {
  contentName: Wi,
  titleName: tx,
  docsSlug: "dialog"
}), MG = ({ titleId: e }) => {
  const t = mM(hM), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return A.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, IG = "DialogDescriptionWarning", DG = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${mM(IG).contentName}}.`;
  return A.useEffect(() => {
    const i = e.current?.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, vM = eM, kG = nM, pM = iM, wd = aM, as = oM, rx = cM, ix = uM, bu = fM;
const oo = vM, hp = pM, dy = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  wd,
  {
    className: J(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=open]:animate-in",
      "fixed inset-0 z-[70] bg-black/80",
      e
    ),
    ref: t,
    ...n
  }
);
dy.displayName = wd.displayName;
const Ui = ku(
  ({
    className: e,
    children: t,
    imageDialog: n,
    imageController: r,
    hideCloseButton: i,
    galleryOverlay: a,
    ...o
  }, s) => a ? /* @__PURE__ */ u.jsxs(hp, { children: [
    /* @__PURE__ */ u.jsx(wd, { className: "fixed inset-0 z-[9999] bg-[#3F3F46]" }),
    /* @__PURE__ */ u.jsx(
      as,
      {
        "aria-describedby": void 0,
        className: J(
          "fixed inset-0 z-[9999] overflow-y-auto focus:outline-none",
          e
        ),
        ref: s,
        ...o,
        children: t
      }
    )
  ] }) : n ? /* @__PURE__ */ u.jsxs(hp, { children: [
    /* @__PURE__ */ u.jsx(dy, {}),
    /* @__PURE__ */ u.jsxs(
      as,
      {
        className: J(
          "fixed inset-0 z-[80] flex h-full w-full items-center justify-center bg-transparent",
          e
        ),
        ref: s,
        ...o,
        children: [
          !i && /* @__PURE__ */ u.jsxs(bu, { className: "fixed top-4 right-4 z-[90] flex h-9 w-9 cursor-pointer items-center justify-center rounded-sm border border-input bg-black/60 p-2 text-white opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none md:bg-transparent", children: [
            /* @__PURE__ */ u.jsx(ei, { className: "h-4 w-4" }),
            /* @__PURE__ */ u.jsx("span", { className: "sr-only", children: "Close" })
          ] }),
          r && /* @__PURE__ */ u.jsx("div", { className: "fixed right-4 bottom-4 z-[90]", children: r }),
          /* @__PURE__ */ u.jsx("div", { className: "flex h-full w-full items-center justify-center", children: /* @__PURE__ */ u.jsx("div", { className: "scrollbar-modal h-full w-full overflow-y-auto rounded-lg bg-white p-2 md:h-[90vh] md:max-h-[800px] md:w-[90vh] md:max-w-[90vh]", children: t }) })
        ]
      }
    )
  ] }) : /* @__PURE__ */ u.jsxs(hp, { children: [
    /* @__PURE__ */ u.jsx(dy, {}),
    /* @__PURE__ */ u.jsxs(
      as,
      {
        className: J(
          "-translate-x-1/2 -translate-y-1/2 scrollbar-modal fixed top-1/2 left-1/2 z-[80] grid max-h-[800px] w-full max-w-lg gap-4 overflow-y-auto border bg-background p-6 shadow-lg duration-200 sm:rounded-lg",
          "data-[state=open]:zoom-in-95 data-[state=open]:fade-in-0 data-[state=open]:animate-in",
          "data-[state=closed]:zoom-out-95 data-[state=closed]:fade-out-0 data-[state=closed]:animate-out",
          e
        ),
        ref: s,
        ...o,
        children: [
          t,
          !i && /* @__PURE__ */ u.jsxs(bu, { className: "absolute top-6 right-4 h-8 w-8 rounded-sm p-2 opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ u.jsx(ei, { className: "h-4 w-4" }),
            /* @__PURE__ */ u.jsx("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
Ui.displayName = as.displayName;
const dc = ({
  className: e,
  ...t
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: J(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
dc.displayName = "DialogHeader";
const ax = ({
  className: e,
  ...t
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: J(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
ax.displayName = "DialogFooter";
const Hi = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  rx,
  {
    className: J(
      "font-semibold text-lg leading-none tracking-tight",
      e
    ),
    ref: t,
    ...n
  }
);
Hi.displayName = rx.displayName;
const ox = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  ix,
  {
    className: J("text-muted-foreground text-sm", e),
    ref: t,
    ...n
  }
);
ox.displayName = ix.displayName;
const RG = yt(
  "flex h-9 w-full rounded-md border bg-white px-3 py-1 text-sm outline-none transition-colors file:mr-3 file:cursor-pointer file:border-0 file:bg-transparent file:font-bold file:text-sm placeholder:text-zinc-900 focus:ring-2 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-zinc-200 shadow-sm focus:border-zinc-900 focus:ring-zinc-900 focus-visible:border-zinc-900 focus-visible:ring-zinc-900",
        error: "border-red-600 shadow-[0_0_0_3px_rgba(254,202,202,1)] focus:border-red-600 focus:ring-red-200 focus-visible:border-red-600 focus-visible:ring-red-200"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function ni(e) {
  const { variant: t, className: n, ...r } = e, i = Le(null), a = () => {
    e.type === "file" && i.current?.focus();
  }, o = (c) => {
    e.type === "file" && i.current?.focus(), e.onChange?.(c);
  }, s = (c) => {
    e.onBlur?.(c);
  };
  return /* @__PURE__ */ u.jsx(
    "input",
    {
      className: J(RG({ variant: t }), n),
      onBlur: s,
      onChange: o,
      onClick: a,
      ref: i,
      ...r
    }
  );
}
var LG = "Label", gM = A.forwardRef((e, t) => /* @__PURE__ */ u.jsx(
  Ae.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      n.target.closest("button, input, select, textarea") || (e.onMouseDown?.(n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
gM.displayName = LG;
var $G = gM;
const BG = yt(
  "font-semibold text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      variant: {
        default: "text-zinc-900",
        muted: "text-zinc-500"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function wt(e) {
  const { variant: t, className: n, disabled: r, ...i } = e;
  return /* @__PURE__ */ u.jsx(
    $G,
    {
      className: J(BG({ variant: t }), r, n),
      ...i
    }
  );
}
const FG = {
  default: ei,
  error: MC,
  success: ls
}, zG = yt("shrink-0", {
  variants: {
    variant: {
      default: "text-primary",
      error: "text-red-600",
      success: "text-lime-500"
    }
  },
  defaultVariants: { variant: "default" }
}), qG = 0, hA = 100, VG = yt("", {
  variants: {
    variant: {
      default: "[&::-moz-progress-bar]:bg-primary [&::-webkit-progress-value]:bg-primary",
      error: "[&::-moz-progress-bar]:bg-red-600 [&::-webkit-progress-value]:bg-red-600",
      success: "[&::-moz-progress-bar]:bg-lime-500 [&::-webkit-progress-value]:bg-lime-500"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function Yle(e) {
  const t = e.variant ?? "default", n = Math.min(
    hA,
    Math.max(qG, e.value)
  ), r = FG[t];
  return /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ u.jsx(
      "progress",
      {
        className: Ce(
          "block h-2.5 w-full appearance-none rounded-full bg-zinc-200",
          "[&::-webkit-progress-bar]:rounded-full [&::-webkit-progress-bar]:bg-zinc-200",
          "[&::-webkit-progress-value]:min-w-2.5 [&::-webkit-progress-value]:rounded-full [&::-webkit-progress-value]:transition-all [&::-webkit-progress-value]:duration-300",
          "[&::-moz-progress-bar]:min-w-2.5 [&::-moz-progress-bar]:rounded-full [&::-moz-progress-bar]:transition-all [&::-moz-progress-bar]:duration-300",
          VG({ variant: t })
        ),
        max: hA,
        value: n
      }
    ),
    !e.hideIcon && /* @__PURE__ */ u.jsx(
      r,
      {
        "aria-hidden": "true",
        className: zG({ variant: t }),
        size: 16
      }
    )
  ] });
}
function fc(e) {
  function t(n) {
    e.onValueChange?.(n.target.value);
  }
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: J("flex flex-col gap-2", e.className),
      role: "radiogroup",
      children: e.options.map((n) => {
        const r = `${e.name ?? "radio-group"}-${n.value}`, i = e.disabled === !0 || n.disabled === !0;
        return /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ u.jsxs(
            wt,
            {
              className: "flex cursor-pointer items-start gap-2",
              disabled: i,
              htmlFor: r,
              children: [
                /* @__PURE__ */ u.jsx(
                  FN,
                  {
                    className: "mt-1",
                    disabled: i,
                    id: r,
                    name: e.name ?? "radio-group",
                    onChange: t,
                    type: "radio",
                    value: n.value,
                    ...e.value === void 0 ? { defaultChecked: e.defaultValue === n.value } : { checked: e.value === n.value }
                  }
                ),
                typeof n.label == "string" ? /* @__PURE__ */ u.jsx(B, { variant: e.labelVariant ?? "body-md", children: n.label }) : /* @__PURE__ */ u.jsx("div", { children: n.label })
              ]
            }
          ),
          n.description !== void 0 && /* @__PURE__ */ u.jsx("div", { className: "ml-6", children: /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-sm", children: n.description }) })
        ] }, n.value);
      })
    }
  );
}
function xu(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function _d(e) {
  const t = e + "CollectionProvider", [n, r] = wn(t), [i, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (p) => {
    const { scope: v, children: y } = p, x = T.useRef(null), w = T.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u.jsx(i, { scope: v, itemMap: w, collectionRef: x, children: y });
  };
  o.displayName = t;
  const s = e + "CollectionSlot", c = Ra(s), l = T.forwardRef(
    (p, v) => {
      const { scope: y, children: x } = p, w = a(s, y), _ = ke(v, w.collectionRef);
      return /* @__PURE__ */ u.jsx(c, { ref: _, children: x });
    }
  );
  l.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", h = Ra(d), m = T.forwardRef(
    (p, v) => {
      const { scope: y, children: x, ...w } = p, _ = T.useRef(null), b = ke(v, _), S = a(d, y);
      return T.useEffect(() => (S.itemMap.set(_, { ref: _, ...w }), () => void S.itemMap.delete(_))), /* @__PURE__ */ u.jsx(h, { [f]: "", ref: b, children: x });
    }
  );
  m.displayName = d;
  function g(p) {
    const v = a(e + "CollectionConsumer", p);
    return T.useCallback(() => {
      const x = v.collectionRef.current;
      if (!x) return [];
      const w = Array.from(x.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, O) => w.indexOf(S.ref.current) - w.indexOf(O.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: m },
    g,
    r
  ];
}
var WG = A.createContext(void 0);
function hc(e) {
  const t = A.useContext(WG);
  return e || t || "ltr";
}
const UG = ["top", "right", "bottom", "left"], ai = Math.min, pn = Math.max, wu = Math.round, el = Math.floor, ur = (e) => ({
  x: e,
  y: e
}), HG = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function fy(e, t, n) {
  return pn(e, ai(t, n));
}
function Rr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Lr(e) {
  return e.split("-")[0];
}
function So(e) {
  return e.split("-")[1];
}
function sx(e) {
  return e === "x" ? "y" : "x";
}
function cx(e) {
  return e === "y" ? "height" : "width";
}
function or(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function lx(e) {
  return sx(or(e));
}
function YG(e, t, n) {
  n === void 0 && (n = !1);
  const r = So(e), i = lx(e), a = cx(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = _u(o)), [o, _u(o)];
}
function KG(e) {
  const t = _u(e);
  return [hy(e), t, hy(t)];
}
function hy(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const mA = ["left", "right"], vA = ["right", "left"], GG = ["top", "bottom"], ZG = ["bottom", "top"];
function XG(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? vA : mA : t ? mA : vA;
    case "left":
    case "right":
      return t ? GG : ZG;
    default:
      return [];
  }
}
function QG(e, t, n, r) {
  const i = So(e);
  let a = XG(Lr(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(hy)))), a;
}
function _u(e) {
  const t = Lr(e);
  return HG[t] + e.slice(t.length);
}
function JG(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function yM(e) {
  return typeof e != "number" ? JG(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Su(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function pA(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = or(t), o = lx(t), s = cx(o), c = Lr(t), l = a === "y", d = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, h = r[s] / 2 - i[s] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (So(t)) {
    case "start":
      m[o] -= h * (n && l ? -1 : 1);
      break;
    case "end":
      m[o] += h * (n && l ? -1 : 1);
      break;
  }
  return m;
}
async function eZ(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = Rr(t, e), g = yM(m), v = s[h ? f === "floating" ? "reference" : "floating" : f], y = Su(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), x = f === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), _ = await (a.isElement == null ? void 0 : a.isElement(w)) ? await (a.getScale == null ? void 0 : a.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Su(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: w,
    strategy: c
  }) : x);
  return {
    top: (y.top - b.top + g.top) / _.y,
    bottom: (b.bottom - y.bottom + g.bottom) / _.y,
    left: (y.left - b.left + g.left) / _.x,
    right: (b.right - y.right + g.right) / _.x
  };
}
const tZ = 50, nZ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = o.detectOverflow ? o : {
    ...o,
    detectOverflow: eZ
  }, c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: f
  } = pA(l, r, c), h = r, m = 0;
  const g = {};
  for (let p = 0; p < a.length; p++) {
    const v = a[p];
    if (!v)
      continue;
    const {
      name: y,
      fn: x
    } = v, {
      x: w,
      y: _,
      data: b,
      reset: S
    } = await x({
      x: d,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: g,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = w ?? d, f = _ ?? f, g[y] = {
      ...g[y],
      ...b
    }, S && m < tZ && (m++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (l = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : S.rects), {
      x: d,
      y: f
    } = pA(l, h, c)), p = -1);
  }
  return {
    x: d,
    y: f,
    placement: h,
    strategy: i,
    middlewareData: g
  };
}, rZ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: d = 0
    } = Rr(e, t) || {};
    if (l == null)
      return {};
    const f = yM(d), h = {
      x: n,
      y: r
    }, m = lx(i), g = cx(m), p = await o.getDimensions(l), v = m === "y", y = v ? "top" : "left", x = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", _ = a.reference[g] + a.reference[m] - h[m] - a.floating[g], b = h[m] - a.reference[m], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l));
    let O = S ? S[w] : 0;
    (!O || !await (o.isElement == null ? void 0 : o.isElement(S))) && (O = s.floating[w] || a.floating[g]);
    const E = _ / 2 - b / 2, P = O / 2 - p[g] / 2 - 1, R = ai(f[y], P), j = ai(f[x], P), C = R, N = O - p[g] - j, k = O / 2 - p[g] / 2 + E, I = fy(C, k, N), $ = !c.arrow && So(i) != null && k !== I && a.reference[g] / 2 - (k < C ? R : j) - p[g] / 2 < 0, z = $ ? k < C ? k - C : k - N : 0;
    return {
      [m]: h[m] + z,
      data: {
        [m]: I,
        centerOffset: k - I - z,
        ...$ && {
          alignmentOffset: z
        }
      },
      reset: $
    };
  }
}), iZ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: p = !0,
        ...v
      } = Rr(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = Lr(i), x = or(s), w = Lr(s) === s, _ = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), b = h || (w || !p ? [_u(s)] : KG(s)), S = g !== "none";
      !h && S && b.push(...QG(s, p, g, _));
      const O = [s, ...b], E = await c.detectOverflow(t, v), P = [];
      let R = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && P.push(E[y]), f) {
        const k = YG(i, o, _);
        P.push(E[k[0]], E[k[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: P
      }], !P.every((k) => k <= 0)) {
        var j, C;
        const k = (((j = a.flip) == null ? void 0 : j.index) || 0) + 1, I = O[k];
        if (I && (!(f === "alignment" ? x !== or(I) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((V) => or(V.placement) === x ? V.overflows[0] > 0 : !0)))
          return {
            data: {
              index: k,
              overflows: R
            },
            reset: {
              placement: I
            }
          };
        let $ = (C = R.filter((z) => z.overflows[0] <= 0).sort((z, V) => z.overflows[1] - V.overflows[1])[0]) == null ? void 0 : C.placement;
        if (!$)
          switch (m) {
            case "bestFit": {
              var N;
              const z = (N = R.filter((V) => {
                if (S) {
                  const K = or(V.placement);
                  return K === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  K === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((K) => K > 0).reduce((K, D) => K + D, 0)]).sort((V, K) => V[1] - K[1])[0]) == null ? void 0 : N[0];
              z && ($ = z);
              break;
            }
            case "initialPlacement":
              $ = s;
              break;
          }
        if (i !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function gA(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function yA(e) {
  return UG.some((t) => e[t] >= 0);
}
const aZ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: i = "referenceHidden",
        ...a
      } = Rr(e, t);
      switch (i) {
        case "referenceHidden": {
          const o = await r.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), s = gA(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: yA(s)
            }
          };
        }
        case "escaped": {
          const o = await r.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), s = gA(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: yA(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, bM = /* @__PURE__ */ new Set(["left", "top"]);
async function oZ(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Lr(n), s = So(n), c = or(n) === "y", l = bM.has(o) ? -1 : 1, d = a && c ? -1 : 1, f = Rr(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (m = s === "end" ? g * -1 : g), c ? {
    x: m * d,
    y: h * l
  } : {
    x: h * l,
    y: m * d
  };
}
const sZ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, c = await oZ(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, cZ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        platform: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (y) => {
            let {
              x,
              y: w
            } = y;
            return {
              x,
              y: w
            };
          }
        },
        ...l
      } = Rr(e, t), d = {
        x: n,
        y: r
      }, f = await a.detectOverflow(t, l), h = or(Lr(i)), m = sx(h);
      let g = d[m], p = d[h];
      if (o) {
        const y = m === "y" ? "top" : "left", x = m === "y" ? "bottom" : "right", w = g + f[y], _ = g - f[x];
        g = fy(w, g, _);
      }
      if (s) {
        const y = h === "y" ? "top" : "left", x = h === "y" ? "bottom" : "right", w = p + f[y], _ = p - f[x];
        p = fy(w, p, _);
      }
      const v = c.fn({
        ...t,
        [m]: g,
        [h]: p
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [m]: o,
            [h]: s
          }
        }
      };
    }
  };
}, lZ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: a,
        middlewareData: o
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Rr(e, t), d = {
        x: n,
        y: r
      }, f = or(i), h = sx(f);
      let m = d[h], g = d[f];
      const p = Rr(s, t), v = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (c) {
        const w = h === "y" ? "height" : "width", _ = a.reference[h] - a.floating[w] + v.mainAxis, b = a.reference[h] + a.reference[w] - v.mainAxis;
        m < _ ? m = _ : m > b && (m = b);
      }
      if (l) {
        var y, x;
        const w = h === "y" ? "width" : "height", _ = bM.has(Lr(i)), b = a.reference[f] - a.floating[w] + (_ && ((y = o.offset) == null ? void 0 : y[f]) || 0) + (_ ? 0 : v.crossAxis), S = a.reference[f] + a.reference[w] + (_ ? 0 : ((x = o.offset) == null ? void 0 : x[f]) || 0) - (_ ? v.crossAxis : 0);
        g < b ? g = b : g > S && (g = S);
      }
      return {
        [h]: m,
        [f]: g
      };
    }
  };
}, uZ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = Rr(e, t), d = await o.detectOverflow(t, l), f = Lr(i), h = So(i), m = or(i) === "y", {
        width: g,
        height: p
      } = a.floating;
      let v, y;
      f === "top" || f === "bottom" ? (v = f, y = h === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (y = f, v = h === "end" ? "top" : "bottom");
      const x = p - d.top - d.bottom, w = g - d.left - d.right, _ = ai(p - d[v], x), b = ai(g - d[y], w), S = !t.middlewareData.shift;
      let O = _, E = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (E = w), (r = t.middlewareData.shift) != null && r.enabled.y && (O = x), S && !h) {
        const R = pn(d.left, 0), j = pn(d.right, 0), C = pn(d.top, 0), N = pn(d.bottom, 0);
        m ? E = g - 2 * (R !== 0 || j !== 0 ? R + j : pn(d.left, d.right)) : O = p - 2 * (C !== 0 || N !== 0 ? C + N : pn(d.top, d.bottom));
      }
      await c({
        ...t,
        availableWidth: E,
        availableHeight: O
      });
      const P = await o.getDimensions(s.floating);
      return g !== P.width || p !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Sd() {
  return typeof window < "u";
}
function Oo(e) {
  return xM(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function bn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function vr(e) {
  var t;
  return (t = (xM(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function xM(e) {
  return Sd() ? e instanceof Node || e instanceof bn(e).Node : !1;
}
function Gn(e) {
  return Sd() ? e instanceof Element || e instanceof bn(e).Element : !1;
}
function qr(e) {
  return Sd() ? e instanceof HTMLElement || e instanceof bn(e).HTMLElement : !1;
}
function bA(e) {
  return !Sd() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof bn(e).ShadowRoot;
}
function mc(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Zn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function dZ(e) {
  return /^(table|td|th)$/.test(Oo(e));
}
function Od(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const fZ = /transform|translate|scale|rotate|perspective|filter/, hZ = /paint|layout|strict|content/, Si = (e) => !!e && e !== "none";
let mp;
function ux(e) {
  const t = Gn(e) ? Zn(e) : e;
  return Si(t.transform) || Si(t.translate) || Si(t.scale) || Si(t.rotate) || Si(t.perspective) || !dx() && (Si(t.backdropFilter) || Si(t.filter)) || fZ.test(t.willChange || "") || hZ.test(t.contain || "");
}
function mZ(e) {
  let t = oi(e);
  for (; qr(t) && !so(t); ) {
    if (ux(t))
      return t;
    if (Od(t))
      return null;
    t = oi(t);
  }
  return null;
}
function dx() {
  return mp == null && (mp = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), mp;
}
function so(e) {
  return /^(html|body|#document)$/.test(Oo(e));
}
function Zn(e) {
  return bn(e).getComputedStyle(e);
}
function Ed(e) {
  return Gn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function oi(e) {
  if (Oo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    bA(e) && e.host || // Fallback.
    vr(e)
  );
  return bA(t) ? t.host : t;
}
function wM(e) {
  const t = oi(e);
  return so(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : qr(t) && mc(t) ? t : wM(t);
}
function Hs(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = wM(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = bn(i);
  if (a) {
    const s = my(o);
    return t.concat(o, o.visualViewport || [], mc(i) ? i : [], s && n ? Hs(s) : []);
  } else
    return t.concat(i, Hs(i, [], n));
}
function my(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function _M(e) {
  const t = Zn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = qr(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = wu(n) !== a || wu(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function fx(e) {
  return Gn(e) ? e : e.contextElement;
}
function Ta(e) {
  const t = fx(e);
  if (!qr(t))
    return ur(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = _M(t);
  let o = (a ? wu(n.width) : n.width) / r, s = (a ? wu(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const vZ = /* @__PURE__ */ ur(0);
function SM(e) {
  const t = bn(e);
  return !dx() || !t.visualViewport ? vZ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function pZ(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== bn(e) ? !1 : t;
}
function Yi(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = fx(e);
  let o = ur(1);
  t && (r ? Gn(r) && (o = Ta(r)) : o = Ta(e));
  const s = pZ(a, n, r) ? SM(a) : ur(0);
  let c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, d = i.width / o.x, f = i.height / o.y;
  if (a) {
    const h = bn(a), m = r && Gn(r) ? bn(r) : r;
    let g = h, p = my(g);
    for (; p && r && m !== g; ) {
      const v = Ta(p), y = p.getBoundingClientRect(), x = Zn(p), w = y.left + (p.clientLeft + parseFloat(x.paddingLeft)) * v.x, _ = y.top + (p.clientTop + parseFloat(x.paddingTop)) * v.y;
      c *= v.x, l *= v.y, d *= v.x, f *= v.y, c += w, l += _, g = bn(p), p = my(g);
    }
  }
  return Su({
    width: d,
    height: f,
    x: c,
    y: l
  });
}
function Ad(e, t) {
  const n = Ed(e).scrollLeft;
  return t ? t.left + n : Yi(vr(e)).left + n;
}
function OM(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Ad(e, n), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function gZ(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = vr(r), s = t ? Od(t.floating) : !1;
  if (r === o || s && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = ur(1);
  const d = ur(0), f = qr(r);
  if ((f || !f && !a) && ((Oo(r) !== "body" || mc(o)) && (c = Ed(r)), f)) {
    const m = Yi(r);
    l = Ta(r), d.x = m.x + r.clientLeft, d.y = m.y + r.clientTop;
  }
  const h = o && !f && !a ? OM(o, c) : ur(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + d.x + h.x,
    y: n.y * l.y - c.scrollTop * l.y + d.y + h.y
  };
}
function yZ(e) {
  return Array.from(e.getClientRects());
}
function bZ(e) {
  const t = vr(e), n = Ed(e), r = e.ownerDocument.body, i = pn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = pn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + Ad(e);
  const s = -n.scrollTop;
  return Zn(r).direction === "rtl" && (o += pn(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
const xA = 25;
function xZ(e, t) {
  const n = bn(e), r = vr(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    const d = dx();
    (!d || d && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  const l = Ad(r);
  if (l <= 0) {
    const d = r.ownerDocument, f = d.body, h = getComputedStyle(f), m = d.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, g = Math.abs(r.clientWidth - f.clientWidth - m);
    g <= xA && (a -= g);
  } else l <= xA && (a += l);
  return {
    width: a,
    height: o,
    x: s,
    y: c
  };
}
function wZ(e, t) {
  const n = Yi(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = qr(e) ? Ta(e) : ur(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, c = i * a.x, l = r * a.y;
  return {
    width: o,
    height: s,
    x: c,
    y: l
  };
}
function wA(e, t, n) {
  let r;
  if (t === "viewport")
    r = xZ(e, n);
  else if (t === "document")
    r = bZ(vr(e));
  else if (Gn(t))
    r = wZ(t, n);
  else {
    const i = SM(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Su(r);
}
function EM(e, t) {
  const n = oi(e);
  return n === t || !Gn(n) || so(n) ? !1 : Zn(n).position === "fixed" || EM(n, t);
}
function _Z(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Hs(e, [], !1).filter((s) => Gn(s) && Oo(s) !== "body"), i = null;
  const a = Zn(e).position === "fixed";
  let o = a ? oi(e) : e;
  for (; Gn(o) && !so(o); ) {
    const s = Zn(o), c = ux(o);
    !c && s.position === "fixed" && (i = null), (a ? !c && !i : !c && s.position === "static" && !!i && (i.position === "absolute" || i.position === "fixed") || mc(o) && !c && EM(e, o)) ? r = r.filter((d) => d !== o) : i = s, o = oi(o);
  }
  return t.set(e, r), r;
}
function SZ(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? Od(t) ? [] : _Z(t, this._c) : [].concat(n), r], s = wA(t, o[0], i);
  let c = s.top, l = s.right, d = s.bottom, f = s.left;
  for (let h = 1; h < o.length; h++) {
    const m = wA(t, o[h], i);
    c = pn(m.top, c), l = ai(m.right, l), d = ai(m.bottom, d), f = pn(m.left, f);
  }
  return {
    width: l - f,
    height: d - c,
    x: f,
    y: c
  };
}
function OZ(e) {
  const {
    width: t,
    height: n
  } = _M(e);
  return {
    width: t,
    height: n
  };
}
function EZ(e, t, n) {
  const r = qr(t), i = vr(t), a = n === "fixed", o = Yi(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ur(0);
  function l() {
    c.x = Ad(i);
  }
  if (r || !r && !a)
    if ((Oo(t) !== "body" || mc(i)) && (s = Ed(t)), r) {
      const m = Yi(t, !0, a, t);
      c.x = m.x + t.clientLeft, c.y = m.y + t.clientTop;
    } else i && l();
  a && !r && i && l();
  const d = i && !r && !a ? OM(i, s) : ur(0), f = o.left + s.scrollLeft - c.x - d.x, h = o.top + s.scrollTop - c.y - d.y;
  return {
    x: f,
    y: h,
    width: o.width,
    height: o.height
  };
}
function vp(e) {
  return Zn(e).position === "static";
}
function _A(e, t) {
  if (!qr(e) || Zn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return vr(e) === n && (n = n.ownerDocument.body), n;
}
function AM(e, t) {
  const n = bn(e);
  if (Od(e))
    return n;
  if (!qr(e)) {
    let i = oi(e);
    for (; i && !so(i); ) {
      if (Gn(i) && !vp(i))
        return i;
      i = oi(i);
    }
    return n;
  }
  let r = _A(e, t);
  for (; r && dZ(r) && vp(r); )
    r = _A(r, t);
  return r && so(r) && vp(r) && !ux(r) ? n : r || mZ(e) || n;
}
const AZ = async function(e) {
  const t = this.getOffsetParent || AM, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: EZ(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function PZ(e) {
  return Zn(e).direction === "rtl";
}
const CZ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: gZ,
  getDocumentElement: vr,
  getClippingRect: SZ,
  getOffsetParent: AM,
  getElementRects: AZ,
  getClientRects: yZ,
  getDimensions: OZ,
  getScale: Ta,
  isElement: Gn,
  isRTL: PZ
};
function PM(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function jZ(e, t) {
  let n = null, r;
  const i = vr(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const l = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: h,
      height: m
    } = l;
    if (s || t(), !h || !m)
      return;
    const g = el(f), p = el(i.clientWidth - (d + h)), v = el(i.clientHeight - (f + m)), y = el(d), w = {
      rootMargin: -g + "px " + -p + "px " + -v + "px " + -y + "px",
      threshold: pn(0, ai(1, c)) || 1
    };
    let _ = !0;
    function b(S) {
      const O = S[0].intersectionRatio;
      if (O !== c) {
        if (!_)
          return o();
        O ? o(!1, O) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !PM(l, e.getBoundingClientRect()) && o(), _ = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, w);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function TZ(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = fx(e), d = i || a ? [...l ? Hs(l) : [], ...t ? Hs(t) : []] : [];
  d.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const f = l && s ? jZ(l, n) : null;
  let h = -1, m = null;
  o && (m = new ResizeObserver((y) => {
    let [x] = y;
    x && x.target === l && m && t && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = m) == null || w.observe(t);
    })), n();
  }), l && !c && m.observe(l), t && m.observe(t));
  let g, p = c ? Yi(e) : null;
  c && v();
  function v() {
    const y = Yi(e);
    p && !PM(p, y) && n(), p = y, g = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    d.forEach((x) => {
      i && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), f?.(), (y = m) == null || y.disconnect(), m = null, c && cancelAnimationFrame(g);
  };
}
const NZ = sZ, MZ = cZ, IZ = iZ, DZ = uZ, kZ = aZ, SA = rZ, RZ = lZ, LZ = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: CZ,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return nZ(e, t, {
    ...i,
    platform: a
  });
};
var $Z = typeof document < "u", BZ = function() {
}, pl = $Z ? Ky : BZ;
function Ou(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ou(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && e.$$typeof) && !Ou(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function CM(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function OA(e, t) {
  const n = CM(e);
  return Math.round(t * n) / n;
}
function pp(e) {
  const t = A.useRef(e);
  return pl(() => {
    t.current = e;
  }), t;
}
function FZ(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [d, f] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = A.useState(r);
  Ou(h, r) || m(r);
  const [g, p] = A.useState(null), [v, y] = A.useState(null), x = A.useCallback((V) => {
    V !== S.current && (S.current = V, p(V));
  }, []), w = A.useCallback((V) => {
    V !== O.current && (O.current = V, y(V));
  }, []), _ = a || g, b = o || v, S = A.useRef(null), O = A.useRef(null), E = A.useRef(d), P = c != null, R = pp(c), j = pp(i), C = pp(l), N = A.useCallback(() => {
    if (!S.current || !O.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: h
    };
    j.current && (V.platform = j.current), LZ(S.current, O.current, V).then((K) => {
      const D = {
        ...K,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: C.current !== !1
      };
      k.current && !Ou(E.current, D) && (E.current = D, Ru.flushSync(() => {
        f(D);
      }));
    });
  }, [h, t, n, j, C]);
  pl(() => {
    l === !1 && E.current.isPositioned && (E.current.isPositioned = !1, f((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [l]);
  const k = A.useRef(!1);
  pl(() => (k.current = !0, () => {
    k.current = !1;
  }), []), pl(() => {
    if (_ && (S.current = _), b && (O.current = b), _ && b) {
      if (R.current)
        return R.current(_, b, N);
      N();
    }
  }, [_, b, N, R, P]);
  const I = A.useMemo(() => ({
    reference: S,
    floating: O,
    setReference: x,
    setFloating: w
  }), [x, w]), $ = A.useMemo(() => ({
    reference: _,
    floating: b
  }), [_, b]), z = A.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return V;
    const K = OA($.floating, d.x), D = OA($.floating, d.y);
    return s ? {
      ...V,
      transform: "translate(" + K + "px, " + D + "px)",
      ...CM($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: K,
      top: D
    };
  }, [n, s, $.floating, d.x, d.y]);
  return A.useMemo(() => ({
    ...d,
    update: N,
    refs: I,
    elements: $,
    floatingStyles: z
  }), [d, N, I, $, z]);
}
const zZ = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? SA({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? SA({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, qZ = (e, t) => {
  const n = NZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, VZ = (e, t) => {
  const n = MZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, WZ = (e, t) => ({
  fn: RZ(e).fn,
  options: [e, t]
}), UZ = (e, t) => {
  const n = IZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, HZ = (e, t) => {
  const n = DZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, YZ = (e, t) => {
  const n = kZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, KZ = (e, t) => {
  const n = zZ(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var GZ = "Arrow", jM = A.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...a } = e;
  return /* @__PURE__ */ u.jsx(
    Ae.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ u.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
jM.displayName = GZ;
var ZZ = jM;
function hx(e) {
  const [t, n] = A.useState(void 0);
  return Vt(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let o, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          o = l.inlineSize, s = l.blockSize;
        } else
          o = e.offsetWidth, s = e.offsetHeight;
        n({ width: o, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var mx = "Popper", [TM, Eo] = wn(mx), [XZ, NM] = TM(mx), MM = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = A.useState(null);
  return /* @__PURE__ */ u.jsx(XZ, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
MM.displayName = mx;
var IM = "PopperAnchor", DM = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, a = NM(IM, n), o = A.useRef(null), s = ke(t, o), c = A.useRef(null);
    return A.useEffect(() => {
      const l = c.current;
      c.current = r?.current || o.current, l !== c.current && a.onAnchorChange(c.current);
    }), r ? null : /* @__PURE__ */ u.jsx(Ae.div, { ...i, ref: s });
  }
);
DM.displayName = IM;
var vx = "PopperContent", [QZ, JZ] = TM(vx), kM = A.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: a = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: g,
      ...p
    } = e, v = NM(vx, n), [y, x] = A.useState(null), w = ke(t, (ee) => x(ee)), [_, b] = A.useState(null), S = hx(_), O = S?.width ?? 0, E = S?.height ?? 0, P = r + (a !== "center" ? "-" + a : ""), R = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, j = Array.isArray(l) ? l : [l], C = j.length > 0, N = {
      padding: R,
      boundary: j.filter(t7),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: C
    }, { refs: k, floatingStyles: I, placement: $, isPositioned: z, middlewareData: V } = FZ({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: P,
      whileElementsMounted: (...ee) => TZ(...ee, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        qZ({ mainAxis: i + E, alignmentAxis: o }),
        c && VZ({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? WZ() : void 0,
          ...N
        }),
        c && UZ({ ...N }),
        HZ({
          ...N,
          apply: ({ elements: ee, rects: se, availableWidth: G, availableHeight: Q }) => {
            const { width: ce, height: F } = se.reference, ye = ee.floating.style;
            ye.setProperty("--radix-popper-available-width", `${G}px`), ye.setProperty("--radix-popper-available-height", `${Q}px`), ye.setProperty("--radix-popper-anchor-width", `${ce}px`), ye.setProperty("--radix-popper-anchor-height", `${F}px`);
          }
        }),
        _ && KZ({ element: _, padding: s }),
        n7({ arrowWidth: O, arrowHeight: E }),
        h && YZ({ strategy: "referenceHidden", ...N })
      ]
    }), [K, D] = $M($), U = ii(g);
    Vt(() => {
      z && U?.();
    }, [z, U]);
    const Y = V.arrow?.x, X = V.arrow?.y, oe = V.arrow?.centerOffset !== 0, [ie, he] = A.useState();
    return Vt(() => {
      y && he(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ u.jsx(
      "div",
      {
        ref: k.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...I,
          transform: z ? I.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ie,
          "--radix-popper-transform-origin": [
            V.transformOrigin?.x,
            V.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...V.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u.jsx(
          QZ,
          {
            scope: n,
            placedSide: K,
            onArrowChange: b,
            arrowX: Y,
            arrowY: X,
            shouldHideArrow: oe,
            children: /* @__PURE__ */ u.jsx(
              Ae.div,
              {
                "data-side": K,
                "data-align": D,
                ...p,
                ref: w,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
kM.displayName = vx;
var RM = "PopperArrow", e7 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, LM = A.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, a = JZ(RM, r), o = e7[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u.jsx(
          ZZ,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
LM.displayName = RM;
function t7(e) {
  return e !== null;
}
var n7 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: i } = t, o = i.arrow?.centerOffset !== 0, s = o ? 0 : e.arrowWidth, c = o ? 0 : e.arrowHeight, [l, d] = $M(n), f = { start: "0%", center: "50%", end: "100%" }[d], h = (i.arrow?.x ?? 0) + s / 2, m = (i.arrow?.y ?? 0) + c / 2;
    let g = "", p = "";
    return l === "bottom" ? (g = o ? f : `${h}px`, p = `${-c}px`) : l === "top" ? (g = o ? f : `${h}px`, p = `${r.floating.height + c}px`) : l === "right" ? (g = `${-c}px`, p = o ? f : `${m}px`) : l === "left" && (g = `${r.floating.width + c}px`, p = o ? f : `${m}px`), { data: { x: g, y: p } };
  }
});
function $M(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var px = MM, Pd = DM, gx = kM, yx = LM;
function bx(e) {
  const t = A.useRef({ value: e, previous: e });
  return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var BM = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), r7 = "VisuallyHidden", FM = A.forwardRef(
  (e, t) => /* @__PURE__ */ u.jsx(
    Ae.span,
    {
      ...e,
      ref: t,
      style: { ...BM, ...e.style }
    }
  )
);
FM.displayName = r7;
var i7 = FM, a7 = [" ", "Enter", "ArrowUp", "ArrowDown"], o7 = [" ", "Enter"], Ki = "Select", [Cd, jd, s7] = _d(Ki), [Ao] = wn(Ki, [
  s7,
  Eo
]), Td = Eo(), [c7, hi] = Ao(Ki), [l7, u7] = Ao(Ki), zM = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    value: o,
    defaultValue: s,
    onValueChange: c,
    dir: l,
    name: d,
    autoComplete: f,
    disabled: h,
    required: m,
    form: g
  } = e, p = Td(t), [v, y] = A.useState(null), [x, w] = A.useState(null), [_, b] = A.useState(!1), S = hc(l), [O, E] = In({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: Ki
  }), [P, R] = In({
    prop: o,
    defaultProp: s,
    onChange: c,
    caller: Ki
  }), j = A.useRef(null), C = v ? g || !!v.closest("form") : !0, [N, k] = A.useState(/* @__PURE__ */ new Set()), I = Array.from(N).map(($) => $.props.value).join(";");
  return /* @__PURE__ */ u.jsx(px, { ...p, children: /* @__PURE__ */ u.jsxs(
    c7,
    {
      required: m,
      scope: t,
      trigger: v,
      onTriggerChange: y,
      valueNode: x,
      onValueNodeChange: w,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: b,
      contentId: Nn(),
      value: P,
      onValueChange: R,
      open: O,
      onOpenChange: E,
      dir: S,
      triggerPointerDownPosRef: j,
      disabled: h,
      children: [
        /* @__PURE__ */ u.jsx(Cd.Provider, { scope: t, children: /* @__PURE__ */ u.jsx(
          l7,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: A.useCallback(($) => {
              k((z) => new Set(z).add($));
            }, []),
            onNativeOptionRemove: A.useCallback(($) => {
              k((z) => {
                const V = new Set(z);
                return V.delete($), V;
              });
            }, []),
            children: n
          }
        ) }),
        C ? /* @__PURE__ */ u.jsxs(
          uI,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: P,
            onChange: ($) => R($.target.value),
            disabled: h,
            form: g,
            children: [
              P === void 0 ? /* @__PURE__ */ u.jsx("option", { value: "" }) : null,
              Array.from(N)
            ]
          },
          I
        ) : null
      ]
    }
  ) });
};
zM.displayName = Ki;
var qM = "SelectTrigger", VM = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, a = Td(n), o = hi(qM, n), s = o.disabled || r, c = ke(t, o.onTriggerChange), l = jd(n), d = A.useRef("touch"), [f, h, m] = fI((p) => {
      const v = l().filter((w) => !w.disabled), y = v.find((w) => w.value === o.value), x = hI(v, p, y);
      x !== void 0 && o.onValueChange(x.value);
    }), g = (p) => {
      s || (o.onOpenChange(!0), m()), p && (o.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ u.jsx(Pd, { asChild: !0, ...a, children: /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": dI(o.value) ? "" : void 0,
        ...i,
        ref: c,
        onClick: Oe(i.onClick, (p) => {
          p.currentTarget.focus(), d.current !== "mouse" && g(p);
        }),
        onPointerDown: Oe(i.onPointerDown, (p) => {
          d.current = p.pointerType;
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (g(p), p.preventDefault());
        }),
        onKeyDown: Oe(i.onKeyDown, (p) => {
          const v = f.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && h(p.key), !(v && p.key === " ") && a7.includes(p.key) && (g(), p.preventDefault());
        })
      }
    ) });
  }
);
VM.displayName = qM;
var WM = "SelectValue", UM = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: a, placeholder: o = "", ...s } = e, c = hi(WM, n), { onValueNodeHasChildrenChange: l } = c, d = a !== void 0, f = ke(t, c.onValueNodeChange);
    return Vt(() => {
      l(d);
    }, [l, d]), /* @__PURE__ */ u.jsx(
      Ae.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: dI(c.value) ? /* @__PURE__ */ u.jsx(u.Fragment, { children: o }) : a
      }
    );
  }
);
UM.displayName = WM;
var d7 = "SelectIcon", HM = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ u.jsx(Ae.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
HM.displayName = d7;
var f7 = "SelectPortal", YM = (e) => /* @__PURE__ */ u.jsx(gd, { asChild: !0, ...e });
YM.displayName = f7;
var Gi = "SelectContent", KM = A.forwardRef(
  (e, t) => {
    const n = hi(Gi, e.__scopeSelect), [r, i] = A.useState();
    if (Vt(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? Ru.createPortal(
        /* @__PURE__ */ u.jsx(GM, { scope: e.__scopeSelect, children: /* @__PURE__ */ u.jsx(Cd.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ u.jsx("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ u.jsx(ZM, { ...e, ref: t });
  }
);
KM.displayName = Gi;
var Fn = 10, [GM, mi] = Ao(Gi), h7 = "SelectContentImpl", m7 = Ra("SelectContent.RemoveScroll"), ZM = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: v,
      //
      ...y
    } = e, x = hi(Gi, n), [w, _] = A.useState(null), [b, S] = A.useState(null), O = ke(t, (ee) => _(ee)), [E, P] = A.useState(null), [R, j] = A.useState(
      null
    ), C = jd(n), [N, k] = A.useState(!1), I = A.useRef(!1);
    A.useEffect(() => {
      if (w) return Jb(w);
    }, [w]), Qb();
    const $ = A.useCallback(
      (ee) => {
        const [se, ...G] = C().map((F) => F.ref.current), [Q] = G.slice(-1), ce = document.activeElement;
        for (const F of ee)
          if (F === ce || (F?.scrollIntoView({ block: "nearest" }), F === se && b && (b.scrollTop = 0), F === Q && b && (b.scrollTop = b.scrollHeight), F?.focus(), document.activeElement !== ce)) return;
      },
      [C, b]
    ), z = A.useCallback(
      () => $([E, w]),
      [$, E, w]
    );
    A.useEffect(() => {
      N && z();
    }, [N, z]);
    const { onOpenChange: V, triggerPointerDownPosRef: K } = x;
    A.useEffect(() => {
      if (w) {
        let ee = { x: 0, y: 0 };
        const se = (Q) => {
          ee = {
            x: Math.abs(Math.round(Q.pageX) - (K.current?.x ?? 0)),
            y: Math.abs(Math.round(Q.pageY) - (K.current?.y ?? 0))
          };
        }, G = (Q) => {
          ee.x <= 10 && ee.y <= 10 ? Q.preventDefault() : w.contains(Q.target) || V(!1), document.removeEventListener("pointermove", se), K.current = null;
        };
        return K.current !== null && (document.addEventListener("pointermove", se), document.addEventListener("pointerup", G, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", se), document.removeEventListener("pointerup", G, { capture: !0 });
        };
      }
    }, [w, V, K]), A.useEffect(() => {
      const ee = () => V(!1);
      return window.addEventListener("blur", ee), window.addEventListener("resize", ee), () => {
        window.removeEventListener("blur", ee), window.removeEventListener("resize", ee);
      };
    }, [V]);
    const [D, U] = fI((ee) => {
      const se = C().filter((ce) => !ce.disabled), G = se.find((ce) => ce.ref.current === document.activeElement), Q = hI(se, ee, G);
      Q && setTimeout(() => Q.ref.current.focus());
    }), Y = A.useCallback(
      (ee, se, G) => {
        const Q = !I.current && !G;
        (x.value !== void 0 && x.value === se || Q) && (P(ee), Q && (I.current = !0));
      },
      [x.value]
    ), X = A.useCallback(() => w?.focus(), [w]), oe = A.useCallback(
      (ee, se, G) => {
        const Q = !I.current && !G;
        (x.value !== void 0 && x.value === se || Q) && j(ee);
      },
      [x.value]
    ), ie = r === "popper" ? vy : XM, he = ie === vy ? {
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: p,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ u.jsx(
      GM,
      {
        scope: n,
        content: w,
        viewport: b,
        onViewportChange: S,
        itemRefCallback: Y,
        selectedItem: E,
        onItemLeave: X,
        itemTextRefCallback: oe,
        focusSelectedItem: z,
        selectedItemText: R,
        position: r,
        isPositioned: N,
        searchRef: D,
        children: /* @__PURE__ */ u.jsx(bd, { as: m7, allowPinchZoom: !0, children: /* @__PURE__ */ u.jsx(
          pd,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (ee) => {
              ee.preventDefault();
            },
            onUnmountAutoFocus: Oe(i, (ee) => {
              x.trigger?.focus({ preventScroll: !0 }), ee.preventDefault();
            }),
            children: /* @__PURE__ */ u.jsx(
              uc,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: o,
                onFocusOutside: (ee) => ee.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ u.jsx(
                  ie,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (ee) => ee.preventDefault(),
                    ...y,
                    ...he,
                    onPlaced: () => k(!0),
                    ref: O,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: Oe(y.onKeyDown, (ee) => {
                      const se = ee.ctrlKey || ee.altKey || ee.metaKey;
                      if (ee.key === "Tab" && ee.preventDefault(), !se && ee.key.length === 1 && U(ee.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(ee.key)) {
                        let Q = C().filter((ce) => !ce.disabled).map((ce) => ce.ref.current);
                        if (["ArrowUp", "End"].includes(ee.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(ee.key)) {
                          const ce = ee.target, F = Q.indexOf(ce);
                          Q = Q.slice(F + 1);
                        }
                        setTimeout(() => $(Q)), ee.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ZM.displayName = h7;
var v7 = "SelectItemAlignedPosition", XM = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, a = hi(Gi, n), o = mi(Gi, n), [s, c] = A.useState(null), [l, d] = A.useState(null), f = ke(t, (O) => d(O)), h = jd(n), m = A.useRef(!1), g = A.useRef(!0), { viewport: p, selectedItem: v, selectedItemText: y, focusSelectedItem: x } = o, w = A.useCallback(() => {
    if (a.trigger && a.valueNode && s && l && p && v && y) {
      const O = a.trigger.getBoundingClientRect(), E = l.getBoundingClientRect(), P = a.valueNode.getBoundingClientRect(), R = y.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const ce = R.left - E.left, F = P.left - ce, ye = O.left - F, te = O.width + ye, Ne = Math.max(te, E.width), Te = window.innerWidth - Fn, Ge = xu(F, [
          Fn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Fn, Te - Ne)
        ]);
        s.style.minWidth = te + "px", s.style.left = Ge + "px";
      } else {
        const ce = E.right - R.right, F = window.innerWidth - P.right - ce, ye = window.innerWidth - O.right - F, te = O.width + ye, Ne = Math.max(te, E.width), Te = window.innerWidth - Fn, Ge = xu(F, [
          Fn,
          Math.max(Fn, Te - Ne)
        ]);
        s.style.minWidth = te + "px", s.style.right = Ge + "px";
      }
      const j = h(), C = window.innerHeight - Fn * 2, N = p.scrollHeight, k = window.getComputedStyle(l), I = parseInt(k.borderTopWidth, 10), $ = parseInt(k.paddingTop, 10), z = parseInt(k.borderBottomWidth, 10), V = parseInt(k.paddingBottom, 10), K = I + $ + N + V + z, D = Math.min(v.offsetHeight * 5, K), U = window.getComputedStyle(p), Y = parseInt(U.paddingTop, 10), X = parseInt(U.paddingBottom, 10), oe = O.top + O.height / 2 - Fn, ie = C - oe, he = v.offsetHeight / 2, ee = v.offsetTop + he, se = I + $ + ee, G = K - se;
      if (se <= oe) {
        const ce = j.length > 0 && v === j[j.length - 1].ref.current;
        s.style.bottom = "0px";
        const F = l.clientHeight - p.offsetTop - p.offsetHeight, ye = Math.max(
          ie,
          he + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ce ? X : 0) + F + z
        ), te = se + ye;
        s.style.height = te + "px";
      } else {
        const ce = j.length > 0 && v === j[0].ref.current;
        s.style.top = "0px";
        const ye = Math.max(
          oe,
          I + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ce ? Y : 0) + he
        ) + G;
        s.style.height = ye + "px", p.scrollTop = se - oe + p.offsetTop;
      }
      s.style.margin = `${Fn}px 0`, s.style.minHeight = D + "px", s.style.maxHeight = C + "px", r?.(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    a.trigger,
    a.valueNode,
    s,
    l,
    p,
    v,
    y,
    a.dir,
    r
  ]);
  Vt(() => w(), [w]);
  const [_, b] = A.useState();
  Vt(() => {
    l && b(window.getComputedStyle(l).zIndex);
  }, [l]);
  const S = A.useCallback(
    (O) => {
      O && g.current === !0 && (w(), x?.(), g.current = !1);
    },
    [w, x]
  );
  return /* @__PURE__ */ u.jsx(
    g7,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ u.jsx(
            Ae.div,
            {
              ...i,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
XM.displayName = v7;
var p7 = "SelectPopperPosition", vy = A.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Fn,
    ...a
  } = e, o = Td(n);
  return /* @__PURE__ */ u.jsx(
    gx,
    {
      ...o,
      ...a,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
vy.displayName = p7;
var [g7, xx] = Ao(Gi, {}), py = "SelectViewport", QM = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, a = mi(py, n), o = xx(py, n), s = ke(t, a.onViewportChange), c = A.useRef(0);
    return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ u.jsx(Cd.Slot, { scope: n, children: /* @__PURE__ */ u.jsx(
        Ae.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: Oe(i.onScroll, (l) => {
            const d = l.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = o;
            if (h?.current && f) {
              const m = Math.abs(c.current - d.scrollTop);
              if (m > 0) {
                const g = window.innerHeight - Fn * 2, p = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), y = Math.max(p, v);
                if (y < g) {
                  const x = y + m, w = Math.min(g, x), _ = x - w;
                  f.style.height = w + "px", f.style.bottom === "0px" && (d.scrollTop = _ > 0 ? _ : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
QM.displayName = py;
var JM = "SelectGroup", [y7, b7] = Ao(JM), x7 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Nn();
    return /* @__PURE__ */ u.jsx(y7, { scope: n, id: i, children: /* @__PURE__ */ u.jsx(Ae.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
x7.displayName = JM;
var eI = "SelectLabel", tI = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = b7(eI, n);
    return /* @__PURE__ */ u.jsx(Ae.div, { id: i.id, ...r, ref: t });
  }
);
tI.displayName = eI;
var Eu = "SelectItem", [w7, nI] = Ao(Eu), rI = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: a,
      ...o
    } = e, s = hi(Eu, n), c = mi(Eu, n), l = s.value === r, [d, f] = A.useState(a ?? ""), [h, m] = A.useState(!1), g = ke(
      t,
      (x) => c.itemRefCallback?.(x, r, i)
    ), p = Nn(), v = A.useRef("touch"), y = () => {
      i || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ u.jsx(
      w7,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: p,
        isSelected: l,
        onItemTextChange: A.useCallback((x) => {
          f((w) => w || (x?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ u.jsx(
          Cd.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: d,
            children: /* @__PURE__ */ u.jsx(
              Ae.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": l && h,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...o,
                ref: g,
                onFocus: Oe(o.onFocus, () => m(!0)),
                onBlur: Oe(o.onBlur, () => m(!1)),
                onClick: Oe(o.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: Oe(o.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: Oe(o.onPointerDown, (x) => {
                  v.current = x.pointerType;
                }),
                onPointerMove: Oe(o.onPointerMove, (x) => {
                  v.current = x.pointerType, i ? c.onItemLeave?.() : v.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Oe(o.onPointerLeave, (x) => {
                  x.currentTarget === document.activeElement && c.onItemLeave?.();
                }),
                onKeyDown: Oe(o.onKeyDown, (x) => {
                  c.searchRef?.current !== "" && x.key === " " || (o7.includes(x.key) && y(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
rI.displayName = Eu;
var Zo = "SelectItemText", iI = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...a } = e, o = hi(Zo, n), s = mi(Zo, n), c = nI(Zo, n), l = u7(Zo, n), [d, f] = A.useState(null), h = ke(
      t,
      (y) => f(y),
      c.onItemTextChange,
      (y) => s.itemTextRefCallback?.(y, c.value, c.disabled)
    ), m = d?.textContent, g = A.useMemo(
      () => /* @__PURE__ */ u.jsx("option", { value: c.value, disabled: c.disabled, children: m }, c.value),
      [c.disabled, c.value, m]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: v } = l;
    return Vt(() => (p(g), () => v(g)), [p, v, g]), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Ae.span, { id: c.textId, ...a, ref: h }),
      c.isSelected && o.valueNode && !o.valueNodeHasChildren ? Ru.createPortal(a.children, o.valueNode) : null
    ] });
  }
);
iI.displayName = Zo;
var aI = "SelectItemIndicator", oI = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return nI(aI, n).isSelected ? /* @__PURE__ */ u.jsx(Ae.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
oI.displayName = aI;
var gy = "SelectScrollUpButton", sI = A.forwardRef((e, t) => {
  const n = mi(gy, e.__scopeSelect), r = xx(gy, e.__scopeSelect), [i, a] = A.useState(!1), o = ke(t, r.onScrollButtonChange);
  return Vt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = c.scrollTop > 0;
        a(l);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ u.jsx(
    lI,
    {
      ...e,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
sI.displayName = gy;
var yy = "SelectScrollDownButton", cI = A.forwardRef((e, t) => {
  const n = mi(yy, e.__scopeSelect), r = xx(yy, e.__scopeSelect), [i, a] = A.useState(!1), o = ke(t, r.onScrollButtonChange);
  return Vt(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = c.scrollHeight - c.clientHeight, d = Math.ceil(c.scrollTop) < l;
        a(d);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ u.jsx(
    lI,
    {
      ...e,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
cI.displayName = yy;
var lI = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, a = mi("SelectScrollButton", n), o = A.useRef(null), s = jd(n), c = A.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return A.useEffect(() => () => c(), [c]), Vt(() => {
    s().find((d) => d.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ u.jsx(
    Ae.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: Oe(i.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerMove: Oe(i.onPointerMove, () => {
        a.onItemLeave?.(), o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Oe(i.onPointerLeave, () => {
        c();
      })
    }
  );
}), _7 = "SelectSeparator", S7 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ u.jsx(Ae.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
S7.displayName = _7;
var by = "SelectArrow", O7 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Td(n), a = hi(by, n), o = mi(by, n);
    return a.open && o.position === "popper" ? /* @__PURE__ */ u.jsx(yx, { ...i, ...r, ref: t }) : null;
  }
);
O7.displayName = by;
var E7 = "SelectBubbleInput", uI = A.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const i = A.useRef(null), a = ke(r, i), o = bx(t);
    return A.useEffect(() => {
      const s = i.current;
      if (!s) return;
      const c = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (o !== t && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(s, t), s.dispatchEvent(f);
      }
    }, [o, t]), /* @__PURE__ */ u.jsx(
      Ae.select,
      {
        ...n,
        style: { ...BM, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
uI.displayName = E7;
function dI(e) {
  return e === "" || e === void 0;
}
function fI(e) {
  const t = ii(e), n = A.useRef(""), r = A.useRef(0), i = A.useCallback(
    (o) => {
      const s = n.current + o;
      t(s), (function c(l) {
        n.current = l, window.clearTimeout(r.current), l !== "" && (r.current = window.setTimeout(() => c(""), 1e3));
      })(s);
    },
    [t]
  ), a = A.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, a];
}
function hI(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let o = A7(e, Math.max(a, 0));
  i.length === 1 && (o = o.filter((l) => l !== n));
  const c = o.find(
    (l) => l.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function A7(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var P7 = zM, mI = VM, C7 = UM, j7 = HM, T7 = YM, vI = KM, N7 = QM, M7 = tI, pI = rI, I7 = iI, D7 = oI, gI = sI, yI = cI;
const co = P7, lo = C7, Zi = ({
  className: e,
  children: t,
  ref: n,
  ...r
}) => /* @__PURE__ */ u.jsxs(
  mI,
  {
    className: Ce(
      "flex h-9 w-full items-center justify-between rounded-md border border-zinc-200 bg-white px-3 py-2 text-sm text-zinc-900 shadow-sm focus:border-zinc-900 focus:outline-none focus:ring-2 focus:ring-zinc-900 disabled:cursor-not-allowed disabled:opacity-50 data-[placeholder]:text-zinc-900",
      e
    ),
    ref: n,
    ...r,
    children: [
      t,
      /* @__PURE__ */ u.jsx(j7, { asChild: !0, children: /* @__PURE__ */ u.jsx(zi, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
);
Zi.displayName = mI.displayName;
const bI = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  gI,
  {
    className: Ce(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ref: t,
    ...n,
    children: /* @__PURE__ */ u.jsx(BL, { className: "h-4 w-4" })
  }
);
bI.displayName = gI.displayName;
const xI = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  yI,
  {
    className: Ce(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ref: t,
    ...n,
    children: /* @__PURE__ */ u.jsx(zi, { className: "h-4 w-4" })
  }
);
xI.displayName = yI.displayName;
const Xi = ({
  className: e,
  children: t,
  position: n = "popper",
  ref: r,
  ...i
}) => /* @__PURE__ */ u.jsx(T7, { children: /* @__PURE__ */ u.jsxs(
  vI,
  {
    className: Ce(
      "fade-in-80 relative z-[90] max-h-96 min-w-[8rem] animate-in overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md",
      n === "popper" && "translate-y-1",
      e
    ),
    position: n,
    ref: r,
    ...i,
    children: [
      /* @__PURE__ */ u.jsx(bI, {}),
      /* @__PURE__ */ u.jsx(
        N7,
        {
          className: Ce(
            "p-1",
            n === "popper" && "w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ u.jsx(xI, {})
    ]
  }
) });
Xi.displayName = vI.displayName;
M7.displayName;
const Qi = ({
  className: e,
  children: t,
  ref: n,
  ...r
}) => /* @__PURE__ */ u.jsxs(
  pI,
  {
    className: Ce(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pr-2 pl-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ref: n,
    ...r,
    children: [
      /* @__PURE__ */ u.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ u.jsx(D7, { children: /* @__PURE__ */ u.jsx(_C, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ u.jsx(I7, { children: t })
    ]
  }
);
Qi.displayName = pI.displayName;
const k7 = yt("", {
  variants: {
    color: {
      white: "bg-white",
      black: "bg-black",
      alabastergrey: "bg-alabastergrey",
      blazeorange: "bg-blazeorange",
      neonchartreuse: "bg-neonchartreuse"
    },
    variant: {
      h1: "my-8",
      h2: "my-8",
      h3: "my-8",
      h4: "my-6",
      h5: "my-6",
      h6: "my-4"
    }
  },
  defaultVariants: {
    color: "black",
    variant: "h1"
  }
});
function R7(e) {
  const t = k7({
    color: e.color,
    variant: e.variant
  });
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: J("h-0.5 w-[30px]", t, "component-dash"),
      "data-testid": "dash"
    }
  );
}
const un = {
  h1: "text-[40px] leading-[45px] md:text-[80px] md:leading-[90px]",
  h2: "text-[34px] leading-[36px] tracking-[1%] md:text-[56px] md:leading-[60px]",
  h3: "text-[28px] leading-[32px] md:text-[30px] md:leading-[34px]",
  h4: "text-[18px] leading-[24px] tracking-[1%] md:text-[20px] md:leading-[26px]",
  h5: "text-[14px] leading-[18px] md:text-[16px] md:leading-[20px]",
  h6: "text-[12px] leading-[14px] tracking-[2%]",
  "p-xlarge": "text-[26px] leading-[32px] md:text-[38px] md:leading-[48px]",
  "p-large": "text-[16px] leading-[24px] md:text-[21px] md:leading-[30px]",
  p: "text-[14px] leading-[20px] md:text-[16px] md:leading-[23px]",
  "p-small": "text-[12px] leading-[16px] md:leading-[17px]",
  "p-xsmall": "text-[10px] leading-[13px]",
  pillar: "text-[9px] leading-[11px] tracking-[4%]"
}, L7 = yt("", {
  variants: {
    variant: {
      h1: `wrap-break-word mb-8 block hyphens-auto break-normal font-bold font-brand last:mb-0 only:mb-0 ${un.h1}`,
      h2: `wrap-break-word mb-8 block hyphens-auto break-normal font-bold font-brand only:mb-0 ${un.h2}`,
      h3: `mb-8 block font-bold font-brand last:mb-0 only:mb-0 ${un.h3}`,
      h4: `mb-6 block font-bold font-brand last:mb-0 only:mb-0 ${un.h4}`,
      h5: `mb-6 block font-bold font-brand last:mb-0 only:mb-0 ${un.h5}`,
      h6: `mb-4 block font-bold font-brand last:mb-0 only:mb-0 ${un.h6}`,
      "p-xlarge": `mb-[1em] font-brand font-normal last:mb-0 only:mb-0 ${un["p-xlarge"]}`,
      "p-large": `mb-[1em] font-brand font-normal last:mb-0 only:mb-0 ${un["p-large"]}`,
      p: `mb-[1em] font-brand font-normal last:mb-0 only:mb-0 ${un.p}`,
      "p-small": `mb-[1em] font-brand font-normal last:mb-0 only:mb-0 ${un["p-small"]}`,
      "p-xsmall": `mb-[1em] font-brand font-normal last:mb-0 only:mb-0 ${un["p-xsmall"]}`,
      pillar: `mb-[1em] font-brand font-normal font-semibold uppercase last:mb-0 only:mb-0 ${un.pillar}`
    },
    color: {
      black: "text-black",
      white: "text-white",
      alabastergrey: "text-alabastergrey",
      blazeorange: "text-blazeorange",
      neonchartreuse: "text-neonchartreuse"
    },
    style: {
      "line-through": "line-through",
      uppercase: "uppercase",
      "hero-section": "tracking-[20%] md:text-[90px] md:leading-[100px] md:tracking-[30%] xl:text-[100px] xl:leading-[110px]",
      regular: "font-normal",
      bold: "font-bold",
      "no-mb": "!mb-0"
    },
    dash: {
      true: "",
      false: ""
    }
  },
  defaultVariants: {
    variant: "p",
    color: "black"
  }
});
function os({
  children: e,
  variant: t = "p",
  color: n = "black",
  style: r,
  dash: i = !1,
  ...a
}) {
  const o = $7(t), s = L7({
    variant: t,
    color: n,
    style: r,
    dash: i
  });
  return /* @__PURE__ */ u.jsxs(
    o,
    {
      className: J(s, "component-text-d2c"),
      "data-testid": "text-d2c",
      ...o === "h1" ? { tabIndex: -1, ...a } : a,
      children: [
        e,
        B7(t) && i && /* @__PURE__ */ u.jsx(
          R7,
          {
            color: n,
            variant: t
          }
        )
      ]
    }
  );
}
function $7(e) {
  switch (e) {
    case "h1":
      return "h1";
    case "h2":
      return "h2";
    case "h3":
      return "h3";
    case "h4":
      return "h4";
    case "h5":
      return "h5";
    case "h6":
      return "h6";
    case "p-xlarge":
    case "p-large":
    case "p":
    case "p-small":
    case "p-xsmall":
    case "pillar":
      return "p";
    default:
      return "p";
  }
}
function B7(e) {
  return e === "h1" || e === "h2" || e === "h3" || e === "h4" || e === "h5" || e === "h6";
}
function Kle(e) {
  const [t, n] = Ee(!1), [r, i] = Ee(!1), [a, o] = Ee(!1);
  return St(() => {
    if (!e)
      return;
    const s = e.container ?? e.elements?.container;
    if (!s)
      return;
    const c = () => {
      n(!0), i(!1);
    }, l = () => {
      n(!1);
    }, d = () => {
      n(!1), i(!0);
    }, f = () => {
      o(!0);
    }, h = () => {
      o(!1);
    };
    return s.addEventListener("play", c), s.addEventListener("pause", l), s.addEventListener("ended", d), s.addEventListener("enterfullscreen", f), s.addEventListener("exitfullscreen", h), () => {
      s.removeEventListener("play", c), s.removeEventListener("pause", l), s.removeEventListener("ended", d), s.removeEventListener("enterfullscreen", f), s.removeEventListener("exitfullscreen", h);
    };
  }, [e]), {
    isPlaying: t,
    isEnded: r,
    isFullscreen: a
  };
}
function Gle() {
  const e = Le(null), [t, n] = Ee(null), r = ot((i) => {
    n(i);
  }, []);
  return {
    ref: e,
    onReady: r,
    player: t
  };
}
/*!
 * @license MIT
 * @name vlitejs
 * @version 8.1.1
 * @copyright 2026 Yoriiis
 */
const Au = {}, wI = {};
function F7({ plugins: e, provider: t, type: n, player: r }) {
  (function(i) {
    const a = [], o = Object.keys(Au);
    return i.forEach(((s) => {
      if (!o.includes(s)) throw new Error(`vlitejs :: Unknown plugin "${s}".`);
      a.push({ id: s, Plugin: Au[s], options: wI[s] });
    })), a;
  })(e).forEach((({ id: i, Plugin: a, options: o }) => {
    const s = new a({ player: r, options: o });
    if (r.plugins[i] = s, !s.providers.includes(t) || !s.types.includes(n)) throw new Error(`vlitejs :: The "${i}" plugin is only compatible with providers:"${s.providers}" and types:"${s.types}"`);
    s.init();
  }));
}
const xy = { html5: function(e) {
  return class extends e {
    constructor(t) {
      super(t), this.events = [{ type: "timeupdate", listener: super.onTimeUpdate.bind(this) }, { type: "ended", listener: super.onMediaEnded.bind(this) }, { type: "playing", listener: this.onPlaying.bind(this) }, { type: "waiting", listener: this.onWaiting.bind(this) }, { type: "seeking", listener: this.onSeeking.bind(this) }, { type: "seeked", listener: this.onSeeked.bind(this) }];
    }
    init() {
      this.waitUntilVideoIsReady().then((() => {
        this.addSpecificEvents(), super.onReady();
      }));
    }
    waitUntilVideoIsReady() {
      return new window.Promise(((t) => {
        this.media.readyState >= 2 && this.media.duration || this.media.readyState === 0 && this.media.preload === "none" ? t() : (this.media.addEventListener("loadedmetadata", t, { once: !0 }), this.media.addEventListener("canplay", t, { once: !0 }));
      }));
    }
    addSpecificEvents() {
      this.events.forEach(((t) => {
        this.media.addEventListener(t.type, t.listener.bind(this));
      }));
    }
    getInstance() {
      return this.media;
    }
    getCurrentTime() {
      return new window.Promise(((t) => t(this.media.currentTime)));
    }
    getDuration() {
      return new window.Promise(((t) => t(this.media.duration)));
    }
    methodPlay() {
      this.media.play();
    }
    methodPause() {
      this.media.pause();
    }
    methodSetVolume(t) {
      this.media.volume = t;
    }
    methodGetVolume() {
      return new window.Promise(((t) => t(this.media.volume)));
    }
    methodMute() {
      this.media.muted = !0, this.media.setAttribute("muted", "");
    }
    methodUnMute() {
      this.media.muted = !1, this.media.removeAttribute("muted");
    }
    methodSetSource(t) {
      this.media.src = t, this.media.load(), this.removeSpecificEvents(), this.init();
    }
    methodSeekTo(t) {
      this.media.currentTime = t;
    }
    onWaiting() {
      this.loading(!0);
    }
    onPlaying() {
      this.loading(!1);
    }
    onSeeking() {
      this.loading(!0);
    }
    onSeeked() {
      this.loading(!1);
    }
    removeSpecificEvents() {
      this.events.forEach(((t) => {
        this.media.removeEventListener(t.type, t.listener);
      }));
    }
    destroy() {
      this.removeSpecificEvents(), super.destroy();
    }
  };
} }, _I = {};
function SI(e) {
  const t = 1e3 * e, n = t / 1e3 / 60 | 0, r = t / 1e3 % 60 | 0;
  let i = "";
  return i += n < 10 ? "0" : "", i += `${n}:`, i += r < 10 ? "0" : "", i += r, i;
}
function z7() {
  const e = (function() {
    return document.exitFullscreen instanceof Function ? "" : ["webkit", "moz", "ms"].find(((t) => document[`${t}ExitFullscreen`] instanceof Function || document[`${t}CancelFullScreen`] instanceof Function)) || "";
  })();
  return { requestFn: e ? `${e}RequestFullScreen` : "requestFullscreen", cancelFn: e ? `${e}ExitFullscreen` : "exitFullscreen", changeEvent: e ? `${e}fullscreenchange` : "fullscreenchange", isFullScreen: e ? `${e}FullscreenElement` : "fullscreenElement" };
}
function wy() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function Na({ target: e, selectorString: t, nodeName: n }) {
  return (n = [].concat(n)).some(((r) => e.nodeName.toLowerCase() === r && e.matches(t)));
}
var q7 = '<svg class="v-iconUnpressed" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M1 9c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H2v-2c0-.55-.45-1-1-1Zm0-4c.55 0 1-.45 1-1V2h2c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1v3c0 .55.45 1 1 1Zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2ZM9 1c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1Z"/></svg>', V7 = '<svg class="v-iconPressed" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M1 11h2v2c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1Zm2-8H1c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1S3 .45 3 1v2Zm7 11c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1Zm1-11V1c0-.55-.45-1-1-1S9 .45 9 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2Z"/></svg>', W7 = '<svg class="v-iconPressed" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg"><path d="M2 14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2S0 .9 0 2v10c0 1.1.9 2 2 2ZM8 2v10c0 1.1.9 2 2 2s2-.9 2-2V2c0-1.1-.9-2-2-2S8 .9 8 2Z"/></svg>', U7 = '<svg class="v-iconUnpressed" viewBox="0 0 11 13" xmlns="http://www.w3.org/2000/svg"><path d="M0 1v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L1.54.16A.998.998 0 0 0 0 1Z"/></svg>', H7 = '<svg class="v-iconUnpressed" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.461v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V2.871c0-.89-1.08-1.34-1.71-.71L4 5.461H1c-.55 0-1 .45-1 1Zm13.5 2a4.5 4.5 0 0 0-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02ZM11 .911v.2c0 .38.25.71.6.85a7.004 7.004 0 0 1 4.4 6.5c0 2.94-1.82 5.47-4.4 6.5-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85a8.98 8.98 0 0 0 5.79-8.4c0-3.84-2.4-7.11-5.79-8.4-.58-.23-1.21.22-1.21.85Z"/></svg>', Y7 = '<svg class="v-iconPressed" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M.63.292a.996.996 0 0 0 0 1.41l3.66 3.66-.29.3H1c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.997.997 0 1 0 1.41-1.41L2.05.293c-.39-.39-1.02-.39-1.42 0ZM16 8.662c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85 2.57 1.04 4.39 3.56 4.39 6.5Zm-8.71-6.29-.17.17L9 4.422v-1.35c0-.89-1.08-1.33-1.71-.7Zm6.21 6.29a4.5 4.5 0 0 0-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24Z"/></svg>';
function K7({ options: e, isMuted: t, isVideo: n }) {
  return n ? `<div class="v-controlBar">${e.playPause ? EA() : ""}${e.time ? AA() : ""}${e.progressBar ? PA() : ""}${e.volume ? CA({ isMuted: t }) : ""}${e.fullscreen ? `<button class="v-fullscreenButton v-controlButton" aria-label="Enter fullscreen">${q7}${V7}</span></button>` : ""}</div>` : `<div class="v-controlBar">${e.playPause ? EA() : ""}${e.time ? AA() : ""}${e.progressBar ? PA() : ""}${e.volume ? CA({ isMuted: t }) : ""}</div>`;
}
function EA() {
  return `<button class="v-playPauseButton v-controlButton" aria-label="Play">${U7}${W7}</button>`;
}
function AA() {
  return '<div class="v-time"><span class="v-currentTime">00:00</span>&nbsp;/&nbsp;<span class="v-duration"></span></div>';
}
function PA() {
  return '<input type="range" class="v-progressBar v-progressBarStyle" min="0" max="100" step="0.01" value="0" aria-label="Seek" aria-valuemin="0" />';
}
function CA({ isMuted: e }) {
  return `<button class="v-volumeButton v-controlButton${e ? " v-controlPressed" : ""}">${H7}${Y7}</button>`;
}
class G7 {
  constructor({ player: t, type: n }) {
    this.player = t, this.type = n, this.touchEvents = ["touchstart", "touchmove", "touchend"], this.onInputProgressBar = this.onInputProgressBar.bind(this), this.onTouchEventProgressBar = this.onTouchEventProgressBar.bind(this), this.onClickOnControlBar = this.onClickOnControlBar.bind(this), this.togglePlayPause = this.togglePlayPause.bind(this), this.toggleVolume = this.toggleVolume.bind(this), this.toggleFullscreen = this.toggleFullscreen.bind(this);
  }
  init() {
    this.render(), this.cacheElements(), this.addEvents();
  }
  cacheElements() {
    const t = this.player.elements.container.querySelector(".v-controlBar");
    t && (this.player.elements.controlBar = t, this.player.elements.playPause = t.querySelector(".v-playPauseButton"), this.player.elements.progressBar = t.querySelector(".v-progressBar"), this.player.elements.currentTime = t.querySelector(".v-currentTime"), this.player.elements.duration = t.querySelector(".v-duration"), this.player.elements.volume = t.querySelector(".v-volumeButton"), this.player.elements.fullscreen = t.querySelector(".v-fullscreenButton"), this.player.elements.volume && this.player.elements.volume.setAttribute("aria-label", this.player.isMuted ? "Unmute" : "Mute"));
  }
  render() {
    this.player.elements.container.insertAdjacentHTML("beforeend", this.getTemplate());
  }
  onReady() {
    this.player.getDuration().then(((t) => {
      this.player.elements.progressBar && this.player.elements.progressBar.setAttribute("aria-valuemax", `${Math.round(t)}`), this.player.elements.duration && (this.player.elements.duration.innerHTML = SI(t));
    }));
  }
  addEvents() {
    var t;
    this.player.elements.progressBar && (this.player.elements.progressBar.addEventListener("input", this.onInputProgressBar), this.player.isTouch && this.touchEvents.forEach(((n) => {
      this.player.elements.progressBar.addEventListener(n, this.onTouchEventProgressBar);
    }))), (t = this.player.elements.controlBar) === null || t === void 0 || t.addEventListener("click", this.onClickOnControlBar);
  }
  onTouchEventProgressBar(t) {
    t.preventDefault();
    const n = t.target, r = Number.parseFloat(n.getAttribute("max") || "100"), i = n.getBoundingClientRect(), a = (t.changedTouches[0].clientX - i.left) / i.width * 100;
    n.value = "" + 100 * a / r, n.dispatchEvent(new Event("input"));
  }
  onInputProgressBar(t) {
    const n = t.target;
    n.style.setProperty("--vlite-progressValue", `${n.value}%`), this.player.elements.outerContainer.classList.contains("v-firstStart") && this.player.play(), this.player.getDuration().then(((r) => {
      this.player.seekTo(Number.parseFloat(n.value) * r / 100);
    }));
  }
  onClickOnControlBar(t) {
    const n = t.target, r = Na({ target: n, selectorString: ".v-playPauseButton", nodeName: ["button"] }), i = Na({ target: n, selectorString: ".v-volumeButton", nodeName: ["button"] }), a = Na({ target: n, selectorString: ".v-fullscreenButton", nodeName: ["button"] });
    r ? this.togglePlayPause(t) : i ? this.toggleVolume(t) : a && this.toggleFullscreen(t), (r || i || a) && this.player.elements.container.focus(), this.player.Vlitejs.startAutoHideTimer();
  }
  togglePlayPause(t) {
    t.preventDefault(), this.player.elements.outerContainer.classList.contains("v-paused") ? this.player.play() : this.player.pause();
  }
  toggleVolume(t) {
    t.preventDefault(), this.player.elements.volume.classList.contains("v-controlPressed") ? this.player.unMute() : this.player.mute();
  }
  toggleFullscreen(t) {
    if (t.preventDefault(), this.player.isFullScreen) this.isOrientationApiAvailable() && window.screen.orientation.unlock(), this.player.exitFullscreen();
    else {
      this.player.requestFullscreen();
      try {
        window.matchMedia("(orientation:portrait)").matches && this.isOrientationApiAvailable() && window.screen.orientation.lock("landscape").catch((() => {
        }));
      } catch {
      }
    }
  }
  isOrientationApiAvailable() {
    return window.screen.orientation !== void 0 && typeof window.screen.orientation.lock == "function" && typeof window.screen.orientation.unlock == "function";
  }
  getTemplate() {
    return `${K7({ options: this.player.options, isMuted: this.player.isMuted, isVideo: this.type === "video" })}`;
  }
  removeEvents() {
    var t;
    this.player.elements.progressBar && (this.player.elements.progressBar.removeEventListener("input", this.onInputProgressBar), this.player.isTouch && this.touchEvents.forEach(((n) => {
      this.player.elements.progressBar.removeEventListener(n, this.onTouchEventProgressBar);
    }))), (t = this.player.elements.controlBar) === null || t === void 0 || t.removeEventListener("click", this.onClickOnControlBar);
  }
  destroy() {
    var t;
    this.removeEvents(), (t = this.player.elements.controlBar) === null || t === void 0 || t.remove();
  }
}
class Z7 {
  constructor({ Vlitejs: t, type: n }) {
    this.Vlitejs = t, this.type = n, this.plugins = {}, this.media = t.media, this.options = t.options, this.isCast = !1, this.isLinearAd = !1, this.elements = { container: t.container, outerContainer: t.outerContainer, bigPlay: t.container.querySelector(".v-bigPlay"), poster: t.container.querySelector(".v-poster"), controlBar: null, playPause: null, progressBar: null, currentTime: null, duration: null, volume: null, fullscreen: null }, this.isFullScreen = !1, this.isMuted = this.options.muted, this.isPaused = null, this.playerEvents = [], this.isTouch = wy(), this.controlBar = new G7({ player: this, type: n });
  }
  build() {
    this.options.controls && this.controlBar.init(), this.init();
  }
  onReady() {
    this.options.muted && this.mute(), this.media.classList.add("v-media"), this.media.setAttribute("tabindex", "-1"), this.options.autoplay && (!this.media.muted && this.mute(), this.play()), this.Vlitejs.onReady instanceof Function && this.Vlitejs.onReady.call(this, this), this.media.preload === "none" && this.Vlitejs.provider === "html5" ? this.media.addEventListener("loadedmetadata", (() => this.triggerOnReady())) : this.triggerOnReady(), this.loading(!1);
  }
  triggerOnReady() {
    this.options.controls && this.controlBar.onReady(), Object.keys(this.plugins).forEach(((t) => {
      this.plugins[t].onReady instanceof Function && this.plugins[t].onReady();
    }));
  }
  on(t, n) {
    n instanceof Function && (this.playerEvents.push({ type: t, listener: n }), this.elements.container.addEventListener(t, n));
  }
  off(t, n) {
    n instanceof Function && this.elements.container.removeEventListener(t, n);
  }
  dispatchEvent(t, n) {
    this.elements.container.dispatchEvent(new window.CustomEvent(t, { detail: n }));
  }
  loading(t) {
    this.elements.outerContainer.classList[t ? "add" : "remove"]("v-loading"), this.dispatchEvent("progress");
  }
  onTimeUpdate() {
    this.options.time && Promise.all([this.getCurrentTime(), this.getDuration()]).then((([t, n]) => this.updateProgressBar({ seconds: t, duration: n })));
  }
  updateProgressBar({ seconds: t, duration: n, isRemote: r = !1 }) {
    const i = Math.round(t);
    if (this.elements.progressBar) {
      const a = 100 * i / n;
      this.elements.progressBar.value = `${a}`, this.elements.progressBar.style.setProperty("--vlite-progressValue", `${a}%`), this.elements.progressBar.setAttribute("aria-valuenow", `${Math.round(t)}`);
    }
    this.elements.currentTime && (this.elements.currentTime.innerHTML = SI(i)), !r && this.dispatchEvent("timeupdate");
  }
  onMediaEnded() {
    this.options.loop ? this.play() : (this.elements.outerContainer.classList.replace("v-playing", "v-paused"), this.elements.outerContainer.classList.add("v-firstStart"), this.isPaused = null), this.elements.poster && this.elements.poster.classList.add("v-active"), this.type === "video" && this.elements.bigPlay && this.elements.bigPlay.setAttribute("aria-label", "Play"), this.elements.playPause && (this.elements.playPause.setAttribute("aria-label", "Play"), this.elements.playPause.classList.remove("v-controlPressed")), this.elements.progressBar && (this.elements.progressBar.value = "0", this.elements.progressBar.style.setProperty("--vlite-progressValue", "0%"), this.elements.progressBar.removeAttribute("aria-valuenow")), this.elements.currentTime && (this.elements.currentTime.innerHTML = "00:00"), this.dispatchEvent("ended");
  }
  play() {
    this.isLinearAd || (this.isPaused === null && (this.elements.outerContainer.classList.remove("v-firstStart"), this.type === "video" && this.elements.poster && this.elements.poster.classList.remove("v-active")), !this.isCast && this.methodPlay(), this.isPaused = !1, this.elements.outerContainer.classList.replace("v-paused", "v-playing"), this.elements.playPause && (this.elements.playPause.setAttribute("aria-label", "Pause"), this.elements.playPause.classList.add("v-controlPressed")), this.type === "video" && this.elements.bigPlay && this.elements.bigPlay.setAttribute("aria-label", "Pause"), this.afterPlayPause(), this.dispatchEvent("play"));
  }
  pause() {
    !this.isCast && this.methodPause(), this.isPaused = !0, this.elements.outerContainer.classList.replace("v-playing", "v-paused"), this.elements.playPause && (this.elements.playPause.setAttribute("aria-label", "Play"), this.elements.playPause.classList.remove("v-controlPressed")), this.type === "video" && this.elements.bigPlay && this.elements.bigPlay.setAttribute("aria-label", "Play"), this.afterPlayPause(), this.dispatchEvent("pause");
  }
  afterPlayPause() {
    this.Vlitejs.autoHideGranted && (this.Vlitejs.stopAutoHideTimer(), !this.isPaused && this.Vlitejs.startAutoHideTimer());
  }
  setVolume(t) {
    let n = t;
    n > 1 ? n = 1 : n <= 0 ? (n = 0, this.isMuted = !0, this.elements.volume && this.elements.volume.classList.add("v-controlPressed")) : (this.isMuted = !1, this.elements.volume && this.elements.volume.classList.remove("v-controlPressed")), this.methodSetVolume(n), this.dispatchEvent("volumechange", { volume: n });
  }
  getVolume() {
    return new window.Promise(((t) => {
      this.methodGetVolume().then(((n) => {
        t(n);
      }));
    }));
  }
  mute() {
    this.methodMute(), this.isMuted = !0, this.elements.volume && (this.elements.volume.classList.add("v-controlPressed"), this.elements.volume.setAttribute("aria-label", "Unmute")), this.dispatchEvent("volumechange");
  }
  unMute() {
    this.methodUnMute(), this.isMuted = !1, this.elements.volume && (this.elements.volume.classList.remove("v-controlPressed"), this.elements.volume.setAttribute("aria-label", "Mute")), this.dispatchEvent("volumechange");
  }
  setSource(t) {
    this.options.loop = !1, this.pause(), this.onMediaEnded(), this.methodSetSource(t), this.controlBar.onReady(), this.play(), this.dispatchEvent("sourcechange");
  }
  seekTo(t) {
    this.methodSeekTo(t);
  }
  requestFullscreen() {
    const { requestFn: t } = this.Vlitejs.supportFullScreen;
    this.media[t] && (this.elements.container[t](), this.isFullScreen = !0, this.elements.outerContainer.classList.add("v-fullscreen"), this.elements.fullscreen && (this.elements.fullscreen.classList.add("v-controlPressed"), this.elements.fullscreen.setAttribute("aria-label", "Exit fullscreen")), this.dispatchEvent("enterfullscreen"));
  }
  exitFullscreen({ escKey: t = !1 } = {}) {
    const { cancelFn: n } = this.Vlitejs.supportFullScreen;
    document[n] && (!t && document[n](), this.isFullScreen = !1, this.elements.outerContainer.classList.remove("v-fullscreen"), this.elements.fullscreen && (this.elements.fullscreen.classList.remove("v-controlPressed"), this.elements.fullscreen.setAttribute("aria-label", "Enter fullscreen")), this.dispatchEvent("exitfullscreen"));
  }
  destroy() {
    var t;
    Object.keys(this.plugins).forEach(((n) => {
      this.plugins[n].destroy instanceof Function && this.plugins[n].destroy();
    })), (t = this.controlBar) === null || t === void 0 || t.destroy(), this.playerEvents.forEach(((n) => {
      this.elements.container.removeEventListener(n.type, n.listener);
    })), this.elements.container.remove();
  }
}
const X7 = { audio: { controls: !0, autoplay: !1, playPause: !0, progressBar: !0, time: !0, volume: !0, loop: !1 }, video: { controls: !0, autoplay: !1, playPause: !0, progressBar: !0, time: !0, volume: !0, fullscreen: !0, poster: null, bigPlay: !0, playsinline: !0, loop: !1, muted: !1, autoHide: !1, autoHideDelay: 3e3, providerParams: {} } };
class Ys {
  constructor(t, { options: n = {}, provider: r = "html5", plugins: i = [], onReady: a = () => {
  } } = {}) {
    if (typeof t == "string") this.media = document.querySelector(t);
    else {
      if (!(t instanceof HTMLVideoElement || t instanceof HTMLAudioElement || t instanceof HTMLDivElement)) throw new TypeError("vlitejs :: The element or selector supplied is not valid.");
      this.media = t;
    }
    this.provider = r, this.onReady = a, this.type = this.media instanceof HTMLAudioElement ? "audio" : "video", this.supportFullScreen = z7(), ["autoplay", "playsinline", "muted", "loop"].forEach(((s) => {
      this.media.hasAttribute(s) ? n[s] = !0 : n[s] && this.media.setAttribute(s, "");
    })), this.options = Object.assign(Object.assign({}, X7[this.type]), n), this.autoHideGranted = this.type === "video" && !!this.options.autoHide && !!this.options.controls, /(iPhone)/gi.test(window.navigator.userAgent) && (this.options.fullscreen = !1), this.onClickOnPlayer = this.onClickOnPlayer.bind(this), this.onDoubleClickOnPlayer = this.onDoubleClickOnPlayer.bind(this), this.onMousemove = this.onMousemove.bind(this), this.onChangeFullScreen = this.onChangeFullScreen.bind(this);
    const o = (function(s, c) {
      const l = xy[s];
      if (l) return l(c, _I[s]);
      throw new Error(`vlitejs :: Unknown provider "${s}"`);
    })(r, Z7);
    this.wrapElement(), this.container = this.media.closest(".v-container"), this.outerContainer = this.container.closest(".v-vlite"), this.type === "video" && this.renderLayout(), this.player = new o({ type: this.type, Vlitejs: this }), this.player.build(), this.addEvents(), F7({ plugins: i, provider: r, type: this.type, player: this.player });
  }
  wrapElement() {
    const t = document.createElement("div");
    t.classList.add("v-vlite", "v-firstStart", "v-paused", "v-loading", `v-${this.type}`);
    const n = document.createElement("div");
    n.setAttribute("tabindex", "0"), n.classList.add("v-container"), t.appendChild(n), this.media.parentNode.insertBefore(t, this.media), n.appendChild(this.media);
  }
  renderLayout() {
    const t = `
			<div class="v-overlay"></div>
			
		<div class="v-loader">
			<div class="v-loaderContent">
				<div class="v-loaderBounce1"></div>
				<div class="v-loaderBounce2"></div>
				<div class="v-loaderBounce3"></div>
			</div>
		</div>
	
			${this.options.poster ? (function({ posterUrl: n = "" }) {
      return `<div class="v-poster v-active"${n && ` style="background-image: url(${n})"`}></div>`;
    })({ posterUrl: this.options.poster }) : ""}
			${this.options.bigPlay ? '<button class="v-bigPlay" aria-label="Play"><svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0ZM7.5 12.67V7.33c0-.79.88-1.27 1.54-.84l4.15 2.67a1 1 0 0 1 0 1.68l-4.15 2.67c-.66.43-1.54-.05-1.54-.84Z"/></svg></button>' : ""}
		`;
    this.container.insertAdjacentHTML("beforeend", t);
  }
  addEvents() {
    this.type === "video" && (this.container.addEventListener("click", this.onClickOnPlayer), this.container.addEventListener("dblclick", this.onDoubleClickOnPlayer), this.autoHideGranted && !this.player.isTouch && this.container.addEventListener("mousemove", this.onMousemove), document.addEventListener(this.supportFullScreen.changeEvent, this.onChangeFullScreen));
  }
  onClickOnPlayer(t) {
    var n;
    const r = t.target, i = Na({ target: r, selectorString: ".v-poster, .v-bigPlay", nodeName: ["div", "button"] }), a = Na({ target: r, selectorString: ".v-overlay", nodeName: ["div"] });
    if (a && wy() && this.autoHideGranted && (!((n = this.player.elements.controlBar) === null || n === void 0) && n.classList.contains("v-hidden"))) return this.stopAutoHideTimer(), void this.startAutoHideTimer();
    (i || a && !wy()) && (this.player.controlBar.togglePlayPause(t), r.matches(".v-bigPlay") && this.container.focus());
  }
  onDoubleClickOnPlayer(t) {
    Na({ target: t.target, selectorString: ".v-overlay", nodeName: ["div"] }) && this.player.controlBar.toggleFullscreen(t);
  }
  onMousemove() {
    !this.player.isPaused && this.autoHideGranted && (this.stopAutoHideTimer(), this.startAutoHideTimer());
  }
  onChangeFullScreen() {
    !document[this.supportFullScreen.isFullScreen] && this.player.isFullScreen && this.player.exitFullscreen({ escKey: !0 });
  }
  stopAutoHideTimer() {
    var t;
    this.type === "video" && this.player.elements.controlBar && ((t = this.player.elements.controlBar) === null || t === void 0 || t.classList.remove("v-hidden"), clearTimeout(this.timerAutoHide));
  }
  startAutoHideTimer() {
    this.type === "video" && !this.player.isPaused && this.player.elements.controlBar && (this.timerAutoHide = window.setTimeout((() => {
      var t;
      (t = this.player.elements.controlBar) === null || t === void 0 || t.classList.add("v-hidden");
    }), this.options.autoHideDelay));
  }
  removeEvents() {
    this.type === "video" && (this.container.removeEventListener("click", this.onClickOnPlayer), this.container.removeEventListener("dblclick", this.onDoubleClickOnPlayer), this.autoHideGranted && !this.player.isTouch && this.container.removeEventListener("mousemove", this.onMousemove), window.removeEventListener(this.supportFullScreen.changeEvent, this.onChangeFullScreen));
  }
  destroy() {
    this.removeEvents(), this.player.destroy(), this.player.controlBar.destroy();
  }
}
Ys.registerProvider = function(e, t, n) {
  if (t !== void 0) {
    if (!Object.keys(xy).includes(e)) return xy[e] = t, void (n && (_I[e] = n));
    throw new Error(`vlitejs :: The provider id "${e}" is already registered.`);
  }
  throw new Error(`vlitejs :: The provider id "${e}" is undefined.`);
}, Ys.registerPlugin = function(e, t, n) {
  if (t !== void 0) {
    if (!Object.keys(Au).includes(e)) return Au[e] = t, void (n && (wI[e] = n));
    throw new Error(`vlitejs :: The plugin id "${e}" is already registered.`);
  }
  throw new Error(`vlitejs :: The plugin id "${e}" is undefined.`);
};
const Q7 = {
  onPlay: "play",
  onPause: "pause",
  onProgress: "progress",
  onTimeUpdate: "timeupdate",
  onVolumeChange: "volumechange",
  onSourceChange: "sourcechange",
  onEnterFullscreen: "enterfullscreen",
  onExitFullscreen: "exitfullscreen",
  onEnded: "ended"
};
function J7(e) {
  return typeof e == "string" ? e : e?.id ?? "html5";
}
function eX(e) {
  e && typeof e != "string" && Ys.registerProvider?.(
    e.id,
    e.entry,
    e.options
  );
}
function tX(e) {
  if (!e)
    return [];
  const t = [];
  for (const n of e) {
    if (typeof n == "string") {
      t.push(n);
      continue;
    }
    Ys.registerPlugin?.(
      n.id,
      n.entry,
      n.options
    ), t.push(n.id);
  }
  return t;
}
function jA(e) {
  if (!e)
    return "";
  try {
    return JSON.stringify(e);
  } catch {
    return "";
  }
}
function TA(e) {
  return e ? e.map((t) => typeof t == "string" ? t : t.id).join(",") : "";
}
function nX(e) {
  return e?.preload ?? (e?.autoplay ? "auto" : "metadata");
}
function rX(e, t) {
  e.preload = nX(t), t?.playsinline !== !1 && (e.playsInline = !0, e.setAttribute("playsinline", ""), e.setAttribute("webkit-playsinline", "")), t?.loop && (e.loop = !0), t?.autoplay && (e.autoplay = !0), (t?.muted || t?.autoplay) && (e.muted = !0, e.defaultMuted = !0, e.setAttribute("muted", "")), t?.poster && (e.poster = t.poster);
}
function iX(e, t) {
  if (e.providerId !== "html5") {
    const r = document.createElement("div"), i = `data-${e.providerId}-id`;
    return e.videoId && r.setAttribute(i, e.videoId), r;
  }
  if (e.type === "audio") {
    const r = document.createElement("audio");
    return e.src && (r.src = e.src), r;
  }
  const n = document.createElement("video");
  return rX(n, t), e.src && (n.src = e.src), n;
}
function aX(e, t) {
  t.className && (e.className = t.className), t.style && Object.assign(e.style, t.style);
}
function oX(e, t) {
  const n = Le(null), r = Le({
    onPlay: e.onPlay,
    onPause: e.onPause,
    onProgress: e.onProgress,
    onTimeUpdate: e.onTimeUpdate,
    onVolumeChange: e.onVolumeChange,
    onSourceChange: e.onSourceChange,
    onEnterFullscreen: e.onEnterFullscreen,
    onExitFullscreen: e.onExitFullscreen,
    onEnded: e.onEnded,
    onReady: e.onReady
  });
  St(() => {
    r.current = {
      onPlay: e.onPlay,
      onPause: e.onPause,
      onProgress: e.onProgress,
      onTimeUpdate: e.onTimeUpdate,
      onVolumeChange: e.onVolumeChange,
      onSourceChange: e.onSourceChange,
      onEnterFullscreen: e.onEnterFullscreen,
      onExitFullscreen: e.onExitFullscreen,
      onEnded: e.onEnded,
      onReady: e.onReady
    };
  });
  const i = J7(e.provider), a = Tr(
    () => ({
      className: e.className,
      providerId: i,
      src: e.src,
      style: e.style,
      type: e.type,
      videoId: e.videoId
    }),
    [
      i,
      e.className,
      e.src,
      e.style,
      e.type,
      e.videoId
    ]
  ), o = Le({
    key: jA(e.options),
    value: e.options
  }), s = jA(e.options);
  o.current.key !== s && (o.current = { key: s, value: e.options });
  const c = o.current.value, l = Le({
    key: TA(e.plugins),
    value: e.plugins
  }), d = TA(e.plugins);
  l.current.key !== d && (l.current = { key: d, value: e.plugins });
  const f = l.current.value;
  return St(() => {
    const h = n.current;
    if (!h)
      return;
    eX(e.provider);
    const m = tX(f), g = iX(a, c);
    aX(g, a), h.appendChild(g);
    const p = new Ys(g, {
      options: c,
      provider: i,
      plugins: m,
      onReady: (x) => {
        r.current.onReady?.(x);
      }
    });
    typeof t == "function" ? t(p) : t && (t.current = p);
    const v = p.container, y = /* @__PURE__ */ new Map();
    for (const [x, w] of Object.entries(Q7)) {
      const _ = (b) => {
        const S = r.current[x];
        typeof S == "function" && S(b);
      };
      y.set(w, _), v.addEventListener(w, _);
    }
    return () => {
      for (const [x, w] of y)
        v.removeEventListener(x, w);
      p.destroy(), h.replaceChildren(), typeof t == "function" ? t(null) : t && (t.current = null);
    };
  }, [
    i,
    t,
    a,
    e.provider,
    c,
    f
  ]), /* @__PURE__ */ u.jsx("div", { ref: n });
}
const sX = ku(oX);
sX.displayName = "VlitePlayer";
function cX(e) {
  return /* @__PURE__ */ u.jsx(ax, { children: /* @__PURE__ */ u.jsxs("div", { className: "flex w-full items-center justify-between px-2", children: [
    e.showDeleteButton ? /* @__PURE__ */ u.jsxs(
      ve,
      {
        className: "flex items-center gap-2 text-red-600 text-sm hover:text-red-800",
        disabled: e.isLoading,
        onClick: e.onDelete,
        variant: "outline",
        children: [
          /* @__PURE__ */ u.jsx(hl, { className: "h-4 w-4" }),
          e.deleteButtonText
        ]
      }
    ) : /* @__PURE__ */ u.jsx("div", {}),
    /* @__PURE__ */ u.jsxs("div", { className: "flex gap-3", children: [
      e.secondaryButtonText ? /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: e.isLoading,
          onClick: e.onSecondaryAction || e.onClose,
          variant: e.secondaryButtonVariant || "outline",
          children: e.secondaryButtonText
        }
      ) : null,
      e.tertiaryButtonText ? /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: e.isLoading || e.isTertiaryButtonDisabled,
          onClick: e.onTertiaryAction,
          variant: e.tertiaryButtonVariant || "default",
          children: e.tertiaryButtonText
        }
      ) : null,
      e.primaryButtonText ? /* @__PURE__ */ u.jsxs(
        ve,
        {
          className: "relative",
          disabled: e.isPrimaryButtonDisabled || e.isLoading,
          form: e.formId,
          onClick: e.onPrimaryAction,
          type: e.formId ? "submit" : "button",
          variant: e.primaryButtonVariant || "default",
          children: [
            /* @__PURE__ */ u.jsx("span", { className: e.isLoading ? "invisible" : "", children: /* @__PURE__ */ u.jsx(B, { children: e.primaryButtonText }) }),
            e.isLoading ? /* @__PURE__ */ u.jsx("span", { className: "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2", children: /* @__PURE__ */ u.jsx(Hp, { className: "h-4 w-4 animate-spin" }) }) : null
          ]
        }
      ) : null
    ] })
  ] }) });
}
function vc(e) {
  const t = (r) => {
    r || e.preventCloseOnOutsideClick || e.onClose();
  }, n = e.headerCentered ?? !0;
  return /* @__PURE__ */ u.jsx(oo, { onOpenChange: t, open: e.isOpen, children: /* @__PURE__ */ u.jsx(
    Ui,
    {
      className: J(e.modalClassName ?? "max-w-2xl p-6 md:max-w-4xl"),
      onInteractOutside: (r) => {
        e.preventCloseOnOutsideClick && r.preventDefault();
      },
      onOpenAutoFocus: e.preventAutoFocus ? (r) => r.preventDefault() : void 0,
      children: /* @__PURE__ */ u.jsxs("div", { className: J("flex max-h-[90vh] flex-col gap-4"), children: [
        /* @__PURE__ */ u.jsxs(
          dc,
          {
            className: J(n ? "text-center" : "text-left"),
            children: [
              /* @__PURE__ */ u.jsx(
                Hi,
                {
                  asChild: !!e.titleAs,
                  className: J(
                    e.subtitle ? "text-xl" : "text-2xl",
                    e.titleClassName ?? "font-semibold text-neutral-darker leading-8 tracking-tight"
                  ),
                  children: e.titleAs ? Yy(e.titleAs, {}, e.title) : e.title
                }
              ),
              e.subtitle ? /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-sm", children: e.subtitle }) : null
            ]
          }
        ),
        e.generalErrorMessage ? /* @__PURE__ */ u.jsx(
          na,
          {
            microcopies: {
              title: e.generalErrorMessage
            },
            variant: "destructive"
          }
        ) : null,
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: e.contentClassName ?? "max-h-[50vh] min-h-0 flex-1 overflow-y-auto",
            children: e.children
          }
        ),
        e.primaryButtonText || e.secondaryButtonText || e.showDeleteButton ? /* @__PURE__ */ u.jsx(cX, { ...e }) : null
      ] })
    }
  ) });
}
const NA = (e) => /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col", children: [
  /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.companyName }),
  /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.street }),
  /* @__PURE__ */ u.jsxs(B, { variant: "body-md", children: [
    e.postalCode,
    " ",
    e.city
  ] }),
  /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.country })
] });
function MA(e, t) {
  if (e && t)
    return e.find((n) => n.id === t);
}
function IA(e) {
  const {
    addresses: t,
    microcopies: n,
    onSelectAddress: r,
    shouldShowCTA: i = !0
  } = e, [a, o] = Ee(!1), [s, c] = Ee(!1), [l, d] = Ee(
    void 0
  ), f = t?.find((O) => O.isDefault) ?? t?.[0], h = Tr(
    () => t?.map((O) => ({
      value: O.id,
      label: /* @__PURE__ */ u.jsx(NA, { ...O })
    })),
    [t]
  ), [m, g] = Ee(
    h?.find((O) => O.value === f?.id)?.value
  ), [p, v] = Ee(
    h?.find((O) => O.value === f?.id)?.value
  ), y = Tr(() => {
    if (h)
      return m ? [
        ...h.filter((O) => O.value === m),
        ...h.filter((O) => O.value !== m)
      ] : h;
  }, [h, m]), x = () => {
    v(m), d(void 0), o(!0);
  }, w = () => {
    v(m), d(void 0), o(!1);
  }, _ = async (O) => {
    if (O.id === m) {
      o(!1);
      return;
    }
    if (r) {
      c(!0), d(void 0);
      try {
        (await r(O)).ok ? (g(O.id), o(!1)) : d(n.dialogErrorMessage);
      } catch (E) {
        d(
          E instanceof Error ? E.message : n.dialogErrorMessage
        );
      } finally {
        c(!1);
      }
    }
  };
  if (!t || t.length === 0)
    return /* @__PURE__ */ u.jsx(
      na,
      {
        microcopies: {
          title: n.warningTitle,
          description: n.warningDescription
        },
        variant: "warning"
      }
    );
  const b = MA(t, m) ?? t[0], S = () => {
    const O = MA(t, p);
    O && _(O);
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(NA, { ...b }),
    t.length > 1 && i ? /* @__PURE__ */ u.jsx(
      ve,
      {
        className: "mt-2 w-max font-semibold",
        onClick: x,
        size: "default",
        variant: "secondary",
        children: n.changeAddressButtonLabel
      }
    ) : null,
    /* @__PURE__ */ u.jsx(
      vc,
      {
        generalErrorMessage: l,
        headerCentered: !1,
        isLoading: s,
        isOpen: a,
        onClose: w,
        onPrimaryAction: S,
        primaryButtonText: n.dialogSubmitButtonLabel,
        subtitle: n.dialogSubtitle,
        title: n.dialogTitle,
        children: /* @__PURE__ */ u.jsx("div", { className: "py-4", children: y && /* @__PURE__ */ u.jsx(
          fc,
          {
            name: "shipping-address",
            onValueChange: v,
            options: y,
            value: p
          }
        ) })
      }
    )
  ] });
}
function DA(e) {
  const t = e.options?.find((n) => n.value === e.selectedValue)?.label ?? e.selectedValue;
  return e.mode === "readonly" ? /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: t }) : /* @__PURE__ */ u.jsxs(co, { onValueChange: e.onValueChange, value: e.selectedValue, children: [
    /* @__PURE__ */ u.jsx(Zi, { className: `h-8 ${e.selectWidth || "w-full"}`, children: /* @__PURE__ */ u.jsx(lo, { placeholder: e.selectedValue }) }),
    /* @__PURE__ */ u.jsx(Xi, { children: e.options?.map((n) => /* @__PURE__ */ u.jsx(Qi, { value: n.value, children: n.label }, n.value)) })
  ] });
}
function kA(e) {
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    e.buttons.showBack && /* @__PURE__ */ u.jsx(
      ve,
      {
        "aria-label": e.microcopies.backButton,
        onClick: e.buttons.onBackClick,
        size: "icon",
        variant: "outline",
        children: /* @__PURE__ */ u.jsx(SC, { className: "h-4 w-4" })
      }
    ),
    e.buttons.showCheckout && /* @__PURE__ */ u.jsxs(ve, { onClick: e.buttons.onCheckoutClick, children: [
      /* @__PURE__ */ u.jsx(bl, { className: "h-4 w-4" }),
      e.microcopies.checkoutButton
    ] }),
    e.buttons.showPlaceOrder && /* @__PURE__ */ u.jsxs(
      ve,
      {
        disabled: !e.placeOrderEnabled,
        onClick: e.buttons.onPlaceOrderClick,
        children: [
          /* @__PURE__ */ u.jsx(bl, { className: "h-4 w-4" }),
          e.microcopies.placeOrderButton
        ]
      }
    ),
    e.buttons.showValidate && /* @__PURE__ */ u.jsx(ve, { onClick: e.buttons.onValidateClick, children: e.microcopies.validateButton }),
    e.buttons.showThreeDots && e.cartMenuOptions
  ] });
}
function Zle(e) {
  const t = e.orderPurpose?.mode !== "hidden" && e.orderPurpose?.mode !== "none", n = e.buttons.showThreeDots ?? e.orderPurpose?.mode !== "readonly";
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-3 md:hidden", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.microcopies.cartTitle }),
        /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.articlesDescription })
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between gap-1", children: [
        /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.totalAmountLabel }),
        /* @__PURE__ */ u.jsx("div", { className: "text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.data.totalAmount }) })
      ] }),
      t && e.orderPurpose && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.orderPurposeLabel }),
        /* @__PURE__ */ u.jsx(
          DA,
          {
            mode: e.orderPurpose.mode,
            onValueChange: e.orderPurpose.onValueChange,
            options: e.orderPurpose.options,
            selectedValue: e.data.selectedOrderPurpose
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex items-center justify-end gap-4", children: /* @__PURE__ */ u.jsx(
        kA,
        {
          buttons: { ...e.buttons, showThreeDots: n },
          cartMenuOptions: e.cartMenuOptions,
          microcopies: e.microcopies,
          placeOrderEnabled: e.placeOrderEnabled
        }
      ) })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "hidden md:flex md:items-center md:justify-between md:gap-5", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col justify-center gap-1", children: [
        /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.microcopies.cartTitle }),
        /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.articlesDescription })
      ] }),
      /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-5", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-end justify-center gap-1", children: [
          /* @__PURE__ */ u.jsx("div", { className: "text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.data.totalAmount }) }),
          /* @__PURE__ */ u.jsx("div", { className: "text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.totalAmountLabel }) })
        ] }),
        t && e.orderPurpose && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-start justify-between gap-0.5", children: [
          /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.orderPurposeLabel }),
          /* @__PURE__ */ u.jsx(
            DA,
            {
              mode: e.orderPurpose?.mode,
              onValueChange: e.orderPurpose?.onValueChange,
              options: e.orderPurpose?.options,
              selectedValue: e.data.selectedOrderPurpose,
              selectWidth: "w-[200px]"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-4", children: /* @__PURE__ */ u.jsx(
          kA,
          {
            buttons: { ...e.buttons, showThreeDots: n },
            cartMenuOptions: e.cartMenuOptions,
            microcopies: e.microcopies,
            placeOrderEnabled: e.placeOrderEnabled
          }
        ) })
      ] })
    ] })
  ] });
}
var Nd = "Collapsible", [lX, OI] = wn(Nd), [uX, wx] = lX(Nd), EI = A.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: a,
      onOpenChange: o,
      ...s
    } = e, [c, l] = In({
      prop: r,
      defaultProp: i ?? !1,
      onChange: o,
      caller: Nd
    });
    return /* @__PURE__ */ u.jsx(
      uX,
      {
        scope: n,
        disabled: a,
        contentId: Nn(),
        open: c,
        onOpenToggle: A.useCallback(() => l((d) => !d), [l]),
        children: /* @__PURE__ */ u.jsx(
          Ae.div,
          {
            "data-state": Sx(c),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
EI.displayName = Nd;
var AI = "CollapsibleTrigger", PI = A.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = wx(AI, n);
    return /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": Sx(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: Oe(e.onClick, i.onOpenToggle)
      }
    );
  }
);
PI.displayName = AI;
var _x = "CollapsibleContent", CI = A.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = wx(_x, e.__scopeCollapsible);
    return /* @__PURE__ */ u.jsx(zr, { present: n || i.open, children: ({ present: a }) => /* @__PURE__ */ u.jsx(dX, { ...r, ref: t, present: a }) });
  }
);
CI.displayName = _x;
var dX = A.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...a } = e, o = wx(_x, n), [s, c] = A.useState(r), l = A.useRef(null), d = ke(t, l), f = A.useRef(0), h = f.current, m = A.useRef(0), g = m.current, p = o.open || s, v = A.useRef(p), y = A.useRef(void 0);
  return A.useEffect(() => {
    const x = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(x);
  }, []), Vt(() => {
    const x = l.current;
    if (x) {
      y.current = y.current || {
        transitionDuration: x.style.transitionDuration,
        animationName: x.style.animationName
      }, x.style.transitionDuration = "0s", x.style.animationName = "none";
      const w = x.getBoundingClientRect();
      f.current = w.height, m.current = w.width, v.current || (x.style.transitionDuration = y.current.transitionDuration, x.style.animationName = y.current.animationName), c(r);
    }
  }, [o.open, r]), /* @__PURE__ */ u.jsx(
    Ae.div,
    {
      "data-state": Sx(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      id: o.contentId,
      hidden: !p,
      ...a,
      ref: d,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: p && i
    }
  );
});
function Sx(e) {
  return e ? "open" : "closed";
}
var fX = EI, hX = PI, mX = CI, Jn = "Accordion", vX = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Ox, pX, gX] = _d(Jn), [Md] = wn(Jn, [
  gX,
  OI
]), Ex = OI(), jI = T.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, i = r, a = r;
    return /* @__PURE__ */ u.jsx(Ox.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ u.jsx(wX, { ...a, ref: t }) : /* @__PURE__ */ u.jsx(xX, { ...i, ref: t }) });
  }
);
jI.displayName = Jn;
var [TI, yX] = Md(Jn), [NI, bX] = Md(
  Jn,
  { collapsible: !1 }
), xX = T.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: a = !1,
      ...o
    } = e, [s, c] = In({
      prop: n,
      defaultProp: r ?? "",
      onChange: i,
      caller: Jn
    });
    return /* @__PURE__ */ u.jsx(
      TI,
      {
        scope: e.__scopeAccordion,
        value: T.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: c,
        onItemClose: T.useCallback(() => a && c(""), [a, c]),
        children: /* @__PURE__ */ u.jsx(NI, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ u.jsx(MI, { ...o, ref: t }) })
      }
    );
  }
), wX = T.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = e, [o, s] = In({
    prop: n,
    defaultProp: r ?? [],
    onChange: i,
    caller: Jn
  }), c = T.useCallback(
    (d) => s((f = []) => [...f, d]),
    [s]
  ), l = T.useCallback(
    (d) => s((f = []) => f.filter((h) => h !== d)),
    [s]
  );
  return /* @__PURE__ */ u.jsx(
    TI,
    {
      scope: e.__scopeAccordion,
      value: o,
      onItemOpen: c,
      onItemClose: l,
      children: /* @__PURE__ */ u.jsx(NI, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ u.jsx(MI, { ...a, ref: t }) })
    }
  );
}), [_X, Id] = Md(Jn), MI = T.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: a = "vertical", ...o } = e, s = T.useRef(null), c = ke(s, t), l = pX(n), f = hc(i) === "ltr", h = Oe(e.onKeyDown, (m) => {
      if (!vX.includes(m.key)) return;
      const g = m.target, p = l().filter((E) => !E.ref.current?.disabled), v = p.findIndex((E) => E.ref.current === g), y = p.length;
      if (v === -1) return;
      m.preventDefault();
      let x = v;
      const w = 0, _ = y - 1, b = () => {
        x = v + 1, x > _ && (x = w);
      }, S = () => {
        x = v - 1, x < w && (x = _);
      };
      switch (m.key) {
        case "Home":
          x = w;
          break;
        case "End":
          x = _;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? b() : S());
          break;
        case "ArrowDown":
          a === "vertical" && b();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? S() : b());
          break;
        case "ArrowUp":
          a === "vertical" && S();
          break;
      }
      const O = x % y;
      p[O].ref.current?.focus();
    });
    return /* @__PURE__ */ u.jsx(
      _X,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: a,
        children: /* @__PURE__ */ u.jsx(Ox.Slot, { scope: n, children: /* @__PURE__ */ u.jsx(
          Ae.div,
          {
            ...o,
            "data-orientation": a,
            ref: c,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), Pu = "AccordionItem", [SX, Ax] = Md(Pu), II = T.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...i } = e, a = Id(Pu, n), o = yX(Pu, n), s = Ex(n), c = Nn(), l = r && o.value.includes(r) || !1, d = a.disabled || e.disabled;
    return /* @__PURE__ */ u.jsx(
      SX,
      {
        scope: n,
        open: l,
        disabled: d,
        triggerId: c,
        children: /* @__PURE__ */ u.jsx(
          fX,
          {
            "data-orientation": a.orientation,
            "data-state": BI(l),
            ...s,
            ...i,
            ref: t,
            disabled: d,
            open: l,
            onOpenChange: (f) => {
              f ? o.onItemOpen(r) : o.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
II.displayName = Pu;
var DI = "AccordionHeader", kI = T.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Id(Jn, n), a = Ax(DI, n);
    return /* @__PURE__ */ u.jsx(
      Ae.h3,
      {
        "data-orientation": i.orientation,
        "data-state": BI(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
kI.displayName = DI;
var _y = "AccordionTrigger", RI = T.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Id(Jn, n), a = Ax(_y, n), o = bX(_y, n), s = Ex(n);
    return /* @__PURE__ */ u.jsx(Ox.ItemSlot, { scope: n, children: /* @__PURE__ */ u.jsx(
      hX,
      {
        "aria-disabled": a.open && !o.collapsible || void 0,
        "data-orientation": i.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
RI.displayName = _y;
var LI = "AccordionContent", $I = T.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Id(Jn, n), a = Ax(LI, n), o = Ex(n);
    return /* @__PURE__ */ u.jsx(
      mX,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": i.orientation,
        ...o,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
$I.displayName = LI;
function BI(e) {
  return e ? "open" : "closed";
}
var OX = jI, EX = II, AX = kI, PX = RI, CX = $I;
const jX = yt("column");
function Dd(e) {
  const t = J(jX({ className: e.className }));
  return /* @__PURE__ */ u.jsx("div", { className: t, "data-testid": "column", children: e.children });
}
const FI = "container--fluid grid gap-unit relative", TX = yt("", {
  variants: {
    fullWidth: {
      true: "container--fullwidth relative",
      false: FI
    },
    paddingTop: {
      none: "pt-0",
      small: "pt-small",
      medium: "pt-medium",
      large: "pt-large"
    },
    paddingBottom: {
      none: "pb-0",
      small: "pb-small",
      medium: "pb-medium",
      large: "pb-large"
    }
  },
  defaultVariants: {
    fullWidth: !1,
    paddingTop: "medium",
    paddingBottom: "medium"
  }
});
function kd(e) {
  const t = J(
    TX({
      fullWidth: !!e.fullWidth,
      paddingTop: e.paddingTop,
      paddingBottom: e.paddingBottom,
      className: e.className
    })
  );
  return /* @__PURE__ */ u.jsx("section", { className: t, "data-testid": "container", id: e.id, children: !e.outerContainerOnly && e.fullWidth ? /* @__PURE__ */ u.jsx("div", { className: FI, children: e.children }) : e.children });
}
const NX = yt("row relative grid grid-cols-12 gap-unit");
function Rd(e) {
  const t = J(NX({ className: e.className }));
  return /* @__PURE__ */ u.jsx("div", { className: t, "data-testid": "row", children: e.children });
}
const Ma = OX, MX = hr(!1), IX = yt("border-b transition-all", {
  variants: {
    variant: {
      b2b: "border-border",
      d2c: "border-alabastergrey"
    }
  },
  defaultVariants: {
    variant: "b2b"
  }
});
function Ks({
  className: e,
  variant: t,
  ...n
}) {
  return /* @__PURE__ */ u.jsx(MX.Provider, { value: !0, children: /* @__PURE__ */ u.jsx(
    EX,
    {
      className: J(IX({ variant: t }), e),
      ...n
    }
  ) });
}
const DX = yt(
  "group flex w-full items-center justify-between focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        b2b: "text-foreground transition-all",
        d2c: "group gap-4 py-8 text-left"
      },
      size: {
        default: "",
        lg: ""
      }
    },
    compoundVariants: [
      {
        variant: "b2b",
        size: "default",
        className: "py-4 font-semibold text-sm leading-5"
      },
      {
        variant: "b2b",
        size: "lg",
        className: "py-4 font-semibold text-2xl leading-8 tracking-tight"
      }
    ],
    defaultVariants: {
      variant: "b2b",
      size: "default"
    }
  }
);
function kX() {
  return /* @__PURE__ */ u.jsxs(
    "span",
    {
      "aria-hidden": "true",
      className: "relative flex size-6 shrink-0 items-center justify-center",
      children: [
        /* @__PURE__ */ u.jsx("span", { className: "-translate-y-1/2 absolute inset-x-0 top-1/2 block h-px bg-current" }),
        /* @__PURE__ */ u.jsx("span", { className: "-translate-x-1/2 absolute inset-y-0 left-1/2 block w-px bg-current group-data-[state=open]:hidden" })
      ]
    }
  );
}
function Gs({
  className: e,
  children: t,
  size: n,
  variant: r,
  triggerVariant: i = "default",
  resetId: a,
  onReset: o,
  resetDisabled: s = !1,
  resetLabel: c = "Reset",
  ...l
}) {
  const d = r === "d2c", f = n === "lg" ? "size-5" : "size-4", h = /* @__PURE__ */ u.jsx(
    zi,
    {
      className: J(
        f,
        "shrink-0 text-muted-foreground transition-transform duration-200",
        "group-data-[state=open]:rotate-180"
      )
    }
  ), m = i === "reset" ? /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
    h,
    /* @__PURE__ */ u.jsx("span", { children: t })
  ] }) : d ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    t,
    /* @__PURE__ */ u.jsx(kX, {})
  ] }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    t,
    h
  ] }), g = i === "reset" ? /* @__PURE__ */ u.jsx(
    ve,
    {
      "aria-label": c,
      className: "ml-4 self-center",
      disabled: s,
      onClick: (p) => {
        p.preventDefault(), p.stopPropagation(), !s && typeof o == "function" && a && o(a);
      },
      size: "sm",
      type: "button",
      variant: "ghost",
      children: c
    }
  ) : null;
  return /* @__PURE__ */ u.jsxs(AX, { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ u.jsx(
      PX,
      {
        className: J(DX({ variant: r, size: n }), e),
        ...l,
        children: m
      }
    ),
    g
  ] });
}
const RX = yt(
  "overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
  {
    variants: {
      variant: {
        b2b: "text-foreground",
        d2c: ""
      },
      size: {
        default: "",
        lg: ""
      }
    },
    compoundVariants: [
      {
        variant: "b2b",
        size: "default",
        className: "font-normal text-sm leading-4"
      },
      {
        variant: "b2b",
        size: "lg",
        className: "font-normal text-base leading-5"
      }
    ],
    defaultVariants: {
      variant: "b2b",
      size: "default"
    }
  }
);
function Zs({
  className: e,
  children: t,
  size: n,
  variant: r,
  ...i
}) {
  const a = r === "d2c";
  return /* @__PURE__ */ u.jsx(
    CX,
    {
      className: J(RX({ size: n, variant: r }), e),
      ...i,
      children: /* @__PURE__ */ u.jsx("div", { className: a ? "pb-8" : "pt-0 pb-5", children: t })
    }
  );
}
const RA = yt("", {
  variants: {
    columnWidth: {
      8: "col-span-10 col-start-2 md:col-span-8 md:col-start-3",
      10: "col-span-10 col-start-2",
      12: "col-span-12"
    },
    backgroundColor: {
      black: "bg-black",
      white: "bg-white",
      whitesmoke: "bg-whitesmoke"
    },
    color: {
      black: "text-black",
      white: "text-white",
      alabastergrey: "text-alabastergrey"
    }
  },
  defaultVariants: {
    columnWidth: 10,
    backgroundColor: "white",
    color: "black"
  }
});
function Xle(e) {
  if (e.mode === "D2C") {
    const r = RA({
      columnWidth: null,
      backgroundColor: e.backgroundColor,
      color: e.color
    }), i = RA({
      columnWidth: e.columnWidth,
      backgroundColor: null,
      color: null
    });
    return /* @__PURE__ */ u.jsx(
      kd,
      {
        className: J(r, "component-accordion", e.className),
        fullWidth: !0,
        paddingBottom: e.paddingBottom,
        paddingTop: e.paddingTop,
        children: /* @__PURE__ */ u.jsx(Rd, { className: "gap-0", children: /* @__PURE__ */ u.jsx(Dd, { className: i, children: /* @__PURE__ */ u.jsx(
          Ma,
          {
            className: "border-alabastergrey border-t",
            type: "multiple",
            children: e.items.map((a) => /* @__PURE__ */ u.jsxs(Ks, { value: a.id, variant: "d2c", children: [
              /* @__PURE__ */ u.jsx(Gs, { variant: "d2c", children: /* @__PURE__ */ u.jsx(os, { style: "no-mb", children: a.label }) }),
              /* @__PURE__ */ u.jsx(Zs, { variant: "d2c", children: a.children })
            ] }, a.id))
          }
        ) }) })
      }
    );
  }
  const t = e.items.map((r) => /* @__PURE__ */ u.jsxs(Ks, { value: r.id, variant: "b2b", children: [
    /* @__PURE__ */ u.jsx(
      Gs,
      {
        onReset: e.onReset,
        resetId: r.id,
        resetLabel: e.resetLabel,
        size: e.size,
        triggerVariant: e.triggerVariant,
        variant: "b2b",
        children: r.label
      }
    ),
    /* @__PURE__ */ u.jsx(Zs, { size: e.size, variant: "b2b", children: r.children })
  ] }, r.id));
  if (e.type === "single")
    return /* @__PURE__ */ u.jsx(
      Ma,
      {
        className: e.className,
        defaultValue: typeof e.defaultValue == "string" ? e.defaultValue : e.defaultValue?.[0],
        type: "single",
        children: t
      }
    );
  let n;
  return Array.isArray(e.defaultValue) ? n = e.defaultValue : e.defaultValue ? n = [e.defaultValue] : n = void 0, /* @__PURE__ */ u.jsx(
    Ma,
    {
      className: e.className,
      defaultValue: n,
      type: "multiple",
      children: t
    }
  );
}
function Qle(e) {
  const t = e.showFullPrices ?? !0, n = e.orderPurpose?.mode !== "hidden", r = e.savings != null && e.savings.totalSavingsValue > 0, i = e.savings != null && e.savings.annualDiscountSavingsValue > 0, a = e.savings != null && e.savings.promoSavingsValue > 0, o = e.savings != null && e.savings.extraDiscountsValue > 0, s = e.orderPurpose?.options?.find(
    (c) => c.value === e.orderPurpose?.value
  )?.label ?? e.orderPurpose?.value;
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: `flex w-full flex-col rounded-md border border-stone-200 bg-white md:min-w-md ${e.className || ""}`,
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col justify-center border-stone-200 border-b p-4", children: [
          /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.title }) }),
          /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.articleCountText }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-5 p-4", children: [
          n && e.orderPurpose && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between gap-2", children: [
            /* @__PURE__ */ u.jsx("div", { className: "flex-1 text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.orderPurpose.label }) }),
            e.orderPurpose.mode === "dropdown" ? /* @__PURE__ */ u.jsx("div", { className: "w-full flex-1", children: /* @__PURE__ */ u.jsxs(
              co,
              {
                onValueChange: e.orderPurpose.onChange,
                value: e.orderPurpose.value || "",
                children: [
                  /* @__PURE__ */ u.jsx(Zi, { className: "w-full", children: /* @__PURE__ */ u.jsx(lo, { placeholder: e.orderPurpose.value }) }),
                  /* @__PURE__ */ u.jsx(Xi, { children: e.orderPurpose.options?.map((c) => /* @__PURE__ */ u.jsx(Qi, { value: c.value, children: c.label }, c.value)) })
                ]
              }
            ) }) : /* @__PURE__ */ u.jsx("div", { className: "flex-1 text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: s }) })
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-0.5", children: t ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-0", children: [
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between", children: [
                /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.subtotalLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: e.prices.subtotal }) })
              ] }),
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between", children: [
                /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.shippingLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.prices.shipping }) })
              ] }),
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between", children: [
                /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.vatLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.prices.vat }) })
              ] })
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "mt-1 flex flex-row items-center justify-between", children: [
              /* @__PURE__ */ u.jsx("div", { className: "text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.microcopies.totalLabel }) }),
              /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.prices.total }) })
            ] })
          ] }) : (
            /* Simplified view - Total only */
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-end", children: [
              /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.prices.total }) }),
              /* @__PURE__ */ u.jsx("div", { className: "text-right text-zinc-900", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.totalAmountLabel || e.microcopies.totalLabel }) })
            ] })
          ) })
        ] }),
        r && e.savings && /* @__PURE__ */ u.jsx("div", { className: "mx-4 mb-4 overflow-hidden rounded-md border border-stone-200 bg-accent", children: /* @__PURE__ */ u.jsx(Ma, { collapsible: !0, type: "single", children: /* @__PURE__ */ u.jsxs(Ks, { className: "border-b-0 px-3", value: "savings", children: [
          /* @__PURE__ */ u.jsxs(Gs, { className: "text-zinc-900 [&>svg]:text-zinc-900", children: [
            /* @__PURE__ */ u.jsx("span", { className: "min-w-0 flex-1 text-left", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.yourTotalSavingsLabel }) }),
            /* @__PURE__ */ u.jsx("span", { className: "mr-2 shrink-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.savings.totalSavings }) })
          ] }),
          /* @__PURE__ */ u.jsx(Zs, { className: "text-zinc-900", children: /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col gap-2 overflow-hidden", children: [
            e.microcopies.savingsDescriptionText && /* @__PURE__ */ u.jsx("div", { className: "w-60 min-w-0 overflow-hidden break-words md:w-96", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.microcopies.savingsDescriptionText }) }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between gap-1", children: [
                /* @__PURE__ */ u.jsx("div", { className: "min-w-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.microcopies.standardDealerPriceLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "shrink-0 text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.savings.standardDealerPrice }) })
              ] }),
              i && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between gap-1", children: [
                /* @__PURE__ */ u.jsx("div", { className: "min-w-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.microcopies.annualDiscountSavingsLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "shrink-0 text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.savings.annualDiscountSavings }) })
              ] }),
              a && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between gap-1", children: [
                /* @__PURE__ */ u.jsx("div", { className: "min-w-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.microcopies.promoSavingsLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "shrink-0 text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.savings.promoSavings }) })
              ] }),
              o && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row items-center justify-between gap-1", children: [
                /* @__PURE__ */ u.jsx("div", { className: "min-w-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.microcopies.extraDiscountsLabel }) }),
                /* @__PURE__ */ u.jsx("div", { className: "shrink-0 text-right", children: /* @__PURE__ */ u.jsx(B, { variant: "body-xs", children: e.savings.extraDiscounts }) })
              ] })
            ] })
          ] }) })
        ] }) }) }),
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col items-end gap-2 border-stone-200 border-t p-5", children: /* @__PURE__ */ u.jsxs(
          ve,
          {
            className: "shadow-base",
            disabled: e.action.disabled,
            onClick: e.action.onClick,
            size: "default",
            variant: "default",
            children: [
              e.action.icon || /* @__PURE__ */ u.jsx(bl, { className: "h-4 w-4" }),
              e.action.label
            ]
          }
        ) })
      ]
    }
  );
}
const zI = A.createContext({});
function Jle(e) {
  const t = A.useMemo(
    () => ({ Override: e.component }),
    [e.component]
  );
  return /* @__PURE__ */ u.jsx(zI.Provider, { value: t, children: e.children });
}
function LX() {
  return A.useContext(zI).Override;
}
function zo(e, t, n) {
  return t ? n || "" : e;
}
const $X = "data:image/webp;base64,UklGRo4CAABXRUJQVlA4IIICAAAQKgCdASp3AfoAPpFInkulpKKho71oILASCWlu4XVRCPNpCJbwVQN+IIaWsb8Zo434zRxvxmjjfjNHG/GaON+M0cb8Zo434zRxvxmjjfjNHG/GaON+M0cb8ZomePP8ODRlzb/YOZni5Gcmj8srDPfHluhGz6gTs24ruEWcizaN+uQMUstDHFp+JHD0p/5UN2HOiZ2SKmnGUiLX1Eyrf/nr3aUWGB5avMZiQfhl3qkk2XBg0lAXsVL9TkWn4icY6okvhOvAAoBSh0hFjQeVD3PSzS2YD1E0e3Y0N7ozFBUt6QJZw24uhZGTOr5Q9ZiKn6y71SNQ1qg4tPxj3XIaMkOxsjwoGz1fDn5dkyKFxo48GDeWsb8Si3V4pseA8tGtcpOtqw1PYzE/GaON+NSVPxqnBzYHlrG/GaON+M0cb8Zo434zRxvxmjjfjNHG/GaON+M0cb8Zo434zKgA/v7fuTtGx44AAAAAAArRHe040lnx/brHO5gLQxTurpq4s3vGazXsQFvSqHPqoI9BhrFC2a0mPSx2N5UWIo0FapPdes2GdjzThSl8M9kzLCFSkhG+c39OQIUR3Uy+H6png8dNk18pq5fcF9OGodLLcSOOq6K47j/V0L040oeYBYSe/El4BnSkGaJsrF6R508BbJPOqFwmg8Q52QVTPoL2lNYDoT7RKuJLo51qB2ziCFFsbaH0yVC4AsDm002VdCvBVLvF5c/Q7NIVttJBazlaj90txmOBx0ATzd/BCV6TNtWO1GXHTgu2ZHcnzpIJ/JjDn8bdNv5gBDLPmFYfzq65Q+191AedUbfixAtR0LS0lVEzk3ig+9xskURR5IA6DBIDhdFBvmAAAAA=";
function Xt(e) {
  const t = LX() || "img", n = e.aspectRatio, r = e.blurDataURL || $X, i = e.placeholder || "blur", a = e.sizes || "100vw", o = "fill" in e, s = !!e.width || !!e.height, c = o ? e.fill !== !1 : !s, l = t === "img";
  let d = "";
  switch (e.borderRadius) {
    case "none":
      d = "rounded-none";
      break;
    case "sm":
      d = "rounded-sm";
      break;
    case "md":
      d = "rounded-md";
      break;
    case "lg":
      d = "rounded-lg";
      break;
    case "full":
      d = "rounded-full";
      break;
  }
  const f = [
    // prefer props.className first so callers can override
    e.className,
    d
  ].filter(Boolean).join(" ");
  return e.unStyled ? /* @__PURE__ */ u.jsx(
    "img",
    {
      alt: zo(
        e.alt,
        !!e.decorative,
        e.decorativeLabel
      ),
      "aria-hidden": e.decorative ? !0 : void 0,
      className: e.className,
      draggable: e.draggable,
      onClick: e.onClick,
      onMouseDown: e.onMouseDown,
      src: e.src,
      style: e.style
    }
  ) : c ? /* @__PURE__ */ u.jsx(
    "div",
    {
      className: f,
      "data-testid": "image-fill-wrapper",
      style: {
        aspectRatio: n.replace(":", "/"),
        position: "relative",
        width: "100%",
        height: "100%"
      },
      children: l ? /* @__PURE__ */ u.jsx(
        "img",
        {
          alt: zo(
            e.alt,
            !!e.decorative,
            e.decorativeLabel
          ),
          "aria-hidden": e.decorative ? !0 : void 0,
          className: f,
          loading: e.loading,
          onClick: e.onClick,
          onError: e.onError,
          onLoad: e.onLoad,
          sizes: e.srcSet ? a : void 0,
          src: e.src,
          srcSet: e.srcSet,
          style: {
            objectFit: e.objectFit || "cover",
            objectPosition: e.objectPosition || "center",
            width: "100%",
            height: "100%"
          }
        }
      ) : /* @__PURE__ */ u.jsx(
        t,
        {
          alt: zo(
            e.alt,
            !!e.decorative,
            e.decorativeLabel
          ),
          "aria-hidden": e.decorative ? !0 : void 0,
          aspectRatio: n,
          blurDataURL: r,
          className: f,
          fill: !0,
          loading: e.loading,
          onClick: e.onClick,
          onError: e.onError,
          onLoad: e.onLoad,
          onLoadingComplete: e.onLoadingComplete,
          placeholder: i,
          priority: e.priority,
          quality: e.quality,
          sizes: a,
          src: e.src,
          style: {
            objectFit: e.objectFit || "cover",
            objectPosition: e.objectPosition || "center"
          }
        }
      )
    }
  ) : l ? /* @__PURE__ */ u.jsx(
    "img",
    {
      alt: zo(
        e.alt,
        !!e.decorative,
        e.decorativeLabel
      ),
      "aria-hidden": e.decorative ? !0 : void 0,
      className: f,
      height: e.height,
      loading: e.loading,
      onClick: e.onClick,
      onError: e.onError,
      onLoad: e.onLoad,
      sizes: e.srcSet ? a : void 0,
      src: e.src,
      srcSet: e.srcSet,
      width: e.width
    }
  ) : /* @__PURE__ */ u.jsx(
    t,
    {
      alt: zo(
        e.alt,
        !!e.decorative,
        e.decorativeLabel
      ),
      "aria-hidden": e.decorative ? !0 : void 0,
      aspectRatio: n,
      blurDataURL: r,
      className: f,
      height: e.height,
      loading: e.loading,
      onClick: e.onClick,
      onError: e.onError,
      onLoad: e.onLoad,
      onLoadingComplete: e.onLoadingComplete,
      placeholder: i,
      priority: e.priority,
      quality: e.quality,
      sizes: a,
      src: e.src,
      width: e.width
    }
  );
}
var [Ld] = wn("Tooltip", [
  Eo
]), $d = Eo(), qI = "TooltipProvider", BX = 700, Sy = "tooltip.open", [FX, Px] = Ld(qI), VI = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = BX,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: a
  } = e, o = A.useRef(!0), s = A.useRef(!1), c = A.useRef(0);
  return A.useEffect(() => {
    const l = c.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ u.jsx(
    FX,
    {
      scope: t,
      isOpenDelayedRef: o,
      delayDuration: n,
      onOpen: A.useCallback(() => {
        window.clearTimeout(c.current), o.current = !1;
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => o.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: A.useCallback((l) => {
        s.current = l;
      }, []),
      disableHoverableContent: i,
      children: a
    }
  );
};
VI.displayName = qI;
var Xs = "Tooltip", [zX, Bd] = Ld(Xs), WI = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    disableHoverableContent: o,
    delayDuration: s
  } = e, c = Px(Xs, e.__scopeTooltip), l = $d(t), [d, f] = A.useState(null), h = Nn(), m = A.useRef(0), g = o ?? c.disableHoverableContent, p = s ?? c.delayDuration, v = A.useRef(!1), [y, x] = In({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (O) => {
      O ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Sy))) : c.onClose(), a?.(O);
    },
    caller: Xs
  }), w = A.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), _ = A.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, v.current = !1, x(!0);
  }, [x]), b = A.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, x(!1);
  }, [x]), S = A.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      v.current = !0, x(!0), m.current = 0;
    }, p);
  }, [p, x]);
  return A.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ u.jsx(px, { ...l, children: /* @__PURE__ */ u.jsx(
    zX,
    {
      scope: t,
      contentId: h,
      open: y,
      stateAttribute: w,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: A.useCallback(() => {
        c.isOpenDelayedRef.current ? S() : _();
      }, [c.isOpenDelayedRef, S, _]),
      onTriggerLeave: A.useCallback(() => {
        g ? b() : (window.clearTimeout(m.current), m.current = 0);
      }, [b, g]),
      onOpen: _,
      onClose: b,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
WI.displayName = Xs;
var Oy = "TooltipTrigger", UI = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = Bd(Oy, n), a = Px(Oy, n), o = $d(n), s = A.useRef(null), c = ke(t, s, i.onTriggerChange), l = A.useRef(!1), d = A.useRef(!1), f = A.useCallback(() => l.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u.jsx(Pd, { asChild: !0, ...o, children: /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: Oe(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (i.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: Oe(e.onPointerLeave, () => {
          i.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: Oe(e.onPointerDown, () => {
          i.open && i.onClose(), l.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: Oe(e.onFocus, () => {
          l.current || i.onOpen();
        }),
        onBlur: Oe(e.onBlur, i.onClose),
        onClick: Oe(e.onClick, i.onClose)
      }
    ) });
  }
);
UI.displayName = Oy;
var qX = "TooltipPortal", [eue, VX] = Ld(qX, {
  forceMount: void 0
}), uo = "TooltipContent", HI = A.forwardRef(
  (e, t) => {
    const n = VX(uo, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, o = Bd(uo, e.__scopeTooltip);
    return /* @__PURE__ */ u.jsx(zr, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ u.jsx(YI, { side: i, ...a, ref: t }) : /* @__PURE__ */ u.jsx(WX, { side: i, ...a, ref: t }) });
  }
), WX = A.forwardRef((e, t) => {
  const n = Bd(uo, e.__scopeTooltip), r = Px(uo, e.__scopeTooltip), i = A.useRef(null), a = ke(t, i), [o, s] = A.useState(null), { trigger: c, onClose: l } = n, d = i.current, { onPointerInTransitChange: f } = r, h = A.useCallback(() => {
    s(null), f(!1);
  }, [f]), m = A.useCallback(
    (g, p) => {
      const v = g.currentTarget, y = { x: g.clientX, y: g.clientY }, x = GX(y, v.getBoundingClientRect()), w = ZX(y, x), _ = XX(p.getBoundingClientRect()), b = JX([...w, ..._]);
      s(b), f(!0);
    },
    [f]
  );
  return A.useEffect(() => () => h(), [h]), A.useEffect(() => {
    if (c && d) {
      const g = (v) => m(v, d), p = (v) => m(v, c);
      return c.addEventListener("pointerleave", g), d.addEventListener("pointerleave", p), () => {
        c.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", p);
      };
    }
  }, [c, d, m, h]), A.useEffect(() => {
    if (o) {
      const g = (p) => {
        const v = p.target, y = { x: p.clientX, y: p.clientY }, x = c?.contains(v) || d?.contains(v), w = !QX(y, o);
        x ? h() : w && (h(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, d, o, l, h]), /* @__PURE__ */ u.jsx(YI, { ...e, ref: a });
}), [UX, HX] = Ld(Xs, { isInside: !1 }), YX = OC("TooltipContent"), YI = A.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      ...s
    } = e, c = Bd(uo, n), l = $d(n), { onClose: d } = c;
    return A.useEffect(() => (document.addEventListener(Sy, d), () => document.removeEventListener(Sy, d)), [d]), A.useEffect(() => {
      if (c.trigger) {
        const f = (h) => {
          h.target?.contains(c.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, d]), /* @__PURE__ */ u.jsx(
      uc,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: o,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ u.jsxs(
          gx,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u.jsx(YX, { children: r }),
              /* @__PURE__ */ u.jsx(UX, { scope: n, isInside: !0, children: /* @__PURE__ */ u.jsx(i7, { id: c.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
HI.displayName = uo;
var KI = "TooltipArrow", KX = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = $d(n);
    return HX(
      KI,
      n
    ).isInside ? null : /* @__PURE__ */ u.jsx(yx, { ...i, ...r, ref: t });
  }
);
KX.displayName = KI;
function GX(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ZX(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function XX(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function QX(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let a = 0, o = t.length - 1; a < t.length; o = a++) {
    const s = t[a], c = t[o], l = s.x, d = s.y, f = c.x, h = c.y;
    d > r != h > r && n < (f - l) * (r - d) / (h - d) + l && (i = !i);
  }
  return i;
}
function JX(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), eQ(t);
}
function eQ(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], o = t[t.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], o = n[n.length - 2];
      if ((a.x - o.x) * (i.y - o.y) >= (a.y - o.y) * (i.x - o.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var tQ = VI, nQ = WI, rQ = UI, iQ = HI;
const aQ = tQ, oQ = nQ, sQ = rQ, cQ = ({
  className: e,
  sideOffset: t = 4,
  ...n
}) => /* @__PURE__ */ u.jsx(
  iQ,
  {
    className: J(
      "fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 z-50 animate-in overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-popover-foreground text-sm shadow-md data-[state=closed]:animate-out",
      e
    ),
    sideOffset: t,
    ...n
  }
), lQ = 200;
function LA(e) {
  const [t, n] = Ee(void 0), r = Yn(e.children) ? _t(
    e.children,
    {
      onClick: (i) => {
        const o = e.children.props.onClick;
        o?.(i), n((s) => !s);
      },
      onTouchStart: (i) => {
        const o = e.children.props.onTouchStart;
        o?.(i), n((s) => !s);
      }
    }
  ) : e.children;
  return /* @__PURE__ */ u.jsx(
    aQ,
    {
      delayDuration: e.delayDuration ?? lQ,
      children: /* @__PURE__ */ u.jsxs(oQ, { onOpenChange: n, open: t, children: [
        /* @__PURE__ */ u.jsx(sQ, { asChild: !0, children: r }),
        /* @__PURE__ */ u.jsx(
          cQ,
          {
            align: e.align ?? "center",
            className: e.className,
            side: e.side ?? "top",
            children: e.content
          }
        )
      ] })
    }
  );
}
const uQ = {
  AT: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  BE: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  DK: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  FR: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  DE: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  IT: { dateFormat: "DD/MM/YYYY", hour12: !1 },
  NL: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  CH: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  SE: { dateFormat: "DD.MM.YYYY", hour12: !1 },
  GB: { dateFormat: "DD/MM/YYYY", hour12: !0 },
  // Future countries (already supported)
  AU: { dateFormat: "DD/MM/YYYY", hour12: !0 },
  NZ: { dateFormat: "DD/MM/YYYY", hour12: !0 },
  US: { dateFormat: "MM/DD/YYYY", hour12: !0 }
}, dQ = "DD.MM.YYYY";
function fQ(e, t, n, r) {
  switch (e) {
    case "DD/MM/YYYY":
      return `${t}/${n}/${r}`;
    case "MM/DD/YYYY":
      return `${n}/${t}/${r}`;
    default:
      return `${t}.${n}.${r}`;
  }
}
function Ey(e, t) {
  const n = uQ[t] ?? {
    dateFormat: dQ,
    hour12: !1
  }, r = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(e), i = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
    e
  ), a = new Intl.DateTimeFormat("en", { year: "numeric" }).format(e), o = fQ(n.dateFormat, r, i, a), s = new Intl.DateTimeFormat("en", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: n.hour12
  });
  return {
    date: o,
    time: s.format(e)
  };
}
const $A = "S0101", hQ = 20, mQ = 50, vQ = 50, pQ = 100;
function gp(e, t = 0, n = 999) {
  return Math.max(t, Math.min(n, e));
}
function gQ(e, t = 999) {
  if (e.trim() === "")
    return null;
  const n = Number(e);
  return Number.isNaN(n) ? null : Math.min(n, t);
}
function BA(e, t) {
  return e <= t ? String(e) : `${t}+`;
}
const yQ = (e) => {
  let t = 0;
  return e.forEach((n) => {
    n.stock !== void 0 && (t += n.stock);
  }), t;
}, ln = {
  AVAILABLE_NOW: "available-now",
  FUTURE_AVAILABILITY: "future-availability",
  OUT_OF_STOCK: "out-of-stock"
};
function Ay(e) {
  const n = e.min ?? 0, r = e.max ?? 999, i = e.merchandiseCategory?.startsWith(
    $A
  ) ? vQ : pQ;
  let a = r;
  e.effectiveLimit !== void 0 ? a = e.effectiveLimit : e.availability?.locations && e.availability.locations.length > 0 && (a = Math.min(
    r,
    yQ(e.availability.locations),
    i
  ));
  const [o, s] = Ee({
    quantity: e.value,
    isFocused: !1,
    prevPropsValue: e.value,
    isWarning: e.value === a
  }), c = e.disabled || e.availability?.status === ln.OUT_OF_STOCK;
  e.value !== o.prevPropsValue && !o.isFocused && s({
    ...o,
    quantity: e.value,
    prevPropsValue: e.value
  });
  const l = () => {
    const O = gp(o.quantity + 1, n, a);
    s((E) => ({
      ...E,
      quantity: O,
      isWarning: O === a
    })), O === a ? e.alertHandler?.({ isVisible: !0, maxAvailability: a }) : e.alertHandler?.({ isVisible: !1, maxAvailability: a }), e.onQuantityChange?.(O);
  }, d = () => {
    const O = gp(o.quantity - 1, n, a);
    s((E) => ({
      ...E,
      quantity: O,
      isFocused: O <= n ? !1 : E.isFocused,
      isWarning: O === a
    })), e.alertHandler?.({ isVisible: !1, maxAvailability: a }), e.onQuantityChange?.(O);
  }, f = (O) => {
    if (c)
      return;
    let E = O.target.value;
    if (e.suffix && E.endsWith(e.suffix) && (E = E.slice(0, -e.suffix.length).trim()), !e.suffix && E.includes("."))
      return;
    if (/^0+\d+/.test(E) && (E = String(Number.parseInt(E, 10)), O.target.value = E), E.trim() === "") {
      s((R) => ({
        ...R,
        quantity: n,
        isWarning: !1
      })), e.alertHandler?.({
        isVisible: !1,
        maxAvailability: a
      }), e.onQuantityChange?.(n);
      return;
    }
    const P = gQ(E, a);
    if (P !== null) {
      const R = gp(P, n, a);
      s((j) => ({
        ...j,
        quantity: R,
        isWarning: R === a
      })), e.alertHandler?.({
        isVisible: R === a,
        maxAvailability: a
      }), e.onQuantityChange?.(R);
    }
  }, h = (O) => {
    O.key === "Enter" && O.preventDefault(), !e.suffix && (O.key === "." || O.key === ",") && O.preventDefault();
  }, m = () => {
    if (!e.availability?.locations)
      return null;
    const O = e.availability.locations.some(
      (R) => R.status === ln.AVAILABLE_NOW
    ), E = e.availability.locations.some(
      (R) => R.status === ln.FUTURE_AVAILABILITY
    ), P = [];
    return O && P.push(
      /* @__PURE__ */ u.jsx("span", { className: "text-green-600", children: /* @__PURE__ */ u.jsx(ls, { "aria-hidden": "true", className: "h-4 w-4" }) }, "available-now")
    ), E && P.push(
      /* @__PURE__ */ u.jsx("span", { className: "text-amber-500", children: /* @__PURE__ */ u.jsx(u0, { "aria-hidden": "true", className: "h-4 w-4" }) }, "future-availability")
    ), P.length > 0 ? P : null;
  }, g = () => e.availability?.status !== ln.OUT_OF_STOCK ? null : /* @__PURE__ */ u.jsx("span", { className: "text-red-600", children: /* @__PURE__ */ u.jsx(l0, { "aria-hidden": !0, className: "h-4 w-4" }) }), p = c || o.quantity <= n, v = c || o.quantity >= a;
  let y = "opacity-0";
  p ? y = "opacity-0 invisible" : o.isFocused && (y = "opacity-100");
  let x = "opacity-0";
  v && c ? x = "opacity-0 invisible" : o.isFocused && (x = "opacity-100");
  const w = () => {
    if (!e.availability)
      return null;
    const O = /* @__PURE__ */ u.jsx("div", { className: "mb-2 flex items-center justify-between", children: /* @__PURE__ */ u.jsx("span", { className: "font-semibold text-sm", children: e.microcopies.availabilityTitle }) });
    return e.availability.status === ln.OUT_OF_STOCK ? /* @__PURE__ */ u.jsxs("div", { className: "w-60 p-2", children: [
      O,
      /* @__PURE__ */ u.jsxs("div", { className: "mt-2 flex items-center gap-1 text-xs", children: [
        /* @__PURE__ */ u.jsx("span", { className: "text-red-600", children: /* @__PURE__ */ u.jsx(l0, { className: "h-3 w-3" }) }),
        /* @__PURE__ */ u.jsx("span", { className: "text-black", children: e.microcopies.outOfStock })
      ] })
    ] }) : (e.availability.status === ln.AVAILABLE_NOW || e.availability.status === ln.FUTURE_AVAILABILITY) && e.availability.locations && e.availability.locations.length > 0 ? /* @__PURE__ */ u.jsxs("div", { className: "w-72 p-2", children: [
      O,
      /* @__PURE__ */ u.jsx("div", { className: "space-y-3", children: e.availability.locations.map((E) => /* @__PURE__ */ u.jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ u.jsx("div", { className: "font-semibold text-sm", children: E.name }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1 text-xs", children: [
          E.status === ln.AVAILABLE_NOW && /* @__PURE__ */ u.jsx("span", { className: "text-green-600", children: /* @__PURE__ */ u.jsx(ls, { className: "h-3 w-3" }) }),
          E.status === ln.FUTURE_AVAILABILITY && /* @__PURE__ */ u.jsx("span", { className: "text-amber-500", children: /* @__PURE__ */ u.jsx(u0, { className: "h-3 w-3" }) }),
          /* @__PURE__ */ u.jsx("span", { children: (() => {
            const P = e.merchandiseCategory?.startsWith(
              $A
            ) ? hQ : mQ;
            if (E.status === ln.AVAILABLE_NOW)
              return E.stock !== void 0 ? `${BA(E.stock, P)} ${e.microcopies.itemsReadyForDelivery}` : E.date ? Ey(
                new Date(E.date),
                e?.country ?? "DE"
              ).date : e.microcopies.availableNow;
            const R = [];
            return E.stock !== void 0 && R.push(
              `${BA(E.stock, P)}`
            ), E.date && R.push(
              Ey(
                new Date(E.date),
                e.country ?? "DE"
              ).date
            ), R.join(" | ");
          })() })
        ] })
      ] }, E.name)) })
    ] }) : null;
  }, _ = e.availabilityIconsLayout || "top", b = o.quantity !== e.value;
  e.onProductStateChange?.(e.productId, b);
  const S = () => e.showAvailability && e.availability ? /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1", children: [
    e.availability.status === ln.OUT_OF_STOCK && /* @__PURE__ */ u.jsx(
      LA,
      {
        align: "start",
        content: w(),
        side: "top",
        children: g()
      }
    ),
    (e.availability.status === ln.AVAILABLE_NOW || e.availability.status === ln.FUTURE_AVAILABILITY) && /* @__PURE__ */ u.jsx(
      LA,
      {
        align: "start",
        content: w(),
        side: "top",
        children: /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-1", children: m() })
      }
    )
  ] }) : null;
  return /* @__PURE__ */ u.jsxs("div", { className: J("flex flex-col gap-1", e.className), children: [
    (e.showSize || e.showAvailability && _ === "top") && /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between", children: [
      e.showSize && e.size && /* @__PURE__ */ u.jsx("div", { className: "font-semibold text-base", children: e.size }),
      _ === "top" && S()
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: J(
            "flex min-w-30 flex-1 items-center justify-center rounded border border-stone-300 bg-white",
            c && "opacity-50",
            !o.isWarning && o.isFocused && "ring-4 ring-blue-300",
            b && !o.isFocused && "ring-4 ring-blue-300",
            o.isWarning && o.isFocused && "border-orange-700 ring-4 ring-orange-500"
          ),
          children: [
            /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-label": e.microcopies.decrement,
                className: J("shrink-0", y),
                disabled: p || c,
                onBlur: () => {
                  s((O) => ({ ...O, isFocused: !1 })), e.alertHandler?.({
                    isVisible: !1,
                    maxAvailability: a
                  });
                },
                onClick: (O) => {
                  O.preventDefault(), O.stopPropagation(), d();
                },
                onFocus: () => {
                  s((O) => ({ ...O, isFocused: !0 })), e.alertHandler?.({
                    isVisible: o.isWarning,
                    maxAvailability: a
                  });
                },
                size: "icon-sm",
                tabIndex: -1,
                variant: "ghost",
                children: /* @__PURE__ */ u.jsx(FL, { className: "h-4 w-4" })
              }
            ),
            /* @__PURE__ */ u.jsx(
              ni,
              {
                "aria-label": e.microcopies.quantity,
                className: "h-auto w-full min-w-13 border-0 text-center shadow-none focus-visible:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&[type='number']]:[-moz-appearance:textfield]",
                disabled: c,
                max: a,
                min: n,
                name: e.productId,
                onBlur: () => {
                  s((O) => ({ ...O, isFocused: !1 })), e.alertHandler?.({
                    isVisible: !1,
                    maxAvailability: a
                  });
                },
                onChange: f,
                onClick: (O) => {
                  c && O.preventDefault();
                },
                onFocus: () => {
                  s((O) => ({ ...O, isFocused: !0 })), e.alertHandler?.({
                    isVisible: o.isWarning,
                    maxAvailability: a
                  });
                },
                onKeyDown: (O) => {
                  if (c) {
                    O.preventDefault();
                    return;
                  }
                  h(O);
                },
                step: e.suffix ? void 0 : "1",
                type: e.suffix ? "text" : "number",
                value: e.suffix ? `${o.quantity}${e.suffix}` : o.quantity
              }
            ),
            /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-label": e.microcopies.increment,
                className: J("shrink-0", x),
                disabled: c,
                onBlur: () => {
                  s((O) => ({ ...O, isFocused: !1 })), e.alertHandler?.({
                    isVisible: !1,
                    maxAvailability: a
                  });
                },
                onClick: (O) => {
                  O.preventDefault(), O.stopPropagation(), l();
                },
                onFocus: () => s((O) => ({ ...O, isFocused: !0 })),
                size: "icon-sm",
                tabIndex: -1,
                variant: "ghost",
                children: /* @__PURE__ */ u.jsx(zL, { className: "h-4 w-4" })
              }
            )
          ]
        }
      ),
      _ === "side" && S()
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: e.showProductId && /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.showEanCode && e.ean ? e.ean : e.productId }) })
  ] });
}
const GI = (e) => e.reduce((t, n) => t + n.quantity, 0), bQ = (e) => e.reduce((t, n) => n.quantityEntries && n.quantityEntries.length > 0 ? t + n.quantityEntries.length : t + n.quantity, 0), xQ = (e, t, n) => {
  if (e.onQuantityChange && e.onQuantityChange(n), !t.quantityEntries || !t.onQuantityChange)
    return;
  const r = t.quantityEntries.reduce((i, a) => {
    const o = a.id === e.id ? n : a.quantity;
    return i + o;
  }, 0);
  t.onQuantityChange(r);
}, FA = (e, t, n, r, i, a, o, s, c, l) => {
  if (n && e.quantityEntries && e.quantityEntries.length > 0)
    return /* @__PURE__ */ u.jsx(
      "section",
      {
        className: J(
          "gap-2",
          t === "desktop" ? "flex w-lg items-end" : `grid grid-cols-${a} items-center`
        ),
        children: e.quantityEntries.slice(0, a).map((f) => /* @__PURE__ */ u.jsx(
          Ay,
          {
            alertHandler: o,
            country: s,
            microcopies: {
              quantity: i.quantity,
              increment: i.increment,
              decrement: i.decrement,
              availableNow: i.availableNow,
              itemsReadyForDelivery: i.itemsReadyForDelivery,
              futureAvailability: i.futureAvailability,
              outOfStock: i.outOfStock
            },
            onQuantityChange: (h) => xQ(f, e, h),
            productId: f.id,
            showAvailability: !1,
            value: f.quantity
          },
          f.id
        ))
      }
    );
  if (r)
    return /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: e.quantity });
  const d = c?.(e.id, e.quantity) ?? e.quantity;
  return /* @__PURE__ */ u.jsx(
    Ay,
    {
      alertHandler: o,
      availability: e.availability,
      availabilityIconsLayout: "side",
      country: s,
      merchandiseCategory: e.merchandiseCategory,
      microcopies: {
        quantity: i.quantity,
        increment: i.increment,
        decrement: i.decrement,
        availableNow: i.availableNow,
        itemsReadyForDelivery: i.itemsReadyForDelivery,
        futureAvailability: i.futureAvailability,
        outOfStock: i.outOfStock
      },
      onQuantityChange: (f) => {
        l?.(e.id, f), e.onQuantityChange?.(f);
      },
      productId: e.productId,
      showAvailability: e.showAvailability,
      value: d
    }
  );
}, tl = (e) => /* @__PURE__ */ u.jsx(
  Xt,
  {
    alt: e.imageAlt,
    aspectRatio: "1:1",
    borderRadius: "sm",
    className: "bg-neutral-100",
    fill: !0,
    objectFit: "cover",
    src: e.imageUrl
  }
), nl = (e, t, n, r) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-0.5", children: [
    e.frame && /* @__PURE__ */ u.jsxs(B, { variant: "body-sm-bold", children: [
      r?.frameLabel,
      ": ",
      e.frame
    ] }),
    e.frame ? /* @__PURE__ */ u.jsxs(B, { variant: "body-sm-bold", children: [
      r?.lensLabel,
      ": ",
      e.lens || e.color
    ] }) : /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.lens || e.color })
  ] }),
  /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-sm", children: e.id }),
  n && e.promoPrice && t,
  n && !e.promoPrice && e.yourPrice && /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.yourPrice })
] }), zA = (e) => /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: e.quantityEntries ? GI(e.quantityEntries) : e.quantity }), qA = 4;
function wQ(e) {
  const t = e.notification.type === "warning", n = e.notification.isDismissible ?? !0;
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: J(
        "flex items-center justify-between gap-4 px-4 py-1 pr-2",
        t ? "bg-orange-500" : "bg-red-700"
      ),
      role: "alert",
      children: [
        /* @__PURE__ */ u.jsx(B, { color: "white", variant: "body-sm-bold", children: e.notification.message }),
        n && /* @__PURE__ */ u.jsx(
          ve,
          {
            "aria-label": "Dismiss notification",
            className: "size-8 shrink-0 cursor-pointer rounded p-0 text-white hover:bg-black",
            onClick: e.onDismiss,
            size: "icon",
            variant: "ghost",
            children: /* @__PURE__ */ u.jsx(ei, { className: "size-4" })
          }
        )
      ]
    }
  );
}
function tue(e) {
  const [t, n] = Ee({
    isVisible: !1,
    maxAvailability: 0
  }), r = e.variant === "pre-order", i = e.totalQuantity ?? bQ(e.variants), [a, o] = Ee({
    showDeleteAllModal: !1,
    isDeletingAll: !1
  }), s = e.variants.some(
    (_) => !_.isReviewOnly
  ), [c, l] = Ee(
    /* @__PURE__ */ new Map()
  ), d = Le({
    isUpdating: e.isUpdating,
    variantIds: e.variants.map((_) => _.id).join(",")
  }), f = e.variants.map((_) => _.id).join(",");
  if (d.current.isUpdating && !e.isUpdating || d.current.variantIds !== f) {
    const _ = /* @__PURE__ */ new Map();
    for (const b of e.variants)
      _.set(b.id, b.quantity);
    l(_);
  }
  d.current = {
    isUpdating: e.isUpdating,
    variantIds: f
  };
  const m = (_, b) => c.get(_) ?? b, g = (_, b) => {
    l((S) => {
      const O = new Map(S);
      return O.set(_, b), O;
    });
  }, p = (_) => {
    o((b) => ({ ...b, ..._ }));
  }, v = () => {
    p({ showDeleteAllModal: !0 });
  }, y = async () => {
    p({ isDeletingAll: !0 });
    try {
      await e.onDeleteAll?.(), p({ showDeleteAllModal: !1 });
    } finally {
      p({ isDeletingAll: !1 });
    }
  }, x = () => {
    p({ showDeleteAllModal: !1 });
  }, w = async (_) => {
    await e.variants.find((S) => S.id === _)?.onDelete?.();
  };
  return /* @__PURE__ */ u.jsxs(
    "section",
    {
      className: J(
        "flex flex-col rounded-lg border bg-white",
        "border-neutral-300",
        e.className
      ),
      children: [
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: J(
              "flex flex-col gap-2 rounded-t-lg border-b p-4 md:flex-row md:items-start md:justify-between md:gap-4",
              "border-neutral-300"
            ),
            children: [
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
                /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.productName }),
                e.showProductCode && /* @__PURE__ */ u.jsxs(B, { variant: "body-md", children: [
                  e.microcopies.productCode,
                  ": ",
                  e.productCode
                ] })
              ] }),
              /* @__PURE__ */ u.jsxs("div", { className: "flex items-end justify-end gap-4", children: [
                e.showTotalQuantity && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-end gap-0.5", children: [
                  /* @__PURE__ */ u.jsxs(B, { variant: "body-lg", children: [
                    e.microcopies.totalQuantity,
                    ": ",
                    i
                  ] }),
                  /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.totalPrice })
                ] }),
                e.showDeleteButton && /* @__PURE__ */ u.jsx(
                  ve,
                  {
                    "aria-label": e.microcopies.deleteButton,
                    disabled: e.variants.length === 0,
                    onClick: v,
                    size: "icon",
                    variant: "ghost",
                    children: /* @__PURE__ */ u.jsx(hl, { className: "size-5" })
                  }
                )
              ] })
            ]
          }
        ),
        t.isVisible && /* @__PURE__ */ u.jsx("div", { className: "m-4", children: /* @__PURE__ */ u.jsx(
          na,
          {
            microcopies: {
              title: e.microcopies.orderLimitReachedTitle,
              description: e.microcopies.orderLimitReachedDescription.replace(
                "{EffectiveLimit}",
                t.maxAvailability.toString()
              )
            },
            variant: "warning"
          }
        ) }),
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col p-4", children: e.variants.map((_, b) => {
          let S = null;
          const O = e.readOnly || _.isReviewOnly, E = e.showDeleteButton && (_.canDelete ?? !0);
          return _.promoPrice ? S = /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-wrap items-baseline gap-1", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.standardDealerPrice }),
              /* @__PURE__ */ u.jsx(B, { style: "line-through", variant: "body-sm-bold", children: _.dealerListPrice }),
              _.promoDiscountPercent && /* @__PURE__ */ u.jsx(
                La,
                {
                  fontWeight: "bold",
                  text: `-${_.promoDiscountPercent}%`,
                  variant: "outline"
                }
              )
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-wrap items-baseline gap-1", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.promoPriceLabel }),
              /* @__PURE__ */ u.jsx(B, { color: "red", variant: "body-sm-bold", children: _.promoPrice })
            ] })
          ] }) : _.yourPrice && (S = e.variant === "bob" ? /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-1", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-wrap items-baseline gap-1", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.standardDealerPrice }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: _.dealerListPrice })
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-wrap items-baseline gap-1", children: [
              /* @__PURE__ */ u.jsxs(B, { variant: "body-sm", children: [
                e.microcopies.yourPrice,
                ":"
              ] }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: _.yourPrice }),
              _.isNetPrice && /* @__PURE__ */ u.jsx(
                La,
                {
                  text: e.microcopies.tagNetPrice,
                  variant: "default"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-wrap items-baseline gap-1", children: [
            /* @__PURE__ */ u.jsxs(B, { variant: "body-sm", children: [
              e.microcopies.yourPrice,
              ":"
            ] }),
            /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: _.yourPrice })
          ] })), /* @__PURE__ */ u.jsxs(
            "section",
            {
              className: J(
                "mb-2 flex flex-col",
                b !== e.variants.length - 1 && "rounded border-b",
                // Apply border color based on notification type
                _.notification?.type === "warning" && "border border-orange-500",
                _.notification?.type === "alert" && "border border-red-600",
                !_.notification && "border-neutral-200"
              ),
              children: [
                _.notification && /* @__PURE__ */ u.jsx(
                  wQ,
                  {
                    notification: _.notification,
                    onDismiss: () => {
                      _.notification?.type === "alert" ? _.isReviewOnly ? _.onDismissNotification?.() : _.onDelete?.() : _.onDismissNotification?.();
                    }
                  }
                ),
                /* @__PURE__ */ u.jsxs(
                  "div",
                  {
                    className: J(
                      "flex flex-col gap-3 p-4 md:grid md:items-center md:gap-6",
                      r ? "md:grid-cols-[1fr_2fr_auto_auto]" : "md:grid-cols-[2fr_2fr_1fr_2fr_1.5fr]",
                      _.notification?.type === "alert" && "opacity-50"
                    ),
                    children: [
                      /* @__PURE__ */ u.jsxs("div", { className: "flex gap-4 py-2 md:hidden", children: [
                        e.onVariantClick ? /* @__PURE__ */ u.jsx(
                          ve,
                          {
                            className: J("size-16 shrink-0 p-0"),
                            onClick: () => e.onVariantClick?.(e.productCode, _.id),
                            unstyled: !0,
                            children: tl(_)
                          }
                        ) : /* @__PURE__ */ u.jsx("div", { className: "size-16 shrink-0", children: tl(_) }),
                        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
                          /* @__PURE__ */ u.jsx("div", { className: "flex items-start gap-1.5", children: e.onVariantClick ? /* @__PURE__ */ u.jsx(
                            ve,
                            {
                              className: J(
                                "flex flex-1 flex-col items-start gap-1 p-0 text-left"
                              ),
                              onClick: () => e.onVariantClick?.(
                                e.productCode,
                                _.id
                              ),
                              variant: "ghost",
                              children: nl(
                                _,
                                S,
                                !0,
                                e.microcopies
                              )
                            }
                          ) : /* @__PURE__ */ u.jsx("div", { className: "flex flex-1 flex-col gap-1", children: nl(
                            _,
                            S,
                            !0,
                            e.microcopies
                          ) }) }),
                          /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between gap-8", children: [
                            /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: _.size }),
                            /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-2.5", children: FA(
                              _,
                              "mobile",
                              r,
                              O,
                              e.microcopies,
                              qA,
                              (P) => n(P),
                              e.country,
                              m,
                              g
                            ) })
                          ] }),
                          r && /* @__PURE__ */ u.jsx("div", { className: "flex justify-end", children: zA(_) }),
                          /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-end gap-4", children: [
                            /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: _.totalPrice }),
                            E && /* @__PURE__ */ u.jsx(
                              ve,
                              {
                                "aria-label": e.microcopies.deleteButton,
                                onClick: () => w(_.id),
                                size: "icon",
                                variant: "ghost",
                                children: /* @__PURE__ */ u.jsx(hl, { className: "size-5" })
                              }
                            )
                          ] })
                        ] })
                      ] }),
                      e.onVariantClick ? /* @__PURE__ */ u.jsx("div", { className: "items-left hidden gap-8 md:flex", children: /* @__PURE__ */ u.jsxs(
                        ve,
                        {
                          className: J(
                            "flex cursor-pointer justify-start gap-8 text-left no-underline hover:no-underline"
                          ),
                          onClick: (P) => {
                            P.preventDefault(), e.onVariantClick?.(e.productCode, _.id);
                          },
                          unstyled: !0,
                          variant: "link",
                          children: [
                            /* @__PURE__ */ u.jsx("div", { className: "size-10 shrink-0", children: tl(_) }),
                            /* @__PURE__ */ u.jsx("div", { className: "flex flex-col justify-center gap-1", children: nl(
                              _,
                              S,
                              r,
                              e.microcopies
                            ) })
                          ]
                        }
                      ) }) : /* @__PURE__ */ u.jsxs("div", { className: "hidden gap-3 md:flex", children: [
                        /* @__PURE__ */ u.jsx("div", { className: "size-20 shrink-0", children: tl(_) }),
                        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col justify-center gap-1", children: nl(
                          _,
                          S,
                          r,
                          e.microcopies
                        ) })
                      ] }),
                      !r && /* @__PURE__ */ u.jsx("div", { className: "hidden items-center justify-center md:flex", children: S }),
                      !r && /* @__PURE__ */ u.jsx("div", { className: "hidden flex-col items-center justify-center gap-0.5 md:flex" }),
                      /* @__PURE__ */ u.jsxs("div", { className: "hidden items-center gap-8 md:flex", children: [
                        /* @__PURE__ */ u.jsx("span", { className: "w-8 shrink-0", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: _.size }) }),
                        FA(
                          _,
                          "desktop",
                          r,
                          O,
                          e.microcopies,
                          qA,
                          (P) => n(P),
                          e.country,
                          m,
                          g
                        )
                      ] }),
                      r && /* @__PURE__ */ u.jsx("div", { className: "hidden items-center justify-center md:flex", children: zA(_) }),
                      /* @__PURE__ */ u.jsxs("div", { className: "hidden items-center justify-end gap-1 md:flex", children: [
                        /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: _.totalPrice }),
                        E && /* @__PURE__ */ u.jsx(
                          ve,
                          {
                            "aria-label": e.microcopies.deleteButton,
                            onClick: () => w(_.id),
                            size: "icon",
                            variant: "ghost",
                            children: /* @__PURE__ */ u.jsx(hl, { className: "size-5" })
                          }
                        )
                      ] })
                    ]
                  }
                )
              ]
            },
            _.id
          );
        }) }),
        !e.readOnly && s && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: J("flex justify-end border-t p-4", "border-neutral-200"),
            children: /* @__PURE__ */ u.jsxs(
              ve,
              {
                "aria-busy": e.isUpdating,
                disabled: e.isUpdating || !e.hasQuantityChanges,
                onClick: () => {
                  const _ = e.variants.filter((b) => !b.isReviewOnly).map((b) => {
                    const S = r && b.quantityEntries && b.quantityEntries.length > 0 ? GI(b.quantityEntries) : b.quantity;
                    return {
                      ...b,
                      quantity: S
                    };
                  });
                  e.onUpdateQuantities?.(_);
                },
                variant: e.isUpdating ? "secondary" : "default",
                children: [
                  /* @__PURE__ */ u.jsx(
                    S2,
                    {
                      className: J("size-4", e.isUpdating ? "animate-spin" : "")
                    }
                  ),
                  e.microcopies.updateQuantities
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ u.jsx(
          vc,
          {
            isLoading: a.isDeletingAll,
            isOpen: a.showDeleteAllModal,
            isPrimaryButtonDisabled: a.isDeletingAll,
            onClose: () => p({ showDeleteAllModal: !1 }),
            onPrimaryAction: () => {
              y();
            },
            onSecondaryAction: x,
            primaryButtonText: e.microcopies.confirmDelete,
            secondaryButtonText: e.microcopies.cancel,
            title: e.microcopies.deleteVariantConfirmTitle || "",
            children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.deleteVariantConfirmMessage || "" })
          }
        )
      ]
    }
  );
}
function nue(e) {
  return /* @__PURE__ */ u.jsxs("div", { className: `flex flex-col gap-1 ${e.className || ""}`, children: [
    /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: e.microcopies.title }),
    /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.articleCount })
  ] });
}
const ZI = 6048e5, _Q = 864e5, VA = Symbol.for("constructDateFrom");
function Et(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && VA in e ? e[VA](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Je(e, t) {
  return Et(t || e, e);
}
function XI(e, t, n) {
  const r = Je(e, n?.in);
  return isNaN(t) ? Et(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function QI(e, t, n) {
  const r = Je(e, n?.in);
  if (isNaN(t)) return Et(e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), a = Et(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const o = a.getDate();
  return i >= o ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), r);
}
let SQ = {};
function pc() {
  return SQ;
}
function fo(e, t) {
  const n = pc(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Je(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function Qs(e, t) {
  return fo(e, { ...t, weekStartsOn: 1 });
}
function JI(e, t) {
  const n = Je(e, t?.in), r = n.getFullYear(), i = Et(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Qs(i), o = Et(n, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const s = Qs(o);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function WA(e) {
  const t = Je(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Po(e, ...t) {
  const n = Et.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function ho(e, t) {
  const n = Je(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function eD(e, t, n) {
  const [r, i] = Po(
    n?.in,
    e,
    t
  ), a = ho(r), o = ho(i), s = +a - WA(a), c = +o - WA(o);
  return Math.round((s - c) / _Q);
}
function OQ(e, t) {
  const n = JI(e, t), r = Et(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Qs(r);
}
function EQ(e, t, n) {
  return XI(e, t * 7, n);
}
function AQ(e, t, n) {
  return QI(e, t * 12, n);
}
function PQ(e, t) {
  let n, r = t?.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = Et.bind(null, i));
    const a = Je(i, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), Et(r, n || NaN);
}
function CQ(e, t) {
  let n, r = t?.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = Et.bind(null, i));
    const a = Je(i, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), Et(r, n || NaN);
}
function jQ(e, t, n) {
  const [r, i] = Po(
    n?.in,
    e,
    t
  );
  return +ho(r) == +ho(i);
}
function tD(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function TQ(e) {
  return !(!tD(e) && typeof e != "number" || isNaN(+Je(e)));
}
function NQ(e, t, n) {
  const [r, i] = Po(
    n?.in,
    e,
    t
  ), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
  return a * 12 + o;
}
function MQ(e, t) {
  const n = Je(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function nD(e, t) {
  const [n, r] = Po(e, t.start, t.end);
  return { start: n, end: r };
}
function IQ(e, t) {
  const { start: n, end: r } = nD(t?.in, e);
  let i = +n > +r;
  const a = i ? +n : +r, o = i ? r : n;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let s = 1;
  const c = [];
  for (; +o <= a; )
    c.push(Et(n, o)), o.setMonth(o.getMonth() + s);
  return i ? c.reverse() : c;
}
function DQ(e, t) {
  const n = Je(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function kQ(e, t) {
  const n = Je(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function rD(e, t) {
  const n = Je(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function RQ(e, t) {
  const { start: n, end: r } = nD(t?.in, e);
  let i = +n > +r;
  const a = i ? +n : +r, o = i ? r : n;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let s = 1;
  const c = [];
  for (; +o <= a; )
    c.push(Et(n, o)), o.setFullYear(o.getFullYear() + s);
  return i ? c.reverse() : c;
}
function iD(e, t) {
  const n = pc(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Je(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
function LQ(e, t) {
  return iD(e, { ...t, weekStartsOn: 1 });
}
const $Q = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, BQ = (e, t, n) => {
  let r;
  const i = $Q[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function yp(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const FQ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, zQ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, qQ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, VQ = {
  date: yp({
    formats: FQ,
    defaultWidth: "full"
  }),
  time: yp({
    formats: zQ,
    defaultWidth: "full"
  }),
  dateTime: yp({
    formats: qQ,
    defaultWidth: "full"
  })
}, WQ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, UQ = (e, t, n, r) => WQ[e];
function qo(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : o;
      i = e.formattingValues[s] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[o];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const HQ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, YQ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, KQ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, GQ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ZQ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, XQ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, QQ = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, JQ = {
  ordinalNumber: QQ,
  era: qo({
    values: HQ,
    defaultWidth: "wide"
  }),
  quarter: qo({
    values: YQ,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: qo({
    values: KQ,
    defaultWidth: "wide"
  }),
  day: qo({
    values: GQ,
    defaultWidth: "wide"
  }),
  dayPeriod: qo({
    values: ZQ,
    defaultWidth: "wide",
    formattingValues: XQ,
    defaultFormattingWidth: "wide"
  })
};
function Vo(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? tJ(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      eJ(s, (f) => f.test(o))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(l)
    ) : l;
    const d = t.slice(o.length);
    return { value: l, rest: d };
  };
}
function eJ(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function tJ(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function nJ(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = t.slice(i.length);
    return { value: o, rest: s };
  };
}
const rJ = /^(\d+)(th|st|nd|rd)?/i, iJ = /\d+/i, aJ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oJ = {
  any: [/^b/i, /^(a|c)/i]
}, sJ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, cJ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, lJ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, uJ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, dJ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, fJ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, hJ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mJ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vJ = {
  ordinalNumber: nJ({
    matchPattern: rJ,
    parsePattern: iJ,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Vo({
    matchPatterns: aJ,
    defaultMatchWidth: "wide",
    parsePatterns: oJ,
    defaultParseWidth: "any"
  }),
  quarter: Vo({
    matchPatterns: sJ,
    defaultMatchWidth: "wide",
    parsePatterns: cJ,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Vo({
    matchPatterns: lJ,
    defaultMatchWidth: "wide",
    parsePatterns: uJ,
    defaultParseWidth: "any"
  }),
  day: Vo({
    matchPatterns: dJ,
    defaultMatchWidth: "wide",
    parsePatterns: fJ,
    defaultParseWidth: "any"
  }),
  dayPeriod: Vo({
    matchPatterns: hJ,
    defaultMatchWidth: "any",
    parsePatterns: mJ,
    defaultParseWidth: "any"
  })
}, Cx = {
  code: "en-US",
  formatDistance: BQ,
  formatLong: VQ,
  formatRelative: UQ,
  localize: JQ,
  match: vJ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function pJ(e, t) {
  const n = Je(e, t?.in);
  return eD(n, rD(n)) + 1;
}
function aD(e, t) {
  const n = Je(e, t?.in), r = +Qs(n) - +OQ(n);
  return Math.round(r / ZI) + 1;
}
function oD(e, t) {
  const n = Je(e, t?.in), r = n.getFullYear(), i = pc(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = Et(t?.in || e, 0);
  o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = fo(o, t), c = Et(t?.in || e, 0);
  c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
  const l = fo(c, t);
  return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
function gJ(e, t) {
  const n = pc(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = oD(e, t), a = Et(t?.in || e, 0);
  return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), fo(a, t);
}
function sD(e, t) {
  const n = Je(e, t?.in), r = +fo(n, t) - +gJ(n, t);
  return Math.round(r / ZI) + 1;
}
function Ze(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Gr = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ze(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ze(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ze(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ze(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ze(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ze(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ze(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ze(i, t.length);
  }
}, ga = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, UA = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Gr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = oD(e, r), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const o = a % 100;
      return Ze(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Ze(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = JI(e);
    return Ze(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ze(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Ze(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Ze(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Gr.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ze(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = sD(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : Ze(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = aD(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ze(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Gr.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = pJ(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ze(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return Ze(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return Ze(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return Ze(i, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = ga.noon : r === 0 ? i = ga.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = ga.evening : r >= 12 ? i = ga.afternoon : r >= 4 ? i = ga.morning : i = ga.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Gr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Gr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ze(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ze(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Gr.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Gr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Gr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return YA(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ai(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Ai(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return YA(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ai(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Ai(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + HA(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Ai(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + HA(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Ai(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Ze(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Ze(+e, t.length);
  }
};
function HA(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(i) : n + String(i) + t + Ze(a, 2);
}
function YA(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ze(Math.abs(e) / 60, 2) : Ai(e, t);
}
function Ai(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Ze(Math.trunc(r / 60), 2), a = Ze(r % 60, 2);
  return n + i + t + a;
}
const KA = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, cD = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, yJ = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return KA(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", KA(r, t)).replace("{{time}}", cD(i, t));
}, bJ = {
  p: cD,
  P: yJ
}, xJ = /^D+$/, wJ = /^Y+$/, _J = ["D", "DD", "YY", "YYYY"];
function SJ(e) {
  return xJ.test(e);
}
function OJ(e) {
  return wJ.test(e);
}
function EJ(e, t, n) {
  const r = AJ(e, t, n);
  if (console.warn(r), _J.includes(e)) throw new RangeError(r);
}
function AJ(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const PJ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, CJ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jJ = /^'([^]*?)'?$/, TJ = /''/g, NJ = /[a-zA-Z]/;
function MJ(e, t, n) {
  const r = pc(), i = n?.locale ?? r.locale ?? Cx, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Je(e, n?.in);
  if (!TQ(s))
    throw new RangeError("Invalid time value");
  let c = t.match(CJ).map((d) => {
    const f = d[0];
    if (f === "p" || f === "P") {
      const h = bJ[f];
      return h(d, i.formatLong);
    }
    return d;
  }).join("").match(PJ).map((d) => {
    if (d === "''")
      return { isToken: !1, value: "'" };
    const f = d[0];
    if (f === "'")
      return { isToken: !1, value: IJ(d) };
    if (UA[f])
      return { isToken: !0, value: d };
    if (f.match(NJ))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: d };
  });
  i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  };
  return c.map((d) => {
    if (!d.isToken) return d.value;
    const f = d.value;
    (!n?.useAdditionalWeekYearTokens && OJ(f) || !n?.useAdditionalDayOfYearTokens && SJ(f)) && EJ(f, t, String(e));
    const h = UA[f[0]];
    return h(s, f, i.localize, l);
  }).join("");
}
function IJ(e) {
  const t = e.match(jJ);
  return t ? t[1].replace(TJ, "'") : e;
}
function DJ(e, t) {
  const n = Je(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = Et(n, 0);
  return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function kJ(e, t) {
  return Je(e, t?.in).getMonth();
}
function RJ(e, t) {
  return Je(e, t?.in).getFullYear();
}
function LJ(e, t) {
  return +Je(e) > +Je(t);
}
function $J(e, t) {
  return +Je(e) < +Je(t);
}
function BJ(e, t, n) {
  const [r, i] = Po(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function FJ(e, t, n) {
  const [r, i] = Po(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function zJ(e, t, n) {
  const r = Je(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = Et(e, 0);
  o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
  const s = DJ(o);
  return r.setMonth(t, Math.min(a, s)), r;
}
function qJ(e, t, n) {
  const r = Je(e, n?.in);
  return isNaN(+r) ? Et(e, NaN) : (r.setFullYear(t), r);
}
function VJ(e) {
  return ho(Date.now(), e);
}
function WJ(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const UJ = {}, Xo = {};
function Di(e, t) {
  try {
    const r = (UJ[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in Xo ? Xo[r] : GA(r, r.split(":"));
  } catch {
    if (e in Xo) return Xo[e];
    const n = e?.match(HJ);
    return n ? GA(e, n.slice(1)) : NaN;
  }
}
const HJ = /([+-]\d\d):?(\d\d)?/;
function GA(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), i = +(t[2] || 0) / 60;
  return Xo[e] = n * 60 + r > 0 ? n * 60 + r + i : n * 60 - r - i;
}
class sr extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Di(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), lD(this), Py(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new sr(...n, t) : new sr(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new sr(+this, t);
  }
  getTimezoneOffset() {
    const t = -Di(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Py(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new sr(+new Date(t), this.timeZone);
  }
  //#endregion
}
const ZA = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!ZA.test(e)) return;
  const t = e.replace(ZA, "$1UTC");
  sr.prototype[t] && (e.startsWith("get") ? sr.prototype[e] = function() {
    return this.internal[t]();
  } : (sr.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), YJ(this), +this;
  }, sr.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Py(this), +this;
  }));
});
function Py(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-Di(e.timeZone, e) * 60));
}
function YJ(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), lD(e);
}
function lD(e) {
  const t = Di(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), o = i - a, s = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  o && s && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + o);
  const c = i - n;
  c && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + c);
  const l = /* @__PURE__ */ new Date(+e);
  l.setUTCSeconds(0);
  const d = i > 0 ? l.getSeconds() : (l.getSeconds() - 60) % 60, f = Math.round(-(Di(e.timeZone, e) * 60)) % 60;
  (f || d) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + d));
  const h = Di(e.timeZone, e), m = h > 0 ? Math.floor(h) : Math.ceil(h), p = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - m, v = m !== n, y = p - c;
  if (v && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const x = Di(e.timeZone, e), w = x > 0 ? Math.floor(x) : Math.ceil(x), _ = m - w;
    _ && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + _), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + _));
  }
}
class Yt extends sr {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Yt(...n, t) : new Yt(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), i = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, i] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${t} GMT${n}${r}${i} (${WJ(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), i = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(t) {
    return new Yt(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Yt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const XA = 5, KJ = 4;
function GJ(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, i = t.addDays(e, -r + 1), a = t.addDays(i, XA * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? XA : KJ;
}
function uD(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function ZJ(e, t) {
  const n = uD(e, t), r = GJ(e, t);
  return t.addDays(n, r * 7 - 1);
}
class xn {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? Yt.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, i, a) => this.overrides?.newDate ? this.overrides.newDate(r, i, a) : this.options.timeZone ? new Yt(r, i, a, this.options.timeZone) : new Date(r, i, a), this.addDays = (r, i) => this.overrides?.addDays ? this.overrides.addDays(r, i) : XI(r, i), this.addMonths = (r, i) => this.overrides?.addMonths ? this.overrides.addMonths(r, i) : QI(r, i), this.addWeeks = (r, i) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, i) : EQ(r, i), this.addYears = (r, i) => this.overrides?.addYears ? this.overrides.addYears(r, i) : AQ(r, i), this.differenceInCalendarDays = (r, i) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : eD(r, i), this.differenceInCalendarMonths = (r, i) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : NQ(r, i), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : IQ(r), this.eachYearOfInterval = (r) => {
      const i = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : RQ(r), a = new Set(i.map((s) => this.getYear(s)));
      if (a.size === i.length)
        return i;
      const o = [];
      return a.forEach((s) => {
        o.push(new Date(s, 0, 1));
      }), o;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : ZJ(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : LQ(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : MQ(r), this.endOfWeek = (r, i) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, i) : iD(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : kQ(r), this.format = (r, i, a) => {
      const o = this.overrides?.format ? this.overrides.format(r, i, this.options) : MJ(r, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(o) : o;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : aD(r), this.getMonth = (r, i) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : kJ(r, this.options), this.getYear = (r, i) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : RJ(r, this.options), this.getWeek = (r, i) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : sD(r, this.options), this.isAfter = (r, i) => this.overrides?.isAfter ? this.overrides.isAfter(r, i) : LJ(r, i), this.isBefore = (r, i) => this.overrides?.isBefore ? this.overrides.isBefore(r, i) : $J(r, i), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : tD(r), this.isSameDay = (r, i) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, i) : jQ(r, i), this.isSameMonth = (r, i) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, i) : BJ(r, i), this.isSameYear = (r, i) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, i) : FJ(r, i), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : PQ(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : CQ(r), this.setMonth = (r, i) => this.overrides?.setMonth ? this.overrides.setMonth(r, i) : zJ(r, i), this.setYear = (r, i) => this.overrides?.setYear ? this.overrides.setYear(r, i) : qJ(r, i), this.startOfBroadcastWeek = (r, i) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : uD(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : ho(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Qs(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : DQ(r), this.startOfWeek = (r, i) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : fo(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : rD(r), this.options = { locale: Cx, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let i = 0; i < 10; i++)
      r[i.toString()] = n.format(i);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && xn.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: i } = this.options, a = n?.code;
    if (a && xn.yearFirstLocales.has(a))
      try {
        return new Intl.DateTimeFormat(a, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: i
        }).format(t);
      } catch {
      }
    const o = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, o);
  }
}
xn.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const pr = new xn();
class dD {
  constructor(t, n, r = pr) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class XJ {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class QJ {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function JJ(e) {
  return T.createElement("button", { ...e });
}
function eee(e) {
  return T.createElement("span", { ...e });
}
function tee(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    T.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && T.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && T.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && T.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && T.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function nee(e) {
  const { day: t, modifiers: n, ...r } = e;
  return T.createElement("td", { ...r });
}
function ree(e) {
  const { day: t, modifiers: n, ...r } = e, i = T.useRef(null);
  return T.useEffect(() => {
    n.focused && i.current?.focus();
  }, [n.focused]), T.createElement("button", { ref: i, ...r });
}
var xe;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(xe || (xe = {}));
var ft;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(ft || (ft = {}));
var Hn;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Hn || (Hn = {}));
var hn;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(hn || (hn = {}));
function iee(e) {
  const { options: t, className: n, components: r, classNames: i, ...a } = e, o = [i[xe.Dropdown], n].join(" "), s = t?.find(({ value: c }) => c === a.value);
  return T.createElement(
    "span",
    { "data-disabled": a.disabled, className: i[xe.DropdownRoot] },
    T.createElement(r.Select, { className: o, ...a }, t?.map(({ value: c, label: l, disabled: d }) => T.createElement(r.Option, { key: c, value: c, disabled: d }, l))),
    T.createElement(
      "span",
      { className: i[xe.CaptionLabel], "aria-hidden": !0 },
      s?.label,
      T.createElement(r.Chevron, { orientation: "down", size: 18, className: i[xe.Chevron] })
    )
  );
}
function aee(e) {
  return T.createElement("div", { ...e });
}
function oee(e) {
  return T.createElement("div", { ...e });
}
function see(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return T.createElement("div", { ...r }, e.children);
}
function cee(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return T.createElement("div", { ...r });
}
function lee(e) {
  return T.createElement("table", { ...e });
}
function uee(e) {
  return T.createElement("div", { ...e });
}
const fD = hr(void 0);
function gc() {
  const e = si(fD);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function dee(e) {
  const { components: t } = gc();
  return T.createElement(t.Dropdown, { ...e });
}
function fee(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: i, ...a } = e, { components: o, classNames: s, labels: { labelPrevious: c, labelNext: l } } = gc(), d = ot((h) => {
    i && n?.(h);
  }, [i, n]), f = ot((h) => {
    r && t?.(h);
  }, [r, t]);
  return T.createElement(
    "nav",
    { ...a },
    T.createElement(
      o.PreviousMonthButton,
      { type: "button", className: s[xe.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: f },
      T.createElement(o.Chevron, { disabled: r ? void 0 : !0, className: s[xe.Chevron], orientation: "left" })
    ),
    T.createElement(
      o.NextMonthButton,
      { type: "button", className: s[xe.NextMonthButton], tabIndex: i ? void 0 : -1, "aria-disabled": i ? void 0 : !0, "aria-label": l(i), onClick: d },
      T.createElement(o.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: s[xe.Chevron] })
    )
  );
}
function hee(e) {
  const { components: t } = gc();
  return T.createElement(t.Button, { ...e });
}
function mee(e) {
  return T.createElement("option", { ...e });
}
function vee(e) {
  const { components: t } = gc();
  return T.createElement(t.Button, { ...e });
}
function pee(e) {
  const { rootRef: t, ...n } = e;
  return T.createElement("div", { ...n, ref: t });
}
function gee(e) {
  return T.createElement("select", { ...e });
}
function yee(e) {
  const { week: t, ...n } = e;
  return T.createElement("tr", { ...n });
}
function bee(e) {
  return T.createElement("th", { ...e });
}
function xee(e) {
  return T.createElement(
    "thead",
    { "aria-hidden": !0 },
    T.createElement("tr", { ...e })
  );
}
function wee(e) {
  const { week: t, ...n } = e;
  return T.createElement("th", { ...n });
}
function _ee(e) {
  return T.createElement("th", { ...e });
}
function See(e) {
  return T.createElement("tbody", { ...e });
}
function Oee(e) {
  const { components: t } = gc();
  return T.createElement(t.Dropdown, { ...e });
}
const Eee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: JJ,
  CaptionLabel: eee,
  Chevron: tee,
  Day: nee,
  DayButton: ree,
  Dropdown: iee,
  DropdownNav: aee,
  Footer: oee,
  Month: see,
  MonthCaption: cee,
  MonthGrid: lee,
  Months: uee,
  MonthsDropdown: dee,
  Nav: fee,
  NextMonthButton: hee,
  Option: mee,
  PreviousMonthButton: vee,
  Root: pee,
  Select: gee,
  Week: yee,
  WeekNumber: wee,
  WeekNumberHeader: _ee,
  Weekday: bee,
  Weekdays: xee,
  Weeks: See,
  YearsDropdown: Oee
}, Symbol.toStringTag, { value: "Module" }));
function Pr(e, t, n = !1, r = pr) {
  let { from: i, to: a } = e;
  const { differenceInCalendarDays: o, isSameDay: s } = r;
  return i && a ? (o(a, i) < 0 && ([i, a] = [a, i]), o(t, i) >= (n ? 1 : 0) && o(a, t) >= (n ? 1 : 0)) : !n && a ? s(a, t) : !n && i ? s(i, t) : !1;
}
function hD(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function jx(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function mD(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function vD(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function pD(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function gD(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Cr(e, t, n = pr) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: a, isAfter: o } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return i(e, s);
    if (gD(s, n))
      return s.includes(e);
    if (jx(s))
      return Pr(s, e, !1, n);
    if (pD(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (hD(s)) {
      const c = a(s.before, e), l = a(s.after, e), d = c > 0, f = l < 0;
      return o(s.before, s.after) ? f && d : d || f;
    }
    return mD(s) ? a(e, s.after) > 0 : vD(s) ? a(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function Aee(e, t, n, r, i) {
  const { disabled: a, hidden: o, modifiers: s, showOutsideDays: c, broadcastCalendar: l, today: d } = t, { isSameDay: f, isSameMonth: h, startOfMonth: m, isBefore: g, endOfMonth: p, isAfter: v } = i, y = n && m(n), x = r && p(r), w = {
    [ft.focused]: [],
    [ft.outside]: [],
    [ft.disabled]: [],
    [ft.hidden]: [],
    [ft.today]: []
  }, _ = {};
  for (const b of e) {
    const { date: S, displayMonth: O } = b, E = !!(O && !h(S, O)), P = !!(y && g(S, y)), R = !!(x && v(S, x)), j = !!(a && Cr(S, a, i)), C = !!(o && Cr(S, o, i)) || P || R || // Broadcast calendar will show outside days as default
    !l && !c && E || l && c === !1 && E, N = f(S, d ?? i.today());
    E && w.outside.push(b), j && w.disabled.push(b), C && w.hidden.push(b), N && w.today.push(b), s && Object.keys(s).forEach((k) => {
      const I = s?.[k];
      I && Cr(S, I, i) && (_[k] ? _[k].push(b) : _[k] = [b]);
    });
  }
  return (b) => {
    const S = {
      [ft.focused]: !1,
      [ft.disabled]: !1,
      [ft.hidden]: !1,
      [ft.outside]: !1,
      [ft.today]: !1
    }, O = {};
    for (const E in w) {
      const P = w[E];
      S[E] = P.some((R) => R === b);
    }
    for (const E in _)
      O[E] = _[E].some((P) => P === b);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...O
    };
  };
}
function Pee(e, t, n = {}) {
  return Object.entries(e).filter(([, i]) => i === !0).reduce((i, [a]) => (n[a] ? i.push(n[a]) : t[ft[a]] ? i.push(t[ft[a]]) : t[Hn[a]] && i.push(t[Hn[a]]), i), [t[xe.Day]]);
}
function Cee(e) {
  return {
    ...Eee,
    ...e
  };
}
function jee(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function Tx() {
  const e = {};
  for (const t in xe)
    e[xe[t]] = `rdp-${xe[t]}`;
  for (const t in ft)
    e[ft[t]] = `rdp-${ft[t]}`;
  for (const t in Hn)
    e[Hn[t]] = `rdp-${Hn[t]}`;
  for (const t in hn)
    e[hn[t]] = `rdp-${hn[t]}`;
  return e;
}
function yD(e, t, n) {
  return (n ?? new xn(t)).formatMonthYear(e);
}
const Tee = yD;
function Nee(e, t, n) {
  return (n ?? new xn(t)).format(e, "d");
}
function Mee(e, t = pr) {
  return t.format(e, "LLLL");
}
function Iee(e, t, n) {
  return (n ?? new xn(t)).format(e, "cccccc");
}
function Dee(e, t = pr) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function kee() {
  return "";
}
function bD(e, t = pr) {
  return t.format(e, "yyyy");
}
const Ree = bD, Lee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: yD,
  formatDay: Nee,
  formatMonthCaption: Tee,
  formatMonthDropdown: Mee,
  formatWeekNumber: Dee,
  formatWeekNumberHeader: kee,
  formatWeekdayName: Iee,
  formatYearCaption: Ree,
  formatYearDropdown: bD
}, Symbol.toStringTag, { value: "Module" }));
function $ee(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Lee,
    ...e
  };
}
function Bee(e, t, n, r, i) {
  const { startOfMonth: a, startOfYear: o, endOfYear: s, eachMonthOfInterval: c, getMonth: l } = i;
  return c({
    start: o(e),
    end: s(e)
  }).map((h) => {
    const m = r.formatMonthDropdown(h, i), g = l(h), p = t && h < a(t) || n && h > a(n) || !1;
    return { value: g, label: m, disabled: p };
  });
}
function Fee(e, t = {}, n = {}) {
  let r = { ...t?.[xe.Day] };
  return Object.entries(e).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n?.[i]
    };
  }), r;
}
function zee(e, t, n) {
  const r = e.today(), i = t ? e.startOfISOWeek(r) : e.startOfWeek(r), a = [];
  for (let o = 0; o < 7; o++) {
    const s = e.addDays(i, o);
    a.push(s);
  }
  return a;
}
function qee(e, t, n, r, i = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: o, eachYearOfInterval: s, getYear: c } = r, l = a(e), d = o(t), f = s({ start: l, end: d });
  return i && f.reverse(), f.map((h) => {
    const m = n.formatYearDropdown(h, r);
    return {
      value: c(h),
      label: m,
      disabled: !1
    };
  });
}
function xD(e, t, n, r) {
  let i = (r ?? new xn(n)).format(e, "PPPP");
  return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
const Vee = xD;
function wD(e, t, n) {
  return (n ?? new xn(t)).formatMonthYear(e);
}
const Wee = wD;
function Uee(e, t, n, r) {
  let i = (r ?? new xn(n)).format(e, "PPPP");
  return t?.today && (i = `Today, ${i}`), i;
}
function Hee(e) {
  return "Choose the Month";
}
function Yee() {
  return "";
}
function Kee(e) {
  return "Go to the Next Month";
}
function Gee(e) {
  return "Go to the Previous Month";
}
function Zee(e, t, n) {
  return (n ?? new xn(t)).format(e, "cccc");
}
function Xee(e, t) {
  return `Week ${e}`;
}
function Qee(e) {
  return "Week Number";
}
function Jee(e) {
  return "Choose the Year";
}
const ete = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Wee,
  labelDay: Vee,
  labelDayButton: xD,
  labelGrid: wD,
  labelGridcell: Uee,
  labelMonthDropdown: Hee,
  labelNav: Yee,
  labelNext: Kee,
  labelPrevious: Gee,
  labelWeekNumber: Xee,
  labelWeekNumberHeader: Qee,
  labelWeekday: Zee,
  labelYearDropdown: Jee
}, Symbol.toStringTag, { value: "Module" })), yc = (e) => e instanceof HTMLElement ? e : null, bp = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], tte = (e) => yc(e.querySelector("[data-animated-month]")), xp = (e) => yc(e.querySelector("[data-animated-caption]")), wp = (e) => yc(e.querySelector("[data-animated-weeks]")), nte = (e) => yc(e.querySelector("[data-animated-nav]")), rte = (e) => yc(e.querySelector("[data-animated-weekdays]"));
function ite(e, t, { classNames: n, months: r, focused: i, dateLib: a }) {
  const o = Le(null), s = Le(r), c = Le(!1);
  Ky(() => {
    const l = s.current;
    if (s.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || l.length === 0 || r.length !== l.length)
      return;
    const d = a.isSameMonth(r[0].date, l[0].date), f = a.isAfter(r[0].date, l[0].date), h = f ? n[hn.caption_after_enter] : n[hn.caption_before_enter], m = f ? n[hn.weeks_after_enter] : n[hn.weeks_before_enter], g = o.current, p = e.current.cloneNode(!0);
    if (p instanceof HTMLElement ? (bp(p).forEach((w) => {
      if (!(w instanceof HTMLElement))
        return;
      const _ = tte(w);
      _ && w.contains(_) && w.removeChild(_);
      const b = xp(w);
      b && b.classList.remove(h);
      const S = wp(w);
      S && S.classList.remove(m);
    }), o.current = p) : o.current = null, c.current || d || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    i)
      return;
    const v = g instanceof HTMLElement ? bp(g) : [], y = bp(e.current);
    if (y?.every((x) => x instanceof HTMLElement) && v && v.every((x) => x instanceof HTMLElement)) {
      c.current = !0, e.current.style.isolation = "isolate";
      const x = nte(e.current);
      x && (x.style.zIndex = "1"), y.forEach((w, _) => {
        const b = v[_];
        if (!b)
          return;
        w.style.position = "relative", w.style.overflow = "hidden";
        const S = xp(w);
        S && S.classList.add(h);
        const O = wp(w);
        O && O.classList.add(m);
        const E = () => {
          c.current = !1, e.current && (e.current.style.isolation = ""), x && (x.style.zIndex = ""), S && S.classList.remove(h), O && O.classList.remove(m), w.style.position = "", w.style.overflow = "", w.contains(b) && w.removeChild(b);
        };
        b.style.pointerEvents = "none", b.style.position = "absolute", b.style.overflow = "hidden", b.setAttribute("aria-hidden", "true");
        const P = rte(b);
        P && (P.style.opacity = "0");
        const R = xp(b);
        R && (R.classList.add(f ? n[hn.caption_before_exit] : n[hn.caption_after_exit]), R.addEventListener("animationend", E));
        const j = wp(b);
        j && j.classList.add(f ? n[hn.weeks_before_exit] : n[hn.weeks_after_exit]), w.insertBefore(b, w.firstChild);
      });
    }
  });
}
function ate(e, t, n, r) {
  const i = e[0], a = e[e.length - 1], { ISOWeek: o, fixedWeeks: s, broadcastCalendar: c } = n ?? {}, { addDays: l, differenceInCalendarDays: d, differenceInCalendarMonths: f, endOfBroadcastWeek: h, endOfISOWeek: m, endOfMonth: g, endOfWeek: p, isAfter: v, startOfBroadcastWeek: y, startOfISOWeek: x, startOfWeek: w } = r, _ = c ? y(i, r) : o ? x(i) : w(i), b = c ? h(a) : o ? m(g(a)) : p(g(a)), S = d(b, _), O = f(a, i) + 1, E = [];
  for (let j = 0; j <= S; j++) {
    const C = l(_, j);
    if (t && v(C, t))
      break;
    E.push(C);
  }
  const R = (c ? 35 : 42) * O;
  if (s && E.length < R) {
    const j = R - E.length;
    for (let C = 0; C < j; C++) {
      const N = l(E[E.length - 1], 1);
      E.push(N);
    }
  }
  return E;
}
function ote(e) {
  const t = [];
  return e.reduce((n, r) => {
    const i = r.weeks.reduce((a, o) => a.concat(o.days.slice()), t.slice());
    return n.concat(i.slice());
  }, t.slice());
}
function ste(e, t, n, r) {
  const { numberOfMonths: i = 1 } = n, a = [];
  for (let o = 0; o < i; o++) {
    const s = r.addMonths(e, o);
    if (t && s > t)
      break;
    a.push(s);
  }
  return a;
}
function QA(e, t, n, r) {
  const { month: i, defaultMonth: a, today: o = r.today(), numberOfMonths: s = 1 } = e;
  let c = i || a || o;
  const { differenceInCalendarMonths: l, addMonths: d, startOfMonth: f } = r;
  if (n && l(n, c) < s - 1) {
    const h = -1 * (s - 1);
    c = d(n, h);
  }
  return t && l(c, t) < 0 && (c = t), f(c);
}
function cte(e, t, n, r) {
  const { addDays: i, endOfBroadcastWeek: a, endOfISOWeek: o, endOfMonth: s, endOfWeek: c, getISOWeek: l, getWeek: d, startOfBroadcastWeek: f, startOfISOWeek: h, startOfWeek: m } = r, g = e.reduce((p, v) => {
    const y = n.broadcastCalendar ? f(v, r) : n.ISOWeek ? h(v) : m(v), x = n.broadcastCalendar ? a(v) : n.ISOWeek ? o(s(v)) : c(s(v)), w = t.filter((O) => O >= y && O <= x), _ = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && w.length < _) {
      const O = t.filter((E) => {
        const P = _ - w.length;
        return E > x && E <= i(x, P);
      });
      w.push(...O);
    }
    const b = w.reduce((O, E) => {
      const P = n.ISOWeek ? l(E) : d(E), R = O.find((C) => C.weekNumber === P), j = new dD(E, v, r);
      return R ? R.days.push(j) : O.push(new QJ(P, [j])), O;
    }, []), S = new XJ(v, b);
    return p.push(S), p;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function lte(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: i, startOfDay: a, startOfMonth: o, endOfMonth: s, addYears: c, endOfYear: l, newDate: d, today: f } = t, { fromYear: h, toYear: m, fromMonth: g, toMonth: p } = e;
  !n && g && (n = g), !n && h && (n = t.newDate(h, 0, 1)), !r && p && (r = p), !r && m && (r = d(m, 11, 31));
  const v = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = o(n) : h ? n = d(h, 0, 1) : !n && v && (n = i(c(e.today ?? f(), -100))), r ? r = s(r) : m ? r = d(m, 11, 31) : !r && v && (r = l(e.today ?? f())), [
    n && a(n),
    r && a(r)
  ];
}
function ute(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a = 1 } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a : 1, d = o(e);
  if (!t)
    return s(d, l);
  if (!(c(t, e) < a))
    return s(d, l);
}
function dte(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: c } = r, l = i ? a ?? 1 : 1, d = o(e);
  if (!t)
    return s(d, -l);
  if (!(c(d, t) <= 0))
    return s(d, -l);
}
function fte(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Fd(e, t) {
  const [n, r] = Ee(e);
  return [t === void 0 ? n : t, r];
}
function hte(e, t) {
  const [n, r] = lte(e, t), { startOfMonth: i, endOfMonth: a } = t, o = QA(e, n, r, t), [s, c] = Fd(
    o,
    // initialMonth is always computed from props.month if provided
    e.month ? o : void 0
  );
  St(() => {
    const S = QA(e, n, r, t);
    c(S);
  }, [e.timeZone]);
  const l = ste(s, r, e, t), d = ate(l, e.endMonth ? a(e.endMonth) : void 0, e, t), f = cte(l, d, e, t), h = fte(f), m = ote(f), g = dte(s, n, e, t), p = ute(s, r, e, t), { disableNavigation: v, onMonthChange: y } = e, x = (S) => h.some((O) => O.days.some((E) => E.isEqualTo(S))), w = (S) => {
    if (v)
      return;
    let O = i(S);
    n && O < i(n) && (O = i(n)), r && O > i(r) && (O = i(r)), c(O), y?.(O);
  };
  return {
    months: f,
    weeks: h,
    days: m,
    navStart: n,
    navEnd: r,
    previousMonth: g,
    nextMonth: p,
    goToMonth: w,
    goToDay: (S) => {
      x(S) || w(S.date);
    }
  };
}
var tr;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(tr || (tr = {}));
function JA(e) {
  return !e[ft.disabled] && !e[ft.hidden] && !e[ft.outside];
}
function mte(e, t, n, r) {
  let i, a = -1;
  for (const o of e) {
    const s = t(o);
    JA(s) && (s[ft.focused] && a < tr.FocusedModifier ? (i = o, a = tr.FocusedModifier) : r?.isEqualTo(o) && a < tr.LastFocused ? (i = o, a = tr.LastFocused) : n(o.date) && a < tr.Selected ? (i = o, a = tr.Selected) : s[ft.today] && a < tr.Today && (i = o, a = tr.Today));
  }
  return i || (i = e.find((o) => JA(t(o)))), i;
}
function vte(e, t, n, r, i, a, o) {
  const { ISOWeek: s, broadcastCalendar: c } = a, { addDays: l, addMonths: d, addWeeks: f, addYears: h, endOfBroadcastWeek: m, endOfISOWeek: g, endOfWeek: p, max: v, min: y, startOfBroadcastWeek: x, startOfISOWeek: w, startOfWeek: _ } = o;
  let S = {
    day: l,
    week: f,
    month: d,
    year: h,
    startOfWeek: (O) => c ? x(O, o) : s ? w(O) : _(O),
    endOfWeek: (O) => c ? m(O) : s ? g(O) : p(O)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? S = v([r, S]) : t === "after" && i && (S = y([i, S])), S;
}
function _D(e, t, n, r, i, a, o, s = 0) {
  if (s > 365)
    return;
  const c = vte(e, t, n.date, r, i, a, o), l = !!(a.disabled && Cr(c, a.disabled, o)), d = !!(a.hidden && Cr(c, a.hidden, o)), f = c, h = new dD(c, f, o);
  return !l && !d ? h : _D(e, t, h, r, i, a, o, s + 1);
}
function pte(e, t, n, r, i) {
  const { autoFocus: a } = e, [o, s] = Ee(), c = mte(t.days, n, r || (() => !1), o), [l, d] = Ee(a ? c : void 0);
  return {
    isFocusTarget: (p) => !!c?.isEqualTo(p),
    setFocused: d,
    focused: l,
    blur: () => {
      s(l), d(void 0);
    },
    moveFocus: (p, v) => {
      if (!l)
        return;
      const y = _D(p, v, l, t.navStart, t.navEnd, e, i);
      y && (e.disableNavigation && !t.days.some((w) => w.isEqualTo(y)) || (t.goToDay(y), d(y)));
    }
  };
}
function gte(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [a, o] = Fd(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t, l = (m) => s?.some((g) => c(g, m)) ?? !1, { min: d, max: f } = e;
  return {
    selected: s,
    select: (m, g, p) => {
      let v = [...s ?? []];
      if (l(m)) {
        if (s?.length === d || r && s?.length === 1)
          return;
        v = s?.filter((y) => !c(y, m));
      } else
        s?.length === f ? v = [m] : v = [...v, m];
      return i || o(v), i?.(v, m, g, p), v;
    },
    isSelected: l
  };
}
function yte(e, t, n = 0, r = 0, i = !1, a = pr) {
  const { from: o, to: s } = t || {}, { isSameDay: c, isAfter: l, isBefore: d } = a;
  let f;
  if (!o && !s)
    f = { from: e, to: n > 0 ? void 0 : e };
  else if (o && !s)
    c(o, e) ? n === 0 ? f = { from: o, to: e } : i ? f = { from: o, to: void 0 } : f = void 0 : d(e, o) ? f = { from: e, to: o } : f = { from: o, to: e };
  else if (o && s)
    if (c(o, e) && c(s, e))
      i ? f = { from: o, to: s } : f = void 0;
    else if (c(o, e))
      f = { from: o, to: n > 0 ? void 0 : e };
    else if (c(s, e))
      f = { from: e, to: n > 0 ? void 0 : e };
    else if (d(e, o))
      f = { from: e, to: s };
    else if (l(e, o))
      f = { from: o, to: e };
    else if (l(e, s))
      f = { from: o, to: e };
    else
      throw new Error("Invalid range");
  if (f?.from && f?.to) {
    const h = a.differenceInCalendarDays(f.to, f.from);
    r > 0 && h > r ? f = { from: e, to: void 0 } : n > 1 && h < n && (f = { from: e, to: void 0 });
  }
  return f;
}
function bte(e, t, n = pr) {
  const r = Array.isArray(t) ? t : [t];
  let i = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), o = Math.min(a, 6);
  for (let s = 0; s <= o; s++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function eP(e, t, n = pr) {
  return Pr(e, t.from, !1, n) || Pr(e, t.to, !1, n) || Pr(t, e.from, !1, n) || Pr(t, e.to, !1, n);
}
function xte(e, t, n = pr) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? Pr(e, s, !1, n) : gD(s, n) ? s.some((c) => Pr(e, c, !1, n)) : jx(s) ? s.from && s.to ? eP(e, { from: s.from, to: s.to }, n) : !1 : pD(s) ? bte(e, s.dayOfWeek, n) : hD(s) ? n.isAfter(s.before, s.after) ? eP(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Cr(e.from, s, n) || Cr(e.to, s, n) : mD(s) || vD(s) ? Cr(e.from, s, n) || Cr(e.to, s, n) : !1))
    return !0;
  const o = r.filter((s) => typeof s == "function");
  if (o.length) {
    let s = e.from;
    const c = n.differenceInCalendarDays(e.to, e.from);
    for (let l = 0; l <= c; l++) {
      if (o.some((d) => d(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function wte(e, t) {
  const { disabled: n, excludeDisabled: r, selected: i, required: a, onSelect: o } = e, [s, c] = Fd(i, o ? i : void 0), l = o ? i : s;
  return {
    selected: l,
    select: (h, m, g) => {
      const { min: p, max: v } = e, y = h ? yte(h, l, p, v, a, t) : void 0;
      return r && n && y?.from && y.to && xte({ from: y.from, to: y.to }, n, t) && (y.from = h, y.to = void 0), o || c(y), o?.(y, h, m, g), y;
    },
    isSelected: (h) => l && Pr(l, h, !1, t)
  };
}
function _te(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [a, o] = Fd(n, i ? n : void 0), s = i ? n : a, { isSameDay: c } = t;
  return {
    selected: s,
    select: (f, h, m) => {
      let g = f;
      return !r && s && s && c(f, s) && (g = void 0), i || o(g), i?.(g, f, h, m), g;
    },
    isSelected: (f) => s ? c(s, f) : !1
  };
}
function Ste(e, t) {
  const n = _te(e, t), r = gte(e, t), i = wte(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function Ote(e) {
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new Yt(t.today, t.timeZone)), t.month && (t.month = new Yt(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new Yt(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new Yt(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new Yt(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new Yt(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((we) => new Yt(we, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new Yt(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new Yt(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: i, dateLib: a, locale: o, classNames: s } = Tr(() => {
    const we = { ...Cx, ...t.locale };
    return {
      dateLib: new xn({
        locale: we,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: Cee(t.components),
      formatters: $ee(t.formatters),
      labels: { ...ete, ...t.labels },
      locale: we,
      classNames: { ...Tx(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: c, mode: l, navLayout: d, numberOfMonths: f = 1, onDayBlur: h, onDayClick: m, onDayFocus: g, onDayKeyDown: p, onDayMouseEnter: v, onDayMouseLeave: y, onNextClick: x, onPrevClick: w, showWeekNumber: _, styles: b } = t, { formatCaption: S, formatDay: O, formatMonthDropdown: E, formatWeekNumber: P, formatWeekNumberHeader: R, formatWeekdayName: j, formatYearDropdown: C } = r, N = hte(t, a), { days: k, months: I, navStart: $, navEnd: z, previousMonth: V, nextMonth: K, goToMonth: D } = N, U = Aee(k, t, $, z, a), { isSelected: Y, select: X, selected: oe } = Ste(t, a) ?? {}, { blur: ie, focused: he, isFocusTarget: ee, moveFocus: se, setFocused: G } = pte(t, N, U, Y ?? (() => !1), a), { labelDayButton: Q, labelGridcell: ce, labelGrid: F, labelMonthDropdown: ye, labelNav: te, labelPrevious: Ne, labelNext: Te, labelWeekday: Ge, labelWeekNumber: At, labelWeekNumberHeader: en, labelYearDropdown: Rn } = i, tn = Tr(() => zee(a, t.ISOWeek), [a, t.ISOWeek]), Wt = l !== void 0 || m !== void 0, Ln = ot(() => {
    V && (D(V), w?.(V));
  }, [V, D, w]), er = ot(() => {
    K && (D(K), x?.(K));
  }, [D, K, x]), Wr = ot((we, Me) => (Se) => {
    Se.preventDefault(), Se.stopPropagation(), G(we), X?.(we.date, Me, Se), m?.(we.date, Me, Se);
  }, [X, m, G]), yr = ot((we, Me) => (Se) => {
    G(we), g?.(we.date, Me, Se);
  }, [g, G]), L = ot((we, Me) => (Se) => {
    ie(), h?.(we.date, Me, Se);
  }, [ie, h]), q = ot((we, Me) => (Se) => {
    const $e = {
      ArrowLeft: [
        Se.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Se.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Se.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Se.shiftKey ? "year" : "week", "before"],
      PageUp: [Se.shiftKey ? "year" : "month", "before"],
      PageDown: [Se.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if ($e[Se.key]) {
      Se.preventDefault(), Se.stopPropagation();
      const [Lt, De] = $e[Se.key];
      se(Lt, De);
    }
    p?.(we.date, Me, Se);
  }, [se, p, t.dir]), H = ot((we, Me) => (Se) => {
    v?.(we.date, Me, Se);
  }, [v]), ae = ot((we, Me) => (Se) => {
    y?.(we.date, Me, Se);
  }, [y]), ue = ot((we) => (Me) => {
    const Se = Number(Me.target.value), $e = a.setMonth(a.startOfMonth(we), Se);
    D($e);
  }, [a, D]), fe = ot((we) => (Me) => {
    const Se = Number(Me.target.value), $e = a.setYear(a.startOfMonth(we), Se);
    D($e);
  }, [a, D]), { className: le, style: be } = Tr(() => ({
    className: [s[xe.Root], t.className].filter(Boolean).join(" "),
    style: { ...b?.[xe.Root], ...t.style }
  }), [s, t.className, t.style, b]), je = jee(t), tt = Le(null);
  ite(tt, !!t.animate, {
    classNames: s,
    months: I,
    focused: he,
    dateLib: a
  });
  const Rt = {
    dayPickerProps: t,
    selected: oe,
    select: X,
    isSelected: Y,
    months: I,
    nextMonth: K,
    previousMonth: V,
    goToMonth: D,
    getModifiers: U,
    components: n,
    classNames: s,
    styles: b,
    labels: i,
    formatters: r
  };
  return T.createElement(
    fD.Provider,
    { value: Rt },
    T.createElement(
      n.Root,
      { rootRef: t.animate ? tt : void 0, className: le, style: be, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...je },
      T.createElement(
        n.Months,
        { className: s[xe.Months], style: b?.[xe.Months] },
        !t.hideNavigation && !d && T.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[xe.Nav], style: b?.[xe.Nav], "aria-label": te(), onPreviousClick: Ln, onNextClick: er, previousMonth: V, nextMonth: K }),
        I.map((we, Me) => T.createElement(
          n.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: s[xe.Month],
            style: b?.[xe.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Me,
            displayIndex: Me,
            calendarMonth: we
          },
          d === "around" && !t.hideNavigation && Me === 0 && T.createElement(
            n.PreviousMonthButton,
            { type: "button", className: s[xe.PreviousMonthButton], tabIndex: V ? void 0 : -1, "aria-disabled": V ? void 0 : !0, "aria-label": Ne(V), onClick: Ln, "data-animated-button": t.animate ? "true" : void 0 },
            T.createElement(n.Chevron, { disabled: V ? void 0 : !0, className: s[xe.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          T.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: s[xe.MonthCaption], style: b?.[xe.MonthCaption], calendarMonth: we, displayIndex: Me }, c?.startsWith("dropdown") ? T.createElement(
            n.DropdownNav,
            { className: s[xe.Dropdowns], style: b?.[xe.Dropdowns] },
            (() => {
              const Se = c === "dropdown" || c === "dropdown-months" ? T.createElement(n.MonthsDropdown, { key: "month", className: s[xe.MonthsDropdown], "aria-label": ye(), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: ue(we.date), options: Bee(we.date, $, z, r, a), style: b?.[xe.Dropdown], value: a.getMonth(we.date) }) : T.createElement("span", { key: "month" }, E(we.date, a)), $e = c === "dropdown" || c === "dropdown-years" ? T.createElement(n.YearsDropdown, { key: "year", className: s[xe.YearsDropdown], "aria-label": Rn(a.options), classNames: s, components: n, disabled: !!t.disableNavigation, onChange: fe(we.date), options: qee($, z, r, a, !!t.reverseYears), style: b?.[xe.Dropdown], value: a.getYear(we.date) }) : T.createElement("span", { key: "year" }, C(we.date, a));
              return a.getMonthYearOrder() === "year-first" ? [$e, Se] : [Se, $e];
            })(),
            T.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, S(we.date, a.options, a))
          ) : (
            // biome-ignore lint/a11y/useSemanticElements: breaking change
            T.createElement(n.CaptionLabel, { className: s[xe.CaptionLabel], role: "status", "aria-live": "polite" }, S(we.date, a.options, a))
          )),
          d === "around" && !t.hideNavigation && Me === f - 1 && T.createElement(
            n.NextMonthButton,
            { type: "button", className: s[xe.NextMonthButton], tabIndex: K ? void 0 : -1, "aria-disabled": K ? void 0 : !0, "aria-label": Te(K), onClick: er, "data-animated-button": t.animate ? "true" : void 0 },
            T.createElement(n.Chevron, { disabled: K ? void 0 : !0, className: s[xe.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          Me === f - 1 && d === "after" && !t.hideNavigation && T.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: s[xe.Nav], style: b?.[xe.Nav], "aria-label": te(), onPreviousClick: Ln, onNextClick: er, previousMonth: V, nextMonth: K }),
          T.createElement(
            n.MonthGrid,
            { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": F(we.date, a.options, a) || void 0, className: s[xe.MonthGrid], style: b?.[xe.MonthGrid] },
            !t.hideWeekdays && T.createElement(
              n.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: s[xe.Weekdays], style: b?.[xe.Weekdays] },
              _ && T.createElement(n.WeekNumberHeader, { "aria-label": en(a.options), className: s[xe.WeekNumberHeader], style: b?.[xe.WeekNumberHeader], scope: "col" }, R()),
              tn.map((Se) => T.createElement(n.Weekday, { "aria-label": Ge(Se, a.options, a), className: s[xe.Weekday], key: String(Se), style: b?.[xe.Weekday], scope: "col" }, j(Se, a.options, a)))
            ),
            T.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: s[xe.Weeks], style: b?.[xe.Weeks] }, we.weeks.map((Se) => T.createElement(
              n.Week,
              { className: s[xe.Week], key: Se.weekNumber, style: b?.[xe.Week], week: Se },
              _ && // biome-ignore lint/a11y/useSemanticElements: react component
              T.createElement(n.WeekNumber, { week: Se, style: b?.[xe.WeekNumber], "aria-label": At(Se.weekNumber, {
                locale: o
              }), className: s[xe.WeekNumber], scope: "row", role: "rowheader" }, P(Se.weekNumber, a)),
              Se.days.map(($e) => {
                const { date: Lt } = $e, De = U($e);
                if (De[ft.focused] = !De.hidden && !!he?.isEqualTo($e), De[Hn.selected] = Y?.(Lt) || De.selected, jx(oe)) {
                  const { from: gi, to: xr } = oe;
                  De[Hn.range_start] = !!(gi && xr && a.isSameDay(Lt, gi)), De[Hn.range_end] = !!(gi && xr && a.isSameDay(Lt, xr)), De[Hn.range_middle] = Pr(oe, Lt, !0, a);
                }
                const br = Fee(De, b, t.modifiersStyles), Ur = Pee(De, s, t.modifiersClassNames), jo = !Wt && !De.hidden ? ce(Lt, De, a.options, a) : void 0;
                return (
                  // biome-ignore lint/a11y/useSemanticElements: react component
                  T.createElement(n.Day, { key: `${a.format(Lt, "yyyy-MM-dd")}_${a.format($e.displayMonth, "yyyy-MM")}`, day: $e, modifiers: De, className: Ur.join(" "), style: br, role: "gridcell", "aria-selected": De.selected || void 0, "aria-label": jo, "data-day": a.format(Lt, "yyyy-MM-dd"), "data-month": $e.outside ? a.format(Lt, "yyyy-MM") : void 0, "data-selected": De.selected || void 0, "data-disabled": De.disabled || void 0, "data-hidden": De.hidden || void 0, "data-outside": $e.outside || void 0, "data-focused": De.focused || void 0, "data-today": De.today || void 0 }, !De.hidden && Wt ? T.createElement(n.DayButton, { className: s[xe.DayButton], style: b?.[xe.DayButton], type: "button", day: $e, modifiers: De, disabled: De.disabled || void 0, tabIndex: ee($e) ? 0 : -1, "aria-label": Q(Lt, De, a.options, a), onClick: Wr($e, De), onBlur: L($e, De), onFocus: yr($e, De), onKeyDown: q($e, De), onMouseEnter: H($e, De), onMouseLeave: ae($e, De) }, O(Lt, a.options, a)) : !De.hidden && O($e.date, a.options, a))
                );
              })
            )))
          )
        ))
      ),
      t.footer && // biome-ignore lint/a11y/useSemanticElements: react component
      T.createElement(n.Footer, { className: s[xe.Footer], style: b?.[xe.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const Ete = ({
  className: e,
  rootRef: t,
  testId: n,
  ...r
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: Ce(e),
    "data-slot": "calendar",
    "data-testid": n,
    ref: t,
    ...r
  }
), Ate = ({
  className: e,
  orientation: t,
  ...n
}) => t === "left" ? /* @__PURE__ */ u.jsx(NC, { className: Ce("size-4", e), ...n }) : t === "right" ? /* @__PURE__ */ u.jsx(EC, { className: Ce("size-4", e), ...n }) : /* @__PURE__ */ u.jsx(zi, { className: Ce("size-4", e), ...n }), Pte = ({
  children: e,
  ...t
}) => /* @__PURE__ */ u.jsx("td", { ...t, children: /* @__PURE__ */ u.jsx("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: e }) });
function Cte(e) {
  return function(n) {
    return /* @__PURE__ */ u.jsx(Ete, { ...n, testId: e });
  };
}
function jte({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r = "label",
  buttonVariant: i = "ghost",
  formatters: a,
  components: o,
  "data-testid": s,
  ...c
}) {
  const l = A.useMemo(
    () => Cte(s),
    [s]
  ), d = Tx();
  return /* @__PURE__ */ u.jsx(
    Ote,
    {
      captionLayout: r,
      className: Ce(
        "group/calendar bg-background p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      classNames: {
        root: Ce("w-fit", d.root),
        months: Ce(
          "relative flex flex-col gap-4 md:flex-row",
          d.months
        ),
        month: Ce("flex w-full flex-col gap-4", d.month),
        nav: Ce(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          d.nav
        ),
        button_previous: Ce(
          Us({ variant: i }),
          "size-(--cell-size) select-none p-0 aria-disabled:opacity-50",
          d.button_previous
        ),
        button_next: Ce(
          Us({ variant: i }),
          "size-(--cell-size) select-none p-0 aria-disabled:opacity-50",
          d.button_next
        ),
        month_caption: Ce(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          d.month_caption
        ),
        dropdowns: Ce(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 font-medium text-sm",
          d.dropdowns
        ),
        dropdown_root: Ce(
          "relative rounded-md border border-input shadow-xs has-focus:border-ring has-focus:ring-[3px] has-focus:ring-ring/50",
          d.dropdown_root
        ),
        dropdown: Ce(
          "absolute inset-0 bg-popover opacity-0",
          d.dropdown
        ),
        caption_label: Ce(
          "select-none font-medium",
          r === "label" ? "text-sm" : "flex h-8 items-center gap-1 rounded-md pr-1 pl-2 text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          d.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: Ce("flex", d.weekdays),
        weekday: Ce(
          "flex-1 select-none rounded-md font-normal text-[0.8rem] text-muted-foreground",
          d.weekday
        ),
        week: Ce("mt-2 flex w-full", d.week),
        week_number_header: Ce(
          "w-(--cell-size) select-none",
          d.week_number_header
        ),
        week_number: Ce(
          "select-none text-[0.8rem] text-muted-foreground",
          d.week_number
        ),
        day: Ce(
          "group/day relative aspect-square w-(--cell-size) select-none p-0 text-center [&:first-child[data-selected=true]_button]:rounded-l-md [&:last-child[data-selected=true]_button]:rounded-r-md",
          d.day
        ),
        range_start: Ce(
          "rounded-l-md bg-accent",
          d.range_start
        ),
        range_middle: Ce("rounded-none", d.range_middle),
        range_end: Ce("rounded-r-md bg-accent", d.range_end),
        today: Ce(
          "rounded-md bg-accent text-accent-foreground data-[selected=true]:rounded-none",
          d.today
        ),
        outside: Ce(
          "text-muted-foreground aria-selected:text-muted-foreground",
          d.outside
        ),
        disabled: Ce(
          "text-muted-foreground opacity-50",
          d.disabled
        ),
        hidden: Ce("invisible", d.hidden),
        ...t
      },
      components: {
        Root: l,
        Chevron: Ate,
        DayButton: Tte,
        WeekNumber: Pte,
        ...o
      },
      formatters: {
        formatMonthDropdown: (f) => f.toLocaleString("default", { month: "short" }),
        ...a
      },
      showOutsideDays: n,
      ...c
    }
  );
}
function Tte({
  className: e,
  day: t,
  modifiers: n,
  ...r
}) {
  const i = Tx(), a = A.useRef(null);
  A.useEffect(() => {
    n.focused && a.current?.focus();
  }, [n.focused]);
  const { onSelect: o, ...s } = r;
  return /* @__PURE__ */ u.jsx(
    ve,
    {
      className: Ce(
        // Calendar-specific day button styling
        "flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 font-normal leading-none data-[range-end=true]:rounded-md data-[range-middle=true]:rounded-none data-[range-start=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-start=true]:rounded-l-md data-[range-end=true]:bg-primary data-[range-middle=true]:bg-accent data-[range-start=true]:bg-primary data-[selected-single=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:text-accent-foreground data-[range-start=true]:text-primary-foreground data-[selected-single=true]:text-primary-foreground group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 dark:hover:text-accent-foreground [&>span]:text-xs [&>span]:opacity-70",
        i.day,
        e
      ),
      "data-day": t.date.toLocaleDateString(),
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      "data-range-start": n.range_start,
      "data-selected-single": n.selected && !n.range_start && !n.range_end ? !n.range_middle : null,
      onClick: o,
      ref: a,
      size: "icon",
      variant: "ghost",
      ...s
    }
  );
}
const Nte = 2e3, Mte = 11, Ite = 31;
function Dte() {
  const e = new Date(Nte, Mte, Ite), r = new Intl.DateTimeFormat(void 0, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }).formatToParts(e).map((i) => {
    switch (i.type) {
      case "day":
        return "DD";
      case "month":
        return "MM";
      case "year":
        return "YYYY";
      default:
        return i.value;
    }
  }).join("");
  return /* @__PURE__ */ u.jsx("span", { children: r });
}
function kte({
  dateOnly: e,
  options: t = { day: "2-digit", month: "2-digit", year: "numeric" }
}) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(e))
    return /* @__PURE__ */ u.jsx(u.Fragment, { children: "—" });
  const [n, r, i] = e.split("-").map(Number), a = new Date(n, r - 1, i);
  return /* @__PURE__ */ u.jsx("time", { dateTime: e, children: a.toLocaleDateString(void 0, t) });
}
var zd = "Popover", [SD] = wn(zd, [
  Eo
]), bc = Eo(), [Rte, vi] = SD(zd), OD = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !1
  } = e, s = bc(t), c = A.useRef(null), [l, d] = A.useState(!1), [f, h] = In({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: zd
  });
  return /* @__PURE__ */ u.jsx(px, { ...s, children: /* @__PURE__ */ u.jsx(
    Rte,
    {
      scope: t,
      contentId: Nn(),
      triggerRef: c,
      open: f,
      onOpenChange: h,
      onOpenToggle: A.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: A.useCallback(() => d(!0), []),
      onCustomAnchorRemove: A.useCallback(() => d(!1), []),
      modal: o,
      children: n
    }
  ) });
};
OD.displayName = zd;
var ED = "PopoverAnchor", Lte = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vi(ED, n), a = bc(n), { onCustomAnchorAdd: o, onCustomAnchorRemove: s } = i;
    return A.useEffect(() => (o(), () => s()), [o, s]), /* @__PURE__ */ u.jsx(Pd, { ...a, ...r, ref: t });
  }
);
Lte.displayName = ED;
var AD = "PopoverTrigger", PD = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vi(AD, n), a = bc(n), o = ke(t, i.triggerRef), s = /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": MD(i.open),
        ...r,
        ref: o,
        onClick: Oe(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? s : /* @__PURE__ */ u.jsx(Pd, { asChild: !0, ...a, children: s });
  }
);
PD.displayName = AD;
var Nx = "PopoverPortal", [$te, Bte] = SD(Nx, {
  forceMount: void 0
}), CD = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = vi(Nx, t);
  return /* @__PURE__ */ u.jsx($te, { scope: t, forceMount: n, children: /* @__PURE__ */ u.jsx(zr, { present: n || a.open, children: /* @__PURE__ */ u.jsx(gd, { asChild: !0, container: i, children: r }) }) });
};
CD.displayName = Nx;
var mo = "PopoverContent", jD = A.forwardRef(
  (e, t) => {
    const n = Bte(mo, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = vi(mo, e.__scopePopover);
    return /* @__PURE__ */ u.jsx(zr, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u.jsx(zte, { ...i, ref: t }) : /* @__PURE__ */ u.jsx(qte, { ...i, ref: t }) });
  }
);
jD.displayName = mo;
var Fte = Ra("PopoverContent.RemoveScroll"), zte = A.forwardRef(
  (e, t) => {
    const n = vi(mo, e.__scopePopover), r = A.useRef(null), i = ke(t, r), a = A.useRef(!1);
    return A.useEffect(() => {
      const o = r.current;
      if (o) return Jb(o);
    }, []), /* @__PURE__ */ u.jsx(bd, { as: Fte, allowPinchZoom: !0, children: /* @__PURE__ */ u.jsx(
      TD,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oe(e.onCloseAutoFocus, (o) => {
          o.preventDefault(), a.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Oe(
          e.onPointerDownOutside,
          (o) => {
            const s = o.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            a.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Oe(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), qte = A.forwardRef(
  (e, t) => {
    const n = vi(mo, e.__scopePopover), r = A.useRef(!1), i = A.useRef(!1);
    return /* @__PURE__ */ u.jsx(
      TD,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          e.onCloseAutoFocus?.(a), a.defaultPrevented || (r.current || n.triggerRef.current?.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          e.onInteractOutside?.(a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = a.target;
          n.triggerRef.current?.contains(o) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), TD = A.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: o,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: d,
      ...f
    } = e, h = vi(mo, n), m = bc(n);
    return Qb(), /* @__PURE__ */ u.jsx(
      pd,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u.jsx(
          uc,
          {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: d,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ u.jsx(
              gx,
              {
                "data-state": MD(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), ND = "PopoverClose", Vte = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vi(ND, n);
    return /* @__PURE__ */ u.jsx(
      Ae.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Oe(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Vte.displayName = ND;
var Wte = "PopoverArrow", Ute = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = bc(n);
    return /* @__PURE__ */ u.jsx(yx, { ...i, ...r, ref: t });
  }
);
Ute.displayName = Wte;
function MD(e) {
  return e ? "open" : "closed";
}
var Hte = OD, Yte = PD, Kte = CD, ID = jD;
const DD = Hte, kD = Yte, Mx = ({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ref: r,
  ...i
}) => /* @__PURE__ */ u.jsx(Kte, { children: /* @__PURE__ */ u.jsx(
  ID,
  {
    align: t,
    className: Ce(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[90] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ref: r,
    sideOffset: n,
    ...i
  }
) });
Mx.displayName = ID.displayName;
function Gte(e, t) {
  const n = [];
  if (e && n.push({ before: e }), t && n.push({ after: t }), n.length !== 0)
    return n.length === 1 ? n[0] : n;
}
function Zte({
  selectedDate: e,
  onDateChange: t,
  disabled: n,
  className: r,
  fromDate: i,
  toDate: a,
  locale: o,
  "data-testid": s,
  country: c
}) {
  const [l, d] = Ee(!1), f = e ? c ? /* @__PURE__ */ u.jsx("time", { children: Ey(e, c).date }) : /* @__PURE__ */ u.jsx(kte, { dateOnly: Xte(e) }) : null;
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: "relative inline-block w-full",
      "data-testid": s ? `${s}-wrapper` : void 0,
      children: [
        /* @__PURE__ */ u.jsxs(DD, { modal: !0, onOpenChange: d, open: l, children: [
          /* @__PURE__ */ u.jsx(kD, { asChild: !0, children: /* @__PURE__ */ u.jsxs(
            ve,
            {
              className: Ce(
                `justify-between ${r}`,
                e ? "pr-8!" : ""
              ),
              disabled: n,
              variant: "outline-no-hover",
              children: [
                f ?? /* @__PURE__ */ u.jsx(Dte, {}),
                /* @__PURE__ */ u.jsx(
                  qL,
                  {
                    className: "ml-2 h-4 w-4",
                    "data-testid": s ? `${s}-calendar-icon` : void 0
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ u.jsx(Mx, { align: "start", className: "w-auto p-0", children: /* @__PURE__ */ u.jsx(
            jte,
            {
              autoFocus: !0,
              defaultMonth: e ?? i ?? VJ(),
              disabled: Gte(i, a),
              endMonth: a,
              locale: o,
              mode: "single",
              onSelect: (h) => {
                t(h), d(!1);
              },
              selected: e,
              startMonth: i
            }
          ) })
        ] }),
        e ? /* @__PURE__ */ u.jsx(
          ei,
          {
            className: "-translate-y-1/2 absolute top-1/2 right-2 z-10 h-4 w-4 cursor-pointer text-muted-foreground hover:text-[#ef4444]",
            "data-testid": s ? `${s}-clear-icon` : void 0,
            onClick: (h) => {
              h.stopPropagation(), t(void 0);
            }
          }
        ) : null
      ]
    }
  );
}
function Xte(e) {
  if (!(e instanceof Date) || Number.isNaN(e.getTime()))
    return "";
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), r = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${r}`;
}
function rue(e) {
  const t = e.personalReferenceMaxLength ?? 24, [n, r] = Ee(e.orderNote ?? ""), [i, a] = Ee(""), o = (l) => {
    const d = l.target.value;
    r(d), e.onOrderNoteChange?.(d);
  }, s = (l) => {
    const d = l.target.value.slice(0, t);
    a(d), e.onPersonalReferenceChange?.(d);
  }, c = !!(e.onOrderNoteChange || e.onPersonalReferenceChange || e.onDeliveryDateChange);
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: Ce(
        "flex w-full flex-col overflow-hidden rounded-md border border-stone-200 bg-white",
        e.className
      ),
      "data-testid": e["data-testid"],
      children: [
        /* @__PURE__ */ u.jsx("div", { className: "border-stone-200 border-b px-4 py-4", children: /* @__PURE__ */ u.jsx("h2", { className: "font-semibold text-lg text-stone-900 leading-[1.56]", children: e.microcopies.title }) }),
        /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-5 p-5 md:grid-cols-4", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.shippingAddressLabel }),
            /* @__PURE__ */ u.jsx(
              IA,
              {
                addresses: e.shippingAddresses,
                microcopies: {
                  changeAddressButtonLabel: e.microcopies.changeAddressButton,
                  warningTitle: e.microcopies.addressDialogWarningTitle,
                  warningDescription: e.microcopies.addressDialogWarningDescription,
                  dialogTitle: e.microcopies.addressDialogTitle,
                  dialogSubtitle: e.microcopies.addressDialogSubtitle,
                  dialogSubmitButtonLabel: e.microcopies.addressDialogSubmitButtonLabel,
                  dialogErrorMessage: e.microcopies.addressDialogErrorMessage
                },
                onSelectAddress: e.onChangeShippingAddress
              }
            )
          ] }),
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.billingAddressLabel }),
            /* @__PURE__ */ u.jsx(
              IA,
              {
                addresses: e.billingAddresses,
                microcopies: {
                  changeAddressButtonLabel: e.microcopies.changeAddressButton,
                  warningTitle: e.microcopies.addressDialogWarningTitle,
                  warningDescription: e.microcopies.addressDialogWarningDescription,
                  dialogTitle: e.microcopies.addressDialogTitle,
                  dialogSubtitle: e.microcopies.addressDialogSubtitle,
                  dialogSubmitButtonLabel: e.microcopies.addressDialogSubmitButtonLabel,
                  dialogErrorMessage: e.microcopies.addressDialogErrorMessage
                },
                onSelectAddress: e.onChangeBillingAddress,
                shouldShowCTA: !1
              }
            )
          ] }),
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.deliveryOptionsLabel }),
            e.microcopies.deliveryOptionsDescription && /* @__PURE__ */ u.jsx("div", { className: "max-w-[210px]", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.deliveryOptionsDescription }) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-2", children: e.deliveryOptions.map((l) => /* @__PURE__ */ u.jsxs(
              wt,
              {
                className: "flex cursor-pointer items-center gap-2 font-normal",
                htmlFor: `delivery-${l.id}`,
                children: [
                  !e.readonly && /* @__PURE__ */ u.jsx(
                    ni,
                    {
                      checked: e.selectedDeliveryOption === l.id,
                      className: "h-4 w-4 cursor-pointer accent-stone-900 shadow-none outline-none",
                      id: `delivery-${l.id}`,
                      name: "delivery-option",
                      onChange: () => e.onDeliveryOptionChange?.(l.id),
                      type: "radio",
                      value: l.id
                    }
                  ),
                  /* @__PURE__ */ u.jsx("span", { className: "text-sm text-stone-900", children: l.label })
                ]
              },
              l.id
            )) })
          ] }),
          e.paymentMethods && e.paymentMethods.length > 0 ? /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.paymentMethodLabel }),
            e.microcopies.paymentOptionsDescription && /* @__PURE__ */ u.jsx("div", { className: "max-w-[210px]", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.paymentOptionsDescription }) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-2", children: e.paymentMethods.map((l) => /* @__PURE__ */ u.jsxs(
              wt,
              {
                className: "flex cursor-pointer items-center gap-2 font-normal",
                htmlFor: `payment-${l.id}`,
                children: [
                  !e.readonly && /* @__PURE__ */ u.jsx(
                    ni,
                    {
                      checked: e.selectedPaymentMethod === l.id,
                      className: "h-4 w-4 cursor-pointer accent-stone-900 shadow-none outline-none",
                      id: `payment-${l.id}`,
                      name: "payment-method",
                      onChange: () => e.onPaymentMethodChange?.(l.id),
                      type: "radio",
                      value: l.id
                    }
                  ),
                  /* @__PURE__ */ u.jsx("span", { className: "text-sm text-stone-900", children: l.label })
                ]
              },
              l.id
            )) })
          ] }) : null
        ] }),
        c && /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-5 p-5 md:grid-cols-2", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-5 md:flex-row md:gap-10", children: [
            e.onPersonalReferenceChange ? /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
              /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.optionalLabel }),
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
                /* @__PURE__ */ u.jsx(wt, { htmlFor: "personal-reference", children: e.microcopies.personalReferenceLabel }),
                /* @__PURE__ */ u.jsx(
                  ni,
                  {
                    id: "personal-reference",
                    maxLength: t,
                    onChange: s,
                    placeholder: e.microcopies.personalReferencePlaceholder,
                    type: "text",
                    value: i
                  }
                ),
                /* @__PURE__ */ u.jsx(wt, { className: "font-normal text-stone-500 text-xs", children: e.microcopies.characterCounter.replace("{current}", String(i.length)).replace("{max}", String(t)) })
              ] })
            ] }) : null,
            e.onDeliveryDateChange ? /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
              /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.requestedShippingDateLabel }),
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
                /* @__PURE__ */ u.jsx(wt, { htmlFor: "delivery-date", children: e.microcopies.dateLabel }),
                /* @__PURE__ */ u.jsx(
                  Zte,
                  {
                    className: "w-full",
                    country: e.country,
                    "data-testid": e["data-testid"] ? `${e["data-testid"]}-delivery-date` : void 0,
                    fromDate: e.minDeliveryDate,
                    locale: e.locale,
                    onDateChange: e.onDeliveryDateChange,
                    selectedDate: e.requestedDeliveryDate,
                    toDate: e.maxDeliveryDate
                  }
                )
              ] })
            ] }) : null
          ] }),
          e.onOrderNoteChange ? /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(wt, { className: "font-semibold text-base", children: e.microcopies.noteToCustomerServiceLabel }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ u.jsx(
                "textarea",
                {
                  className: "min-h-[100px] w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm shadow-sm outline-none transition-colors placeholder:text-stone-400 focus-visible:border-stone-900 focus-visible:ring-1 focus-visible:ring-stone-900",
                  id: "order-note",
                  maxLength: 255,
                  onChange: o,
                  placeholder: "",
                  value: n
                }
              ),
              /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
                /* @__PURE__ */ u.jsx(wt, { className: "font-normal", variant: "muted", children: e.microcopies.noteToCustomerServiceDescription }),
                /* @__PURE__ */ u.jsx(wt, { className: "font-normal text-stone-500 text-xs", children: e.microcopies.characterCounter.replace("{current}", String(n.length)).replace("{max}", "255") })
              ] })
            ] })
          ] }) : null
        ] })
      ]
    }
  );
}
var jr = (process.env.NODE_ENV, console);
const Qte = 100;
async function Jte(e, t = "download") {
  if (!e) {
    jr.error("No download URL provided for downloadFile");
    return;
  }
  jr.info("Initiating file download", { url: e, filename: t });
  try {
    const n = await fetch(e);
    if (!n.ok)
      throw new Error(
        `Failed to fetch file: ${n.status} ${n.statusText}`
      );
    const r = await n.blob(), i = URL.createObjectURL(r), a = document.createElement("a");
    a.href = i, a.download = t, a.rel = "noopener noreferrer", a.style.display = "none", document.body.appendChild(a), a.click(), a.remove(), setTimeout(() => {
      URL.revokeObjectURL(i);
    }, Qte), jr.info("File download triggered", { url: e, filename: t });
  } catch (n) {
    jr.error("Failed to download file", { url: e, filename: t, error: n });
  }
}
function ene(e) {
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: "flex flex-col items-start gap-2 rounded-lg border border-[#E7E5E4] bg-white p-5",
      children: [
        /* @__PURE__ */ u.jsx("div", { className: "w-full shrink-0 overflow-hidden rounded-[6px] bg-[#FAFAF9]", children: /* @__PURE__ */ u.jsx(
          Xt,
          {
            alt: e.documentImageAltText,
            aspectRatio: "3:4",
            src: e.documentImageSrcLink
          }
        ) }),
        /* @__PURE__ */ u.jsx("div", { className: "flex items-start", children: /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.titleText }) }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex shrink-0 gap-2", children: [
          /* @__PURE__ */ u.jsxs(
            ve,
            {
              "aria-label": `${e.viewButtonText}:${e.titleText}`,
              onClick: e.onViewClick,
              variant: "default",
              children: [
                /* @__PURE__ */ u.jsx(VL, { className: "size-4" }),
                e.viewButtonText
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            ve,
            {
              "aria-label": `${e.downloadButtonText}: ${e.titleText}`,
              onClick: e.onDownloadClick,
              variant: "outline",
              children: [
                /* @__PURE__ */ u.jsx(WL, { className: "size-4" }),
                e.downloadButtonText
              ]
            }
          )
        ] })
      ]
    },
    e.id
  );
}
function iue(e) {
  const t = e.fluid ?? !0, n = /* @__PURE__ */ u.jsxs("section", { className: "flex w-full flex-col items-start gap-5", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-start gap-2.5", children: [
      /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center gap-2 pb-2", children: /* @__PURE__ */ u.jsx(B, { variant: "h2", children: e.heading }) }),
      /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.description })
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4", children: e.documents.map((r) => /* @__PURE__ */ u.jsx(
      ene,
      {
        documentImageAltText: r.image.alt,
        documentImageSrcLink: r.image.src,
        downloadButtonText: r.downloadButton.text,
        id: r.id,
        onDownloadClick: () => {
          Jte(r.downloadButton.href, r.titleText);
        },
        onViewClick: () => {
          window.open(r.viewButton.href, "_blank");
        },
        titleText: r.titleText,
        viewButtonText: r.viewButton.text
      },
      r.id
    )) })
  ] });
  return t ? /* @__PURE__ */ u.jsx(TC, { children: n }) : n;
}
function tne(e) {
  return e.primaryButtonText || e.secondaryButtonText || e.showDeleteButton ? /* @__PURE__ */ u.jsx(ax, { children: /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-center justify-between gap-3 px-2 sm:flex-row sm:items-center", children: [
    e.showDeleteButton ? /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center justify-center sm:w-auto [&>button]:w-full sm:[&>button]:w-auto", children: /* @__PURE__ */ u.jsxs(
      ve,
      {
        disabled: !!e.isLoading,
        onClick: e.onDelete,
        variant: "destructive",
        children: [
          /* @__PURE__ */ u.jsx(UL, { size: "sm" }),
          e.deleteButtonText
        ]
      }
    ) }) : (
      //  to keep the flex layout consistent when the delete button is not shown
      /* @__PURE__ */ u.jsx("div", {})
    ),
    /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row", children: [
      e.secondaryButtonText ? /* @__PURE__ */ u.jsx("div", { className: "w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: !!e.isLoading,
          onClick: e.onSecondaryAction || e.onClose,
          variant: e.secondaryButtonVariant ?? "outline",
          children: e.secondaryButtonText
        }
      ) }) : null,
      e.tertiaryButtonText ? /* @__PURE__ */ u.jsx("div", { className: "w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: !!e.isLoading || !!e.isTertiaryButtonDisabled,
          onClick: e.onTertiaryAction,
          variant: e.tertiaryButtonVariant || "default",
          children: e.tertiaryButtonText
        }
      ) }) : null,
      e.primaryButtonText ? /* @__PURE__ */ u.jsx("div", { className: "relative w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto", children: /* @__PURE__ */ u.jsxs(
        ve,
        {
          ...e.formAttributes ?? {},
          disabled: !!e.isPrimaryButtonDisabled || !!e.isLoading,
          onClick: e.onPrimaryAction,
          type: e.formId ? "submit" : "button",
          variant: "default",
          children: [
            /* @__PURE__ */ u.jsx("span", { className: e.isLoading ? "invisible" : "", children: e.primaryButtonText }),
            e.isLoading ? /* @__PURE__ */ u.jsx("span", { className: "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2", children: /* @__PURE__ */ u.jsx(AC, { className: "animate-spin", size: "md" }) }) : null
          ]
        }
      ) }) : null
    ] })
  ] }) }) : null;
}
function aue(e) {
  const t = (r) => {
    r || e.preventCloseOnOutsideClick || e.onClose();
  }, n = e.formId ? { form: e.formId } : {};
  return /* @__PURE__ */ u.jsx(oo, { onOpenChange: t, open: e.isOpen, children: /* @__PURE__ */ u.jsx(
    Ui,
    {
      className: J(e.modalClassName ?? "max-w-[894px]! p-0"),
      onInteractOutside: (r) => {
        e.preventCloseOnOutsideClick && r.preventDefault();
      },
      children: /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: J(
            "flex max-h-[90vh] flex-col gap-6 overflow-y-auto p-16"
          ),
          children: [
            /* @__PURE__ */ u.jsxs(dc, { children: [
              /* @__PURE__ */ u.jsx(Hi, { className: "font-bold text-4xl", children: e.title }),
              e.subtitle ? /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.subtitle }) : null
            ] }),
            e.generalErrorMessage ? /* @__PURE__ */ u.jsx(
              na,
              {
                microcopies: { title: e.generalErrorMessage },
                variant: "destructive"
              }
            ) : null,
            /* @__PURE__ */ u.jsx("div", { children: e.children }),
            /* @__PURE__ */ u.jsx(
              tne,
              {
                deleteButtonText: e.deleteButtonText,
                formAttributes: n,
                formId: e.formId,
                isLoading: e.isLoading,
                isPrimaryButtonDisabled: e.isPrimaryButtonDisabled,
                isTertiaryButtonDisabled: e.isTertiaryButtonDisabled,
                onClose: e.onClose,
                onDelete: e.onDelete,
                onPrimaryAction: e.onPrimaryAction,
                onSecondaryAction: e.onSecondaryAction,
                onTertiaryAction: e.onTertiaryAction,
                primaryButtonText: e.primaryButtonText,
                secondaryButtonText: e.secondaryButtonText,
                secondaryButtonVariant: e.secondaryButtonVariant,
                showDeleteButton: e.showDeleteButton,
                tertiaryButtonText: e.tertiaryButtonText,
                tertiaryButtonVariant: e.tertiaryButtonVariant
              }
            )
          ]
        }
      )
    }
  ) });
}
var RD = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Qo = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, nne = { 0: String.fromCodePoint(Qo[0]), 1: String.fromCodePoint(Qo[1]), 2: String.fromCodePoint(Qo[2]), 3: String.fromCodePoint(Qo[3]) }, rne = new Array(4).fill(String.fromCodePoint(Qo[0])).join(""), tP = "\0", rl = Object.fromEntries(Object.entries(nne).map((e) => [e[1], +e[0]])), nP = Object.fromEntries(Object.entries(RD).map((e) => e.reverse())), ine = `${Object.values(RD).map((e) => `\\u{${e.toString(16)}}`).join("")}`, ane = new RegExp(`[${ine}]{4,}`, "gu");
function one(e) {
  let t = e.match(ane);
  if (t) return sne(t[0], !0)[0];
}
function sne(e, t = !1) {
  let n = Array.from(e);
  if (n.length % 2 === 0) {
    if (n.length % 4 || !e.startsWith(rne)) return cne(n, t);
  } else throw new Error("Encoded data has invalid length");
  let r = n.slice(4), i = new Uint8Array(r.length / 4);
  for (let o = 0; o < i.length; o++) i[o] = rl[r[o * 4]] << 6 | rl[r[o * 4 + 1]] << 4 | rl[r[o * 4 + 2]] << 2 | rl[r[o * 4 + 3]];
  let a = new TextDecoder().decode(i);
  if (t) {
    let o = a.indexOf(tP);
    return o === -1 && (o = a.length), [JSON.parse(a.slice(0, o))];
  }
  return a.split(tP).filter(Boolean).map((o) => JSON.parse(o));
}
function cne(e, t) {
  var n;
  let r = [];
  for (let s = e.length * 0.5; s--; ) {
    let c = `${nP[e[s * 2].codePointAt(0)]}${nP[e[s * 2 + 1].codePointAt(0)]}`;
    r.unshift(String.fromCharCode(parseInt(c, 16)));
  }
  let i = [], a = [r.join("")], o = 10;
  for (; a.length; ) {
    let s = a.shift();
    try {
      if (i.push(JSON.parse(s)), t) return i;
    } catch (c) {
      if (!o--) throw c;
      let l = +((n = c.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : n[1]);
      if (!l) throw c;
      a.unshift(s.substring(0, l), s.substring(l));
    }
  }
  return i;
}
function lne(e) {
  return one(e);
}
var _p, rP;
function une() {
  if (rP) return _p;
  rP = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString;
  return _p = function(n, r, i) {
    if (t.call(r) !== "[object Function]")
      throw new TypeError("iterator must be a function");
    var a = n.length;
    if (a === +a)
      for (var o = 0; o < a; o++)
        r.call(i, n[o], o, n);
    else
      for (var s in n)
        e.call(n, s) && r.call(i, n[s], s, n);
  }, _p;
}
var Sp, iP;
function dne() {
  if (iP) return Sp;
  iP = 1;
  var e = une();
  Sp = t;
  function t(n, r, i) {
    if (arguments.length === 3)
      return t.set(n, r, i);
    if (arguments.length === 2)
      return t.get(n, r);
    var a = t.bind(t, n);
    for (var o in t)
      t.hasOwnProperty(o) && (a[o] = t[o].bind(a, n));
    return a;
  }
  return t.get = function(n, r) {
    for (var i = Array.isArray(r) ? r : t.parse(r), a = 0; a < i.length; ++a) {
      var o = i[a];
      if (!(typeof n == "object" && o in n))
        throw new Error("Invalid reference token: " + o);
      n = n[o];
    }
    return n;
  }, t.set = function(n, r, i) {
    var a = Array.isArray(r) ? r : t.parse(r), o = a[0];
    if (a.length === 0)
      throw Error("Can not set the root object");
    for (var s = 0; s < a.length - 1; ++s) {
      var c = a[s];
      typeof c != "string" && typeof c != "number" && (c = String(c)), !(c === "__proto__" || c === "constructor" || c === "prototype") && (c === "-" && Array.isArray(n) && (c = n.length), o = a[s + 1], c in n || (o.match(/^(\d+|-)$/) ? n[c] = [] : n[c] = {}), n = n[c]);
    }
    return o === "-" && Array.isArray(n) && (o = n.length), n[o] = i, this;
  }, t.remove = function(n, r) {
    var i = Array.isArray(r) ? r : t.parse(r), a = i[i.length - 1];
    if (a === void 0)
      throw new Error('Invalid JSON pointer for remove: "' + r + '"');
    var o = t.get(n, i.slice(0, -1));
    if (Array.isArray(o)) {
      var s = +a;
      if (a === "" && isNaN(s))
        throw new Error('Invalid array index: "' + a + '"');
      Array.prototype.splice.call(o, s, 1);
    } else
      delete o[a];
  }, t.dict = function(n, r) {
    var i = {};
    return t.walk(n, function(a, o) {
      i[o] = a;
    }, r), i;
  }, t.walk = function(n, r, i) {
    var a = [];
    i = i || function(o) {
      var s = Object.prototype.toString.call(o);
      return s === "[object Object]" || s === "[object Array]";
    }, (function o(s) {
      e(s, function(c, l) {
        a.push(String(l)), i(c) ? o(c) : r(c, t.compile(a)), a.pop();
      });
    })(n);
  }, t.has = function(n, r) {
    try {
      t.get(n, r);
    } catch {
      return !1;
    }
    return !0;
  }, t.escape = function(n) {
    return n.toString().replace(/~/g, "~0").replace(/\//g, "~1");
  }, t.unescape = function(n) {
    return n.replace(/~1/g, "/").replace(/~0/g, "~");
  }, t.parse = function(n) {
    if (n === "")
      return [];
    if (n.charAt(0) !== "/")
      throw new Error("Invalid JSON pointer: " + n);
    return n.substring(1).split(/\//).map(t.unescape);
  }, t.compile = function(n) {
    return n.length === 0 ? "" : "/" + n.map(t.escape).join("/");
  }, Sp;
}
dne();
const fne = [
  "nt_experiences",
  "nt_name",
  "nt_description",
  "nt_audience_id",
  "nt_rules",
  "nt_metadata",
  "nt_experience_id",
  "nt_type",
  "nt_config",
  "nt_audience",
  "nt_variants"
];
fne.map(
  (e) => e.replace(/_([a-z])/g, (t, n) => n.toUpperCase())
);
const hne = "4.9.8", LD = {
  version: hne
};
let $D = !1;
function aP(e) {
  $D = e;
}
const Op = (e) => (...t) => {
  $D && console[e](...t);
}, yn = {
  error: Op("error"),
  warn: Op("warn"),
  log: Op("log")
};
function mne(e, t = 500) {
  let n = window.location.href;
  const r = setInterval(() => {
    const i = window.location.href;
    i !== n && (n = i, e(i));
  }, t);
  return () => clearInterval(r);
}
const vne = "live-preview-editor", pne = "live-preview-sdk", gne = /* @__PURE__ */ new Set([
  "AREA",
  "BASE",
  "BR",
  "COL",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
]);
function rr(e, t, n) {
  const r = {
    ...t,
    method: e,
    source: pne,
    location: window.location.href,
    version: LD.version
  };
  yn.log("Send message", r), n.forEach((i) => {
    window.top?.postMessage(r, i);
  });
}
function yne(e, t = 100) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => {
      e.apply(this, r);
    }, t);
  };
}
function bne() {
  try {
    return window.top?.location.href !== window.location.href;
  } catch {
    return !0;
  }
}
function xne() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function wne(e) {
  return typeof e.data != "object" || !e.data ? !1 : "source" in e.data && e.data.source === vne;
}
var il = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _ne(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gl = { exports: {} };
gl.exports;
var oP;
function Sne() {
  return oP || (oP = 1, (function(e, t) {
    var n = 200, r = "__lodash_hash_undefined__", i = 1, a = 2, o = 9007199254740991, s = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", d = "[object Boolean]", f = "[object Date]", h = "[object Error]", m = "[object Function]", g = "[object GeneratorFunction]", p = "[object Map]", v = "[object Number]", y = "[object Null]", x = "[object Object]", w = "[object Promise]", _ = "[object Proxy]", b = "[object RegExp]", S = "[object Set]", O = "[object String]", E = "[object Symbol]", P = "[object Undefined]", R = "[object WeakMap]", j = "[object ArrayBuffer]", C = "[object DataView]", N = "[object Float32Array]", k = "[object Float64Array]", I = "[object Int8Array]", $ = "[object Int16Array]", z = "[object Int32Array]", V = "[object Uint8Array]", K = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]", Y = /[\\^$.*+?()[\]{}|]/g, X = /^\[object .+?Constructor\]$/, oe = /^(?:0|[1-9]\d*)$/, ie = {};
    ie[N] = ie[k] = ie[I] = ie[$] = ie[z] = ie[V] = ie[K] = ie[D] = ie[U] = !0, ie[s] = ie[c] = ie[j] = ie[d] = ie[C] = ie[f] = ie[h] = ie[m] = ie[p] = ie[v] = ie[x] = ie[b] = ie[S] = ie[O] = ie[R] = !1;
    var he = typeof il == "object" && il && il.Object === Object && il, ee = typeof self == "object" && self && self.Object === Object && self, se = he || ee || Function("return this")(), G = t && !t.nodeType && t, Q = G && !0 && e && !e.nodeType && e, ce = Q && Q.exports === G, F = ce && he.process, ye = (function() {
      try {
        return F && F.binding && F.binding("util");
      } catch {
      }
    })(), te = ye && ye.isTypedArray;
    function Ne(M, W) {
      for (var ne = -1, pe = M == null ? 0 : M.length, it = 0, Ie = []; ++ne < pe; ) {
        var vt = M[ne];
        W(vt, ne, M) && (Ie[it++] = vt);
      }
      return Ie;
    }
    function Te(M, W) {
      for (var ne = -1, pe = W.length, it = M.length; ++ne < pe; )
        M[it + ne] = W[ne];
      return M;
    }
    function Ge(M, W) {
      for (var ne = -1, pe = M == null ? 0 : M.length; ++ne < pe; )
        if (W(M[ne], ne, M))
          return !0;
      return !1;
    }
    function At(M, W) {
      for (var ne = -1, pe = Array(M); ++ne < M; )
        pe[ne] = W(ne);
      return pe;
    }
    function en(M) {
      return function(W) {
        return M(W);
      };
    }
    function Rn(M, W) {
      return M.has(W);
    }
    function tn(M, W) {
      return M?.[W];
    }
    function Wt(M) {
      var W = -1, ne = Array(M.size);
      return M.forEach(function(pe, it) {
        ne[++W] = [it, pe];
      }), ne;
    }
    function Ln(M, W) {
      return function(ne) {
        return M(W(ne));
      };
    }
    function er(M) {
      var W = -1, ne = Array(M.size);
      return M.forEach(function(pe) {
        ne[++W] = pe;
      }), ne;
    }
    var Wr = Array.prototype, yr = Function.prototype, L = Object.prototype, q = se["__core-js_shared__"], H = yr.toString, ae = L.hasOwnProperty, ue = (function() {
      var M = /[^.]+$/.exec(q && q.keys && q.keys.IE_PROTO || "");
      return M ? "Symbol(src)_1." + M : "";
    })(), fe = L.toString, le = RegExp(
      "^" + H.call(ae).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), be = ce ? se.Buffer : void 0, je = se.Symbol, tt = se.Uint8Array, Rt = L.propertyIsEnumerable, we = Wr.splice, Me = je ? je.toStringTag : void 0, Se = Object.getOwnPropertySymbols, $e = be ? be.isBuffer : void 0, Lt = Ln(Object.keys, Object), De = ua(se, "DataView"), br = ua(se, "Map"), Ur = ua(se, "Promise"), jo = ua(se, "Set"), gi = ua(se, "WeakMap"), xr = ua(Object, "create"), WR = xi(De), UR = xi(br), HR = xi(Ur), YR = xi(jo), KR = xi(gi), Qx = je ? je.prototype : void 0, Jd = Qx ? Qx.valueOf : void 0;
    function yi(M) {
      var W = -1, ne = M == null ? 0 : M.length;
      for (this.clear(); ++W < ne; ) {
        var pe = M[W];
        this.set(pe[0], pe[1]);
      }
    }
    function GR() {
      this.__data__ = xr ? xr(null) : {}, this.size = 0;
    }
    function ZR(M) {
      var W = this.has(M) && delete this.__data__[M];
      return this.size -= W ? 1 : 0, W;
    }
    function XR(M) {
      var W = this.__data__;
      if (xr) {
        var ne = W[M];
        return ne === r ? void 0 : ne;
      }
      return ae.call(W, M) ? W[M] : void 0;
    }
    function QR(M) {
      var W = this.__data__;
      return xr ? W[M] !== void 0 : ae.call(W, M);
    }
    function JR(M, W) {
      var ne = this.__data__;
      return this.size += this.has(M) ? 0 : 1, ne[M] = xr && W === void 0 ? r : W, this;
    }
    yi.prototype.clear = GR, yi.prototype.delete = ZR, yi.prototype.get = XR, yi.prototype.has = QR, yi.prototype.set = JR;
    function wr(M) {
      var W = -1, ne = M == null ? 0 : M.length;
      for (this.clear(); ++W < ne; ) {
        var pe = M[W];
        this.set(pe[0], pe[1]);
      }
    }
    function eL() {
      this.__data__ = [], this.size = 0;
    }
    function tL(M) {
      var W = this.__data__, ne = Pc(W, M);
      if (ne < 0)
        return !1;
      var pe = W.length - 1;
      return ne == pe ? W.pop() : we.call(W, ne, 1), --this.size, !0;
    }
    function nL(M) {
      var W = this.__data__, ne = Pc(W, M);
      return ne < 0 ? void 0 : W[ne][1];
    }
    function rL(M) {
      return Pc(this.__data__, M) > -1;
    }
    function iL(M, W) {
      var ne = this.__data__, pe = Pc(ne, M);
      return pe < 0 ? (++this.size, ne.push([M, W])) : ne[pe][1] = W, this;
    }
    wr.prototype.clear = eL, wr.prototype.delete = tL, wr.prototype.get = nL, wr.prototype.has = rL, wr.prototype.set = iL;
    function bi(M) {
      var W = -1, ne = M == null ? 0 : M.length;
      for (this.clear(); ++W < ne; ) {
        var pe = M[W];
        this.set(pe[0], pe[1]);
      }
    }
    function aL() {
      this.size = 0, this.__data__ = {
        hash: new yi(),
        map: new (br || wr)(),
        string: new yi()
      };
    }
    function oL(M) {
      var W = Cc(this, M).delete(M);
      return this.size -= W ? 1 : 0, W;
    }
    function sL(M) {
      return Cc(this, M).get(M);
    }
    function cL(M) {
      return Cc(this, M).has(M);
    }
    function lL(M, W) {
      var ne = Cc(this, M), pe = ne.size;
      return ne.set(M, W), this.size += ne.size == pe ? 0 : 1, this;
    }
    bi.prototype.clear = aL, bi.prototype.delete = oL, bi.prototype.get = sL, bi.prototype.has = cL, bi.prototype.set = lL;
    function Ac(M) {
      var W = -1, ne = M == null ? 0 : M.length;
      for (this.__data__ = new bi(); ++W < ne; )
        this.add(M[W]);
    }
    function uL(M) {
      return this.__data__.set(M, r), this;
    }
    function dL(M) {
      return this.__data__.has(M);
    }
    Ac.prototype.add = Ac.prototype.push = uL, Ac.prototype.has = dL;
    function Hr(M) {
      var W = this.__data__ = new wr(M);
      this.size = W.size;
    }
    function fL() {
      this.__data__ = new wr(), this.size = 0;
    }
    function hL(M) {
      var W = this.__data__, ne = W.delete(M);
      return this.size = W.size, ne;
    }
    function mL(M) {
      return this.__data__.get(M);
    }
    function vL(M) {
      return this.__data__.has(M);
    }
    function pL(M, W) {
      var ne = this.__data__;
      if (ne instanceof wr) {
        var pe = ne.__data__;
        if (!br || pe.length < n - 1)
          return pe.push([M, W]), this.size = ++ne.size, this;
        ne = this.__data__ = new bi(pe);
      }
      return ne.set(M, W), this.size = ne.size, this;
    }
    Hr.prototype.clear = fL, Hr.prototype.delete = hL, Hr.prototype.get = mL, Hr.prototype.has = vL, Hr.prototype.set = pL;
    function gL(M, W) {
      var ne = jc(M), pe = !ne && ML(M), it = !ne && !pe && ef(M), Ie = !ne && !pe && !it && s0(M), vt = ne || pe || it || Ie, Nt = vt ? At(M.length, String) : [], $t = Nt.length;
      for (var dt in M)
        ae.call(M, dt) && !(vt && // Safari 9 has enumerable `arguments.length` in strict mode.
        (dt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        it && (dt == "offset" || dt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Ie && (dt == "buffer" || dt == "byteLength" || dt == "byteOffset") || // Skip index properties.
        PL(dt, $t))) && Nt.push(dt);
      return Nt;
    }
    function Pc(M, W) {
      for (var ne = M.length; ne--; )
        if (r0(M[ne][0], W))
          return ne;
      return -1;
    }
    function yL(M, W, ne) {
      var pe = W(M);
      return jc(M) ? pe : Te(pe, ne(M));
    }
    function To(M) {
      return M == null ? M === void 0 ? P : y : Me && Me in Object(M) ? EL(M) : NL(M);
    }
    function Jx(M) {
      return No(M) && To(M) == s;
    }
    function e0(M, W, ne, pe, it) {
      return M === W ? !0 : M == null || W == null || !No(M) && !No(W) ? M !== M && W !== W : bL(M, W, ne, pe, e0, it);
    }
    function bL(M, W, ne, pe, it, Ie) {
      var vt = jc(M), Nt = jc(W), $t = vt ? c : Yr(M), dt = Nt ? c : Yr(W);
      $t = $t == s ? x : $t, dt = dt == s ? x : dt;
      var cn = $t == x, $n = dt == x, Ut = $t == dt;
      if (Ut && ef(M)) {
        if (!ef(W))
          return !1;
        vt = !0, cn = !1;
      }
      if (Ut && !cn)
        return Ie || (Ie = new Hr()), vt || s0(M) ? t0(M, W, ne, pe, it, Ie) : SL(M, W, $t, ne, pe, it, Ie);
      if (!(ne & i)) {
        var _n = cn && ae.call(M, "__wrapped__"), Sn = $n && ae.call(W, "__wrapped__");
        if (_n || Sn) {
          var Kr = _n ? M.value() : M, _r = Sn ? W.value() : W;
          return Ie || (Ie = new Hr()), it(Kr, _r, ne, pe, Ie);
        }
      }
      return Ut ? (Ie || (Ie = new Hr()), OL(M, W, ne, pe, it, Ie)) : !1;
    }
    function xL(M) {
      if (!o0(M) || jL(M))
        return !1;
      var W = i0(M) ? le : X;
      return W.test(xi(M));
    }
    function wL(M) {
      return No(M) && a0(M.length) && !!ie[To(M)];
    }
    function _L(M) {
      if (!TL(M))
        return Lt(M);
      var W = [];
      for (var ne in Object(M))
        ae.call(M, ne) && ne != "constructor" && W.push(ne);
      return W;
    }
    function t0(M, W, ne, pe, it, Ie) {
      var vt = ne & i, Nt = M.length, $t = W.length;
      if (Nt != $t && !(vt && $t > Nt))
        return !1;
      var dt = Ie.get(M);
      if (dt && Ie.get(W))
        return dt == W;
      var cn = -1, $n = !0, Ut = ne & a ? new Ac() : void 0;
      for (Ie.set(M, W), Ie.set(W, M); ++cn < Nt; ) {
        var _n = M[cn], Sn = W[cn];
        if (pe)
          var Kr = vt ? pe(Sn, _n, cn, W, M, Ie) : pe(_n, Sn, cn, M, W, Ie);
        if (Kr !== void 0) {
          if (Kr)
            continue;
          $n = !1;
          break;
        }
        if (Ut) {
          if (!Ge(W, function(_r, wi) {
            if (!Rn(Ut, wi) && (_n === _r || it(_n, _r, ne, pe, Ie)))
              return Ut.push(wi);
          })) {
            $n = !1;
            break;
          }
        } else if (!(_n === Sn || it(_n, Sn, ne, pe, Ie))) {
          $n = !1;
          break;
        }
      }
      return Ie.delete(M), Ie.delete(W), $n;
    }
    function SL(M, W, ne, pe, it, Ie, vt) {
      switch (ne) {
        case C:
          if (M.byteLength != W.byteLength || M.byteOffset != W.byteOffset)
            return !1;
          M = M.buffer, W = W.buffer;
        case j:
          return !(M.byteLength != W.byteLength || !Ie(new tt(M), new tt(W)));
        case d:
        case f:
        case v:
          return r0(+M, +W);
        case h:
          return M.name == W.name && M.message == W.message;
        case b:
        case O:
          return M == W + "";
        case p:
          var Nt = Wt;
        case S:
          var $t = pe & i;
          if (Nt || (Nt = er), M.size != W.size && !$t)
            return !1;
          var dt = vt.get(M);
          if (dt)
            return dt == W;
          pe |= a, vt.set(M, W);
          var cn = t0(Nt(M), Nt(W), pe, it, Ie, vt);
          return vt.delete(M), cn;
        case E:
          if (Jd)
            return Jd.call(M) == Jd.call(W);
      }
      return !1;
    }
    function OL(M, W, ne, pe, it, Ie) {
      var vt = ne & i, Nt = n0(M), $t = Nt.length, dt = n0(W), cn = dt.length;
      if ($t != cn && !vt)
        return !1;
      for (var $n = $t; $n--; ) {
        var Ut = Nt[$n];
        if (!(vt ? Ut in W : ae.call(W, Ut)))
          return !1;
      }
      var _n = Ie.get(M);
      if (_n && Ie.get(W))
        return _n == W;
      var Sn = !0;
      Ie.set(M, W), Ie.set(W, M);
      for (var Kr = vt; ++$n < $t; ) {
        Ut = Nt[$n];
        var _r = M[Ut], wi = W[Ut];
        if (pe)
          var c0 = vt ? pe(wi, _r, Ut, W, M, Ie) : pe(_r, wi, Ut, M, W, Ie);
        if (!(c0 === void 0 ? _r === wi || it(_r, wi, ne, pe, Ie) : c0)) {
          Sn = !1;
          break;
        }
        Kr || (Kr = Ut == "constructor");
      }
      if (Sn && !Kr) {
        var Tc = M.constructor, Nc = W.constructor;
        Tc != Nc && "constructor" in M && "constructor" in W && !(typeof Tc == "function" && Tc instanceof Tc && typeof Nc == "function" && Nc instanceof Nc) && (Sn = !1);
      }
      return Ie.delete(M), Ie.delete(W), Sn;
    }
    function n0(M) {
      return yL(M, kL, AL);
    }
    function Cc(M, W) {
      var ne = M.__data__;
      return CL(W) ? ne[typeof W == "string" ? "string" : "hash"] : ne.map;
    }
    function ua(M, W) {
      var ne = tn(M, W);
      return xL(ne) ? ne : void 0;
    }
    function EL(M) {
      var W = ae.call(M, Me), ne = M[Me];
      try {
        M[Me] = void 0;
        var pe = !0;
      } catch {
      }
      var it = fe.call(M);
      return pe && (W ? M[Me] = ne : delete M[Me]), it;
    }
    var AL = Se ? function(M) {
      return M == null ? [] : (M = Object(M), Ne(Se(M), function(W) {
        return Rt.call(M, W);
      }));
    } : RL, Yr = To;
    (De && Yr(new De(new ArrayBuffer(1))) != C || br && Yr(new br()) != p || Ur && Yr(Ur.resolve()) != w || jo && Yr(new jo()) != S || gi && Yr(new gi()) != R) && (Yr = function(M) {
      var W = To(M), ne = W == x ? M.constructor : void 0, pe = ne ? xi(ne) : "";
      if (pe)
        switch (pe) {
          case WR:
            return C;
          case UR:
            return p;
          case HR:
            return w;
          case YR:
            return S;
          case KR:
            return R;
        }
      return W;
    });
    function PL(M, W) {
      return W = W ?? o, !!W && (typeof M == "number" || oe.test(M)) && M > -1 && M % 1 == 0 && M < W;
    }
    function CL(M) {
      var W = typeof M;
      return W == "string" || W == "number" || W == "symbol" || W == "boolean" ? M !== "__proto__" : M === null;
    }
    function jL(M) {
      return !!ue && ue in M;
    }
    function TL(M) {
      var W = M && M.constructor, ne = typeof W == "function" && W.prototype || L;
      return M === ne;
    }
    function NL(M) {
      return fe.call(M);
    }
    function xi(M) {
      if (M != null) {
        try {
          return H.call(M);
        } catch {
        }
        try {
          return M + "";
        } catch {
        }
      }
      return "";
    }
    function r0(M, W) {
      return M === W || M !== M && W !== W;
    }
    var ML = Jx(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? Jx : function(M) {
      return No(M) && ae.call(M, "callee") && !Rt.call(M, "callee");
    }, jc = Array.isArray;
    function IL(M) {
      return M != null && a0(M.length) && !i0(M);
    }
    var ef = $e || LL;
    function DL(M, W) {
      return e0(M, W);
    }
    function i0(M) {
      if (!o0(M))
        return !1;
      var W = To(M);
      return W == m || W == g || W == l || W == _;
    }
    function a0(M) {
      return typeof M == "number" && M > -1 && M % 1 == 0 && M <= o;
    }
    function o0(M) {
      var W = typeof M;
      return M != null && (W == "object" || W == "function");
    }
    function No(M) {
      return M != null && typeof M == "object";
    }
    var s0 = te ? en(te) : wL;
    function kL(M) {
      return IL(M) ? gL(M) : _L(M);
    }
    function RL() {
      return [];
    }
    function LL() {
      return !1;
    }
    e.exports = DL;
  })(gl, gl.exports)), gl.exports;
}
var One = Sne();
const Ene = /* @__PURE__ */ _ne(One);
var Xe = /* @__PURE__ */ ((e) => (e.FIELD_ID = "data-contentful-field-id", e.ENTRY_ID = "data-contentful-entry-id", e.ASSET_ID = "data-contentful-asset-id", e.LOCALE = "data-contentful-locale", e.SPACE = "data-contentful-space", e.ENVIRONMENT = "data-contentful-environment", e))(Xe || {}), Pi = /* @__PURE__ */ ((e) => (e.MOUSE_MOVE = "MOUSE_MOVE", e.SCROLL_START = "SCROLL_START", e.SCROLL_END = "SCROLL_END", e.RESIZE_START = "RESIZE_START", e.RESIZE_END = "RESIZE_END", e.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", e.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", e))(Pi || {}), BD = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Jo = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, Ane = { 0: String.fromCodePoint(Jo[0]), 1: String.fromCodePoint(Jo[1]), 2: String.fromCodePoint(Jo[2]), 3: String.fromCodePoint(Jo[3]) };
new Array(4).fill(String.fromCodePoint(Jo[0])).join("");
Object.fromEntries(Object.entries(Ane).map((e) => [e[1], +e[0]]));
Object.fromEntries(Object.entries(BD).map((e) => e.reverse()));
var Pne = `${Object.values(BD).map((e) => `\\u{${e.toString(16)}}`).join("")}`, Cne = new RegExp(`[${Pne}]{4,}`, "gu");
const jne = (e) => {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = e;
  return !(!t.hasAttribute(Xe.FIELD_ID) || !t.hasAttribute(Xe.ENTRY_ID) && !t.hasAttribute(Xe.ASSET_ID));
};
function Tne(e, t) {
  if (!jne(e))
    return null;
  const n = {
    fieldId: e.getAttribute(Xe.FIELD_ID),
    locale: e.getAttribute(Xe.LOCALE) ?? t.locale,
    environment: e.getAttribute(Xe.ENVIRONMENT) ?? t.environment,
    space: e.getAttribute(Xe.SPACE) ?? t.space,
    manuallyTagged: !0
  };
  if (!n.fieldId)
    return yn.warn("Element is missing field ID attribute and cannot be tagged", {
      id: e.getAttribute(Xe.ENTRY_ID) ?? e.getAttribute(Xe.ASSET_ID),
      sharedProps: n
    }), null;
  const r = e.getAttribute(Xe.ENTRY_ID);
  if (r)
    return { ...n, entryId: r };
  const i = e.getAttribute(Xe.ASSET_ID);
  return i ? { ...n, assetId: i } : null;
}
function FD(e, t) {
  return e.href === t.href;
}
function Nne(e, t) {
  return !(!FD(e.sourceMap, t.sourceMap) || e.element !== t.element);
}
function Mne(e) {
  let t = [];
  return typeof e.matches == "function" && e.matches("*") && (t = [e]), [
    ...t,
    ...Array.from(e.querySelectorAll("*:not(script,style,meta,title)"))
  ].map((n) => ({ node: n, text: Ine(n) })).filter(({ text: n }) => !!(n && n.match(Cne)));
}
function Ine(e) {
  return e.matches("input[type=submit], input[type=button], input[type=reset]") ? e.value : e.matches("img, video") ? e.alt : Array.from(e.childNodes).filter((t) => t.nodeType === Node.TEXT_NODE && !!t.textContent).map((t) => t.textContent).join("");
}
function Dne(e, t) {
  for (const n of t)
    if (n.element === e || n.element.contains(e))
      return !0;
  return !1;
}
function Ix({
  root: e = window.document,
  options: t
}) {
  const n = [...t.ignoreManuallyTaggedElements ? [] : e.querySelectorAll(
    `[${Xe.ASSET_ID}][${Xe.FIELD_ID}], [${Xe.ENTRY_ID}][${Xe.FIELD_ID}]`
  )].map((s) => ({
    element: s,
    attributes: Tne(s, t)
  })).filter(({ attributes: s }) => s !== null), r = [], i = Mne("body" in e ? e.body : e);
  for (const { node: s, text: c } of i) {
    const l = lne(c);
    if (!l || !l.origin.includes("contentful.com")) {
      yn.warn(
        "Element has missing or invalid ContentSourceMap, please check if you have correctly enabled ContentSourceMaps and that the element's data originates from Contentful",
        {
          node: s,
          sourceMap: l
        }
      );
      continue;
    }
    if (!(Dne(s, n) || r.some(
      (d) => d.element.contains(s) && FD(d.sourceMap, l)
    ))) {
      if (s.matches("img")) {
        const d = s.closest("figure") || s.closest("picture") || s;
        r.push({ element: d, sourceMap: l });
        continue;
      }
      r.push({ element: s, sourceMap: l });
    }
  }
  const a = r.filter(
    (s, c) => r.findIndex((l) => Nne(s, l)) === c
  );
  for (const { element: s, sourceMap: c } of a) {
    let l = null;
    if (c.href) {
      const d = Bne(c.href);
      if (!d)
        continue;
      if (d.entityType === "Asset")
        l = {
          fieldId: d.fieldId,
          locale: d.locale,
          space: d.space,
          environment: d.environment,
          assetId: d.entityId
        };
      else if (d.entityType === "Entry")
        l = {
          fieldId: d.fieldId,
          locale: d.locale,
          space: d.space,
          environment: d.environment,
          entryId: d.entityId
        };
      else {
        yn.warn("Unknown entityType", {
          element: s,
          sourceMap: c
        });
        continue;
      }
    } else if (c.contentful && Fne(c.contentful)) {
      const d = c.contentful;
      if (!d.entity || !d.field || !d.locale || !d.space || !d.environment) {
        yn.warn(
          "Element has missing information in their ContentSourceMap, please check if you have restricted the platform for the encoding. (Missing parameters in `contentful`)",
          {
            element: s,
            sourceMap: c
          }
        );
        continue;
      }
      const f = {
        fieldId: d.field,
        locale: d.locale,
        space: d.space,
        environment: d.environment
      };
      if (d.entityType === "Asset")
        f.assetId = d.entity, l = f;
      else if (d.entityType === "Entry")
        f.entryId = d.entity, l = f;
      else {
        yn.warn("Unknown entityType in contentful data", {
          element: s,
          sourceMap: c
        });
        continue;
      }
    } else {
      yn.warn(
        "Element has neither href nor contentful data in their ContentSourceMap, unable to extract attributes.",
        {
          element: s,
          sourceMap: c
        }
      );
      continue;
    }
    n.push({
      element: s,
      attributes: l
    });
  }
  const o = n.filter(
    ({ attributes: s }) => s?.manuallyTagged === !1 || !s?.manuallyTagged
  ).length;
  return {
    taggedElements: n,
    manuallyTaggedCount: n.length - o,
    automaticallyTaggedCount: o,
    autoTaggedElements: a
  };
}
function zD({
  options: e
}) {
  return [
    ...new Set(
      Ix({ options: e }).taggedElements.map((t) => t.attributes && "entryId" in t.attributes ? t.attributes.entryId : null).filter(Boolean)
    )
  ];
}
const kne = (e, t, n = window.document) => {
  const { top: r, right: i, bottom: a, left: o } = t, s = n.elementFromPoint(o + 1, r + 1), c = n.elementFromPoint(i - 1, r + 1), l = n.elementFromPoint(o + 1, a - 1), d = n.elementFromPoint(i - 1, a - 1), f = (h) => h ? e === h || e.contains(h) : !1;
  return [
    f(s),
    f(c),
    f(l),
    f(d)
  ].filter(Boolean).length < 2;
}, Rne = (e, t = window.document) => e.map((n) => ({
  ...n,
  isVisible: n.element.checkVisibility({
    checkOpacity: !0,
    checkVisibilityCSS: !0
  }),
  isCoveredByOtherElement: kne(
    n.element,
    n.coordinates,
    t
  )
})), Lne = (e) => e.map(({ element: t, attributes: n }) => ({
  element: t,
  coordinates: t.getBoundingClientRect(),
  attributes: n
})), $ne = (e, t = window.document) => {
  const n = Lne(e);
  return Rne(n, t);
};
function Bne(e) {
  try {
    const t = new URL(e), n = t.searchParams.get("focusedField"), r = t.searchParams.get("focusedLocale"), i = t.pathname.split("/").filter(Boolean), a = i.indexOf("spaces"), o = i.indexOf("environments"), s = a !== -1 ? i[a + 1] : void 0, c = o !== -1 ? i[o + 1] : void 0;
    let l, d;
    const f = i.indexOf("entries"), h = i.indexOf("assets");
    return f !== -1 ? (l = "Entry", d = i[f + 1]) : h !== -1 && (l = "Asset", d = i[h + 1]), !l || !d ? (console.warn("Unable to determine entityType or entityId from href", { href: e }), null) : n ? r ? !s || !c ? (console.warn("Missing space or environment in href path", { href: e }), null) : {
      entityId: d,
      entityType: l,
      fieldId: n,
      locale: r,
      space: s,
      environment: c
    } : (console.warn("Missing focusedLocale query parameter in href", { href: e }), null) : (console.warn("Missing focusedField query parameter in href", { href: e }), null);
  } catch (t) {
    return console.warn("Invalid href URL", { href: e, error: t }), null;
  }
}
function Fne(e) {
  return e && typeof e.entity == "string" && typeof e.field == "string" && typeof e.locale == "string" && typeof e.space == "string" && typeof e.environment == "string" && (e.entityType === "Asset" || e.entityType === "Entry");
}
function zne(e) {
  return gne.has(e.element.tagName.toUpperCase()) ? {
    [e.element.tagName.toLowerCase()]: Array.from(e.element.attributes).map((t) => `${t.name}="${t.value}"`).join(" ")
  } : { [e.element.tagName.toLowerCase()]: e.element.innerHTML };
}
class qne {
  constructor(t) {
    this.options = t, this.intersectionObserver = new IntersectionObserver(
      (n) => {
        const r = this.taggedElements;
        for (const i of n)
          if (i.isIntersecting)
            for (const a of r)
              a.element === i.target && (a.coordinates = i.intersectionRect, a.isVisible = i.target.checkVisibility({
                checkOpacity: !0,
                checkVisibilityCSS: !0
              }));
        this.taggedElements = r, this.sendTaggedElements();
      },
      { threshold: 0.15 }
    );
  }
  delay = 300;
  isScrolling = !1;
  scrollTimeout;
  isResizing = !1;
  resizeTimeout;
  hoveredElement;
  taggedElements = [];
  manuallyTaggedCount = 0;
  automaticallyTaggedCount = 0;
  releaseId;
  intersectionObserver;
  observersCB = [];
  cleanupCB = [];
  /**
   * Attaches the event listeners and send the tagged elements once
   */
  init = () => {
    this.cleanupCB = [
      this.addScrollListener(),
      this.addMutationListener(document.body),
      this.addResizeListener(),
      this.addHoverListener()
    ], this.updateElements();
  };
  /**
   * Cancels all listeners and observers
   */
  cleanup = () => {
    this.observersCB.forEach((t) => t()), this.cleanupCB.forEach((t) => t());
  };
  // Handles incoming messages from Contentful
  receiveMessage = (t) => {
    if (t.method === Pi.INSPECTOR_MODE_CHANGED) {
      const { isInspectorActive: n, releaseId: r } = t;
      this.releaseId = r, n ? this.init() : this.cleanup();
    }
  };
  /** Listen for changes on the element via intersection and mutation observer */
  observe = (t) => {
    this.intersectionObserver.observe(t);
    const n = this.addMutationListener(t);
    this.observersCB.push(n, () => this.intersectionObserver.unobserve(t));
  };
  /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
  addScrollListener = () => {
    const { targetOrigin: t } = this.options, n = () => {
      this.isScrolling || (this.isScrolling = !0, rr(Pi.SCROLL_START, {}, t)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
        this.isScrolling = !1, rr(Pi.SCROLL_END, {}, t), this.updateElements();
      }, this.delay);
    }, r = { capture: !0, passive: !0 };
    return window.addEventListener("scroll", n, r), () => window.removeEventListener("scroll", n, r);
  };
  /** Detects DOM changes and sends the tagged elements to the editor */
  addMutationListener = (t) => {
    const n = new MutationObserver(() => {
      this.updateElements();
    });
    return n.observe(t, {
      // Content source maps
      characterData: !0,
      // Manual tagging
      attributes: !0,
      attributeFilter: [
        Xe.ENTRY_ID,
        Xe.FIELD_ID,
        Xe.LOCALE,
        Xe.SPACE,
        Xe.ENVIRONMENT,
        "class",
        "style"
      ],
      // Adding or removal of new nodes
      childList: !0,
      // Include children
      subtree: !0
    }), () => n.disconnect();
  };
  /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
  addResizeListener = () => {
    const { targetOrigin: t } = this.options, n = new ResizeObserver(() => {
      this.isResizing || (this.isResizing = !0, rr(Pi.RESIZE_START, {}, t)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
        this.isResizing = !1, rr(Pi.RESIZE_END, {}, t), this.updateElements();
      }, this.delay);
    });
    return n.observe(document.body), () => n.disconnect();
  };
  /** Checks if the hovered element is an tagged entry and then sends it to the editor */
  addHoverListener = () => {
    const t = yne((r) => {
      let i;
      for (const a of r) {
        const o = a;
        if (o.nodeName === "BODY") break;
        const s = this.taggedElements.find((c) => c.element === o);
        if (s) {
          i = s;
          break;
        }
      }
      this.hoveredElement = i?.element, this.updateElements();
    }, this.delay), n = (r) => {
      t(r.composedPath());
    };
    return window.addEventListener("mouseover", n, { passive: !0 }), () => window.removeEventListener("mouseover", n);
  };
  sendTaggedElements = () => {
    rr(
      Pi.TAGGED_ELEMENTS,
      {
        elements: this.taggedElements.map((t) => ({
          // Important: do not add `element` as it can't be cloned by sendMessage
          coordinates: t.coordinates,
          isVisible: !!t.isVisible,
          attributes: t.attributes,
          isHovered: this.hoveredElement === t.element,
          isCoveredByOtherElement: !!t.isCoveredByOtherElement,
          snapshot: zne(t)
        })),
        automaticallyTaggedCount: this.automaticallyTaggedCount,
        manuallyTaggedCount: this.manuallyTaggedCount,
        ...this.releaseId !== void 0 && { releaseId: this.releaseId }
      },
      this.options.targetOrigin
    );
  };
  /**
   * Finds all elements that have all inspector mode attributes
   * and sends them to the editor
   */
  updateElements = () => {
    const { taggedElements: t, manuallyTaggedCount: n, automaticallyTaggedCount: r } = Ix({
      options: this.options
    }), i = $ne(t);
    Ene(i, this.taggedElements) || (this.observersCB.forEach((a) => a()), this.observersCB = [], this.taggedElements = i, t.forEach(({ element: a }) => this.observe(a)), this.manuallyTaggedCount = n, this.automaticallyTaggedCount = r);
  };
}
const { stringify: Vne } = JSON, Wne = String, Une = "string", Hne = "object", Yne = (e, t) => t, sP = (e, t, n) => {
  const r = Wne(t.push(n) - 1);
  return e.set(n, r), r;
}, Kne = (e, t, n) => {
  const r = Yne, i = /* @__PURE__ */ new Map(), a = [], o = [];
  let s = +sP(i, a, r.call({ "": e }, "", e)), c = !s;
  for (; s < a.length; )
    c = !0, o[s] = Vne(a[s++], l, n);
  return "[" + o.join(",") + "]";
  function l(d, f) {
    if (c)
      return c = !c, f;
    const h = r.call(this, d, f);
    switch (typeof h) {
      case Hne:
        if (h === null) return h;
      case Une:
        return i.get(h) || sP(i, a, h);
    }
    return h;
  }
};
var ir = /* @__PURE__ */ ((e) => (e.CONNECTED = "CONNECTED", e.DISCONNECTED = "DISCONNECTED", e.ERROR = "ERROR", e.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", e.URL_CHANGED = "URL_CHANGED", e.SUBSCRIBED = "SUBSCRIBED", e.UNSUBSCRIBED = "UNSUBSCRIBED", e.ENTRY_UPDATED = "ENTRY_UPDATED", e.ENTRY_SAVED = "ENTRY_SAVED", e.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", e))(ir || {});
function Gne(e, t) {
  rr(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...e
    },
    t
  );
}
function Zne(e, t) {
  rr(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...e
    },
    t
  );
}
class Xne {
  subscriptions = /* @__PURE__ */ new Map();
  defaultLocale;
  sendMessage;
  constructor({ locale: t, targetOrigin: n }) {
    this.defaultLocale = t, this.sendMessage = (r, i) => rr(r, i, n);
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(t) {
    if (t.method === ir.ENTRY_UPDATED) {
      const { data: n, subscriptionId: r } = t, i = this.subscriptions.get(r);
      i ? (i.callback(n), i.data = n, this.subscriptions.set(r, i)) : yn.error("Received an update for an unknown subscription", {
        subscriptionId: r,
        data: n,
        subscriptions: this.subscriptions
      });
    }
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(t) {
    const n = xne(), r = t.locale ?? this.defaultLocale;
    this.subscriptions.set(n, {
      ...t
    });
    const i = {
      locale: r,
      event: "edit",
      id: n,
      config: Kne(t)
    };
    return this.sendMessage(ir.SUBSCRIBED, i), () => {
      this.sendMessage(ir.UNSUBSCRIBED, i), this.subscriptions.delete(n);
    };
  }
}
class Qne {
  locale;
  options;
  inspectorModeEnabled;
  subscription;
  constructor({
    locale: t,
    options: n,
    inspectorModeEnabled: r
  }) {
    this.locale = t, this.options = n, this.inspectorModeEnabled = r;
  }
  subscribe(t) {
    return this.subscription && yn.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = t, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(t) {
    if (t.method === ir.ENTRY_SAVED && this.subscription) {
      const { entity: n } = t;
      this.inspectorModeEnabled ? zD({ options: this.options }).includes(n.sys.id) && this.subscription(n) : this.subscription(n);
    }
  }
}
const cP = [
  "https://app.contentful.com",
  "https://app.eu.contentful.com",
  "http://localhost:3001"
  // for local debugging for Contentful engineers
];
class vo {
  static initialized = !1;
  static inspectorMode = null;
  static liveUpdates = null;
  static saveEvent = null;
  static inspectorModeEnabled = !0;
  static liveUpdatesEnabled = !0;
  static locale;
  static space;
  static environment;
  static sendMessage;
  static targetOrigin;
  // Static method to initialize the LivePreview SDK
  static init(t) {
    if (typeof t != "object" || !t?.locale)
      throw new Error(
        "Init function has to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: n,
      enableInspectorMode: r,
      enableLiveUpdates: i,
      locale: a,
      environment: o,
      space: s,
      targetOrigin: c
    } = t;
    if (typeof window < "u") {
      if (!bne())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (n && aP(n), typeof r == "boolean" && (this.inspectorModeEnabled = r), typeof i == "boolean" && (this.liveUpdatesEnabled = i), this.locale = a, this.space = s, this.environment = o, this.initTargetOrigin(c), this.initialized)
        return yn.log("You have already initialized the Live Preview SDK."), Promise.resolve(vo.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new qne({
        locale: a,
        space: s,
        environment: o,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: t.experimental?.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new Xne({ locale: a, targetOrigin: this.targetOrigin }), this.saveEvent = new Qne({
        locale: a,
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment,
          targetOrigin: this.targetOrigin
        },
        inspectorModeEnabled: this.inspectorModeEnabled
      })), window.addEventListener("message", (m) => {
        if (wne(m)) {
          if (yn.log("Received message", m.data), m.data.method === ir.DEBUG_MODE_ENABLED) {
            aP(!0);
            return;
          }
          this.inspectorModeEnabled && this.inspectorMode?.receiveMessage(m.data), this.liveUpdatesEnabled && (this.liveUpdates?.receiveMessage(m.data), this.saveEvent?.receiveMessage(m.data));
        }
      }), mne(() => {
        rr(
          ir.URL_CHANGED,
          {
            action: ir.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${Xe.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const { taggedElements: l, manuallyTaggedCount: d, automaticallyTaggedCount: f } = this.inspectorModeEnabled ? Ix({
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment
        }
      }) : {
        taggedElements: [],
        manuallyTaggedCount: 0,
        automaticallyTaggedCount: 0
      }, h = l.length;
      return rr(
        ir.CONNECTED,
        {
          action: ir.CONNECTED,
          connected: !0,
          tags: h,
          taggedElementCount: h,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled,
          manuallyTaggedElementCount: d,
          automaticallyTaggedElementCount: f,
          hideCoveredElementOutlines: t.experimental?.hideCoveredElementOutlines,
          version: LD.version
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(vo.inspectorMode);
    }
  }
  static initTargetOrigin(t) {
    if (t)
      this.targetOrigin = Array.isArray(t) ? t : [t];
    else {
      const n = window.location.ancestorOrigins, r = n ? cP.find((i) => n.contains(i)) : (
        //less consistent workaround for Firefox, where ancestorOrigins is not supported
        cP.find((i) => document.referrer.includes(i))
      );
      if (!r)
        throw new Error(
          "The current origin is not supported. Please provide a targetOrigin in the live preview configuration."
        );
      this.targetOrigin = [r];
    }
  }
  static subscribe(t, n) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const r = typeof t == "string" ? t : "edit", i = typeof t == "object" ? t : n;
    if (r === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(i.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(i);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(t) {
    const { fieldId: n, locale: r, environment: i, space: a } = t;
    if (!this.inspectorModeEnabled)
      return null;
    if (n) {
      const o = {
        ...r ? { [Xe.LOCALE]: r } : {},
        ...i ? { [Xe.ENVIRONMENT]: i } : {},
        ...a ? { [Xe.SPACE]: a } : {},
        [Xe.FIELD_ID]: n
      };
      if (r && (o[Xe.LOCALE] = r), t.assetId !== void 0)
        return {
          ...o,
          [Xe.ASSET_ID]: t.assetId
        };
      if (t.entryId !== void 0)
        return {
          ...o,
          [Xe.ENTRY_ID]: t.entryId
        };
    }
    return yn.warn("Missing property for inspector mode", { ...t }), null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  //TODO: Rename to openEntityInEditor, as assets can also be opened. Would be breaking change
  static openEntryInEditor(t) {
    const n = {
      locale: this.locale,
      environment: this.environment,
      space: this.space
    };
    if (t.assetId !== void 0 && t.fieldId) {
      Zne(
        {
          ...n,
          ...t
        },
        this.targetOrigin
      );
      return;
    }
    if (t.entryId !== void 0 && t.fieldId) {
      Gne(
        {
          ...n,
          ...t
        },
        this.targetOrigin
      );
      return;
    }
    yn.error("Please provide field id and entry/asset id to openEntryInEditor.", { ...t });
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return zD({
      options: {
        locale: this.locale,
        space: this.space,
        environment: this.environment
      }
    });
  }
}
const Jne = hr(null);
function ere(e) {
  const t = si(Jne);
  return ot(
    (n) => t?.enableInspectorMode ? vo.getProps({ ...e, ...n }) : null,
    [t?.enableInspectorMode, e]
  );
}
var tre = Object.defineProperty, qD = (e, t) => tre(e, "name", { value: t, configurable: !0 });
function nre(e) {
  return St(() => {
    const t = vo.init({ locale: e.locale, debugMode: e.debugMode ?? !1, enableLiveUpdates: e.enableLiveUpdates ?? !0, enableInspectorMode: e.enableInspectorMode ?? !0, targetOrigin: e.targetOrigin ?? "https://app.contentful.com" });
    t ? t.then(() => {
      const n = e.onSave ?? (async () => {
        const { pathname: r } = globalThis.location;
        await fetch(`/api/revalidate-preview?pathname=${r}`), globalThis.location.reload();
      });
      vo.subscribe("save", { callback: qD(async () => {
        await n();
      }, "callback") });
    }).catch((n) => {
      jr.error("[ContentfulLivePreviewInit] Initialization failed:", n);
    }) : jr.warn("[ContentfulLivePreviewInit] init() returned null/undefined - likely not in Contentful preview context");
  }, [e.locale, e.debugMode, e.enableLiveUpdates, e.enableInspectorMode, e.targetOrigin, e.onSave]), null;
}
qD(nre, "ContentfulLivePreviewInit");
function oue(e) {
  const t = e?.sys?.id, n = ere({ entryId: t }), r = Le(null), [i, a] = Ee(!1), [o, s] = Ee(!0), c = e.fluid ?? !0, l = e.aspectRatio ?? "3:1", f = (e.media.type === "Video" || "poster" in e.media) && !i, h = () => {
    r.current && (o ? (r.current.pause(), s(!1)) : (r.current.play(), s(!0)));
  };
  let m = "Banner image";
  "alt" in e.media ? m = e.media.alt : "poster" in e.media && (m = e.media.poster);
  const g = /* @__PURE__ */ u.jsxs(
    "section",
    {
      className: `relative z-0 aspect-[1/1.414] w-full overflow-hidden rounded-md md:aspect-[16/9] ${l === "3:1" ? "lg:aspect-[3/1]" : "lg:aspect-[16/9]"}`,
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "absolute inset-0 z-0", children: [
          f ? /* @__PURE__ */ u.jsx(
            "video",
            {
              "aria-label": e.media.src,
              autoPlay: !0,
              className: "h-full w-full object-cover",
              loop: !0,
              muted: !0,
              onError: () => a(!0),
              playsInline: !0,
              poster: "poster" in e.media ? e.media.poster : void 0,
              ref: r,
              children: /* @__PURE__ */ u.jsx("source", { src: e.media.src, type: "video/mp4" })
            }
          ) : /* @__PURE__ */ u.jsx(
            Xt,
            {
              alt: m,
              aspectRatio: l,
              fill: !0,
              priority: !0,
              src: e.media.src
            }
          ),
          /* @__PURE__ */ u.jsx("div", { className: "container absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-black/70 to-transparent" }),
          /* @__PURE__ */ u.jsx("div", { className: "container absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent" })
        ] }),
        f && /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "absolute right-10 bottom-10 z-30 cursor-pointer",
            onClick: h,
            children: o ? /* @__PURE__ */ u.jsx(u2, { color: "white", size: 64, strokeWidth: 0.5 }) : /* @__PURE__ */ u.jsx(f2, { color: "white", size: 64, strokeWidth: 0.5 })
          }
        ),
        /* @__PURE__ */ u.jsxs("div", { className: "relative z-20 flex min-h-full flex-col items-start gap-4 px-4 py-14 md:p-14", children: [
          e.logo && /* @__PURE__ */ u.jsx("div", { className: "h-14 w-auto", children: /* @__PURE__ */ u.jsx(
            Xt,
            {
              alt: e.logo.alt,
              aspectRatio: "1:1",
              objectFit: "contain",
              objectPosition: "bottom left",
              priority: !0,
              src: e.logo.src
            }
          ) }),
          /* @__PURE__ */ u.jsxs("div", { className: "flex max-w-[500px] flex-col gap-2 text-left", children: [
            /* @__PURE__ */ u.jsx(
              B,
              {
                color: "white",
                variant: "h2",
                ...n({ fieldId: "title" }),
                children: e.title
              }
            ),
            e.subtitle && /* @__PURE__ */ u.jsx(
              B,
              {
                color: "white",
                variant: "lead",
                ...n({ fieldId: "subtitle" }),
                children: e.subtitle
              }
            )
          ] })
        ] })
      ]
    }
  );
  return c ? /* @__PURE__ */ u.jsx(TC, { children: g }) : g;
}
var Ep = {}, Ap = {}, Pp = {}, lP;
function xc() {
  return lP || (lP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "BLOCKS", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    var t = /* @__PURE__ */ (function(n) {
      return n.DOCUMENT = "document", n.PARAGRAPH = "paragraph", n.HEADING_1 = "heading-1", n.HEADING_2 = "heading-2", n.HEADING_3 = "heading-3", n.HEADING_4 = "heading-4", n.HEADING_5 = "heading-5", n.HEADING_6 = "heading-6", n.OL_LIST = "ordered-list", n.UL_LIST = "unordered-list", n.LIST_ITEM = "list-item", n.HR = "hr", n.QUOTE = "blockquote", n.EMBEDDED_ENTRY = "embedded-entry-block", n.EMBEDDED_ASSET = "embedded-asset-block", n.EMBEDDED_RESOURCE = "embedded-resource-block", n.TABLE = "table", n.TABLE_ROW = "table-row", n.TABLE_CELL = "table-cell", n.TABLE_HEADER_CELL = "table-header-cell", n;
    })({});
  })(Pp)), Pp;
}
var Cp = {}, uP;
function qd() {
  return uP || (uP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "INLINES", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    var t = /* @__PURE__ */ (function(n) {
      return n.ASSET_HYPERLINK = "asset-hyperlink", n.EMBEDDED_ENTRY = "embedded-entry-inline", n.EMBEDDED_RESOURCE = "embedded-resource-inline", n.ENTRY_HYPERLINK = "entry-hyperlink", n.HYPERLINK = "hyperlink", n.RESOURCE_HYPERLINK = "resource-hyperlink", n;
    })({});
  })(Cp)), Cp;
}
var jp = {}, dP;
function VD() {
  return dP || (dP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "MARKS", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    var t = /* @__PURE__ */ (function(n) {
      return n.BOLD = "bold", n.ITALIC = "italic", n.UNDERLINE = "underline", n.CODE = "code", n.SUPERSCRIPT = "superscript", n.SUBSCRIPT = "subscript", n.STRIKETHROUGH = "strikethrough", n;
    })({});
  })(jp)), jp;
}
var Tp = {}, fP;
function WD() {
  return fP || (fP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(S, O) {
      for (var E in O) Object.defineProperty(S, E, {
        enumerable: !0,
        get: Object.getOwnPropertyDescriptor(O, E).get
      });
    }
    t(e, {
      get CONTAINERS() {
        return y;
      },
      get HEADINGS() {
        return x;
      },
      get LIST_ITEM_BLOCKS() {
        return m;
      },
      get TABLE_BLOCKS() {
        return g;
      },
      get TEXT_CONTAINERS() {
        return w;
      },
      get TOP_LEVEL_BLOCKS() {
        return h;
      },
      get V1_MARKS() {
        return b;
      },
      get V1_NODE_TYPES() {
        return _;
      },
      get VOID_BLOCKS() {
        return p;
      }
    });
    var n = xc(), r = qd(), i = VD();
    function a(S, O) {
      (O == null || O > S.length) && (O = S.length);
      for (var E = 0, P = new Array(O); E < O; E++) P[E] = S[E];
      return P;
    }
    function o(S) {
      if (Array.isArray(S)) return a(S);
    }
    function s(S, O, E) {
      return O in S ? Object.defineProperty(S, O, {
        value: E,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : S[O] = E, S;
    }
    function c(S) {
      if (typeof Symbol < "u" && S[Symbol.iterator] != null || S["@@iterator"] != null) return Array.from(S);
    }
    function l() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function d(S) {
      return o(S) || c(S) || f(S) || l();
    }
    function f(S, O) {
      if (S) {
        if (typeof S == "string") return a(S, O);
        var E = Object.prototype.toString.call(S).slice(8, -1);
        if (E === "Object" && S.constructor && (E = S.constructor.name), E === "Map" || E === "Set") return Array.from(E);
        if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return a(S, O);
      }
    }
    var h = [
      n.BLOCKS.PARAGRAPH,
      n.BLOCKS.HEADING_1,
      n.BLOCKS.HEADING_2,
      n.BLOCKS.HEADING_3,
      n.BLOCKS.HEADING_4,
      n.BLOCKS.HEADING_5,
      n.BLOCKS.HEADING_6,
      n.BLOCKS.OL_LIST,
      n.BLOCKS.UL_LIST,
      n.BLOCKS.HR,
      n.BLOCKS.QUOTE,
      n.BLOCKS.EMBEDDED_ENTRY,
      n.BLOCKS.EMBEDDED_ASSET,
      n.BLOCKS.EMBEDDED_RESOURCE,
      n.BLOCKS.TABLE
    ], m = [
      n.BLOCKS.PARAGRAPH,
      n.BLOCKS.HEADING_1,
      n.BLOCKS.HEADING_2,
      n.BLOCKS.HEADING_3,
      n.BLOCKS.HEADING_4,
      n.BLOCKS.HEADING_5,
      n.BLOCKS.HEADING_6,
      n.BLOCKS.OL_LIST,
      n.BLOCKS.UL_LIST,
      n.BLOCKS.HR,
      n.BLOCKS.QUOTE,
      n.BLOCKS.EMBEDDED_ENTRY,
      n.BLOCKS.EMBEDDED_ASSET,
      n.BLOCKS.EMBEDDED_RESOURCE
    ], g = [
      n.BLOCKS.TABLE,
      n.BLOCKS.TABLE_ROW,
      n.BLOCKS.TABLE_CELL,
      n.BLOCKS.TABLE_HEADER_CELL
    ], p = [
      n.BLOCKS.HR,
      n.BLOCKS.EMBEDDED_ENTRY,
      n.BLOCKS.EMBEDDED_ASSET,
      n.BLOCKS.EMBEDDED_RESOURCE
    ], v, y = (v = {}, s(v, n.BLOCKS.OL_LIST, [
      n.BLOCKS.LIST_ITEM
    ]), s(v, n.BLOCKS.UL_LIST, [
      n.BLOCKS.LIST_ITEM
    ]), s(v, n.BLOCKS.LIST_ITEM, m), s(v, n.BLOCKS.QUOTE, [
      n.BLOCKS.PARAGRAPH
    ]), s(v, n.BLOCKS.TABLE, [
      n.BLOCKS.TABLE_ROW
    ]), s(v, n.BLOCKS.TABLE_ROW, [
      n.BLOCKS.TABLE_CELL,
      n.BLOCKS.TABLE_HEADER_CELL
    ]), s(v, n.BLOCKS.TABLE_CELL, [
      n.BLOCKS.PARAGRAPH,
      n.BLOCKS.UL_LIST,
      n.BLOCKS.OL_LIST
    ]), s(v, n.BLOCKS.TABLE_HEADER_CELL, [
      n.BLOCKS.PARAGRAPH
    ]), v), x = [
      n.BLOCKS.HEADING_1,
      n.BLOCKS.HEADING_2,
      n.BLOCKS.HEADING_3,
      n.BLOCKS.HEADING_4,
      n.BLOCKS.HEADING_5,
      n.BLOCKS.HEADING_6
    ], w = [
      n.BLOCKS.PARAGRAPH
    ].concat(d(x)), _ = [
      n.BLOCKS.DOCUMENT,
      n.BLOCKS.PARAGRAPH,
      n.BLOCKS.HEADING_1,
      n.BLOCKS.HEADING_2,
      n.BLOCKS.HEADING_3,
      n.BLOCKS.HEADING_4,
      n.BLOCKS.HEADING_5,
      n.BLOCKS.HEADING_6,
      n.BLOCKS.OL_LIST,
      n.BLOCKS.UL_LIST,
      n.BLOCKS.LIST_ITEM,
      n.BLOCKS.HR,
      n.BLOCKS.QUOTE,
      n.BLOCKS.EMBEDDED_ENTRY,
      n.BLOCKS.EMBEDDED_ASSET,
      r.INLINES.HYPERLINK,
      r.INLINES.ENTRY_HYPERLINK,
      r.INLINES.ASSET_HYPERLINK,
      r.INLINES.EMBEDDED_ENTRY,
      "text"
    ], b = [
      i.MARKS.BOLD,
      i.MARKS.CODE,
      i.MARKS.ITALIC,
      i.MARKS.UNDERLINE
    ];
  })(Tp)), Tp;
}
var Np = {}, hP;
function rre() {
  return hP || (hP = 1, Object.defineProperty(Np, "__esModule", {
    value: !0
  })), Np;
}
var Mp = {}, mP;
function ire() {
  return mP || (mP = 1, Object.defineProperty(Mp, "__esModule", {
    value: !0
  })), Mp;
}
var Ip = {}, vP;
function are() {
  return vP || (vP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "EMPTY_DOCUMENT", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    var t = xc(), n = {
      nodeType: t.BLOCKS.DOCUMENT,
      data: {},
      content: [
        {
          nodeType: t.BLOCKS.PARAGRAPH,
          data: {},
          content: [
            {
              nodeType: "text",
              value: "",
              marks: [],
              data: {}
            }
          ]
        }
      ]
    };
  })(Ip)), Ip;
}
var Dp = {}, pP;
function ore() {
  return pP || (pP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(y, x) {
      for (var w in x) Object.defineProperty(y, w, {
        enumerable: !0,
        get: Object.getOwnPropertyDescriptor(x, w).get
      });
    }
    t(e, {
      get isBlock() {
        return f;
      },
      get isEmptyParagraph() {
        return m;
      },
      get isInline() {
        return d;
      },
      get isText() {
        return h;
      },
      get stripEmptyTrailingParagraphFromDocument() {
        return v;
      }
    });
    var n = xc(), r = qd();
    function i(y, x, w) {
      return x in y ? Object.defineProperty(y, x, {
        value: w,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : y[x] = w, y;
    }
    function a(y) {
      for (var x = 1; x < arguments.length; x++) {
        var w = arguments[x] != null ? arguments[x] : {}, _ = Object.keys(w);
        typeof Object.getOwnPropertySymbols == "function" && (_ = _.concat(Object.getOwnPropertySymbols(w).filter(function(b) {
          return Object.getOwnPropertyDescriptor(w, b).enumerable;
        }))), _.forEach(function(b) {
          i(y, b, w[b]);
        });
      }
      return y;
    }
    function o(y, x) {
      var w = Object.keys(y);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(y);
        w.push.apply(w, _);
      }
      return w;
    }
    function s(y, x) {
      return x = x ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(x)) : o(Object(x)).forEach(function(w) {
        Object.defineProperty(y, w, Object.getOwnPropertyDescriptor(x, w));
      }), y;
    }
    function c(y) {
      "@swc/helpers - typeof";
      return y && typeof Symbol < "u" && y.constructor === Symbol ? "symbol" : typeof y;
    }
    function l(y, x) {
      var w = !0, _ = !1, b = void 0;
      try {
        for (var S = Object.keys(y)[Symbol.iterator](), O; !(w = (O = S.next()).done); w = !0) {
          var E = O.value;
          if (x === y[E])
            return !0;
        }
      } catch (P) {
        _ = !0, b = P;
      } finally {
        try {
          !w && S.return != null && S.return();
        } finally {
          if (_)
            throw b;
        }
      }
      return !1;
    }
    function d(y) {
      return l(r.INLINES, y.nodeType);
    }
    function f(y) {
      return l(n.BLOCKS, y.nodeType);
    }
    function h(y) {
      return y.nodeType === "text";
    }
    function m(y) {
      if (y.nodeType !== n.BLOCKS.PARAGRAPH || y.content.length !== 1)
        return !1;
      var x = y.content[0];
      return x.nodeType === "text" && x.value === "";
    }
    function g(y) {
      return y != null && (typeof y > "u" ? "undefined" : c(y)) === "object" && "content" in y && Array.isArray(y.content);
    }
    var p = 2;
    function v(y) {
      if (!g(y) || y.content.length < p)
        return y;
      var x = y.content[y.content.length - 1];
      return m(x) ? s(a({}, y), {
        content: y.content.slice(0, -1)
      }) : y;
    }
  })(Dp)), Dp;
}
var kp = {}, Rp = {}, Lp = {}, gP;
function sre() {
  return gP || (gP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(g, p) {
      for (var v in p) Object.defineProperty(g, v, {
        enumerable: !0,
        get: Object.getOwnPropertyDescriptor(p, v).get
      });
    }
    t(e, {
      get enumError() {
        return f;
      },
      get maxSizeError() {
        return d;
      },
      get minSizeError() {
        return l;
      },
      get requiredPropertyError() {
        return m;
      },
      get typeMismatchError() {
        return c;
      },
      get unknownPropertyError() {
        return h;
      }
    });
    function n(g, p) {
      (p == null || p > g.length) && (p = g.length);
      for (var v = 0, y = new Array(p); v < p; v++) y[v] = g[v];
      return y;
    }
    function r(g) {
      if (Array.isArray(g)) return n(g);
    }
    function i(g) {
      if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null) return Array.from(g);
    }
    function a() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function o(g) {
      return r(g) || i(g) || s(g) || a();
    }
    function s(g, p) {
      if (g) {
        if (typeof g == "string") return n(g, p);
        var v = Object.prototype.toString.call(g).slice(8, -1);
        if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set") return Array.from(v);
        if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return n(g, p);
      }
    }
    var c = function(g) {
      var p = g.path, v = g.property, y = g.typeName, x = g.value;
      return {
        details: 'The type of "'.concat(v, '" is incorrect, expected type: ').concat(y),
        name: "type",
        path: p.toArray(),
        type: y,
        value: x
      };
    }, l = function(g) {
      var p = g.min, v = g.value, y = g.path;
      return {
        name: "size",
        min: p,
        path: y.toArray(),
        details: "Size must be at least ".concat(p),
        value: v
      };
    }, d = function(g) {
      var p = g.max, v = g.value, y = g.path;
      return {
        name: "size",
        max: p,
        path: y.toArray(),
        details: "Size must be at most ".concat(p),
        value: v
      };
    }, f = function(g) {
      var p = g.expected, v = g.value, y = g.path;
      return {
        details: "Value must be one of expected values",
        name: "in",
        expected: o(p).sort(),
        path: y.toArray(),
        value: v
      };
    }, h = function(g) {
      var p = g.property, v = g.path;
      return {
        details: 'The property "'.concat(p, '" is not expected'),
        name: "unexpected",
        path: v.toArray()
      };
    }, m = function(g) {
      var p = g.property, v = g.path;
      return {
        details: 'The property "'.concat(p, '" is required here'),
        name: "required",
        path: v.toArray()
      };
    };
  })(Lp)), Lp;
}
var yP;
function Dx() {
  return yP || (yP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ObjectAssertion", {
      enumerable: !0,
      get: function() {
        return m;
      }
    });
    var t = sre();
    function n(g, p) {
      (p == null || p > g.length) && (p = g.length);
      for (var v = 0, y = new Array(p); v < p; v++) y[v] = g[v];
      return y;
    }
    function r(g) {
      if (Array.isArray(g)) return n(g);
    }
    function i(g, p) {
      if (!(g instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function a(g, p) {
      for (var v = 0; v < p.length; v++) {
        var y = p[v];
        y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
      }
    }
    function o(g, p, v) {
      return p && a(g.prototype, p), g;
    }
    function s(g, p, v) {
      return p in g ? Object.defineProperty(g, p, {
        value: v,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : g[p] = v, g;
    }
    function c(g) {
      if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null) return Array.from(g);
    }
    function l() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function d(g) {
      return r(g) || c(g) || h(g) || l();
    }
    function f(g) {
      "@swc/helpers - typeof";
      return g && typeof Symbol < "u" && g.constructor === Symbol ? "symbol" : typeof g;
    }
    function h(g, p) {
      if (g) {
        if (typeof g == "string") return n(g, p);
        var v = Object.prototype.toString.call(g).slice(8, -1);
        if (v === "Object" && g.constructor && (v = g.constructor.name), v === "Map" || v === "Set") return Array.from(v);
        if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return n(g, p);
      }
    }
    var m = /* @__PURE__ */ (function() {
      function g(p, v) {
        var y = this, x = this;
        i(this, g), s(this, "obj", void 0), s(this, "path", void 0), s(this, "_errors", void 0), s(this, "catch", void 0), s(this, "exists", void 0), s(this, "object", void 0), s(this, "string", void 0), s(this, "number", void 0), s(this, "array", void 0), s(this, "enum", void 0), s(this, "empty", void 0), s(this, "minLength", void 0), s(this, "noAdditionalProperties", void 0), s(this, "each", void 0), this.obj = p, this.path = v, this._errors = [], this.catch = function() {
          for (var w = arguments.length, _ = new Array(w), b = 0; b < w; b++)
            _[b] = arguments[b];
          var S;
          (S = x._errors).push.apply(S, d(_));
        }, this.exists = function(w) {
          return w in y.obj ? !0 : (y.catch((0, t.requiredPropertyError)({
            property: w,
            path: y.path.of(w)
          })), !1);
        }, this.object = function(w) {
          var _, b = w ? y.obj[w] : y.obj;
          if (w && !y.exists(w))
            return !1;
          if ((typeof b > "u" ? "undefined" : f(b)) === "object" && !Array.isArray(b) && b !== null)
            return !0;
          var S = w ? y.path.of(w) : y.path, O = (_ = w ?? y.path.last()) !== null && _ !== void 0 ? _ : "value";
          return y.catch((0, t.typeMismatchError)({
            typeName: "Object",
            property: O,
            path: S,
            value: b
          })), !1;
        }, this.string = function(w) {
          var _ = y.obj[w];
          return w && !y.exists(w) ? !1 : typeof _ == "string" ? !0 : (y.catch((0, t.typeMismatchError)({
            typeName: "String",
            property: w,
            path: y.path.of(w),
            value: _
          })), !1);
        }, this.number = function(w, _) {
          var b = y.obj[w];
          return _ && !(w in y.obj) ? !0 : y.exists(w) ? typeof b == "number" && !Number.isNaN(b) ? !0 : (y.catch((0, t.typeMismatchError)({
            typeName: "Number",
            property: w,
            path: y.path.of(w),
            value: b
          })), !1) : !1;
        }, this.array = function(w) {
          var _ = y.obj[w];
          return w && !y.exists(w) ? !1 : Array.isArray(_) ? !0 : (y.catch((0, t.typeMismatchError)({
            typeName: "Array",
            property: w,
            path: y.path.of(w),
            value: _
          })), !1);
        }, this.enum = function(w, _) {
          var b = y.obj[w];
          return typeof b == "string" && _.includes(b) ? !0 : (y.catch((0, t.enumError)({
            expected: _,
            value: b,
            path: y.path.of(w)
          })), !1);
        }, this.empty = function(w) {
          if (!y.array(w))
            return !1;
          var _ = y.obj[w];
          return _.length === 0 ? !0 : (y.catch((0, t.maxSizeError)({
            max: 0,
            value: _,
            path: y.path.of(w)
          })), !1);
        }, this.minLength = function(w, _) {
          if (!y.array(w))
            return !1;
          var b = y.obj[w];
          return b.length >= _ ? !0 : (y.catch((0, t.minSizeError)({
            min: _,
            value: b,
            path: y.path.of(w)
          })), !1);
        }, this.noAdditionalProperties = function(w) {
          var _ = Object.keys(y.obj).sort().filter(function(b) {
            return !w.includes(b);
          });
          return _.forEach(function(b) {
            return y.catch((0, t.unknownPropertyError)({
              property: b,
              path: y.path.of(b)
            }));
          }), _.length === 0;
        }, this.each = function(w, _) {
          if (y.array(w)) {
            var b = y.obj[w], S = !1;
            b.forEach(function(O, E) {
              if (!S) {
                var P = _(O, y.path.of(w).of(E));
                P.length > 0 && (S = !0), y.catch.apply(y, d(P));
              }
            });
          }
        };
      }
      return o(g, [
        {
          key: "errors",
          get: function() {
            var v = this, y = function(x) {
              return JSON.stringify({
                details: x.details,
                path: x.path
              });
            };
            return this._errors.filter(function(x, w) {
              return v._errors.findIndex(function(_) {
                return y(x) === y(_);
              }) === w;
            });
          }
        }
      ]), g;
    })();
  })(Rp)), Rp;
}
var $p = {}, bP;
function cre() {
  return bP || (bP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(j, C) {
      for (var N in C) Object.defineProperty(j, N, {
        enumerable: !0,
        get: Object.getOwnPropertyDescriptor(C, N).get
      });
    }
    t(e, {
      get EntityLinkAssertion() {
        return O;
      },
      get HyperLinkAssertion() {
        return E;
      },
      get NodeAssertion() {
        return S;
      },
      get VOID_CONTENT() {
        return b;
      },
      get assert() {
        return P;
      },
      get assertLink() {
        return R;
      }
    });
    var n = Dx();
    function r(j, C) {
      (C == null || C > j.length) && (C = j.length);
      for (var N = 0, k = new Array(C); N < C; N++) k[N] = j[N];
      return k;
    }
    function i(j) {
      if (Array.isArray(j)) return r(j);
    }
    function a(j) {
      if (j === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return j;
    }
    function o(j, C, N) {
      return C = f(C), p(j, _() ? Reflect.construct(C, N || [], f(j).constructor) : C.apply(j, N));
    }
    function s(j, C) {
      if (!(j instanceof C))
        throw new TypeError("Cannot call a class as a function");
    }
    function c(j, C) {
      for (var N = 0; N < C.length; N++) {
        var k = C[N];
        k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(j, k.key, k);
      }
    }
    function l(j, C, N) {
      return C && c(j.prototype, C), j;
    }
    function d(j, C, N) {
      return C in j ? Object.defineProperty(j, C, {
        value: N,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : j[C] = N, j;
    }
    function f(j) {
      return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(N) {
        return N.__proto__ || Object.getPrototypeOf(N);
      }, f(j);
    }
    function h(j, C) {
      if (typeof C != "function" && C !== null)
        throw new TypeError("Super expression must either be null or a function");
      j.prototype = Object.create(C && C.prototype, {
        constructor: {
          value: j,
          writable: !0,
          configurable: !0
        }
      }), C && v(j, C);
    }
    function m(j) {
      if (typeof Symbol < "u" && j[Symbol.iterator] != null || j["@@iterator"] != null) return Array.from(j);
    }
    function g() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function p(j, C) {
      return C && (x(C) === "object" || typeof C == "function") ? C : a(j);
    }
    function v(j, C) {
      return v = Object.setPrototypeOf || function(k, I) {
        return k.__proto__ = I, k;
      }, v(j, C);
    }
    function y(j) {
      return i(j) || m(j) || w(j) || g();
    }
    function x(j) {
      "@swc/helpers - typeof";
      return j && typeof Symbol < "u" && j.constructor === Symbol ? "symbol" : typeof j;
    }
    function w(j, C) {
      if (j) {
        if (typeof j == "string") return r(j, C);
        var N = Object.prototype.toString.call(j).slice(8, -1);
        if (N === "Object" && j.constructor && (N = j.constructor.name), N === "Map" || N === "Set") return Array.from(N);
        if (N === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(N)) return r(j, C);
      }
    }
    function _() {
      try {
        var j = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (_ = function() {
        return !!j;
      })();
    }
    var b = [], S = /* @__PURE__ */ (function() {
      function j(C, N) {
        s(this, j), d(this, "contentRule", void 0), d(this, "validateData", void 0), this.contentRule = C, this.validateData = N;
      }
      return l(j, [
        {
          key: "assert",
          value: function(N, k) {
            var I = new n.ObjectAssertion(N, k);
            if (!I.object())
              return I.errors;
            I.noAdditionalProperties([
              "nodeType",
              "data",
              "content"
            ]);
            var $ = Array.isArray(this.contentRule) ? {
              nodeTypes: this.contentRule
            } : this.contentRule(N, k), z = $.nodeTypes, V = $.min, K = V === void 0 ? 0 : V;
            if (z.length === 0 && K > 0)
              throw new Error("Invalid content rule. Cannot have enforce a 'min' of ".concat(K, " with no nodeTypes"));
            if (I.minLength("content", K), z.length === 0 ? I.empty("content") : I.each("content", function(ie, he) {
              var ee = new n.ObjectAssertion(ie, he);
              return ee.object() && ee.enum("nodeType", z), ee.errors;
            }), I.object("data")) {
              var D, U, Y, X, oe = (U = (Y = (X = this).validateData) === null || Y === void 0 ? void 0 : Y.call(X, N.data, k.of("data"))) !== null && U !== void 0 ? U : [];
              (D = I).catch.apply(D, y(oe));
            }
            return I.errors;
          }
        }
      ]), j;
    })(), O = /* @__PURE__ */ (function(j) {
      h(C, j);
      function C(N, k) {
        s(this, C);
        var I;
        return I = o(this, C, [
          k,
          function($, z) {
            return a(I).assertLink($, z);
          }
        ]), d(I, "linkType", void 0), d(I, "type", void 0), d(I, "assertLink", void 0), I.linkType = N, I.assertLink = function($, z) {
          var V = new n.ObjectAssertion($, z);
          if (V.object("target")) {
            var K, D = new n.ObjectAssertion($.target.sys, z.of("target").of("sys"));
            D.object() && (D.enum("type", [
              I.type
            ]), D.enum("linkType", [
              I.linkType
            ]), I.type === "Link" ? (D.string("id"), D.noAdditionalProperties([
              "type",
              "linkType",
              "id"
            ])) : I.type === "ResourceLink" && (D.string("urn"), D.noAdditionalProperties([
              "type",
              "linkType",
              "urn"
            ]))), (K = V).catch.apply(K, y(D.errors));
          }
          return V.noAdditionalProperties([
            "target"
          ]), V.errors;
        }, I.type = I.linkType.startsWith("Contentful:") ? "ResourceLink" : "Link", I;
      }
      return C;
    })(S), E = /* @__PURE__ */ (function(j) {
      h(C, j);
      function C() {
        s(this, C);
        var N;
        return N = o(this, C, [
          [
            "text"
          ],
          function(k, I) {
            return a(N).assertLink(k, I);
          }
        ]), d(N, "assertLink", function(k, I) {
          var $ = new n.ObjectAssertion(k, I);
          return $.string("uri"), $.noAdditionalProperties([
            "uri"
          ]), $.errors;
        }), N;
      }
      return C;
    })(S), P = function(j, C) {
      return new S(j, C);
    }, R = function(j, C) {
      return new O(j, C);
    };
  })($p)), $p;
}
var Bp = {}, xP;
function lre() {
  return xP || (xP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "Path", {
      enumerable: !0,
      get: function() {
        return l;
      }
    });
    function t(d, f) {
      (f == null || f > d.length) && (f = d.length);
      for (var h = 0, m = new Array(f); h < f; h++) m[h] = d[h];
      return m;
    }
    function n(d) {
      if (Array.isArray(d)) return t(d);
    }
    function r(d, f) {
      if (!(d instanceof f))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(d, f, h) {
      return f in d ? Object.defineProperty(d, f, {
        value: h,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : d[f] = h, d;
    }
    function a(d) {
      if (typeof Symbol < "u" && d[Symbol.iterator] != null || d["@@iterator"] != null) return Array.from(d);
    }
    function o() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function s(d) {
      return n(d) || a(d) || c(d) || o();
    }
    function c(d, f) {
      if (d) {
        if (typeof d == "string") return t(d, f);
        var h = Object.prototype.toString.call(d).slice(8, -1);
        if (h === "Object" && d.constructor && (h = d.constructor.name), h === "Map" || h === "Set") return Array.from(h);
        if (h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h)) return t(d, f);
      }
    }
    var l = function d() {
      var f = this, h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      r(this, d), i(this, "path", void 0), i(this, "of", void 0), i(this, "isRoot", void 0), i(this, "last", void 0), i(this, "toArray", void 0), this.path = h, this.of = function(m) {
        return new d(s(f.path).concat([
          m
        ]));
      }, this.isRoot = function() {
        return f.path.length === 0;
      }, this.last = function() {
        return f.path[f.path.length - 1];
      }, this.toArray = function() {
        return f.path;
      };
    };
  })(Bp)), Bp;
}
var Fp = {}, wP;
function ure() {
  return wP || (wP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "assertText", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    var t = Dx();
    function n(r, i) {
      var a = new t.ObjectAssertion(r, i);
      return a.object() && (a.noAdditionalProperties([
        "nodeType",
        "data",
        "value",
        "marks"
      ]), a.object("data"), a.each("marks", function(o, s) {
        var c = new t.ObjectAssertion(o, s);
        return c.object() && c.string("type"), c.errors;
      }), a.string("value")), a.errors;
    }
  })(Fp)), Fp;
}
var _P;
function dre() {
  return _P || (_P = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "validateRichTextDocument", {
      enumerable: !0,
      get: function() {
        return S;
      }
    });
    var t = xc(), n = qd(), r = WD(), i = Dx(), a = cre(), o = lre(), s = ure();
    function c(O, E) {
      (E == null || E > O.length) && (E = O.length);
      for (var P = 0, R = new Array(E); P < E; P++) R[P] = O[P];
      return R;
    }
    function l(O) {
      if (Array.isArray(O)) return c(O);
    }
    function d(O, E, P) {
      return E in O ? Object.defineProperty(O, E, {
        value: P,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : O[E] = P, O;
    }
    function f(O) {
      if (typeof Symbol < "u" && O[Symbol.iterator] != null || O["@@iterator"] != null) return Array.from(O);
    }
    function h() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function m(O) {
      return l(O) || f(O) || g(O) || h();
    }
    function g(O, E) {
      if (O) {
        if (typeof O == "string") return c(O, E);
        var P = Object.prototype.toString.call(O).slice(8, -1);
        if (P === "Object" && O.constructor && (P = O.constructor.name), P === "Map" || P === "Set") return Array.from(P);
        if (P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P)) return c(O, E);
      }
    }
    var p = (0, a.assert)(m(Object.values(n.INLINES)).concat([
      "text"
    ]).sort()), v = (0, a.assert)([
      t.BLOCKS.LIST_ITEM
    ]), y = (0, a.assertLink)("Entry", a.VOID_CONTENT), x = (0, a.assert)(function() {
      return {
        nodeTypes: [
          t.BLOCKS.PARAGRAPH
        ],
        min: 1
      };
    }, function(O, E) {
      var P = new i.ObjectAssertion(O, E);
      return P.noAdditionalProperties([
        "colspan",
        "rowspan"
      ]), P.number("colspan", !0), P.number("rowspan", !0), P.errors;
    }), w, _ = (w = {}, d(w, t.BLOCKS.DOCUMENT, (0, a.assert)(r.TOP_LEVEL_BLOCKS)), d(w, t.BLOCKS.PARAGRAPH, p), d(w, t.BLOCKS.HEADING_1, p), d(w, t.BLOCKS.HEADING_2, p), d(w, t.BLOCKS.HEADING_3, p), d(w, t.BLOCKS.HEADING_4, p), d(w, t.BLOCKS.HEADING_5, p), d(w, t.BLOCKS.HEADING_6, p), d(w, t.BLOCKS.QUOTE, (0, a.assert)(r.CONTAINERS[t.BLOCKS.QUOTE])), d(w, t.BLOCKS.EMBEDDED_ENTRY, y), d(w, t.BLOCKS.EMBEDDED_ASSET, (0, a.assertLink)("Asset", a.VOID_CONTENT)), d(w, t.BLOCKS.EMBEDDED_RESOURCE, (0, a.assertLink)("Contentful:Entry", a.VOID_CONTENT)), d(w, t.BLOCKS.HR, (0, a.assert)(a.VOID_CONTENT)), d(w, t.BLOCKS.OL_LIST, v), d(w, t.BLOCKS.UL_LIST, v), d(w, t.BLOCKS.LIST_ITEM, (0, a.assert)(m(r.LIST_ITEM_BLOCKS).sort())), d(w, t.BLOCKS.TABLE, (0, a.assert)(function() {
      return {
        nodeTypes: [
          t.BLOCKS.TABLE_ROW
        ],
        min: 1
      };
    })), d(w, t.BLOCKS.TABLE_ROW, (0, a.assert)(function() {
      return {
        nodeTypes: [
          t.BLOCKS.TABLE_CELL,
          t.BLOCKS.TABLE_HEADER_CELL
        ],
        min: 1
      };
    })), d(w, t.BLOCKS.TABLE_CELL, x), d(w, t.BLOCKS.TABLE_HEADER_CELL, x), d(w, n.INLINES.HYPERLINK, new a.HyperLinkAssertion()), d(w, n.INLINES.EMBEDDED_ENTRY, y), d(w, n.INLINES.EMBEDDED_RESOURCE, (0, a.assertLink)("Contentful:Entry", a.VOID_CONTENT)), d(w, n.INLINES.ENTRY_HYPERLINK, (0, a.assertLink)("Entry", [
      "text"
    ])), d(w, n.INLINES.ASSET_HYPERLINK, (0, a.assertLink)("Asset", [
      "text"
    ])), d(w, n.INLINES.RESOURCE_HYPERLINK, (0, a.assertLink)("Contentful:Entry", [
      "text"
    ])), w);
    function b(O, E) {
      if (O.nodeType === "text")
        return (0, s.assertText)(O, E);
      var P = _[O.nodeType].assert(O, E);
      if (P.length > 0)
        return P;
      var R = new i.ObjectAssertion(O, E);
      return R.each("content", function(j, C) {
        return b(j, C);
      }), R.errors;
    }
    var S = function(O) {
      var E = new o.Path(), P = new i.ObjectAssertion(O, E);
      return P.object() && P.enum("nodeType", [
        t.BLOCKS.DOCUMENT
      ]), P.errors.length > 0 ? P.errors : b(O, E);
    };
  })(kp)), kp;
}
var SP;
function fre() {
  return SP || (SP = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(f, h) {
      for (var m in h) Object.defineProperty(f, m, {
        enumerable: !0,
        get: Object.getOwnPropertyDescriptor(h, m).get
      });
    }
    t(e, {
      get BLOCKS() {
        return n.BLOCKS;
      },
      get EMPTY_DOCUMENT() {
        return a.EMPTY_DOCUMENT;
      },
      get INLINES() {
        return r.INLINES;
      },
      get MARKS() {
        return i.MARKS;
      },
      get helpers() {
        return o;
      },
      get validateRichTextDocument() {
        return s.validateRichTextDocument;
      }
    });
    var n = xc(), r = qd(), i = VD();
    c(WD(), e), c(rre(), e), c(ire(), e);
    var a = are(), o = /* @__PURE__ */ d(ore()), s = dre();
    function c(f, h) {
      return Object.keys(f).forEach(function(m) {
        m !== "default" && !Object.prototype.hasOwnProperty.call(h, m) && Object.defineProperty(h, m, {
          enumerable: !0,
          get: function() {
            return f[m];
          }
        });
      }), f;
    }
    function l(f) {
      if (typeof WeakMap != "function") return null;
      var h = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap();
      return (l = function(g) {
        return g ? m : h;
      })(f);
    }
    function d(f, h) {
      if (f && f.__esModule)
        return f;
      if (f === null || typeof f != "object" && typeof f != "function")
        return {
          default: f
        };
      var m = l(h);
      if (m && m.has(f))
        return m.get(f);
      var g = {
        __proto__: null
      }, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var v in f)
        if (v !== "default" && Object.prototype.hasOwnProperty.call(f, v)) {
          var y = p ? Object.getOwnPropertyDescriptor(f, v) : null;
          y && (y.get || y.set) ? Object.defineProperty(g, v, y) : g[v] = f[v];
        }
      return g.default = f, m && m.set(f, g), g;
    }
  })(Ap)), Ap;
}
var OP;
function hre() {
  if (OP) return Ep;
  OP = 1;
  var e = T, t = fre();
  function n(d, f) {
    return e.isValidElement(d) && d.key === null ? e.cloneElement(d, {
      key: f
    }) : d;
  }
  function r(d, f) {
    return d.map((h, m) => n(i(h, f), m));
  }
  function i(d, f) {
    const { renderNode: h, renderMark: m, renderText: g, preserveWhitespace: p } = f;
    if (t.helpers.isText(d)) {
      let v = g ? g(d.value) : d.value;
      if (p && !g) {
        v = v.replace(/ {2,}/g, (w) => " ".repeat(w.length));
        const y = v.split(`
`), x = [];
        y.forEach((w, _) => {
          x.push(w), _ !== y.length - 1 && x.push(e.createElement("br", null));
        }), v = x;
      }
      return d.marks.reduce((y, x) => m[x.type] ? m[x.type](y) : y, v);
    } else {
      const v = r(d.content, f);
      return !d.nodeType || !h[d.nodeType] ? e.createElement(e.Fragment, null, v) : h[d.nodeType](d, v);
    }
  }
  const a = {
    [t.BLOCKS.DOCUMENT]: (d, f) => f,
    [t.BLOCKS.PARAGRAPH]: (d, f) => e.createElement("p", null, f),
    [t.BLOCKS.HEADING_1]: (d, f) => e.createElement("h1", null, f),
    [t.BLOCKS.HEADING_2]: (d, f) => e.createElement("h2", null, f),
    [t.BLOCKS.HEADING_3]: (d, f) => e.createElement("h3", null, f),
    [t.BLOCKS.HEADING_4]: (d, f) => e.createElement("h4", null, f),
    [t.BLOCKS.HEADING_5]: (d, f) => e.createElement("h5", null, f),
    [t.BLOCKS.HEADING_6]: (d, f) => e.createElement("h6", null, f),
    [t.BLOCKS.EMBEDDED_ENTRY]: (d, f) => e.createElement("div", null, f),
    [t.BLOCKS.EMBEDDED_RESOURCE]: (d, f) => e.createElement("div", null, f),
    [t.BLOCKS.UL_LIST]: (d, f) => e.createElement("ul", null, f),
    [t.BLOCKS.OL_LIST]: (d, f) => e.createElement("ol", null, f),
    [t.BLOCKS.LIST_ITEM]: (d, f) => e.createElement("li", null, f),
    [t.BLOCKS.QUOTE]: (d, f) => e.createElement("blockquote", null, f),
    [t.BLOCKS.HR]: () => e.createElement("hr", null),
    [t.BLOCKS.TABLE]: (d, f) => e.createElement("table", null, e.createElement("tbody", null, f)),
    [t.BLOCKS.TABLE_ROW]: (d, f) => e.createElement("tr", null, f),
    [t.BLOCKS.TABLE_HEADER_CELL]: (d, f) => e.createElement("th", null, f),
    [t.BLOCKS.TABLE_CELL]: (d, f) => e.createElement("td", null, f),
    [t.INLINES.ASSET_HYPERLINK]: (d) => s(t.INLINES.ASSET_HYPERLINK, d),
    [t.INLINES.ENTRY_HYPERLINK]: (d) => s(t.INLINES.ENTRY_HYPERLINK, d),
    [t.INLINES.RESOURCE_HYPERLINK]: (d) => c(t.INLINES.RESOURCE_HYPERLINK, d),
    [t.INLINES.EMBEDDED_ENTRY]: (d) => s(t.INLINES.EMBEDDED_ENTRY, d),
    [t.INLINES.EMBEDDED_RESOURCE]: (d, f) => c(t.INLINES.EMBEDDED_RESOURCE, d),
    [t.INLINES.HYPERLINK]: (d, f) => e.createElement("a", {
      href: d.data.uri
    }, f)
  }, o = {
    [t.MARKS.BOLD]: (d) => e.createElement("b", null, d),
    [t.MARKS.ITALIC]: (d) => e.createElement("i", null, d),
    [t.MARKS.UNDERLINE]: (d) => e.createElement("u", null, d),
    [t.MARKS.CODE]: (d) => e.createElement("code", null, d),
    [t.MARKS.SUPERSCRIPT]: (d) => e.createElement("sup", null, d),
    [t.MARKS.SUBSCRIPT]: (d) => e.createElement("sub", null, d),
    [t.MARKS.STRIKETHROUGH]: (d) => e.createElement("s", null, d)
  };
  function s(d, f) {
    return e.createElement("span", {
      key: f.data.target.sys.id
    }, "type: ", f.nodeType, " id: ", f.data.target.sys.id);
  }
  function c(d, f) {
    return e.createElement("span", {
      key: f.data.target.sys.urn
    }, "type: ", f.nodeType, " urn: ", f.data.target.sys.urn);
  }
  function l(d, f = {}) {
    if (!d)
      return null;
    let h = d;
    return f.stripEmptyTrailingParagraph && (h = t.helpers.stripEmptyTrailingParagraphFromDocument(d)), i(h, {
      renderNode: {
        ...a,
        ...f.renderNode
      },
      renderMark: {
        ...o,
        ...f.renderMark
      },
      renderText: f.renderText,
      preserveWhitespace: f.preserveWhitespace
    });
  }
  return Ep.documentToReactComponents = l, Ep;
}
var mre = hre(), vre = /* @__PURE__ */ (function(e) {
  return e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code", e.SUPERSCRIPT = "superscript", e.SUBSCRIPT = "subscript", e.STRIKETHROUGH = "strikethrough", e;
})({}), pre = Object.defineProperty, kx = (e, t) => pre(e, "name", { value: t, configurable: !0 });
function UD(e) {
  let t = 0, n = 0;
  return { preserveWhitespace: !0, stripEmptyTrailingParagraph: !0, renderMark: { [vre.STRIKETHROUGH]: (r) => u.jsx("mark", { children: r }) }, renderText: kx((r) => r.split(`
`).flatMap((i, a, o) => a === o.length - 1 ? [i] : [i, u.jsx("br", {}, `br-${n++}`)]), "renderText"), renderNode: { [i2.PARAGRAPH]: (r, i) => {
    const a = !i || [i].flat(2).every((o) => o === "" || o === null || o === void 0);
    return e ? a ? u.jsx("br", {}, `empty-p-${t++}`) : i : u.jsx("p", { children: i }, `p-${t++}`);
  } } };
}
kx(UD, "createRenderOptions");
function ss(e) {
  return e.richText ? mre.documentToReactComponents(e.richText, UD(e.suppressParagraphs ?? !0)) : null;
}
kx(ss, "RichTextRenderer");
function HD(e) {
  const t = e === "black";
  return {
    headlineColor: t ? "white" : "black",
    textColor: t ? "alabastergrey" : "black"
  };
}
const gre = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null
};
function yre(e, t) {
  const n = e.scrollSnapList();
  return typeof t == "number" ? n.map(() => t) : t(n, e);
}
function bre(e, t) {
  const n = e.rootNode();
  return t && t(n) || n;
}
function Rx(e = {}) {
  let t, n, r, i, a = null, o = 0, s = !1, c = !1, l = !1, d = !1;
  function f(k, I) {
    n = k;
    const {
      mergeOptions: $,
      optionsAtMedia: z
    } = I, V = $(gre, Rx.globalOptions), K = $(V, e);
    if (t = z(K), n.scrollSnapList().length <= 1) return;
    d = t.jump, r = !1, i = yre(n, t.delay);
    const {
      eventStore: D,
      ownerDocument: U
    } = n.internalEngine(), Y = !!n.internalEngine().options.watchDrag, X = bre(n, t.rootNode);
    D.add(U, "visibilitychange", y), Y && n.on("pointerDown", w), Y && !t.stopOnInteraction && n.on("pointerUp", _), t.stopOnMouseEnter && D.add(X, "mouseenter", b), t.stopOnMouseEnter && !t.stopOnInteraction && D.add(X, "mouseleave", S), t.stopOnFocusIn && n.on("slideFocusStart", v), t.stopOnFocusIn && !t.stopOnInteraction && D.add(n.containerNode(), "focusout", p), t.playOnInit && p();
  }
  function h() {
    n.off("pointerDown", w).off("pointerUp", _).off("slideFocusStart", v), v(), r = !0, s = !1;
  }
  function m() {
    const {
      ownerWindow: k
    } = n.internalEngine();
    k.clearTimeout(o), o = k.setTimeout(j, i[n.selectedScrollSnap()]), a = (/* @__PURE__ */ new Date()).getTime(), n.emit("autoplay:timerset");
  }
  function g() {
    const {
      ownerWindow: k
    } = n.internalEngine();
    k.clearTimeout(o), o = 0, a = null, n.emit("autoplay:timerstopped");
  }
  function p() {
    if (!r) {
      if (x()) {
        l = !0;
        return;
      }
      s || n.emit("autoplay:play"), m(), s = !0;
    }
  }
  function v() {
    r || (s && n.emit("autoplay:stop"), g(), s = !1);
  }
  function y() {
    if (x())
      return l = s, v();
    l && p();
  }
  function x() {
    const {
      ownerDocument: k
    } = n.internalEngine();
    return k.visibilityState === "hidden";
  }
  function w() {
    c || v();
  }
  function _() {
    c || p();
  }
  function b() {
    c = !0, v();
  }
  function S() {
    c = !1, p();
  }
  function O(k) {
    typeof k < "u" && (d = k), p();
  }
  function E() {
    s && v();
  }
  function P() {
    s && p();
  }
  function R() {
    return s;
  }
  function j() {
    const {
      index: k
    } = n.internalEngine(), I = k.clone().add(1).get(), $ = n.scrollSnapList().length - 1, z = t.stopOnLastSnap && I === $;
    if (n.canScrollNext() ? n.scrollNext(d) : n.scrollTo(0, d), n.emit("autoplay:select"), z) return v();
    p();
  }
  function C() {
    if (!a) return null;
    const k = i[n.selectedScrollSnap()], I = (/* @__PURE__ */ new Date()).getTime() - a;
    return k - I;
  }
  return {
    name: "autoplay",
    options: e,
    init: f,
    destroy: h,
    play: O,
    stop: E,
    reset: P,
    isPlaying: R,
    timeUntilNext: C
  };
}
Rx.globalOptions = void 0;
const EP = {
  "primary-large": "9:11",
  "primary-medium": "3:4",
  "primary-small": "1:1",
  secondary: "16:9",
  "secondary-image-full": "1:1"
}, AP = yt("relative flex flex-col overflow-hidden rounded-md", {
  variants: {
    variant: {
      "primary-large": "h-full w-full",
      "primary-medium": "h-full w-full",
      "primary-small": "h-full w-full",
      secondary: "min-h-full w-full gap-2 border border-border bg-background p-5 shadow",
      "secondary-image-full": "min-h-full w-full gap-2 bg-background"
    }
  }
}), PP = yt("relative w-full overflow-hidden", {
  variants: {
    variant: {
      "primary-large": "h-full w-full",
      "primary-medium": "h-full",
      secondary: "mb-2 rounded-md",
      "primary-small": "h-full",
      "secondary-image-full": "w-full rounded-md"
    }
  }
}), CP = yt("", {
  variants: {
    variant: {
      "primary-large": "absolute inset-0 flex flex-col justify-end bg-[linear-gradient(180deg,rgba(0,0,0,0)_50%,rgba(0,0,0,0.9)_100%)] p-5",
      "primary-medium": "absolute inset-0 flex flex-col justify-end bg-[linear-gradient(180deg,rgba(0,0,0,0)_50%,rgba(0,0,0,0.9)_100%)] p-5",
      secondary: "flex flex-1 flex-col justify-between",
      "primary-small": "absolute inset-0 flex flex-col justify-end bg-[linear-gradient(180deg,rgba(0,0,0,0)_50%,rgba(0,0,0,0.9)_100%)] p-5",
      "secondary-image-full": "flex flex-1 flex-col justify-between"
    }
  }
});
function YD(e) {
  const t = e.variant;
  return t === "secondary" || t === "secondary-image-full" ? /* @__PURE__ */ u.jsxs("div", { className: J(AP({ variant: t })), children: [
    /* @__PURE__ */ u.jsx("div", { className: J(PP({ variant: t })), children: e.overlayImage && /* @__PURE__ */ u.jsx(
      Xt,
      {
        alt: e.overlayImage.alt,
        aspectRatio: EP[t],
        fill: !0,
        src: e.overlayImage.url
      }
    ) }),
    /* @__PURE__ */ u.jsxs("div", { className: J(CP({ variant: t })), children: [
      /* @__PURE__ */ u.jsxs("div", { className: "mt-2 mb-2", children: [
        /* @__PURE__ */ u.jsx(B, { color: "black", variant: "h4", children: e.title }),
        e.description && /* @__PURE__ */ u.jsx(
          "div",
          {
            className: J(
              "mt-2 mb-2",
              t === "secondary-image-full" && "line-clamp-3 overflow-hidden"
            ),
            children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm", children: e.description })
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "mt-2", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          href: e.button.href,
          onClick: e.button.onClick,
          variant: "default",
          children: e.button.text
        }
      ) })
    ] })
  ] }) : /* @__PURE__ */ u.jsx("div", { className: AP({ variant: t }), children: /* @__PURE__ */ u.jsxs("div", { className: PP({ variant: t }), children: [
    e.overlayImage && /* @__PURE__ */ u.jsx(
      Xt,
      {
        alt: e.overlayImage.alt,
        "aria-hidden": "true",
        aspectRatio: EP[t],
        className: "pointer-events-none absolute inset-0 h-full w-full rounded-md object-cover",
        fill: !0,
        src: e.overlayImage.url
      }
    ),
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: J(
          CP({ variant: t }),
          t === "primary-small" && "text-center"
        ),
        children: [
          /* @__PURE__ */ u.jsx(B, { color: "white", variant: "h3", children: e.title }),
          e.description && /* @__PURE__ */ u.jsx("div", { className: "mb-4", children: /* @__PURE__ */ u.jsx(B, { color: "white", variant: "body-md", children: e.description }) }),
          /* @__PURE__ */ u.jsx(
            "div",
            {
              className: J(
                t === "primary-small" && "mt-2 flex justify-center"
              ),
              children: /* @__PURE__ */ u.jsx(
                ve,
                {
                  className: J(
                    t === "primary-large" && "rounded-md bg-muted text-foreground shadow-sm",
                    t === "primary-small" && "px-3"
                  ),
                  href: e.button.href,
                  onClick: e.button.onClick,
                  variant: "outline",
                  children: e.button.text
                }
              )
            }
          )
        ]
      }
    )
  ] }) });
}
const xre = 3, Wo = 100, wre = 5e3, _re = "(prefers-reduced-motion: reduce)", KD = A.createContext(null);
function GD() {
  const e = A.useContext(KD);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
function Sre(e) {
  const [t, n] = A.useState(
    !e.disableDragWhenNotScrollable
  ), r = A.useMemo(
    () => Rx({
      delay: e.autoplayDelay ?? wre,
      playOnInit: !1,
      stopOnFocusIn: !0,
      stopOnInteraction: !0,
      stopOnLastSnap: e.behavior !== "carousel",
      stopOnMouseEnter: !0
    }),
    [e.autoplayDelay, e.behavior]
  ), i = A.useMemo(
    () => e.autoplay ? [r] : [],
    [r, e.autoplay]
  ), [a, o] = a2(
    {
      align: "start",
      dragFree: e.dragFree,
      loop: e.behavior === "carousel",
      watchDrag: e.disableDragWhenNotScrollable ? t : !0
    },
    i
  ), [s, c] = A.useState(!1), [l, d] = A.useState(!1), [f, h] = A.useState(0), [m, g] = A.useState(0), p = A.useCallback(() => {
    r.stop();
  }, [r]), v = A.useCallback(
    (I) => {
      I && (c(I.canScrollPrev()), d(I.canScrollNext()), e.showPagination && (h(I.selectedScrollSnap()), g(I.scrollSnapList().length)));
    },
    [e.showPagination]
  ), y = A.useCallback(() => {
    p(), o?.scrollPrev();
  }, [o, p]), x = A.useCallback(() => {
    p(), o?.scrollNext();
  }, [o, p]), w = A.useCallback(
    (I) => {
      p(), o?.scrollTo(I);
    },
    [o, p]
  ), _ = A.useCallback(
    (I) => {
      I.key === "ArrowLeft" ? (I.preventDefault(), y()) : I.key === "ArrowRight" && (I.preventDefault(), x());
    },
    [y, x]
  );
  A.useEffect(() => {
    if (!o)
      return;
    const I = () => {
      if (!e.disableDragWhenNotScrollable)
        return;
      const $ = o.canScrollPrev() || o.canScrollNext();
      n(
        (z) => z === $ ? z : $
      );
    };
    return v(o), I(), o.on("reInit", v), o.on("select", v), o.on("reInit", I), o.on("select", I), () => {
      o?.off("select", v), o?.off("reInit", v), o?.off("select", I), o?.off("reInit", I);
    };
  }, [o, v, e.disableDragWhenNotScrollable]), A.useEffect(() => {
    if (!(o && e.autoplay))
      return;
    if (typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(_re).matches) {
      r.stop();
      return;
    }
    return r.play(), () => {
      r.stop();
    };
  }, [o, r, e.autoplay]);
  const b = A.useRef(null);
  A.useEffect(() => {
    if (!(e.wheelGestures && b.current))
      return;
    const I = b.current;
    let $ = 0, z;
    const V = (K) => {
      Math.abs(K.deltaX) <= Math.abs(K.deltaY) || (K.preventDefault(), $ += K.deltaX, cancelAnimationFrame(z), z = requestAnimationFrame(() => {
        $ > 0 ? o?.scrollNext() : o?.scrollPrev(), $ = 0;
      }));
    };
    return I.addEventListener("wheel", V, { passive: !1 }), () => {
      I.removeEventListener("wheel", V), cancelAnimationFrame(z);
    };
  }, [o, e.wheelGestures]);
  const S = A.useMemo(
    () => ({
      carouselRef: a,
      api: o,
      scrollPrev: y,
      scrollNext: x,
      scrollTo: w,
      selectedIndex: f,
      scrollSnapCount: m,
      canScrollPrev: s,
      canScrollNext: l
    }),
    [
      a,
      o,
      y,
      x,
      w,
      f,
      m,
      s,
      l
    ]
  ), O = e.showNavigationArrows === void 0 ? !0 : e.showNavigationArrows, E = O || !!e.button, P = e.items ? e.items.length : A.Children.count(e.children), R = e.navigationMinItems ?? xre, j = P >= R, C = e.navigationPlacement ?? "footer", N = j && O && C === "sides", k = e.sideNavigationPosition === "outside";
  return /* @__PURE__ */ u.jsx(KD.Provider, { value: S, children: /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: "relative w-full min-w-0",
      onKeyDownCapture: _,
      ref: b,
      children: [
        /* @__PURE__ */ u.jsx("div", { className: "overflow-hidden px-px", ref: a, children: /* @__PURE__ */ u.jsx("div", { className: "-ml-2 flex", children: e.items ? e.items.map((I, $) => /* @__PURE__ */ u.jsx(
          Ere,
          {
            variant: I.variant,
            children: /* @__PURE__ */ u.jsx(YD, { ...I })
          },
          `${I.title}-${$}`
        )) : e.children }) }),
        N && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx(
            al,
            {
              className: J(
                "-translate-y-1/2 absolute top-1/2 left-2 z-10",
                k && "lg:-left-12 xl:-left-16"
              ),
              disabled: !s,
              label: e.previousSlideText,
              onClick: y,
              side: "previous",
              size: "icon"
            }
          ),
          /* @__PURE__ */ u.jsx(
            al,
            {
              className: J(
                "-translate-y-1/2 absolute top-1/2 right-2 z-10",
                k && "lg:-right-12 xl:-right-16"
              ),
              disabled: !l,
              label: e.nextSlideText,
              onClick: x,
              side: "next",
              size: "icon"
            }
          )
        ] }),
        j && E && /* @__PURE__ */ u.jsxs("div", { className: "mt-5 flex items-center justify-between", children: [
          O && C === "footer" ? /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ u.jsx(
              al,
              {
                disabled: !s,
                label: e.previousSlideText,
                onClick: y,
                side: "previous"
              }
            ),
            /* @__PURE__ */ u.jsx(
              al,
              {
                disabled: !l,
                label: e.nextSlideText,
                onClick: x,
                side: "next"
              }
            )
          ] }) : /* @__PURE__ */ u.jsx("div", {}),
          e.button && /* @__PURE__ */ u.jsx(
            ve,
            {
              href: e.button.href,
              size: "default",
              variant: "secondary",
              children: e.button.text
            }
          )
        ] }),
        e.showPagination && j && (e.navigationLayout === "bars" ? /* @__PURE__ */ u.jsx(
          jP,
          {
            className: e.progressBarClassName,
            indicatorClassName: e.progressIndicatorClassName,
            interactive: !0,
            trackClassName: e.progressTrackClassName
          }
        ) : /* @__PURE__ */ u.jsx(
          Ore,
          {
            activeDotClassName: e.activeDotClassName,
            dotClassName: e.dotClassName
          }
        )),
        e.showProgressBar && !(e.showPagination && e.navigationLayout === "bars") && /* @__PURE__ */ u.jsx(
          jP,
          {
            className: e.progressBarClassName,
            indicatorClassName: e.progressIndicatorClassName,
            interactive: e.interactiveProgressBar,
            trackClassName: e.progressTrackClassName
          }
        )
      ]
    }
  ) });
}
function al({
  className: e,
  disabled: t,
  label: n,
  onClick: r,
  size: i = "icon",
  side: a
}) {
  return /* @__PURE__ */ u.jsxs(
    ve,
    {
      className: e,
      disabled: t,
      onClick: r,
      size: i,
      variant: "outline",
      children: [
        a === "previous" ? /* @__PURE__ */ u.jsx(SC, { className: "size-4" }) : /* @__PURE__ */ u.jsx(bl, { className: "size-4" }),
        /* @__PURE__ */ u.jsx("span", { className: "sr-only", children: n })
      ]
    }
  );
}
function Ore({
  dotClassName: e,
  activeDotClassName: t
}) {
  const { scrollSnapCount: n, selectedIndex: r, scrollTo: i } = GD();
  return n < 2 ? null : /* @__PURE__ */ u.jsx(
    "nav",
    {
      "aria-label": "Slide navigation",
      className: "mt-8 flex justify-center gap-2",
      children: Array.from({ length: n }, (a, o) => /* @__PURE__ */ u.jsx(
        "button",
        {
          "aria-current": r === o ? "true" : void 0,
          "aria-label": `Go to slide ${o + 1}`,
          className: J(
            "size-2 rounded-full bg-black/30 transition-colors",
            e,
            r === o && "bg-black",
            r === o && t
          ),
          onClick: () => i(o),
          type: "button"
        },
        o
      ))
    }
  );
}
function jP({
  className: e,
  trackClassName: t,
  indicatorClassName: n,
  interactive: r = !1
}) {
  const { api: i, canScrollPrev: a, canScrollNext: o, scrollSnapCount: s, scrollTo: c } = GD(), [l, d] = A.useState(Wo), [f, h] = A.useState(0);
  if (A.useEffect(() => {
    if (!i)
      return;
    const y = () => {
      const x = i.rootNode(), w = i.containerNode(), _ = x.clientWidth, b = w.scrollWidth;
      if (!(_ && b)) {
        d(Wo), h(0);
        return;
      }
      const O = Math.min(1, _ / b) * Wo, E = Math.min(Wo, O), P = Wo - E, R = Math.min(1, Math.max(0, i.scrollProgress()));
      d(E), h(R * P);
    };
    return y(), i.on("scroll", y), i.on("select", y), i.on("reInit", y), () => {
      i.off("scroll", y), i.off("select", y), i.off("reInit", y);
    };
  }, [i]), !(a || o))
    return null;
  const g = (y) => {
    if (!(r && s > 1))
      return;
    const x = y.currentTarget.getBoundingClientRect(), w = Math.min(
      1,
      Math.max(0, (y.clientX - x.left) / x.width)
    ), _ = Math.round(w * (s - 1));
    c(_);
  }, p = J(
    "relative h-[2px] w-full max-w-[360px] bg-black/15",
    r && "cursor-pointer",
    t
  ), v = /* @__PURE__ */ u.jsx(
    "div",
    {
      className: J(
        "pointer-events-none absolute top-0 left-0 h-[2px] bg-black",
        n
      ),
      "data-testid": "carousel-progress-indicator",
      style: {
        left: `${f}%`,
        width: `${l}%`
      }
    }
  );
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: J("mt-8 flex justify-center", e),
      "data-testid": "carousel-progress",
      children: r ? /* @__PURE__ */ u.jsx(
        "button",
        {
          "aria-label": "Go to slide",
          className: p,
          "data-testid": "carousel-progress-track",
          onClick: g,
          type: "button",
          children: v
        }
      ) : /* @__PURE__ */ u.jsx("div", { className: p, "data-testid": "carousel-progress-track", children: v })
    }
  );
}
function Ere({
  children: e,
  variant: t
}) {
  const n = t === "primary-large";
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: n ? "h-generic-card-height w-full min-w-0 max-w-generic-card-width shrink-0 grow-0 basis-full pr-4 pl-2 md:basis-1/2 lg:basis-1/2" : "min-w-0 shrink-0 grow-0 basis-4/5 pr-4 pl-2 md:basis-1/2 lg:basis-1/4",
      children: e
    }
  );
}
const Are = 0.75, ol = yt("", {
  variants: {
    columnWidth: {
      8: "col-span-10 col-start-2 md:col-span-8 md:col-start-3",
      10: "col-span-10 col-start-2",
      12: "col-span-12"
    },
    textColumns: {
      1: "columns-1 gap-unit",
      2: "columns-1 gap-unit md:columns-2",
      3: "columns-1 gap-unit md:columns-3",
      4: "columns-2 gap-unit md:columns-4"
    },
    textVariant: {
      "p-xlarge": "",
      "p-large": "",
      p: "",
      "p-small": ""
    },
    backgroundColor: {
      black: "bg-black",
      white: "bg-white",
      whitesmoke: "bg-whitesmoke"
    },
    color: {
      black: "text-black",
      white: "text-white",
      alabastergrey: "text-alabastergrey"
    }
  },
  defaultVariants: {
    columnWidth: 10,
    textColumns: 1,
    textVariant: "p",
    backgroundColor: "white",
    color: "black"
  }
});
function ZD(e) {
  const t = typeof e.value == "string" ? e.value : "", n = Array.isArray(e.content) ? e.content.map(ZD).join("") : "";
  return `${t}${n}`;
}
function Cy(e) {
  return e ? ZD(e) : "";
}
function Pre(e, t) {
  if (e.length <= t)
    return e;
  const n = e.slice(0, t).trimEnd(), r = n.search(/\s+\S*$/), i = Math.floor(
    t * Are
  );
  return r > i ? n.slice(0, r).trimEnd() : n;
}
function XD(e, t) {
  if (!(e && Number.isFinite(t) && t > 0))
    return e;
  let n = t;
  function r(i) {
    if (n <= 0)
      return null;
    if (typeof i.value == "string") {
      if (i.value.length <= n)
        return n -= i.value.length, { ...i };
      const a = Pre(i.value, n);
      return n = 0, {
        ...i,
        value: a
      };
    }
    if (Array.isArray(i.content)) {
      const a = [];
      for (const o of i.content) {
        const s = r(o);
        if (s && a.push(s), n <= 0)
          break;
      }
      return {
        ...i,
        content: a
      };
    }
    return { ...i };
  }
  return r(e);
}
function TP({
  columnWidth: e,
  textColumns: t,
  textVariant: n,
  headline: r,
  headlineVariant: i = "h3",
  headlineDash: a = !0,
  text: o,
  backgroundColor: s,
  headlineColor: c,
  color: l,
  outerContainerOnly: d,
  truncateAt: f,
  truncationMode: h = "expand",
  readMoreLabel: m,
  truncationModalTitle: g,
  ...p
}) {
  const [v, y] = Ee({
    isExpanded: !1,
    isModalOpen: !1
  }), x = o?.text?.json, w = n ?? "p", _ = Cy(r?.headline?.json), b = Cy(x), S = typeof f == "number" && Number.isFinite(f) && f > 0 && b.length > f, O = S ? XD(x, f) : x, E = g || _, P = S && !!m && (h === "expand" || !!E), R = P && !v.isExpanded ? O : x, j = ol({
    columnWidth: null,
    textColumns: null,
    textVariant: null,
    backgroundColor: s,
    color: l
  }), C = ol({
    columnWidth: e,
    textColumns: null,
    textVariant: null,
    backgroundColor: null,
    color: null
  }), N = ol({
    columnWidth: null,
    textColumns: t,
    textVariant: null,
    backgroundColor: null,
    color: null
  }), k = J(
    ol({
      columnWidth: null,
      textColumns: null,
      textVariant: null,
      backgroundColor: null,
      color: l
    }),
    un[w],
    "mt-1 inline cursor-pointer bg-transparent p-0 text-left font-brand underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
  ), I = () => {
    if (h === "modal") {
      y(($) => ({
        ...$,
        isModalOpen: !0
      }));
      return;
    }
    y(($) => ({
      ...$,
      isExpanded: !0
    }));
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      kd,
      {
        className: J(j, "component-text-section -mb-px"),
        fullWidth: !0,
        id: p.anchorId,
        outerContainerOnly: d,
        paddingBottom: p.paddingBottom,
        paddingTop: p.paddingTop,
        children: /* @__PURE__ */ u.jsx(Rd, { className: "gap-0", children: /* @__PURE__ */ u.jsxs(Dd, { className: J(C), children: [
          r && /* @__PURE__ */ u.jsx(
            os,
            {
              color: c,
              dash: a,
              variant: i,
              children: /* @__PURE__ */ u.jsx(ss, { richText: r.headline?.json })
            }
          ),
          x && /* @__PURE__ */ u.jsxs("div", { className: N, children: [
            /* @__PURE__ */ u.jsx(os, { color: l, variant: w, children: /* @__PURE__ */ u.jsx(ss, { richText: R }) }),
            P && !v.isExpanded ? /* @__PURE__ */ u.jsx(
              "button",
              {
                "aria-expanded": h === "expand" ? v.isExpanded : void 0,
                "aria-haspopup": h === "modal" ? "dialog" : void 0,
                className: k,
                onClick: I,
                type: "button",
                children: m
              }
            ) : null
          ] })
        ] }) })
      }
    ),
    P && h === "modal" ? /* @__PURE__ */ u.jsx(
      vc,
      {
        headerCentered: !1,
        isOpen: v.isModalOpen,
        modalClassName: "max-w-2xl p-6 md:max-w-3xl",
        onClose: () => y(($) => ({
          ...$,
          isModalOpen: !1
        })),
        title: E,
        titleAs: "h5",
        titleClassName: "text-base font-semibold leading-8 tracking-normal",
        children: /* @__PURE__ */ u.jsx(os, { color: "black", variant: w, children: /* @__PURE__ */ u.jsx(ss, { richText: x }) })
      }
    ) : null
  ] });
}
const NP = 175;
function Cre(e) {
  const [t, n] = Ee(!1), r = {
    black: "text-black",
    white: "text-white",
    alabastergrey: "text-alabastergrey"
  }, i = Cy(e.image.text?.text?.json).length > NP;
  let a = e.image.text;
  return i && (a = e.image.text ? {
    ...e.image.text,
    text: {
      json: XD(
        e.image.text.text?.json,
        NP
      )
    }
  } : void 0), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      TP,
      {
        backgroundColor: e.backgroundColor,
        color: e.textColor,
        columnWidth: 12,
        headline: e.image.headline,
        headlineColor: e.textColor,
        headlineVariant: "h5",
        outerContainerOnly: !0,
        paddingBottom: "none",
        paddingTop: "small",
        text: a,
        textColumns: 1,
        textVariant: "p-small"
      }
    ),
    e.readMoreLabel && i ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        "button",
        {
          "aria-haspopup": "dialog",
          className: J(
            "mt-1 inline cursor-pointer bg-transparent p-0 text-left font-brand text-sm underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            r[e.textColor]
          ),
          onClick: () => n(!0),
          type: "button",
          children: e.readMoreLabel
        }
      ),
      /* @__PURE__ */ u.jsx(
        vc,
        {
          contentClassName: "min-h-0",
          headerCentered: !1,
          isOpen: t,
          modalClassName: "max-w-2xl p-6 md:max-w-3xl",
          onClose: () => n(!1),
          preventAutoFocus: !0,
          title: e.readMoreModalTitle ?? "",
          titleAs: "h5",
          titleClassName: "text-base font-semibold leading-8 tracking-normal",
          children: /* @__PURE__ */ u.jsxs("div", { className: "flex flex-row gap-6", children: [
            /* @__PURE__ */ u.jsx("div", { className: "w-40 shrink-0", children: /* @__PURE__ */ u.jsx(
              Xt,
              {
                alt: e.image.alt,
                aspectRatio: e.image.aspectRatio || "3:4",
                className: "h-auto w-full",
                loading: "eager",
                objectPosition: e.image.objectPosition,
                src: e.image.src,
                srcSet: e.image.srcSet,
                width: 160
              }
            ) }),
            /* @__PURE__ */ u.jsx(
              TP,
              {
                color: "black",
                columnWidth: 12,
                headline: e.image.headline,
                headlineColor: "black",
                headlineDash: !1,
                headlineVariant: "h5",
                outerContainerOnly: !0,
                paddingBottom: "none",
                paddingTop: "none",
                text: e.image.text,
                textColumns: 1,
                textVariant: "p-small"
              }
            )
          ] })
        }
      )
    ] }) : null
  ] });
}
function po(e) {
  const t = !!(e.image.headline || e.image.text), n = e.background ?? "white", { textColor: r } = HD(n);
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      Xt,
      {
        alt: e.image.alt,
        aspectRatio: e.image.aspectRatio || e.defaultAspectRatio || "3:4",
        className: J("h-auto w-full", e.className),
        height: 533,
        objectPosition: e.image.objectPosition,
        sizes: e.sizes,
        src: e.image.src,
        srcSet: e.image.srcSet,
        width: 400
      }
    ),
    t ? /* @__PURE__ */ u.jsx(
      Cre,
      {
        backgroundColor: n,
        image: e.image,
        readMoreLabel: e.readMoreLabel,
        readMoreModalTitle: e.readMoreModalTitle,
        textColor: r
      }
    ) : null
  ] });
}
function jre(e) {
  const t = e.background === "black", n = e.images.length <= e.staticLayoutThreshold, r = e.fullWidth ?? !0, { headlineColor: i } = HD(e.background), a = e.headline && /* @__PURE__ */ u.jsx(os, { color: i, dash: !1, variant: "h4", children: /* @__PURE__ */ u.jsx(ss, { richText: e.headline.headline?.json }) }), o = /* @__PURE__ */ u.jsx("div", { "data-testid": "image-arrangement-row", children: /* @__PURE__ */ u.jsx(
    Sre,
    {
      disableDragWhenNotScrollable: !0,
      dragFree: !0,
      nextSlideText: e.nextSlideText || "Next image",
      previousSlideText: e.previousSlideText || "Previous image",
      progressIndicatorClassName: J(t && "bg-white"),
      progressTrackClassName: J(t && "bg-white/30"),
      showNavigationArrows: !e.hideCarouselNavigationArrows,
      showProgressBar: !0,
      wheelGestures: !0,
      children: e.images.map((s, c) => /* @__PURE__ */ u.jsx(
        "div",
        {
          className: "mx-2 min-w-0 shrink-0 grow-0 basis-[85vw] last:mr-auto sm:basis-80 md:basis-[22.5rem] lg:basis-[25rem]",
          "data-testid": "image-arrangement-row-item",
          children: /* @__PURE__ */ u.jsx("div", { className: "mx-auto w-full max-w-[400px]", children: /* @__PURE__ */ u.jsx(
            po,
            {
              background: e.background,
              image: s,
              readMoreLabel: e.readMoreLabel,
              readMoreModalTitle: e.readMoreModalTitle,
              sizes: "(min-width: 640px) 400px, 85vw"
            }
          ) })
        },
        `${s.src}-${c}`
      ))
    }
  ) });
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: n ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: J("md:hidden"), children: [
      a,
      o
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: J(r && "mx-auto w-fit", "hidden md:block"), children: [
      a,
      /* @__PURE__ */ u.jsx("div", { className: "flex gap-10", "data-testid": "image-arrangement-row", children: e.images.map((s, c) => /* @__PURE__ */ u.jsx(
        "div",
        {
          "data-testid": "image-arrangement-row-item",
          children: /* @__PURE__ */ u.jsx("div", { className: "mx-auto w-full max-w-[364px]", children: /* @__PURE__ */ u.jsx(
            po,
            {
              background: e.background,
              image: s,
              readMoreLabel: e.readMoreLabel,
              readMoreModalTitle: e.readMoreModalTitle,
              sizes: "(min-width: 640px) 364px, 85vw"
            }
          ) })
        },
        `${s.src}-${c}`
      )) })
    ] })
  ] }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    a,
    o
  ] }) });
}
const zp = "gap-4";
function Tre(e) {
  const t = e.images.filter((r, i) => i % 2 === 0), n = e.images.filter((r, i) => i % 2 === 1);
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: `flex ${zp}`,
      "data-testid": "image-arrangement-simple-columns-grid",
      children: [
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: `flex min-w-0 flex-1 flex-col ${zp}`,
            "data-testid": "image-arrangement-simple-columns-column-left",
            children: t.map((r, i) => /* @__PURE__ */ u.jsx(
              "div",
              {
                "data-testid": "image-arrangement-simple-columns-item",
                children: /* @__PURE__ */ u.jsx(
                  po,
                  {
                    background: e.background,
                    defaultAspectRatio: "1:1",
                    image: r,
                    readMoreLabel: e.readMoreLabel,
                    readMoreModalTitle: e.readMoreModalTitle,
                    sizes: "50vw"
                  }
                )
              },
              `${r.src}-left-${i}`
            ))
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: `flex min-w-0 flex-1 flex-col ${zp}`,
            "data-testid": "image-arrangement-simple-columns-column-right",
            children: n.map((r, i) => /* @__PURE__ */ u.jsx(
              "div",
              {
                "data-testid": "image-arrangement-simple-columns-item",
                children: /* @__PURE__ */ u.jsx(
                  po,
                  {
                    background: e.background,
                    defaultAspectRatio: "1:1",
                    image: r,
                    readMoreLabel: e.readMoreLabel,
                    readMoreModalTitle: e.readMoreModalTitle,
                    sizes: "50vw"
                  }
                )
              },
              `${r.src}-right-${i}`
            ))
          }
        )
      ]
    }
  );
}
function Nre(e) {
  const t = e.images.filter((r, i) => i % 2 === 0), n = e.images.filter((r, i) => i % 2 === 1);
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: "flex gap-2 md:gap-10",
      "data-testid": "image-arrangement-staggered-grid",
      children: [
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "flex min-w-0 flex-1 flex-col gap-2 pt-[20%] md:gap-10",
            "data-testid": "image-arrangement-staggered-column-left",
            children: t.map((r, i) => /* @__PURE__ */ u.jsx(
              "div",
              {
                "data-testid": "image-arrangement-staggered-item",
                children: /* @__PURE__ */ u.jsx(
                  po,
                  {
                    background: e.background,
                    image: r,
                    readMoreLabel: e.readMoreLabel,
                    readMoreModalTitle: e.readMoreModalTitle,
                    sizes: "50vw"
                  }
                )
              },
              `${r.src}-left-${i}`
            ))
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: "flex min-w-0 flex-1 flex-col gap-2 md:gap-10",
            "data-testid": "image-arrangement-staggered-column-right",
            children: n.map((r, i) => /* @__PURE__ */ u.jsx(
              "div",
              {
                "data-testid": "image-arrangement-staggered-item",
                children: /* @__PURE__ */ u.jsx(
                  po,
                  {
                    background: e.background,
                    image: r,
                    readMoreLabel: e.readMoreLabel,
                    readMoreModalTitle: e.readMoreModalTitle,
                    sizes: "50vw"
                  }
                )
              },
              `${r.src}-right-${i}`
            ))
          }
        )
      ]
    }
  );
}
const Mre = yt("", {
  variants: {
    background: {
      white: "bg-white",
      whitesmoke: "bg-whitesmoke",
      black: "bg-black"
    }
  },
  defaultVariants: {
    background: "white"
  }
});
function sue(e) {
  if (!e.images.length)
    return null;
  const t = 3, n = e.fullWidth ?? !0, r = e.variant, i = e.background ?? "white", a = Mre({ background: i });
  let o;
  r === "staggered" ? o = /* @__PURE__ */ u.jsx(
    Nre,
    {
      background: i,
      images: e.images,
      readMoreLabel: e.readMoreLabel,
      readMoreModalTitle: e.readMoreModalTitle
    }
  ) : r === "simple-columns" ? o = /* @__PURE__ */ u.jsx(
    Tre,
    {
      background: i,
      images: e.images,
      readMoreLabel: e.readMoreLabel,
      readMoreModalTitle: e.readMoreModalTitle
    }
  ) : o = /* @__PURE__ */ u.jsx(
    jre,
    {
      background: i,
      fullWidth: n,
      headline: e.headline,
      hideCarouselNavigationArrows: !0,
      images: e.images,
      nextSlideText: e.nextSlideText,
      previousSlideText: e.previousSlideText,
      readMoreLabel: e.readMoreLabel,
      readMoreModalTitle: e.readMoreModalTitle,
      staticLayoutThreshold: t
    }
  );
  const s = r === "row" && e.images.length <= t;
  let c;
  return n && r === "row" && !s ? c = "col-span-12 px-0 md:pl-8" : n || r === "staggered" ? c = "col-span-12" : c = "col-span-12 md:col-span-10 md:col-start-2", /* @__PURE__ */ u.jsx(
    kd,
    {
      className: J("component-image-arrangement", a, e.className),
      fullWidth: n,
      outerContainerOnly: n,
      paddingBottom: e.paddingBottom,
      paddingTop: e.paddingTop,
      children: /* @__PURE__ */ u.jsx(Rd, { className: "gap-0", children: /* @__PURE__ */ u.jsx(Dd, { className: c, children: o }) })
    }
  );
}
function QD(e) {
  const t = e.objectFit ?? "cover", n = J(
    e.zoomed === "Yes" && "cursor-zoom-out",
    e.zoomed === "No" && "cursor-zoom-in"
  );
  return /* @__PURE__ */ u.jsx(
    Xt,
    {
      alt: e.alt,
      aspectRatio: "1:1",
      className: J(
        "absolute inset-0 h-full w-full bg-white",
        t === "cover" ? "object-cover" : "object-contain",
        n,
        e.className
      ),
      draggable: e.draggable,
      onClick: e.onClick,
      onLoad: e.onLoad,
      src: e.src
    }
  );
}
const Ire = 50;
function Dre(e) {
  const [t, n] = Ee(!1), r = Le(null), i = e.activeIndex > 0, a = e.activeIndex < e.images.length - 1, o = e.images.length > 1, s = e.images[e.activeIndex], c = e.device === "Mobile", l = o && e.showNavigationArrows !== !1 && !c, d = t || e.mouse === "mouse over", f = (m) => {
    r.current = m.touches[0].clientX;
  }, h = (m) => {
    if (r.current === null || !o)
      return;
    const g = m.changedTouches[0].clientX, p = r.current - g;
    Math.abs(p) > Ire && (p > 0 && a ? e.onImageChange(e.activeIndex + 1) : p < 0 && i && e.onImageChange(e.activeIndex - 1)), r.current = null;
  };
  return /* @__PURE__ */ u.jsxs("div", { className: J("flex flex-col items-center gap-4", e.className), children: [
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: "relative aspect-square w-full max-w-[23.4375rem] overflow-hidden bg-gray-100 md:aspect-auto md:h-[40.625rem] md:w-[40.625rem] md:max-w-none",
        onMouseEnter: () => n(!0),
        onMouseLeave: () => n(!1),
        onTouchEnd: h,
        onTouchStart: f,
        children: [
          /* @__PURE__ */ u.jsx(
            QD,
            {
              alt: s.alt,
              objectFit: "cover",
              onClick: e.onOverlayOpen,
              src: s.src
            }
          ),
          /* @__PURE__ */ u.jsx(
            ve,
            {
              "aria-label": e.microcopies.viewGallery,
              className: J(
                "absolute right-2 bottom-2 shadow-sm",
                "bg-zinc-100 hover:bg-zinc-200"
              ),
              onClick: (m) => {
                m.stopPropagation(), e.onOverlayOpen();
              },
              size: "icon",
              variant: "secondary",
              children: /* @__PURE__ */ u.jsx(HL, { className: "!h-4 !w-4" })
            }
          ),
          l && d && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-label": e.microcopies.previous,
                className: "-translate-y-1/2 absolute top-1/2 left-2 hidden bg-zinc-100 shadow-sm hover:bg-zinc-200 md:flex",
                disabled: !i,
                onClick: (m) => {
                  m.stopPropagation(), e.onImageChange(e.activeIndex - 1);
                },
                size: "icon",
                variant: "outline",
                children: /* @__PURE__ */ u.jsx(Uy, { className: "!h-4 !w-4" })
              }
            ),
            /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-label": e.microcopies.next,
                className: "-translate-y-1/2 absolute top-1/2 right-2 hidden bg-zinc-100 shadow-sm hover:bg-zinc-200 md:flex",
                disabled: !a,
                onClick: (m) => {
                  m.stopPropagation(), e.onImageChange(e.activeIndex + 1);
                },
                size: "icon",
                variant: "outline",
                children: /* @__PURE__ */ u.jsx(Hy, { className: "!h-4 !w-4" })
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ u.jsx("div", { className: "flex w-full max-w-[23.4375rem] pl-4 md:w-[40.625rem] md:max-w-none", children: /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2 text-base text-zinc-900", children: [
      /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: e.activeIndex + 1 }),
      /* @__PURE__ */ u.jsx(B, { children: "/" }),
      /* @__PURE__ */ u.jsx(B, { children: e.images.length })
    ] }) }),
    /* @__PURE__ */ u.jsx("div", { "aria-atomic": "true", "aria-live": "polite", className: "sr-only", children: e.microcopies.imageCounter.replace("{current}", String(e.activeIndex + 1)).replace("{total}", String(e.images.length)) })
  ] });
}
const kre = 5, Rre = 64, Lre = 8, $re = 2;
function JD(e) {
  const t = Le(null), [n, r] = Ee(!1), [i, a] = Ee(!1), [o, s] = Ee(!1), c = e.device === "Mobile", d = e.width === "Full" && !c ? o : (e.showNavigationArrows ?? e.images.length > kre) && !c, f = ot(() => {
    const m = t.current;
    if (m) {
      const g = m.scrollWidth > m.clientWidth;
      s(g), r(m.scrollLeft > 0), a(
        m.scrollLeft < m.scrollWidth - m.clientWidth - 1
      );
    }
  }, []);
  St(() => {
    f();
    const m = t.current;
    return m && (m.addEventListener("scroll", f), window.addEventListener("resize", f)), () => {
      m && m.removeEventListener("scroll", f), window.removeEventListener("resize", f);
    };
  }, [f]), St(() => {
    const m = t.current, g = m?.children.item(
      e.activeIndex
    );
    if (!(m && g))
      return;
    const p = g.offsetLeft - (m.clientWidth - g.offsetWidth) / 2;
    typeof m.scrollTo == "function" ? m.scrollTo({
      left: p,
      behavior: "smooth"
    }) : m.scrollLeft = p;
  }, [e.activeIndex]);
  const h = (m) => {
    const g = t.current;
    if (g) {
      const p = g.querySelector("button"), x = ((p ? p.offsetWidth : Rre) + Lre) * $re;
      g.scrollBy({
        left: m === "left" ? -x : x,
        behavior: "smooth"
      });
    }
  };
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: J(
        "relative flex w-full items-center justify-center gap-2",
        e.className
      ),
      children: [
        d && /* @__PURE__ */ u.jsx(
          ve,
          {
            "aria-label": e.microcopies.previous,
            className: J(
              "h-8 w-8 flex-shrink-0 transition-opacity",
              n ? "opacity-100" : "pointer-events-none opacity-30"
            ),
            disabled: !n,
            onClick: () => h("left"),
            size: "icon",
            variant: "outline",
            children: /* @__PURE__ */ u.jsx(Uy, { className: "!h-4 !w-4" })
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: J(
              "scrollbar-hide flex items-center gap-2 overflow-x-auto",
              o ? "justify-start" : "justify-center",
              e.width === "Full" ? "w-[16.0625rem] md:w-[22rem] lg:w-auto lg:max-w-full" : "w-[16.0625rem] md:w-[22rem]"
            ),
            ref: t,
            style: { scrollbarWidth: "none", msOverflowStyle: "none" },
            children: e.images.map((m, g) => {
              const p = g === e.activeIndex, v = m.src || `thumbnail-${String(g)}`;
              return /* @__PURE__ */ u.jsx(
                "button",
                {
                  "aria-current": p ? "true" : void 0,
                  "aria-label": `Thumbnail ${g + 1}`,
                  className: J(
                    "relative h-[2.8125rem] w-[2.8125rem] flex-shrink-0 overflow-hidden transition-all md:h-16 md:w-16",
                    "rounded bg-white",
                    // borderRadius: 4px
                    p ? "border border-[#71717A] opacity-100" : "border-0 opacity-60 hover:opacity-100"
                    // Inactive: 60% opacity per Figma
                  ),
                  onClick: () => e.onThumbnailClick(g),
                  type: "button",
                  children: /* @__PURE__ */ u.jsx(
                    Xt,
                    {
                      alt: m.alt,
                      aspectRatio: "1:1",
                      className: "h-full w-full object-cover",
                      src: m.thumbnailSrc || m.src
                    }
                  )
                },
                v
              );
            })
          }
        ),
        d && /* @__PURE__ */ u.jsx(
          ve,
          {
            "aria-label": e.microcopies.next,
            className: J(
              "h-8 w-8 flex-shrink-0 transition-opacity",
              i ? "opacity-100" : "pointer-events-none opacity-30"
            ),
            disabled: !i,
            onClick: () => h("right"),
            size: "icon",
            variant: "outline",
            children: /* @__PURE__ */ u.jsx(Hy, { className: "!h-4 !w-4" })
          }
        )
      ]
    }
  );
}
const MP = 2e3, Bre = 0.5, Uo = (e, t, n) => Math.max(t, Math.min(n, e)), qp = () => ({
  maxX: Math.max(0, (MP - window.innerWidth) / 2),
  maxY: Math.max(0, (MP - window.innerHeight) / 2)
});
function Fre({ imgSrc: e, imgAlt: t, onClick: n }) {
  const [r, i] = Ee({ x: 0, y: 0 }), a = Le({ x: 0, y: 0 }), o = Le(!1), s = ot((f) => {
    f.preventDefault();
    const { maxY: h } = qp();
    i((m) => ({
      ...m,
      y: Uo(m.y - f.deltaY * Bre, -h, h)
    }));
  }, []), c = ot(
    (f) => {
      f.preventDefault(), o.current = !1, a.current = {
        x: f.clientX - r.x,
        y: f.clientY - r.y
      };
      const h = (g) => {
        o.current = !0;
        const { maxX: p, maxY: v } = qp();
        i({
          x: Uo(g.clientX - a.current.x, -p, p),
          y: Uo(g.clientY - a.current.y, -v, v)
        });
      }, m = () => {
        window.removeEventListener("mousemove", h), window.removeEventListener("mouseup", m);
      };
      window.addEventListener("mousemove", h), window.addEventListener("mouseup", m);
    },
    [r]
  ), l = ot(
    (f) => {
      f.touches.length === 1 && (o.current = !1, a.current = {
        x: f.touches[0].clientX - r.x,
        y: f.touches[0].clientY - r.y
      });
    },
    [r]
  ), d = ot(
    (f) => {
      if (f.touches.length !== 1)
        return;
      o.current = !0;
      const { maxX: h, maxY: m } = qp();
      i({
        x: Uo(f.touches[0].clientX - a.current.x, -h, h),
        y: Uo(f.touches[0].clientY - a.current.y, -m, m)
      });
    },
    []
  );
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      className: "fixed inset-0 overflow-hidden border-0 bg-transparent p-0",
      onClick: () => {
        o.current || n();
      },
      onKeyDown: (f) => {
        (f.key === "Enter" || f.key === " ") && (f.preventDefault(), o.current || n());
      },
      onTouchMove: d,
      onTouchStart: l,
      onWheel: s,
      style: { touchAction: "none" },
      type: "button",
      children: /* @__PURE__ */ u.jsx(
        Xt,
        {
          alt: t,
          aspectRatio: "1:1",
          className: "absolute top-1/2 left-1/2 h-[125rem] w-[125rem] max-w-none cursor-grab bg-white active:cursor-grabbing",
          onMouseDown: c,
          src: e,
          style: {
            transform: `translate(
            calc(-50% + ${r.x}px),
            calc(-50% + ${r.y}px)
          )`
          },
          unStyled: !0
        }
      )
    }
  );
}
const zre = 50;
function qre({
  isVisible: e = !0,
  onClose: t,
  images: n,
  activeIndex: r,
  onImageChange: i,
  device: a,
  microcopies: o
}) {
  const [s, c] = Ee(!1), l = Le(null), d = n[r], f = r > 0, h = r < n.length - 1;
  St(() => {
    const P = () => {
      document.body.style.pointerEvents = "auto", document.body.style.overflow = "auto", t?.();
    };
    return window.addEventListener("popstate", P), () => {
      window.removeEventListener("popstate", P), document.body.style.pointerEvents = "auto", document.body.style.overflow = "auto";
    };
  }, [t]);
  const m = ot(() => {
    c(!1);
  }, []), g = () => {
    c((P) => !P);
  }, p = ot(() => {
    f && (m(), i(r - 1));
  }, [f, r, i, m]), v = ot(() => {
    h && (m(), i(r + 1));
  }, [h, r, i, m]);
  St(() => {
    const P = (R) => {
      R.key === "ArrowLeft" && f && p(), R.key === "ArrowRight" && h && v();
    };
    return window.addEventListener("keydown", P), () => {
      window.removeEventListener("keydown", P);
    };
  }, [f, h, p, v]);
  const y = (P) => {
    l.current = P.touches[0].clientX;
  }, x = (P) => {
    if (l.current === null)
      return;
    const R = P.changedTouches[0].clientX, j = l.current - R;
    Math.abs(j) > zre && (j > 0 && h ? v() : j < 0 && f && p()), l.current = null;
  }, w = (P) => {
    i(P), m();
  }, _ = () => /* @__PURE__ */ u.jsx(
    "button",
    {
      "aria-hidden": "true",
      className: "fixed inset-0 z-0 cursor-default border-0 bg-transparent p-0",
      onClick: t,
      tabIndex: -1,
      type: "button"
    }
  ), b = (P) => /* @__PURE__ */ u.jsx(
    ve,
    {
      "aria-label": o.close,
      className: "absolute top-4 right-4 z-[10000]",
      onClick: P,
      size: "icon",
      type: "button",
      variant: "secondary",
      children: /* @__PURE__ */ u.jsx(GL, { className: "!h-4 !w-4" })
    }
  ), S = () => /* @__PURE__ */ u.jsx("div", { className: "-translate-y-1/2 pointer-events-none absolute top-1/2 hidden w-full px-4 md:block", children: /* @__PURE__ */ u.jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ u.jsx(
      ve,
      {
        className: "pointer-events-auto z-[10000]",
        disabled: !f,
        onClick: p,
        size: "icon",
        type: "button",
        variant: "secondary",
        children: /* @__PURE__ */ u.jsx(Uy, { className: "!h-4 !w-4" })
      }
    ),
    /* @__PURE__ */ u.jsx(
      ve,
      {
        className: "pointer-events-auto z-[10000]",
        disabled: !h,
        onClick: v,
        size: "icon",
        type: "button",
        variant: "secondary",
        children: /* @__PURE__ */ u.jsx(Hy, { className: "!h-4 !w-4" })
      }
    )
  ] }) }), O = (P) => /* @__PURE__ */ u.jsx(
    JD,
    {
      activeIndex: r,
      device: a,
      images: n,
      microcopies: {
        previous: o.previous,
        next: o.next
      },
      onThumbnailClick: P,
      width: "Full"
    }
  ), E = (P) => /* @__PURE__ */ u.jsx(
    "div",
    {
      className: "pointer-events-auto relative aspect-square w-[min(100vw-2rem,calc(100vh-10rem),53.5rem)] overflow-hidden rounded-lg",
      onTouchEnd: x,
      onTouchStart: y,
      children: /* @__PURE__ */ u.jsx(
        QD,
        {
          alt: d.alt,
          className: "h-full w-full select-none rounded-lg object-contain",
          onClick: P,
          src: d.src
        }
      )
    }
  );
  return s ? /* @__PURE__ */ u.jsx(oo, { onOpenChange: (P) => !P && t?.(), open: e, children: /* @__PURE__ */ u.jsxs(Ui, { galleryOverlay: !0, children: [
    /* @__PURE__ */ u.jsx(Hi, { className: "sr-only", children: o.imageCounter }),
    /* @__PURE__ */ u.jsx(
      ve,
      {
        className: "absolute right-4 bottom-4 z-[10000] hidden md:flex",
        onClick: g,
        size: "icon",
        type: "button",
        variant: "secondary",
        children: /* @__PURE__ */ u.jsx(YL, { className: "!h-4 !w-4" })
      }
    ),
    b(m),
    /* @__PURE__ */ u.jsx(
      Fre,
      {
        imgAlt: d.alt,
        imgSrc: d.src,
        onClick: m
      }
    ),
    S(),
    /* @__PURE__ */ u.jsx("div", { className: "-translate-x-1/2 tra absolute bottom-0 left-1/2 mb-4 select-none", children: O(w) })
  ] }) }) : /* @__PURE__ */ u.jsx(oo, { onOpenChange: (P) => !P && t?.(), open: e, children: /* @__PURE__ */ u.jsxs(Ui, { galleryOverlay: !0, children: [
    /* @__PURE__ */ u.jsx(Hi, { className: "sr-only", children: o.imageCounter }),
    _(),
    b(t),
    /* @__PURE__ */ u.jsx(
      ve,
      {
        className: "absolute right-4 bottom-4 z-[10000] hidden md:flex",
        onClick: g,
        size: "icon",
        type: "button",
        variant: "secondary",
        children: /* @__PURE__ */ u.jsx(KL, { className: "!h-4 !w-4" })
      }
    ),
    /* @__PURE__ */ u.jsxs("div", { className: "pointer-events-none flex h-screen flex-col overflow-hidden md:hidden", children: [
      /* @__PURE__ */ u.jsx("div", { className: "flex flex-1 items-center justify-center p-2", children: E(g) }),
      /* @__PURE__ */ u.jsx("div", { className: "pointer-events-auto relative shrink-0 select-none px-4 pb-4", children: O(i) })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "pointer-events-none hidden h-screen overflow-hidden p-4 md:flex md:flex-col md:items-center md:justify-center", children: [
      E(g),
      /* @__PURE__ */ u.jsx("div", { className: "pointer-events-auto relative mt-4 shrink-0 select-none", children: O(i) })
    ] }),
    S(),
    /* @__PURE__ */ u.jsx("div", { "aria-atomic": "true", "aria-live": "polite", className: "sr-only", children: o.imageCounter.replace("{current}", String(r + 1)).replace("{total}", String(n.length)) })
  ] }) });
}
function cue(e) {
  const t = Math.max(
    0,
    Math.min(e.initialIndex ?? 0, (e.images?.length ?? 1) - 1)
  ), [n, r] = Ee(t), [i, a] = Ee(!1), o = (l) => {
    r(l);
  }, s = () => {
    a(!0);
  }, c = () => {
    a(!1);
  };
  return !e.images || e.images.length === 0 ? null : /* @__PURE__ */ u.jsxs("div", { className: J("flex w-full flex-col gap-4", e.className), children: [
    /* @__PURE__ */ u.jsx(
      Dre,
      {
        activeIndex: n,
        device: e.device,
        images: e.images,
        microcopies: {
          viewGallery: e.microcopies.viewGallery,
          previous: e.microcopies.previous,
          next: e.microcopies.next,
          imageCounter: e.microcopies.imageCounter
        },
        mouse: e.mouse,
        onImageChange: o,
        onOverlayOpen: s,
        showNavigationArrows: e.showNavigationArrows
      }
    ),
    /* @__PURE__ */ u.jsx(
      JD,
      {
        activeIndex: n,
        device: e.device,
        images: e.images,
        microcopies: {
          previous: e.microcopies.previous,
          next: e.microcopies.next
        },
        onThumbnailClick: o
      }
    ),
    /* @__PURE__ */ u.jsx(
      qre,
      {
        activeIndex: n,
        device: e.device,
        images: e.images,
        isVisible: i,
        microcopies: {
          close: e.microcopies.close,
          previous: e.microcopies.previous,
          next: e.microcopies.next,
          imageCounter: e.microcopies.imageCounter
        },
        onClose: c,
        onImageChange: o
      }
    )
  ] });
}
const Vre = yt("", {
  variants: {
    background: {
      white: "bg-white",
      whitesmoke: "bg-whitesmoke",
      black: "bg-black"
    },
    width: {
      full: "",
      contained: ""
    },
    hotspotColor: {
      blazeorange: "",
      darkteal: "",
      neonchartreuse: ""
    }
  },
  defaultVariants: {
    background: "white",
    width: "full",
    hotspotColor: "blazeorange"
  }
}), Wre = {
  blazeorange: {
    active: "bg-blazeorange",
    ring: "border-blazeorange"
  },
  darkteal: {
    active: "bg-darkteal",
    ring: "border-darkteal"
  },
  neonchartreuse: {
    active: "bg-neonchartreuse",
    ring: "border-neonchartreuse"
  }
}, Pn = 100, Ure = 4, Hre = 18, Yre = "16:9", Kre = [], Gre = "(any-hover: hover) and (any-pointer: fine)";
function Ci(e, t, n) {
  return Number.isNaN(e) ? t : Math.min(n, Math.max(t, e));
}
function IP(e, t) {
  return e === 0 || t === void 0 ? null : Ci(t, 0, e - 1);
}
function DP() {
  return typeof window.matchMedia != "function" || window.matchMedia(Gre).matches;
}
function Zre(e, t, n, r) {
  if (n >= r) {
    const o = r / n * Pn, s = (Pn - o) / 2;
    return { x: e, y: s + t / Pn * o };
  }
  const i = n / r * Pn;
  return { x: (Pn - i) / 2 + e / Pn * i, y: t };
}
function lue(e) {
  const n = (e.hotspots?.hotspots ?? Kre).map((D) => ({
    ...D,
    x: Ci(D.x, 0, Pn),
    y: Ci(D.y, 0, Pn)
  })), r = n.length, [i, a] = Ee(null), o = e.aspectRatio ?? Yre, [s, c] = o.split(":").map(Number), l = s / c, d = i ?? l, f = n.map((D) => ({
    ...D,
    ...Zre(D.x, D.y, d, l)
  })), [h, m] = Ee(() => ({
    clickedIndex: IP(
      n.length,
      e.defaultActiveHotspotIndex
    ),
    hoveredIndex: null,
    detailsState: e.detailsActions?.defaultState ?? "visible",
    layoutVersion: 0,
    hotspotCardPosition: null
  })), g = Le(null), p = Le(null), v = Le(null), y = h.hoveredIndex ?? h.clickedIndex, x = y !== null && y >= 0 && y < f.length ? f[y] : null, w = x?.x ?? null, _ = x?.y ?? null, b = h.detailsState === "visible", S = !!(x?.link?.href || x?.link?.onClick), O = x ? {
    "--poi-hotspot-card-left": h.hotspotCardPosition ? `${h.hotspotCardPosition.left}px` : `${Ci(x.x + Ure, 0, Pn)}%`,
    "--poi-hotspot-card-top": h.hotspotCardPosition ? `${h.hotspotCardPosition.top}px` : `${Ci(x.y - Hre, 0, Pn)}%`
  } : void 0;
  function E(D) {
    m((U) => {
      const Y = U.hotspotCardPosition;
      return Y?.left === D?.left && Y?.top === D?.top ? U : {
        ...U,
        hotspotCardPosition: D
      };
    });
  }
  St(
    () => () => {
      v.current && clearTimeout(v.current);
    },
    []
  ), St(() => {
    if (!e.imageUrl) {
      a(null);
      return;
    }
    let D = !0;
    const U = new window.Image();
    function Y() {
      D && U.naturalWidth && U.naturalHeight && a(U.naturalWidth / U.naturalHeight);
    }
    return a(null), U.onload = Y, U.src = e.imageUrl, U.complete && Y(), () => {
      D = !1, U.onload = null;
    };
  }, [e.imageUrl]), St(() => {
    m((D) => D.clickedIndex === null || D.clickedIndex < r ? D : {
      ...D,
      clickedIndex: IP(
        r,
        e.defaultActiveHotspotIndex
      ),
      hoveredIndex: null,
      hotspotCardPosition: null
    });
  }, [r, e.defaultActiveHotspotIndex]);
  const P = e.hotspotColor ?? "blazeorange", R = Wre[P], j = e.width !== "contained", C = j ? "col-span-12" : "col-span-10 col-start-2";
  St(() => {
    if (!b || typeof ResizeObserver > "u")
      return;
    const D = g.current;
    if (!D)
      return;
    const U = new ResizeObserver(() => {
      m((Y) => ({
        ...Y,
        layoutVersion: Y.layoutVersion + 1
      }));
    });
    return U.observe(D), () => U.disconnect();
  }, [b]), Ky(() => {
    if (!(b && x)) {
      E(null);
      return;
    }
    const D = g.current, U = p.current;
    if (!(D && U))
      return;
    const Y = D.getBoundingClientRect(), X = U.getBoundingClientRect(), oe = Y.width, ie = Y.height, he = X.width, ee = X.height;
    if (!(oe && ie && he && ee)) {
      E(null);
      return;
    }
    const se = 16, G = 24, Q = x.x / Pn * oe, ce = x.y / Pn * ie, F = Q + G, ye = Q - G - he, te = F + he <= oe - se, Ne = ye >= se;
    let Te = Q <= oe / 2 ? F : ye;
    Q <= oe / 2 && !te && Ne && (Te = ye), Q > oe / 2 && !Ne && te && (Te = F);
    const Ge = Math.max(
      se,
      oe - he - se
    );
    Te = Ci(Te, se, Ge);
    let At = ce - ee / 2;
    const en = Math.max(
      se,
      ie - ee - se
    );
    At = Ci(At, se, en), E({ left: Te, top: At });
  }, [
    y,
    w,
    _,
    b,
    h.layoutVersion,
    d,
    l
  ]), St(() => {
    if (h.clickedIndex === null)
      return;
    function D(U) {
      U.composedPath().some(
        (X) => X instanceof Element && (X.matches('[data-testid="poi-hotspot-detail-card"]') || X.matches('[data-testid^="poi-hotspot-marker-"]'))
      ) || m(
        (X) => X.clickedIndex === null ? X : { ...X, clickedIndex: null }
      );
    }
    return document.addEventListener("click", D), () => document.removeEventListener("click", D);
  }, [h.clickedIndex]);
  function N() {
    v.current && (clearTimeout(v.current), v.current = null);
  }
  function k(D) {
    D.pointerType === "mouse" && DP() && N();
  }
  const I = 150;
  function $(D) {
    D.pointerType === "mouse" && (v.current = setTimeout(() => {
      m((U) => ({
        ...U,
        hoveredIndex: null
      }));
    }, I));
  }
  function z(D, U) {
    U.pointerType !== "mouse" || !DP() || (N(), m((Y) => ({
      ...Y,
      clickedIndex: Y.clickedIndex === D ? Y.clickedIndex : null,
      hoveredIndex: D
    })));
  }
  function V(D) {
    N(), m((U) => ({
      ...U,
      clickedIndex: D,
      hoveredIndex: null
    })), e.onHotspotChange?.(n[D], D);
  }
  function K(D, U) {
    m((Y) => ({
      ...Y,
      detailsState: D
    })), e.detailsActions?.onChange?.(D, U);
  }
  return /* @__PURE__ */ u.jsx(
    kd,
    {
      className: J(
        Vre({
          background: e.background,
          width: e.width,
          hotspotColor: e.hotspotColor
        }),
        "component-poi-image-hotspot",
        e.className
      ),
      fullWidth: !0,
      outerContainerOnly: j,
      paddingBottom: e.paddingBottom ?? "none",
      paddingTop: e.paddingTop ?? "none",
      children: /* @__PURE__ */ u.jsx(Rd, { children: /* @__PURE__ */ u.jsxs(Dd, { className: C, children: [
        /* @__PURE__ */ u.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ u.jsxs(
            "div",
            {
              className: "relative",
              style: {
                aspectRatio: o.replace(":", " / ")
              },
              children: [
                /* @__PURE__ */ u.jsx("div", { className: "absolute inset-0 overflow-hidden rounded-sm", children: /* @__PURE__ */ u.jsx(
                  Xt,
                  {
                    alt: e.imageAlt ?? e.title,
                    aspectRatio: o,
                    className: "h-full w-full",
                    fill: !0,
                    loading: "lazy",
                    objectFit: "contain",
                    src: e.imageUrl
                  }
                ) }),
                /* @__PURE__ */ u.jsx(
                  "div",
                  {
                    className: "absolute inset-0 z-10 overflow-visible",
                    ref: g,
                    children: b && f.map((D, U) => {
                      const Y = y === U;
                      return /* @__PURE__ */ u.jsx(
                        "button",
                        {
                          "aria-label": `Open hotspot: ${D.name}`,
                          "aria-pressed": Y,
                          className: J(
                            "-translate-x-1/2 -translate-y-1/2 absolute z-20 flex h-[39px] w-[39px] items-center justify-center rounded-full bg-transparent",
                            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/35 focus-visible:ring-offset-2"
                          ),
                          "data-testid": `poi-hotspot-marker-${U}`,
                          onClick: () => V(U),
                          onPointerEnter: (X) => z(U, X),
                          onPointerLeave: $,
                          style: {
                            left: `${D.x}%`,
                            top: `${D.y}%`
                          },
                          type: "button",
                          children: Y ? /* @__PURE__ */ u.jsx(
                            "span",
                            {
                              "aria-hidden": "true",
                              className: J(
                                "h-[21px] w-[21px] rounded-full",
                                R.active
                              )
                            }
                          ) : /* @__PURE__ */ u.jsxs(
                            "span",
                            {
                              "aria-hidden": "true",
                              className: "relative flex h-[21px] w-[21px] items-center justify-center",
                              children: [
                                /* @__PURE__ */ u.jsx(
                                  "span",
                                  {
                                    className: J(
                                      "absolute inset-0 animate-poi-hotspot-pulse rounded-full border-[4.5px] bg-transparent",
                                      R.ring
                                    )
                                  }
                                ),
                                /* @__PURE__ */ u.jsx(
                                  "span",
                                  {
                                    className: J(
                                      "relative h-full w-full rounded-full border-[4.5px] bg-transparent",
                                      R.ring
                                    )
                                  }
                                )
                              ]
                            }
                          )
                        },
                        `${D.name}-${U}`
                      );
                    })
                  }
                )
              ]
            }
          ),
          b && x && y !== null && /* @__PURE__ */ u.jsx(
            "div",
            {
              className: "relative z-30 mt-3 animate-poi-card-in px-4 md:absolute md:top-[var(--poi-hotspot-card-top)] md:left-[var(--poi-hotspot-card-left)] md:mt-0 md:px-0",
              "data-testid": "poi-hotspot-detail-card",
              onPointerEnter: k,
              onPointerLeave: $,
              style: O,
              children: /* @__PURE__ */ u.jsx(
                "article",
                {
                  className: "overflow-hidden rounded-[4px] bg-white p-[16px] shadow-[0_4px_4px_rgba(0,0,0,0.02)] md:min-h-[112px]",
                  ref: p,
                  children: /* @__PURE__ */ u.jsxs("div", { className: "flex items-start gap-[12px] md:items-center md:gap-[16px]", children: [
                    x.thumbnailUrl && /* @__PURE__ */ u.jsx("div", { className: "relative h-[64px] w-[64px] shrink-0 overflow-hidden bg-alabastergrey md:h-[80px] md:w-[80px]", children: /* @__PURE__ */ u.jsx(
                      Xt,
                      {
                        alt: x.thumbnailAlt ?? `Hotspot preview for ${x.name}`,
                        aspectRatio: "1:1",
                        className: "h-full w-full",
                        fill: !0,
                        loading: "lazy",
                        objectFit: "cover",
                        src: x.thumbnailUrl
                      }
                    ) }),
                    /* @__PURE__ */ u.jsxs("div", { className: "flex min-w-0 flex-1 flex-col gap-[8px] md:w-[140px] md:flex-none md:shrink-0", children: [
                      /* @__PURE__ */ u.jsx("p", { className: "font-bold font-brand text-[13px] text-black leading-[16px] tracking-[0.24px] md:text-[12px] md:leading-[14px]", children: x.name }),
                      x.description && /* @__PURE__ */ u.jsx("p", { className: "font-brand text-[12px] text-black leading-[16px] md:text-[10px] md:leading-[13px]", children: x.description })
                    ] }),
                    S && /* @__PURE__ */ u.jsx(
                      ve,
                      {
                        "aria-label": x?.link?.ariaLabel ?? `Open link for hotspot ${x.name}`,
                        className: "size-12 shrink-0",
                        href: x?.link?.href,
                        mode: "D2C",
                        onClick: x?.link?.onClick,
                        size: "icon",
                        variant: "outline",
                        children: /* @__PURE__ */ u.jsx(ZL, {})
                      }
                    )
                  ] })
                }
              )
            },
            `card-${y}`
          )
        ] }),
        e.detailsActions && /* @__PURE__ */ u.jsx("div", { className: "mt-8 flex justify-center", children: /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: "inline-flex items-center rounded-[8px] border border-white/70 bg-black/85 p-1",
            "data-testid": "poi-hotspot-details-toggle",
            children: [
              /* @__PURE__ */ u.jsx(
                "button",
                {
                  "aria-label": e.detailsActions.viewDetailsLabel,
                  "aria-pressed": b,
                  className: J(
                    "w-[120px] rounded-[6px] px-4 py-[16px] font-brand text-[12px] leading-[17px] transition",
                    b ? "bg-alabastergrey text-black" : "bg-transparent text-white hover:bg-white/10"
                  ),
                  onClick: (D) => K("visible", D),
                  type: "button",
                  children: e.detailsActions.viewDetailsLabel
                }
              ),
              /* @__PURE__ */ u.jsx(
                "button",
                {
                  "aria-label": e.detailsActions.hideDetailsLabel,
                  "aria-pressed": !b,
                  className: J(
                    "w-[120px] rounded-[6px] px-4 py-[16px] font-brand text-[12px] leading-[17px] transition",
                    b ? "bg-transparent text-white hover:bg-white/10" : "bg-alabastergrey text-black"
                  ),
                  onClick: (D) => K("hidden", D),
                  type: "button",
                  children: e.detailsActions.hideDetailsLabel
                }
              )
            ]
          }
        ) })
      ] }) })
    }
  );
}
function kP(e) {
  return /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-start gap-1", children: [
      e.priceInfo.showVariantPrice !== !1 && /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.priceInfo.label }) }),
      e.priceInfo.showVariantPrice !== !1 && /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ u.jsx(
          B,
          {
            style: e.priceInfo.discountLabel ? "line-through" : void 0,
            variant: "body-sm-bold",
            children: e.priceInfo.value
          }
        ),
        e.priceInfo.isNetPriced && e.tagNetPriced && /* @__PURE__ */ u.jsx(La, { size: "sm", text: e.tagNetPriced, variant: "default" }),
        e.priceInfo.discountLabel && /* @__PURE__ */ u.jsx(
          La,
          {
            size: "sm",
            text: e.priceInfo.discountLabel,
            variant: "outline"
          }
        )
      ] }),
      e.priceInfo.showVariantPrice !== !1 && e.priceInfo.discountPrice && /* @__PURE__ */ u.jsx(B, { color: "red", variant: "body-sm-bold", children: e.priceInfo.discountPrice })
    ] }),
    e.priceInfo.showRrp && e.priceInfo.rrpValue && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-start gap-1", children: [
      /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.priceInfo.rrpLabel }),
      /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.priceInfo.rrpValue })
    ] })
  ] });
}
function Xre(e) {
  const [t, n] = Ee({
    isVisible: !1,
    maxAvailability: 0
  });
  return /* @__PURE__ */ u.jsxs("div", { className: e.className, children: [
    t.isVisible && /* @__PURE__ */ u.jsx("div", { className: "mb-4", children: /* @__PURE__ */ u.jsx(
      na,
      {
        microcopies: {
          title: e.microcopies.orderLimitReachedTitle,
          description: e.microcopies.orderLimitReachedDescription.replace(
            "{EffectiveLimit}",
            t.maxAvailability.toString()
          )
        },
        variant: "warning"
      }
    ) }),
    /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-start gap-6 md:flex-row", children: [
      e.productInfo && /* @__PURE__ */ u.jsxs(
        ve,
        {
          className: "flex h-full w-[280px] justify-start gap-4 px-0 py-4 hover:no-underline min-[1024px]:max-[1070px]:w-[230px]",
          href: e.productInfo.href || "",
          onClick: (r) => {
            r.preventDefault(), e.handleButtonClick(e?.productInfo?.href || "");
          },
          unstyled: !0,
          variant: "link",
          children: [
            /* @__PURE__ */ u.jsx("div", { className: "h-16 w-16 overflow-hidden", children: /* @__PURE__ */ u.jsx(
              Xt,
              {
                alt: e.productInfo.imageAlt,
                aspectRatio: "1:1",
                borderRadius: "sm",
                fill: !0,
                objectFit: "cover",
                src: e.productInfo.imageUrl
              }
            ) }),
            e.priceInfo && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
              (e.productInfo?.colorName || e.productInfo?.lensName || e.productInfo?.productName) && /* @__PURE__ */ u.jsxs("div", { children: [
                e.productInfo?.colorName && (e.productInfo.colorName && e.productInfo.lensName ? /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm-bold", children: `${e.microcopyLabels?.frameLabel}: ${e.productInfo.colorName}` }) : /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm-bold", children: e.productInfo.colorName })),
                e.productInfo?.lensName && (e.productInfo.colorName && e.productInfo.lensName ? /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm-bold", children: `${e.microcopyLabels?.lensLabel}: ${e.productInfo.lensName}` }) : /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm-bold", children: e.productInfo.lensName })),
                !(e.productInfo?.colorName || e.productInfo?.lensName) && e.productInfo?.productName && /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-sm-bold", children: e.productInfo.productName })
              ] }),
              e.priceInfo && /* @__PURE__ */ u.jsx(
                kP,
                {
                  priceInfo: e.priceInfo,
                  tagNetPriced: e.tagNetPriced
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ u.jsx("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ u.jsx("div", { className: "flex flex-wrap gap-4", children: e.sizes.map((r) => /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: "flex flex-col items-start gap-1 pb-2",
          children: [
            /* @__PURE__ */ u.jsx(
              Ay,
              {
                country: e.country,
                ...r.quantityProps,
                alertHandler: (i) => n(i),
                ean: r.ean,
                onProductStateChange: e.onProductStateChange,
                productId: r.productId,
                showAvailability: e.showAvailability ?? r.quantityProps.showAvailability ?? !1,
                showEanCode: e.showEanCode,
                showProductId: r.productId.length > 0,
                showSize: r.size.length > 0,
                size: r.size
              }
            ),
            r.priceInfo && /* @__PURE__ */ u.jsx("div", { className: "mt-1", children: /* @__PURE__ */ u.jsx(
              kP,
              {
                priceInfo: r.priceInfo,
                tagNetPriced: e.tagNetPriced
              }
            ) })
          ]
        },
        `${r.size}-${r.productId}`
      )) }) })
    ] })
  ] });
}
function Qre(e) {
  const t = {};
  return e.forEach((n, r) => {
    const i = Number(n);
    Number.isFinite(i) && (t[r] = i);
  }), t;
}
function Jre(e) {
  const [, t] = jC(), [n, r] = Ee({
    resetKey: 0,
    isSubmitting: !1,
    isDirty: !1,
    hasBeenAddedToCart: e.hasCartItems ?? !1,
    quantityBaselines: {}
  }), i = Le(null), a = Le(/* @__PURE__ */ new Map()), o = (d, f) => {
    a.current.set(d, f);
    const h = Array.from(a.current.values()).some(
      Boolean
    );
    queueMicrotask(() => {
      r((m) => m.isDirty !== h ? { ...m, isDirty: h } : m);
    });
  };
  e.displayNavigationWarning && e.showNavigationWarning?.({
    enabled: n.isDirty,
    showDialog: e.displayNavigationWarning
  });
  function s(d) {
    d.preventDefault();
    const f = new FormData(d.currentTarget), h = Qre(f);
    if (r((m) => ({ ...m, isSubmitting: !0 })), e.addToCartAction) {
      const m = e.addToCartAction;
      t(async () => {
        try {
          const g = await m(
            f,
            e.baseSiteId,
            e.cartId
          );
          if (g.status === "success") {
            const p = Object.values(h).some(
              (v) => v > 0
            );
            r((v) => ({
              ...v,
              resetKey: g.resetKey,
              isSubmitting: !1,
              isDirty: !1,
              hasBeenAddedToCart: p,
              quantityBaselines: {
                ...v.quantityBaselines,
                ...h
              }
            }));
          } else g.status === "error" && (r((p) => ({
            ...p,
            isSubmitting: !1,
            isDirty: !1
          })), jr.error("Add to cart error:", g.errorMessage));
        } catch (g) {
          r((p) => ({
            ...p,
            isSubmitting: !1,
            isDirty: !1
          })), jr.error("Add to cart failed:", g);
        }
      });
    } else
      jr.warn("No addToCartAction provided"), r((m) => ({
        ...m,
        isSubmitting: !1
      }));
  }
  if (e.products) {
    const d = Object.entries(e.products);
    return /* @__PURE__ */ u.jsx("div", { className: "mb-8 space-y-6", children: d.map(([f, h]) => /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(Jre, { ...h }) }, f)) });
  }
  const c = e.header, l = e.variants;
  return /* @__PURE__ */ u.jsx(
    "form",
    {
      "data-testid": "product-form",
      onSubmit: s,
      ref: i,
      children: /* @__PURE__ */ u.jsxs("div", { className: "overflow-hidden rounded-lg border border-stone-200", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-start gap-1 border-b bg-white p-4", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center gap-3", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md-bold", children: c.productName }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center gap-2", children: /* @__PURE__ */ u.jsxs(B, { variant: "body-md", children: [
            e.microcopies.productCode,
            ": ",
            c.productCode
          ] }) })
        ] }),
        /* @__PURE__ */ u.jsx("div", { children: l.map((d, f) => {
          const h = d.sizes.map((g) => ({
            ...g,
            quantityProps: {
              ...g.quantityProps,
              disabled: d.yourPrice === "" && !e.hideDealerPrice || g.quantityProps.disabled,
              value: n.quantityBaselines[g.productId] ?? g.quantityProps.value
            },
            priceInfo: g.priceInfo ? {
              ...g.priceInfo,
              showVariantPrice: g.priceInfo.showVariantPrice !== !1 && !e.hideDealerPrice
            } : g.priceInfo
          })), m = d.sizes?.[0]?.productId ?? `${c.productCode}-${f}`;
          return /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx("div", { className: "bg-white p-4 py-0", children: /* @__PURE__ */ u.jsx(
            "div",
            {
              className: f > 0 ? "flex items-start gap-4 border-t" : "flex items-start gap-4",
              children: /* @__PURE__ */ u.jsx("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ u.jsx("div", { className: "mt-4", children: /* @__PURE__ */ u.jsx(
                Xre,
                {
                  country: e.country,
                  handleButtonClick: e.onProductSizeClick ?? (() => {
                  }),
                  microcopies: {
                    orderLimitReachedTitle: e.microcopies.orderLimitReachedTitle,
                    orderLimitReachedDescription: e.microcopies.orderLimitReachedDescription,
                    fromLabel: e.microcopies.fromLabel
                  },
                  microcopyLabels: {
                    frameLabel: e.microcopies.frameLabel,
                    lensLabel: e.microcopies.lensLabel
                  },
                  onProductStateChange: o,
                  priceInfo: {
                    label: e.microcopies.yourPriceLabel,
                    value: d.yourPrice,
                    showRrp: !0,
                    rrpLabel: e.microcopies.rrpLabel,
                    rrpValue: d.normalPrice,
                    discountLabel: d.discountLabel,
                    discountPrice: d.discountPrice,
                    isNetPriced: d.isNetPriced,
                    showVariantPrice: !e.hideDealerPrice
                  },
                  productInfo: {
                    imageUrl: d.imageUrl,
                    imageAlt: c.imageAlt,
                    colorName: d.colorName,
                    lensName: d.lensName,
                    productName: c.productName,
                    productCode: c.productCode,
                    href: d.href
                    // Pass href with query params to ProductSizes
                  },
                  showEanCode: e.showEanCode,
                  sizes: h,
                  tagNetPriced: e.microcopies.tagNetPriced
                }
              ) }) })
            }
          ) }) }, String(m));
        }) }),
        e.footer && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col items-end justify-end gap-4 border-t bg-white p-4 md:flex-row md:items-center", children: [
          /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(
            na,
            {
              microcopies: { title: e.microcopies.helperMessage4 ?? "" },
              variant: "default"
            }
          ) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ u.jsxs(
            ve,
            {
              disabled: n.isSubmitting || !n.isDirty,
              size: "sm",
              type: "submit",
              variant: "default",
              children: [
                n.isSubmitting ? /* @__PURE__ */ u.jsx(AC, { className: "animate-spin", size: "sm" }) : /* @__PURE__ */ u.jsx(XL, { size: "sm" }),
                /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: n.hasBeenAddedToCart && e.footer.updateCartLabel ? e.footer.updateCartLabel : e.footer.addToCartLabel })
              ]
            }
          ) })
        ] })
      ] })
    },
    n.resetKey
  );
}
const eie = 3;
function uue(e) {
  const [t, n] = Ee(null), [r, i] = Ee(!1), a = e.microcopies.learnMore, o = e.microcopies?.title || "Product Highlights", s = e.microcopies?.subtitle || "", c = (f) => {
    n(f), i(!0);
  }, l = () => {
    i(!1), n(null);
  }, d = e.highlights?.filter(
    (f) => f.title && f.code
  ) ?? [];
  return d.length === 0 ? null : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs("div", { className: "mb-6", "data-testid": "product-highlights-header", children: [
      /* @__PURE__ */ u.jsx(B, { variant: "h2", children: o }),
      s ? /* @__PURE__ */ u.jsx("div", { className: "mt-2", children: /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-sm", children: s }) }) : null
    ] }),
    /* @__PURE__ */ u.jsx("div", { className: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4", children: d.slice(0, eie).map((f) => /* @__PURE__ */ u.jsx(
      YD,
      {
        button: {
          text: a,
          href: "#",
          onClick: () => {
            c(f);
          }
        },
        description: f.teaser || "",
        overlayImage: {
          url: f.picture?.url || "",
          alt: f.picture?.title || f.title || "Product Highlight"
        },
        title: f.title || "",
        variant: "secondary-image-full"
      },
      f.code
    )) }),
    /* @__PURE__ */ u.jsx(
      vc,
      {
        isOpen: r,
        modalClassName: "max-w-2xl md:max-w-4xl",
        onClose: l,
        title: t?.title || "",
        children: t && /* @__PURE__ */ u.jsxs("div", { className: "w-full space-y-4", children: [
          t.picture?.url && /* @__PURE__ */ u.jsx("div", { className: "w-full overflow-hidden rounded-sm bg-neutral-100", children: /* @__PURE__ */ u.jsx(
            Xt,
            {
              alt: t.picture.title || t.title || "Product Highlight",
              aspectRatio: "16:9",
              className: "block h-auto w-full",
              loading: "lazy",
              objectPosition: "center",
              placeholder: "empty",
              src: t.picture.url
            }
          ) }),
          (t.content || t.teaser) && /* @__PURE__ */ u.jsx("div", { className: "w-full", children: /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-md", children: t.content || t.teaser }) })
        ] })
      }
    )
  ] });
}
var ek = "AlertDialog", [tie] = wn(ek, [
  JN
]), Vr = JN(), tk = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Vr(t);
  return /* @__PURE__ */ u.jsx(vM, { ...r, ...n, modal: !0 });
};
tk.displayName = ek;
var nie = "AlertDialogTrigger", nk = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Vr(n);
    return /* @__PURE__ */ u.jsx(kG, { ...i, ...r, ref: t });
  }
);
nk.displayName = nie;
var rie = "AlertDialogPortal", rk = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Vr(t);
  return /* @__PURE__ */ u.jsx(pM, { ...r, ...n });
};
rk.displayName = rie;
var iie = "AlertDialogOverlay", ik = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Vr(n);
    return /* @__PURE__ */ u.jsx(wd, { ...i, ...r, ref: t });
  }
);
ik.displayName = iie;
var Ia = "AlertDialogContent", [aie, oie] = tie(Ia), sie = OC("AlertDialogContent"), ak = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...i } = e, a = Vr(n), o = A.useRef(null), s = ke(t, o), c = A.useRef(null);
    return /* @__PURE__ */ u.jsx(
      NG,
      {
        contentName: Ia,
        titleName: ok,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ u.jsx(aie, { scope: n, cancelRef: c, children: /* @__PURE__ */ u.jsxs(
          as,
          {
            role: "alertdialog",
            ...a,
            ...i,
            ref: s,
            onOpenAutoFocus: Oe(i.onOpenAutoFocus, (l) => {
              l.preventDefault(), c.current?.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (l) => l.preventDefault(),
            onInteractOutside: (l) => l.preventDefault(),
            children: [
              /* @__PURE__ */ u.jsx(sie, { children: r }),
              /* @__PURE__ */ u.jsx(lie, { contentRef: o })
            ]
          }
        ) })
      }
    );
  }
);
ak.displayName = Ia;
var ok = "AlertDialogTitle", sk = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Vr(n);
    return /* @__PURE__ */ u.jsx(rx, { ...i, ...r, ref: t });
  }
);
sk.displayName = ok;
var ck = "AlertDialogDescription", lk = A.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, i = Vr(n);
  return /* @__PURE__ */ u.jsx(ix, { ...i, ...r, ref: t });
});
lk.displayName = ck;
var cie = "AlertDialogAction", uk = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Vr(n);
    return /* @__PURE__ */ u.jsx(bu, { ...i, ...r, ref: t });
  }
);
uk.displayName = cie;
var dk = "AlertDialogCancel", fk = A.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: i } = oie(dk, n), a = Vr(n), o = ke(t, i);
    return /* @__PURE__ */ u.jsx(bu, { ...a, ...r, ref: o });
  }
);
fk.displayName = dk;
var lie = ({ contentRef: e }) => {
  const t = `\`${Ia}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Ia}\` by passing a \`${ck}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Ia}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return A.useEffect(() => {
    document.getElementById(
      e.current?.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, uie = tk, die = nk, fie = rk, hk = ik, mk = ak, vk = uk, pk = fk, gk = sk, yk = lk;
const due = uie, fue = die, hie = fie, bk = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  hk,
  {
    className: J(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=open]:animate-in",
      "fixed inset-0 z-[70] bg-black/80",
      e
    ),
    ref: t,
    ...n
  }
);
bk.displayName = hk.displayName;
const mie = ({
  className: e,
  centered: t,
  children: n,
  ref: r,
  preventCloseOnOutsideClick: i = !1,
  preventCloseOnEscapeKey: a = !1,
  onEscapeKeyDown: o,
  onInteractOutside: s,
  ...c
}) => {
  const l = (h) => {
    a && h.preventDefault(), o?.(h);
  }, d = (h) => {
    i && h.preventDefault(), s?.(h);
  }, f = mk;
  return /* @__PURE__ */ u.jsxs(hie, { children: [
    /* @__PURE__ */ u.jsx(bk, {}),
    /* @__PURE__ */ u.jsx(
      f,
      {
        className: J(
          "-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-[80] flex w-full max-w-[20rem] flex-col gap-6 rounded border border-zinc-200 bg-white p-6 shadow-[0px_4px_6px_-2px_rgba(0,0,0,0.05),0px_10px_15px_-3px_rgba(0,0,0,0.1)] duration-200 md:max-w-[30rem]",
          "data-[state=open]:zoom-in-95 data-[state=open]:fade-in-0 data-[state=open]:animate-in",
          "data-[state=closed]:zoom-out-95 data-[state=closed]:fade-out-0 data-[state=closed]:animate-out",
          e
        ),
        onEscapeKeyDown: l,
        onInteractOutside: d,
        ref: r,
        ...c,
        children: n
      }
    )
  ] });
};
mie.displayName = mk.displayName;
const vie = ({
  className: e,
  centered: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: J(
      "flex flex-col gap-2",
      t ? "items-center text-center" : "items-center text-center md:items-start md:text-left",
      e
    ),
    ...n
  }
);
vie.displayName = "AlertDialogHeader";
const pie = ({
  className: e,
  centered: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: J(
      "flex gap-2",
      t ? "flex-col items-stretch" : "flex-col-reverse items-stretch md:flex-row md:items-center md:justify-end",
      e
    ),
    ...n
  }
);
pie.displayName = "AlertDialogFooter";
const gie = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  gk,
  {
    className: J("font-semibold text-lg leading-tight", e),
    ref: t,
    ...n
  }
);
gie.displayName = gk.displayName;
const yie = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  yk,
  {
    className: J("text-sm leading-tight", e),
    ref: t,
    ...n
  }
);
yie.displayName = yk.displayName;
const bie = vk;
bie.displayName = vk.displayName;
const xie = pk;
xie.displayName = pk.displayName;
function hue({ className: e, ...t }) {
  return /* @__PURE__ */ u.jsx(
    "nav",
    {
      "aria-label": "pagination",
      className: J("mx-auto flex w-full justify-center", e),
      "data-slot": "pagination",
      ...t
    }
  );
}
function mue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsx(
    "ul",
    {
      className: J("flex items-center gap-0.5", e),
      "data-slot": "pagination-content",
      ...t
    }
  );
}
function vue({ ...e }) {
  return /* @__PURE__ */ u.jsx("li", { "data-slot": "pagination-item", ...e });
}
function xk({
  className: e,
  isActive: t,
  size: n = "icon",
  href: r,
  children: i,
  ...a
}) {
  return /* @__PURE__ */ u.jsx(
    ve,
    {
      "aria-current": t ? "page" : void 0,
      className: J(e),
      "data-active": t,
      "data-slot": "pagination-link",
      href: r,
      size: n,
      variant: t ? "outline" : "ghost",
      ...a,
      children: i
    }
  );
}
function pue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsxs(
    xk,
    {
      "aria-label": "Go to previous page",
      className: J("pl-1.5!", e),
      size: "default",
      ...t,
      children: [
        /* @__PURE__ */ u.jsx(NC, { "data-icon": "inline-start" }),
        /* @__PURE__ */ u.jsx("span", { children: "Previous" })
      ]
    }
  );
}
function gue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsxs(
    xk,
    {
      "aria-label": "Go to next page",
      className: J("pr-1.5!", e),
      size: "default",
      ...t,
      children: [
        /* @__PURE__ */ u.jsx("span", { children: "Next" }),
        /* @__PURE__ */ u.jsx(EC, { "data-icon": "inline-end" })
      ]
    }
  );
}
function yue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsxs(
    "span",
    {
      "aria-hidden": !0,
      className: J(
        "flex size-8 items-center justify-center [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      "data-slot": "pagination-ellipsis",
      ...t,
      children: [
        /* @__PURE__ */ u.jsx(m2, {}),
        /* @__PURE__ */ u.jsx("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
function bue({
  id: e,
  options: t,
  value: n,
  onValueChange: r,
  placeholder: i = "Select an option",
  searchPlaceholder: a = "Search...",
  emptyMessage: o = "No results found."
}) {
  const [s, c] = Ee(!1), [l, d] = Ee(""), f = t.find((p) => p.value === n), h = Tr(() => {
    const p = l.trim().toLowerCase();
    return p ? t.filter(
      (v) => v.label.toLowerCase().includes(p)
    ) : t;
  }, [t, l]), m = (p) => {
    c(p), p || d("");
  }, g = (p) => {
    r(p.value), c(!1), d("");
  };
  return /* @__PURE__ */ u.jsxs(DD, { onOpenChange: m, open: s, children: [
    /* @__PURE__ */ u.jsx("div", { className: "[&>button]:w-full [&>button]:justify-between", children: /* @__PURE__ */ u.jsx(kD, { asChild: !0, children: /* @__PURE__ */ u.jsxs(
      ve,
      {
        "aria-expanded": s,
        id: e,
        role: "combobox",
        type: "button",
        variant: "outline",
        children: [
          /* @__PURE__ */ u.jsx("span", { className: f ? void 0 : "text-zinc-500", children: f ? f.label : i }),
          /* @__PURE__ */ u.jsx(zi, { "aria-hidden": !0, className: "h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }) }),
    /* @__PURE__ */ u.jsxs(
      Mx,
      {
        align: "start",
        className: "w-[var(--radix-popover-trigger-width)] p-0",
        children: [
          /* @__PURE__ */ u.jsxs("div", { className: "relative border-b p-2", children: [
            /* @__PURE__ */ u.jsx(
              QL,
              {
                "aria-hidden": !0,
                className: "-translate-y-1/2 absolute top-1/2 left-5 size-4 text-zinc-500"
              }
            ),
            /* @__PURE__ */ u.jsx(
              ni,
              {
                autoFocus: !0,
                className: "pl-9",
                onChange: (p) => d(p.target.value),
                placeholder: a,
                value: l
              }
            )
          ] }),
          /* @__PURE__ */ u.jsxs("ul", { className: "max-h-72 overflow-y-auto p-1", children: [
            h.length === 0 && /* @__PURE__ */ u.jsx("li", { className: "px-3 py-2", children: /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-sm", children: o }) }),
            h.map((p) => /* @__PURE__ */ u.jsx(
              "li",
              {
                className: "[&>button]:w-full [&>button]:justify-between [&>button]:rounded-sm [&>button]:text-left",
                children: /* @__PURE__ */ u.jsxs(
                  ve,
                  {
                    onClick: () => g(p),
                    type: "button",
                    variant: "ghost",
                    children: [
                      p.label,
                      p.value === n && /* @__PURE__ */ u.jsx(_C, { "aria-hidden": !0, className: "size-4 shrink-0" })
                    ]
                  }
                )
              },
              p.value
            ))
          ] })
        ]
      }
    )
  ] });
}
var Vd = "Switch", [wie] = wn(Vd), [_ie, Sie] = wie(Vd), wk = A.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: o,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      form: d,
      ...f
    } = e, [h, m] = A.useState(null), g = ke(t, (w) => m(w)), p = A.useRef(!1), v = h ? d || !!h.closest("form") : !0, [y, x] = In({
      prop: i,
      defaultProp: a ?? !1,
      onChange: l,
      caller: Vd
    });
    return /* @__PURE__ */ u.jsxs(_ie, { scope: n, checked: y, disabled: s, children: [
      /* @__PURE__ */ u.jsx(
        Ae.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": o,
          "data-state": Ek(y),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...f,
          ref: g,
          onClick: Oe(e.onClick, (w) => {
            x((_) => !_), v && (p.current = w.isPropagationStopped(), p.current || w.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ u.jsx(
        Ok,
        {
          control: h,
          bubbles: !p.current,
          name: r,
          value: c,
          checked: y,
          required: o,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
wk.displayName = Vd;
var _k = "SwitchThumb", Sk = A.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, i = Sie(_k, n);
    return /* @__PURE__ */ u.jsx(
      Ae.span,
      {
        "data-state": Ek(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Sk.displayName = _k;
var Oie = "SwitchBubbleInput", Ok = A.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...i
  }, a) => {
    const o = A.useRef(null), s = ke(o, a), c = bx(n), l = hx(t);
    return A.useEffect(() => {
      const d = o.current;
      if (!d) return;
      const f = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (c !== n && m) {
        const g = new Event("click", { bubbles: r });
        m.call(d, n), d.dispatchEvent(g);
      }
    }, [c, n, r]), /* @__PURE__ */ u.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...i,
        tabIndex: -1,
        ref: s,
        style: {
          ...i.style,
          ...l,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Ok.displayName = Oie;
function Ek(e) {
  return e ? "checked" : "unchecked";
}
var Ak = wk, Eie = Sk;
const Cu = ({
  className: e,
  ref: t,
  ...n
}) => /* @__PURE__ */ u.jsx(
  Ak,
  {
    className: Ce(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#B3DAF9] data-[state=unchecked]:bg-[#E6E6E6]",
      e
    ),
    ...n,
    ref: t,
    children: /* @__PURE__ */ u.jsx(
      Eie,
      {
        className: Ce(
          "pointer-events-none block h-4 w-4 rounded-full bg-background bg-blue-600 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
);
Cu.displayName = Ak.displayName;
function xue(e, t) {
  const n = Le(e), r = Le(null);
  return St(() => {
    n.current = e;
  }, [e]), St(
    () => () => {
      r.current && clearTimeout(r.current);
    },
    []
  ), ot(
    (...i) => {
      r.current && clearTimeout(r.current), r.current = setTimeout(() => {
        n.current(...i);
      }, t);
    },
    [t]
  );
}
function wue(e) {
  const t = e.variant === "simple" ? "gap-4" : "gap-2", n = J(
    "flex h-full w-full flex-col items-start rounded-lg border border-stone-200 bg-white p-5 text-inherit no-underline",
    t,
    e.href && "cursor-pointer"
  ), r = /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx("div", { className: "w-full shrink-0 overflow-hidden rounded-[6px]", children: /* @__PURE__ */ u.jsx(
      Xt,
      {
        alt: e.product.image.alt,
        aspectRatio: e.product.image.aspectRatio,
        fill: !0,
        src: e.product.image.src
      }
    ) }),
    e.variant === "simple" ? /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-center justify-center gap-2", children: [
      /* @__PURE__ */ u.jsx("div", { className: "flex min-h-16 w-full items-center justify-center text-center", children: /* @__PURE__ */ u.jsx("div", { className: "line-clamp-2 overflow-hidden", children: /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.product.name }) }) }),
      e.product.price && /* @__PURE__ */ u.jsx("div", { className: "flex items-center py-1", children: /* @__PURE__ */ u.jsx(B, { variant: "muted", children: e.product.price }) })
    ] }) }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx("div", { className: "flex min-h-16 w-full items-center justify-center self-stretch text-center", children: /* @__PURE__ */ u.jsx("div", { className: "line-clamp-2 overflow-hidden", children: /* @__PURE__ */ u.jsx(B, { variant: "h3", children: e.product.name }) }) }),
      e.product.code && /* @__PURE__ */ u.jsx("div", { className: "w-full self-stretch text-center", children: /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-center gap-2.5", children: [
        /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.productCode }),
        /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.product.code })
      ] }) }),
      /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col items-center gap-1 self-stretch", children: [
        e.product.dealerPriceLabel && e.product.dealerPriceValue && /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-center gap-2.5", children: [
          /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.product.dealerPriceLabel }),
          /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.product.dealerPriceValue })
        ] }),
        e.product.rrpLabel && e.product.rrpValue && /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2.5", children: [
          /* @__PURE__ */ u.jsx(B, { variant: "muted", children: e.product.rrpLabel }),
          /* @__PURE__ */ u.jsx(B, { variant: "muted", children: e.product.rrpValue })
        ] })
      ] })
    ] })
  ] });
  return e.href ? /* @__PURE__ */ u.jsx(
    ve,
    {
      className: "block h-full w-full shrink whitespace-normal bg-transparent p-0 text-inherit no-underline shadow-none hover:bg-transparent hover:no-underline focus-visible:ring-0",
      href: e.href,
      unstyled: !0,
      children: /* @__PURE__ */ u.jsx("div", { className: n, children: r }, e.id)
    }
  ) : /* @__PURE__ */ u.jsx("div", { className: n, children: r }, e.id);
}
function _ue(e) {
  return /* @__PURE__ */ u.jsx(
    "nav",
    {
      "aria-label": e.navAriaLabel || "Line steps navigation",
      className: J("w-full", e.className),
      "data-testid": "line-steps",
      children: /* @__PURE__ */ u.jsx("ol", { className: "flex w-full items-start", children: e.steps.map((t, n) => {
        const r = n + 1, i = t.id === e.currentStep, a = n < e.steps.findIndex((c) => c.id === e.currentStep), o = n === e.steps.length - 1, s = (i || a) && !e.nonClickableStepIds?.includes(t.id);
        return /* @__PURE__ */ u.jsxs(
          "li",
          {
            className: J(
              "flex max-w-[234px] shrink-0 items-start",
              !o && "flex-1"
            ),
            children: [
              /* @__PURE__ */ u.jsxs("div", { className: "flex min-w-[70px] shrink-0 flex-col items-center gap-3", children: [
                /* @__PURE__ */ u.jsx(
                  ve,
                  {
                    "aria-label": `step ${r} of ${e.steps.length}${a ? ", completed" : ""}`,
                    className: J(
                      i ? "bg-primary text-primary-foreground" : "",
                      s ? "cursor-pointer" : "cursor-default"
                    ),
                    onClick: () => s && e.onStepClick?.(t.id),
                    size: "rounded-lg",
                    variant: "rounded",
                    children: /* @__PURE__ */ u.jsx(B, { variant: "body-lg", children: r })
                  }
                ),
                /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: t.label })
              ] }),
              !o && /* @__PURE__ */ u.jsx("div", { className: "mt-7 h-px min-w-2 max-w-[120px] grow bg-border sm:mx-2 md:mx-[22px]" })
            ]
          },
          t.id
        );
      }) })
    }
  );
}
function Aie(e) {
  const t = Le(e);
  return t.current = e, t;
}
function RP(e, t) {
  if (e.length !== t.length)
    return !1;
  const n = new Set(t);
  return e.every((r) => n.has(r));
}
function Pie(e) {
  const t = Aie(e.selectedValues), n = Le(
    e.defaultSelectedValues.length > 0 ? e.defaultSelectedValues : e.selectedValues
  );
  function r(d) {
    e.onSelectionChange?.(d);
  }
  function i(d) {
    const h = t.current.includes(d) ? t.current.filter((m) => m !== d) : [...t.current, d];
    r(h);
  }
  function a() {
    e.onReset?.();
  }
  const o = e.name || `accordion-filter-${e.title.replace(/\s+/g, "-").toLowerCase()}`, s = t.current.length > 0 ? ` (${t.current.length})` : "", c = e.variant === "radio" ? e.resetLabel : e.resetLabel + s, l = e.variant === "radio" ? RP(
    t.current,
    e.defaultSelectedValues
  ) : RP(
    t.current,
    n.current
  );
  return /* @__PURE__ */ u.jsx("div", { className: J("accordion-filter", e.className), children: /* @__PURE__ */ u.jsx(
    Ma,
    {
      collapsible: !0,
      defaultValue: e.defaultOpen ? "open" : void 0,
      type: "single",
      children: /* @__PURE__ */ u.jsxs(Ks, { value: "open", children: [
        /* @__PURE__ */ u.jsx(
          Gs,
          {
            className: "pt-4 pb-2",
            onReset: () => a(),
            resetDisabled: l,
            resetId: o,
            resetLabel: c,
            triggerVariant: "reset",
            children: /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.title }) })
          }
        ),
        /* @__PURE__ */ u.jsx(Zs, { children: /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1.5 py-1 [&_label]:items-center", children: e.variant === "radio" ? /* @__PURE__ */ u.jsx(
          fc,
          {
            labelVariant: "body-sm",
            name: o,
            onValueChange: (d) => r(d ? [d] : []),
            options: e.options,
            value: t.current[0]
          }
        ) : e.options.map((d) => {
          const f = `${o}-${d.value}`, h = t.current.includes(
            d.value
          );
          return /* @__PURE__ */ u.jsxs(
            wt,
            {
              className: "flex cursor-pointer select-none items-start gap-2",
              disabled: d.disabled,
              htmlFor: f,
              variant: "default",
              children: [
                /* @__PURE__ */ u.jsx(
                  FN,
                  {
                    checked: h,
                    className: "mt-px",
                    disabled: d.disabled,
                    id: f,
                    name: o,
                    onChange: () => {
                      d.disabled || i(d.value);
                    },
                    type: "checkbox"
                  }
                ),
                /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: d.label }),
                  d.description && /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-xs", children: d.description })
                ] })
              ]
            },
            d.value
          );
        }) }) })
      ] })
    }
  ) });
}
function Sa(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e?.(i), n === !1 || !i.defaultPrevented)
      return t?.(i);
  };
}
var Pk = ["PageUp", "PageDown"], Ck = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], jk = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Co = "Slider", [jy, Cie, jie] = _d(Co), [Tk] = wn(Co, [
  jie
]), [Tie, Wd] = Tk(Co), Nk = A.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: a = 1,
      orientation: o = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: l = [r],
      value: d,
      onValueChange: f = () => {
      },
      onValueCommit: h = () => {
      },
      inverted: m = !1,
      form: g,
      ...p
    } = e, v = A.useRef(/* @__PURE__ */ new Set()), y = A.useRef(0), w = o === "horizontal" ? Nie : Mie, [_ = [], b] = In({
      prop: d,
      defaultProp: l,
      onChange: (j) => {
        [...v.current][y.current]?.focus(), f(j);
      }
    }), S = A.useRef(_);
    function O(j) {
      const C = Lie(_, j);
      R(j, C);
    }
    function E(j) {
      R(j, y.current);
    }
    function P() {
      const j = S.current[y.current];
      _[y.current] !== j && h(_);
    }
    function R(j, C, { commit: N } = { commit: !1 }) {
      const k = zie(a), I = qie(Math.round((j - r) / a) * a + r, k), $ = xu(I, [r, i]);
      b((z = []) => {
        const V = kie(z, $, C);
        if (Fie(V, c * a)) {
          y.current = V.indexOf($);
          const K = String(V) !== String(z);
          return K && N && h(V), K ? V : z;
        } else
          return z;
      });
    }
    return /* @__PURE__ */ u.jsx(
      Tie,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: i,
        valueIndexToChangeRef: y,
        thumbs: v.current,
        values: _,
        orientation: o,
        form: g,
        children: /* @__PURE__ */ u.jsx(jy.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ u.jsx(jy.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ u.jsx(
          w,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...p,
            ref: t,
            onPointerDown: Sa(p.onPointerDown, () => {
              s || (S.current = _);
            }),
            min: r,
            max: i,
            inverted: m,
            onSlideStart: s ? void 0 : O,
            onSlideMove: s ? void 0 : E,
            onSlideEnd: s ? void 0 : P,
            onHomeKeyDown: () => !s && R(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && R(i, _.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: j, direction: C }) => {
              if (!s) {
                const I = Pk.includes(j.key) || j.shiftKey && Ck.includes(j.key) ? 10 : 1, $ = y.current, z = _[$], V = a * I * C;
                R(z + V, $, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
Nk.displayName = Co;
var [Mk, Ik] = Tk(Co, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Nie = A.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: a,
      onSlideStart: o,
      onSlideMove: s,
      onSlideEnd: c,
      onStepKeyDown: l,
      ...d
    } = e, [f, h] = A.useState(null), m = ke(t, (w) => h(w)), g = A.useRef(void 0), p = hc(i), v = p === "ltr", y = v && !a || !v && a;
    function x(w) {
      const _ = g.current || f.getBoundingClientRect(), b = [0, _.width], O = Lx(b, y ? [n, r] : [r, n]);
      return g.current = _, O(w - _.left);
    }
    return /* @__PURE__ */ u.jsx(
      Mk,
      {
        scope: e.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ u.jsx(
          Dk,
          {
            dir: p,
            "data-orientation": "horizontal",
            ...d,
            ref: m,
            style: {
              ...d.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (w) => {
              const _ = x(w.clientX);
              o?.(_);
            },
            onSlideMove: (w) => {
              const _ = x(w.clientX);
              s?.(_);
            },
            onSlideEnd: () => {
              g.current = void 0, c?.();
            },
            onStepKeyDown: (w) => {
              const b = jk[y ? "from-left" : "from-right"].includes(w.key);
              l?.({ event: w, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Mie = A.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: a,
      onSlideMove: o,
      onSlideEnd: s,
      onStepKeyDown: c,
      ...l
    } = e, d = A.useRef(null), f = ke(t, d), h = A.useRef(void 0), m = !i;
    function g(p) {
      const v = h.current || d.current.getBoundingClientRect(), y = [0, v.height], w = Lx(y, m ? [r, n] : [n, r]);
      return h.current = v, w(p - v.top);
    }
    return /* @__PURE__ */ u.jsx(
      Mk,
      {
        scope: e.__scopeSlider,
        startEdge: m ? "bottom" : "top",
        endEdge: m ? "top" : "bottom",
        size: "height",
        direction: m ? 1 : -1,
        children: /* @__PURE__ */ u.jsx(
          Dk,
          {
            "data-orientation": "vertical",
            ...l,
            ref: f,
            style: {
              ...l.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (p) => {
              const v = g(p.clientY);
              a?.(v);
            },
            onSlideMove: (p) => {
              const v = g(p.clientY);
              o?.(v);
            },
            onSlideEnd: () => {
              h.current = void 0, s?.();
            },
            onStepKeyDown: (p) => {
              const y = jk[m ? "from-bottom" : "from-top"].includes(p.key);
              c?.({ event: p, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Dk = A.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: a,
      onHomeKeyDown: o,
      onEndKeyDown: s,
      onStepKeyDown: c,
      ...l
    } = e, d = Wd(Co, n);
    return /* @__PURE__ */ u.jsx(
      Ae.span,
      {
        ...l,
        ref: t,
        onKeyDown: Sa(e.onKeyDown, (f) => {
          f.key === "Home" ? (o(f), f.preventDefault()) : f.key === "End" ? (s(f), f.preventDefault()) : Pk.concat(Ck).includes(f.key) && (c(f), f.preventDefault());
        }),
        onPointerDown: Sa(e.onPointerDown, (f) => {
          const h = f.target;
          h.setPointerCapture(f.pointerId), f.preventDefault(), d.thumbs.has(h) ? h.focus() : r(f);
        }),
        onPointerMove: Sa(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && i(f);
        }),
        onPointerUp: Sa(e.onPointerUp, (f) => {
          const h = f.target;
          h.hasPointerCapture(f.pointerId) && (h.releasePointerCapture(f.pointerId), a(f));
        })
      }
    );
  }
), kk = "SliderTrack", Rk = A.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Wd(kk, n);
    return /* @__PURE__ */ u.jsx(
      Ae.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: t
      }
    );
  }
);
Rk.displayName = kk;
var Ty = "SliderRange", Lk = A.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Wd(Ty, n), a = Ik(Ty, n), o = A.useRef(null), s = ke(t, o), c = i.values.length, l = i.values.map(
      (h) => Fk(h, i.min, i.max)
    ), d = c > 1 ? Math.min(...l) : 0, f = 100 - Math.max(...l);
    return /* @__PURE__ */ u.jsx(
      Ae.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: d + "%",
          [a.endEdge]: f + "%"
        }
      }
    );
  }
);
Lk.displayName = Ty;
var Ny = "SliderThumb", $k = A.forwardRef(
  (e, t) => {
    const n = Cie(e.__scopeSlider), [r, i] = A.useState(null), a = ke(t, (s) => i(s)), o = A.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ u.jsx(Iie, { ...e, ref: a, index: o });
  }
), Iie = A.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: i, ...a } = e, o = Wd(Ny, n), s = Ik(Ny, n), [c, l] = A.useState(null), d = ke(t, (x) => l(x)), f = c ? o.form || !!c.closest("form") : !0, h = hx(c), m = o.values[r], g = m === void 0 ? 0 : Fk(m, o.min, o.max), p = Rie(r, o.values.length), v = h?.[s.size], y = v ? $ie(v, g, s.direction) : 0;
    return A.useEffect(() => {
      if (c)
        return o.thumbs.add(c), () => {
          o.thumbs.delete(c);
        };
    }, [c, o.thumbs]), /* @__PURE__ */ u.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${g}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ u.jsx(jy.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ u.jsx(
            Ae.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || p,
              "aria-valuemin": o.min,
              "aria-valuenow": m,
              "aria-valuemax": o.max,
              "aria-orientation": o.orientation,
              "data-orientation": o.orientation,
              "data-disabled": o.disabled ? "" : void 0,
              tabIndex: o.disabled ? void 0 : 0,
              ...a,
              ref: d,
              style: m === void 0 ? { display: "none" } : e.style,
              onFocus: Sa(e.onFocus, () => {
                o.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          f && /* @__PURE__ */ u.jsx(
            Bk,
            {
              name: i ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0),
              form: o.form,
              value: m
            },
            r
          )
        ]
      }
    );
  }
);
$k.displayName = Ny;
var Die = "RadioBubbleInput", Bk = A.forwardRef(
  ({ __scopeSlider: e, value: t, ...n }, r) => {
    const i = A.useRef(null), a = ke(i, r), o = bx(t);
    return A.useEffect(() => {
      const s = i.current;
      if (!s) return;
      const c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "value").set;
      if (o !== t && d) {
        const f = new Event("input", { bubbles: !0 });
        d.call(s, t), s.dispatchEvent(f);
      }
    }, [o, t]), /* @__PURE__ */ u.jsx(
      Ae.input,
      {
        style: { display: "none" },
        ...n,
        ref: a,
        defaultValue: t
      }
    );
  }
);
Bk.displayName = Die;
function kie(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((i, a) => i - a);
}
function Fk(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return xu(a, [0, 100]);
}
function Rie(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function Lie(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((i) => Math.abs(i - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function $ie(e, t, n) {
  const r = e / 2, a = Lx([0, 50], [0, r]);
  return (r - a(t) * n) * n;
}
function Bie(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function Fie(e, t) {
  if (t > 0) {
    const n = Bie(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Lx(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function zie(e) {
  return (String(e).split(".")[1] || "").length;
}
function qie(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Vie = Nk, Wie = Rk, Uie = Lk, LP = $k;
function Hie(e) {
  const t = Le(e);
  return t.current = e, t;
}
function $P(e, t, n) {
  return Math.min(n, Math.max(t, e));
}
function sl(e, t) {
  const n = e.replace(/[^\d-]/g, "");
  if (n === "" || n === "-")
    return t;
  const r = Number(n);
  return Number.isFinite(r) ? r : t;
}
function BP(e) {
  let t = "";
  for (const n of e) {
    if (/\d/.test(n)) {
      t += n;
      continue;
    }
    n === "-" && t.length === 0 && (t += n);
  }
  return t;
}
function FP(e, t) {
  const n = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2
  }).format(e);
  return `${t} ${n}`;
}
function Yie(e, t, n, r) {
  const i = t - e || 1, a = Math.floor((n[0] - e) / i * r), o = Math.ceil((n[1] - e) / i * r) - 1;
  return [Math.max(0, a), Math.min(r - 1, o)];
}
function Kie(e) {
  const t = tf(), n = tf(), r = tf(), i = e.step ?? 1, a = Hie(e.value), [o, s] = Ee({
    draftVersion: 0,
    focusedInput: null
  }), c = Le({
    minInput: String(e.value[0]),
    maxInput: String(e.value[1])
  }), l = Le(e.value), d = e.selectedPriceType ?? "dealer", f = [
    {
      value: "dealer",
      label: e.microcopies.dealerPriceLabel
    },
    {
      value: "retail",
      label: e.microcopies.retailPriceLabel
    }
  ], h = e.distribution && e.distribution.length > 0 ? Yie(
    e.min,
    e.max,
    e.value,
    e.distribution.length
  ) : void 0;
  (l.current[0] !== e.value[0] || l.current[1] !== e.value[1]) && (l.current = e.value, c.current = {
    minInput: String(e.value[0]),
    maxInput: String(e.value[1])
  });
  function m() {
    s((b) => ({
      ...b,
      draftVersion: b.draftVersion + 1
    }));
  }
  function g(b) {
    s((S) => ({
      ...S,
      focusedInput: b
    }));
  }
  function p() {
    const b = v();
    e.onValueChange?.(b), e.onFilterAction?.(b);
  }
  function v() {
    const b = sl(
      c.current.minInput,
      a.current[0]
    ), S = sl(
      c.current.maxInput,
      a.current[1]
    ), O = $P(b, e.min, e.max), E = $P(S, e.min, e.max);
    return O <= E ? [O, E] : [E, O];
  }
  const y = v(), x = y[0] !== e.value[0] || y[1] !== e.value[1], w = o.focusedInput === "min" ? c.current.minInput : FP(
    sl(c.current.minInput, e.value[0]),
    e.microcopies.currencySymbol
  ), _ = o.focusedInput === "max" ? c.current.maxInput : FP(
    sl(c.current.maxInput, e.value[1]),
    e.microcopies.currencySymbol
  );
  return /* @__PURE__ */ u.jsxs("div", { className: J("space-y-3", e.className), children: [
    /* @__PURE__ */ u.jsxs("fieldset", { className: "space-y-2", children: [
      /* @__PURE__ */ u.jsx("legend", { children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.priceTypeLabel }) }),
      /* @__PURE__ */ u.jsx(
        fc,
        {
          className: "gap-1",
          labelVariant: "body-sm",
          name: t,
          onValueChange: (b) => {
            (b === "dealer" || b === "retail") && e.onPriceTypeChange?.(b);
          },
          options: f,
          value: d
        }
      )
    ] }),
    e.distribution ? /* @__PURE__ */ u.jsx(
      cK,
      {
        activeRange: h,
        data: e.distribution,
        height: 48
      }
    ) : null,
    /* @__PURE__ */ u.jsxs(
      Vie,
      {
        className: "relative flex w-full touch-none select-none items-center",
        max: e.max,
        min: e.min,
        onValueChange: (b) => {
          c.current = {
            minInput: String(b[0]),
            maxInput: String(b[1])
          }, m();
        },
        step: i,
        value: y,
        children: [
          /* @__PURE__ */ u.jsx(Wie, { className: "relative h-2.5 w-full grow overflow-hidden rounded-full bg-stone-200", children: /* @__PURE__ */ u.jsx(Uie, { className: "absolute h-full bg-stone-900" }) }),
          /* @__PURE__ */ u.jsx(
            LP,
            {
              "aria-label": `${e.microcopies.title} minimum price`,
              className: "block h-4 w-4 rounded-full border border-stone-900 bg-white shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-2"
            }
          ),
          /* @__PURE__ */ u.jsx(
            LP,
            {
              "aria-label": `${e.microcopies.title} maximum price`,
              className: "block h-4 w-4 rounded-full border border-stone-900 bg-white shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-2"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: `${e.microcopies.currencySymbol} ${e.value[0]}` }),
      /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: `${e.microcopies.currencySymbol} ${e.value[1]}` })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-[1fr_auto_1fr] items-end gap-2", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ u.jsx("label", { className: "block", htmlFor: n, children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.minLabel }) }),
          /* @__PURE__ */ u.jsx(
            ni,
            {
              id: n,
              inputMode: "numeric",
              max: e.max,
              min: e.min,
              onBlur: () => {
                g(null);
              },
              onChange: (b) => {
                const S = BP(
                  b.target.value
                );
                c.current = {
                  ...c.current,
                  minInput: S
                }, m();
              },
              onFocus: () => {
                g("min");
              },
              onKeyDown: (b) => {
                b.key === "Enter" && p();
              },
              step: i,
              type: "text",
              value: w
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("span", { className: "pb-3", children: "-" }),
        /* @__PURE__ */ u.jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ u.jsx("label", { className: "block", htmlFor: r, children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.maxLabel }) }),
          /* @__PURE__ */ u.jsx(
            ni,
            {
              id: r,
              inputMode: "numeric",
              max: e.max,
              min: e.min,
              onBlur: () => {
                g(null);
              },
              onChange: (b) => {
                const S = BP(
                  b.target.value
                );
                c.current = {
                  ...c.current,
                  maxInput: S
                }, m();
              },
              onFocus: () => {
                g("max");
              },
              onKeyDown: (b) => {
                b.key === "Enter" && p();
              },
              step: i,
              type: "text",
              value: _
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: !x,
          onClick: p,
          size: "sm",
          type: "button",
          variant: "outline-no-hover",
          children: e.microcopies.okButtonLabel
        }
      ) })
    ] })
  ] });
}
const zk = "__price_filter_range__";
function My(e) {
  return e.value === zk;
}
function Iy(e) {
  return `${e.groupTitle}::${e.value}`;
}
function Gie(e, t) {
  if (e.length !== t.length)
    return !1;
  const n = new Set(t.map(Iy));
  return e.every((r) => n.has(Iy(r)));
}
function Zie(e) {
  const { selectedValues: t, ...n } = e;
  return n;
}
function ju(e) {
  return "kind" in e && e.kind === "price";
}
function qk(e) {
  return !ju(e);
}
function $x(e, t) {
  return e.find((r) => r.value === t)?.label ?? t;
}
function zP(e, t) {
  return t.map((n) => ({
    groupTitle: e.title,
    value: n,
    label: $x(e.options, n)
  }));
}
function qP(e) {
  return e.flatMap((t) => ju(t) ? [] : t.defaultSelectedValues.map((n) => ({
    groupTitle: t.title,
    value: n,
    label: $x(t.options, n)
  })));
}
function Xie(e, t) {
  const n = new Set(
    t.flatMap((r) => !qk(r) || r.variant !== "radio" ? [] : r.defaultSelectedValues.map(
      (i) => `${r.title}::${i}`
    ))
  );
  return e.filter(
    (r) => !n.has(Iy(r))
  );
}
function Vk(e) {
  return [e.min, e.max];
}
function Dy(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}
function Qie(e) {
  if (!e)
    return !0;
  const t = e.defaultSelectedPriceType ?? "dealer", n = e.selectedPriceType ?? "dealer";
  return Dy(e.value, Vk(e)) && n === t;
}
function VP(e) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(e);
}
function Jie(e, t, n) {
  return {
    groupTitle: e,
    value: zk,
    label: `${n} ${VP(t[0])} - ${n} ${VP(t[1])}`
  };
}
function WP(e, t, n, r, i) {
  const a = e.filter(
    (o) => !(o.groupTitle === t && My(o))
  );
  return n ? a : [
    ...a,
    Jie(t, r, i)
  ];
}
function eae(e, t, n) {
  return /* @__PURE__ */ u.jsx("div", { className: J("accordion-filter", e.className), children: /* @__PURE__ */ u.jsx(
    Ma,
    {
      collapsible: !0,
      defaultValue: e.defaultOpen ? "open" : void 0,
      type: "single",
      children: /* @__PURE__ */ u.jsxs(Ks, { value: "open", children: [
        /* @__PURE__ */ u.jsx(
          Gs,
          {
            className: "pt-4 pb-2",
            onReset: () => t.onReset?.(),
            resetDisabled: n,
            resetId: `accordion-filter-${e.title.replace(/\s+/g, "-").toLowerCase()}`,
            resetLabel: e.resetLabel,
            triggerVariant: "reset",
            children: /* @__PURE__ */ u.jsx("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.title }) })
          }
        ),
        /* @__PURE__ */ u.jsx(Zs, { children: /* @__PURE__ */ u.jsx("div", { className: "py-1", children: /* @__PURE__ */ u.jsx(Kie, { ...t, className: t.className }) }) })
      ] })
    }
  ) }, e.title);
}
function Sue(e) {
  const t = e.priceFilter ? {
    kind: "price",
    title: e.priceFilter.microcopies.title,
    resetLabel: e.priceFilter.microcopies.resetLabel,
    defaultOpen: e.defaultOpen,
    priceFilter: e.priceFilter
  } : void 0, n = t ? [...e.filterGroups, t] : e.filterGroups, r = n.find(
    (x) => ju(x)
  ), [i, a] = Ee({
    open: !!e.defaultOpen,
    internalSelected: e.selectedFilters || qP(n),
    resetAllSignal: void 0,
    removeValuesMap: {}
  }), o = Le({}), s = e.selectedFilters ?? i.internalSelected, c = Le(s);
  function l(x) {
    globalThis.matchMedia("(max-width: 639px)").matches && (document.body.style.overflow = x ? "hidden" : ""), a((_) => ({ ..._, open: x })), e.onToggle?.(x);
  }
  const d = Xie(
    s,
    n
  ), f = qP(n), h = Gie(
    s,
    f
  ), m = r ? Qie(r.priceFilter) : !0, g = h && m;
  c.current = s;
  function p(x) {
    e.selectedFilters === void 0 && a((w) => ({ ...w, internalSelected: x })), e.onFiltersChange?.(x);
  }
  function v(x) {
    if (x.groupTitle === r?.title && My(x) && r) {
      r.priceFilter.onReset?.();
      const S = c.current.filter(
        (O) => !(O.groupTitle === r.title && My(O))
      );
      p(S);
      return;
    }
    const _ = e.filterGroups.find(
      (S) => S.title === x.groupTitle && qk(S)
    );
    if (!_) {
      const S = c.current.filter(
        (O) => !(O.groupTitle === x.groupTitle && O.value === x.value)
      );
      p(S);
      return;
    }
    if (_.variant === "radio") {
      const S = zP(
        _,
        _.defaultSelectedValues
      ), O = [
        ...c.current.filter(
          (E) => E.groupTitle !== x.groupTitle
        ),
        ...S
      ];
      p(O);
      return;
    }
    const b = c.current.filter(
      (S) => !(S.groupTitle === x.groupTitle && S.value === x.value)
    );
    p(b), a((S) => ({
      ...S,
      removeValuesMap: {
        ...S.removeValuesMap,
        [x.groupTitle]: [
          ...S.removeValuesMap[x.groupTitle] || [],
          x.value
        ]
      }
    })), setTimeout(() => {
      a((S) => {
        const O = { ...S.removeValuesMap };
        return delete O[x.groupTitle], { ...S, removeValuesMap: O };
      });
    }, 0);
  }
  function y() {
    g || (h || p(f), m || r?.priceFilter.onReset?.(), a((x) => ({
      ...x,
      resetAllSignal: x.resetAllSignal === void 0 ? 1 : x.resetAllSignal + 1
    })), e.onResetAll?.());
  }
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: J("product-filters", "w-full sm:max-w-64", e.className),
      children: [
        /* @__PURE__ */ u.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ u.jsxs(
          ve,
          {
            className: "max-[425px]:w-full",
            onClick: () => l(!i.open),
            size: "sm",
            variant: "outline",
            children: [
              /* @__PURE__ */ u.jsx(d0, { className: "mr-1 h-4 w-4" }),
              /* @__PURE__ */ u.jsxs(B, { variant: "body-sm", children: [
                i.open ? e.microcopies?.hideFiltersButton : e.microcopies?.showFiltersButton,
                " ",
                "(",
                d.length,
                ")"
              ] })
            ]
          }
        ) }),
        d.length > 0 && !i.open ? /* @__PURE__ */ u.jsxs("div", { className: "mt-3 w-full sm:hidden", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies?.selectedFiltersMobileTitle }),
            /* @__PURE__ */ u.jsx(
              ve,
              {
                className: "pr-0",
                disabled: g,
                onClick: y,
                size: "sm",
                variant: "ghost",
                children: e.microcopies?.clearFiltersButton
              }
            )
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "mt-1 flex min-w-0 flex-wrap gap-2", children: d.map((x) => /* @__PURE__ */ u.jsx(
            La,
            {
              className: "px-2",
              fontWeight: "bold",
              icon: /* @__PURE__ */ u.jsx(ei, { className: "h-full w-full", strokeWidth: 3 }),
              onClick: () => v(x),
              size: "default",
              text: x.label,
              variant: "outline"
            },
            x.label
          )) })
        ] }) : null,
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: J(
              "grid transition-[grid-template-rows] duration-200 ease-out",
              e.panelClassName,
              i.open ? "mt-4 grid-rows-[1fr]" : "grid-rows-[0fr]",
              i.open ? "max-sm:fixed max-sm:inset-0 max-sm:z-[100] max-sm:mt-0 max-sm:h-screen max-sm:overflow-y-auto max-sm:bg-white" : ""
            ),
            children: /* @__PURE__ */ u.jsxs(
              "div",
              {
                className: J(
                  "min-h-0 overflow-hidden transition-opacity duration-200 ease-out",
                  i.open ? "p-5 pr-0 pb-0 pl-8 opacity-100 max-sm:flex max-sm:h-screen max-sm:flex-col max-sm:overflow-y-auto max-sm:p-0" : "opacity-0"
                ),
                children: [
                  /* @__PURE__ */ u.jsxs("div", { className: "hidden items-center justify-between border-b px-4 py-3 max-sm:flex", children: [
                    /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ u.jsx(d0, { className: "h-4 w-4" }),
                      /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies?.filtersTitle ?? e.microcopies?.hideFiltersButton })
                    ] }),
                    /* @__PURE__ */ u.jsx(
                      ve,
                      {
                        "aria-label": e.microcopies?.hideFiltersButton,
                        onClick: () => l(!1),
                        size: "sm",
                        variant: "ghost",
                        children: /* @__PURE__ */ u.jsx(ei, { className: "h-5 w-5" })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ u.jsxs("div", { className: "mt-2 w-full max-sm:px-4", children: [
                    /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-between", children: [
                      /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies?.selectedFiltersTitle }),
                      /* @__PURE__ */ u.jsx(
                        ve,
                        {
                          disabled: g,
                          onClick: y,
                          size: "sm",
                          variant: "ghost",
                          children: e.microcopies?.resetAllButton
                        }
                      )
                    ] }),
                    /* @__PURE__ */ u.jsx("div", { className: "mt-1 flex min-w-0 flex-wrap gap-2", children: d.map((x) => /* @__PURE__ */ u.jsx(
                      La,
                      {
                        className: "px-2",
                        fontWeight: "bold",
                        icon: /* @__PURE__ */ u.jsx(ei, { className: "h-full w-full", strokeWidth: 3 }),
                        onClick: () => v(x),
                        size: "default",
                        text: x.label,
                        variant: "outline"
                      },
                      x.label
                    )) })
                  ] }),
                  /* @__PURE__ */ u.jsx("div", { className: "w-full max-sm:px-4 max-sm:pb-8", children: n.map((x) => {
                    if (ju(x)) {
                      o.current[x.title] || (o.current[x.title] = {
                        range: Vk(x.priceFilter),
                        selectedPriceType: x.priceFilter.defaultSelectedPriceType ?? "dealer"
                      });
                      const O = o.current[x.title], E = x.priceFilter.selectedPriceType ?? "dealer", P = Dy(
                        x.priceFilter.value,
                        O.range
                      ) && E === O.selectedPriceType, R = {
                        ...x.priceFilter,
                        onFilterAction: (j) => {
                          x.priceFilter.onFilterAction?.(j);
                          const C = x.priceFilter.selectedPriceType ?? "dealer", N = x.priceFilter.defaultSelectedPriceType ?? "dealer", k = Dy(j, O.range) && C === N, I = WP(
                            c.current,
                            x.title,
                            k,
                            j,
                            x.priceFilter.microcopies.currencySymbol
                          );
                          p(I);
                        },
                        onReset: () => {
                          x.priceFilter.onReset?.();
                          const j = WP(
                            c.current,
                            x.title,
                            !0,
                            O.range,
                            x.priceFilter.microcopies.currencySymbol
                          );
                          p(j);
                        }
                      };
                      return eae(
                        x,
                        R,
                        P
                      );
                    }
                    const w = Zie(x), _ = (S) => {
                      const O = zP(
                        x,
                        S || []
                      ), P = [
                        // keep everything except this group's existing entries
                        ...c.current.filter((R) => R.groupTitle !== x.title),
                        // add the group's current selection
                        ...O
                      ];
                      p(P);
                    }, b = () => {
                      let O = c.current.filter((E) => E.groupTitle !== x.title);
                      if (x.variant === "radio" && x.defaultSelectedValues.length > 0) {
                        const E = x.defaultSelectedValues.map(
                          (P) => ({
                            groupTitle: x.title,
                            value: P,
                            label: $x(x.options, P)
                          })
                        );
                        O = [...O, ...E];
                      }
                      p(O);
                    };
                    return /* @__PURE__ */ u.jsx(
                      Pie,
                      {
                        ...w,
                        onReset: b,
                        onSelectionChange: _,
                        resetLabel: x.resetLabel,
                        selectedValues: s.filter((S) => S.groupTitle === x.title).map((S) => S.value)
                      },
                      x.title
                    );
                  }) }),
                  /* @__PURE__ */ u.jsxs("div", { className: "hidden gap-3 border-t bg-white p-4 max-sm:sticky max-sm:bottom-0 max-sm:flex", children: [
                    /* @__PURE__ */ u.jsx(
                      ve,
                      {
                        className: "flex-1",
                        disabled: g,
                        onClick: y,
                        size: "sm",
                        variant: "outline",
                        children: e.microcopies?.resetFiltersButton ?? e.microcopies?.resetAllButton
                      }
                    ),
                    /* @__PURE__ */ u.jsx(ve, { className: "flex-1", onClick: () => l(!1), size: "sm", children: e.microcopies?.showResultsButton })
                  ] })
                ]
              }
            )
          }
        )
      ]
    }
  );
}
var Vp = "rovingFocusGroup.onEntryFocus", tae = { bubbles: !1, cancelable: !0 }, wc = "RovingFocusGroup", [ky, Wk, nae] = _d(wc), [rae, Uk] = wn(
  wc,
  [nae]
), [iae, aae] = rae(wc), Hk = A.forwardRef(
  (e, t) => /* @__PURE__ */ u.jsx(ky.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u.jsx(ky.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u.jsx(oae, { ...e, ref: t }) }) })
);
Hk.displayName = wc;
var oae = A.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: a,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, h = A.useRef(null), m = ke(t, h), g = hc(a), [p, v] = In({
    prop: o,
    defaultProp: s ?? null,
    onChange: c,
    caller: wc
  }), [y, x] = A.useState(!1), w = ii(l), _ = Wk(n), b = A.useRef(!1), [S, O] = A.useState(0);
  return A.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(Vp, w), () => E.removeEventListener(Vp, w);
  }, [w]), /* @__PURE__ */ u.jsx(
    iae,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: i,
      currentTabStopId: p,
      onItemFocus: A.useCallback(
        (E) => v(E),
        [v]
      ),
      onItemShiftTab: A.useCallback(() => x(!0), []),
      onFocusableItemAdd: A.useCallback(
        () => O((E) => E + 1),
        []
      ),
      onFocusableItemRemove: A.useCallback(
        () => O((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ u.jsx(
        Ae.div,
        {
          tabIndex: y || S === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: Oe(e.onMouseDown, () => {
            b.current = !0;
          }),
          onFocus: Oe(e.onFocus, (E) => {
            const P = !b.current;
            if (E.target === E.currentTarget && P && !y) {
              const R = new CustomEvent(Vp, tae);
              if (E.currentTarget.dispatchEvent(R), !R.defaultPrevented) {
                const j = _().filter(($) => $.focusable), C = j.find(($) => $.active), N = j.find(($) => $.id === p), I = [C, N, ...j].filter(
                  Boolean
                ).map(($) => $.ref.current);
                Gk(I, d);
              }
            }
            b.current = !1;
          }),
          onBlur: Oe(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), Yk = "RovingFocusGroupItem", Kk = A.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: a,
      children: o,
      ...s
    } = e, c = Nn(), l = a || c, d = aae(Yk, n), f = d.currentTabStopId === l, h = Wk(n), { onFocusableItemAdd: m, onFocusableItemRemove: g, currentTabStopId: p } = d;
    return A.useEffect(() => {
      if (r)
        return m(), () => g();
    }, [r, m, g]), /* @__PURE__ */ u.jsx(
      ky.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ u.jsx(
          Ae.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: Oe(e.onMouseDown, (v) => {
              r ? d.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: Oe(e.onFocus, () => d.onItemFocus(l)),
            onKeyDown: Oe(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = lae(v, d.orientation, d.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = h().filter((_) => _.focusable).map((_) => _.ref.current);
                if (y === "last") w.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && w.reverse();
                  const _ = w.indexOf(v.currentTarget);
                  w = d.loop ? uae(w, _ + 1) : w.slice(_ + 1);
                }
                setTimeout(() => Gk(w));
              }
            }),
            children: typeof o == "function" ? o({ isCurrentTabStop: f, hasTabStop: p != null }) : o
          }
        )
      }
    );
  }
);
Kk.displayName = Yk;
var sae = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function cae(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function lae(e, t, n) {
  const r = cae(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return sae[r];
}
function Gk(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function uae(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var dae = Hk, fae = Kk, Ud = "Tabs", [hae] = wn(Ud, [
  Uk
]), Zk = Uk(), [mae, Bx] = hae(Ud), Xk = A.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: a,
      orientation: o = "horizontal",
      dir: s,
      activationMode: c = "automatic",
      ...l
    } = e, d = hc(s), [f, h] = In({
      prop: r,
      onChange: i,
      defaultProp: a ?? "",
      caller: Ud
    });
    return /* @__PURE__ */ u.jsx(
      mae,
      {
        scope: n,
        baseId: Nn(),
        value: f,
        onValueChange: h,
        orientation: o,
        dir: d,
        activationMode: c,
        children: /* @__PURE__ */ u.jsx(
          Ae.div,
          {
            dir: d,
            "data-orientation": o,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
Xk.displayName = Ud;
var Qk = "TabsList", Jk = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = e, a = Bx(Qk, n), o = Zk(n);
    return /* @__PURE__ */ u.jsx(
      dae,
      {
        asChild: !0,
        ...o,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ u.jsx(
          Ae.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
Jk.displayName = Qk;
var eR = "TabsTrigger", tR = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...a } = e, o = Bx(eR, n), s = Zk(n), c = iR(o.baseId, r), l = aR(o.baseId, r), d = r === o.value;
    return /* @__PURE__ */ u.jsx(
      fae,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ u.jsx(
          Ae.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": l,
            "data-state": d ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: c,
            ...a,
            ref: t,
            onMouseDown: Oe(e.onMouseDown, (f) => {
              !i && f.button === 0 && f.ctrlKey === !1 ? o.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: Oe(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && o.onValueChange(r);
            }),
            onFocus: Oe(e.onFocus, () => {
              const f = o.activationMode !== "manual";
              !d && !i && f && o.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
tR.displayName = eR;
var nR = "TabsContent", rR = A.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: a, ...o } = e, s = Bx(nR, n), c = iR(s.baseId, r), l = aR(s.baseId, r), d = r === s.value, f = A.useRef(d);
    return A.useEffect(() => {
      const h = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ u.jsx(zr, { present: i || d, children: ({ present: h }) => /* @__PURE__ */ u.jsx(
      Ae.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !h,
        id: l,
        tabIndex: 0,
        ...o,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: h && a
      }
    ) });
  }
);
rR.displayName = nR;
function iR(e, t) {
  return `${e}-trigger-${t}`;
}
function aR(e, t) {
  return `${e}-content-${t}`;
}
var vae = Xk, pae = Jk, gae = tR, yae = rR;
const Oue = vae;
function Eue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsx(
    pae,
    {
      className: J(
        "flex w-full items-center justify-start border-[#E7E5E4] border-b bg-transparent p-0",
        e
      ),
      ...t
    }
  );
}
function Aue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsx(
    gae,
    {
      className: J(
        "inline-flex items-center justify-center whitespace-nowrap border-transparent border-b-2 px-4 py-2 font-medium text-[#78716C] text-sm transition-all hover:text-[#1C1917] focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-[#1C1917] data-[state=active]:text-[#1C1917]",
        e
      ),
      ...t
    }
  );
}
function Pue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsx(
    yae,
    {
      className: J("mt-4 focus-visible:outline-none", e),
      ...t
    }
  );
}
var _c = (e) => e.type === "checkbox", ki = (e) => e instanceof Date, zt = (e) => e == null;
const oR = (e) => typeof e == "object";
var ht = (e) => !zt(e) && !Array.isArray(e) && oR(e) && !ki(e), sR = (e) => ht(e) && e.target ? _c(e.target) ? e.target.checked : e.target.value : e, cR = (e, t) => t.split(".").some((n, r, i) => !isNaN(Number(n)) && e.has(i.slice(0, r).join("."))), bae = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return ht(t) && t.hasOwnProperty("isPrototypeOf");
}, Hd = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function pt(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (Hd && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(ht(e) && bae(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = pt(e[i]));
  return r;
}
const Qr = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change",
  SUBMIT: "submit",
  TRIGGER: "trigger",
  VALID: "valid"
}, Wn = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, zn = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Wp = "form", lR = "root", uR = ["__proto__", "constructor", "prototype"];
var Sc = (e) => /^\w*$/.test(e), at = (e) => e === void 0, Yd = (e) => e.split(/[.[\]'"]/g).filter(Boolean), de = (e, t, n) => {
  if (!t || !ht(e))
    return n;
  const r = Sc(t) ? [t] : Yd(t);
  if (r.some((a) => uR.includes(a)))
    return n;
  const i = r.reduce((a, o) => zt(a) ? void 0 : a[o], e);
  return at(i) || i === e ? at(e[t]) ? n : e[t] : i;
}, mn = (e) => typeof e == "boolean", Gt = (e) => typeof e == "function", He = (e, t, n) => {
  let r = -1;
  const i = Sc(t) ? [t] : Yd(t), a = i.length, o = a - 1;
  for (; ++r < a; ) {
    const s = i[r];
    let c = n;
    if (r !== o) {
      const l = e[s];
      c = ht(l) || Array.isArray(l) ? l : isNaN(+i[r + 1]) ? {} : [];
    }
    if (uR.includes(s))
      return;
    e[s] = c, e = e[s];
  }
};
const dR = T.createContext(null);
dR.displayName = "HookFormControlContext";
const Fx = () => T.useContext(dR);
var fR = (e, t, n, r = !0) => {
  const i = {};
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const o = a;
        return t._proxyFormState[o] !== Wn.all && (t._proxyFormState[o] = !r || Wn.all), n && (n[o] = !0), e[o];
      }
    });
  return i;
};
const zx = Hd ? T.useLayoutEffect : T.useEffect;
function xae(e) {
  const t = Fx(), { control: n = t, disabled: r, name: i, exact: a } = e || {}, [o, s] = T.useState(() => ({
    ...n._formState,
    defaultValues: n._defaultValues
  })), c = T.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return zx(() => n._subscribe({
    name: i,
    formState: c.current,
    exact: a,
    callback: (l) => {
      !r && s({
        ...n._formState,
        ...l,
        defaultValues: n._defaultValues
      });
    }
  }), [i, r, a]), T.useEffect(() => {
    c.current.isValid && n._setValid(!0);
  }, [n]), T.useMemo(() => fR(o, n, c.current, !1), [o, n]);
}
var Zt = (e) => typeof e == "string", Ry = (e, t, n, r, i) => Zt(e) ? (r && t.watch.add(e), de(n, e, i)) : Array.isArray(e) ? e.map((a) => (r && t.watch.add(a), de(n, a))) : (r && (t.watchAll = !0), n), Ly = (e) => zt(e) || !oR(e);
function vn(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (e === t)
    return !0;
  if (Ly(e) || Ly(t))
    return Object.is(e, t);
  if (ki(e) && ki(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const a of r) {
    const o = e[a];
    if (!(a in t))
      return !1;
    if (a !== "ref") {
      const s = t[a];
      if (ki(o) && ki(s) || (ht(o) || Array.isArray(o)) && (ht(s) || Array.isArray(s)) ? !vn(o, s, n) : !Object.is(o, s))
        return !1;
    }
  }
  return !0;
}
function hR(e) {
  const t = Fx(), { control: n = t, name: r, defaultValue: i, disabled: a, exact: o, compute: s } = e || {}, c = T.useRef(i), l = T.useRef(s), d = T.useRef(void 0), f = T.useRef(n), h = T.useRef(r);
  l.current = s;
  const [m, g] = T.useState(() => {
    const _ = n._getWatch(r, c.current);
    return l.current ? l.current(_) : _;
  }), p = T.useCallback((_) => {
    const b = Ry(r, n._names, _ || n._formValues, !1, c.current);
    return l.current ? l.current(b) : b;
  }, [n._formValues, n._names, r]), v = T.useCallback((_) => {
    if (!a) {
      const b = Ry(r, n._names, _ || n._formValues, !1, c.current);
      if (l.current) {
        const S = l.current(b);
        vn(S, d.current) || (g(S), d.current = S);
      } else
        g(b);
    }
  }, [n._formValues, n._names, a, r]);
  zx(() => ((f.current !== n || !vn(h.current, r)) && (f.current = n, h.current = r, v()), n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: o,
    callback: (_) => {
      v(_.values);
    }
  })), [n, o, r, v]), T.useEffect(() => n._removeUnmounted());
  const y = f.current !== n, x = h.current, w = T.useMemo(() => {
    if (a)
      return null;
    const _ = !y && !vn(x, r);
    return y || _ ? p() : null;
  }, [a, y, r, x, p]);
  return w !== null ? w : m;
}
function wae(e) {
  const t = Fx(), { name: n, disabled: r, control: i = t, shouldUnregister: a, defaultValue: o, exact: s = !0 } = e, c = cR(i._names.array, n), l = T.useMemo(() => de(i._formValues, n, de(i._defaultValues, n, o)), [i, n, o]), d = hR({
    control: i,
    name: n,
    defaultValue: l,
    exact: s
  }), f = xae({
    control: i,
    name: n,
    exact: s
  }), h = T.useRef(e), m = T.useRef(i.register(n, {
    ...e.rules,
    value: d,
    ...mn(e.disabled) ? { disabled: e.disabled } : {}
  }));
  h.current = e;
  const g = T.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!de(f.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!de(f.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!de(f.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!de(f.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => de(f.errors, n)
    }
  }), [f, n]), p = T.useCallback((w) => m.current.onChange({
    target: {
      value: sR(w),
      name: n
    },
    type: Qr.CHANGE
  }), [n]), v = T.useCallback(() => m.current.onBlur({
    target: {
      value: de(i._formValues, n),
      name: n
    },
    type: Qr.BLUR
  }), [n, i._formValues]), y = T.useCallback((w) => {
    const _ = de(i._fields, n);
    _ && _._f && w && (_._f.ref = {
      focus: () => Gt(w.focus) && w.focus(),
      select: () => Gt(w.select) && w.select(),
      setCustomValidity: (b) => Gt(w.setCustomValidity) && w.setCustomValidity(b),
      reportValidity: () => Gt(w.reportValidity) && w.reportValidity()
    });
  }, [i._fields, n]), x = T.useMemo(() => ({
    name: n,
    value: d,
    ...mn(r) || f.disabled ? { disabled: f.disabled || r } : {},
    onChange: p,
    onBlur: v,
    ref: y
  }), [n, r, f.disabled, p, v, y, d]);
  return T.useEffect(() => {
    const w = i._options.shouldUnregister || a;
    i.register(n, {
      ...h.current.rules,
      ...mn(h.current.disabled) ? { disabled: h.current.disabled } : {}
    });
    const _ = (b, S) => {
      const O = de(i._fields, b);
      O && O._f && (O._f.mount = S);
    };
    if (_(n, !0), w) {
      const b = pt(de(i._defaultValues, n, de(i._options.defaultValues, n, h.current.defaultValue)));
      He(i._defaultValues, n, b), at(de(i._formValues, n)) && He(i._formValues, n, b);
    }
    return !c && i.register(n), () => {
      (c ? w && !i._state.action : w) ? i.unregister(n) : _(n, !1);
    };
  }, [n, i, c, a]), T.useEffect(() => {
    i._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, i]), T.useMemo(() => ({
    field: x,
    formState: f,
    fieldState: g
  }), [x, f, g]);
}
const Da = (e) => e.render(wae(e)), _ae = T.createContext(null);
_ae.displayName = "HookFormContext";
var mR = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, vR = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yl = (e) => Array.isArray(e) ? e : [e], UP = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const a of e)
        a.next && a.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((a) => a !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function pR(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const i = e[r], a = t[r];
      if (i && ht(i) && a) {
        const o = pR(i, a);
        ht(o) && (n[r] = o);
      } else e[r] && (n[r] = a);
    }
  return n;
}
var Ft = (e) => ht(e) && !Object.keys(e).length, qx = (e) => e.type === "file", Tu = (e) => {
  if (!Hd)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, gR = (e) => e.type === "select-multiple", Vx = (e) => e.type === "radio", Sae = (e) => Vx(e) || _c(e), Up = (e) => Tu(e) && e.isConnected;
function Oae(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; ) {
    if (zt(e)) {
      e = void 0;
      break;
    }
    e = e[t[r]], r++;
  }
  return e;
}
function Eae(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !at(e[t]))
      return !1;
  return !0;
}
function bt(e, t) {
  if (Zt(t) && Object.prototype.hasOwnProperty.call(e, t))
    return delete e[t], e;
  const n = Array.isArray(t) ? t : Sc(t) ? [t] : Yd(t), r = n.length === 1 ? e : Oae(e, n), i = n.length - 1, a = n[i];
  return r && delete r[a], i !== 0 && (ht(r) && Ft(r) || Array.isArray(r) && Eae(r)) && bt(e, n.slice(0, -1)), e;
}
var Aae = (e) => {
  for (const t in e)
    if (Gt(e[t]))
      return !0;
  return !1;
};
function yR(e) {
  return Array.isArray(e) || ht(e) && !Aae(e);
}
function $y(e, t = {}) {
  for (const n in e) {
    const r = e[n];
    yR(r) ? (t[n] = Array.isArray(r) ? [] : {}, $y(r, t[n])) : at(r) || (t[n] = !0);
  }
  return t;
}
function By(e) {
  if (e !== !1) {
    if (e === !0)
      return !0;
    if (Array.isArray(e)) {
      const t = e.map((n) => By(n));
      return t.some((n) => n !== void 0) ? t : void 0;
    }
    if (ht(e)) {
      const t = {};
      for (const n in e) {
        const r = By(e[n]);
        at(r) || (t[n] = r);
      }
      return Object.keys(t).length ? t : void 0;
    }
  }
}
function ji(e, t, n) {
  n || (n = $y(t));
  for (const r in e) {
    const i = e[r];
    if (yR(i))
      at(t) || Ly(n[r]) ? n[r] = $y(i, Array.isArray(i) ? [] : {}) : ji(i, zt(t) ? {} : t[r], n[r]);
    else {
      const a = t[r];
      n[r] = !vn(i, a);
    }
  }
  return By(n) || {};
}
const HP = {
  value: !1,
  isValid: !1
}, YP = { value: !0, isValid: !0 };
var bR = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? YP : { value: e[0].value, isValid: !0 } : YP
    ) : HP;
  }
  return HP;
}, xR = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => at(e) ? e : t ? e === "" ? NaN : e && +e : n && Zt(e) ? new Date(e) : r ? r(e) : e;
const KP = {
  isValid: !1,
  value: null
};
var wR = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, KP) : KP;
function GP(e) {
  const t = e.ref;
  return qx(t) ? t.files : Vx(t) ? wR(e.refs).value : gR(t) ? [...t.selectedOptions].map(({ value: n }) => n) : _c(t) ? bR(e.refs).value : xR(at(t.value) ? e.ref.value : t.value, e);
}
var Pae = (e, t, n, r) => {
  const i = {};
  for (const a of e) {
    const o = de(t, a);
    o && He(i, a, o._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Nu = (e) => e instanceof RegExp, Ho = (e) => at(e) ? e : Nu(e) ? e.source : ht(e) ? Nu(e.value) ? e.value.source : e.value : e, ZP = (e) => ({
  isOnSubmit: !e || e === Wn.onSubmit,
  isOnBlur: e === Wn.onBlur,
  isOnChange: e === Wn.onChange,
  isOnAll: e === Wn.all,
  isOnTouch: e === Wn.onTouched
});
const XP = "AsyncFunction";
var Cae = (e) => !!e && !!e.validate && !!(Gt(e.validate) && e.validate.constructor.name === XP || ht(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === XP)), jae = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), QP = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(`${r}.`)));
const cs = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const a = de(e, i);
    if (a) {
      const { _f: o, ...s } = a;
      if (o) {
        if (o.refs && o.refs[0] && t(o.refs[0], i) && !r)
          return !0;
        if (o.ref && t(o.ref, o.name) && !r)
          return !0;
        if (cs(s, t))
          break;
      } else if (ht(s) && cs(s, t))
        break;
    }
  }
};
function JP(e, t, n) {
  const r = de(e, n);
  if (r || Sc(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const a = i.join("."), o = de(t, a), s = de(e, a);
    if (o && !Array.isArray(o) && n !== a)
      return { name: n };
    if (s && s.type)
      return {
        name: a,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${a}.root`,
        error: s.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var Tae = (e, t, n, r) => {
  n(e);
  const { name: i, ...a } = e;
  return Ft(a) || r && Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((o) => t[o] === (!r || Wn.all));
}, Nae = (e, t, n) => !e || !t || e === t || yl(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), Mae = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, Iae = (e, t) => !vR(de(e, t)).length && bt(e, t), eC = (e, t, n) => {
  const r = de(e, n), i = Array.isArray(r) ? r : [];
  return He(i, lR, t[n]), He(e, n, i), e;
};
function tC(e, t, n = "validate") {
  if (Zt(e) || Array.isArray(e) && e.every(Zt) || mn(e) && !e)
    return {
      type: n,
      message: Zt(e) ? e : "",
      ref: t
    };
}
var ya = (e) => ht(e) && !Nu(e) ? e : {
  value: e,
  message: ""
}, nC = async (e, t, n, r, i, a) => {
  const { ref: o, refs: s, required: c, maxLength: l, minLength: d, min: f, max: h, pattern: m, validate: g, name: p, valueAsNumber: v, mount: y } = e._f, x = de(n, p);
  if (!y || t.has(p))
    return {};
  const w = s ? s[0] : o, _ = (C) => {
    i && w.reportValidity && (w.setCustomValidity(mn(C) ? "" : C || ""), w.reportValidity());
  }, b = {}, S = Vx(o), O = _c(o), E = S || O, P = (v || qx(o)) && at(o.value) && at(x) || Tu(o) && o.value === "" || x === "" || Array.isArray(x) && !x.length, R = mR.bind(null, p, r, b), j = (C, N, k, I = zn.maxLength, $ = zn.minLength) => {
    const z = C ? N : k;
    b[p] = {
      type: C ? I : $,
      message: z,
      ref: o,
      ...R(C ? I : $, z)
    };
  };
  if (a ? !Array.isArray(x) || !x.length : c && (!E && (P || zt(x)) || mn(x) && !x || O && !bR(s).isValid || S && !wR(s).isValid)) {
    const { value: C, message: N } = Zt(c) ? { value: !!c, message: c } : ya(c);
    if (C && (b[p] = {
      type: zn.required,
      message: N,
      ref: w,
      ...R(zn.required, N)
    }, !r))
      return _(N), b;
  }
  if (!P && (!zt(f) || !zt(h))) {
    let C, N;
    const k = ya(h), I = ya(f);
    if (!zt(x) && !isNaN(x)) {
      const $ = o.valueAsNumber || x && +x;
      zt(k.value) || (C = $ > k.value), zt(I.value) || (N = $ < I.value);
    } else {
      const $ = o.valueAsDate || new Date(x), z = (D) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + D), V = o.type == "time", K = o.type == "week";
      Zt(k.value) && x && (C = V ? z(x) > z(k.value) : K ? x > k.value : $ > new Date(k.value)), Zt(I.value) && x && (N = V ? z(x) < z(I.value) : K ? x < I.value : $ < new Date(I.value));
    }
    if ((C || N) && (j(!!C, k.message, I.message, zn.max, zn.min), !r))
      return _(b[p].message), b;
  }
  if ((l || d) && !P && (Zt(x) || a && Array.isArray(x))) {
    const C = ya(l), N = ya(d), k = !zt(C.value) && x.length > +C.value, I = !zt(N.value) && x.length < +N.value;
    if ((k || I) && (j(k, C.message, N.message), !r))
      return _(b[p].message), b;
  }
  if (m && !P && Zt(x)) {
    const { value: C, message: N } = ya(m);
    if (Nu(C) && !x.match(C) && (b[p] = {
      type: zn.pattern,
      message: N,
      ref: o,
      ...R(zn.pattern, N)
    }, !r))
      return _(N), b;
  }
  if (g) {
    if (Gt(g)) {
      const C = await g(x, n), N = tC(C, w);
      if (N && (b[p] = {
        ...N,
        ...R(zn.validate, N.message)
      }, !r))
        return _(N.message), b;
    } else if (ht(g)) {
      let C = {};
      for (const N in g) {
        if (!Ft(C) && !r)
          break;
        const k = tC(await g[N](x, n), w, N);
        k && (C = {
          ...k,
          ...R(N, k.message)
        }, _(k.message), r && (b[p] = C));
      }
      if (!Ft(C) && (b[p] = {
        ref: w,
        ...C
      }, !r))
        return b;
    }
  }
  return _(!0), b;
};
const Dae = {
  mode: Wn.onSubmit,
  reValidateMode: Wn.onChange,
  shouldFocusError: !0
}, _R = {
  submitCount: 0,
  isDirty: !1,
  isReady: !1,
  isValidating: !1,
  isSubmitted: !1,
  isSubmitting: !1,
  isSubmitSuccessful: !1,
  isValid: !1,
  touchedFields: {},
  dirtyFields: {},
  validatingFields: {}
};
function kae(e = {}) {
  let t = {
    ...Dae,
    ...e
  }, n = {
    ...pt(_R),
    isLoading: Gt(t.defaultValues),
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = ht(t.defaultValues) || ht(t.values) ? pt(t.defaultValues || t.values) || {} : {}, a = t.shouldUnregister ? {} : pt(i), o = {
    action: !1,
    mount: !1,
    watch: !1,
    keepIsValid: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set(),
    registerName: /* @__PURE__ */ new Set()
  }, c, l = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    ...d
  };
  let h = {
    ...f
  };
  const m = {
    array: UP(),
    state: UP()
  }, g = t.criteriaMode === Wn.all, p = (L) => (q) => {
    clearTimeout(l), l = setTimeout(L, q);
  }, v = async (L) => {
    if (!o.keepIsValid && !t.disabled && (f.isValid || h.isValid || L)) {
      let q;
      t.resolver ? (q = Ft((await R()).errors), y()) : q = await N({
        fields: r,
        onlyCheckValid: !0,
        eventType: Qr.VALID
      }), q !== n.isValid && m.state.next({
        isValid: q
      });
    }
  }, y = (L, q) => {
    !t.disabled && (f.isValidating || f.validatingFields || h.isValidating || h.validatingFields) && ((L || Array.from(s.mount)).forEach((H) => {
      H && (q ? He(n.validatingFields, H, q) : bt(n.validatingFields, H));
    }), m.state.next({
      validatingFields: n.validatingFields,
      isValidating: !Ft(n.validatingFields)
    }));
  }, x = () => {
    n.dirtyFields = ji(i, a);
  }, w = (L, q = [], H, ae, ue = !0, fe = !0) => {
    if (ae && H && !t.disabled) {
      if (o.action = !0, fe && Array.isArray(de(r, L))) {
        const le = H(de(r, L), ae.argA, ae.argB);
        ue && He(r, L, le);
      }
      if (fe && Array.isArray(de(n.errors, L))) {
        const le = H(de(n.errors, L), ae.argA, ae.argB);
        ue && He(n.errors, L, le), Iae(n.errors, L);
      }
      if ((f.touchedFields || h.touchedFields) && fe && Array.isArray(de(n.touchedFields, L))) {
        const le = H(de(n.touchedFields, L), ae.argA, ae.argB);
        ue && He(n.touchedFields, L, le);
      }
      (f.dirtyFields || h.dirtyFields) && x(), m.state.next({
        name: L,
        isDirty: I(L, q),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      He(a, L, q);
  }, _ = (L, q) => {
    He(n.errors, L, q), m.state.next({
      errors: n.errors
    });
  }, b = (L) => {
    n.errors = L, m.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, S = (L) => {
    const q = Sc(L) ? [L] : Yd(L);
    let H = a, ae = i;
    for (let ue = 0; ue < q.length - 1; ue++) {
      const fe = q[ue];
      if (H = zt(H) ? H : H[fe], ae = zt(ae) ? ae : ae[fe], H === null && ae !== null)
        return !0;
    }
    return !1;
  }, O = (L, q, H, ae) => {
    const ue = de(r, L);
    if (ue) {
      if (S(L))
        return;
      const fe = at(de(a, L)), le = de(a, L, at(H) ? de(i, L) : H);
      at(le) || ae && ae.defaultChecked || q ? He(a, L, q ? le : GP(ue._f)) : V(L, le), o.mount && !o.action && (v(), fe && n.isDirty && (f.isDirty || h.isDirty) && (I() || (n.isDirty = !1, m.state.next({ ...n }))));
    }
  }, E = (L, q, H, ae, ue) => {
    let fe = !1, le = !1;
    const be = {
      name: L
    };
    if (!t.disabled) {
      if (!H || ae) {
        (f.isDirty || h.isDirty) && (le = n.isDirty, n.isDirty = be.isDirty = I(), fe = le !== be.isDirty);
        const je = vn(de(i, L), q);
        le = !!de(n.dirtyFields, L), je !== n.isDirty ? n.dirtyFields = ji(i, a) : je ? bt(n.dirtyFields, L) : He(n.dirtyFields, L, !0), be.dirtyFields = n.dirtyFields, fe = fe || (f.dirtyFields || h.dirtyFields) && le !== !je;
      }
      if (H) {
        const je = de(n.touchedFields, L);
        je || (He(n.touchedFields, L, H), be.touchedFields = n.touchedFields, fe = fe || (f.touchedFields || h.touchedFields) && je !== H);
      }
      fe && ue && m.state.next(be);
    }
    return fe ? be : {};
  }, P = (L, q, H, ae) => {
    const ue = de(n.errors, L), fe = (f.isValid || h.isValid) && mn(q) && n.isValid !== q;
    if (t.delayError && H ? (c = p(() => _(L, H)), c(t.delayError)) : (clearTimeout(l), c = null, H ? He(n.errors, L, H) : bt(n.errors, L)), (H ? !vn(ue, H) : ue) || !Ft(ae) || fe) {
      const le = {
        ...ae,
        ...fe && mn(q) ? { isValid: q } : {},
        errors: n.errors,
        name: L
      };
      n = {
        ...n,
        ...le
      }, m.state.next(le);
    }
  }, R = async (L) => (y(L, !0), await t.resolver(a, t.context, Pae(L || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), j = async (L) => {
    const { errors: q } = await R(L);
    if (y(L), L)
      for (const H of L) {
        const ae = de(q, H);
        ae ? s.array.has(H) && ht(ae) && !Object.keys(ae).some((ue) => !Number.isNaN(Number(ue))) ? eC(n.errors, { [H]: ae }, H) : He(n.errors, H, ae) : bt(n.errors, H);
      }
    else
      n.errors = q;
    return q;
  }, C = async ({ name: L, eventType: q }) => {
    if (e.validate) {
      const H = await e.validate({
        formValues: a,
        formState: n,
        name: L,
        eventType: q
      });
      if (ht(H))
        for (const ae in H) {
          const ue = H[ae];
          ue && G(`${Wp}.${ae}`, {
            message: Zt(ue.message) ? ue.message : "",
            type: ue.type || zn.validate
          });
        }
      else Zt(H) || !H ? G(Wp, {
        message: H || "",
        type: zn.validate
      }) : se(Wp);
      return H;
    }
    return !0;
  }, N = async ({ fields: L, onlyCheckValid: q, name: H, eventType: ae, context: ue = {
    valid: !0,
    runRootValidation: !1
  } }) => {
    if (e.validate && (ue.runRootValidation = !0, !await C({
      name: H,
      eventType: ae
    }) && (ue.valid = !1, q)))
      return ue.valid;
    for (const fe in L) {
      const le = L[fe];
      if (le) {
        const { _f: be, ...je } = le;
        if (be) {
          const tt = s.array.has(be.name), Rt = le._f && Cae(le._f), we = f.validatingFields || f.isValidating || h.validatingFields || h.isValidating;
          Rt && we && y([be.name], !0);
          const Me = await nC(le, s.disabled, a, g, t.shouldUseNativeValidation && !q, tt);
          if (Rt && we && y([be.name]), Me[be.name] && (ue.valid = !1, q) || (!q && (de(Me, be.name) ? tt ? eC(n.errors, Me, be.name) : He(n.errors, be.name, Me[be.name]) : bt(n.errors, be.name)), e.shouldUseNativeValidation && Me[be.name]))
            break;
        }
        !Ft(je) && await N({
          context: ue,
          onlyCheckValid: q,
          fields: je,
          name: fe,
          eventType: ae
        });
      }
    }
    return ue.valid;
  }, k = () => {
    for (const L of s.unMount) {
      const q = de(r, L);
      q && (q._f.refs ? q._f.refs.every((H) => !Up(H)) : !Up(q._f.ref)) && ye(L);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, I = (L, q) => !t.disabled && (L && q && He(a, L, q), !vn(he(), i)), $ = (L, q, H) => Ry(L, s, {
    ...o.mount ? a : at(q) ? i : Zt(L) ? { [L]: q } : q
  }, H, q), z = (L) => vR(de(o.mount ? a : i, L, t.shouldUnregister ? de(i, L, []) : [])), V = (L, q, H = {}, ae = !1) => {
    const ue = de(r, L);
    let fe = q;
    if (ue) {
      const le = ue._f;
      le && (!le.disabled && He(a, L, xR(q, le)), fe = Tu(le.ref) && zt(q) ? "" : q, gR(le.ref) ? [...le.ref.options].forEach((be) => be.selected = fe.includes(be.value)) : le.refs ? _c(le.ref) ? le.refs.forEach((be) => {
        (!be.defaultChecked || !be.disabled) && (Array.isArray(fe) ? be.checked = !!fe.find((je) => je === be.value) : be.checked = fe === be.value || !!fe);
      }) : le.refs.forEach((be) => be.checked = be.value === fe) : qx(le.ref) ? le.ref.value = "" : (le.ref.value = fe, le.ref.type || m.state.next({
        name: L,
        values: ae ? a : pt(a)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && E(L, fe, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && ie(L);
  }, K = (L, q, H, ae = !1) => {
    for (const ue in q) {
      if (!q.hasOwnProperty(ue))
        return;
      const fe = q[ue], le = L + "." + ue, be = de(r, le);
      (s.array.has(L) || ht(fe) || be && !be._f) && !ki(fe) ? K(le, fe, H, ae) : V(le, fe, H, ae);
    }
  }, D = (L, q, H, ae) => {
    const ue = de(r, L), fe = s.array.has(L), le = ae ? q : pt(q), be = de(a, L), je = vn(be, le);
    if (je || He(a, L, le), fe)
      m.array.next({
        name: L,
        values: ae ? a : pt(a)
      }), (f.isDirty || f.dirtyFields || h.isDirty || h.dirtyFields) && H.shouldDirty && (x(), m.state.next({
        name: L,
        dirtyFields: n.dirtyFields,
        isDirty: I(L, le)
      }));
    else {
      const tt = Array.isArray(le) && !le.length || Ft(le);
      !ue || ue._f || zt(le) || tt ? V(L, le, H, ae) : K(L, le, H, ae);
    }
    if (!je) {
      const tt = QP(L, s), Rt = ae ? a : pt(a);
      m.state.next({
        ...tt && n,
        name: o.mount || tt ? L : void 0,
        values: Rt
      });
    }
  }, U = (L, q, H = {}) => D(L, q, H, !1), Y = (L, q = {}) => {
    const H = Gt(L) ? L(a) : L;
    if (!vn(a, H)) {
      a = {
        ...a,
        ...H
      };
      for (const ae of s.mount)
        D(ae, de(H, ae), q, !0);
      m.state.next({
        ...n,
        name: void 0,
        type: void 0,
        values: a
      }), q.shouldValidate && v();
    }
  }, X = async (L) => {
    o.mount = !0;
    const q = L.target;
    let H = q.name, ae = !0;
    const ue = de(r, H), fe = (je) => {
      ae = Number.isNaN(je) || ki(je) && isNaN(je.getTime()) || vn(je, de(a, H, je));
    }, le = ZP(t.mode), be = ZP(t.reValidateMode);
    if (ue) {
      let je, tt;
      const Rt = q.type ? GP(ue._f) : sR(L), we = L.type === Qr.BLUR || L.type === Qr.FOCUS_OUT, Me = !jae(ue._f) && !e.validate && !t.resolver && !de(n.errors, H) && !ue._f.deps || Mae(we, de(n.touchedFields, H), n.isSubmitted, be, le), Se = QP(H, s, we);
      He(a, H, Rt), we ? (!q || !q.readOnly) && (ue._f.onBlur && ue._f.onBlur(L), c && c(0)) : ue._f.onChange && ue._f.onChange(L);
      const $e = E(H, Rt, we), Lt = !Ft($e) || Se;
      if (!we && m.state.next({
        name: H,
        type: L.type,
        values: pt(a)
      }), Me)
        return (f.isValid || h.isValid) && (t.mode === "onBlur" ? we && v() : we || v()), Lt && m.state.next({ name: H, ...Se ? {} : $e });
      if (!t.resolver && e.validate && await C({
        name: H,
        eventType: L.type
      }), !we && Se && m.state.next({ ...n }), t.resolver) {
        const { errors: De } = await R([H]);
        if (y([H]), fe(Rt), ae) {
          const br = JP(n.errors, r, H), Ur = JP(De, r, br.name || H);
          je = Ur.error, H = Ur.name, tt = Ft(De);
        }
      } else
        y([H], !0), je = (await nC(ue, s.disabled, a, g, t.shouldUseNativeValidation))[H], y([H]), fe(Rt), ae && (je ? tt = !1 : (f.isValid || h.isValid) && (tt = await N({
          fields: r,
          onlyCheckValid: !0,
          name: H,
          eventType: L.type
        })));
      ae && (ue._f.deps && (!Array.isArray(ue._f.deps) || ue._f.deps.length > 0) && ie(ue._f.deps), P(H, tt, je, $e));
    }
  }, oe = (L, q) => {
    if (de(n.errors, q) && L.focus)
      return L.focus(), 1;
  }, ie = async (L, q = {}) => {
    let H, ae;
    const ue = yl(L);
    if (t.resolver) {
      const fe = await j(at(L) ? L : ue);
      H = Ft(fe), ae = L ? !ue.some((le) => de(fe, le)) : H;
    } else L ? (ae = (await Promise.all(ue.map(async (fe) => {
      const le = de(r, fe);
      return await N({
        fields: le && le._f ? { [fe]: le } : le,
        eventType: Qr.TRIGGER
      });
    }))).every(Boolean), !(!ae && !n.isValid) && v()) : ae = H = await N({
      fields: r,
      name: L,
      eventType: Qr.TRIGGER
    });
    return m.state.next({
      ...!Zt(L) || (f.isValid || h.isValid) && H !== n.isValid ? {} : { name: L },
      ...t.resolver || !L ? { isValid: H } : {},
      errors: n.errors
    }), q.shouldFocus && !ae && cs(r, oe, L ? ue : s.mount), ae;
  }, he = (L, q) => {
    let H = {
      ...o.mount ? a : i
    };
    return q && (H = pR(q.dirtyFields ? n.dirtyFields : n.touchedFields, H)), at(L) ? H : Zt(L) ? de(H, L) : L.map((ae) => de(H, ae));
  }, ee = (L, q) => ({
    invalid: !!de((q || n).errors, L),
    isDirty: !!de((q || n).dirtyFields, L),
    error: de((q || n).errors, L),
    isValidating: !!de(n.validatingFields, L),
    isTouched: !!de((q || n).touchedFields, L)
  }), se = (L) => {
    const q = L ? yl(L) : void 0;
    q?.forEach((H) => bt(n.errors, H)), q ? q.forEach((H) => {
      m.state.next({
        name: H,
        errors: n.errors
      });
    }) : m.state.next({
      errors: {}
    });
  }, G = (L, q, H) => {
    const ae = (de(r, L, { _f: {} })._f || {}).ref, ue = de(n.errors, L) || {}, { ref: fe, message: le, type: be, ...je } = ue;
    He(n.errors, L, {
      ...je,
      ...q,
      ref: ae
    }), m.state.next({
      name: L,
      errors: n.errors,
      isValid: !1
    }), H && H.shouldFocus && ae && ae.focus && ae.focus();
  }, Q = (L, q) => Gt(L) ? m.state.subscribe({
    next: (H) => "values" in H && L(H.values || $(void 0, q), H)
  }) : $(L, q, !0), ce = (L) => m.state.subscribe({
    next: (q) => {
      if (Nae(L.name, q.name, L.exact) && Tae(q, L.formState || f, Ln, L.reRenderRoot)) {
        const H = { ...a };
        L.callback({
          values: H,
          ...n,
          ...q,
          defaultValues: i
        });
      }
    }
  }).unsubscribe, F = (L) => (o.mount = !0, h = {
    ...h,
    ...L.formState
  }, ce({
    ...L,
    formState: {
      ...d,
      ...L.formState
    }
  })), ye = (L, q = {}) => {
    for (const H of L ? yl(L) : s.mount)
      s.mount.delete(H), s.array.delete(H), q.keepValue || (bt(r, H), bt(a, H)), !q.keepError && bt(n.errors, H), !q.keepDirty && bt(n.dirtyFields, H), !q.keepTouched && bt(n.touchedFields, H), !q.keepIsValidating && bt(n.validatingFields, H), !t.shouldUnregister && !q.keepDefaultValue && bt(i, H);
    m.state.next({
      values: pt(a)
    }), m.state.next({
      ...n,
      ...q.keepDirty ? { isDirty: I() } : {}
    }), !q.keepIsValid && v();
  }, te = ({ disabled: L, name: q }) => {
    if (mn(L) && o.mount || L || s.disabled.has(q)) {
      const ue = s.disabled.has(q) !== !!L;
      L ? s.disabled.add(q) : s.disabled.delete(q), ue && o.mount && !o.action && v();
    }
  }, Ne = (L, q = {}) => {
    let H = de(r, L);
    const ae = mn(q.disabled) || mn(t.disabled), ue = !s.registerName.has(L) && H && H._f && !H._f.mount;
    return He(r, L, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: L } },
        name: L,
        mount: !0,
        ...q
      }
    }), s.mount.add(L), H && !ue ? te({
      disabled: mn(q.disabled) ? q.disabled : t.disabled,
      name: L
    }) : O(L, !0, q.value), {
      ...ae ? { disabled: q.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!q.required,
        min: Ho(q.min),
        max: Ho(q.max),
        minLength: Ho(q.minLength),
        maxLength: Ho(q.maxLength),
        pattern: Ho(q.pattern)
      } : {},
      name: L,
      onChange: X,
      onBlur: X,
      ref: (fe) => {
        if (fe) {
          s.registerName.add(L), Ne(L, q), s.registerName.delete(L), H = de(r, L);
          const le = at(fe.value) && fe.querySelectorAll && fe.querySelectorAll("input,select,textarea")[0] || fe, be = Sae(le), je = H._f.refs || [];
          if (be ? je.find((tt) => tt === le) : le === H._f.ref)
            return;
          He(r, L, {
            _f: {
              ...H._f,
              ...be ? {
                refs: [
                  ...je.filter(Up),
                  le,
                  ...Array.isArray(de(i, L)) ? [{}] : []
                ],
                ref: { type: le.type, name: L }
              } : { ref: le }
            }
          }), O(L, !1, void 0, le);
        } else
          H = de(r, L, {}), H._f && (H._f.mount = !1), (t.shouldUnregister || q.shouldUnregister) && !(cR(s.array, L) && o.action) && s.unMount.add(L);
      }
    };
  }, Te = () => t.shouldFocusError && !t.shouldUseNativeValidation && cs(r, oe, s.mount), Ge = (L) => {
    mn(L) && (m.state.next({ disabled: L }), cs(r, (q, H) => {
      const ae = de(r, H);
      ae && (q.disabled = ae._f.disabled || L, Array.isArray(ae._f.refs) && ae._f.refs.forEach((ue) => {
        ue.disabled = ae._f.disabled || L;
      }));
    }, 0, !1));
  }, At = (L, q) => async (H) => {
    let ae;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let ue = pt(a);
    if (m.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: fe, values: le } = await R();
      y(), n.errors = fe, ue = pt(le);
    } else
      await N({
        fields: r,
        eventType: Qr.SUBMIT
      });
    if (s.disabled.size)
      for (const fe of s.disabled)
        bt(ue, fe);
    if (bt(n.errors, lR), Ft(n.errors)) {
      m.state.next({
        errors: {}
      });
      try {
        await L(ue, H);
      } catch (fe) {
        ae = fe;
      }
    } else
      q && await q({ ...n.errors }, H), Te(), setTimeout(Te);
    if (m.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ft(n.errors) && !ae,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), ae)
      throw ae;
  }, en = (L, q = {}) => {
    de(r, L) && (at(q.defaultValue) ? U(L, pt(de(i, L))) : (U(L, q.defaultValue), He(i, L, pt(q.defaultValue))), q.keepTouched || bt(n.touchedFields, L), q.keepDirty || (bt(n.dirtyFields, L), n.isDirty = q.defaultValue ? I(L, pt(de(i, L))) : I()), q.keepError || (bt(n.errors, L), f.isValid && v()), m.state.next({ ...n }));
  }, Rn = (L, q = {}) => {
    const H = L ? pt(L) : i, ae = pt(H), ue = Ft(L), fe = ae;
    if (q.keepDefaultValues || (i = H), !q.keepValues) {
      if (q.keepDirtyValues) {
        const le = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(ji(i, a))
        ]);
        for (const be of Array.from(le)) {
          const je = de(n.dirtyFields, be), tt = de(a, be), Rt = de(fe, be);
          je && !at(tt) ? He(fe, be, tt) : !je && !at(Rt) && U(be, Rt);
        }
      } else {
        if (Hd && at(L))
          for (const le of s.mount) {
            const be = de(r, le);
            if (be && be._f) {
              const je = Array.isArray(be._f.refs) ? be._f.refs[0] : be._f.ref;
              if (Tu(je)) {
                const tt = je.closest("form");
                if (tt) {
                  tt.reset();
                  break;
                }
              }
            }
          }
        if (q.keepFieldsRef)
          for (const le of s.mount)
            U(le, de(fe, le));
        else
          r = {};
      }
      if (t.shouldUnregister) {
        if (a = q.keepDefaultValues ? pt(i) : {}, q.keepFieldsRef)
          for (const le of s.mount)
            He(a, le, de(fe, le));
      } else
        a = pt(fe);
      m.array.next({
        values: { ...fe }
      }), m.state.next({
        values: { ...fe }
      });
    }
    s = {
      mount: q.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      registerName: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !f.isValid || !!q.keepIsValid || !!q.keepDirtyValues || !t.shouldUnregister && !Ft(fe), o.watch = !!t.shouldUnregister, o.keepIsValid = !!q.keepIsValid, o.action = !1, q.keepErrors || (n.errors = {}), m.state.next({
      submitCount: q.keepSubmitCount ? n.submitCount : 0,
      isDirty: ue ? !1 : q.keepDirty ? n.isDirty : q.keepValues ? I() : !!(q.keepDefaultValues && !vn(L, i)),
      isSubmitted: q.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: ue ? {} : q.keepDirtyValues ? q.keepDefaultValues && a ? ji(i, a) : n.dirtyFields : q.keepDefaultValues && L ? ji(i, L) : q.keepDirty ? n.dirtyFields : {},
      touchedFields: q.keepTouched ? n.touchedFields : {},
      errors: q.keepErrors ? n.errors : {},
      isSubmitSuccessful: q.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, tn = (L, q) => Rn(Gt(L) ? L(a) : L, { ...t.resetOptions, ...q }), Wt = (L, q = {}) => {
    const H = de(r, L), ae = H && H._f;
    if (ae) {
      const ue = ae.refs ? ae.refs[0] : ae.ref;
      ue.focus && setTimeout(() => {
        ue.focus(), q.shouldSelect && Gt(ue.select) && ue.select();
      });
    }
  }, Ln = (L) => {
    n = {
      ...n,
      ...L
    };
  }, yr = {
    control: {
      register: Ne,
      unregister: ye,
      getFieldState: ee,
      handleSubmit: At,
      setError: G,
      _subscribe: ce,
      _runSchema: R,
      _updateIsValidating: y,
      _focusError: Te,
      _getWatch: $,
      _getDirty: I,
      _setValid: v,
      _setFieldArray: w,
      _setDisabledField: te,
      _setErrors: b,
      _getFieldArray: z,
      _reset: Rn,
      _resetDefaultValues: () => Gt(t.defaultValues) && t.defaultValues().then((L) => {
        tn(L, t.resetOptions), m.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: k,
      _disableForm: Ge,
      _subjects: m,
      _proxyFormState: f,
      get _fields() {
        return r;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return o;
      },
      set _state(L) {
        o = L;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(L) {
        s = L;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(L) {
        t = {
          ...t,
          ...L
        };
      }
    },
    subscribe: F,
    trigger: ie,
    register: Ne,
    handleSubmit: At,
    watch: Q,
    setValue: U,
    setValues: Y,
    getValues: he,
    reset: tn,
    resetField: en,
    resetDefaultValues: (L, q = {}) => {
      if (i = pt(L), !q.keepDirty) {
        const H = ji(i, a);
        n.dirtyFields = H, n.isDirty = !Ft(H);
      }
      q.keepIsValid || v(), m.state.next({
        ...n,
        defaultValues: i
      });
    },
    clearErrors: se,
    unregister: ye,
    setError: G,
    setFocus: Wt,
    getFieldState: ee
  };
  return {
    ...yr,
    formControl: yr
  };
}
function Oc(e = {}) {
  const t = T.useRef(void 0), n = T.useRef(void 0), [r, i] = T.useState(() => ({
    ...pt(_R),
    isLoading: Gt(e.defaultValues),
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Gt(e.defaultValues) ? void 0 : e.defaultValues
  }));
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: r
      }, e.defaultValues && !Gt(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: o, ...s } = kae(e);
      t.current = {
        ...s,
        formState: r
      };
    }
  const a = t.current.control;
  return a._options = e, zx(() => {
    const o = a._subscribe({
      formState: a._proxyFormState,
      callback: () => i({
        ...a._formState,
        defaultValues: a._defaultValues
      }),
      reRenderRoot: !0
    });
    return i((s) => ({
      ...s,
      isReady: !0
    })), a._formState.isReady = !0, o;
  }, [a]), T.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), T.useEffect(() => {
    e.mode && (a._options.mode = e.mode), e.reValidateMode && (a._options.reValidateMode = e.reValidateMode);
  }, [a, e.mode, e.reValidateMode]), T.useEffect(() => {
    e.errors && (a._setErrors(e.errors), a._focusError());
  }, [a, e.errors]), T.useEffect(() => {
    e.shouldUnregister && a._subjects.state.next({
      values: a._getWatch()
    });
  }, [a, e.shouldUnregister]), T.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const o = a._getDirty();
      o !== r.isDirty && a._subjects.state.next({
        isDirty: o
      });
    }
  }, [a, r.isDirty]), T.useEffect(() => {
    var o;
    e.values && !vn(e.values, n.current) ? (a._reset(e.values, {
      keepFieldsRef: !0,
      ...a._options.resetOptions
    }), !((o = a._options.resetOptions) === null || o === void 0) && o.keepIsValid || a._setValid(), n.current = e.values, i((s) => ({ ...s }))) : a._resetDefaultValues();
  }, [a, e.values]), T.useEffect(() => {
    a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), t.current.formState = T.useMemo(() => fR(r, a), [a, r]), t.current;
}
const rC = (e, t, n) => {
  if (e && "reportValidity" in e) {
    const r = de(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, SR = (e, t) => {
  for (const n in t.fields) {
    const r = t.fields[n];
    r && r.ref && "reportValidity" in r.ref ? rC(r.ref, n, e) : r.refs && r.refs.forEach((i) => rC(i, n, e));
  }
}, Rae = (e, t) => {
  t.shouldUseNativeValidation && SR(e, t);
  const n = {};
  for (const r in e) {
    const i = de(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.ref });
    if (Lae(t.names || Object.keys(e), r)) {
      const o = Object.assign({}, de(n, r));
      He(o, "root", a), He(n, r, o);
    } else He(n, r, a);
  }
  return n;
}, Lae = (e, t) => e.some((n) => n.startsWith(t + "."));
var $ae = function(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
    if (!n[o]) if ("unionErrors" in r) {
      var s = r.unionErrors[0].errors[0];
      n[o] = { message: s.message, type: s.code };
    } else n[o] = { message: a, type: i };
    if ("unionErrors" in r && r.unionErrors.forEach(function(d) {
      return d.errors.forEach(function(f) {
        return e.push(f);
      });
    }), t) {
      var c = n[o].types, l = c && c[r.code];
      n[o] = mR(o, t, n, i, l ? [].concat(l, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}, Wx = function(e, t, n) {
  return n === void 0 && (n = {}), function(r, i, a) {
    try {
      return Promise.resolve((function(o, s) {
        try {
          var c = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(l) {
            return a.shouldUseNativeValidation && SR({}, a), { errors: {}, values: n.raw ? r : l };
          });
        } catch (l) {
          return s(l);
        }
        return c && c.then ? c.then(void 0, s) : c;
      })(0, function(o) {
        if ((function(s) {
          return Array.isArray(s?.errors);
        })(o)) return { values: {}, errors: Rae($ae(o.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a) };
        throw o;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
};
function re(e, t, n) {
  function r(s, c) {
    var l;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (l = s._zod).traits ?? (l.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, c);
    for (const d in o.prototype)
      d in s || Object.defineProperty(s, d, { value: o.prototype[d].bind(s) });
    s._zod.constr = o, s._zod.def = c;
  }
  const i = n?.Parent ?? Object;
  class a extends i {
  }
  Object.defineProperty(a, "name", { value: e });
  function o(s) {
    var c;
    const l = n?.Parent ? new a() : this;
    r(l, s), (c = l._zod).deferred ?? (c.deferred = []);
    for (const d of l._zod.deferred)
      d();
    return l;
  }
  return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, {
    value: (s) => n?.Parent && s instanceof n.Parent ? !0 : s?._zod?.traits?.has(e)
  }), Object.defineProperty(o, "name", { value: e }), o;
}
class ka extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class OR extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const ER = {};
function Ji(e) {
  return ER;
}
function Bae(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, i]) => t.indexOf(+r) === -1).map(([r, i]) => i);
}
function Fy(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ux(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Hx(e) {
  return e == null;
}
function Yx(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const iC = Symbol("evaluating");
function rt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== iC)
        return r === void 0 && (r = iC, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function ca(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function la(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function aC(e) {
  return JSON.stringify(e);
}
const AR = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Mu(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Fae = Ux(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Js(e) {
  if (Mu(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(Mu(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function PR(e) {
  return Js(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const zae = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Kd(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function pi(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (r._zod.parent = e), r;
}
function Pe(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function qae(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function Vae(e, t) {
  const n = e._zod.def, r = la(e._zod.def, {
    get shape() {
      const i = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (i[a] = n.shape[a]);
      }
      return ca(this, "shape", i), i;
    },
    checks: []
  });
  return pi(e, r);
}
function Wae(e, t) {
  const n = e._zod.def, r = la(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete i[a];
      }
      return ca(this, "shape", i), i;
    },
    checks: []
  });
  return pi(e, r);
}
function Uae(e, t) {
  if (!Js(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const i = la(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape, ...t };
      return ca(this, "shape", a), a;
    },
    checks: []
  });
  return pi(e, i);
}
function Hae(e, t) {
  if (!Js(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return ca(this, "shape", r), r;
    },
    checks: e._zod.def.checks
  };
  return pi(e, n);
}
function Yae(e, t) {
  const n = la(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return ca(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return pi(e, n);
}
function Kae(e, t, n) {
  const r = la(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, a = { ...i };
      if (n)
        for (const o in n) {
          if (!(o in i))
            throw new Error(`Unrecognized key: "${o}"`);
          n[o] && (a[o] = e ? new e({
            type: "optional",
            innerType: i[o]
          }) : i[o]);
        }
      else
        for (const o in i)
          a[o] = e ? new e({
            type: "optional",
            innerType: i[o]
          }) : i[o];
      return ca(this, "shape", a), a;
    },
    checks: []
  });
  return pi(t, r);
}
function Gae(e, t, n) {
  const r = la(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, a = { ...i };
      if (n)
        for (const o in n) {
          if (!(o in a))
            throw new Error(`Unrecognized key: "${o}"`);
          n[o] && (a[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          }));
        }
      else
        for (const o in i)
          a[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          });
      return ca(this, "shape", a), a;
    },
    checks: []
  });
  return pi(t, r);
}
function Oa(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function CR(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function cl(e) {
  return typeof e == "string" ? e : e?.message;
}
function ea(e, t, n) {
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const i = cl(e.inst?._zod.def?.error?.(e)) ?? cl(t?.error?.(e)) ?? cl(n.customError?.(e)) ?? cl(n.localeError?.(e)) ?? "Invalid input";
    r.message = i;
  }
  return delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function Kx(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function ec(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const jR = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Fy, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, TR = re("$ZodError", jR), NR = re("$ZodError", jR, { Parent: Error });
function Zae(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function Xae(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const a of i.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((o) => r({ issues: o }));
      else if (a.code === "invalid_key")
        r({ issues: a.issues });
      else if (a.code === "invalid_element")
        r({ issues: a.issues });
      else if (a.path.length === 0)
        n._errors.push(t(a));
      else {
        let o = n, s = 0;
        for (; s < a.path.length; ) {
          const c = a.path[s];
          s === a.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(t(a))) : o[c] = o[c] || { _errors: [] }, o = o[c], s++;
        }
      }
  };
  return r(e), n;
}
const Gx = (e) => (t, n, r, i) => {
  const a = r ? Object.assign(r, { async: !1 }) : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, a);
  if (o instanceof Promise)
    throw new ka();
  if (o.issues.length) {
    const s = new (i?.Err ?? e)(o.issues.map((c) => ea(c, a, Ji())));
    throw AR(s, i?.callee), s;
  }
  return o.value;
}, Zx = (e) => async (t, n, r, i) => {
  const a = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, a);
  if (o instanceof Promise && (o = await o), o.issues.length) {
    const s = new (i?.Err ?? e)(o.issues.map((c) => ea(c, a, Ji())));
    throw AR(s, i?.callee), s;
  }
  return o.value;
}, Gd = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, i);
  if (a instanceof Promise)
    throw new ka();
  return a.issues.length ? {
    success: !1,
    error: new (e ?? TR)(a.issues.map((o) => ea(o, i, Ji())))
  } : { success: !0, data: a.value };
}, Qae = /* @__PURE__ */ Gd(NR), Zd = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, i);
  return a instanceof Promise && (a = await a), a.issues.length ? {
    success: !1,
    error: new e(a.issues.map((o) => ea(o, i, Ji())))
  } : { success: !0, data: a.value };
}, Jae = /* @__PURE__ */ Zd(NR), eoe = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Gx(e)(t, n, i);
}, toe = (e) => (t, n, r) => Gx(e)(t, n, r), noe = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Zx(e)(t, n, i);
}, roe = (e) => async (t, n, r) => Zx(e)(t, n, r), ioe = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Gd(e)(t, n, i);
}, aoe = (e) => (t, n, r) => Gd(e)(t, n, r), ooe = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Zd(e)(t, n, i);
}, soe = (e) => async (t, n, r) => Zd(e)(t, n, r), coe = /^[cC][^\s-]{8,}$/, loe = /^[0-9a-z]+$/, uoe = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, doe = /^[0-9a-vA-V]{20}$/, foe = /^[A-Za-z0-9]{27}$/, hoe = /^[a-zA-Z0-9_-]{21}$/, moe = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, voe = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, oC = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, poe = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, goe = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function yoe() {
  return new RegExp(goe, "u");
}
const boe = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, xoe = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, woe = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, _oe = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Soe = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, MR = /^[A-Za-z0-9_-]*$/, Ooe = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Eoe = /^\+(?:[0-9]){6,14}[0-9]$/, IR = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Aoe = /* @__PURE__ */ new RegExp(`^${IR}$`);
function DR(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Poe(e) {
  return new RegExp(`^${DR(e)}$`);
}
function Coe(e) {
  const t = DR({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${IR}T(?:${r})$`);
}
const joe = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Toe = /^[^A-Z]*$/, Noe = /^[^a-z]*$/, gr = /* @__PURE__ */ re("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Moe = /* @__PURE__ */ re("$ZodCheckMaxLength", (e, t) => {
  var n;
  gr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hx(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Kx(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Ioe = /* @__PURE__ */ re("$ZodCheckMinLength", (e, t) => {
  var n;
  gr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hx(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Kx(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Doe = /* @__PURE__ */ re("$ZodCheckLengthEquals", (e, t) => {
  var n;
  gr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Hx(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, a = i.length;
    if (a === t.length)
      return;
    const o = Kx(i), s = a > t.length;
    r.issues.push({
      origin: o,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Xd = /* @__PURE__ */ re("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  gr.init(e, t), e._zod.onattach.push((i) => {
    const a = i._zod.bag;
    a.format = t.format, t.pattern && (a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), koe = /* @__PURE__ */ re("$ZodCheckRegex", (e, t) => {
  Xd.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Roe = /* @__PURE__ */ re("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Toe), Xd.init(e, t);
}), Loe = /* @__PURE__ */ re("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Noe), Xd.init(e, t);
}), $oe = /* @__PURE__ */ re("$ZodCheckIncludes", (e, t) => {
  gr.init(e, t);
  const n = Kd(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const a = i._zod.bag;
    a.patterns ?? (a.patterns = /* @__PURE__ */ new Set()), a.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Boe = /* @__PURE__ */ re("$ZodCheckStartsWith", (e, t) => {
  gr.init(e, t);
  const n = new RegExp(`^${Kd(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Foe = /* @__PURE__ */ re("$ZodCheckEndsWith", (e, t) => {
  gr.init(e, t);
  const n = new RegExp(`.*${Kd(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zoe = /* @__PURE__ */ re("$ZodCheckOverwrite", (e, t) => {
  gr.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class qoe {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((o) => o), i = Math.min(...r.map((o) => o.length - o.trimStart().length)), a = r.map((o) => o.slice(i)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of a)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this?.args, i = [...(this?.content ?? [""]).map((a) => `  ${a}`)];
    return new t(...n, i.join(`
`));
  }
}
const Voe = {
  major: 4,
  minor: 1,
  patch: 12
}, Tt = /* @__PURE__ */ re("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Voe;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const i of r)
    for (const a of i._zod.onattach)
      a(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (o, s, c) => {
      let l = Oa(o), d;
      for (const f of s) {
        if (f._zod.def.when) {
          if (!f._zod.def.when(o))
            continue;
        } else if (l)
          continue;
        const h = o.issues.length, m = f._zod.check(o);
        if (m instanceof Promise && c?.async === !1)
          throw new ka();
        if (d || m instanceof Promise)
          d = (d ?? Promise.resolve()).then(async () => {
            await m, o.issues.length !== h && (l || (l = Oa(o, h)));
          });
        else {
          if (o.issues.length === h)
            continue;
          l || (l = Oa(o, h));
        }
      }
      return d ? d.then(() => o) : o;
    }, a = (o, s, c) => {
      if (Oa(o))
        return o.aborted = !0, o;
      const l = i(s, r, c);
      if (l instanceof Promise) {
        if (c.async === !1)
          throw new ka();
        return l.then((d) => e._zod.parse(d, c));
      }
      return e._zod.parse(l, c);
    };
    e._zod.run = (o, s) => {
      if (s.skipChecks)
        return e._zod.parse(o, s);
      if (s.direction === "backward") {
        const l = e._zod.parse({ value: o.value, issues: [] }, { ...s, skipChecks: !0 });
        return l instanceof Promise ? l.then((d) => a(d, o, s)) : a(l, o, s);
      }
      const c = e._zod.parse(o, s);
      if (c instanceof Promise) {
        if (s.async === !1)
          throw new ka();
        return c.then((l) => i(l, r, s));
      }
      return i(c, r, s);
    };
  }
  e["~standard"] = {
    validate: (i) => {
      try {
        const a = Qae(e, i);
        return a.success ? { value: a.data } : { issues: a.error?.issues };
      } catch {
        return Jae(e, i).then((o) => o.success ? { value: o.data } : { issues: o.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Xx = /* @__PURE__ */ re("$ZodString", (e, t) => {
  Tt.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? joe(e._zod.bag), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), ut = /* @__PURE__ */ re("$ZodStringFormat", (e, t) => {
  Xd.init(e, t), Xx.init(e, t);
}), Woe = /* @__PURE__ */ re("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = voe), ut.init(e, t);
}), Uoe = /* @__PURE__ */ re("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = oC(r));
  } else
    t.pattern ?? (t.pattern = oC());
  ut.init(e, t);
}), Hoe = /* @__PURE__ */ re("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = poe), ut.init(e, t);
}), Yoe = /* @__PURE__ */ re("$ZodURL", (e, t) => {
  ut.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Ooe.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Koe = /* @__PURE__ */ re("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = yoe()), ut.init(e, t);
}), Goe = /* @__PURE__ */ re("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = hoe), ut.init(e, t);
}), Zoe = /* @__PURE__ */ re("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = coe), ut.init(e, t);
}), Xoe = /* @__PURE__ */ re("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = loe), ut.init(e, t);
}), Qoe = /* @__PURE__ */ re("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = uoe), ut.init(e, t);
}), Joe = /* @__PURE__ */ re("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = doe), ut.init(e, t);
}), ese = /* @__PURE__ */ re("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = foe), ut.init(e, t);
}), tse = /* @__PURE__ */ re("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Coe(t)), ut.init(e, t);
}), nse = /* @__PURE__ */ re("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Aoe), ut.init(e, t);
}), rse = /* @__PURE__ */ re("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Poe(t)), ut.init(e, t);
}), ise = /* @__PURE__ */ re("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = moe), ut.init(e, t);
}), ase = /* @__PURE__ */ re("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = boe), ut.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv4";
  });
}), ose = /* @__PURE__ */ re("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = xoe), ut.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), sse = /* @__PURE__ */ re("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = woe), ut.init(e, t);
}), cse = /* @__PURE__ */ re("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = _oe), ut.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, a] = r;
      if (!a)
        throw new Error();
      const o = Number(a);
      if (`${o}` !== a)
        throw new Error();
      if (o < 0 || o > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function kR(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const lse = /* @__PURE__ */ re("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Soe), ut.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    kR(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function use(e) {
  if (!MR.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return kR(n);
}
const dse = /* @__PURE__ */ re("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = MR), ut.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    use(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), fse = /* @__PURE__ */ re("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Eoe), ut.init(e, t);
});
function hse(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const mse = /* @__PURE__ */ re("$ZodJWT", (e, t) => {
  ut.init(e, t), e._zod.check = (n) => {
    hse(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), vse = /* @__PURE__ */ re("$ZodUnknown", (e, t) => {
  Tt.init(e, t), e._zod.parse = (n) => n;
}), pse = /* @__PURE__ */ re("$ZodNever", (e, t) => {
  Tt.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function sC(e, t, n) {
  e.issues.length && t.issues.push(...CR(n, e.issues)), t.value[n] = e.value;
}
const gse = /* @__PURE__ */ re("$ZodArray", (e, t) => {
  Tt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const a = [];
    for (let o = 0; o < i.length; o++) {
      const s = i[o], c = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      c instanceof Promise ? a.push(c.then((l) => sC(l, n, o))) : sC(c, n, o);
    }
    return a.length ? Promise.all(a).then(() => n) : n;
  };
});
function Iu(e, t, n, r) {
  e.issues.length && t.issues.push(...CR(n, e.issues)), e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function RR(e) {
  const t = Object.keys(e.shape);
  for (const r of t)
    if (!e.shape?.[r]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${r}": expected a Zod schema`);
  const n = qae(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function LR(e, t, n, r, i, a) {
  const o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type;
  for (const d of Object.keys(t)) {
    if (s.has(d))
      continue;
    if (l === "never") {
      o.push(d);
      continue;
    }
    const f = c.run({ value: t[d], issues: [] }, r);
    f instanceof Promise ? e.push(f.then((h) => Iu(h, n, d, t))) : Iu(f, n, d, t);
  }
  return o.length && n.issues.push({
    code: "unrecognized_keys",
    keys: o,
    input: t,
    inst: a
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const yse = /* @__PURE__ */ re("$ZodObject", (e, t) => {
  if (Tt.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const c = { ...s };
        return Object.defineProperty(t, "shape", {
          value: c
        }), c;
      }
    });
  }
  const r = Ux(() => RR(t));
  rt(e._zod, "propValues", () => {
    const s = t.shape, c = {};
    for (const l in s) {
      const d = s[l]._zod;
      if (d.values) {
        c[l] ?? (c[l] = /* @__PURE__ */ new Set());
        for (const f of d.values)
          c[l].add(f);
      }
    }
    return c;
  });
  const i = Mu, a = t.catchall;
  let o;
  e._zod.parse = (s, c) => {
    o ?? (o = r.value);
    const l = s.value;
    if (!i(l))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), s;
    s.value = {};
    const d = [], f = o.shape;
    for (const h of o.keys) {
      const g = f[h]._zod.run({ value: l[h], issues: [] }, c);
      g instanceof Promise ? d.push(g.then((p) => Iu(p, s, h, l))) : Iu(g, s, h, l);
    }
    return a ? LR(d, l, s, c, r.value, e) : d.length ? Promise.all(d).then(() => s) : s;
  };
}), bse = /* @__PURE__ */ re("$ZodObjectJIT", (e, t) => {
  yse.init(e, t);
  const n = e._zod.parse, r = Ux(() => RR(t)), i = (h) => {
    const m = new qoe(["shape", "payload", "ctx"]), g = r.value, p = (w) => {
      const _ = aC(w);
      return `shape[${_}]._zod.run({ value: input[${_}], issues: [] }, ctx)`;
    };
    m.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let y = 0;
    for (const w of g.keys)
      v[w] = `key_${y++}`;
    m.write("const newResult = {};");
    for (const w of g.keys) {
      const _ = v[w], b = aC(w);
      m.write(`const ${_} = ${p(w)};`), m.write(`
        if (${_}.issues.length) {
          payload.issues = payload.issues.concat(${_}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${b}, ...iss.path] : [${b}]
          })));
        }
        
        
        if (${_}.value === undefined) {
          if (${b} in input) {
            newResult[${b}] = undefined;
          }
        } else {
          newResult[${b}] = ${_}.value;
        }
        
      `);
    }
    m.write("payload.value = newResult;"), m.write("return payload;");
    const x = m.compile();
    return (w, _) => x(h, w, _);
  };
  let a;
  const o = Mu, s = !ER.jitless, l = s && Fae.value, d = t.catchall;
  let f;
  e._zod.parse = (h, m) => {
    f ?? (f = r.value);
    const g = h.value;
    return o(g) ? s && l && m?.async === !1 && m.jitless !== !0 ? (a || (a = i(t.shape)), h = a(h, m), d ? LR([], g, h, m, f, e) : h) : n(h, m) : (h.issues.push({
      expected: "object",
      code: "invalid_type",
      input: g,
      inst: e
    }), h);
  };
});
function cC(e, t, n, r) {
  for (const a of e)
    if (a.issues.length === 0)
      return t.value = a.value, t;
  const i = e.filter((a) => !Oa(a));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((a) => a.issues.map((o) => ea(o, r, Ji())))
  }), t);
}
const xse = /* @__PURE__ */ re("$ZodUnion", (e, t) => {
  Tt.init(e, t), rt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), rt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), rt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), rt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((a) => a._zod.pattern);
      return new RegExp(`^(${i.map((a) => Yx(a.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, a) => {
    if (n)
      return r(i, a);
    let o = !1;
    const s = [];
    for (const c of t.options) {
      const l = c._zod.run({
        value: i.value,
        issues: []
      }, a);
      if (l instanceof Promise)
        s.push(l), o = !0;
      else {
        if (l.issues.length === 0)
          return l;
        s.push(l);
      }
    }
    return o ? Promise.all(s).then((c) => cC(c, i, e, a)) : cC(s, i, e, a);
  };
}), wse = /* @__PURE__ */ re("$ZodIntersection", (e, t) => {
  Tt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, a = t.left._zod.run({ value: i, issues: [] }, r), o = t.right._zod.run({ value: i, issues: [] }, r);
    return a instanceof Promise || o instanceof Promise ? Promise.all([a, o]).then(([c, l]) => lC(n, c, l)) : lC(n, a, o);
  };
});
function zy(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Js(e) && Js(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((a) => n.indexOf(a) !== -1), i = { ...e, ...t };
    for (const a of r) {
      const o = zy(e[a], t[a]);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...o.mergeErrorPath]
        };
      i[a] = o.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], a = t[r], o = zy(i, a);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...o.mergeErrorPath]
        };
      n.push(o.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function lC(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), Oa(e))
    return e;
  const r = zy(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const _se = /* @__PURE__ */ re("$ZodEnum", (e, t) => {
  Tt.init(e, t);
  const n = Bae(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => zae.has(typeof i)).map((i) => typeof i == "string" ? Kd(i) : i.toString()).join("|")})$`), e._zod.parse = (i, a) => {
    const o = i.value;
    return r.has(o) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: o,
      inst: e
    }), i;
  };
}), Sse = /* @__PURE__ */ re("$ZodTransform", (e, t) => {
  Tt.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new OR(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new ka();
    return n.value = i, n;
  };
});
function uC(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Ose = /* @__PURE__ */ re("$ZodOptional", (e, t) => {
  Tt.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", rt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), rt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Yx(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((a) => uC(a, n.value)) : uC(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), Ese = /* @__PURE__ */ re("$ZodNullable", (e, t) => {
  Tt.init(e, t), rt(e._zod, "optin", () => t.innerType._zod.optin), rt(e._zod, "optout", () => t.innerType._zod.optout), rt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Yx(n.source)}|null)$`) : void 0;
  }), rt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), Ase = /* @__PURE__ */ re("$ZodDefault", (e, t) => {
  Tt.init(e, t), e._zod.optin = "optional", rt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => dC(a, t)) : dC(i, t);
  };
});
function dC(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Pse = /* @__PURE__ */ re("$ZodPrefault", (e, t) => {
  Tt.init(e, t), e._zod.optin = "optional", rt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Cse = /* @__PURE__ */ re("$ZodNonOptional", (e, t) => {
  Tt.init(e, t), rt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => fC(a, e)) : fC(i, e);
  };
});
function fC(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const jse = /* @__PURE__ */ re("$ZodCatch", (e, t) => {
  Tt.init(e, t), rt(e._zod, "optin", () => t.innerType._zod.optin), rt(e._zod, "optout", () => t.innerType._zod.optout), rt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => (n.value = a.value, a.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: a.issues.map((o) => ea(o, r, Ji()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((a) => ea(a, r, Ji()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Tse = /* @__PURE__ */ re("$ZodPipe", (e, t) => {
  Tt.init(e, t), rt(e._zod, "values", () => t.in._zod.values), rt(e._zod, "optin", () => t.in._zod.optin), rt(e._zod, "optout", () => t.out._zod.optout), rt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const a = t.out._zod.run(n, r);
      return a instanceof Promise ? a.then((o) => ll(o, t.in, r)) : ll(a, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((a) => ll(a, t.out, r)) : ll(i, t.out, r);
  };
});
function ll(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Nse = /* @__PURE__ */ re("$ZodReadonly", (e, t) => {
  Tt.init(e, t), rt(e._zod, "propValues", () => t.innerType._zod.propValues), rt(e._zod, "values", () => t.innerType._zod.values), rt(e._zod, "optin", () => t.innerType._zod.optin), rt(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(hC) : hC(i);
  };
});
function hC(e) {
  return e.value = Object.freeze(e.value), e;
}
const Mse = /* @__PURE__ */ re("$ZodCustom", (e, t) => {
  gr.init(e, t), Tt.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((a) => mC(a, n, r, e));
    mC(i, n, r, e);
  };
});
function mC(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(ec(i));
  }
}
class Ise {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    if (this._map.set(t, r), r && typeof r == "object" && "id" in r) {
      if (this._idmap.has(r.id))
        throw new Error(`ID ${r.id} already exists in the registry`);
      this._idmap.set(r.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Dse() {
  return new Ise();
}
const ul = /* @__PURE__ */ Dse();
function kse(e, t) {
  return new e({
    type: "string",
    ...Pe(t)
  });
}
function Rse(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function vC(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Lse(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function $se(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Pe(t)
  });
}
function Bse(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Pe(t)
  });
}
function Fse(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Pe(t)
  });
}
function zse(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function qse(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Vse(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Wse(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Use(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Hse(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Yse(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Kse(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Gse(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Zse(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Xse(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Qse(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function Jse(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function ece(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function tce(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function nce(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Pe(t)
  });
}
function rce(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Pe(t)
  });
}
function ice(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Pe(t)
  });
}
function ace(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Pe(t)
  });
}
function oce(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Pe(t)
  });
}
function sce(e) {
  return new e({
    type: "unknown"
  });
}
function cce(e, t) {
  return new e({
    type: "never",
    ...Pe(t)
  });
}
function $R(e, t) {
  return new Moe({
    check: "max_length",
    ...Pe(t),
    maximum: e
  });
}
function Du(e, t) {
  return new Ioe({
    check: "min_length",
    ...Pe(t),
    minimum: e
  });
}
function BR(e, t) {
  return new Doe({
    check: "length_equals",
    ...Pe(t),
    length: e
  });
}
function lce(e, t) {
  return new koe({
    check: "string_format",
    format: "regex",
    ...Pe(t),
    pattern: e
  });
}
function uce(e) {
  return new Roe({
    check: "string_format",
    format: "lowercase",
    ...Pe(e)
  });
}
function dce(e) {
  return new Loe({
    check: "string_format",
    format: "uppercase",
    ...Pe(e)
  });
}
function fce(e, t) {
  return new $oe({
    check: "string_format",
    format: "includes",
    ...Pe(t),
    includes: e
  });
}
function hce(e, t) {
  return new Boe({
    check: "string_format",
    format: "starts_with",
    ...Pe(t),
    prefix: e
  });
}
function mce(e, t) {
  return new Foe({
    check: "string_format",
    format: "ends_with",
    ...Pe(t),
    suffix: e
  });
}
function Ec(e) {
  return new zoe({
    check: "overwrite",
    tx: e
  });
}
function vce(e) {
  return Ec((t) => t.normalize(e));
}
function pce() {
  return Ec((e) => e.trim());
}
function gce() {
  return Ec((e) => e.toLowerCase());
}
function yce() {
  return Ec((e) => e.toUpperCase());
}
function bce(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Pe(n)
  });
}
function xce(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Pe(n)
  });
}
function wce(e) {
  const t = _ce((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(ec(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(ec(i));
    }
  }, e(n.value, n)));
  return t;
}
function _ce(e, t) {
  const n = new gr({
    check: "custom",
    ...Pe(t)
  });
  return n._zod.check = e, n;
}
const Sce = /* @__PURE__ */ re("ZodISODateTime", (e, t) => {
  tse.init(e, t), mt.init(e, t);
});
function Oce(e) {
  return rce(Sce, e);
}
const Ece = /* @__PURE__ */ re("ZodISODate", (e, t) => {
  nse.init(e, t), mt.init(e, t);
});
function Ace(e) {
  return ice(Ece, e);
}
const Pce = /* @__PURE__ */ re("ZodISOTime", (e, t) => {
  rse.init(e, t), mt.init(e, t);
});
function Cce(e) {
  return ace(Pce, e);
}
const jce = /* @__PURE__ */ re("ZodISODuration", (e, t) => {
  ise.init(e, t), mt.init(e, t);
});
function Tce(e) {
  return oce(jce, e);
}
const Nce = (e, t) => {
  TR.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Xae(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Zae(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Fy, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Fy, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, kn = re("ZodError", Nce, {
  Parent: Error
}), Mce = /* @__PURE__ */ Gx(kn), Ice = /* @__PURE__ */ Zx(kn), Dce = /* @__PURE__ */ Gd(kn), kce = /* @__PURE__ */ Zd(kn), Rce = /* @__PURE__ */ eoe(kn), Lce = /* @__PURE__ */ toe(kn), $ce = /* @__PURE__ */ noe(kn), Bce = /* @__PURE__ */ roe(kn), Fce = /* @__PURE__ */ ioe(kn), zce = /* @__PURE__ */ aoe(kn), qce = /* @__PURE__ */ ooe(kn), Vce = /* @__PURE__ */ soe(kn), kt = /* @__PURE__ */ re("ZodType", (e, t) => (Tt.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(la(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
})), e.clone = (n, r) => pi(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => Mce(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Dce(e, n, r), e.parseAsync = async (n, r) => Ice(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => kce(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => Rce(e, n, r), e.decode = (n, r) => Lce(e, n, r), e.encodeAsync = async (n, r) => $ce(e, n, r), e.decodeAsync = async (n, r) => Bce(e, n, r), e.safeEncode = (n, r) => Fce(e, n, r), e.safeDecode = (n, r) => zce(e, n, r), e.safeEncodeAsync = async (n, r) => qce(e, n, r), e.safeDecodeAsync = async (n, r) => Vce(e, n, r), e.refine = (n, r) => e.check(Mle(n, r)), e.superRefine = (n) => e.check(Ile(n)), e.overwrite = (n) => e.check(Ec(n)), e.optional = () => yC(e), e.nullable = () => bC(e), e.nullish = () => yC(bC(e)), e.nonoptional = (n) => Ele(e, n), e.array = () => fle(e), e.or = (n) => vle([e, n]), e.and = (n) => gle(e, n), e.transform = (n) => xC(e, ble(n)), e.default = (n) => _le(e, n), e.prefault = (n) => Ole(e, n), e.catch = (n) => Ple(e, n), e.pipe = (n) => xC(e, n), e.readonly = () => Tle(e), e.describe = (n) => {
  const r = e.clone();
  return ul.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    return ul.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return ul.get(e);
  const r = e.clone();
  return ul.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), FR = /* @__PURE__ */ re("_ZodString", (e, t) => {
  Xx.init(e, t), kt.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(lce(...r)), e.includes = (...r) => e.check(fce(...r)), e.startsWith = (...r) => e.check(hce(...r)), e.endsWith = (...r) => e.check(mce(...r)), e.min = (...r) => e.check(Du(...r)), e.max = (...r) => e.check($R(...r)), e.length = (...r) => e.check(BR(...r)), e.nonempty = (...r) => e.check(Du(1, ...r)), e.lowercase = (r) => e.check(uce(r)), e.uppercase = (r) => e.check(dce(r)), e.trim = () => e.check(pce()), e.normalize = (...r) => e.check(vce(...r)), e.toLowerCase = () => e.check(gce()), e.toUpperCase = () => e.check(yce());
}), Wce = /* @__PURE__ */ re("ZodString", (e, t) => {
  Xx.init(e, t), FR.init(e, t), e.email = (n) => e.check(Rse(Uce, n)), e.url = (n) => e.check(zse(Hce, n)), e.jwt = (n) => e.check(nce(sle, n)), e.emoji = (n) => e.check(qse(Yce, n)), e.guid = (n) => e.check(vC(pC, n)), e.uuid = (n) => e.check(Lse(dl, n)), e.uuidv4 = (n) => e.check($se(dl, n)), e.uuidv6 = (n) => e.check(Bse(dl, n)), e.uuidv7 = (n) => e.check(Fse(dl, n)), e.nanoid = (n) => e.check(Vse(Kce, n)), e.guid = (n) => e.check(vC(pC, n)), e.cuid = (n) => e.check(Wse(Gce, n)), e.cuid2 = (n) => e.check(Use(Zce, n)), e.ulid = (n) => e.check(Hse(Xce, n)), e.base64 = (n) => e.check(Jse(ile, n)), e.base64url = (n) => e.check(ece(ale, n)), e.xid = (n) => e.check(Yse(Qce, n)), e.ksuid = (n) => e.check(Kse(Jce, n)), e.ipv4 = (n) => e.check(Gse(ele, n)), e.ipv6 = (n) => e.check(Zse(tle, n)), e.cidrv4 = (n) => e.check(Xse(nle, n)), e.cidrv6 = (n) => e.check(Qse(rle, n)), e.e164 = (n) => e.check(tce(ole, n)), e.datetime = (n) => e.check(Oce(n)), e.date = (n) => e.check(Ace(n)), e.time = (n) => e.check(Cce(n)), e.duration = (n) => e.check(Tce(n));
});
function nn(e) {
  return kse(Wce, e);
}
const mt = /* @__PURE__ */ re("ZodStringFormat", (e, t) => {
  ut.init(e, t), FR.init(e, t);
}), Uce = /* @__PURE__ */ re("ZodEmail", (e, t) => {
  Hoe.init(e, t), mt.init(e, t);
}), pC = /* @__PURE__ */ re("ZodGUID", (e, t) => {
  Woe.init(e, t), mt.init(e, t);
}), dl = /* @__PURE__ */ re("ZodUUID", (e, t) => {
  Uoe.init(e, t), mt.init(e, t);
}), Hce = /* @__PURE__ */ re("ZodURL", (e, t) => {
  Yoe.init(e, t), mt.init(e, t);
}), Yce = /* @__PURE__ */ re("ZodEmoji", (e, t) => {
  Koe.init(e, t), mt.init(e, t);
}), Kce = /* @__PURE__ */ re("ZodNanoID", (e, t) => {
  Goe.init(e, t), mt.init(e, t);
}), Gce = /* @__PURE__ */ re("ZodCUID", (e, t) => {
  Zoe.init(e, t), mt.init(e, t);
}), Zce = /* @__PURE__ */ re("ZodCUID2", (e, t) => {
  Xoe.init(e, t), mt.init(e, t);
}), Xce = /* @__PURE__ */ re("ZodULID", (e, t) => {
  Qoe.init(e, t), mt.init(e, t);
}), Qce = /* @__PURE__ */ re("ZodXID", (e, t) => {
  Joe.init(e, t), mt.init(e, t);
}), Jce = /* @__PURE__ */ re("ZodKSUID", (e, t) => {
  ese.init(e, t), mt.init(e, t);
}), ele = /* @__PURE__ */ re("ZodIPv4", (e, t) => {
  ase.init(e, t), mt.init(e, t);
}), tle = /* @__PURE__ */ re("ZodIPv6", (e, t) => {
  ose.init(e, t), mt.init(e, t);
}), nle = /* @__PURE__ */ re("ZodCIDRv4", (e, t) => {
  sse.init(e, t), mt.init(e, t);
}), rle = /* @__PURE__ */ re("ZodCIDRv6", (e, t) => {
  cse.init(e, t), mt.init(e, t);
}), ile = /* @__PURE__ */ re("ZodBase64", (e, t) => {
  lse.init(e, t), mt.init(e, t);
}), ale = /* @__PURE__ */ re("ZodBase64URL", (e, t) => {
  dse.init(e, t), mt.init(e, t);
}), ole = /* @__PURE__ */ re("ZodE164", (e, t) => {
  fse.init(e, t), mt.init(e, t);
}), sle = /* @__PURE__ */ re("ZodJWT", (e, t) => {
  mse.init(e, t), mt.init(e, t);
}), cle = /* @__PURE__ */ re("ZodUnknown", (e, t) => {
  vse.init(e, t), kt.init(e, t);
});
function gC() {
  return sce(cle);
}
const lle = /* @__PURE__ */ re("ZodNever", (e, t) => {
  pse.init(e, t), kt.init(e, t);
});
function ule(e) {
  return cce(lle, e);
}
const dle = /* @__PURE__ */ re("ZodArray", (e, t) => {
  gse.init(e, t), kt.init(e, t), e.element = t.element, e.min = (n, r) => e.check(Du(n, r)), e.nonempty = (n) => e.check(Du(1, n)), e.max = (n, r) => e.check($R(n, r)), e.length = (n, r) => e.check(BR(n, r)), e.unwrap = () => e.element;
});
function fle(e, t) {
  return bce(dle, e, t);
}
const hle = /* @__PURE__ */ re("ZodObject", (e, t) => {
  bse.init(e, t), kt.init(e, t), rt(e, "shape", () => t.shape), e.keyof = () => zR(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: gC() }), e.loose = () => e.clone({ ...e._zod.def, catchall: gC() }), e.strict = () => e.clone({ ...e._zod.def, catchall: ule() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Uae(e, n), e.safeExtend = (n) => Hae(e, n), e.merge = (n) => Yae(e, n), e.pick = (n) => Vae(e, n), e.omit = (n) => Wae(e, n), e.partial = (...n) => Kae(qR, e, n[0]), e.required = (...n) => Gae(VR, e, n[0]);
});
function Qd(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Pe(t)
  };
  return new hle(n);
}
const mle = /* @__PURE__ */ re("ZodUnion", (e, t) => {
  xse.init(e, t), kt.init(e, t), e.options = t.options;
});
function vle(e, t) {
  return new mle({
    type: "union",
    options: e,
    ...Pe(t)
  });
}
const ple = /* @__PURE__ */ re("ZodIntersection", (e, t) => {
  wse.init(e, t), kt.init(e, t);
});
function gle(e, t) {
  return new ple({
    type: "intersection",
    left: e,
    right: t
  });
}
const qy = /* @__PURE__ */ re("ZodEnum", (e, t) => {
  _se.init(e, t), kt.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const a = {};
    for (const o of r)
      if (n.has(o))
        a[o] = t.entries[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new qy({
      ...t,
      checks: [],
      ...Pe(i),
      entries: a
    });
  }, e.exclude = (r, i) => {
    const a = { ...t.entries };
    for (const o of r)
      if (n.has(o))
        delete a[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new qy({
      ...t,
      checks: [],
      ...Pe(i),
      entries: a
    });
  };
});
function zR(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new qy({
    type: "enum",
    entries: n,
    ...Pe(t)
  });
}
const yle = /* @__PURE__ */ re("ZodTransform", (e, t) => {
  Sse.init(e, t), kt.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new OR(e.constructor.name);
    n.addIssue = (a) => {
      if (typeof a == "string")
        n.issues.push(ec(a, n.value, t));
      else {
        const o = a;
        o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = e), n.issues.push(ec(o));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((a) => (n.value = a, n)) : (n.value = i, n);
  };
});
function ble(e) {
  return new yle({
    type: "transform",
    transform: e
  });
}
const qR = /* @__PURE__ */ re("ZodOptional", (e, t) => {
  Ose.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function yC(e) {
  return new qR({
    type: "optional",
    innerType: e
  });
}
const xle = /* @__PURE__ */ re("ZodNullable", (e, t) => {
  Ese.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function bC(e) {
  return new xle({
    type: "nullable",
    innerType: e
  });
}
const wle = /* @__PURE__ */ re("ZodDefault", (e, t) => {
  Ase.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function _le(e, t) {
  return new wle({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : PR(t);
    }
  });
}
const Sle = /* @__PURE__ */ re("ZodPrefault", (e, t) => {
  Pse.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ole(e, t) {
  return new Sle({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : PR(t);
    }
  });
}
const VR = /* @__PURE__ */ re("ZodNonOptional", (e, t) => {
  Cse.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ele(e, t) {
  return new VR({
    type: "nonoptional",
    innerType: e,
    ...Pe(t)
  });
}
const Ale = /* @__PURE__ */ re("ZodCatch", (e, t) => {
  jse.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ple(e, t) {
  return new Ale({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Cle = /* @__PURE__ */ re("ZodPipe", (e, t) => {
  Tse.init(e, t), kt.init(e, t), e.in = t.in, e.out = t.out;
});
function xC(e, t) {
  return new Cle({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const jle = /* @__PURE__ */ re("ZodReadonly", (e, t) => {
  Nse.init(e, t), kt.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Tle(e) {
  return new jle({
    type: "readonly",
    innerType: e
  });
}
const Nle = /* @__PURE__ */ re("ZodCustom", (e, t) => {
  Mse.init(e, t), kt.init(e, t);
});
function Mle(e, t = {}) {
  return xce(Nle, e, t);
}
function Ile(e) {
  return wce(e);
}
const Dle = Qd({
  addressId: nn().min(1, "Please select an address")
});
function Cue(e) {
  const {
    control: t,
    handleSubmit: n,
    reset: r,
    formState: { isSubmitting: i, isValid: a }
  } = Oc({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver type inference is incompatible with this Zod schema
    resolver: Wx(Dle),
    values: {
      addressId: e.defaultAddressId ?? ""
    },
    mode: "onChange"
  }), o = async (l) => {
    await e.onSubmit(l), e.onOpenChange(!1), r(l);
  }, s = (l) => {
    e.onOpenChange(l), l || r({ addressId: e.defaultAddressId ?? "" });
  }, c = e.addresses.map((l) => ({
    value: l.id,
    label: /* @__PURE__ */ u.jsxs(B, { variant: "body-md", children: [
      l.name,
      /* @__PURE__ */ u.jsx("br", {}),
      l.street,
      /* @__PURE__ */ u.jsx("br", {}),
      l.postalCode,
      " ",
      l.city,
      /* @__PURE__ */ u.jsx("br", {}),
      l.country
    ] })
  }));
  return /* @__PURE__ */ u.jsx(oo, { onOpenChange: s, open: e.open, children: /* @__PURE__ */ u.jsxs(Ui, { className: "sm:max-w-[532px]", children: [
    /* @__PURE__ */ u.jsxs(dc, { children: [
      /* @__PURE__ */ u.jsx(Hi, { children: e.microcopies.title }),
      /* @__PURE__ */ u.jsx(ox, { children: e.microcopies.description })
    ] }),
    /* @__PURE__ */ u.jsxs("form", { className: "flex flex-col gap-6", onSubmit: n(o), children: [
      /* @__PURE__ */ u.jsx("div", { className: "max-h-[50vh] overflow-y-auto p-2", children: /* @__PURE__ */ u.jsx(
        Da,
        {
          control: t,
          name: "addressId",
          render: ({ field: l }) => /* @__PURE__ */ u.jsx(
            fc,
            {
              onValueChange: l.onChange,
              options: c,
              value: l.value
            }
          )
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: "flex justify-end pt-4", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: e.isPending || i || !a,
          loading: i || e.isPending,
          type: "submit",
          children: e.microcopies.saveButtonLabel
        }
      ) })
    ] })
  ] }) });
}
function Vy(e) {
  return /* @__PURE__ */ u.jsx(PC, { ...e, children: /* @__PURE__ */ u.jsx(w2, {}) });
}
function kle(e) {
  return e.type === "shipping" ? /* @__PURE__ */ u.jsx(Yp, { color: "muted", size: "lg" }) : /* @__PURE__ */ u.jsx(Vy, { color: "muted", size: "lg" });
}
function jue(e) {
  const t = e.addresses.filter(
    (n) => n.type === "shipping"
  ).length;
  return /* @__PURE__ */ u.jsxs(
    "section",
    {
      "aria-label": e.microcopies.sectionTitle,
      className: "rounded-md bg-background p-4",
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2 py-4 md:px-3", children: [
          /* @__PURE__ */ u.jsx(JL, { color: "muted", size: "lg" }),
          /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.sectionTitle })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-6 pb-3 md:grid-cols-2 md:px-3", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "rounded-md border border-border p-4", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "mb-3 flex items-center justify-between", children: [
              /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ u.jsx(Yp, { className: "text-zinc-500", size: "lg" }),
                /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.preferredShippingLabel })
              ] }),
              e.userRole !== "SHOP_VIEWER" && e.userRole !== "UNKNOWN" && t > 1 && /* @__PURE__ */ u.jsx(
                ve,
                {
                  "aria-label": e.microcopies.preferredShippingLabel,
                  onClick: e.onEditShipping,
                  size: "icon-sm",
                  variant: "ghost",
                  children: /* @__PURE__ */ u.jsx(us, { className: "size-6 text-zinc-500" })
                }
              )
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-0.5", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredShipping.companyName }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredShipping.street }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredShipping.postalCodeCity }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredShipping.country })
            ] })
          ] }),
          /* @__PURE__ */ u.jsxs("div", { className: "rounded-md border border-border p-4", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ u.jsx(Vy, { className: "text-zinc-500", size: "lg" }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.preferredBillingLabel })
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-0.5", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredBilling.companyName }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredBilling.street }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredBilling.postalCodeCity }),
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.preferredBilling.country })
            ] })
          ] })
        ] }),
        e.addresses.length > 0 && /* @__PURE__ */ u.jsx("div", { className: "md:px-3", children: /* @__PURE__ */ u.jsx("ul", { children: e.addresses.map((n) => /* @__PURE__ */ u.jsxs(
          "li",
          {
            className: "flex items-center justify-between border-border border-b px-4 py-4",
            children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: n.fullAddress }),
              /* @__PURE__ */ u.jsx("div", { className: "shrink-0 pl-4 text-zinc-500", children: /* @__PURE__ */ u.jsx(kle, { type: n.type }) })
            ]
          },
          n.id
        )) }) }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-4 py-5 pt-3 md:flex-row md:items-center md:justify-between md:px-3", children: [
          /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.footerNote }),
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2 md:flex-row md:items-center md:gap-4", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1.5", children: [
              /* @__PURE__ */ u.jsx(Yp, { color: "muted", size: "lg" }),
              /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-xs", children: e.microcopies.shippingLegend })
            ] }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-1.5", children: [
              /* @__PURE__ */ u.jsx(Vy, { color: "muted", size: "lg" }),
              /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-xs", children: e.microcopies.billingLegend })
            ] })
          ] })
        ] })
      ]
    }
  );
}
function wC(e) {
  return /* @__PURE__ */ u.jsxs("div", { className: "flex w-full flex-col gap-2", children: [
    /* @__PURE__ */ u.jsx(wt, { disabled: e.disabled, htmlFor: e.id, children: e.label }),
    /* @__PURE__ */ u.jsxs(
      co,
      {
        defaultValue: e.defaultValue,
        disabled: e.disabled,
        onValueChange: e.onValueChange,
        value: e.value,
        children: [
          /* @__PURE__ */ u.jsx(Zi, { className: "w-full", id: e.id, children: /* @__PURE__ */ u.jsx(lo, { placeholder: e.placeholder }) }),
          /* @__PURE__ */ u.jsx(Xi, { children: e.options.map((t) => /* @__PURE__ */ u.jsx(Qi, { value: t.value, children: t.label }, t.value)) })
        ]
      }
    ),
    e.description && /* @__PURE__ */ u.jsx("p", { className: "font-normal text-sm text-zinc-500 leading-5", children: e.description })
  ] });
}
function Tue(e) {
  const { control: t, handleSubmit: n } = Oc({
    defaultValues: {
      language: e.defaultLanguage ?? e.languageOptions[0]?.value ?? "",
      catalog: e.defaultCatalog ?? e.catalogOptions[0]?.value ?? "",
      priceVisibility: e.defaultPriceVisibility ?? !1
    },
    mode: "onChange"
  });
  return /* @__PURE__ */ u.jsxs("article", { className: "flex flex-col gap-6 rounded-md bg-white p-4", children: [
    /* @__PURE__ */ u.jsxs("header", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ u.jsx(P2, { className: "h-6 w-6 text-zinc-500" }),
        /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-md", children: e.microcopies.headerDescription }) })
    ] }),
    /* @__PURE__ */ u.jsxs(
      "form",
      {
        className: "flex flex-col gap-6",
        onSubmit: n((r) => e.onSubmit?.(r)),
        children: [
          /* @__PURE__ */ u.jsx(
            Da,
            {
              control: t,
              name: "language",
              render: ({ field: r }) => /* @__PURE__ */ u.jsx(
                wC,
                {
                  id: "language",
                  label: e.microcopies.languageLabel,
                  onValueChange: r.onChange,
                  options: e.languageOptions,
                  placeholder: e.languageOptions[0]?.label,
                  value: r.value
                }
              )
            }
          ),
          /* @__PURE__ */ u.jsx(
            Da,
            {
              control: t,
              name: "catalog",
              render: ({ field: r }) => /* @__PURE__ */ u.jsx(
                wC,
                {
                  id: "catalog",
                  label: e.microcopies.catalogLabel,
                  onValueChange: r.onChange,
                  options: e.catalogOptions,
                  placeholder: e.catalogOptions[0]?.label,
                  value: r.value
                }
              )
            }
          ),
          /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.priceVisibilityLabel }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.hideLabel }),
              /* @__PURE__ */ u.jsx(
                Da,
                {
                  control: t,
                  name: "priceVisibility",
                  render: ({ field: r }) => /* @__PURE__ */ u.jsx(
                    Cu,
                    {
                      checked: r.value,
                      className: "data-[state=checked]:bg-black [&_span]:bg-white",
                      disabled: e.userRole === "SHOP_VIEWER",
                      onCheckedChange: r.onChange
                    }
                  )
                }
              ),
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.showLabel })
            ] })
          ] }),
          /* @__PURE__ */ u.jsx("footer", { className: "flex items-center pt-12", children: /* @__PURE__ */ u.jsx(ve, { disabled: !0, size: "sm", type: "submit", variant: "default", children: e.microcopies.saveButtonLabel }) })
        ]
      }
    )
  ] });
}
function Cn({
  id: e,
  label: t,
  type: n = "text",
  required: r = !1,
  disabled: i = !1,
  registerProps: a,
  error: o,
  className: s = "flex flex-col gap-2",
  placeholder: c,
  children: l,
  labelClassName: d,
  autoComplete: f
}) {
  return /* @__PURE__ */ u.jsxs("div", { className: s, children: [
    /* @__PURE__ */ u.jsxs(wt, { className: d, htmlFor: e, children: [
      t,
      r && "*"
    ] }),
    /* @__PURE__ */ u.jsx(
      ni,
      {
        autoComplete: f,
        disabled: i,
        id: e,
        placeholder: c,
        type: n,
        variant: o ? "error" : "default",
        ...a
      }
    ),
    l || o && /* @__PURE__ */ u.jsx(B, { color: "red", variant: "body-xs", children: o.message })
  ] });
}
const Rle = Qd({
  customerId: nn().optional(),
  firstName: nn().min(1, "First name is required"),
  lastName: nn().min(1, "Last name is required"),
  email: nn().email("Please enter a valid email address")
});
function Nue(e) {
  const t = e.variant || "readonly", {
    register: n,
    handleSubmit: r,
    reset: i,
    formState: { errors: a, isSubmitting: o, isDirty: s }
  } = Oc({
    // biome-ignore lint/suspicious/noExplicitAny: -
    resolver: Wx(Rle),
    values: e.data
  }), c = e.userRole !== "ADMIN" && e.userRole !== "UNKNOWN", l = async (f) => {
    t === "form" && (await e.onSubmit(f), i(f));
  };
  if (t === "readonly")
    return /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-6 rounded-md bg-white p-4", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ u.jsx(es, { className: "h-6 w-6 text-zinc-500" }),
          /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-md", children: e.microcopies.subtitle }) })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-4", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.customerIdLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.data.customerId }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.firstNameLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.data.firstName }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.lastNameLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.data.lastName }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.emailLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.data.email }) })
        ] })
      ] }) }),
      /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-6", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.footer }) })
    ] });
  if (t === "editable") {
    const f = e;
    return /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-6 rounded-md bg-white p-4", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ u.jsx(es, { className: "h-6 w-6 text-muted-foreground" }),
          /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-md", children: e.microcopies.subtitle }) })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-6 sm:flex-row sm:items-end", children: [
        /* @__PURE__ */ u.jsxs("div", { className: "relative flex flex-1 flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.customerIdLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.data.customerId }) }),
          e.userRole !== "ADMIN" && e.userRole !== "UNKNOWN" && /* @__PURE__ */ u.jsx(
            "button",
            {
              className: "absolute top-0 right-0 flex h-8 w-8 items-center justify-center sm:hidden",
              onClick: f.onEdit,
              type: "button",
              children: /* @__PURE__ */ u.jsx(us, { className: "h-5 w-5 text-neutral-600" })
            }
          )
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.firstNameLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.data.firstName }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.lastNameLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.data.lastName }) })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.emailLabel }) }),
          /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.data.email }) })
        ] }),
        e.userRole !== "ADMIN" && e.userRole !== "UNKNOWN" && /* @__PURE__ */ u.jsx(
          "button",
          {
            className: "hidden h-10 w-8 items-center justify-end sm:flex",
            onClick: f.onEdit,
            type: "button",
            children: /* @__PURE__ */ u.jsx(us, { className: "h-5 w-5 text-neutral-600" })
          }
        )
      ] }) })
    ] });
  }
  const d = e;
  return /* @__PURE__ */ u.jsxs(
    "form",
    {
      className: "flex flex-col gap-6 rounded-md bg-white p-4",
      onSubmit: r(l),
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ u.jsx(es, { className: "h-6 w-6 text-muted-foreground" }),
            /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-md", children: e.microcopies.subtitle }) })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-4 sm:flex-row sm:justify-between", children: [
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              className: "flex flex-1 flex-col gap-1",
              disabled: !0,
              id: "customerId",
              label: d.microcopies.customerIdLabel,
              placeholder: d.microcopies.customerIdPlaceholder,
              registerProps: n("customerId")
            }
          ),
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              className: "flex flex-1 flex-col gap-1",
              disabled: !c,
              error: a.firstName,
              id: "firstName",
              label: d.microcopies.firstNameLabel,
              placeholder: d.microcopies.firstNamePlaceholder,
              registerProps: n("firstName"),
              required: !0
            }
          ),
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              className: "flex flex-1 flex-col gap-1",
              disabled: !c,
              error: a.lastName,
              id: "lastName",
              label: d.microcopies.lastNameLabel,
              placeholder: d.microcopies.lastNamePlaceholder,
              registerProps: n("lastName"),
              required: !0
            }
          ),
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              className: "flex flex-1 flex-col gap-1",
              disabled: !c,
              error: a.email,
              id: "email",
              label: d.microcopies.emailLabel,
              placeholder: d.microcopies.emailPlaceholder,
              registerProps: n("email"),
              required: !0,
              type: "email"
            }
          )
        ] }) }),
        /* @__PURE__ */ u.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ u.jsx(
          ve,
          {
            disabled: o || !s,
            loading: o,
            size: "sm",
            type: "submit",
            children: d.microcopies.saveButtonLabel
          }
        ) })
      ]
    }
  );
}
function Lle(e) {
  return /* @__PURE__ */ u.jsx(PC, { ...e, children: /* @__PURE__ */ u.jsx(g2, {}) });
}
const Wy = 8;
Qd({
  currentPassword: nn().min(1, "Current password is required"),
  newPassword: nn().min(Wy, "Minimum 8 characters").regex(/[A-Z]/, "At least 1 uppercase letter").regex(/[a-z]/, "At least 1 lowercase letter").regex(/\d/, "At least 1 number").regex(/[^A-Za-z\d]/, "At least 1 special character"),
  confirmNewPassword: nn().min(1, "Please confirm your new password")
}).refine((e) => e.newPassword === e.confirmNewPassword, {
  message: `Password don't match
Write them carefully`,
  path: ["confirmNewPassword"]
});
function Mue(e) {
  const {
    register: t,
    handleSubmit: n,
    control: r,
    reset: i,
    formState: { errors: a, isValid: o }
  } = Oc({
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    },
    mode: "onChange"
  }), s = hR({ control: r, name: "newPassword" }), c = s.length >= Wy, l = /\d/.test(s), d = /[a-z]/.test(s) && /[A-Z]/.test(s), f = /[^A-Za-z0-9]/.test(s), h = e.userRole !== "UNKNOWN";
  function m(g) {
    e.onChangePassword?.(g), i({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    });
  }
  return /* @__PURE__ */ u.jsxs("article", { className: "flex flex-col gap-6 rounded-md bg-white p-4", children: [
    /* @__PURE__ */ u.jsxs("header", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ u.jsx(Lle, { className: "h-6 w-6 text-muted-foreground" }),
        /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ u.jsx(B, { color: "black", variant: "body-md", children: e.microcopies.description }) })
    ] }),
    /* @__PURE__ */ u.jsxs("form", { className: "flex flex-col gap-4", onSubmit: n(m), children: [
      /* @__PURE__ */ u.jsx(
        Cn,
        {
          autoComplete: "current-password",
          disabled: e.disabled || !h,
          error: a.currentPassword,
          id: "currentPassword",
          label: e.microcopies.currentPasswordLabel,
          labelClassName: "font-semibold text-zinc-900",
          registerProps: t("currentPassword", {
            required: "Current password is required"
          }),
          type: "password"
        }
      ),
      /* @__PURE__ */ u.jsx(
        Cn,
        {
          autoComplete: "new-password",
          disabled: e.disabled || !h,
          error: a.newPassword,
          id: "newPassword",
          label: e.microcopies.newPasswordLabel,
          labelClassName: "font-semibold text-zinc-900",
          registerProps: t("newPassword", {
            required: "New password is required",
            minLength: {
              value: Wy,
              message: "Minimum 8 characters"
            },
            validate: {
              hasUpper: (g) => /[A-Z]/.test(g) || "At least 1 uppercase letter",
              hasLower: (g) => /[a-z]/.test(g) || "At least 1 lowercase letter",
              hasNum: (g) => /\d/.test(g) || "At least 1 number",
              hasSpecial: (g) => /[^A-Za-z\d]/.test(g) || "At least 1 special character"
            }
          }),
          type: "password",
          children: s.length === 0 && !a.newPassword ? /* @__PURE__ */ u.jsx(B, { color: "muted", variant: "body-xs", children: e.microcopies.newPasswordHint }) : /* @__PURE__ */ u.jsxs("div", { className: "mt-1 flex flex-col gap-1", children: [
            /* @__PURE__ */ u.jsx(B, { color: c ? "success" : "muted", variant: "body-xs", children: e.microcopies.reqMinChars }),
            /* @__PURE__ */ u.jsx(B, { color: l ? "success" : "muted", variant: "body-xs", children: e.microcopies.reqNumber }),
            /* @__PURE__ */ u.jsx(
              B,
              {
                color: d ? "success" : "muted",
                variant: "body-xs",
                children: e.microcopies.reqUpperLower
              }
            ),
            /* @__PURE__ */ u.jsx(B, { color: f ? "success" : "muted", variant: "body-xs", children: e.microcopies.reqSpecialChar })
          ] })
        }
      ),
      /* @__PURE__ */ u.jsx(
        Cn,
        {
          autoComplete: "new-password",
          disabled: e.disabled || !h,
          error: a.confirmNewPassword,
          id: "confirmNewPassword",
          label: e.microcopies.confirmNewPasswordLabel,
          labelClassName: "font-semibold",
          registerProps: t("confirmNewPassword", {
            required: "Please confirm your new password",
            validate: (g) => g === s || `Password don't match
Write them carefully`
          }),
          type: "password"
        }
      ),
      /* @__PURE__ */ u.jsx("footer", { className: "mt-2 flex items-center", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: !(o && h),
          loading: e.loading,
          size: "sm",
          type: "submit",
          variant: "default",
          children: e.microcopies.changePasswordButton
        }
      ) })
    ] })
  ] });
}
const $le = Qd({
  customerId: nn().optional(),
  firstName: nn().min(1, "First name is required"),
  lastName: nn().min(1, "Last name is required"),
  language: nn().min(1, "Language is required"),
  email: nn().email("Please enter a valid email address"),
  confirmEmail: nn().email("Please enter a valid email address"),
  role: zR(["Administrator", "Sub Administrator", "Employee", "Viewer"], {
    message: "Please select a role"
  })
}).refine((e) => e.email === e.confirmEmail, {
  message: "Email addresses don't match",
  path: ["confirmEmail"]
});
function Iue(e) {
  const {
    register: t,
    control: n,
    handleSubmit: r,
    reset: i,
    setError: a,
    formState: { isSubmitting: o, errors: s }
  } = Oc({
    // biome-ignore lint/suspicious/noExplicitAny: -
    resolver: Wx($le),
    values: {
      customerId: e.defaultValues?.customerId ?? "",
      firstName: e.defaultValues?.firstName ?? "",
      lastName: e.defaultValues?.lastName ?? "",
      language: e.defaultValues?.language ?? e.languageOptions[0]?.value ?? "",
      email: e.defaultValues?.email ?? "",
      confirmEmail: e.defaultValues?.confirmEmail ?? "",
      role: e.defaultValues?.role ?? "Viewer"
    },
    mode: "onChange"
  });
  St(() => {
    e.serverError && a("email", { type: "server", message: e.serverError });
  }, [e.serverError, a]);
  const c = async (f) => {
    await e.onSubmit(f), e.onOpenChange(!1), i();
  }, l = (f) => {
    e.onOpenChange(f), f || i(e.defaultValues);
  }, d = !!e.defaultValues?.customerId;
  return /* @__PURE__ */ u.jsx(oo, { onOpenChange: l, open: e.open, children: /* @__PURE__ */ u.jsxs(Ui, { className: "scrollbar-modal max-h-[90vh] overflow-y-auto sm:max-w-[532px]", children: [
    /* @__PURE__ */ u.jsxs(dc, { children: [
      /* @__PURE__ */ u.jsx(Hi, { children: e.microcopies.title }),
      /* @__PURE__ */ u.jsx(ox, { children: e.microcopies.description })
    ] }),
    /* @__PURE__ */ u.jsxs("form", { className: "flex flex-col gap-6", onSubmit: r(c), children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ u.jsx("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ u.jsx(
          Cn,
          {
            disabled: d,
            id: "customerId",
            label: e.microcopies.customerIdLabel,
            registerProps: t("customerId"),
            required: !d
          }
        ) }),
        /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2", children: [
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              error: s.firstName,
              id: "firstName",
              label: e.microcopies.firstNameLabel,
              registerProps: t("firstName"),
              required: !0
            }
          ),
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              error: s.lastName,
              id: "lastName",
              label: e.microcopies.lastNameLabel,
              registerProps: t("lastName"),
              required: !0
            }
          )
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsx(wt, { children: e.microcopies.languageLabel }),
          /* @__PURE__ */ u.jsx(
            Da,
            {
              control: n,
              name: "language",
              render: ({ field: f }) => /* @__PURE__ */ u.jsxs(co, { onValueChange: f.onChange, value: f.value, children: [
                /* @__PURE__ */ u.jsx(Zi, { children: /* @__PURE__ */ u.jsx(lo, { placeholder: "Select language" }) }),
                /* @__PURE__ */ u.jsx(Xi, { children: e.languageOptions.map((h) => /* @__PURE__ */ u.jsx(Qi, { value: h.value, children: h.label }, h.value)) })
              ] })
            }
          ),
          s.language && /* @__PURE__ */ u.jsx(B, { color: "red", variant: "body-xs", children: s.language.message })
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2", children: [
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              error: s.email,
              id: "email",
              label: e.microcopies.emailLabel,
              registerProps: t("email"),
              required: !0,
              type: "email"
            }
          ),
          /* @__PURE__ */ u.jsx(
            Cn,
            {
              error: s.confirmEmail,
              id: "confirmEmail",
              label: e.microcopies.confirmEmailLabel,
              registerProps: t("confirmEmail"),
              required: !0,
              type: "email"
            }
          )
        ] }),
        e.serverError && /* @__PURE__ */ u.jsx(
          na,
          {
            microcopies: {
              title: e.microcopies.serverErrorTitle ?? e.serverError,
              description: e.microcopies.serverErrorTitle ? e.serverError : void 0
            },
            variant: "warning"
          }
        ),
        e.showRoleField !== !1 && /* @__PURE__ */ u.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ u.jsxs(wt, { children: [
            e.microcopies.roleLabel,
            "*"
          ] }),
          /* @__PURE__ */ u.jsx(
            Da,
            {
              control: n,
              name: "role",
              render: ({ field: f }) => /* @__PURE__ */ u.jsx(
                fc,
                {
                  onValueChange: f.onChange,
                  options: e.roleOptions,
                  value: f.value
                }
              )
            }
          ),
          s.role && /* @__PURE__ */ u.jsx(B, { color: "red", variant: "body-xs", children: s.role.message })
        ] })
      ] }),
      /* @__PURE__ */ u.jsx("div", { className: "flex justify-end pt-4", children: /* @__PURE__ */ u.jsx(
        ve,
        {
          disabled: e.isPending || o,
          loading: o || e.isPending,
          type: "submit",
          children: e.microcopies.saveButtonLabel
        }
      ) })
    ] })
  ] }) });
}
function fl(e, t) {
  return e.replace("{firstName}", t.firstName).replace("{lastName}", t.lastName);
}
function Due(e) {
  const [t, n] = Ee(
    /* @__PURE__ */ new Set()
  ), r = (i) => {
    const a = new Set(t);
    a.has(i) ? a.delete(i) : a.add(i), n(a);
  };
  return /* @__PURE__ */ u.jsxs("div", { className: "w-full rounded-md bg-white p-4", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "mb-6 flex items-center justify-between", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ u.jsx(e2, { "aria-hidden": "true", className: "size-5 text-muted-foreground" }),
        /* @__PURE__ */ u.jsx(B, { variant: "h4", children: e.microcopies.title })
      ] }),
      /* @__PURE__ */ u.jsxs(
        ve,
        {
          className: "flex items-center gap-2",
          onClick: e.onAddNewUser,
          size: "sm",
          variant: "ghost",
          children: [
            /* @__PURE__ */ u.jsx(
              t2,
              {
                "aria-hidden": "true",
                className: "size-4 text-muted-foreground"
              }
            ),
            /* @__PURE__ */ u.jsx(B, { variant: "body-sm-bold", children: e.microcopies.addNewUserLabel })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "w-full overflow-hidden", children: [
      /* @__PURE__ */ u.jsxs("div", { className: "hidden border-border border-b bg-transparent px-4 py-3 md:grid md:grid-cols-[2.5rem_2.5rem_1fr_1fr_1fr_1fr_auto] md:gap-4", children: [
        /* @__PURE__ */ u.jsx("div", {}),
        /* @__PURE__ */ u.jsx("div", {}),
        /* @__PURE__ */ u.jsx("div", { className: "text-zinc-500", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.firstNameHeader }) }),
        /* @__PURE__ */ u.jsx("div", { className: "text-zinc-500", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.lastNameHeader }) }),
        /* @__PURE__ */ u.jsx("div", { className: "text-zinc-500", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.roleHeader }) }),
        /* @__PURE__ */ u.jsx("div", { className: "text-zinc-500", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.statusHeader }) }),
        /* @__PURE__ */ u.jsx("div", { className: "w-10" })
      ] }),
      e.users.length === 0 ? /* @__PURE__ */ u.jsx("div", { className: "px-4 py-8 text-center", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: e.microcopies.emptyStateLabel }) }) : e.users.map((i) => {
        const a = t.has(i.id);
        return /* @__PURE__ */ u.jsxs("div", { className: "border-border border-b", children: [
          /* @__PURE__ */ u.jsxs("div", { className: "hidden px-4 pt-3 pb-2 hover:bg-secondary md:grid md:grid-cols-[2.5rem_2.5rem_1fr_1fr_1fr_1fr_auto] md:gap-4", children: [
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-expanded": a,
                "aria-label": fl(
                  e.microcopies.toggleDetailsAriaLabel,
                  i
                ),
                className: "p-0",
                onClick: () => r(i.id),
                size: "sm",
                variant: "ghost",
                children: /* @__PURE__ */ u.jsx(
                  zi,
                  {
                    "aria-hidden": "true",
                    className: `size-4 text-muted-foreground transition-transform duration-200 ${a ? "rotate-180" : ""}`
                  }
                )
              }
            ) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsx(
              es,
              {
                "aria-hidden": "true",
                className: "size-5 text-muted-foreground"
              }
            ) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center text-left font-medium", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: i.firstName }) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center pl-1 text-left font-medium", children: /* @__PURE__ */ u.jsx(B, { variant: "body-md", children: i.lastName }) }),
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ u.jsxs(
              co,
              {
                disabled: i.isDisabled,
                onValueChange: i.onRoleChange,
                value: i.role,
                children: [
                  /* @__PURE__ */ u.jsx(Zi, { className: "w-full rounded border border-border bg-white px-3 py-2 hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-0", children: /* @__PURE__ */ u.jsx(lo, {}) }),
                  /* @__PURE__ */ u.jsx(Xi, { children: e.roleOptions?.map((o) => /* @__PURE__ */ u.jsx(Qi, { value: o, children: e.microcopies.roleLabels?.[o] ?? o }, o)) })
                ]
              }
            ) }),
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center justify-start gap-2", children: [
              /* @__PURE__ */ u.jsx(
                Cu,
                {
                  "aria-label": fl(
                    e.microcopies.statusAriaLabel,
                    i
                  ),
                  checked: i.status === "Active",
                  className: "data-[state=checked]:bg-black [&_span]:bg-white",
                  disabled: i.isDisabled,
                  onCheckedChange: i.onStatusChange
                }
              ),
              /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.statusLabels?.[i.status] ?? i.status }) })
            ] }),
            /* @__PURE__ */ u.jsx("div", { className: "flex items-center justify-end text-muted-foreground", children: /* @__PURE__ */ u.jsx(
              ve,
              {
                "aria-label": `${e.microcopies.editLabel} ${i.firstName} ${i.lastName}`,
                disabled: i.isDisabled,
                onClick: i.onEdit,
                size: "sm",
                variant: "ghost",
                children: /* @__PURE__ */ u.jsx(
                  us,
                  {
                    "aria-hidden": "true",
                    className: "size-6 text-zinc-500"
                  }
                )
              }
            ) })
          ] }),
          /* @__PURE__ */ u.jsxs("div", { className: "py-4 md:hidden", children: [
            /* @__PURE__ */ u.jsxs("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ u.jsx(
                ve,
                {
                  "aria-expanded": a,
                  "aria-label": fl(
                    e.microcopies.toggleDetailsAriaLabel,
                    i
                  ),
                  className: "p-0",
                  onClick: () => r(i.id),
                  size: "sm",
                  variant: "ghost",
                  children: /* @__PURE__ */ u.jsx(
                    zi,
                    {
                      "aria-hidden": "true",
                      className: `size-4 text-muted-foreground transition-transform duration-200 ${a ? "rotate-180" : ""}`
                    }
                  )
                }
              ),
              /* @__PURE__ */ u.jsx(
                es,
                {
                  "aria-hidden": "true",
                  className: "size-5 text-muted-foreground"
                }
              ),
              /* @__PURE__ */ u.jsx("div", { className: "flex-1 font-medium", children: /* @__PURE__ */ u.jsxs(B, { variant: "body-sm", children: [
                i.firstName,
                " ",
                i.lastName
              ] }) }),
              /* @__PURE__ */ u.jsx(
                ve,
                {
                  "aria-label": `${e.microcopies.editLabel} ${i.firstName} ${i.lastName}`,
                  disabled: i.isDisabled,
                  onClick: i.onEdit,
                  size: "sm",
                  variant: "ghost",
                  children: /* @__PURE__ */ u.jsx(
                    us,
                    {
                      "aria-hidden": "true",
                      className: "size-4 text-muted-foreground"
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ u.jsx("div", { className: "mt-2 w-44 pl-8", children: /* @__PURE__ */ u.jsxs(
              co,
              {
                disabled: i.isDisabled,
                onValueChange: i.onRoleChange,
                value: i.role,
                children: [
                  /* @__PURE__ */ u.jsx(Zi, { className: "h-9 w-full rounded border border-border bg-white px-3 py-2 hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-0", children: /* @__PURE__ */ u.jsx(lo, {}) }),
                  /* @__PURE__ */ u.jsx(Xi, { children: e.roleOptions?.map((o) => /* @__PURE__ */ u.jsx(Qi, { value: o, children: e.microcopies.roleLabels?.[o] ?? o }, o)) })
                ]
              }
            ) }),
            /* @__PURE__ */ u.jsxs("div", { className: "mt-2 flex items-center gap-2 pl-10", children: [
              /* @__PURE__ */ u.jsx(
                Cu,
                {
                  "aria-label": fl(
                    e.microcopies.statusAriaLabel,
                    i
                  ),
                  checked: i.status === "Active",
                  className: "data-[state=checked]:bg-black [&_span]:bg-white",
                  disabled: i.isDisabled,
                  onCheckedChange: i.onStatusChange
                }
              ),
              /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.statusLabels?.[i.status] ?? i.status })
            ] })
          ] }),
          a && /* @__PURE__ */ u.jsxs("div", { className: "py-2 pl-10 md:grid md:grid-cols-[2.5rem_2.5rem_1fr_1fr_1fr_1fr_auto] md:gap-4 md:pl-0", children: [
            /* @__PURE__ */ u.jsx("div", { className: "hidden md:block" }),
            /* @__PURE__ */ u.jsx("div", { className: "hidden md:block" }),
            /* @__PURE__ */ u.jsxs("dl", { className: "grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 px-4 md:col-span-4", children: [
              /* @__PURE__ */ u.jsx("dt", { className: "font-semibold", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.customerIdLabel }) }),
              /* @__PURE__ */ u.jsx("dd", { children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: i.id }) }),
              /* @__PURE__ */ u.jsx("dt", { className: "font-semibold", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.emailLabel }) }),
              /* @__PURE__ */ u.jsx("dd", { children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: i.email || "—" }) }),
              /* @__PURE__ */ u.jsx("dt", { className: "font-semibold", children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.languageLabel }) }),
              /* @__PURE__ */ u.jsx("dd", { children: /* @__PURE__ */ u.jsx(B, { variant: "body-sm", children: e.microcopies.languageValue }) })
            ] })
          ] })
        ] }, i.id);
      })
    ] })
  ] });
}
function kue(e, t) {
  const [n, r] = Ee(t), [i, a] = jC(), o = ot(
    (s) => {
      s.preventDefault(), a(async () => {
        const c = await e(
          n,
          new FormData(s.currentTarget)
        );
        r(c);
      });
    },
    [n, e]
  );
  return [n, o, i, r];
}
export {
  Xle as Accordion,
  Zs as AccordionContent,
  Ks as AccordionItem,
  Ma as AccordionPrimitive,
  Gs as AccordionTrigger,
  IA as AddressSelector,
  na as Alert,
  due as AlertDialog,
  bie as AlertDialogAction,
  xie as AlertDialogCancel,
  mie as AlertDialogContent,
  yie as AlertDialogDescription,
  pie as AlertDialogFooter,
  vie as AlertDialogHeader,
  bk as AlertDialogOverlay,
  hie as AlertDialogPortal,
  gie as AlertDialogTitle,
  fue as AlertDialogTrigger,
  ve as Button,
  jte as Calendar,
  Tte as CalendarDayButton,
  ene as CardDocument,
  YD as CardGeneric,
  wue as CardProduct,
  Zle as CartHeader,
  Qle as CartOrderSummary,
  tue as CartProductBox,
  nue as CartProductListTitle,
  Hle as ChangingButton,
  FN as ChoiceInput,
  Dd as Column,
  kd as Container,
  Zte as DatePicker,
  Dte as DatePlaceholder,
  rue as DeliveryPaymentInfo,
  iue as DocumentListCard,
  kte as FormattedDate,
  aue as GenericModal,
  oue as HeroBanner,
  Xt as Image,
  sue as ImageArrangement,
  cue as ImageGallery,
  Jle as ImageProvider,
  ni as Input,
  wt as Label,
  _ue as LineSteps,
  Ule as LinkProvider,
  hue as Pagination,
  mue as PaginationContent,
  yue as PaginationEllipsis,
  vue as PaginationItem,
  xk as PaginationLink,
  gue as PaginationNext,
  pue as PaginationPrevious,
  lue as PoiImageHotspot,
  DD as Popover,
  Mx as PopoverContent,
  kD as PopoverTrigger,
  Jre as ProductBox,
  Sue as ProductFilters,
  uue as ProductHighlights,
  Ay as ProductInputQuantity,
  Yle as Progress,
  Rd as Row,
  bue as SearchableSelect,
  co as Select,
  Xi as SelectContent,
  Qi as SelectItem,
  Zi as SelectTrigger,
  lo as SelectValue,
  Cu as Switch,
  Oue as Tabs,
  Pue as TabsContent,
  Eue as TabsList,
  Aue as TabsTrigger,
  B as Text,
  Cue as UserAddressModal,
  jue as UserCardAddress,
  Tue as UserCardPreferences,
  Nue as UserCardProfile,
  Mue as UserCardSecurity,
  Iue as UserFormModal,
  Due as UserMyCompany,
  sX as VlitePlayer,
  Us as buttonVariants,
  Ce as cn,
  kue as useActionStateWithoutReset,
  xue as useDebouncedCallback,
  LX as useImage,
  lK as useLink,
  Kle as useVlitePlaybackState,
  Gle as useVlitePlayer,
  $ue as wordCount
};
